import { ref as tI } from "vue";
import { R as rI, r as nI, n as ai, t as iI, c as sI, a as fn, i as Od, b as oI, S as Iw, h as xw, m as Fm, M as aI, d as Bm, f as Um, o as Zl, e as cI, g as jm, p as Hm, j as Ct, k as uI, l as lI, q as es, U as ho, s as ma, u as Mc, C as Rw, v as Yl, P as hI, w as fI } from "./utils-yMopjW74.js";
import { i as dI, g as is, c as Te, a as Bc, e as pI, b as yo, d as Aw, h as gI, f as mI } from "./infiniteQueryBehavior-xKUyRKiT.js";
import { isMobile as vI } from "@swapin-hub/utils";
function xa(t) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...t
  };
}
var yI = class extends rI {
  constructor(t) {
    super(), this.#o = !1, this.#c = t.defaultOptions, this.#u(t.options), this.#t = [], this.#r = t.cache, this.queryKey = t.queryKey, this.queryHash = t.queryHash, this.#e = t.state || _I(this.options), this.state = this.#e, this.scheduleGc();
  }
  #e;
  #i;
  #r;
  #s;
  #n;
  #t;
  #c;
  #o;
  get meta() {
    return this.options.meta;
  }
  #u(t) {
    this.options = { ...this.#c, ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.#t.length && this.state.fetchStatus === "idle" && this.#r.remove(this);
  }
  setData(t, e) {
    const r = nI(this.state.data, t, this.options);
    return this.#a({
      data: r,
      type: "success",
      dataUpdatedAt: e?.updatedAt,
      manual: e?.manual
    }), r;
  }
  setState(t, e) {
    this.#a({ type: "setState", state: t, setStateOptions: e });
  }
  cancel(t) {
    const e = this.#s;
    return this.#n?.cancel(t), e ? e.then(ai).catch(ai) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(this.#e);
  }
  isActive() {
    return this.#t.some(
      (t) => t.options.enabled !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.#t.some((t) => t.getCurrentResult().isStale);
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !iI(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    this.#t.find((e) => e.shouldFetchOnWindowFocus())?.refetch({ cancelRefetch: !1 }), this.#n?.continue();
  }
  onOnline() {
    this.#t.find((e) => e.shouldFetchOnReconnect())?.refetch({ cancelRefetch: !1 }), this.#n?.continue();
  }
  addObserver(t) {
    this.#t.includes(t) || (this.#t.push(t), this.clearGcTimeout(), this.#r.notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.#t.includes(t) && (this.#t = this.#t.filter((e) => e !== t), this.#t.length || (this.#n && (this.#o ? this.#n.cancel({ revert: !0 }) : this.#n.cancelRetry()), this.scheduleGc()), this.#r.notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.#t.length;
  }
  invalidate() {
    this.state.isInvalidated || this.#a({ type: "invalidate" });
  }
  fetch(t, e) {
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && e?.cancelRefetch)
        this.cancel({ silent: !0 });
      else if (this.#s)
        return this.#n?.continueRetry(), this.#s;
    }
    if (t && this.#u(t), !this.options.queryFn) {
      const l = this.#t.find((f) => f.options.queryFn);
      l && this.#u(l.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), n = {
      queryKey: this.queryKey,
      meta: this.meta
    }, i = (l) => {
      Object.defineProperty(l, "signal", {
        enumerable: !0,
        get: () => (this.#o = !0, r.signal)
      });
    };
    i(n);
    const o = () => this.options.queryFn ? (this.#o = !1, this.options.persister ? this.options.persister(
      this.options.queryFn,
      n,
      this
    ) : this.options.queryFn(
      n
    )) : Promise.reject(
      new Error(`Missing queryFn: '${this.options.queryHash}'`)
    ), c = {
      fetchOptions: e,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: o
    };
    i(c), this.options.behavior?.onFetch(
      c,
      this
    ), this.#i = this.state, (this.state.fetchStatus === "idle" || this.state.fetchMeta !== c.fetchOptions?.meta) && this.#a({ type: "fetch", meta: c.fetchOptions?.meta });
    const u = (l) => {
      Od(l) && l.silent || this.#a({
        type: "error",
        error: l
      }), Od(l) || (this.#r.config.onError?.(
        l,
        this
      ), this.#r.config.onSettled?.(
        this.state.data,
        l,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.#n = sI({
      fn: c.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (l) => {
        if (typeof l > "u") {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), u(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        this.setData(l), this.#r.config.onSuccess?.(l, this), this.#r.config.onSettled?.(
          l,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: u,
      onFail: (l, f) => {
        this.#a({ type: "failed", failureCount: l, error: f });
      },
      onPause: () => {
        this.#a({ type: "pause" });
      },
      onContinue: () => {
        this.#a({ type: "continue" });
      },
      retry: c.options.retry,
      retryDelay: c.options.retryDelay,
      networkMode: c.options.networkMode
    }), this.#s = this.#n.promise, this.#s;
  }
  #a(t) {
    const e = (r) => {
      switch (t.type) {
        case "failed":
          return {
            ...r,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          };
        case "pause":
          return {
            ...r,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...r,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...r,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: t.meta ?? null,
            fetchStatus: oI(this.options.networkMode) ? "fetching" : "paused",
            ...!r.dataUpdatedAt && {
              error: null,
              status: "pending"
            }
          };
        case "success":
          return {
            ...r,
            data: t.data,
            dataUpdateCount: r.dataUpdateCount + 1,
            dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const n = t.error;
          return Od(n) && n.revert && this.#i ? { ...this.#i, fetchStatus: "idle" } : {
            ...r,
            error: n,
            errorUpdateCount: r.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: r.fetchFailureCount + 1,
            fetchFailureReason: n,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...r,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...r,
            ...t.state
          };
      }
    };
    this.state = e(this.state), fn.batch(() => {
      this.#t.forEach((r) => {
        r.onQueryUpdate();
      }), this.#r.notify({ query: this, type: "updated", action: t });
    });
  }
};
function _I(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = typeof e < "u", n = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Mw = class extends Iw {
  constructor(e = {}) {
    super(), this.config = e, this.#e = /* @__PURE__ */ new Map();
  }
  #e;
  build(e, r, n) {
    const i = r.queryKey, o = r.queryHash ?? xw(i, r);
    let c = this.get(o);
    return c || (c = new yI({
      cache: this,
      queryKey: i,
      queryHash: o,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(i)
    }), this.add(c)), c;
  }
  add(e) {
    this.#e.has(e.queryHash) || (this.#e.set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = this.#e.get(e.queryHash);
    r && (e.destroy(), r === e && this.#e.delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    fn.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.#e.get(e);
  }
  getAll() {
    return [...this.#e.values()];
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.getAll().find(
      (n) => Fm(r, n)
    );
  }
  findAll(e = {}) {
    const r = this.getAll();
    return Object.keys(e).length > 0 ? r.filter((n) => Fm(e, n)) : r;
  }
  notify(e) {
    fn.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  onFocus() {
    fn.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    fn.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, Dw = class extends Iw {
  constructor(e = {}) {
    super(), this.config = e, this.#e = [], this.#i = 0;
  }
  #e;
  #i;
  #r;
  build(e, r, n) {
    const i = new aI({
      mutationCache: this,
      mutationId: ++this.#i,
      options: e.defaultMutationOptions(r),
      state: n
    });
    return this.add(i), i;
  }
  add(e) {
    this.#e.push(e), this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    this.#e = this.#e.filter((r) => r !== e), this.notify({ type: "removed", mutation: e });
  }
  clear() {
    fn.batch(() => {
      this.#e.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.#e;
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.#e.find(
      (n) => Bm(r, n)
    );
  }
  findAll(e = {}) {
    return this.#e.filter(
      (r) => Bm(e, r)
    );
  }
  notify(e) {
    fn.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    return this.#r = (this.#r ?? Promise.resolve()).then(() => {
      const e = this.#e.filter((r) => r.state.isPaused);
      return fn.batch(
        () => e.reduce(
          (r, n) => r.then(() => n.continue().catch(ai)),
          Promise.resolve()
        )
      );
    }).then(() => {
      this.#r = void 0;
    }), this.#r;
  }
}, wI = class {
  #e;
  #i;
  #r;
  #s;
  #n;
  #t;
  #c;
  #o;
  constructor(e = {}) {
    this.#e = e.queryCache || new Mw(), this.#i = e.mutationCache || new Dw(), this.#r = e.defaultOptions || {}, this.#s = /* @__PURE__ */ new Map(), this.#n = /* @__PURE__ */ new Map(), this.#t = 0;
  }
  mount() {
    this.#t++, this.#t === 1 && (this.#c = Um.subscribe(() => {
      Um.isFocused() && (this.resumePausedMutations(), this.#e.onFocus());
    }), this.#o = Zl.subscribe(() => {
      Zl.isOnline() && (this.resumePausedMutations(), this.#e.onOnline());
    }));
  }
  unmount() {
    this.#t--, this.#t === 0 && (this.#c?.(), this.#c = void 0, this.#o?.(), this.#o = void 0);
  }
  isFetching(e) {
    return this.#e.findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return this.#i.findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    return this.#e.find({ queryKey: e })?.state.data;
  }
  ensureQueryData(e) {
    const r = this.getQueryData(e.queryKey);
    return r !== void 0 ? Promise.resolve(r) : this.fetchQuery(e);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({ queryKey: r, state: n }) => {
      const i = n.data;
      return [r, i];
    });
  }
  setQueryData(e, r, n) {
    const o = this.#e.find({ queryKey: e })?.state.data, c = cI(r, o);
    if (typeof c > "u")
      return;
    const u = this.defaultQueryOptions({ queryKey: e });
    return this.#e.build(this, u).setData(c, { ...n, manual: !0 });
  }
  setQueriesData(e, r, n) {
    return fn.batch(
      () => this.getQueryCache().findAll(e).map(({ queryKey: i }) => [
        i,
        this.setQueryData(i, r, n)
      ])
    );
  }
  getQueryState(e) {
    return this.#e.find({ queryKey: e })?.state;
  }
  removeQueries(e) {
    const r = this.#e;
    fn.batch(() => {
      r.findAll(e).forEach((n) => {
        r.remove(n);
      });
    });
  }
  resetQueries(e, r) {
    const n = this.#e, i = {
      type: "active",
      ...e
    };
    return fn.batch(() => (n.findAll(e).forEach((o) => {
      o.reset();
    }), this.refetchQueries(i, r)));
  }
  cancelQueries(e = {}, r = {}) {
    const n = { revert: !0, ...r }, i = fn.batch(
      () => this.#e.findAll(e).map((o) => o.cancel(n))
    );
    return Promise.all(i).then(ai).catch(ai);
  }
  invalidateQueries(e = {}, r = {}) {
    return fn.batch(() => {
      if (this.#e.findAll(e).forEach((i) => {
        i.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(n, r);
    });
  }
  refetchQueries(e = {}, r) {
    const n = {
      ...r,
      cancelRefetch: r?.cancelRefetch ?? !0
    }, i = fn.batch(
      () => this.#e.findAll(e).filter((o) => !o.isDisabled()).map((o) => {
        let c = o.fetch(void 0, n);
        return n.throwOnError || (c = c.catch(ai)), o.state.fetchStatus === "paused" ? Promise.resolve() : c;
      })
    );
    return Promise.all(i).then(ai);
  }
  fetchQuery(e) {
    const r = this.defaultQueryOptions(e);
    typeof r.retry > "u" && (r.retry = !1);
    const n = this.#e.build(this, r);
    return n.isStaleByTime(r.staleTime) ? n.fetch(r) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(ai).catch(ai);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = dI(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(ai).catch(ai);
  }
  resumePausedMutations() {
    return this.#i.resumePausedMutations();
  }
  getQueryCache() {
    return this.#e;
  }
  getMutationCache() {
    return this.#i;
  }
  getDefaultOptions() {
    return this.#r;
  }
  setDefaultOptions(e) {
    this.#r = e;
  }
  setQueryDefaults(e, r) {
    this.#s.set(jm(e), {
      queryKey: e,
      defaultOptions: r
    });
  }
  getQueryDefaults(e) {
    const r = [...this.#s.values()];
    let n = {};
    return r.forEach((i) => {
      Hm(e, i.queryKey) && (n = { ...n, ...i.defaultOptions });
    }), n;
  }
  setMutationDefaults(e, r) {
    this.#n.set(jm(e), {
      mutationKey: e,
      defaultOptions: r
    });
  }
  getMutationDefaults(e) {
    const r = [...this.#n.values()];
    let n = {};
    return r.forEach((i) => {
      Hm(e, i.mutationKey) && (n = { ...n, ...i.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e?._defaulted)
      return e;
    const r = {
      ...this.#r.queries,
      ...e?.queryKey && this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return r.queryHash || (r.queryHash = xw(
      r.queryKey,
      r
    )), typeof r.refetchOnReconnect > "u" && (r.refetchOnReconnect = r.networkMode !== "always"), typeof r.throwOnError > "u" && (r.throwOnError = !!r.suspense), typeof r.networkMode > "u" && r.persister && (r.networkMode = "offlineFirst"), r;
  }
  defaultMutationOptions(e) {
    return e?._defaulted ? e : {
      ...this.#r.mutations,
      ...e?.mutationKey && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.#e.clear(), this.#i.clear();
  }
}, bI = class extends Mw {
  find(t) {
    return super.find(Ct(t));
  }
  findAll(t = {}) {
    return super.findAll(Ct(t));
  }
}, EI = class extends Dw {
  find(t) {
    return super.find(Ct(t));
  }
  findAll(t = {}) {
    return super.findAll(Ct(t));
  }
}, SI = class extends wI {
  constructor(t = {}) {
    const e = {
      defaultOptions: t.defaultOptions,
      queryCache: t.queryCache || new bI(),
      mutationCache: t.mutationCache || new EI()
    };
    super(e), this.isRestoring = tI(!1);
  }
  isFetching(t = {}) {
    return super.isFetching(Ct(t));
  }
  isMutating(t = {}) {
    return super.isMutating(Ct(t));
  }
  getQueryData(t) {
    return super.getQueryData(Ct(t));
  }
  ensureQueryData(t) {
    return super.ensureQueryData(Ct(t));
  }
  getQueriesData(t) {
    return super.getQueriesData(Ct(t));
  }
  setQueryData(t, e, r = {}) {
    return super.setQueryData(
      Ct(t),
      e,
      Ct(r)
    );
  }
  setQueriesData(t, e, r = {}) {
    return super.setQueriesData(
      Ct(t),
      e,
      Ct(r)
    );
  }
  getQueryState(t) {
    return super.getQueryState(Ct(t));
  }
  removeQueries(t = {}) {
    return super.removeQueries(Ct(t));
  }
  resetQueries(t = {}, e = {}) {
    return super.resetQueries(Ct(t), Ct(e));
  }
  cancelQueries(t = {}, e = {}) {
    return super.cancelQueries(Ct(t), Ct(e));
  }
  invalidateQueries(t = {}, e = {}) {
    return new Promise((r) => {
      setTimeout(async () => {
        await super.invalidateQueries(
          Ct(t),
          Ct(e)
        ), r();
      }, 0);
    });
  }
  refetchQueries(t = {}, e = {}) {
    return super.refetchQueries(
      Ct(t),
      Ct(e)
    );
  }
  fetchQuery(t) {
    return super.fetchQuery(Ct(t));
  }
  prefetchQuery(t) {
    return super.prefetchQuery(Ct(t));
  }
  fetchInfiniteQuery(t) {
    return super.fetchInfiniteQuery(Ct(t));
  }
  prefetchInfiniteQuery(t) {
    return super.prefetchInfiniteQuery(Ct(t));
  }
  setDefaultOptions(t) {
    super.setDefaultOptions(Ct(t));
  }
  setQueryDefaults(t, e) {
    super.setQueryDefaults(Ct(t), Ct(e));
  }
  getQueryDefaults(t) {
    return super.getQueryDefaults(Ct(t));
  }
  setMutationDefaults(t, e) {
    super.setMutationDefaults(
      Ct(t),
      Ct(e)
    );
  }
  getMutationDefaults(t) {
    return super.getMutationDefaults(Ct(t));
  }
};
function CI() {
  return Ow().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function Ow() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const II = typeof Proxy == "function", xI = "devtools-plugin:setup", RI = "plugin:settings:set";
let Ko, k0;
function AI() {
  var t;
  return Ko !== void 0 || (typeof window < "u" && window.performance ? (Ko = !0, k0 = window.performance) : typeof global < "u" && (!((t = global.perf_hooks) === null || t === void 0) && t.performance) ? (Ko = !0, k0 = global.perf_hooks.performance) : Ko = !1), Ko;
}
function MI() {
  return AI() ? k0.now() : Date.now();
}
class DI {
  constructor(e, r) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = e, this.hook = r;
    const n = {};
    if (e.settings)
      for (const c in e.settings) {
        const u = e.settings[c];
        n[c] = u.defaultValue;
      }
    const i = `__vue-devtools-plugin-settings__${e.id}`;
    let o = Object.assign({}, n);
    try {
      const c = localStorage.getItem(i), u = JSON.parse(c);
      Object.assign(o, u);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return o;
      },
      setSettings(c) {
        try {
          localStorage.setItem(i, JSON.stringify(c));
        } catch {
        }
        o = c;
      },
      now() {
        return MI();
      }
    }, r && r.on(RI, (c, u) => {
      c === this.plugin.id && this.fallbacks.setSettings(u);
    }), this.proxiedOn = new Proxy({}, {
      get: (c, u) => this.target ? this.target.on[u] : (...l) => {
        this.onQueue.push({
          method: u,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (c, u) => this.target ? this.target[u] : u === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(u) ? (...l) => (this.targetQueue.push({
        method: u,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[u](...l)) : (...l) => new Promise((f) => {
        this.targetQueue.push({
          method: u,
          args: l,
          resolve: f
        });
      })
    });
  }
  async setRealTarget(e) {
    this.target = e;
    for (const r of this.onQueue)
      this.target.on[r.method](...r.args);
    for (const r of this.targetQueue)
      r.resolve(await this.target[r.method](...r.args));
  }
}
function OI(t, e) {
  const r = t, n = Ow(), i = CI(), o = II && r.enableEarlyProxy;
  if (i && (n.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !o))
    i.emit(xI, t, e);
  else {
    const c = o ? new DI(r, i) : null;
    (n.__VUE_DEVTOOLS_PLUGINS__ = n.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: r,
      setupFn: e,
      proxy: c
    }), c && e(c.proxiedTarget);
  }
}
/**
   * match-sorter-utils
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
const Pw = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z"
}, PI = Object.keys(Pw).join("|"), TI = new RegExp(PI, "g");
function NI(t) {
  return t.replace(TI, (e) => Pw[e]);
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const hn = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
function kI(t, e, r) {
  var n;
  if (r = r || {}, r.threshold = (n = r.threshold) != null ? n : hn.MATCHES, !r.accessors) {
    const c = qm(t, e, r);
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: t,
      rank: c,
      accessorIndex: -1,
      accessorThreshold: r.threshold,
      passed: c >= r.threshold
    };
  }
  const i = BI(t, r.accessors), o = {
    rankedValue: t,
    rank: hn.NO_MATCH,
    accessorIndex: -1,
    accessorThreshold: r.threshold,
    passed: !1
  };
  for (let c = 0; c < i.length; c++) {
    const u = i[c];
    let l = qm(u.itemValue, e, r);
    const {
      minRanking: f,
      maxRanking: p,
      threshold: g = r.threshold
    } = u.attributes;
    l < f && l >= hn.MATCHES ? l = f : l > p && (l = p), l = Math.min(l, p), l >= g && l > o.rank && (o.rank = l, o.passed = !0, o.accessorIndex = c, o.accessorThreshold = g, o.rankedValue = u.itemValue);
  }
  return o;
}
function qm(t, e, r) {
  return t = zm(t, r), e = zm(e, r), e.length > t.length ? hn.NO_MATCH : t === e ? hn.CASE_SENSITIVE_EQUAL : (t = t.toLowerCase(), e = e.toLowerCase(), t === e ? hn.EQUAL : t.startsWith(e) ? hn.STARTS_WITH : t.includes(` ${e}`) ? hn.WORD_STARTS_WITH : t.includes(e) ? hn.CONTAINS : e.length === 1 ? hn.NO_MATCH : LI(t).includes(e) ? hn.ACRONYM : $I(t, e));
}
function LI(t) {
  let e = "";
  return t.split(" ").forEach((n) => {
    n.split("-").forEach((o) => {
      e += o.substr(0, 1);
    });
  }), e;
}
function $I(t, e) {
  let r = 0, n = 0;
  function i(l, f, p) {
    for (let g = p, y = f.length; g < y; g++)
      if (f[g] === l)
        return r += 1, g + 1;
    return -1;
  }
  function o(l) {
    const f = 1 / l, p = r / e.length;
    return hn.MATCHES + p * f;
  }
  const c = i(e[0], t, 0);
  if (c < 0)
    return hn.NO_MATCH;
  n = c;
  for (let l = 1, f = e.length; l < f; l++) {
    const p = e[l];
    if (n = i(p, t, n), !(n > -1))
      return hn.NO_MATCH;
  }
  const u = n - c;
  return o(u);
}
function zm(t, e) {
  let {
    keepDiacritics: r
  } = e;
  return t = `${t}`, r || (t = NI(t)), t;
}
function FI(t, e) {
  let r = e;
  typeof e == "object" && (r = e.accessor);
  const n = r(t);
  return n == null ? [] : Array.isArray(n) ? n : [String(n)];
}
function BI(t, e) {
  const r = [];
  for (let n = 0, i = e.length; n < i; n++) {
    const o = e[n], c = UI(o), u = FI(t, o);
    for (let l = 0, f = u.length; l < f; l++)
      r.push({
        itemValue: u[l],
        attributes: c
      });
  }
  return r;
}
const Vm = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function UI(t) {
  return typeof t == "function" ? Vm : {
    ...Vm,
    ...t
  };
}
function oo(t) {
  return t.state.fetchStatus === "fetching" ? 0 : t.state.fetchStatus === "paused" ? 4 : t.getObserversCount() ? t.isStale() ? 2 : 1 : 3;
}
function Wm(t) {
  const e = oo(t);
  return e === 0 ? "fetching" : e === 4 ? "paused" : e === 2 ? "stale" : e === 3 ? "inactive" : "fresh";
}
function jI(t) {
  return oo(t) === 2 ? 0 : 16777215;
}
function HI(t) {
  const e = oo(t);
  return e === 0 ? 27647 : e === 4 ? 9193963 : e === 2 ? 16757248 : e === 3 ? 4148832 : 33575;
}
var qI = (t, e) => t.queryHash.localeCompare(e.queryHash), Tw = (t, e) => t.state.dataUpdatedAt < e.state.dataUpdatedAt ? 1 : -1, zI = (t, e) => oo(t) === oo(e) ? Tw(t, e) : oo(t) > oo(e) ? 1 : -1, Pd = {
  "Status > Last Updated": zI,
  "Query Hash": qI,
  "Last Updated": Tw
}, ys = "vue-query", Td = "Vue Query";
function VI(t, e) {
  OI(
    {
      id: ys,
      label: Td,
      packageName: "vue-query",
      homepage: "https://tanstack.com/query/latest",
      logo: "https://raw.githubusercontent.com/TanStack/query/main/packages/vue-query/media/vue-query.svg",
      app: t,
      settings: {
        baseSort: {
          type: "choice",
          component: "button-group",
          label: "Sort Cache Entries",
          options: [
            {
              label: "ASC",
              value: 1
            },
            {
              label: "DESC",
              value: -1
            }
          ],
          defaultValue: 1
        },
        sortFn: {
          type: "choice",
          label: "Sort Function",
          options: Object.keys(Pd).map((r) => ({
            label: r,
            value: r
          })),
          defaultValue: Object.keys(Pd)[0]
        },
        onlineMode: {
          type: "choice",
          component: "button-group",
          label: "Online mode",
          options: [
            {
              label: "Online",
              value: 1
            },
            {
              label: "Offline",
              value: 0
            }
          ],
          defaultValue: 1
        }
      }
    },
    (r) => {
      const n = r.getSettings();
      Zl.setOnline(!!n.onlineMode.valueOf());
      const i = e.getQueryCache();
      r.addInspector({
        id: ys,
        label: Td,
        icon: "api",
        nodeActions: [
          {
            icon: "file_download",
            tooltip: "Refetch",
            action: (o) => {
              i.get(o)?.fetch();
            }
          },
          {
            icon: "alarm",
            tooltip: "Invalidate",
            action: (o) => {
              const c = i.get(o);
              e.invalidateQueries(c);
            }
          },
          {
            icon: "settings_backup_restore",
            tooltip: "Reset",
            action: (o) => {
              i.get(o)?.reset();
            }
          },
          {
            icon: "delete",
            tooltip: "Remove",
            action: (o) => {
              const c = i.get(o);
              i.remove(c);
            }
          },
          {
            icon: "hourglass_empty",
            tooltip: "Force loading",
            action: (o) => {
              i.get(o).setState({
                data: void 0,
                status: "pending"
              });
            }
          },
          {
            icon: "error_outline",
            tooltip: "Force error",
            action: (o) => {
              i.get(o).setState({
                data: void 0,
                status: "error",
                error: new Error("Unknown error from devtools")
              });
            }
          }
        ]
      }), r.addTimelineLayer({
        id: ys,
        label: Td,
        color: 16767308
      }), i.subscribe((o) => {
        r.sendInspectorTree(ys), r.sendInspectorState(ys), [
          "added",
          "removed",
          "updated"
        ].includes(o.type) && r.addTimelineEvent({
          layerId: ys,
          event: {
            title: o.type,
            subtitle: o.query.queryHash,
            time: r.now(),
            data: {
              queryHash: o.query.queryHash,
              ...o
            }
          }
        });
      }), r.on.setPluginSettings((o) => {
        o.key === "onlineMode" && Zl.setOnline(!!o.newValue);
      }), r.on.getInspectorTree((o) => {
        if (o.inspectorId === ys) {
          const c = i.getAll(), u = r.getSettings(), p = (o.filter ? c.filter(
            (g) => kI(g.queryHash, o.filter).passed
          ) : [...c]).sort(
            (g, y) => Pd[u.sortFn](g, y) * u.baseSort
          ).map((g) => {
            const y = Wm(g);
            return {
              id: g.queryHash,
              label: g.queryHash,
              tags: [
                {
                  label: `${y} [${g.getObserversCount()}]`,
                  textColor: jI(g),
                  backgroundColor: HI(g)
                }
              ]
            };
          });
          o.rootNodes = p;
        }
      }), r.on.getInspectorState((o) => {
        if (o.inspectorId === ys) {
          const c = i.get(o.nodeId);
          if (!c)
            return;
          o.state = {
            " Query Details": [
              {
                key: "Query key",
                value: c.queryHash
              },
              {
                key: "Query status",
                value: Wm(c)
              },
              {
                key: "Observers",
                value: c.getObserversCount()
              },
              {
                key: "Last Updated",
                value: new Date(c.state.dataUpdatedAt).toLocaleTimeString()
              }
            ],
            "Data Explorer": [
              {
                key: "Data",
                value: c.state.data
              }
            ],
            "Query Explorer": [
              {
                key: "Query",
                value: c
              }
            ]
          };
        }
      });
    }
  );
}
var WI = {
  install: (t, e = {}) => {
    const r = uI(e.queryClientKey);
    let n;
    if ("queryClient" in e && e.queryClient)
      n = e.queryClient;
    else {
      const c = "queryClientConfig" in e ? e.queryClientConfig : void 0;
      n = new SI(c);
    }
    lI || n.mount();
    let i = () => {
    };
    if (e.clientPersister) {
      n.isRestoring.value = !0;
      const [c, u] = e.clientPersister(n);
      i = c, u.then(() => {
        n.isRestoring.value = !1, e.clientPersisterOnSuccess?.(n);
      });
    }
    const o = () => {
      n.unmount(), i();
    };
    if (t.onUnmount)
      t.onUnmount(o);
    else {
      const c = t.unmount;
      t.unmount = function() {
        o(), c();
      };
    }
    t.provide(r, n), process.env.NODE_ENV === "development" && VI(t, n);
  }
};
const Nw = /* @__PURE__ */ xa({
  id: 56,
  name: "BNB Smart Chain",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB"
  },
  rpcUrls: {
    default: { http: ["https://rpc.ankr.com/bsc"] }
  },
  blockExplorers: {
    default: {
      name: "BscScan",
      url: "https://bscscan.com",
      apiUrl: "https://api.bscscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 15921452
    }
  }
}), KI = /* @__PURE__ */ xa({
  id: 97,
  name: "Binance Smart Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "tBNB"
  },
  rpcUrls: {
    default: { http: ["https://data-seed-prebsc-1-s1.bnbchain.org:8545"] }
  },
  blockExplorers: {
    default: {
      name: "BscScan",
      url: "https://testnet.bscscan.com",
      apiUrl: "https://testnet.bscscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 17422483
    }
  },
  testnet: !0
}), kw = /* @__PURE__ */ xa({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://cloudflare-eth.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0x8cab227b1162f03b8338331adaad7aadc83b895e",
      blockCreated: 18958930
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), L0 = /* @__PURE__ */ xa({
  id: 11155111,
  name: "Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "SEP", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.sepolia.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia.etherscan.io",
      apiUrl: "https://api-sepolia.etherscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 751532
    },
    ensRegistry: { address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e" },
    ensUniversalResolver: {
      address: "0xBaBC7678D7A63104f1658c11D6AE9A21cdA09725",
      blockCreated: 5043334
    }
  },
  testnet: !0
}), GI = xa({
  ...L0,
  nativeCurrency: {
    ...L0.nativeCurrency,
    symbol: kw.nativeCurrency.symbol
  }
}), JI = xa({
  ...KI,
  nativeCurrency: {
    ...L0.nativeCurrency,
    symbol: Nw.nativeCurrency.symbol
  }
});
var Lw = {}, Dc = {}, hh = {};
Object.defineProperty(hh, "__esModule", { value: !0 });
hh.walletLogo = void 0;
const QI = (t, e) => {
  let r;
  switch (t) {
    case "standard":
      return r = e, `data:image/svg+xml,%3Csvg width='${e}' height='${r}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
    case "circle":
      return r = e, `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${e}' height='${r}' viewBox='0 0 999.81 999.81'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052fe;%7D.cls-2%7Bfill:%23fefefe;%7D.cls-3%7Bfill:%230152fe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M655-115.9h56c.83,1.59,2.36.88,3.56,1a478,478,0,0,1,75.06,10.42C891.4-81.76,978.33-32.58,1049.19,44q116.7,126,131.94,297.61c.38,4.14-.34,8.53,1.78,12.45v59c-1.58.84-.91,2.35-1,3.56a482.05,482.05,0,0,1-10.38,74.05c-24,106.72-76.64,196.76-158.83,268.93s-178.18,112.82-287.2,122.6c-4.83.43-9.86-.25-14.51,1.77H654c-1-1.68-2.69-.91-4.06-1a496.89,496.89,0,0,1-105.9-18.59c-93.54-27.42-172.78-77.59-236.91-150.94Q199.34,590.1,184.87,426.58c-.47-5.19.25-10.56-1.77-15.59V355c1.68-1,.91-2.7,1-4.06a498.12,498.12,0,0,1,18.58-105.9c26-88.75,72.64-164.9,140.6-227.57q126-116.27,297.21-131.61C645.32-114.57,650.35-113.88,655-115.9Zm377.92,500c0-192.44-156.31-349.49-347.56-350.15-194.13-.68-350.94,155.13-352.29,347.42-1.37,194.55,155.51,352.1,348.56,352.47C876.15,734.23,1032.93,577.84,1032.93,384.11Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-2' d='M1032.93,384.11c0,193.73-156.78,350.12-351.29,349.74-193-.37-349.93-157.92-348.56-352.47C334.43,189.09,491.24,33.28,685.37,34,876.62,34.62,1032.94,191.67,1032.93,384.11ZM683,496.81q43.74,0,87.48,0c15.55,0,25.32-9.72,25.33-25.21q0-87.48,0-175c0-15.83-9.68-25.46-25.59-25.46H595.77c-15.88,0-25.57,9.64-25.58,25.46q0,87.23,0,174.45c0,16.18,9.59,25.7,25.84,25.71Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-3' d='M683,496.81H596c-16.25,0-25.84-9.53-25.84-25.71q0-87.23,0-174.45c0-15.82,9.7-25.46,25.58-25.46H770.22c15.91,0,25.59,9.63,25.59,25.46q0,87.47,0,175c0,15.49-9.78,25.2-25.33,25.21Q726.74,496.84,683,496.81Z' transform='translate(-183.1 115.9)'/%3E%3C/svg%3E`;
    case "text":
      return r = (0.1 * e).toFixed(2), `data:image/svg+xml,%3Csvg width='${e}' height='${r}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
    case "textWithLogo":
      return r = (0.25 * e).toFixed(2), `data:image/svg+xml,%3Csvg width='${e}' height='${r}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
    case "textLight":
      return r = (0.1 * e).toFixed(2), `data:image/svg+xml,%3Csvg width='${e}' height='${r}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
    case "textWithLogoLight":
      return r = (0.25 * e).toFixed(2), `data:image/svg+xml,%3Csvg width='${e}' height='${r}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
    default:
      return r = e, `data:image/svg+xml,%3Csvg width='${e}' height='${r}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
  }
};
hh.walletLogo = QI;
var fh = {};
Object.defineProperty(fh, "__esModule", { value: !0 });
fh.LINK_API_URL = void 0;
fh.LINK_API_URL = "https://www.walletlink.org";
var $e = {}, Sp = { exports: {} };
const ZI = {}, YI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ZI
}, Symbol.toStringTag, { value: "Module" })), dh = /* @__PURE__ */ is(YI);
Sp.exports;
(function(t) {
  (function(e, r) {
    function n(k, h) {
      if (!k)
        throw new Error(h || "Assertion failed");
    }
    function i(k, h) {
      k.super_ = h;
      var m = function() {
      };
      m.prototype = h.prototype, k.prototype = new m(), k.prototype.constructor = k;
    }
    function o(k, h, m) {
      if (o.isBN(k))
        return k;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, k !== null && ((h === "le" || h === "be") && (m = h, h = 10), this._init(k || 0, h || 10, m || "be"));
    }
    typeof e == "object" ? e.exports = o : r.BN = o, o.BN = o, o.wordSize = 26;
    var c;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? c = window.Buffer : c = dh.Buffer;
    } catch {
    }
    o.isBN = function(h) {
      return h instanceof o ? !0 : h !== null && typeof h == "object" && h.constructor.wordSize === o.wordSize && Array.isArray(h.words);
    }, o.max = function(h, m) {
      return h.cmp(m) > 0 ? h : m;
    }, o.min = function(h, m) {
      return h.cmp(m) < 0 ? h : m;
    }, o.prototype._init = function(h, m, x) {
      if (typeof h == "number")
        return this._initNumber(h, m, x);
      if (typeof h == "object")
        return this._initArray(h, m, x);
      m === "hex" && (m = 16), n(m === (m | 0) && m >= 2 && m <= 36), h = h.toString().replace(/\s+/g, "");
      var M = 0;
      h[0] === "-" && (M++, this.negative = 1), M < h.length && (m === 16 ? this._parseHex(h, M, x) : (this._parseBase(h, m, M), x === "le" && this._initArray(this.toArray(), m, x)));
    }, o.prototype._initNumber = function(h, m, x) {
      h < 0 && (this.negative = 1, h = -h), h < 67108864 ? (this.words = [h & 67108863], this.length = 1) : h < 4503599627370496 ? (this.words = [
        h & 67108863,
        h / 67108864 & 67108863
      ], this.length = 2) : (n(h < 9007199254740992), this.words = [
        h & 67108863,
        h / 67108864 & 67108863,
        1
      ], this.length = 3), x === "le" && this._initArray(this.toArray(), m, x);
    }, o.prototype._initArray = function(h, m, x) {
      if (n(typeof h.length == "number"), h.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(h.length / 3), this.words = new Array(this.length);
      for (var M = 0; M < this.length; M++)
        this.words[M] = 0;
      var A, $, K = 0;
      if (x === "be")
        for (M = h.length - 1, A = 0; M >= 0; M -= 3)
          $ = h[M] | h[M - 1] << 8 | h[M - 2] << 16, this.words[A] |= $ << K & 67108863, this.words[A + 1] = $ >>> 26 - K & 67108863, K += 24, K >= 26 && (K -= 26, A++);
      else if (x === "le")
        for (M = 0, A = 0; M < h.length; M += 3)
          $ = h[M] | h[M + 1] << 8 | h[M + 2] << 16, this.words[A] |= $ << K & 67108863, this.words[A + 1] = $ >>> 26 - K & 67108863, K += 24, K >= 26 && (K -= 26, A++);
      return this._strip();
    };
    function u(k, h) {
      var m = k.charCodeAt(h);
      if (m >= 48 && m <= 57)
        return m - 48;
      if (m >= 65 && m <= 70)
        return m - 55;
      if (m >= 97 && m <= 102)
        return m - 87;
      n(!1, "Invalid character in " + k);
    }
    function l(k, h, m) {
      var x = u(k, m);
      return m - 1 >= h && (x |= u(k, m - 1) << 4), x;
    }
    o.prototype._parseHex = function(h, m, x) {
      this.length = Math.ceil((h.length - m) / 6), this.words = new Array(this.length);
      for (var M = 0; M < this.length; M++)
        this.words[M] = 0;
      var A = 0, $ = 0, K;
      if (x === "be")
        for (M = h.length - 1; M >= m; M -= 2)
          K = l(h, m, M) << A, this.words[$] |= K & 67108863, A >= 18 ? (A -= 18, $ += 1, this.words[$] |= K >>> 26) : A += 8;
      else {
        var D = h.length - m;
        for (M = D % 2 === 0 ? m + 1 : m; M < h.length; M += 2)
          K = l(h, m, M) << A, this.words[$] |= K & 67108863, A >= 18 ? (A -= 18, $ += 1, this.words[$] |= K >>> 26) : A += 8;
      }
      this._strip();
    };
    function f(k, h, m, x) {
      for (var M = 0, A = 0, $ = Math.min(k.length, m), K = h; K < $; K++) {
        var D = k.charCodeAt(K) - 48;
        M *= x, D >= 49 ? A = D - 49 + 10 : D >= 17 ? A = D - 17 + 10 : A = D, n(D >= 0 && A < x, "Invalid character"), M += A;
      }
      return M;
    }
    o.prototype._parseBase = function(h, m, x) {
      this.words = [0], this.length = 1;
      for (var M = 0, A = 1; A <= 67108863; A *= m)
        M++;
      M--, A = A / m | 0;
      for (var $ = h.length - x, K = $ % M, D = Math.min($, $ - K) + x, w = 0, U = x; U < D; U += M)
        w = f(h, U, U + M, m), this.imuln(A), this.words[0] + w < 67108864 ? this.words[0] += w : this._iaddn(w);
      if (K !== 0) {
        var me = 1;
        for (w = f(h, U, h.length, m), U = 0; U < K; U++)
          me *= m;
        this.imuln(me), this.words[0] + w < 67108864 ? this.words[0] += w : this._iaddn(w);
      }
      this._strip();
    }, o.prototype.copy = function(h) {
      h.words = new Array(this.length);
      for (var m = 0; m < this.length; m++)
        h.words[m] = this.words[m];
      h.length = this.length, h.negative = this.negative, h.red = this.red;
    };
    function p(k, h) {
      k.words = h.words, k.length = h.length, k.negative = h.negative, k.red = h.red;
    }
    if (o.prototype._move = function(h) {
      p(h, this);
    }, o.prototype.clone = function() {
      var h = new o(null);
      return this.copy(h), h;
    }, o.prototype._expand = function(h) {
      for (; this.length < h; )
        this.words[this.length++] = 0;
      return this;
    }, o.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, o.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        o.prototype[Symbol.for("nodejs.util.inspect.custom")] = g;
      } catch {
        o.prototype.inspect = g;
      }
    else
      o.prototype.inspect = g;
    function g() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var y = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], C = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], R = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    o.prototype.toString = function(h, m) {
      h = h || 10, m = m | 0 || 1;
      var x;
      if (h === 16 || h === "hex") {
        x = "";
        for (var M = 0, A = 0, $ = 0; $ < this.length; $++) {
          var K = this.words[$], D = ((K << M | A) & 16777215).toString(16);
          A = K >>> 24 - M & 16777215, M += 2, M >= 26 && (M -= 26, $--), A !== 0 || $ !== this.length - 1 ? x = y[6 - D.length] + D + x : x = D + x;
        }
        for (A !== 0 && (x = A.toString(16) + x); x.length % m !== 0; )
          x = "0" + x;
        return this.negative !== 0 && (x = "-" + x), x;
      }
      if (h === (h | 0) && h >= 2 && h <= 36) {
        var w = C[h], U = R[h];
        x = "";
        var me = this.clone();
        for (me.negative = 0; !me.isZero(); ) {
          var pe = me.modrn(U).toString(h);
          me = me.idivn(U), me.isZero() ? x = pe + x : x = y[w - pe.length] + pe + x;
        }
        for (this.isZero() && (x = "0" + x); x.length % m !== 0; )
          x = "0" + x;
        return this.negative !== 0 && (x = "-" + x), x;
      }
      n(!1, "Base should be between 2 and 36");
    }, o.prototype.toNumber = function() {
      var h = this.words[0];
      return this.length === 2 ? h += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? h += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -h : h;
    }, o.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, c && (o.prototype.toBuffer = function(h, m) {
      return this.toArrayLike(c, h, m);
    }), o.prototype.toArray = function(h, m) {
      return this.toArrayLike(Array, h, m);
    };
    var J = function(h, m) {
      return h.allocUnsafe ? h.allocUnsafe(m) : new h(m);
    };
    o.prototype.toArrayLike = function(h, m, x) {
      this._strip();
      var M = this.byteLength(), A = x || Math.max(1, M);
      n(M <= A, "byte array longer than desired length"), n(A > 0, "Requested array length <= 0");
      var $ = J(h, A), K = m === "le" ? "LE" : "BE";
      return this["_toArrayLike" + K]($, M), $;
    }, o.prototype._toArrayLikeLE = function(h, m) {
      for (var x = 0, M = 0, A = 0, $ = 0; A < this.length; A++) {
        var K = this.words[A] << $ | M;
        h[x++] = K & 255, x < h.length && (h[x++] = K >> 8 & 255), x < h.length && (h[x++] = K >> 16 & 255), $ === 6 ? (x < h.length && (h[x++] = K >> 24 & 255), M = 0, $ = 0) : (M = K >>> 24, $ += 2);
      }
      if (x < h.length)
        for (h[x++] = M; x < h.length; )
          h[x++] = 0;
    }, o.prototype._toArrayLikeBE = function(h, m) {
      for (var x = h.length - 1, M = 0, A = 0, $ = 0; A < this.length; A++) {
        var K = this.words[A] << $ | M;
        h[x--] = K & 255, x >= 0 && (h[x--] = K >> 8 & 255), x >= 0 && (h[x--] = K >> 16 & 255), $ === 6 ? (x >= 0 && (h[x--] = K >> 24 & 255), M = 0, $ = 0) : (M = K >>> 24, $ += 2);
      }
      if (x >= 0)
        for (h[x--] = M; x >= 0; )
          h[x--] = 0;
    }, Math.clz32 ? o.prototype._countBits = function(h) {
      return 32 - Math.clz32(h);
    } : o.prototype._countBits = function(h) {
      var m = h, x = 0;
      return m >= 4096 && (x += 13, m >>>= 13), m >= 64 && (x += 7, m >>>= 7), m >= 8 && (x += 4, m >>>= 4), m >= 2 && (x += 2, m >>>= 2), x + m;
    }, o.prototype._zeroBits = function(h) {
      if (h === 0)
        return 26;
      var m = h, x = 0;
      return m & 8191 || (x += 13, m >>>= 13), m & 127 || (x += 7, m >>>= 7), m & 15 || (x += 4, m >>>= 4), m & 3 || (x += 2, m >>>= 2), m & 1 || x++, x;
    }, o.prototype.bitLength = function() {
      var h = this.words[this.length - 1], m = this._countBits(h);
      return (this.length - 1) * 26 + m;
    };
    function G(k) {
      for (var h = new Array(k.bitLength()), m = 0; m < h.length; m++) {
        var x = m / 26 | 0, M = m % 26;
        h[m] = k.words[x] >>> M & 1;
      }
      return h;
    }
    o.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var h = 0, m = 0; m < this.length; m++) {
        var x = this._zeroBits(this.words[m]);
        if (h += x, x !== 26)
          break;
      }
      return h;
    }, o.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, o.prototype.toTwos = function(h) {
      return this.negative !== 0 ? this.abs().inotn(h).iaddn(1) : this.clone();
    }, o.prototype.fromTwos = function(h) {
      return this.testn(h - 1) ? this.notn(h).iaddn(1).ineg() : this.clone();
    }, o.prototype.isNeg = function() {
      return this.negative !== 0;
    }, o.prototype.neg = function() {
      return this.clone().ineg();
    }, o.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, o.prototype.iuor = function(h) {
      for (; this.length < h.length; )
        this.words[this.length++] = 0;
      for (var m = 0; m < h.length; m++)
        this.words[m] = this.words[m] | h.words[m];
      return this._strip();
    }, o.prototype.ior = function(h) {
      return n((this.negative | h.negative) === 0), this.iuor(h);
    }, o.prototype.or = function(h) {
      return this.length > h.length ? this.clone().ior(h) : h.clone().ior(this);
    }, o.prototype.uor = function(h) {
      return this.length > h.length ? this.clone().iuor(h) : h.clone().iuor(this);
    }, o.prototype.iuand = function(h) {
      var m;
      this.length > h.length ? m = h : m = this;
      for (var x = 0; x < m.length; x++)
        this.words[x] = this.words[x] & h.words[x];
      return this.length = m.length, this._strip();
    }, o.prototype.iand = function(h) {
      return n((this.negative | h.negative) === 0), this.iuand(h);
    }, o.prototype.and = function(h) {
      return this.length > h.length ? this.clone().iand(h) : h.clone().iand(this);
    }, o.prototype.uand = function(h) {
      return this.length > h.length ? this.clone().iuand(h) : h.clone().iuand(this);
    }, o.prototype.iuxor = function(h) {
      var m, x;
      this.length > h.length ? (m = this, x = h) : (m = h, x = this);
      for (var M = 0; M < x.length; M++)
        this.words[M] = m.words[M] ^ x.words[M];
      if (this !== m)
        for (; M < m.length; M++)
          this.words[M] = m.words[M];
      return this.length = m.length, this._strip();
    }, o.prototype.ixor = function(h) {
      return n((this.negative | h.negative) === 0), this.iuxor(h);
    }, o.prototype.xor = function(h) {
      return this.length > h.length ? this.clone().ixor(h) : h.clone().ixor(this);
    }, o.prototype.uxor = function(h) {
      return this.length > h.length ? this.clone().iuxor(h) : h.clone().iuxor(this);
    }, o.prototype.inotn = function(h) {
      n(typeof h == "number" && h >= 0);
      var m = Math.ceil(h / 26) | 0, x = h % 26;
      this._expand(m), x > 0 && m--;
      for (var M = 0; M < m; M++)
        this.words[M] = ~this.words[M] & 67108863;
      return x > 0 && (this.words[M] = ~this.words[M] & 67108863 >> 26 - x), this._strip();
    }, o.prototype.notn = function(h) {
      return this.clone().inotn(h);
    }, o.prototype.setn = function(h, m) {
      n(typeof h == "number" && h >= 0);
      var x = h / 26 | 0, M = h % 26;
      return this._expand(x + 1), m ? this.words[x] = this.words[x] | 1 << M : this.words[x] = this.words[x] & ~(1 << M), this._strip();
    }, o.prototype.iadd = function(h) {
      var m;
      if (this.negative !== 0 && h.negative === 0)
        return this.negative = 0, m = this.isub(h), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && h.negative !== 0)
        return h.negative = 0, m = this.isub(h), h.negative = 1, m._normSign();
      var x, M;
      this.length > h.length ? (x = this, M = h) : (x = h, M = this);
      for (var A = 0, $ = 0; $ < M.length; $++)
        m = (x.words[$] | 0) + (M.words[$] | 0) + A, this.words[$] = m & 67108863, A = m >>> 26;
      for (; A !== 0 && $ < x.length; $++)
        m = (x.words[$] | 0) + A, this.words[$] = m & 67108863, A = m >>> 26;
      if (this.length = x.length, A !== 0)
        this.words[this.length] = A, this.length++;
      else if (x !== this)
        for (; $ < x.length; $++)
          this.words[$] = x.words[$];
      return this;
    }, o.prototype.add = function(h) {
      var m;
      return h.negative !== 0 && this.negative === 0 ? (h.negative = 0, m = this.sub(h), h.negative ^= 1, m) : h.negative === 0 && this.negative !== 0 ? (this.negative = 0, m = h.sub(this), this.negative = 1, m) : this.length > h.length ? this.clone().iadd(h) : h.clone().iadd(this);
    }, o.prototype.isub = function(h) {
      if (h.negative !== 0) {
        h.negative = 0;
        var m = this.iadd(h);
        return h.negative = 1, m._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(h), this.negative = 1, this._normSign();
      var x = this.cmp(h);
      if (x === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var M, A;
      x > 0 ? (M = this, A = h) : (M = h, A = this);
      for (var $ = 0, K = 0; K < A.length; K++)
        m = (M.words[K] | 0) - (A.words[K] | 0) + $, $ = m >> 26, this.words[K] = m & 67108863;
      for (; $ !== 0 && K < M.length; K++)
        m = (M.words[K] | 0) + $, $ = m >> 26, this.words[K] = m & 67108863;
      if ($ === 0 && K < M.length && M !== this)
        for (; K < M.length; K++)
          this.words[K] = M.words[K];
      return this.length = Math.max(this.length, K), M !== this && (this.negative = 1), this._strip();
    }, o.prototype.sub = function(h) {
      return this.clone().isub(h);
    };
    function H(k, h, m) {
      m.negative = h.negative ^ k.negative;
      var x = k.length + h.length | 0;
      m.length = x, x = x - 1 | 0;
      var M = k.words[0] | 0, A = h.words[0] | 0, $ = M * A, K = $ & 67108863, D = $ / 67108864 | 0;
      m.words[0] = K;
      for (var w = 1; w < x; w++) {
        for (var U = D >>> 26, me = D & 67108863, pe = Math.min(w, h.length - 1), ee = Math.max(0, w - k.length + 1); ee <= pe; ee++) {
          var V = w - ee | 0;
          M = k.words[V] | 0, A = h.words[ee] | 0, $ = M * A + me, U += $ / 67108864 | 0, me = $ & 67108863;
        }
        m.words[w] = me | 0, D = U | 0;
      }
      return D !== 0 ? m.words[w] = D | 0 : m.length--, m._strip();
    }
    var T = function(h, m, x) {
      var M = h.words, A = m.words, $ = x.words, K = 0, D, w, U, me = M[0] | 0, pe = me & 8191, ee = me >>> 13, V = M[1] | 0, Q = V & 8191, X = V >>> 13, E = M[2] | 0, I = E & 8191, F = E >>> 13, se = M[3] | 0, fe = se & 8191, Re = se >>> 13, j = M[4] | 0, b = j & 8191, S = j >>> 13, Z = M[5] | 0, re = Z & 8191, ue = Z >>> 13, ge = M[6] | 0, Ee = ge & 8191, Ie = ge >>> 13, Ae = M[7] | 0, xe = Ae & 8191, Se = Ae >>> 13, Le = M[8] | 0, Ne = Le & 8191, Oe = Le >>> 13, it = M[9] | 0, Fe = it & 8191, je = it >>> 13, ut = A[0] | 0, Be = ut & 8191, ht = ut >>> 13, ar = A[1] | 0, bt = ar & 8191, ft = ar >>> 13, Lr = A[2] | 0, It = Lr & 8191, Mt = Lr >>> 13, Tt = A[3] | 0, Ke = Tt & 8191, Qe = Tt >>> 13, Nt = A[4] | 0, Je = Nt & 8191, Ge = Nt >>> 13, Ht = A[5] | 0, tt = Ht & 8191, Ze = Ht >>> 13, qt = A[6] | 0, Ye = qt & 8191, Xe = qt >>> 13, kt = A[7] | 0, qe = kt & 8191, rt = kt >>> 13, zt = A[8] | 0, $t = zt & 8191, Ft = zt >>> 13, pi = A[9] | 0, vt = pi & 8191, Bt = pi >>> 13;
      x.negative = h.negative ^ m.negative, x.length = 19, D = Math.imul(pe, Be), w = Math.imul(pe, ht), w = w + Math.imul(ee, Be) | 0, U = Math.imul(ee, ht);
      var Wn = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, D = Math.imul(Q, Be), w = Math.imul(Q, ht), w = w + Math.imul(X, Be) | 0, U = Math.imul(X, ht), D = D + Math.imul(pe, bt) | 0, w = w + Math.imul(pe, ft) | 0, w = w + Math.imul(ee, bt) | 0, U = U + Math.imul(ee, ft) | 0;
      var Kn = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Kn >>> 26) | 0, Kn &= 67108863, D = Math.imul(I, Be), w = Math.imul(I, ht), w = w + Math.imul(F, Be) | 0, U = Math.imul(F, ht), D = D + Math.imul(Q, bt) | 0, w = w + Math.imul(Q, ft) | 0, w = w + Math.imul(X, bt) | 0, U = U + Math.imul(X, ft) | 0, D = D + Math.imul(pe, It) | 0, w = w + Math.imul(pe, Mt) | 0, w = w + Math.imul(ee, It) | 0, U = U + Math.imul(ee, Mt) | 0;
      var Gn = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Gn >>> 26) | 0, Gn &= 67108863, D = Math.imul(fe, Be), w = Math.imul(fe, ht), w = w + Math.imul(Re, Be) | 0, U = Math.imul(Re, ht), D = D + Math.imul(I, bt) | 0, w = w + Math.imul(I, ft) | 0, w = w + Math.imul(F, bt) | 0, U = U + Math.imul(F, ft) | 0, D = D + Math.imul(Q, It) | 0, w = w + Math.imul(Q, Mt) | 0, w = w + Math.imul(X, It) | 0, U = U + Math.imul(X, Mt) | 0, D = D + Math.imul(pe, Ke) | 0, w = w + Math.imul(pe, Qe) | 0, w = w + Math.imul(ee, Ke) | 0, U = U + Math.imul(ee, Qe) | 0;
      var Jn = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, D = Math.imul(b, Be), w = Math.imul(b, ht), w = w + Math.imul(S, Be) | 0, U = Math.imul(S, ht), D = D + Math.imul(fe, bt) | 0, w = w + Math.imul(fe, ft) | 0, w = w + Math.imul(Re, bt) | 0, U = U + Math.imul(Re, ft) | 0, D = D + Math.imul(I, It) | 0, w = w + Math.imul(I, Mt) | 0, w = w + Math.imul(F, It) | 0, U = U + Math.imul(F, Mt) | 0, D = D + Math.imul(Q, Ke) | 0, w = w + Math.imul(Q, Qe) | 0, w = w + Math.imul(X, Ke) | 0, U = U + Math.imul(X, Qe) | 0, D = D + Math.imul(pe, Je) | 0, w = w + Math.imul(pe, Ge) | 0, w = w + Math.imul(ee, Je) | 0, U = U + Math.imul(ee, Ge) | 0;
      var Ar = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Ar >>> 26) | 0, Ar &= 67108863, D = Math.imul(re, Be), w = Math.imul(re, ht), w = w + Math.imul(ue, Be) | 0, U = Math.imul(ue, ht), D = D + Math.imul(b, bt) | 0, w = w + Math.imul(b, ft) | 0, w = w + Math.imul(S, bt) | 0, U = U + Math.imul(S, ft) | 0, D = D + Math.imul(fe, It) | 0, w = w + Math.imul(fe, Mt) | 0, w = w + Math.imul(Re, It) | 0, U = U + Math.imul(Re, Mt) | 0, D = D + Math.imul(I, Ke) | 0, w = w + Math.imul(I, Qe) | 0, w = w + Math.imul(F, Ke) | 0, U = U + Math.imul(F, Qe) | 0, D = D + Math.imul(Q, Je) | 0, w = w + Math.imul(Q, Ge) | 0, w = w + Math.imul(X, Je) | 0, U = U + Math.imul(X, Ge) | 0, D = D + Math.imul(pe, tt) | 0, w = w + Math.imul(pe, Ze) | 0, w = w + Math.imul(ee, tt) | 0, U = U + Math.imul(ee, Ze) | 0;
      var Xr = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Xr >>> 26) | 0, Xr &= 67108863, D = Math.imul(Ee, Be), w = Math.imul(Ee, ht), w = w + Math.imul(Ie, Be) | 0, U = Math.imul(Ie, ht), D = D + Math.imul(re, bt) | 0, w = w + Math.imul(re, ft) | 0, w = w + Math.imul(ue, bt) | 0, U = U + Math.imul(ue, ft) | 0, D = D + Math.imul(b, It) | 0, w = w + Math.imul(b, Mt) | 0, w = w + Math.imul(S, It) | 0, U = U + Math.imul(S, Mt) | 0, D = D + Math.imul(fe, Ke) | 0, w = w + Math.imul(fe, Qe) | 0, w = w + Math.imul(Re, Ke) | 0, U = U + Math.imul(Re, Qe) | 0, D = D + Math.imul(I, Je) | 0, w = w + Math.imul(I, Ge) | 0, w = w + Math.imul(F, Je) | 0, U = U + Math.imul(F, Ge) | 0, D = D + Math.imul(Q, tt) | 0, w = w + Math.imul(Q, Ze) | 0, w = w + Math.imul(X, tt) | 0, U = U + Math.imul(X, Ze) | 0, D = D + Math.imul(pe, Ye) | 0, w = w + Math.imul(pe, Xe) | 0, w = w + Math.imul(ee, Ye) | 0, U = U + Math.imul(ee, Xe) | 0;
      var Qn = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Qn >>> 26) | 0, Qn &= 67108863, D = Math.imul(xe, Be), w = Math.imul(xe, ht), w = w + Math.imul(Se, Be) | 0, U = Math.imul(Se, ht), D = D + Math.imul(Ee, bt) | 0, w = w + Math.imul(Ee, ft) | 0, w = w + Math.imul(Ie, bt) | 0, U = U + Math.imul(Ie, ft) | 0, D = D + Math.imul(re, It) | 0, w = w + Math.imul(re, Mt) | 0, w = w + Math.imul(ue, It) | 0, U = U + Math.imul(ue, Mt) | 0, D = D + Math.imul(b, Ke) | 0, w = w + Math.imul(b, Qe) | 0, w = w + Math.imul(S, Ke) | 0, U = U + Math.imul(S, Qe) | 0, D = D + Math.imul(fe, Je) | 0, w = w + Math.imul(fe, Ge) | 0, w = w + Math.imul(Re, Je) | 0, U = U + Math.imul(Re, Ge) | 0, D = D + Math.imul(I, tt) | 0, w = w + Math.imul(I, Ze) | 0, w = w + Math.imul(F, tt) | 0, U = U + Math.imul(F, Ze) | 0, D = D + Math.imul(Q, Ye) | 0, w = w + Math.imul(Q, Xe) | 0, w = w + Math.imul(X, Ye) | 0, U = U + Math.imul(X, Xe) | 0, D = D + Math.imul(pe, qe) | 0, w = w + Math.imul(pe, rt) | 0, w = w + Math.imul(ee, qe) | 0, U = U + Math.imul(ee, rt) | 0;
      var en = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, D = Math.imul(Ne, Be), w = Math.imul(Ne, ht), w = w + Math.imul(Oe, Be) | 0, U = Math.imul(Oe, ht), D = D + Math.imul(xe, bt) | 0, w = w + Math.imul(xe, ft) | 0, w = w + Math.imul(Se, bt) | 0, U = U + Math.imul(Se, ft) | 0, D = D + Math.imul(Ee, It) | 0, w = w + Math.imul(Ee, Mt) | 0, w = w + Math.imul(Ie, It) | 0, U = U + Math.imul(Ie, Mt) | 0, D = D + Math.imul(re, Ke) | 0, w = w + Math.imul(re, Qe) | 0, w = w + Math.imul(ue, Ke) | 0, U = U + Math.imul(ue, Qe) | 0, D = D + Math.imul(b, Je) | 0, w = w + Math.imul(b, Ge) | 0, w = w + Math.imul(S, Je) | 0, U = U + Math.imul(S, Ge) | 0, D = D + Math.imul(fe, tt) | 0, w = w + Math.imul(fe, Ze) | 0, w = w + Math.imul(Re, tt) | 0, U = U + Math.imul(Re, Ze) | 0, D = D + Math.imul(I, Ye) | 0, w = w + Math.imul(I, Xe) | 0, w = w + Math.imul(F, Ye) | 0, U = U + Math.imul(F, Xe) | 0, D = D + Math.imul(Q, qe) | 0, w = w + Math.imul(Q, rt) | 0, w = w + Math.imul(X, qe) | 0, U = U + Math.imul(X, rt) | 0, D = D + Math.imul(pe, $t) | 0, w = w + Math.imul(pe, Ft) | 0, w = w + Math.imul(ee, $t) | 0, U = U + Math.imul(ee, Ft) | 0;
      var Zn = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Zn >>> 26) | 0, Zn &= 67108863, D = Math.imul(Fe, Be), w = Math.imul(Fe, ht), w = w + Math.imul(je, Be) | 0, U = Math.imul(je, ht), D = D + Math.imul(Ne, bt) | 0, w = w + Math.imul(Ne, ft) | 0, w = w + Math.imul(Oe, bt) | 0, U = U + Math.imul(Oe, ft) | 0, D = D + Math.imul(xe, It) | 0, w = w + Math.imul(xe, Mt) | 0, w = w + Math.imul(Se, It) | 0, U = U + Math.imul(Se, Mt) | 0, D = D + Math.imul(Ee, Ke) | 0, w = w + Math.imul(Ee, Qe) | 0, w = w + Math.imul(Ie, Ke) | 0, U = U + Math.imul(Ie, Qe) | 0, D = D + Math.imul(re, Je) | 0, w = w + Math.imul(re, Ge) | 0, w = w + Math.imul(ue, Je) | 0, U = U + Math.imul(ue, Ge) | 0, D = D + Math.imul(b, tt) | 0, w = w + Math.imul(b, Ze) | 0, w = w + Math.imul(S, tt) | 0, U = U + Math.imul(S, Ze) | 0, D = D + Math.imul(fe, Ye) | 0, w = w + Math.imul(fe, Xe) | 0, w = w + Math.imul(Re, Ye) | 0, U = U + Math.imul(Re, Xe) | 0, D = D + Math.imul(I, qe) | 0, w = w + Math.imul(I, rt) | 0, w = w + Math.imul(F, qe) | 0, U = U + Math.imul(F, rt) | 0, D = D + Math.imul(Q, $t) | 0, w = w + Math.imul(Q, Ft) | 0, w = w + Math.imul(X, $t) | 0, U = U + Math.imul(X, Ft) | 0, D = D + Math.imul(pe, vt) | 0, w = w + Math.imul(pe, Bt) | 0, w = w + Math.imul(ee, vt) | 0, U = U + Math.imul(ee, Bt) | 0;
      var Yn = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Yn >>> 26) | 0, Yn &= 67108863, D = Math.imul(Fe, bt), w = Math.imul(Fe, ft), w = w + Math.imul(je, bt) | 0, U = Math.imul(je, ft), D = D + Math.imul(Ne, It) | 0, w = w + Math.imul(Ne, Mt) | 0, w = w + Math.imul(Oe, It) | 0, U = U + Math.imul(Oe, Mt) | 0, D = D + Math.imul(xe, Ke) | 0, w = w + Math.imul(xe, Qe) | 0, w = w + Math.imul(Se, Ke) | 0, U = U + Math.imul(Se, Qe) | 0, D = D + Math.imul(Ee, Je) | 0, w = w + Math.imul(Ee, Ge) | 0, w = w + Math.imul(Ie, Je) | 0, U = U + Math.imul(Ie, Ge) | 0, D = D + Math.imul(re, tt) | 0, w = w + Math.imul(re, Ze) | 0, w = w + Math.imul(ue, tt) | 0, U = U + Math.imul(ue, Ze) | 0, D = D + Math.imul(b, Ye) | 0, w = w + Math.imul(b, Xe) | 0, w = w + Math.imul(S, Ye) | 0, U = U + Math.imul(S, Xe) | 0, D = D + Math.imul(fe, qe) | 0, w = w + Math.imul(fe, rt) | 0, w = w + Math.imul(Re, qe) | 0, U = U + Math.imul(Re, rt) | 0, D = D + Math.imul(I, $t) | 0, w = w + Math.imul(I, Ft) | 0, w = w + Math.imul(F, $t) | 0, U = U + Math.imul(F, Ft) | 0, D = D + Math.imul(Q, vt) | 0, w = w + Math.imul(Q, Bt) | 0, w = w + Math.imul(X, vt) | 0, U = U + Math.imul(X, Bt) | 0;
      var tn = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, D = Math.imul(Fe, It), w = Math.imul(Fe, Mt), w = w + Math.imul(je, It) | 0, U = Math.imul(je, Mt), D = D + Math.imul(Ne, Ke) | 0, w = w + Math.imul(Ne, Qe) | 0, w = w + Math.imul(Oe, Ke) | 0, U = U + Math.imul(Oe, Qe) | 0, D = D + Math.imul(xe, Je) | 0, w = w + Math.imul(xe, Ge) | 0, w = w + Math.imul(Se, Je) | 0, U = U + Math.imul(Se, Ge) | 0, D = D + Math.imul(Ee, tt) | 0, w = w + Math.imul(Ee, Ze) | 0, w = w + Math.imul(Ie, tt) | 0, U = U + Math.imul(Ie, Ze) | 0, D = D + Math.imul(re, Ye) | 0, w = w + Math.imul(re, Xe) | 0, w = w + Math.imul(ue, Ye) | 0, U = U + Math.imul(ue, Xe) | 0, D = D + Math.imul(b, qe) | 0, w = w + Math.imul(b, rt) | 0, w = w + Math.imul(S, qe) | 0, U = U + Math.imul(S, rt) | 0, D = D + Math.imul(fe, $t) | 0, w = w + Math.imul(fe, Ft) | 0, w = w + Math.imul(Re, $t) | 0, U = U + Math.imul(Re, Ft) | 0, D = D + Math.imul(I, vt) | 0, w = w + Math.imul(I, Bt) | 0, w = w + Math.imul(F, vt) | 0, U = U + Math.imul(F, Bt) | 0;
      var Rn = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Rn >>> 26) | 0, Rn &= 67108863, D = Math.imul(Fe, Ke), w = Math.imul(Fe, Qe), w = w + Math.imul(je, Ke) | 0, U = Math.imul(je, Qe), D = D + Math.imul(Ne, Je) | 0, w = w + Math.imul(Ne, Ge) | 0, w = w + Math.imul(Oe, Je) | 0, U = U + Math.imul(Oe, Ge) | 0, D = D + Math.imul(xe, tt) | 0, w = w + Math.imul(xe, Ze) | 0, w = w + Math.imul(Se, tt) | 0, U = U + Math.imul(Se, Ze) | 0, D = D + Math.imul(Ee, Ye) | 0, w = w + Math.imul(Ee, Xe) | 0, w = w + Math.imul(Ie, Ye) | 0, U = U + Math.imul(Ie, Xe) | 0, D = D + Math.imul(re, qe) | 0, w = w + Math.imul(re, rt) | 0, w = w + Math.imul(ue, qe) | 0, U = U + Math.imul(ue, rt) | 0, D = D + Math.imul(b, $t) | 0, w = w + Math.imul(b, Ft) | 0, w = w + Math.imul(S, $t) | 0, U = U + Math.imul(S, Ft) | 0, D = D + Math.imul(fe, vt) | 0, w = w + Math.imul(fe, Bt) | 0, w = w + Math.imul(Re, vt) | 0, U = U + Math.imul(Re, Bt) | 0;
      var An = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, D = Math.imul(Fe, Je), w = Math.imul(Fe, Ge), w = w + Math.imul(je, Je) | 0, U = Math.imul(je, Ge), D = D + Math.imul(Ne, tt) | 0, w = w + Math.imul(Ne, Ze) | 0, w = w + Math.imul(Oe, tt) | 0, U = U + Math.imul(Oe, Ze) | 0, D = D + Math.imul(xe, Ye) | 0, w = w + Math.imul(xe, Xe) | 0, w = w + Math.imul(Se, Ye) | 0, U = U + Math.imul(Se, Xe) | 0, D = D + Math.imul(Ee, qe) | 0, w = w + Math.imul(Ee, rt) | 0, w = w + Math.imul(Ie, qe) | 0, U = U + Math.imul(Ie, rt) | 0, D = D + Math.imul(re, $t) | 0, w = w + Math.imul(re, Ft) | 0, w = w + Math.imul(ue, $t) | 0, U = U + Math.imul(ue, Ft) | 0, D = D + Math.imul(b, vt) | 0, w = w + Math.imul(b, Bt) | 0, w = w + Math.imul(S, vt) | 0, U = U + Math.imul(S, Bt) | 0;
      var mr = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (mr >>> 26) | 0, mr &= 67108863, D = Math.imul(Fe, tt), w = Math.imul(Fe, Ze), w = w + Math.imul(je, tt) | 0, U = Math.imul(je, Ze), D = D + Math.imul(Ne, Ye) | 0, w = w + Math.imul(Ne, Xe) | 0, w = w + Math.imul(Oe, Ye) | 0, U = U + Math.imul(Oe, Xe) | 0, D = D + Math.imul(xe, qe) | 0, w = w + Math.imul(xe, rt) | 0, w = w + Math.imul(Se, qe) | 0, U = U + Math.imul(Se, rt) | 0, D = D + Math.imul(Ee, $t) | 0, w = w + Math.imul(Ee, Ft) | 0, w = w + Math.imul(Ie, $t) | 0, U = U + Math.imul(Ie, Ft) | 0, D = D + Math.imul(re, vt) | 0, w = w + Math.imul(re, Bt) | 0, w = w + Math.imul(ue, vt) | 0, U = U + Math.imul(ue, Bt) | 0;
      var Os = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Os >>> 26) | 0, Os &= 67108863, D = Math.imul(Fe, Ye), w = Math.imul(Fe, Xe), w = w + Math.imul(je, Ye) | 0, U = Math.imul(je, Xe), D = D + Math.imul(Ne, qe) | 0, w = w + Math.imul(Ne, rt) | 0, w = w + Math.imul(Oe, qe) | 0, U = U + Math.imul(Oe, rt) | 0, D = D + Math.imul(xe, $t) | 0, w = w + Math.imul(xe, Ft) | 0, w = w + Math.imul(Se, $t) | 0, U = U + Math.imul(Se, Ft) | 0, D = D + Math.imul(Ee, vt) | 0, w = w + Math.imul(Ee, Bt) | 0, w = w + Math.imul(Ie, vt) | 0, U = U + Math.imul(Ie, Bt) | 0;
      var Ps = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Ps >>> 26) | 0, Ps &= 67108863, D = Math.imul(Fe, qe), w = Math.imul(Fe, rt), w = w + Math.imul(je, qe) | 0, U = Math.imul(je, rt), D = D + Math.imul(Ne, $t) | 0, w = w + Math.imul(Ne, Ft) | 0, w = w + Math.imul(Oe, $t) | 0, U = U + Math.imul(Oe, Ft) | 0, D = D + Math.imul(xe, vt) | 0, w = w + Math.imul(xe, Bt) | 0, w = w + Math.imul(Se, vt) | 0, U = U + Math.imul(Se, Bt) | 0;
      var Ts = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Ts >>> 26) | 0, Ts &= 67108863, D = Math.imul(Fe, $t), w = Math.imul(Fe, Ft), w = w + Math.imul(je, $t) | 0, U = Math.imul(je, Ft), D = D + Math.imul(Ne, vt) | 0, w = w + Math.imul(Ne, Bt) | 0, w = w + Math.imul(Oe, vt) | 0, U = U + Math.imul(Oe, Bt) | 0;
      var Ns = (K + D | 0) + ((w & 8191) << 13) | 0;
      K = (U + (w >>> 13) | 0) + (Ns >>> 26) | 0, Ns &= 67108863, D = Math.imul(Fe, vt), w = Math.imul(Fe, Bt), w = w + Math.imul(je, vt) | 0, U = Math.imul(je, Bt);
      var as = (K + D | 0) + ((w & 8191) << 13) | 0;
      return K = (U + (w >>> 13) | 0) + (as >>> 26) | 0, as &= 67108863, $[0] = Wn, $[1] = Kn, $[2] = Gn, $[3] = Jn, $[4] = Ar, $[5] = Xr, $[6] = Qn, $[7] = en, $[8] = Zn, $[9] = Yn, $[10] = tn, $[11] = Rn, $[12] = An, $[13] = mr, $[14] = Os, $[15] = Ps, $[16] = Ts, $[17] = Ns, $[18] = as, K !== 0 && ($[19] = K, x.length++), x;
    };
    Math.imul || (T = H);
    function q(k, h, m) {
      m.negative = h.negative ^ k.negative, m.length = k.length + h.length;
      for (var x = 0, M = 0, A = 0; A < m.length - 1; A++) {
        var $ = M;
        M = 0;
        for (var K = x & 67108863, D = Math.min(A, h.length - 1), w = Math.max(0, A - k.length + 1); w <= D; w++) {
          var U = A - w, me = k.words[U] | 0, pe = h.words[w] | 0, ee = me * pe, V = ee & 67108863;
          $ = $ + (ee / 67108864 | 0) | 0, V = V + K | 0, K = V & 67108863, $ = $ + (V >>> 26) | 0, M += $ >>> 26, $ &= 67108863;
        }
        m.words[A] = K, x = $, $ = M;
      }
      return x !== 0 ? m.words[A] = x : m.length--, m._strip();
    }
    function B(k, h, m) {
      return q(k, h, m);
    }
    o.prototype.mulTo = function(h, m) {
      var x, M = this.length + h.length;
      return this.length === 10 && h.length === 10 ? x = T(this, h, m) : M < 63 ? x = H(this, h, m) : M < 1024 ? x = q(this, h, m) : x = B(this, h, m), x;
    }, o.prototype.mul = function(h) {
      var m = new o(null);
      return m.words = new Array(this.length + h.length), this.mulTo(h, m);
    }, o.prototype.mulf = function(h) {
      var m = new o(null);
      return m.words = new Array(this.length + h.length), B(this, h, m);
    }, o.prototype.imul = function(h) {
      return this.clone().mulTo(h, this);
    }, o.prototype.imuln = function(h) {
      var m = h < 0;
      m && (h = -h), n(typeof h == "number"), n(h < 67108864);
      for (var x = 0, M = 0; M < this.length; M++) {
        var A = (this.words[M] | 0) * h, $ = (A & 67108863) + (x & 67108863);
        x >>= 26, x += A / 67108864 | 0, x += $ >>> 26, this.words[M] = $ & 67108863;
      }
      return x !== 0 && (this.words[M] = x, this.length++), m ? this.ineg() : this;
    }, o.prototype.muln = function(h) {
      return this.clone().imuln(h);
    }, o.prototype.sqr = function() {
      return this.mul(this);
    }, o.prototype.isqr = function() {
      return this.imul(this.clone());
    }, o.prototype.pow = function(h) {
      var m = G(h);
      if (m.length === 0)
        return new o(1);
      for (var x = this, M = 0; M < m.length && m[M] === 0; M++, x = x.sqr())
        ;
      if (++M < m.length)
        for (var A = x.sqr(); M < m.length; M++, A = A.sqr())
          m[M] !== 0 && (x = x.mul(A));
      return x;
    }, o.prototype.iushln = function(h) {
      n(typeof h == "number" && h >= 0);
      var m = h % 26, x = (h - m) / 26, M = 67108863 >>> 26 - m << 26 - m, A;
      if (m !== 0) {
        var $ = 0;
        for (A = 0; A < this.length; A++) {
          var K = this.words[A] & M, D = (this.words[A] | 0) - K << m;
          this.words[A] = D | $, $ = K >>> 26 - m;
        }
        $ && (this.words[A] = $, this.length++);
      }
      if (x !== 0) {
        for (A = this.length - 1; A >= 0; A--)
          this.words[A + x] = this.words[A];
        for (A = 0; A < x; A++)
          this.words[A] = 0;
        this.length += x;
      }
      return this._strip();
    }, o.prototype.ishln = function(h) {
      return n(this.negative === 0), this.iushln(h);
    }, o.prototype.iushrn = function(h, m, x) {
      n(typeof h == "number" && h >= 0);
      var M;
      m ? M = (m - m % 26) / 26 : M = 0;
      var A = h % 26, $ = Math.min((h - A) / 26, this.length), K = 67108863 ^ 67108863 >>> A << A, D = x;
      if (M -= $, M = Math.max(0, M), D) {
        for (var w = 0; w < $; w++)
          D.words[w] = this.words[w];
        D.length = $;
      }
      if ($ !== 0)
        if (this.length > $)
          for (this.length -= $, w = 0; w < this.length; w++)
            this.words[w] = this.words[w + $];
        else
          this.words[0] = 0, this.length = 1;
      var U = 0;
      for (w = this.length - 1; w >= 0 && (U !== 0 || w >= M); w--) {
        var me = this.words[w] | 0;
        this.words[w] = U << 26 - A | me >>> A, U = me & K;
      }
      return D && U !== 0 && (D.words[D.length++] = U), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, o.prototype.ishrn = function(h, m, x) {
      return n(this.negative === 0), this.iushrn(h, m, x);
    }, o.prototype.shln = function(h) {
      return this.clone().ishln(h);
    }, o.prototype.ushln = function(h) {
      return this.clone().iushln(h);
    }, o.prototype.shrn = function(h) {
      return this.clone().ishrn(h);
    }, o.prototype.ushrn = function(h) {
      return this.clone().iushrn(h);
    }, o.prototype.testn = function(h) {
      n(typeof h == "number" && h >= 0);
      var m = h % 26, x = (h - m) / 26, M = 1 << m;
      if (this.length <= x)
        return !1;
      var A = this.words[x];
      return !!(A & M);
    }, o.prototype.imaskn = function(h) {
      n(typeof h == "number" && h >= 0);
      var m = h % 26, x = (h - m) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= x)
        return this;
      if (m !== 0 && x++, this.length = Math.min(x, this.length), m !== 0) {
        var M = 67108863 ^ 67108863 >>> m << m;
        this.words[this.length - 1] &= M;
      }
      return this._strip();
    }, o.prototype.maskn = function(h) {
      return this.clone().imaskn(h);
    }, o.prototype.iaddn = function(h) {
      return n(typeof h == "number"), n(h < 67108864), h < 0 ? this.isubn(-h) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= h ? (this.words[0] = h - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(h), this.negative = 1, this) : this._iaddn(h);
    }, o.prototype._iaddn = function(h) {
      this.words[0] += h;
      for (var m = 0; m < this.length && this.words[m] >= 67108864; m++)
        this.words[m] -= 67108864, m === this.length - 1 ? this.words[m + 1] = 1 : this.words[m + 1]++;
      return this.length = Math.max(this.length, m + 1), this;
    }, o.prototype.isubn = function(h) {
      if (n(typeof h == "number"), n(h < 67108864), h < 0)
        return this.iaddn(-h);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(h), this.negative = 1, this;
      if (this.words[0] -= h, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var m = 0; m < this.length && this.words[m] < 0; m++)
          this.words[m] += 67108864, this.words[m + 1] -= 1;
      return this._strip();
    }, o.prototype.addn = function(h) {
      return this.clone().iaddn(h);
    }, o.prototype.subn = function(h) {
      return this.clone().isubn(h);
    }, o.prototype.iabs = function() {
      return this.negative = 0, this;
    }, o.prototype.abs = function() {
      return this.clone().iabs();
    }, o.prototype._ishlnsubmul = function(h, m, x) {
      var M = h.length + x, A;
      this._expand(M);
      var $, K = 0;
      for (A = 0; A < h.length; A++) {
        $ = (this.words[A + x] | 0) + K;
        var D = (h.words[A] | 0) * m;
        $ -= D & 67108863, K = ($ >> 26) - (D / 67108864 | 0), this.words[A + x] = $ & 67108863;
      }
      for (; A < this.length - x; A++)
        $ = (this.words[A + x] | 0) + K, K = $ >> 26, this.words[A + x] = $ & 67108863;
      if (K === 0)
        return this._strip();
      for (n(K === -1), K = 0, A = 0; A < this.length; A++)
        $ = -(this.words[A] | 0) + K, K = $ >> 26, this.words[A] = $ & 67108863;
      return this.negative = 1, this._strip();
    }, o.prototype._wordDiv = function(h, m) {
      var x = this.length - h.length, M = this.clone(), A = h, $ = A.words[A.length - 1] | 0, K = this._countBits($);
      x = 26 - K, x !== 0 && (A = A.ushln(x), M.iushln(x), $ = A.words[A.length - 1] | 0);
      var D = M.length - A.length, w;
      if (m !== "mod") {
        w = new o(null), w.length = D + 1, w.words = new Array(w.length);
        for (var U = 0; U < w.length; U++)
          w.words[U] = 0;
      }
      var me = M.clone()._ishlnsubmul(A, 1, D);
      me.negative === 0 && (M = me, w && (w.words[D] = 1));
      for (var pe = D - 1; pe >= 0; pe--) {
        var ee = (M.words[A.length + pe] | 0) * 67108864 + (M.words[A.length + pe - 1] | 0);
        for (ee = Math.min(ee / $ | 0, 67108863), M._ishlnsubmul(A, ee, pe); M.negative !== 0; )
          ee--, M.negative = 0, M._ishlnsubmul(A, 1, pe), M.isZero() || (M.negative ^= 1);
        w && (w.words[pe] = ee);
      }
      return w && w._strip(), M._strip(), m !== "div" && x !== 0 && M.iushrn(x), {
        div: w || null,
        mod: M
      };
    }, o.prototype.divmod = function(h, m, x) {
      if (n(!h.isZero()), this.isZero())
        return {
          div: new o(0),
          mod: new o(0)
        };
      var M, A, $;
      return this.negative !== 0 && h.negative === 0 ? ($ = this.neg().divmod(h, m), m !== "mod" && (M = $.div.neg()), m !== "div" && (A = $.mod.neg(), x && A.negative !== 0 && A.iadd(h)), {
        div: M,
        mod: A
      }) : this.negative === 0 && h.negative !== 0 ? ($ = this.divmod(h.neg(), m), m !== "mod" && (M = $.div.neg()), {
        div: M,
        mod: $.mod
      }) : this.negative & h.negative ? ($ = this.neg().divmod(h.neg(), m), m !== "div" && (A = $.mod.neg(), x && A.negative !== 0 && A.isub(h)), {
        div: $.div,
        mod: A
      }) : h.length > this.length || this.cmp(h) < 0 ? {
        div: new o(0),
        mod: this
      } : h.length === 1 ? m === "div" ? {
        div: this.divn(h.words[0]),
        mod: null
      } : m === "mod" ? {
        div: null,
        mod: new o(this.modrn(h.words[0]))
      } : {
        div: this.divn(h.words[0]),
        mod: new o(this.modrn(h.words[0]))
      } : this._wordDiv(h, m);
    }, o.prototype.div = function(h) {
      return this.divmod(h, "div", !1).div;
    }, o.prototype.mod = function(h) {
      return this.divmod(h, "mod", !1).mod;
    }, o.prototype.umod = function(h) {
      return this.divmod(h, "mod", !0).mod;
    }, o.prototype.divRound = function(h) {
      var m = this.divmod(h);
      if (m.mod.isZero())
        return m.div;
      var x = m.div.negative !== 0 ? m.mod.isub(h) : m.mod, M = h.ushrn(1), A = h.andln(1), $ = x.cmp(M);
      return $ < 0 || A === 1 && $ === 0 ? m.div : m.div.negative !== 0 ? m.div.isubn(1) : m.div.iaddn(1);
    }, o.prototype.modrn = function(h) {
      var m = h < 0;
      m && (h = -h), n(h <= 67108863);
      for (var x = (1 << 26) % h, M = 0, A = this.length - 1; A >= 0; A--)
        M = (x * M + (this.words[A] | 0)) % h;
      return m ? -M : M;
    }, o.prototype.modn = function(h) {
      return this.modrn(h);
    }, o.prototype.idivn = function(h) {
      var m = h < 0;
      m && (h = -h), n(h <= 67108863);
      for (var x = 0, M = this.length - 1; M >= 0; M--) {
        var A = (this.words[M] | 0) + x * 67108864;
        this.words[M] = A / h | 0, x = A % h;
      }
      return this._strip(), m ? this.ineg() : this;
    }, o.prototype.divn = function(h) {
      return this.clone().idivn(h);
    }, o.prototype.egcd = function(h) {
      n(h.negative === 0), n(!h.isZero());
      var m = this, x = h.clone();
      m.negative !== 0 ? m = m.umod(h) : m = m.clone();
      for (var M = new o(1), A = new o(0), $ = new o(0), K = new o(1), D = 0; m.isEven() && x.isEven(); )
        m.iushrn(1), x.iushrn(1), ++D;
      for (var w = x.clone(), U = m.clone(); !m.isZero(); ) {
        for (var me = 0, pe = 1; !(m.words[0] & pe) && me < 26; ++me, pe <<= 1)
          ;
        if (me > 0)
          for (m.iushrn(me); me-- > 0; )
            (M.isOdd() || A.isOdd()) && (M.iadd(w), A.isub(U)), M.iushrn(1), A.iushrn(1);
        for (var ee = 0, V = 1; !(x.words[0] & V) && ee < 26; ++ee, V <<= 1)
          ;
        if (ee > 0)
          for (x.iushrn(ee); ee-- > 0; )
            ($.isOdd() || K.isOdd()) && ($.iadd(w), K.isub(U)), $.iushrn(1), K.iushrn(1);
        m.cmp(x) >= 0 ? (m.isub(x), M.isub($), A.isub(K)) : (x.isub(m), $.isub(M), K.isub(A));
      }
      return {
        a: $,
        b: K,
        gcd: x.iushln(D)
      };
    }, o.prototype._invmp = function(h) {
      n(h.negative === 0), n(!h.isZero());
      var m = this, x = h.clone();
      m.negative !== 0 ? m = m.umod(h) : m = m.clone();
      for (var M = new o(1), A = new o(0), $ = x.clone(); m.cmpn(1) > 0 && x.cmpn(1) > 0; ) {
        for (var K = 0, D = 1; !(m.words[0] & D) && K < 26; ++K, D <<= 1)
          ;
        if (K > 0)
          for (m.iushrn(K); K-- > 0; )
            M.isOdd() && M.iadd($), M.iushrn(1);
        for (var w = 0, U = 1; !(x.words[0] & U) && w < 26; ++w, U <<= 1)
          ;
        if (w > 0)
          for (x.iushrn(w); w-- > 0; )
            A.isOdd() && A.iadd($), A.iushrn(1);
        m.cmp(x) >= 0 ? (m.isub(x), M.isub(A)) : (x.isub(m), A.isub(M));
      }
      var me;
      return m.cmpn(1) === 0 ? me = M : me = A, me.cmpn(0) < 0 && me.iadd(h), me;
    }, o.prototype.gcd = function(h) {
      if (this.isZero())
        return h.abs();
      if (h.isZero())
        return this.abs();
      var m = this.clone(), x = h.clone();
      m.negative = 0, x.negative = 0;
      for (var M = 0; m.isEven() && x.isEven(); M++)
        m.iushrn(1), x.iushrn(1);
      do {
        for (; m.isEven(); )
          m.iushrn(1);
        for (; x.isEven(); )
          x.iushrn(1);
        var A = m.cmp(x);
        if (A < 0) {
          var $ = m;
          m = x, x = $;
        } else if (A === 0 || x.cmpn(1) === 0)
          break;
        m.isub(x);
      } while (!0);
      return x.iushln(M);
    }, o.prototype.invm = function(h) {
      return this.egcd(h).a.umod(h);
    }, o.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, o.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, o.prototype.andln = function(h) {
      return this.words[0] & h;
    }, o.prototype.bincn = function(h) {
      n(typeof h == "number");
      var m = h % 26, x = (h - m) / 26, M = 1 << m;
      if (this.length <= x)
        return this._expand(x + 1), this.words[x] |= M, this;
      for (var A = M, $ = x; A !== 0 && $ < this.length; $++) {
        var K = this.words[$] | 0;
        K += A, A = K >>> 26, K &= 67108863, this.words[$] = K;
      }
      return A !== 0 && (this.words[$] = A, this.length++), this;
    }, o.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, o.prototype.cmpn = function(h) {
      var m = h < 0;
      if (this.negative !== 0 && !m)
        return -1;
      if (this.negative === 0 && m)
        return 1;
      this._strip();
      var x;
      if (this.length > 1)
        x = 1;
      else {
        m && (h = -h), n(h <= 67108863, "Number is too big");
        var M = this.words[0] | 0;
        x = M === h ? 0 : M < h ? -1 : 1;
      }
      return this.negative !== 0 ? -x | 0 : x;
    }, o.prototype.cmp = function(h) {
      if (this.negative !== 0 && h.negative === 0)
        return -1;
      if (this.negative === 0 && h.negative !== 0)
        return 1;
      var m = this.ucmp(h);
      return this.negative !== 0 ? -m | 0 : m;
    }, o.prototype.ucmp = function(h) {
      if (this.length > h.length)
        return 1;
      if (this.length < h.length)
        return -1;
      for (var m = 0, x = this.length - 1; x >= 0; x--) {
        var M = this.words[x] | 0, A = h.words[x] | 0;
        if (M !== A) {
          M < A ? m = -1 : M > A && (m = 1);
          break;
        }
      }
      return m;
    }, o.prototype.gtn = function(h) {
      return this.cmpn(h) === 1;
    }, o.prototype.gt = function(h) {
      return this.cmp(h) === 1;
    }, o.prototype.gten = function(h) {
      return this.cmpn(h) >= 0;
    }, o.prototype.gte = function(h) {
      return this.cmp(h) >= 0;
    }, o.prototype.ltn = function(h) {
      return this.cmpn(h) === -1;
    }, o.prototype.lt = function(h) {
      return this.cmp(h) === -1;
    }, o.prototype.lten = function(h) {
      return this.cmpn(h) <= 0;
    }, o.prototype.lte = function(h) {
      return this.cmp(h) <= 0;
    }, o.prototype.eqn = function(h) {
      return this.cmpn(h) === 0;
    }, o.prototype.eq = function(h) {
      return this.cmp(h) === 0;
    }, o.red = function(h) {
      return new he(h);
    }, o.prototype.toRed = function(h) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), h.convertTo(this)._forceRed(h);
    }, o.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, o.prototype._forceRed = function(h) {
      return this.red = h, this;
    }, o.prototype.forceRed = function(h) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(h);
    }, o.prototype.redAdd = function(h) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, h);
    }, o.prototype.redIAdd = function(h) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, h);
    }, o.prototype.redSub = function(h) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, h);
    }, o.prototype.redISub = function(h) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, h);
    }, o.prototype.redShl = function(h) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, h);
    }, o.prototype.redMul = function(h) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, h), this.red.mul(this, h);
    }, o.prototype.redIMul = function(h) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, h), this.red.imul(this, h);
    }, o.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, o.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, o.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, o.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, o.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, o.prototype.redPow = function(h) {
      return n(this.red && !h.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, h);
    };
    var L = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function P(k, h) {
      this.name = k, this.p = new o(h, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    P.prototype._tmp = function() {
      var h = new o(null);
      return h.words = new Array(Math.ceil(this.n / 13)), h;
    }, P.prototype.ireduce = function(h) {
      var m = h, x;
      do
        this.split(m, this.tmp), m = this.imulK(m), m = m.iadd(this.tmp), x = m.bitLength();
      while (x > this.n);
      var M = x < this.n ? -1 : m.ucmp(this.p);
      return M === 0 ? (m.words[0] = 0, m.length = 1) : M > 0 ? m.isub(this.p) : m.strip !== void 0 ? m.strip() : m._strip(), m;
    }, P.prototype.split = function(h, m) {
      h.iushrn(this.n, 0, m);
    }, P.prototype.imulK = function(h) {
      return h.imul(this.k);
    };
    function v() {
      P.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    i(v, P), v.prototype.split = function(h, m) {
      for (var x = 4194303, M = Math.min(h.length, 9), A = 0; A < M; A++)
        m.words[A] = h.words[A];
      if (m.length = M, h.length <= 9) {
        h.words[0] = 0, h.length = 1;
        return;
      }
      var $ = h.words[9];
      for (m.words[m.length++] = $ & x, A = 10; A < h.length; A++) {
        var K = h.words[A] | 0;
        h.words[A - 10] = (K & x) << 4 | $ >>> 22, $ = K;
      }
      $ >>>= 22, h.words[A - 10] = $, $ === 0 && h.length > 10 ? h.length -= 10 : h.length -= 9;
    }, v.prototype.imulK = function(h) {
      h.words[h.length] = 0, h.words[h.length + 1] = 0, h.length += 2;
      for (var m = 0, x = 0; x < h.length; x++) {
        var M = h.words[x] | 0;
        m += M * 977, h.words[x] = m & 67108863, m = M * 64 + (m / 67108864 | 0);
      }
      return h.words[h.length - 1] === 0 && (h.length--, h.words[h.length - 1] === 0 && h.length--), h;
    };
    function N() {
      P.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    i(N, P);
    function ie() {
      P.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    i(ie, P);
    function le() {
      P.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    i(le, P), le.prototype.imulK = function(h) {
      for (var m = 0, x = 0; x < h.length; x++) {
        var M = (h.words[x] | 0) * 19 + m, A = M & 67108863;
        M >>>= 26, h.words[x] = A, m = M;
      }
      return m !== 0 && (h.words[h.length++] = m), h;
    }, o._prime = function(h) {
      if (L[h])
        return L[h];
      var m;
      if (h === "k256")
        m = new v();
      else if (h === "p224")
        m = new N();
      else if (h === "p192")
        m = new ie();
      else if (h === "p25519")
        m = new le();
      else
        throw new Error("Unknown prime " + h);
      return L[h] = m, m;
    };
    function he(k) {
      if (typeof k == "string") {
        var h = o._prime(k);
        this.m = h.p, this.prime = h;
      } else
        n(k.gtn(1), "modulus must be greater than 1"), this.m = k, this.prime = null;
    }
    he.prototype._verify1 = function(h) {
      n(h.negative === 0, "red works only with positives"), n(h.red, "red works only with red numbers");
    }, he.prototype._verify2 = function(h, m) {
      n((h.negative | m.negative) === 0, "red works only with positives"), n(
        h.red && h.red === m.red,
        "red works only with red numbers"
      );
    }, he.prototype.imod = function(h) {
      return this.prime ? this.prime.ireduce(h)._forceRed(this) : (p(h, h.umod(this.m)._forceRed(this)), h);
    }, he.prototype.neg = function(h) {
      return h.isZero() ? h.clone() : this.m.sub(h)._forceRed(this);
    }, he.prototype.add = function(h, m) {
      this._verify2(h, m);
      var x = h.add(m);
      return x.cmp(this.m) >= 0 && x.isub(this.m), x._forceRed(this);
    }, he.prototype.iadd = function(h, m) {
      this._verify2(h, m);
      var x = h.iadd(m);
      return x.cmp(this.m) >= 0 && x.isub(this.m), x;
    }, he.prototype.sub = function(h, m) {
      this._verify2(h, m);
      var x = h.sub(m);
      return x.cmpn(0) < 0 && x.iadd(this.m), x._forceRed(this);
    }, he.prototype.isub = function(h, m) {
      this._verify2(h, m);
      var x = h.isub(m);
      return x.cmpn(0) < 0 && x.iadd(this.m), x;
    }, he.prototype.shl = function(h, m) {
      return this._verify1(h), this.imod(h.ushln(m));
    }, he.prototype.imul = function(h, m) {
      return this._verify2(h, m), this.imod(h.imul(m));
    }, he.prototype.mul = function(h, m) {
      return this._verify2(h, m), this.imod(h.mul(m));
    }, he.prototype.isqr = function(h) {
      return this.imul(h, h.clone());
    }, he.prototype.sqr = function(h) {
      return this.mul(h, h);
    }, he.prototype.sqrt = function(h) {
      if (h.isZero())
        return h.clone();
      var m = this.m.andln(3);
      if (n(m % 2 === 1), m === 3) {
        var x = this.m.add(new o(1)).iushrn(2);
        return this.pow(h, x);
      }
      for (var M = this.m.subn(1), A = 0; !M.isZero() && M.andln(1) === 0; )
        A++, M.iushrn(1);
      n(!M.isZero());
      var $ = new o(1).toRed(this), K = $.redNeg(), D = this.m.subn(1).iushrn(1), w = this.m.bitLength();
      for (w = new o(2 * w * w).toRed(this); this.pow(w, D).cmp(K) !== 0; )
        w.redIAdd(K);
      for (var U = this.pow(w, M), me = this.pow(h, M.addn(1).iushrn(1)), pe = this.pow(h, M), ee = A; pe.cmp($) !== 0; ) {
        for (var V = pe, Q = 0; V.cmp($) !== 0; Q++)
          V = V.redSqr();
        n(Q < ee);
        var X = this.pow(U, new o(1).iushln(ee - Q - 1));
        me = me.redMul(X), U = X.redSqr(), pe = pe.redMul(U), ee = Q;
      }
      return me;
    }, he.prototype.invm = function(h) {
      var m = h._invmp(this.m);
      return m.negative !== 0 ? (m.negative = 0, this.imod(m).redNeg()) : this.imod(m);
    }, he.prototype.pow = function(h, m) {
      if (m.isZero())
        return new o(1).toRed(this);
      if (m.cmpn(1) === 0)
        return h.clone();
      var x = 4, M = new Array(1 << x);
      M[0] = new o(1).toRed(this), M[1] = h;
      for (var A = 2; A < M.length; A++)
        M[A] = this.mul(M[A - 1], h);
      var $ = M[0], K = 0, D = 0, w = m.bitLength() % 26;
      for (w === 0 && (w = 26), A = m.length - 1; A >= 0; A--) {
        for (var U = m.words[A], me = w - 1; me >= 0; me--) {
          var pe = U >> me & 1;
          if ($ !== M[0] && ($ = this.sqr($)), pe === 0 && K === 0) {
            D = 0;
            continue;
          }
          K <<= 1, K |= pe, D++, !(D !== x && (A !== 0 || me !== 0)) && ($ = this.mul($, M[K]), D = 0, K = 0);
        }
        w = 26;
      }
      return $;
    }, he.prototype.convertTo = function(h) {
      var m = h.umod(this.m);
      return m === h ? m.clone() : m;
    }, he.prototype.convertFrom = function(h) {
      var m = h.clone();
      return m.red = null, m;
    }, o.mont = function(h) {
      return new ye(h);
    };
    function ye(k) {
      he.call(this, k), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    i(ye, he), ye.prototype.convertTo = function(h) {
      return this.imod(h.ushln(this.shift));
    }, ye.prototype.convertFrom = function(h) {
      var m = this.imod(h.mul(this.rinv));
      return m.red = null, m;
    }, ye.prototype.imul = function(h, m) {
      if (h.isZero() || m.isZero())
        return h.words[0] = 0, h.length = 1, h;
      var x = h.imul(m), M = x.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), A = x.isub(M).iushrn(this.shift), $ = A;
      return A.cmp(this.m) >= 0 ? $ = A.isub(this.m) : A.cmpn(0) < 0 && ($ = A.iadd(this.m)), $._forceRed(this);
    }, ye.prototype.mul = function(h, m) {
      if (h.isZero() || m.isZero())
        return new o(0)._forceRed(this);
      var x = h.mul(m), M = x.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), A = x.isub(M).iushrn(this.shift), $ = A;
      return A.cmp(this.m) >= 0 ? $ = A.isub(this.m) : A.cmpn(0) < 0 && ($ = A.iadd(this.m)), $._forceRed(this);
    }, ye.prototype.invm = function(h) {
      var m = this.imod(h._invmp(this.m).mul(this.r2));
      return m._forceRed(this);
    };
  })(t, Te);
})(Sp);
var Uc = Sp.exports;
const bV = /* @__PURE__ */ Bc(Uc);
var jc = {}, ts = {};
Object.defineProperty(ts, "__esModule", { value: !0 });
ts.errorValues = ts.standardErrorCodes = void 0;
ts.standardErrorCodes = {
  rpc: {
    invalidInput: -32e3,
    resourceNotFound: -32001,
    resourceUnavailable: -32002,
    transactionRejected: -32003,
    methodNotSupported: -32004,
    limitExceeded: -32005,
    parse: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603
  },
  provider: {
    userRejectedRequest: 4001,
    unauthorized: 4100,
    unsupportedMethod: 4200,
    disconnected: 4900,
    chainDisconnected: 4901,
    unsupportedChain: 4902
  }
};
ts.errorValues = {
  "-32700": {
    standard: "JSON RPC 2.0",
    message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
  },
  "-32600": {
    standard: "JSON RPC 2.0",
    message: "The JSON sent is not a valid Request object."
  },
  "-32601": {
    standard: "JSON RPC 2.0",
    message: "The method does not exist / is not available."
  },
  "-32602": {
    standard: "JSON RPC 2.0",
    message: "Invalid method parameter(s)."
  },
  "-32603": {
    standard: "JSON RPC 2.0",
    message: "Internal JSON-RPC error."
  },
  "-32000": {
    standard: "EIP-1474",
    message: "Invalid input."
  },
  "-32001": {
    standard: "EIP-1474",
    message: "Resource not found."
  },
  "-32002": {
    standard: "EIP-1474",
    message: "Resource unavailable."
  },
  "-32003": {
    standard: "EIP-1474",
    message: "Transaction rejected."
  },
  "-32004": {
    standard: "EIP-1474",
    message: "Method not supported."
  },
  "-32005": {
    standard: "EIP-1474",
    message: "Request limit exceeded."
  },
  4001: {
    standard: "EIP-1193",
    message: "User rejected the request."
  },
  4100: {
    standard: "EIP-1193",
    message: "The requested account and/or method has not been authorized by the user."
  },
  4200: {
    standard: "EIP-1193",
    message: "The requested method is not supported by this Ethereum provider."
  },
  4900: {
    standard: "EIP-1193",
    message: "The provider is disconnected from all chains."
  },
  4901: {
    standard: "EIP-1193",
    message: "The provider is disconnected from the specified chain."
  },
  4902: {
    standard: "EIP-3085",
    message: "Unrecognized chain ID."
  }
};
var ph = {}, gh = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.serialize = t.getErrorCode = t.isValidCode = t.getMessageFromCode = t.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
  const e = ts, r = "Unspecified error message.";
  t.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
  function n(y, C = r) {
    if (y && Number.isInteger(y)) {
      const R = y.toString();
      if (p(e.errorValues, R))
        return e.errorValues[R].message;
      if (l(y))
        return t.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return C;
  }
  t.getMessageFromCode = n;
  function i(y) {
    if (!Number.isInteger(y))
      return !1;
    const C = y.toString();
    return !!(e.errorValues[C] || l(y));
  }
  t.isValidCode = i;
  function o(y) {
    var C;
    if (typeof y == "number")
      return y;
    if (c(y))
      return (C = y.code) !== null && C !== void 0 ? C : y.errorCode;
  }
  t.getErrorCode = o;
  function c(y) {
    return typeof y == "object" && y !== null && (typeof y.code == "number" || typeof y.errorCode == "number");
  }
  function u(y, { shouldIncludeStack: C = !1 } = {}) {
    const R = {};
    if (y && typeof y == "object" && !Array.isArray(y) && p(y, "code") && i(y.code)) {
      const J = y;
      R.code = J.code, J.message && typeof J.message == "string" ? (R.message = J.message, p(J, "data") && (R.data = J.data)) : (R.message = n(R.code), R.data = { originalError: f(y) });
    } else
      R.code = e.standardErrorCodes.rpc.internal, R.message = g(y, "message") ? y.message : r, R.data = { originalError: f(y) };
    return C && (R.stack = g(y, "stack") ? y.stack : void 0), R;
  }
  t.serialize = u;
  function l(y) {
    return y >= -32099 && y <= -32e3;
  }
  function f(y) {
    return y && typeof y == "object" && !Array.isArray(y) ? Object.assign({}, y) : y;
  }
  function p(y, C) {
    return Object.prototype.hasOwnProperty.call(y, C);
  }
  function g(y, C) {
    return typeof y == "object" && y !== null && C in y && typeof y[C] == "string";
  }
})(gh);
Object.defineProperty(ph, "__esModule", { value: !0 });
ph.standardErrors = void 0;
const Dr = ts, $w = gh;
ph.standardErrors = {
  rpc: {
    parse: (t) => $n(Dr.standardErrorCodes.rpc.parse, t),
    invalidRequest: (t) => $n(Dr.standardErrorCodes.rpc.invalidRequest, t),
    invalidParams: (t) => $n(Dr.standardErrorCodes.rpc.invalidParams, t),
    methodNotFound: (t) => $n(Dr.standardErrorCodes.rpc.methodNotFound, t),
    internal: (t) => $n(Dr.standardErrorCodes.rpc.internal, t),
    server: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum RPC Server errors must provide single object argument.");
      const { code: e } = t;
      if (!Number.isInteger(e) || e > -32005 || e < -32099)
        throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
      return $n(e, t);
    },
    invalidInput: (t) => $n(Dr.standardErrorCodes.rpc.invalidInput, t),
    resourceNotFound: (t) => $n(Dr.standardErrorCodes.rpc.resourceNotFound, t),
    resourceUnavailable: (t) => $n(Dr.standardErrorCodes.rpc.resourceUnavailable, t),
    transactionRejected: (t) => $n(Dr.standardErrorCodes.rpc.transactionRejected, t),
    methodNotSupported: (t) => $n(Dr.standardErrorCodes.rpc.methodNotSupported, t),
    limitExceeded: (t) => $n(Dr.standardErrorCodes.rpc.limitExceeded, t)
  },
  provider: {
    userRejectedRequest: (t) => Go(Dr.standardErrorCodes.provider.userRejectedRequest, t),
    unauthorized: (t) => Go(Dr.standardErrorCodes.provider.unauthorized, t),
    unsupportedMethod: (t) => Go(Dr.standardErrorCodes.provider.unsupportedMethod, t),
    disconnected: (t) => Go(Dr.standardErrorCodes.provider.disconnected, t),
    chainDisconnected: (t) => Go(Dr.standardErrorCodes.provider.chainDisconnected, t),
    unsupportedChain: (t) => Go(Dr.standardErrorCodes.provider.unsupportedChain, t),
    custom: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum Provider custom errors must provide single object argument.");
      const { code: e, message: r, data: n } = t;
      if (!r || typeof r != "string")
        throw new Error('"message" must be a nonempty string');
      return new Uw(e, r, n);
    }
  }
};
function $n(t, e) {
  const [r, n] = Fw(e);
  return new Bw(t, r || (0, $w.getMessageFromCode)(t), n);
}
function Go(t, e) {
  const [r, n] = Fw(e);
  return new Uw(t, r || (0, $w.getMessageFromCode)(t), n);
}
function Fw(t) {
  if (t) {
    if (typeof t == "string")
      return [t];
    if (typeof t == "object" && !Array.isArray(t)) {
      const { message: e, data: r } = t;
      if (e && typeof e != "string")
        throw new Error("Must specify string message.");
      return [e || void 0, r];
    }
  }
  return [];
}
let Bw = class extends Error {
  constructor(e, r, n) {
    if (!Number.isInteger(e))
      throw new Error('"code" must be an integer.');
    if (!r || typeof r != "string")
      throw new Error('"message" must be a nonempty string.');
    super(r), this.code = e, n !== void 0 && (this.data = n);
  }
}, Uw = class extends Bw {
  /**
   * Create an Ethereum Provider JSON-RPC error.
   * `code` must be an integer in the 1000 <= 4999 range.
   */
  constructor(e, r, n) {
    if (!XI(e))
      throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    super(e, r, n);
  }
};
function XI(t) {
  return Number.isInteger(t) && t >= 1e3 && t <= 4999;
}
var mh = {}, Ra = {};
Object.defineProperty(Ra, "__esModule", { value: !0 });
Ra.isErrorResponse = void 0;
function ex(t) {
  return t.errorMessage !== void 0;
}
Ra.isErrorResponse = ex;
var Aa = {};
Object.defineProperty(Aa, "__esModule", { value: !0 });
Aa.LIB_VERSION = void 0;
Aa.LIB_VERSION = "3.9.1";
Object.defineProperty(mh, "__esModule", { value: !0 });
mh.serializeError = void 0;
const tx = Ra, rx = Aa, nx = ts, ix = gh;
function sx(t, e) {
  const r = (0, ix.serialize)(ox(t), {
    shouldIncludeStack: !0
  }), n = new URL("https://docs.cloud.coinbase.com/wallet-sdk/docs/errors");
  n.searchParams.set("version", rx.LIB_VERSION), n.searchParams.set("code", r.code.toString());
  const i = ax(r.data, e);
  return i && n.searchParams.set("method", i), n.searchParams.set("message", r.message), Object.assign(Object.assign({}, r), { docUrl: n.href });
}
mh.serializeError = sx;
function ox(t) {
  return typeof t == "string" ? {
    message: t,
    code: nx.standardErrorCodes.rpc.internal
  } : (0, tx.isErrorResponse)(t) ? Object.assign(Object.assign({}, t), { message: t.errorMessage, code: t.errorCode, data: { method: t.method } }) : t;
}
function ax(t, e) {
  const r = t?.method;
  if (r)
    return r;
  if (e !== void 0) {
    if (typeof e == "string")
      return e;
    if (Array.isArray(e)) {
      if (e.length > 0)
        return e[0].method;
    } else
      return e.method;
  }
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.standardErrors = t.standardErrorCodes = t.serializeError = t.getMessageFromCode = t.getErrorCode = void 0;
  const e = ts;
  Object.defineProperty(t, "standardErrorCodes", { enumerable: !0, get: function() {
    return e.standardErrorCodes;
  } });
  const r = ph;
  Object.defineProperty(t, "standardErrors", { enumerable: !0, get: function() {
    return r.standardErrors;
  } });
  const n = mh;
  Object.defineProperty(t, "serializeError", { enumerable: !0, get: function() {
    return n.serializeError;
  } });
  const i = gh;
  Object.defineProperty(t, "getErrorCode", { enumerable: !0, get: function() {
    return i.getErrorCode;
  } }), Object.defineProperty(t, "getMessageFromCode", { enumerable: !0, get: function() {
    return i.getMessageFromCode;
  } });
})(jc);
var _r = {};
Object.defineProperty(_r, "__esModule", { value: !0 });
_r.ProviderType = _r.RegExpString = _r.IntNumber = _r.BigIntString = _r.AddressString = _r.HexString = _r.OpaqueType = void 0;
function Hc() {
  return (t) => t;
}
_r.OpaqueType = Hc;
_r.HexString = Hc();
_r.AddressString = Hc();
_r.BigIntString = Hc();
function cx(t) {
  return Math.floor(t);
}
_r.IntNumber = cx;
_r.RegExpString = Hc();
var Km;
(function(t) {
  t.CoinbaseWallet = "CoinbaseWallet", t.MetaMask = "MetaMask", t.Unselected = "";
})(Km || (_r.ProviderType = Km = {}));
var ux = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty($e, "__esModule", { value: !0 });
$e.isMobileWeb = $e.getLocation = $e.isInIFrame = $e.createQrUrl = $e.getFavicon = $e.range = $e.isBigNumber = $e.ensureParsedJSONObject = $e.ensureBN = $e.ensureRegExpString = $e.ensureIntNumber = $e.ensureBuffer = $e.ensureAddressString = $e.ensureEvenLengthHexString = $e.ensureHexString = $e.isHexString = $e.prepend0x = $e.strip0x = $e.has0xPrefix = $e.hexStringFromIntNumber = $e.intNumberFromHexString = $e.bigIntStringFromBN = $e.hexStringFromBuffer = $e.hexStringToUint8Array = $e.uint8ArrayToHex = $e.randomBytesHex = void 0;
const Es = ux(Uc), _o = jc, qn = _r, jw = /^[0-9]*$/, Hw = /^[a-f0-9]*$/;
function lx(t) {
  return qw(crypto.getRandomValues(new Uint8Array(t)));
}
$e.randomBytesHex = lx;
function qw(t) {
  return [...t].map((e) => e.toString(16).padStart(2, "0")).join("");
}
$e.uint8ArrayToHex = qw;
function hx(t) {
  return new Uint8Array(t.match(/.{1,2}/g).map((e) => parseInt(e, 16)));
}
$e.hexStringToUint8Array = hx;
function fx(t, e = !1) {
  const r = t.toString("hex");
  return (0, qn.HexString)(e ? `0x${r}` : r);
}
$e.hexStringFromBuffer = fx;
function dx(t) {
  return (0, qn.BigIntString)(t.toString(10));
}
$e.bigIntStringFromBN = dx;
function px(t) {
  return (0, qn.IntNumber)(new Es.default(zc(t, !1), 16).toNumber());
}
$e.intNumberFromHexString = px;
function gx(t) {
  return (0, qn.HexString)(`0x${new Es.default(t).toString(16)}`);
}
$e.hexStringFromIntNumber = gx;
function Cp(t) {
  return t.startsWith("0x") || t.startsWith("0X");
}
$e.has0xPrefix = Cp;
function vh(t) {
  return Cp(t) ? t.slice(2) : t;
}
$e.strip0x = vh;
function zw(t) {
  return Cp(t) ? `0x${t.slice(2)}` : `0x${t}`;
}
$e.prepend0x = zw;
function qc(t) {
  if (typeof t != "string")
    return !1;
  const e = vh(t).toLowerCase();
  return Hw.test(e);
}
$e.isHexString = qc;
function Vw(t, e = !1) {
  if (typeof t == "string") {
    const r = vh(t).toLowerCase();
    if (Hw.test(r))
      return (0, qn.HexString)(e ? `0x${r}` : r);
  }
  throw _o.standardErrors.rpc.invalidParams(`"${String(t)}" is not a hexadecimal string`);
}
$e.ensureHexString = Vw;
function zc(t, e = !1) {
  let r = Vw(t, !1);
  return r.length % 2 === 1 && (r = (0, qn.HexString)(`0${r}`)), e ? (0, qn.HexString)(`0x${r}`) : r;
}
$e.ensureEvenLengthHexString = zc;
function mx(t) {
  if (typeof t == "string") {
    const e = vh(t).toLowerCase();
    if (qc(e) && e.length === 40)
      return (0, qn.AddressString)(zw(e));
  }
  throw _o.standardErrors.rpc.invalidParams(`Invalid Ethereum address: ${String(t)}`);
}
$e.ensureAddressString = mx;
function vx(t) {
  if (Buffer.isBuffer(t))
    return t;
  if (typeof t == "string") {
    if (qc(t)) {
      const e = zc(t, !1);
      return Buffer.from(e, "hex");
    }
    return Buffer.from(t, "utf8");
  }
  throw _o.standardErrors.rpc.invalidParams(`Not binary data: ${String(t)}`);
}
$e.ensureBuffer = vx;
function Ww(t) {
  if (typeof t == "number" && Number.isInteger(t))
    return (0, qn.IntNumber)(t);
  if (typeof t == "string") {
    if (jw.test(t))
      return (0, qn.IntNumber)(Number(t));
    if (qc(t))
      return (0, qn.IntNumber)(new Es.default(zc(t, !1), 16).toNumber());
  }
  throw _o.standardErrors.rpc.invalidParams(`Not an integer: ${String(t)}`);
}
$e.ensureIntNumber = Ww;
function yx(t) {
  if (t instanceof RegExp)
    return (0, qn.RegExpString)(t.toString());
  throw _o.standardErrors.rpc.invalidParams(`Not a RegExp: ${String(t)}`);
}
$e.ensureRegExpString = yx;
function _x(t) {
  if (t !== null && (Es.default.isBN(t) || Kw(t)))
    return new Es.default(t.toString(10), 10);
  if (typeof t == "number")
    return new Es.default(Ww(t));
  if (typeof t == "string") {
    if (jw.test(t))
      return new Es.default(t, 10);
    if (qc(t))
      return new Es.default(zc(t, !1), 16);
  }
  throw _o.standardErrors.rpc.invalidParams(`Not an integer: ${String(t)}`);
}
$e.ensureBN = _x;
function wx(t) {
  if (typeof t == "string")
    return JSON.parse(t);
  if (typeof t == "object")
    return t;
  throw _o.standardErrors.rpc.invalidParams(`Not a JSON string or an object: ${String(t)}`);
}
$e.ensureParsedJSONObject = wx;
function Kw(t) {
  if (t == null || typeof t.constructor != "function")
    return !1;
  const { constructor: e } = t;
  return typeof e.config == "function" && typeof e.EUCLID == "number";
}
$e.isBigNumber = Kw;
function bx(t, e) {
  return Array.from({ length: e - t }, (r, n) => t + n);
}
$e.range = bx;
function Ex() {
  const t = document.querySelector('link[sizes="192x192"]') || document.querySelector('link[sizes="180x180"]') || document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]'), { protocol: e, host: r } = document.location, n = t ? t.getAttribute("href") : null;
  return !n || n.startsWith("javascript:") || n.startsWith("vbscript:") ? null : n.startsWith("http://") || n.startsWith("https://") || n.startsWith("data:") ? n : n.startsWith("//") ? e + n : `${e}//${r}${n}`;
}
$e.getFavicon = Ex;
function Sx(t, e, r, n, i, o) {
  const c = n ? "parent-id" : "id", u = new URLSearchParams({
    [c]: t,
    secret: e,
    server: r,
    v: i,
    chainId: o.toString()
  }).toString();
  return `${r}/#/link?${u}`;
}
$e.createQrUrl = Sx;
function Gw() {
  try {
    return window.frameElement !== null;
  } catch {
    return !1;
  }
}
$e.isInIFrame = Gw;
function Cx() {
  try {
    return Gw() && window.top ? window.top.location : window.location;
  } catch {
    return window.location;
  }
}
$e.getLocation = Cx;
function Ix() {
  var t;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test((t = window?.navigator) === null || t === void 0 ? void 0 : t.userAgent);
}
$e.isMobileWeb = Ix;
var yh = {};
Object.defineProperty(yh, "__esModule", { value: !0 });
yh.ScopedLocalStorage = void 0;
class xx {
  // eslint-disable-next-line no-useless-constructor
  constructor(e) {
    this.scope = e;
  }
  setItem(e, r) {
    localStorage.setItem(this.scopedKey(e), r);
  }
  getItem(e) {
    return localStorage.getItem(this.scopedKey(e));
  }
  removeItem(e) {
    localStorage.removeItem(this.scopedKey(e));
  }
  clear() {
    const e = this.scopedKey(""), r = [];
    for (let n = 0; n < localStorage.length; n++) {
      const i = localStorage.key(n);
      typeof i == "string" && i.startsWith(e) && r.push(i);
    }
    r.forEach((n) => localStorage.removeItem(n));
  }
  scopedKey(e) {
    return `${this.scope}:${e}`;
  }
}
yh.ScopedLocalStorage = xx;
var va = {}, Vc = {}, Wc = {}, Ma = {};
Object.defineProperty(Ma, "__esModule", { value: !0 });
Ma.EVENTS = void 0;
Ma.EVENTS = {
  STARTED_CONNECTING: "walletlink_sdk.started.connecting",
  CONNECTED_STATE_CHANGE: "walletlink_sdk.connected",
  DISCONNECTED: "walletlink_sdk.disconnected",
  METADATA_DESTROYED: "walletlink_sdk_metadata_destroyed",
  LINKED: "walletlink_sdk.linked",
  FAILURE: "walletlink_sdk.generic_failure",
  SESSION_CONFIG_RECEIVED: "walletlink_sdk.session_config_event_received",
  ETH_ACCOUNTS_STATE: "walletlink_sdk.eth_accounts_state",
  SESSION_STATE_CHANGE: "walletlink_sdk.session_state_change",
  UNLINKED_ERROR_STATE: "walletlink_sdk.unlinked_error_state",
  SKIPPED_CLEARING_SESSION: "walletlink_sdk.skipped_clearing_session",
  GENERAL_ERROR: "walletlink_sdk.general_error",
  WEB3_REQUEST: "walletlink_sdk.web3.request",
  WEB3_REQUEST_PUBLISHED: "walletlink_sdk.web3.request_published",
  WEB3_RESPONSE: "walletlink_sdk.web3.response",
  METHOD_NOT_IMPLEMENTED: "walletlink_sdk.method_not_implemented",
  UNKNOWN_ADDRESS_ENCOUNTERED: "walletlink_sdk.unknown_address_encountered"
};
var Hn = {};
Object.defineProperty(Hn, "__esModule", { value: !0 });
Hn.RelayAbstract = Hn.APP_VERSION_KEY = Hn.LOCAL_STORAGE_ADDRESSES_KEY = Hn.WALLET_USER_NAME_KEY = void 0;
const Gm = jc;
Hn.WALLET_USER_NAME_KEY = "walletUsername";
Hn.LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";
Hn.APP_VERSION_KEY = "AppVersion";
class Rx {
  async makeEthereumJSONRPCRequest(e, r) {
    if (!r)
      throw new Error("Error: No jsonRpcUrl provided");
    return window.fetch(r, {
      method: "POST",
      body: JSON.stringify(e),
      mode: "cors",
      headers: { "Content-Type": "application/json" }
    }).then((n) => n.json()).then((n) => {
      if (!n)
        throw Gm.standardErrors.rpc.parse({});
      const i = n, { error: o } = i;
      if (o)
        throw (0, Gm.serializeError)(o, e.method);
      return i;
    });
  }
}
Hn.RelayAbstract = Rx;
var Da = {}, Jw = { exports: {} }, $0 = { exports: {} };
typeof Object.create == "function" ? $0.exports = function(e, r) {
  r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : $0.exports = function(e, r) {
  if (r) {
    e.super_ = r;
    var n = function() {
    };
    n.prototype = r.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }
};
var hi = $0.exports, F0 = { exports: {} }, Kc = {}, _h = {};
_h.byteLength = Dx;
_h.toByteArray = Px;
_h.fromByteArray = kx;
var Ri = [], jn = [], Ax = typeof Uint8Array < "u" ? Uint8Array : Array, Nd = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Jo = 0, Mx = Nd.length; Jo < Mx; ++Jo)
  Ri[Jo] = Nd[Jo], jn[Nd.charCodeAt(Jo)] = Jo;
jn[45] = 62;
jn[95] = 63;
function Qw(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var n = r === e ? 0 : 4 - r % 4;
  return [r, n];
}
function Dx(t) {
  var e = Qw(t), r = e[0], n = e[1];
  return (r + n) * 3 / 4 - n;
}
function Ox(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function Px(t) {
  var e, r = Qw(t), n = r[0], i = r[1], o = new Ax(Ox(t, n, i)), c = 0, u = i > 0 ? n - 4 : n, l;
  for (l = 0; l < u; l += 4)
    e = jn[t.charCodeAt(l)] << 18 | jn[t.charCodeAt(l + 1)] << 12 | jn[t.charCodeAt(l + 2)] << 6 | jn[t.charCodeAt(l + 3)], o[c++] = e >> 16 & 255, o[c++] = e >> 8 & 255, o[c++] = e & 255;
  return i === 2 && (e = jn[t.charCodeAt(l)] << 2 | jn[t.charCodeAt(l + 1)] >> 4, o[c++] = e & 255), i === 1 && (e = jn[t.charCodeAt(l)] << 10 | jn[t.charCodeAt(l + 1)] << 4 | jn[t.charCodeAt(l + 2)] >> 2, o[c++] = e >> 8 & 255, o[c++] = e & 255), o;
}
function Tx(t) {
  return Ri[t >> 18 & 63] + Ri[t >> 12 & 63] + Ri[t >> 6 & 63] + Ri[t & 63];
}
function Nx(t, e, r) {
  for (var n, i = [], o = e; o < r; o += 3)
    n = (t[o] << 16 & 16711680) + (t[o + 1] << 8 & 65280) + (t[o + 2] & 255), i.push(Tx(n));
  return i.join("");
}
function kx(t) {
  for (var e, r = t.length, n = r % 3, i = [], o = 16383, c = 0, u = r - n; c < u; c += o)
    i.push(Nx(t, c, c + o > u ? u : c + o));
  return n === 1 ? (e = t[r - 1], i.push(
    Ri[e >> 2] + Ri[e << 4 & 63] + "=="
  )) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(
    Ri[e >> 10] + Ri[e >> 4 & 63] + Ri[e << 2 & 63] + "="
  )), i.join("");
}
var Ip = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Ip.read = function(t, e, r, n, i) {
  var o, c, u = i * 8 - n - 1, l = (1 << u) - 1, f = l >> 1, p = -7, g = r ? i - 1 : 0, y = r ? -1 : 1, C = t[e + g];
  for (g += y, o = C & (1 << -p) - 1, C >>= -p, p += u; p > 0; o = o * 256 + t[e + g], g += y, p -= 8)
    ;
  for (c = o & (1 << -p) - 1, o >>= -p, p += n; p > 0; c = c * 256 + t[e + g], g += y, p -= 8)
    ;
  if (o === 0)
    o = 1 - f;
  else {
    if (o === l)
      return c ? NaN : (C ? -1 : 1) * (1 / 0);
    c = c + Math.pow(2, n), o = o - f;
  }
  return (C ? -1 : 1) * c * Math.pow(2, o - n);
};
Ip.write = function(t, e, r, n, i, o) {
  var c, u, l, f = o * 8 - i - 1, p = (1 << f) - 1, g = p >> 1, y = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, C = n ? 0 : o - 1, R = n ? 1 : -1, J = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (u = isNaN(e) ? 1 : 0, c = p) : (c = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -c)) < 1 && (c--, l *= 2), c + g >= 1 ? e += y / l : e += y * Math.pow(2, 1 - g), e * l >= 2 && (c++, l /= 2), c + g >= p ? (u = 0, c = p) : c + g >= 1 ? (u = (e * l - 1) * Math.pow(2, i), c = c + g) : (u = e * Math.pow(2, g - 1) * Math.pow(2, i), c = 0)); i >= 8; t[r + C] = u & 255, C += R, u /= 256, i -= 8)
    ;
  for (c = c << i | u, f += i; f > 0; t[r + C] = c & 255, C += R, c /= 256, f -= 8)
    ;
  t[r + C - R] |= J * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  var e = _h, r = Ip, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = u, t.SlowBuffer = T, t.INSPECT_MAX_BYTES = 50;
  var i = 2147483647;
  t.kMaxLength = i, u.TYPED_ARRAY_SUPPORT = o(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function o() {
    try {
      var j = new Uint8Array(1), b = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(b, Uint8Array.prototype), Object.setPrototypeOf(j, b), j.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(u.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(u.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.byteOffset;
    }
  });
  function c(j) {
    if (j > i)
      throw new RangeError('The value "' + j + '" is invalid for option "size"');
    var b = new Uint8Array(j);
    return Object.setPrototypeOf(b, u.prototype), b;
  }
  function u(j, b, S) {
    if (typeof j == "number") {
      if (typeof b == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return g(j);
    }
    return l(j, b, S);
  }
  u.poolSize = 8192;
  function l(j, b, S) {
    if (typeof j == "string")
      return y(j, b);
    if (ArrayBuffer.isView(j))
      return R(j);
    if (j == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof j
      );
    if (se(j, ArrayBuffer) || j && se(j.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (se(j, SharedArrayBuffer) || j && se(j.buffer, SharedArrayBuffer)))
      return J(j, b, S);
    if (typeof j == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    var Z = j.valueOf && j.valueOf();
    if (Z != null && Z !== j)
      return u.from(Z, b, S);
    var re = G(j);
    if (re)
      return re;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof j[Symbol.toPrimitive] == "function")
      return u.from(
        j[Symbol.toPrimitive]("string"),
        b,
        S
      );
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof j
    );
  }
  u.from = function(j, b, S) {
    return l(j, b, S);
  }, Object.setPrototypeOf(u.prototype, Uint8Array.prototype), Object.setPrototypeOf(u, Uint8Array);
  function f(j) {
    if (typeof j != "number")
      throw new TypeError('"size" argument must be of type number');
    if (j < 0)
      throw new RangeError('The value "' + j + '" is invalid for option "size"');
  }
  function p(j, b, S) {
    return f(j), j <= 0 ? c(j) : b !== void 0 ? typeof S == "string" ? c(j).fill(b, S) : c(j).fill(b) : c(j);
  }
  u.alloc = function(j, b, S) {
    return p(j, b, S);
  };
  function g(j) {
    return f(j), c(j < 0 ? 0 : H(j) | 0);
  }
  u.allocUnsafe = function(j) {
    return g(j);
  }, u.allocUnsafeSlow = function(j) {
    return g(j);
  };
  function y(j, b) {
    if ((typeof b != "string" || b === "") && (b = "utf8"), !u.isEncoding(b))
      throw new TypeError("Unknown encoding: " + b);
    var S = q(j, b) | 0, Z = c(S), re = Z.write(j, b);
    return re !== S && (Z = Z.slice(0, re)), Z;
  }
  function C(j) {
    for (var b = j.length < 0 ? 0 : H(j.length) | 0, S = c(b), Z = 0; Z < b; Z += 1)
      S[Z] = j[Z] & 255;
    return S;
  }
  function R(j) {
    if (se(j, Uint8Array)) {
      var b = new Uint8Array(j);
      return J(b.buffer, b.byteOffset, b.byteLength);
    }
    return C(j);
  }
  function J(j, b, S) {
    if (b < 0 || j.byteLength < b)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (j.byteLength < b + (S || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    var Z;
    return b === void 0 && S === void 0 ? Z = new Uint8Array(j) : S === void 0 ? Z = new Uint8Array(j, b) : Z = new Uint8Array(j, b, S), Object.setPrototypeOf(Z, u.prototype), Z;
  }
  function G(j) {
    if (u.isBuffer(j)) {
      var b = H(j.length) | 0, S = c(b);
      return S.length === 0 || j.copy(S, 0, 0, b), S;
    }
    if (j.length !== void 0)
      return typeof j.length != "number" || fe(j.length) ? c(0) : C(j);
    if (j.type === "Buffer" && Array.isArray(j.data))
      return C(j.data);
  }
  function H(j) {
    if (j >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return j | 0;
  }
  function T(j) {
    return +j != j && (j = 0), u.alloc(+j);
  }
  u.isBuffer = function(b) {
    return b != null && b._isBuffer === !0 && b !== u.prototype;
  }, u.compare = function(b, S) {
    if (se(b, Uint8Array) && (b = u.from(b, b.offset, b.byteLength)), se(S, Uint8Array) && (S = u.from(S, S.offset, S.byteLength)), !u.isBuffer(b) || !u.isBuffer(S))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (b === S)
      return 0;
    for (var Z = b.length, re = S.length, ue = 0, ge = Math.min(Z, re); ue < ge; ++ue)
      if (b[ue] !== S[ue]) {
        Z = b[ue], re = S[ue];
        break;
      }
    return Z < re ? -1 : re < Z ? 1 : 0;
  }, u.isEncoding = function(b) {
    switch (String(b).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(b, S) {
    if (!Array.isArray(b))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (b.length === 0)
      return u.alloc(0);
    var Z;
    if (S === void 0)
      for (S = 0, Z = 0; Z < b.length; ++Z)
        S += b[Z].length;
    var re = u.allocUnsafe(S), ue = 0;
    for (Z = 0; Z < b.length; ++Z) {
      var ge = b[Z];
      if (se(ge, Uint8Array))
        ue + ge.length > re.length ? u.from(ge).copy(re, ue) : Uint8Array.prototype.set.call(
          re,
          ge,
          ue
        );
      else if (u.isBuffer(ge))
        ge.copy(re, ue);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      ue += ge.length;
    }
    return re;
  };
  function q(j, b) {
    if (u.isBuffer(j))
      return j.length;
    if (ArrayBuffer.isView(j) || se(j, ArrayBuffer))
      return j.byteLength;
    if (typeof j != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof j
      );
    var S = j.length, Z = arguments.length > 2 && arguments[2] === !0;
    if (!Z && S === 0)
      return 0;
    for (var re = !1; ; )
      switch (b) {
        case "ascii":
        case "latin1":
        case "binary":
          return S;
        case "utf8":
        case "utf-8":
          return Q(j).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return S * 2;
        case "hex":
          return S >>> 1;
        case "base64":
          return I(j).length;
        default:
          if (re)
            return Z ? -1 : Q(j).length;
          b = ("" + b).toLowerCase(), re = !0;
      }
  }
  u.byteLength = q;
  function B(j, b, S) {
    var Z = !1;
    if ((b === void 0 || b < 0) && (b = 0), b > this.length || ((S === void 0 || S > this.length) && (S = this.length), S <= 0) || (S >>>= 0, b >>>= 0, S <= b))
      return "";
    for (j || (j = "utf8"); ; )
      switch (j) {
        case "hex":
          return $(this, b, S);
        case "utf8":
        case "utf-8":
          return h(this, b, S);
        case "ascii":
          return M(this, b, S);
        case "latin1":
        case "binary":
          return A(this, b, S);
        case "base64":
          return k(this, b, S);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return K(this, b, S);
        default:
          if (Z)
            throw new TypeError("Unknown encoding: " + j);
          j = (j + "").toLowerCase(), Z = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function L(j, b, S) {
    var Z = j[b];
    j[b] = j[S], j[S] = Z;
  }
  u.prototype.swap16 = function() {
    var b = this.length;
    if (b % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var S = 0; S < b; S += 2)
      L(this, S, S + 1);
    return this;
  }, u.prototype.swap32 = function() {
    var b = this.length;
    if (b % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var S = 0; S < b; S += 4)
      L(this, S, S + 3), L(this, S + 1, S + 2);
    return this;
  }, u.prototype.swap64 = function() {
    var b = this.length;
    if (b % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var S = 0; S < b; S += 8)
      L(this, S, S + 7), L(this, S + 1, S + 6), L(this, S + 2, S + 5), L(this, S + 3, S + 4);
    return this;
  }, u.prototype.toString = function() {
    var b = this.length;
    return b === 0 ? "" : arguments.length === 0 ? h(this, 0, b) : B.apply(this, arguments);
  }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(b) {
    if (!u.isBuffer(b))
      throw new TypeError("Argument must be a Buffer");
    return this === b ? !0 : u.compare(this, b) === 0;
  }, u.prototype.inspect = function() {
    var b = "", S = t.INSPECT_MAX_BYTES;
    return b = this.toString("hex", 0, S).replace(/(.{2})/g, "$1 ").trim(), this.length > S && (b += " ... "), "<Buffer " + b + ">";
  }, n && (u.prototype[n] = u.prototype.inspect), u.prototype.compare = function(b, S, Z, re, ue) {
    if (se(b, Uint8Array) && (b = u.from(b, b.offset, b.byteLength)), !u.isBuffer(b))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof b
      );
    if (S === void 0 && (S = 0), Z === void 0 && (Z = b ? b.length : 0), re === void 0 && (re = 0), ue === void 0 && (ue = this.length), S < 0 || Z > b.length || re < 0 || ue > this.length)
      throw new RangeError("out of range index");
    if (re >= ue && S >= Z)
      return 0;
    if (re >= ue)
      return -1;
    if (S >= Z)
      return 1;
    if (S >>>= 0, Z >>>= 0, re >>>= 0, ue >>>= 0, this === b)
      return 0;
    for (var ge = ue - re, Ee = Z - S, Ie = Math.min(ge, Ee), Ae = this.slice(re, ue), xe = b.slice(S, Z), Se = 0; Se < Ie; ++Se)
      if (Ae[Se] !== xe[Se]) {
        ge = Ae[Se], Ee = xe[Se];
        break;
      }
    return ge < Ee ? -1 : Ee < ge ? 1 : 0;
  };
  function P(j, b, S, Z, re) {
    if (j.length === 0)
      return -1;
    if (typeof S == "string" ? (Z = S, S = 0) : S > 2147483647 ? S = 2147483647 : S < -2147483648 && (S = -2147483648), S = +S, fe(S) && (S = re ? 0 : j.length - 1), S < 0 && (S = j.length + S), S >= j.length) {
      if (re)
        return -1;
      S = j.length - 1;
    } else if (S < 0)
      if (re)
        S = 0;
      else
        return -1;
    if (typeof b == "string" && (b = u.from(b, Z)), u.isBuffer(b))
      return b.length === 0 ? -1 : v(j, b, S, Z, re);
    if (typeof b == "number")
      return b = b & 255, typeof Uint8Array.prototype.indexOf == "function" ? re ? Uint8Array.prototype.indexOf.call(j, b, S) : Uint8Array.prototype.lastIndexOf.call(j, b, S) : v(j, [b], S, Z, re);
    throw new TypeError("val must be string, number or Buffer");
  }
  function v(j, b, S, Z, re) {
    var ue = 1, ge = j.length, Ee = b.length;
    if (Z !== void 0 && (Z = String(Z).toLowerCase(), Z === "ucs2" || Z === "ucs-2" || Z === "utf16le" || Z === "utf-16le")) {
      if (j.length < 2 || b.length < 2)
        return -1;
      ue = 2, ge /= 2, Ee /= 2, S /= 2;
    }
    function Ie(Ne, Oe) {
      return ue === 1 ? Ne[Oe] : Ne.readUInt16BE(Oe * ue);
    }
    var Ae;
    if (re) {
      var xe = -1;
      for (Ae = S; Ae < ge; Ae++)
        if (Ie(j, Ae) === Ie(b, xe === -1 ? 0 : Ae - xe)) {
          if (xe === -1 && (xe = Ae), Ae - xe + 1 === Ee)
            return xe * ue;
        } else
          xe !== -1 && (Ae -= Ae - xe), xe = -1;
    } else
      for (S + Ee > ge && (S = ge - Ee), Ae = S; Ae >= 0; Ae--) {
        for (var Se = !0, Le = 0; Le < Ee; Le++)
          if (Ie(j, Ae + Le) !== Ie(b, Le)) {
            Se = !1;
            break;
          }
        if (Se)
          return Ae;
      }
    return -1;
  }
  u.prototype.includes = function(b, S, Z) {
    return this.indexOf(b, S, Z) !== -1;
  }, u.prototype.indexOf = function(b, S, Z) {
    return P(this, b, S, Z, !0);
  }, u.prototype.lastIndexOf = function(b, S, Z) {
    return P(this, b, S, Z, !1);
  };
  function N(j, b, S, Z) {
    S = Number(S) || 0;
    var re = j.length - S;
    Z ? (Z = Number(Z), Z > re && (Z = re)) : Z = re;
    var ue = b.length;
    Z > ue / 2 && (Z = ue / 2);
    for (var ge = 0; ge < Z; ++ge) {
      var Ee = parseInt(b.substr(ge * 2, 2), 16);
      if (fe(Ee))
        return ge;
      j[S + ge] = Ee;
    }
    return ge;
  }
  function ie(j, b, S, Z) {
    return F(Q(b, j.length - S), j, S, Z);
  }
  function le(j, b, S, Z) {
    return F(X(b), j, S, Z);
  }
  function he(j, b, S, Z) {
    return F(I(b), j, S, Z);
  }
  function ye(j, b, S, Z) {
    return F(E(b, j.length - S), j, S, Z);
  }
  u.prototype.write = function(b, S, Z, re) {
    if (S === void 0)
      re = "utf8", Z = this.length, S = 0;
    else if (Z === void 0 && typeof S == "string")
      re = S, Z = this.length, S = 0;
    else if (isFinite(S))
      S = S >>> 0, isFinite(Z) ? (Z = Z >>> 0, re === void 0 && (re = "utf8")) : (re = Z, Z = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    var ue = this.length - S;
    if ((Z === void 0 || Z > ue) && (Z = ue), b.length > 0 && (Z < 0 || S < 0) || S > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    re || (re = "utf8");
    for (var ge = !1; ; )
      switch (re) {
        case "hex":
          return N(this, b, S, Z);
        case "utf8":
        case "utf-8":
          return ie(this, b, S, Z);
        case "ascii":
        case "latin1":
        case "binary":
          return le(this, b, S, Z);
        case "base64":
          return he(this, b, S, Z);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ye(this, b, S, Z);
        default:
          if (ge)
            throw new TypeError("Unknown encoding: " + re);
          re = ("" + re).toLowerCase(), ge = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function k(j, b, S) {
    return b === 0 && S === j.length ? e.fromByteArray(j) : e.fromByteArray(j.slice(b, S));
  }
  function h(j, b, S) {
    S = Math.min(j.length, S);
    for (var Z = [], re = b; re < S; ) {
      var ue = j[re], ge = null, Ee = ue > 239 ? 4 : ue > 223 ? 3 : ue > 191 ? 2 : 1;
      if (re + Ee <= S) {
        var Ie, Ae, xe, Se;
        switch (Ee) {
          case 1:
            ue < 128 && (ge = ue);
            break;
          case 2:
            Ie = j[re + 1], (Ie & 192) === 128 && (Se = (ue & 31) << 6 | Ie & 63, Se > 127 && (ge = Se));
            break;
          case 3:
            Ie = j[re + 1], Ae = j[re + 2], (Ie & 192) === 128 && (Ae & 192) === 128 && (Se = (ue & 15) << 12 | (Ie & 63) << 6 | Ae & 63, Se > 2047 && (Se < 55296 || Se > 57343) && (ge = Se));
            break;
          case 4:
            Ie = j[re + 1], Ae = j[re + 2], xe = j[re + 3], (Ie & 192) === 128 && (Ae & 192) === 128 && (xe & 192) === 128 && (Se = (ue & 15) << 18 | (Ie & 63) << 12 | (Ae & 63) << 6 | xe & 63, Se > 65535 && Se < 1114112 && (ge = Se));
        }
      }
      ge === null ? (ge = 65533, Ee = 1) : ge > 65535 && (ge -= 65536, Z.push(ge >>> 10 & 1023 | 55296), ge = 56320 | ge & 1023), Z.push(ge), re += Ee;
    }
    return x(Z);
  }
  var m = 4096;
  function x(j) {
    var b = j.length;
    if (b <= m)
      return String.fromCharCode.apply(String, j);
    for (var S = "", Z = 0; Z < b; )
      S += String.fromCharCode.apply(
        String,
        j.slice(Z, Z += m)
      );
    return S;
  }
  function M(j, b, S) {
    var Z = "";
    S = Math.min(j.length, S);
    for (var re = b; re < S; ++re)
      Z += String.fromCharCode(j[re] & 127);
    return Z;
  }
  function A(j, b, S) {
    var Z = "";
    S = Math.min(j.length, S);
    for (var re = b; re < S; ++re)
      Z += String.fromCharCode(j[re]);
    return Z;
  }
  function $(j, b, S) {
    var Z = j.length;
    (!b || b < 0) && (b = 0), (!S || S < 0 || S > Z) && (S = Z);
    for (var re = "", ue = b; ue < S; ++ue)
      re += Re[j[ue]];
    return re;
  }
  function K(j, b, S) {
    for (var Z = j.slice(b, S), re = "", ue = 0; ue < Z.length - 1; ue += 2)
      re += String.fromCharCode(Z[ue] + Z[ue + 1] * 256);
    return re;
  }
  u.prototype.slice = function(b, S) {
    var Z = this.length;
    b = ~~b, S = S === void 0 ? Z : ~~S, b < 0 ? (b += Z, b < 0 && (b = 0)) : b > Z && (b = Z), S < 0 ? (S += Z, S < 0 && (S = 0)) : S > Z && (S = Z), S < b && (S = b);
    var re = this.subarray(b, S);
    return Object.setPrototypeOf(re, u.prototype), re;
  };
  function D(j, b, S) {
    if (j % 1 !== 0 || j < 0)
      throw new RangeError("offset is not uint");
    if (j + b > S)
      throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUintLE = u.prototype.readUIntLE = function(b, S, Z) {
    b = b >>> 0, S = S >>> 0, Z || D(b, S, this.length);
    for (var re = this[b], ue = 1, ge = 0; ++ge < S && (ue *= 256); )
      re += this[b + ge] * ue;
    return re;
  }, u.prototype.readUintBE = u.prototype.readUIntBE = function(b, S, Z) {
    b = b >>> 0, S = S >>> 0, Z || D(b, S, this.length);
    for (var re = this[b + --S], ue = 1; S > 0 && (ue *= 256); )
      re += this[b + --S] * ue;
    return re;
  }, u.prototype.readUint8 = u.prototype.readUInt8 = function(b, S) {
    return b = b >>> 0, S || D(b, 1, this.length), this[b];
  }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(b, S) {
    return b = b >>> 0, S || D(b, 2, this.length), this[b] | this[b + 1] << 8;
  }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(b, S) {
    return b = b >>> 0, S || D(b, 2, this.length), this[b] << 8 | this[b + 1];
  }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(b, S) {
    return b = b >>> 0, S || D(b, 4, this.length), (this[b] | this[b + 1] << 8 | this[b + 2] << 16) + this[b + 3] * 16777216;
  }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(b, S) {
    return b = b >>> 0, S || D(b, 4, this.length), this[b] * 16777216 + (this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3]);
  }, u.prototype.readIntLE = function(b, S, Z) {
    b = b >>> 0, S = S >>> 0, Z || D(b, S, this.length);
    for (var re = this[b], ue = 1, ge = 0; ++ge < S && (ue *= 256); )
      re += this[b + ge] * ue;
    return ue *= 128, re >= ue && (re -= Math.pow(2, 8 * S)), re;
  }, u.prototype.readIntBE = function(b, S, Z) {
    b = b >>> 0, S = S >>> 0, Z || D(b, S, this.length);
    for (var re = S, ue = 1, ge = this[b + --re]; re > 0 && (ue *= 256); )
      ge += this[b + --re] * ue;
    return ue *= 128, ge >= ue && (ge -= Math.pow(2, 8 * S)), ge;
  }, u.prototype.readInt8 = function(b, S) {
    return b = b >>> 0, S || D(b, 1, this.length), this[b] & 128 ? (255 - this[b] + 1) * -1 : this[b];
  }, u.prototype.readInt16LE = function(b, S) {
    b = b >>> 0, S || D(b, 2, this.length);
    var Z = this[b] | this[b + 1] << 8;
    return Z & 32768 ? Z | 4294901760 : Z;
  }, u.prototype.readInt16BE = function(b, S) {
    b = b >>> 0, S || D(b, 2, this.length);
    var Z = this[b + 1] | this[b] << 8;
    return Z & 32768 ? Z | 4294901760 : Z;
  }, u.prototype.readInt32LE = function(b, S) {
    return b = b >>> 0, S || D(b, 4, this.length), this[b] | this[b + 1] << 8 | this[b + 2] << 16 | this[b + 3] << 24;
  }, u.prototype.readInt32BE = function(b, S) {
    return b = b >>> 0, S || D(b, 4, this.length), this[b] << 24 | this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3];
  }, u.prototype.readFloatLE = function(b, S) {
    return b = b >>> 0, S || D(b, 4, this.length), r.read(this, b, !0, 23, 4);
  }, u.prototype.readFloatBE = function(b, S) {
    return b = b >>> 0, S || D(b, 4, this.length), r.read(this, b, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(b, S) {
    return b = b >>> 0, S || D(b, 8, this.length), r.read(this, b, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(b, S) {
    return b = b >>> 0, S || D(b, 8, this.length), r.read(this, b, !1, 52, 8);
  };
  function w(j, b, S, Z, re, ue) {
    if (!u.isBuffer(j))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (b > re || b < ue)
      throw new RangeError('"value" argument is out of bounds');
    if (S + Z > j.length)
      throw new RangeError("Index out of range");
  }
  u.prototype.writeUintLE = u.prototype.writeUIntLE = function(b, S, Z, re) {
    if (b = +b, S = S >>> 0, Z = Z >>> 0, !re) {
      var ue = Math.pow(2, 8 * Z) - 1;
      w(this, b, S, Z, ue, 0);
    }
    var ge = 1, Ee = 0;
    for (this[S] = b & 255; ++Ee < Z && (ge *= 256); )
      this[S + Ee] = b / ge & 255;
    return S + Z;
  }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(b, S, Z, re) {
    if (b = +b, S = S >>> 0, Z = Z >>> 0, !re) {
      var ue = Math.pow(2, 8 * Z) - 1;
      w(this, b, S, Z, ue, 0);
    }
    var ge = Z - 1, Ee = 1;
    for (this[S + ge] = b & 255; --ge >= 0 && (Ee *= 256); )
      this[S + ge] = b / Ee & 255;
    return S + Z;
  }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 1, 255, 0), this[S] = b & 255, S + 1;
  }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 2, 65535, 0), this[S] = b & 255, this[S + 1] = b >>> 8, S + 2;
  }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 2, 65535, 0), this[S] = b >>> 8, this[S + 1] = b & 255, S + 2;
  }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 4, 4294967295, 0), this[S + 3] = b >>> 24, this[S + 2] = b >>> 16, this[S + 1] = b >>> 8, this[S] = b & 255, S + 4;
  }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 4, 4294967295, 0), this[S] = b >>> 24, this[S + 1] = b >>> 16, this[S + 2] = b >>> 8, this[S + 3] = b & 255, S + 4;
  }, u.prototype.writeIntLE = function(b, S, Z, re) {
    if (b = +b, S = S >>> 0, !re) {
      var ue = Math.pow(2, 8 * Z - 1);
      w(this, b, S, Z, ue - 1, -ue);
    }
    var ge = 0, Ee = 1, Ie = 0;
    for (this[S] = b & 255; ++ge < Z && (Ee *= 256); )
      b < 0 && Ie === 0 && this[S + ge - 1] !== 0 && (Ie = 1), this[S + ge] = (b / Ee >> 0) - Ie & 255;
    return S + Z;
  }, u.prototype.writeIntBE = function(b, S, Z, re) {
    if (b = +b, S = S >>> 0, !re) {
      var ue = Math.pow(2, 8 * Z - 1);
      w(this, b, S, Z, ue - 1, -ue);
    }
    var ge = Z - 1, Ee = 1, Ie = 0;
    for (this[S + ge] = b & 255; --ge >= 0 && (Ee *= 256); )
      b < 0 && Ie === 0 && this[S + ge + 1] !== 0 && (Ie = 1), this[S + ge] = (b / Ee >> 0) - Ie & 255;
    return S + Z;
  }, u.prototype.writeInt8 = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 1, 127, -128), b < 0 && (b = 255 + b + 1), this[S] = b & 255, S + 1;
  }, u.prototype.writeInt16LE = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 2, 32767, -32768), this[S] = b & 255, this[S + 1] = b >>> 8, S + 2;
  }, u.prototype.writeInt16BE = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 2, 32767, -32768), this[S] = b >>> 8, this[S + 1] = b & 255, S + 2;
  }, u.prototype.writeInt32LE = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 4, 2147483647, -2147483648), this[S] = b & 255, this[S + 1] = b >>> 8, this[S + 2] = b >>> 16, this[S + 3] = b >>> 24, S + 4;
  }, u.prototype.writeInt32BE = function(b, S, Z) {
    return b = +b, S = S >>> 0, Z || w(this, b, S, 4, 2147483647, -2147483648), b < 0 && (b = 4294967295 + b + 1), this[S] = b >>> 24, this[S + 1] = b >>> 16, this[S + 2] = b >>> 8, this[S + 3] = b & 255, S + 4;
  };
  function U(j, b, S, Z, re, ue) {
    if (S + Z > j.length)
      throw new RangeError("Index out of range");
    if (S < 0)
      throw new RangeError("Index out of range");
  }
  function me(j, b, S, Z, re) {
    return b = +b, S = S >>> 0, re || U(j, b, S, 4), r.write(j, b, S, Z, 23, 4), S + 4;
  }
  u.prototype.writeFloatLE = function(b, S, Z) {
    return me(this, b, S, !0, Z);
  }, u.prototype.writeFloatBE = function(b, S, Z) {
    return me(this, b, S, !1, Z);
  };
  function pe(j, b, S, Z, re) {
    return b = +b, S = S >>> 0, re || U(j, b, S, 8), r.write(j, b, S, Z, 52, 8), S + 8;
  }
  u.prototype.writeDoubleLE = function(b, S, Z) {
    return pe(this, b, S, !0, Z);
  }, u.prototype.writeDoubleBE = function(b, S, Z) {
    return pe(this, b, S, !1, Z);
  }, u.prototype.copy = function(b, S, Z, re) {
    if (!u.isBuffer(b))
      throw new TypeError("argument should be a Buffer");
    if (Z || (Z = 0), !re && re !== 0 && (re = this.length), S >= b.length && (S = b.length), S || (S = 0), re > 0 && re < Z && (re = Z), re === Z || b.length === 0 || this.length === 0)
      return 0;
    if (S < 0)
      throw new RangeError("targetStart out of bounds");
    if (Z < 0 || Z >= this.length)
      throw new RangeError("Index out of range");
    if (re < 0)
      throw new RangeError("sourceEnd out of bounds");
    re > this.length && (re = this.length), b.length - S < re - Z && (re = b.length - S + Z);
    var ue = re - Z;
    return this === b && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(S, Z, re) : Uint8Array.prototype.set.call(
      b,
      this.subarray(Z, re),
      S
    ), ue;
  }, u.prototype.fill = function(b, S, Z, re) {
    if (typeof b == "string") {
      if (typeof S == "string" ? (re = S, S = 0, Z = this.length) : typeof Z == "string" && (re = Z, Z = this.length), re !== void 0 && typeof re != "string")
        throw new TypeError("encoding must be a string");
      if (typeof re == "string" && !u.isEncoding(re))
        throw new TypeError("Unknown encoding: " + re);
      if (b.length === 1) {
        var ue = b.charCodeAt(0);
        (re === "utf8" && ue < 128 || re === "latin1") && (b = ue);
      }
    } else
      typeof b == "number" ? b = b & 255 : typeof b == "boolean" && (b = Number(b));
    if (S < 0 || this.length < S || this.length < Z)
      throw new RangeError("Out of range index");
    if (Z <= S)
      return this;
    S = S >>> 0, Z = Z === void 0 ? this.length : Z >>> 0, b || (b = 0);
    var ge;
    if (typeof b == "number")
      for (ge = S; ge < Z; ++ge)
        this[ge] = b;
    else {
      var Ee = u.isBuffer(b) ? b : u.from(b, re), Ie = Ee.length;
      if (Ie === 0)
        throw new TypeError('The value "' + b + '" is invalid for argument "value"');
      for (ge = 0; ge < Z - S; ++ge)
        this[ge + S] = Ee[ge % Ie];
    }
    return this;
  };
  var ee = /[^+/0-9A-Za-z-_]/g;
  function V(j) {
    if (j = j.split("=")[0], j = j.trim().replace(ee, ""), j.length < 2)
      return "";
    for (; j.length % 4 !== 0; )
      j = j + "=";
    return j;
  }
  function Q(j, b) {
    b = b || 1 / 0;
    for (var S, Z = j.length, re = null, ue = [], ge = 0; ge < Z; ++ge) {
      if (S = j.charCodeAt(ge), S > 55295 && S < 57344) {
        if (!re) {
          if (S > 56319) {
            (b -= 3) > -1 && ue.push(239, 191, 189);
            continue;
          } else if (ge + 1 === Z) {
            (b -= 3) > -1 && ue.push(239, 191, 189);
            continue;
          }
          re = S;
          continue;
        }
        if (S < 56320) {
          (b -= 3) > -1 && ue.push(239, 191, 189), re = S;
          continue;
        }
        S = (re - 55296 << 10 | S - 56320) + 65536;
      } else
        re && (b -= 3) > -1 && ue.push(239, 191, 189);
      if (re = null, S < 128) {
        if ((b -= 1) < 0)
          break;
        ue.push(S);
      } else if (S < 2048) {
        if ((b -= 2) < 0)
          break;
        ue.push(
          S >> 6 | 192,
          S & 63 | 128
        );
      } else if (S < 65536) {
        if ((b -= 3) < 0)
          break;
        ue.push(
          S >> 12 | 224,
          S >> 6 & 63 | 128,
          S & 63 | 128
        );
      } else if (S < 1114112) {
        if ((b -= 4) < 0)
          break;
        ue.push(
          S >> 18 | 240,
          S >> 12 & 63 | 128,
          S >> 6 & 63 | 128,
          S & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return ue;
  }
  function X(j) {
    for (var b = [], S = 0; S < j.length; ++S)
      b.push(j.charCodeAt(S) & 255);
    return b;
  }
  function E(j, b) {
    for (var S, Z, re, ue = [], ge = 0; ge < j.length && !((b -= 2) < 0); ++ge)
      S = j.charCodeAt(ge), Z = S >> 8, re = S % 256, ue.push(re), ue.push(Z);
    return ue;
  }
  function I(j) {
    return e.toByteArray(V(j));
  }
  function F(j, b, S, Z) {
    for (var re = 0; re < Z && !(re + S >= b.length || re >= j.length); ++re)
      b[re + S] = j[re];
    return re;
  }
  function se(j, b) {
    return j instanceof b || j != null && j.constructor != null && j.constructor.name != null && j.constructor.name === b.name;
  }
  function fe(j) {
    return j !== j;
  }
  var Re = function() {
    for (var j = "0123456789abcdef", b = new Array(256), S = 0; S < 16; ++S)
      for (var Z = S * 16, re = 0; re < 16; ++re)
        b[Z + re] = j[S] + j[re];
    return b;
  }();
})(Kc);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(t, e) {
  var r = Kc, n = r.Buffer;
  function i(c, u) {
    for (var l in c)
      u[l] = c[l];
  }
  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? t.exports = r : (i(r, e), e.Buffer = o);
  function o(c, u, l) {
    return n(c, u, l);
  }
  o.prototype = Object.create(n.prototype), i(n, o), o.from = function(c, u, l) {
    if (typeof c == "number")
      throw new TypeError("Argument must not be a number");
    return n(c, u, l);
  }, o.alloc = function(c, u, l) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    var f = n(c);
    return u !== void 0 ? typeof l == "string" ? f.fill(u, l) : f.fill(u) : f.fill(0), f;
  }, o.allocUnsafe = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return n(c);
  }, o.allocUnsafeSlow = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return r.SlowBuffer(c);
  };
})(F0, F0.exports);
var As = F0.exports, Zw = As.Buffer;
function wh(t, e) {
  this._block = Zw.alloc(t), this._finalSize = e, this._blockSize = t, this._len = 0;
}
wh.prototype.update = function(t, e) {
  typeof t == "string" && (e = e || "utf8", t = Zw.from(t, e));
  for (var r = this._block, n = this._blockSize, i = t.length, o = this._len, c = 0; c < i; ) {
    for (var u = o % n, l = Math.min(i - c, n - u), f = 0; f < l; f++)
      r[u + f] = t[c + f];
    o += l, c += l, o % n === 0 && this._update(r);
  }
  return this._len += i, this;
};
wh.prototype.digest = function(t) {
  var e = this._len % this._blockSize;
  this._block[e] = 128, this._block.fill(0, e + 1), e >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var r = this._len * 8;
  if (r <= 4294967295)
    this._block.writeUInt32BE(r, this._blockSize - 4);
  else {
    var n = (r & 4294967295) >>> 0, i = (r - n) / 4294967296;
    this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
  }
  this._update(this._block);
  var o = this._hash();
  return t ? o.toString(t) : o;
};
wh.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var Oa = wh, Lx = hi, Yw = Oa, $x = As.Buffer, Fx = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], Bx = new Array(80);
function Gc() {
  this.init(), this._w = Bx, Yw.call(this, 64, 56);
}
Lx(Gc, Yw);
Gc.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function Ux(t) {
  return t << 5 | t >>> 27;
}
function jx(t) {
  return t << 30 | t >>> 2;
}
function Hx(t, e, r, n) {
  return t === 0 ? e & r | ~e & n : t === 2 ? e & r | e & n | r & n : e ^ r ^ n;
}
Gc.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, n = this._b | 0, i = this._c | 0, o = this._d | 0, c = this._e | 0, u = 0; u < 16; ++u)
    e[u] = t.readInt32BE(u * 4);
  for (; u < 80; ++u)
    e[u] = e[u - 3] ^ e[u - 8] ^ e[u - 14] ^ e[u - 16];
  for (var l = 0; l < 80; ++l) {
    var f = ~~(l / 20), p = Ux(r) + Hx(f, n, i, o) + c + e[l] + Fx[f] | 0;
    c = o, o = i, i = jx(n), n = r, r = p;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = i + this._c | 0, this._d = o + this._d | 0, this._e = c + this._e | 0;
};
Gc.prototype._hash = function() {
  var t = $x.allocUnsafe(20);
  return t.writeInt32BE(this._a | 0, 0), t.writeInt32BE(this._b | 0, 4), t.writeInt32BE(this._c | 0, 8), t.writeInt32BE(this._d | 0, 12), t.writeInt32BE(this._e | 0, 16), t;
};
var qx = Gc, zx = hi, Xw = Oa, Vx = As.Buffer, Wx = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], Kx = new Array(80);
function Jc() {
  this.init(), this._w = Kx, Xw.call(this, 64, 56);
}
zx(Jc, Xw);
Jc.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function Gx(t) {
  return t << 1 | t >>> 31;
}
function Jx(t) {
  return t << 5 | t >>> 27;
}
function Qx(t) {
  return t << 30 | t >>> 2;
}
function Zx(t, e, r, n) {
  return t === 0 ? e & r | ~e & n : t === 2 ? e & r | e & n | r & n : e ^ r ^ n;
}
Jc.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, n = this._b | 0, i = this._c | 0, o = this._d | 0, c = this._e | 0, u = 0; u < 16; ++u)
    e[u] = t.readInt32BE(u * 4);
  for (; u < 80; ++u)
    e[u] = Gx(e[u - 3] ^ e[u - 8] ^ e[u - 14] ^ e[u - 16]);
  for (var l = 0; l < 80; ++l) {
    var f = ~~(l / 20), p = Jx(r) + Zx(f, n, i, o) + c + e[l] + Wx[f] | 0;
    c = o, o = i, i = Qx(n), n = r, r = p;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = i + this._c | 0, this._d = o + this._d | 0, this._e = c + this._e | 0;
};
Jc.prototype._hash = function() {
  var t = Vx.allocUnsafe(20);
  return t.writeInt32BE(this._a | 0, 0), t.writeInt32BE(this._b | 0, 4), t.writeInt32BE(this._c | 0, 8), t.writeInt32BE(this._d | 0, 12), t.writeInt32BE(this._e | 0, 16), t;
};
var Yx = Jc, Xx = hi, eb = Oa, eR = As.Buffer, tR = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], rR = new Array(64);
function Qc() {
  this.init(), this._w = rR, eb.call(this, 64, 56);
}
Xx(Qc, eb);
Qc.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
};
function nR(t, e, r) {
  return r ^ t & (e ^ r);
}
function iR(t, e, r) {
  return t & e | r & (t | e);
}
function sR(t) {
  return (t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10);
}
function oR(t) {
  return (t >>> 6 | t << 26) ^ (t >>> 11 | t << 21) ^ (t >>> 25 | t << 7);
}
function aR(t) {
  return (t >>> 7 | t << 25) ^ (t >>> 18 | t << 14) ^ t >>> 3;
}
function cR(t) {
  return (t >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10;
}
Qc.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, n = this._b | 0, i = this._c | 0, o = this._d | 0, c = this._e | 0, u = this._f | 0, l = this._g | 0, f = this._h | 0, p = 0; p < 16; ++p)
    e[p] = t.readInt32BE(p * 4);
  for (; p < 64; ++p)
    e[p] = cR(e[p - 2]) + e[p - 7] + aR(e[p - 15]) + e[p - 16] | 0;
  for (var g = 0; g < 64; ++g) {
    var y = f + oR(c) + nR(c, u, l) + tR[g] + e[g] | 0, C = sR(r) + iR(r, n, i) | 0;
    f = l, l = u, u = c, c = o + y | 0, o = i, i = n, n = r, r = y + C | 0;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = i + this._c | 0, this._d = o + this._d | 0, this._e = c + this._e | 0, this._f = u + this._f | 0, this._g = l + this._g | 0, this._h = f + this._h | 0;
};
Qc.prototype._hash = function() {
  var t = eR.allocUnsafe(32);
  return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t.writeInt32BE(this._h, 28), t;
};
var tb = Qc, uR = hi, lR = tb, hR = Oa, fR = As.Buffer, dR = new Array(64);
function bh() {
  this.init(), this._w = dR, hR.call(this, 64, 56);
}
uR(bh, lR);
bh.prototype.init = function() {
  return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
};
bh.prototype._hash = function() {
  var t = fR.allocUnsafe(28);
  return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t;
};
var pR = bh, gR = hi, rb = Oa, mR = As.Buffer, Jm = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
], vR = new Array(160);
function Zc() {
  this.init(), this._w = vR, rb.call(this, 128, 112);
}
gR(Zc, rb);
Zc.prototype.init = function() {
  return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
};
function Qm(t, e, r) {
  return r ^ t & (e ^ r);
}
function Zm(t, e, r) {
  return t & e | r & (t | e);
}
function Ym(t, e) {
  return (t >>> 28 | e << 4) ^ (e >>> 2 | t << 30) ^ (e >>> 7 | t << 25);
}
function Xm(t, e) {
  return (t >>> 14 | e << 18) ^ (t >>> 18 | e << 14) ^ (e >>> 9 | t << 23);
}
function yR(t, e) {
  return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ t >>> 7;
}
function _R(t, e) {
  return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ (t >>> 7 | e << 25);
}
function wR(t, e) {
  return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ t >>> 6;
}
function bR(t, e) {
  return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ (t >>> 6 | e << 26);
}
function Sr(t, e) {
  return t >>> 0 < e >>> 0 ? 1 : 0;
}
Zc.prototype._update = function(t) {
  for (var e = this._w, r = this._ah | 0, n = this._bh | 0, i = this._ch | 0, o = this._dh | 0, c = this._eh | 0, u = this._fh | 0, l = this._gh | 0, f = this._hh | 0, p = this._al | 0, g = this._bl | 0, y = this._cl | 0, C = this._dl | 0, R = this._el | 0, J = this._fl | 0, G = this._gl | 0, H = this._hl | 0, T = 0; T < 32; T += 2)
    e[T] = t.readInt32BE(T * 4), e[T + 1] = t.readInt32BE(T * 4 + 4);
  for (; T < 160; T += 2) {
    var q = e[T - 30], B = e[T - 15 * 2 + 1], L = yR(q, B), P = _R(B, q);
    q = e[T - 2 * 2], B = e[T - 2 * 2 + 1];
    var v = wR(q, B), N = bR(B, q), ie = e[T - 7 * 2], le = e[T - 7 * 2 + 1], he = e[T - 16 * 2], ye = e[T - 16 * 2 + 1], k = P + le | 0, h = L + ie + Sr(k, P) | 0;
    k = k + N | 0, h = h + v + Sr(k, N) | 0, k = k + ye | 0, h = h + he + Sr(k, ye) | 0, e[T] = h, e[T + 1] = k;
  }
  for (var m = 0; m < 160; m += 2) {
    h = e[m], k = e[m + 1];
    var x = Zm(r, n, i), M = Zm(p, g, y), A = Ym(r, p), $ = Ym(p, r), K = Xm(c, R), D = Xm(R, c), w = Jm[m], U = Jm[m + 1], me = Qm(c, u, l), pe = Qm(R, J, G), ee = H + D | 0, V = f + K + Sr(ee, H) | 0;
    ee = ee + pe | 0, V = V + me + Sr(ee, pe) | 0, ee = ee + U | 0, V = V + w + Sr(ee, U) | 0, ee = ee + k | 0, V = V + h + Sr(ee, k) | 0;
    var Q = $ + M | 0, X = A + x + Sr(Q, $) | 0;
    f = l, H = G, l = u, G = J, u = c, J = R, R = C + ee | 0, c = o + V + Sr(R, C) | 0, o = i, C = y, i = n, y = g, n = r, g = p, p = ee + Q | 0, r = V + X + Sr(p, ee) | 0;
  }
  this._al = this._al + p | 0, this._bl = this._bl + g | 0, this._cl = this._cl + y | 0, this._dl = this._dl + C | 0, this._el = this._el + R | 0, this._fl = this._fl + J | 0, this._gl = this._gl + G | 0, this._hl = this._hl + H | 0, this._ah = this._ah + r + Sr(this._al, p) | 0, this._bh = this._bh + n + Sr(this._bl, g) | 0, this._ch = this._ch + i + Sr(this._cl, y) | 0, this._dh = this._dh + o + Sr(this._dl, C) | 0, this._eh = this._eh + c + Sr(this._el, R) | 0, this._fh = this._fh + u + Sr(this._fl, J) | 0, this._gh = this._gh + l + Sr(this._gl, G) | 0, this._hh = this._hh + f + Sr(this._hl, H) | 0;
};
Zc.prototype._hash = function() {
  var t = mR.allocUnsafe(64);
  function e(r, n, i) {
    t.writeInt32BE(r, i), t.writeInt32BE(n, i + 4);
  }
  return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), e(this._gh, this._gl, 48), e(this._hh, this._hl, 56), t;
};
var nb = Zc, ER = hi, SR = nb, CR = Oa, IR = As.Buffer, xR = new Array(160);
function Eh() {
  this.init(), this._w = xR, CR.call(this, 128, 112);
}
ER(Eh, SR);
Eh.prototype.init = function() {
  return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
};
Eh.prototype._hash = function() {
  var t = IR.allocUnsafe(48);
  function e(r, n, i) {
    t.writeInt32BE(r, i), t.writeInt32BE(n, i + 4);
  }
  return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), t;
};
var RR = Eh, wo = Jw.exports = function(e) {
  e = e.toLowerCase();
  var r = wo[e];
  if (!r)
    throw new Error(e + " is not supported (we accept pull requests)");
  return new r();
};
wo.sha = qx;
wo.sha1 = Yx;
wo.sha224 = pR;
wo.sha256 = tb;
wo.sha384 = RR;
wo.sha512 = nb;
var AR = Jw.exports;
Object.defineProperty(Da, "__esModule", { value: !0 });
Da.Session = void 0;
const ev = AR, tv = $e, rv = "session:id", nv = "session:secret", iv = "session:linked";
class xp {
  constructor(e, r, n, i) {
    this._storage = e, this._id = r || (0, tv.randomBytesHex)(16), this._secret = n || (0, tv.randomBytesHex)(32), this._key = new ev.sha256().update(`${this._id}, ${this._secret} WalletLink`).digest("hex"), this._linked = !!i;
  }
  static load(e) {
    const r = e.getItem(rv), n = e.getItem(iv), i = e.getItem(nv);
    return r && i ? new xp(e, r, i, n === "1") : null;
  }
  /**
   * Takes in a session ID and returns the sha256 hash of it.
   * @param sessionId session ID
   */
  static hash(e) {
    return new ev.sha256().update(e).digest("hex");
  }
  get id() {
    return this._id;
  }
  get secret() {
    return this._secret;
  }
  get key() {
    return this._key;
  }
  get linked() {
    return this._linked;
  }
  set linked(e) {
    this._linked = e, this.persistLinked();
  }
  save() {
    return this._storage.setItem(rv, this._id), this._storage.setItem(nv, this._secret), this.persistLinked(), this;
  }
  persistLinked() {
    this._storage.setItem(iv, this._linked ? "1" : "0");
  }
}
Da.Session = xp;
var Sh = {}, Ch = {};
Object.defineProperty(Ch, "__esModule", { value: !0 });
Ch.Cipher = void 0;
const El = $e;
class MR {
  // @param secret hex representation of 32-byte secret
  constructor(e) {
    this.secret = e;
  }
  /**
   *
   * @param plainText string to be encrypted
   * returns hex string representation of bytes in the order: initialization vector (iv),
   * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes. Remaining bytes are the
   * encrypted plainText.
   */
  async encrypt(e) {
    const r = this.secret;
    if (r.length !== 64)
      throw Error("secret must be 256 bits");
    const n = crypto.getRandomValues(new Uint8Array(12)), i = await crypto.subtle.importKey("raw", (0, El.hexStringToUint8Array)(r), { name: "aes-gcm" }, !1, ["encrypt", "decrypt"]), o = new TextEncoder(), c = await window.crypto.subtle.encrypt({
      name: "AES-GCM",
      iv: n
    }, i, o.encode(e)), u = 16, l = c.slice(c.byteLength - u), f = c.slice(0, c.byteLength - u), p = new Uint8Array(l), g = new Uint8Array(f), y = new Uint8Array([...n, ...p, ...g]);
    return (0, El.uint8ArrayToHex)(y);
  }
  /**
   *
   * @param cipherText hex string representation of bytes in the order: initialization vector (iv),
   * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes.
   */
  async decrypt(e) {
    const r = this.secret;
    if (r.length !== 64)
      throw Error("secret must be 256 bits");
    return new Promise((n, i) => {
      (async function() {
        const o = await crypto.subtle.importKey("raw", (0, El.hexStringToUint8Array)(r), { name: "aes-gcm" }, !1, ["encrypt", "decrypt"]), c = (0, El.hexStringToUint8Array)(e), u = c.slice(0, 12), l = c.slice(12, 28), f = c.slice(28), p = new Uint8Array([...f, ...l]), g = {
          name: "AES-GCM",
          iv: new Uint8Array(u)
        };
        try {
          const y = await window.crypto.subtle.decrypt(g, o, p), C = new TextDecoder();
          n(C.decode(y));
        } catch (y) {
          i(y);
        }
      })();
    });
  }
}
Ch.Cipher = MR;
var Ih = {};
Object.defineProperty(Ih, "__esModule", { value: !0 });
Ih.WalletLinkHTTP = void 0;
class DR {
  constructor(e, r, n) {
    this.linkAPIUrl = e, this.sessionId = r;
    const i = `${r}:${n}`;
    this.auth = `Basic ${btoa(i)}`;
  }
  // mark unseen events as seen
  async markUnseenEventsAsSeen(e) {
    return Promise.all(e.map((r) => fetch(`${this.linkAPIUrl}/events/${r.eventId}/seen`, {
      method: "POST",
      headers: {
        Authorization: this.auth
      }
    }))).catch((r) => console.error("Unabled to mark event as failed:", r));
  }
  async fetchUnseenEvents() {
    var e;
    const r = await fetch(`${this.linkAPIUrl}/events?unseen=true`, {
      headers: {
        Authorization: this.auth
      }
    });
    if (r.ok) {
      const { events: n, error: i } = await r.json();
      if (i)
        throw new Error(`Check unseen events failed: ${i}`);
      const o = (e = n?.filter((c) => c.event === "Web3Response").map((c) => ({
        type: "Event",
        sessionId: this.sessionId,
        eventId: c.id,
        event: c.event,
        data: c.data
      }))) !== null && e !== void 0 ? e : [];
      return this.markUnseenEventsAsSeen(o), o;
    }
    throw new Error(`Check unseen events failed: ${r.status}`);
  }
}
Ih.WalletLinkHTTP = DR;
var ya = {};
Object.defineProperty(ya, "__esModule", { value: !0 });
ya.WalletLinkWebSocket = ya.ConnectionState = void 0;
var sa;
(function(t) {
  t[t.DISCONNECTED = 0] = "DISCONNECTED", t[t.CONNECTING = 1] = "CONNECTING", t[t.CONNECTED = 2] = "CONNECTED";
})(sa || (ya.ConnectionState = sa = {}));
class OR {
  setConnectionStateListener(e) {
    this.connectionStateListener = e;
  }
  setIncomingDataListener(e) {
    this.incomingDataListener = e;
  }
  /**
   * Constructor
   * @param url WebSocket server URL
   * @param [WebSocketClass] Custom WebSocket implementation
   */
  constructor(e, r = WebSocket) {
    this.WebSocketClass = r, this.webSocket = null, this.pendingData = [], this.url = e.replace(/^http/, "ws");
  }
  /**
   * Make a websocket connection
   * @returns a Promise that resolves when connected
   */
  async connect() {
    if (this.webSocket)
      throw new Error("webSocket object is not null");
    return new Promise((e, r) => {
      var n;
      let i;
      try {
        this.webSocket = i = new this.WebSocketClass(this.url);
      } catch (o) {
        r(o);
        return;
      }
      (n = this.connectionStateListener) === null || n === void 0 || n.call(this, sa.CONNECTING), i.onclose = (o) => {
        var c;
        this.clearWebSocket(), r(new Error(`websocket error ${o.code}: ${o.reason}`)), (c = this.connectionStateListener) === null || c === void 0 || c.call(this, sa.DISCONNECTED);
      }, i.onopen = (o) => {
        var c;
        e(), (c = this.connectionStateListener) === null || c === void 0 || c.call(this, sa.CONNECTED), this.pendingData.length > 0 && ([...this.pendingData].forEach((l) => this.sendData(l)), this.pendingData = []);
      }, i.onmessage = (o) => {
        var c, u;
        if (o.data === "h")
          (c = this.incomingDataListener) === null || c === void 0 || c.call(this, {
            type: "Heartbeat"
          });
        else
          try {
            const l = JSON.parse(o.data);
            (u = this.incomingDataListener) === null || u === void 0 || u.call(this, l);
          } catch {
          }
      };
    });
  }
  /**
   * Disconnect from server
   */
  disconnect() {
    var e;
    const { webSocket: r } = this;
    if (r) {
      this.clearWebSocket(), (e = this.connectionStateListener) === null || e === void 0 || e.call(this, sa.DISCONNECTED), this.connectionStateListener = void 0, this.incomingDataListener = void 0;
      try {
        r.close();
      } catch {
      }
    }
  }
  /**
   * Send data to server
   * @param data text to send
   */
  sendData(e) {
    const { webSocket: r } = this;
    if (!r) {
      this.pendingData.push(e), this.connect();
      return;
    }
    r.send(e);
  }
  clearWebSocket() {
    const { webSocket: e } = this;
    e && (this.webSocket = null, e.onclose = null, e.onerror = null, e.onmessage = null, e.onopen = null);
  }
}
ya.WalletLinkWebSocket = OR;
Object.defineProperty(Sh, "__esModule", { value: !0 });
Sh.WalletLinkConnection = void 0;
const Qo = _r, PR = Ch, wi = Ma, sv = Hn, Zo = Da, TR = Ih, Sl = ya, ov = 1e4, NR = 6e4;
class kR {
  /**
   * Constructor
   * @param session Session
   * @param linkAPIUrl Coinbase Wallet link server URL
   * @param listener WalletLinkConnectionUpdateListener
   * @param [WebSocketClass] Custom WebSocket implementation
   */
  constructor({ session: e, linkAPIUrl: r, listener: n, diagnostic: i, WebSocketClass: o = WebSocket }) {
    this.destroyed = !1, this.lastHeartbeatResponse = 0, this.nextReqId = (0, Qo.IntNumber)(1), this._connected = !1, this._linked = !1, this.shouldFetchUnseenEventsOnConnect = !1, this.requestResolutions = /* @__PURE__ */ new Map(), this.handleSessionMetadataUpdated = (u) => {
      if (!u)
        return;
      (/* @__PURE__ */ new Map([
        ["__destroyed", this.handleDestroyed],
        ["EthereumAddress", this.handleAccountUpdated],
        ["WalletUsername", this.handleWalletUsernameUpdated],
        ["AppVersion", this.handleAppVersionUpdated],
        [
          "ChainId",
          (f) => u.JsonRpcUrl && this.handleChainUpdated(f, u.JsonRpcUrl)
        ]
      ])).forEach((f, p) => {
        const g = u[p];
        g !== void 0 && f(g);
      });
    }, this.handleDestroyed = (u) => {
      var l, f;
      u === "1" && ((l = this.listener) === null || l === void 0 || l.resetAndReload(), (f = this.diagnostic) === null || f === void 0 || f.log(wi.EVENTS.METADATA_DESTROYED, {
        alreadyDestroyed: this.isDestroyed,
        sessionIdHash: Zo.Session.hash(this.session.id)
      }));
    }, this.handleAccountUpdated = async (u) => {
      var l, f;
      try {
        const p = await this.cipher.decrypt(u);
        (l = this.listener) === null || l === void 0 || l.accountUpdated(p);
      } catch {
        (f = this.diagnostic) === null || f === void 0 || f.log(wi.EVENTS.GENERAL_ERROR, {
          message: "Had error decrypting",
          value: "selectedAddress"
        });
      }
    }, this.handleMetadataUpdated = async (u, l) => {
      var f, p;
      try {
        const g = await this.cipher.decrypt(l);
        (f = this.listener) === null || f === void 0 || f.metadataUpdated(u, g);
      } catch {
        (p = this.diagnostic) === null || p === void 0 || p.log(wi.EVENTS.GENERAL_ERROR, {
          message: "Had error decrypting",
          value: u
        });
      }
    }, this.handleWalletUsernameUpdated = async (u) => {
      this.handleMetadataUpdated(sv.WALLET_USER_NAME_KEY, u);
    }, this.handleAppVersionUpdated = async (u) => {
      this.handleMetadataUpdated(sv.APP_VERSION_KEY, u);
    }, this.handleChainUpdated = async (u, l) => {
      var f, p;
      try {
        const g = await this.cipher.decrypt(u), y = await this.cipher.decrypt(l);
        (f = this.listener) === null || f === void 0 || f.chainUpdated(g, y);
      } catch {
        (p = this.diagnostic) === null || p === void 0 || p.log(wi.EVENTS.GENERAL_ERROR, {
          message: "Had error decrypting",
          value: "chainId|jsonRpcUrl"
        });
      }
    }, this.session = e, this.cipher = new PR.Cipher(e.secret), this.diagnostic = i, this.listener = n;
    const c = new Sl.WalletLinkWebSocket(`${r}/rpc`, o);
    c.setConnectionStateListener(async (u) => {
      var l;
      (l = this.diagnostic) === null || l === void 0 || l.log(wi.EVENTS.CONNECTED_STATE_CHANGE, {
        state: u,
        sessionIdHash: Zo.Session.hash(e.id)
      });
      let f = !1;
      switch (u) {
        case Sl.ConnectionState.DISCONNECTED:
          if (!this.destroyed) {
            const p = async () => {
              await new Promise((g) => setTimeout(g, 5e3)), this.destroyed || c.connect().catch(() => {
                p();
              });
            };
            p();
          }
          break;
        case Sl.ConnectionState.CONNECTED:
          try {
            await this.authenticate(), this.sendIsLinked(), this.sendGetSessionConfig(), f = !0;
          } catch {
          }
          this.updateLastHeartbeat(), setInterval(() => {
            this.heartbeat();
          }, ov), this.shouldFetchUnseenEventsOnConnect && this.fetchUnseenEventsAPI();
          break;
        case Sl.ConnectionState.CONNECTING:
          break;
      }
      this.connected !== f && (this.connected = f);
    }), c.setIncomingDataListener((u) => {
      var l, f, p;
      switch (u.type) {
        case "Heartbeat":
          this.updateLastHeartbeat();
          return;
        case "IsLinkedOK":
        case "Linked": {
          const g = u.type === "IsLinkedOK" ? u.linked : void 0;
          (l = this.diagnostic) === null || l === void 0 || l.log(wi.EVENTS.LINKED, {
            sessionIdHash: Zo.Session.hash(e.id),
            linked: g,
            type: u.type,
            onlineGuests: u.onlineGuests
          }), this.linked = g || u.onlineGuests > 0;
          break;
        }
        case "GetSessionConfigOK":
        case "SessionConfigUpdated": {
          (f = this.diagnostic) === null || f === void 0 || f.log(wi.EVENTS.SESSION_CONFIG_RECEIVED, {
            sessionIdHash: Zo.Session.hash(e.id),
            metadata_keys: u && u.metadata ? Object.keys(u.metadata) : void 0
          }), this.handleSessionMetadataUpdated(u.metadata);
          break;
        }
        case "Event": {
          this.handleIncomingEvent(u);
          break;
        }
      }
      u.id !== void 0 && ((p = this.requestResolutions.get(u.id)) === null || p === void 0 || p(u));
    }), this.ws = c, this.http = new TR.WalletLinkHTTP(r, e.id, e.key);
  }
  /**
   * Make a connection to the server
   */
  connect() {
    var e;
    if (this.destroyed)
      throw new Error("instance is destroyed");
    (e = this.diagnostic) === null || e === void 0 || e.log(wi.EVENTS.STARTED_CONNECTING, {
      sessionIdHash: Zo.Session.hash(this.session.id)
    }), this.ws.connect();
  }
  /**
   * Terminate connection, and mark as destroyed. To reconnect, create a new
   * instance of WalletSDKConnection
   */
  destroy() {
    var e;
    this.destroyed = !0, this.ws.disconnect(), (e = this.diagnostic) === null || e === void 0 || e.log(wi.EVENTS.DISCONNECTED, {
      sessionIdHash: Zo.Session.hash(this.session.id)
    }), this.listener = void 0;
  }
  get isDestroyed() {
    return this.destroyed;
  }
  get connected() {
    return this._connected;
  }
  set connected(e) {
    var r, n;
    this._connected = e, e && ((r = this.onceConnected) === null || r === void 0 || r.call(this)), (n = this.listener) === null || n === void 0 || n.connectedUpdated(e);
  }
  setOnceConnected(e) {
    return new Promise((r) => {
      this.connected ? e().then(r) : this.onceConnected = () => {
        e().then(r), this.onceConnected = void 0;
      };
    });
  }
  get linked() {
    return this._linked;
  }
  set linked(e) {
    var r, n;
    this._linked = e, e && ((r = this.onceLinked) === null || r === void 0 || r.call(this)), (n = this.listener) === null || n === void 0 || n.linkedUpdated(e);
  }
  setOnceLinked(e) {
    return new Promise((r) => {
      this.linked ? e().then(r) : this.onceLinked = () => {
        e().then(r), this.onceLinked = void 0;
      };
    });
  }
  async handleIncomingEvent(e) {
    var r, n;
    if (!(e.type !== "Event" || e.event !== "Web3Response"))
      try {
        const i = await this.cipher.decrypt(e.data), o = JSON.parse(i);
        if (o.type !== "WEB3_RESPONSE")
          return;
        (r = this.listener) === null || r === void 0 || r.handleWeb3ResponseMessage(o);
      } catch {
        (n = this.diagnostic) === null || n === void 0 || n.log(wi.EVENTS.GENERAL_ERROR, {
          message: "Had error decrypting",
          value: "incomingEvent"
        });
      }
  }
  async checkUnseenEvents() {
    if (!this.connected) {
      this.shouldFetchUnseenEventsOnConnect = !0;
      return;
    }
    await new Promise((e) => setTimeout(e, 250));
    try {
      await this.fetchUnseenEventsAPI();
    } catch (e) {
      console.error("Unable to check for unseen events", e);
    }
  }
  async fetchUnseenEventsAPI() {
    this.shouldFetchUnseenEventsOnConnect = !1, (await this.http.fetchUnseenEvents()).forEach((r) => this.handleIncomingEvent(r));
  }
  /**
   * Set session metadata in SessionConfig object
   * @param key
   * @param value
   * @returns a Promise that completes when successful
   */
  async setSessionMetadata(e, r) {
    const n = {
      type: "SetSessionConfig",
      id: (0, Qo.IntNumber)(this.nextReqId++),
      sessionId: this.session.id,
      metadata: { [e]: r }
    };
    return this.setOnceConnected(async () => {
      const i = await this.makeRequest(n);
      if (i.type === "Fail")
        throw new Error(i.error || "failed to set session metadata");
    });
  }
  /**
   * Publish an event and emit event ID when successful
   * @param event event name
   * @param unencryptedData unencrypted event data
   * @param callWebhook whether the webhook should be invoked
   * @returns a Promise that emits event ID when successful
   */
  async publishEvent(e, r, n = !1) {
    const i = await this.cipher.encrypt(JSON.stringify(Object.assign(Object.assign({}, r), { origin: location.origin, relaySource: window.coinbaseWalletExtension ? "injected_sdk" : "sdk" }))), o = {
      type: "PublishEvent",
      id: (0, Qo.IntNumber)(this.nextReqId++),
      sessionId: this.session.id,
      event: e,
      data: i,
      callWebhook: n
    };
    return this.setOnceLinked(async () => {
      const c = await this.makeRequest(o);
      if (c.type === "Fail")
        throw new Error(c.error || "failed to publish event");
      return c.eventId;
    });
  }
  sendData(e) {
    this.ws.sendData(JSON.stringify(e));
  }
  updateLastHeartbeat() {
    this.lastHeartbeatResponse = Date.now();
  }
  heartbeat() {
    if (Date.now() - this.lastHeartbeatResponse > ov * 2) {
      this.ws.disconnect();
      return;
    }
    try {
      this.ws.sendData("h");
    } catch {
    }
  }
  async makeRequest(e, r = NR) {
    const n = e.id;
    this.sendData(e);
    let i;
    return Promise.race([
      new Promise((o, c) => {
        i = window.setTimeout(() => {
          c(new Error(`request ${n} timed out`));
        }, r);
      }),
      new Promise((o) => {
        this.requestResolutions.set(n, (c) => {
          clearTimeout(i), o(c), this.requestResolutions.delete(n);
        });
      })
    ]);
  }
  async authenticate() {
    const e = {
      type: "HostSession",
      id: (0, Qo.IntNumber)(this.nextReqId++),
      sessionId: this.session.id,
      sessionKey: this.session.key
    }, r = await this.makeRequest(e);
    if (r.type === "Fail")
      throw new Error(r.error || "failed to authentcate");
  }
  sendIsLinked() {
    const e = {
      type: "IsLinked",
      id: (0, Qo.IntNumber)(this.nextReqId++),
      sessionId: this.session.id
    };
    this.sendData(e);
  }
  sendGetSessionConfig() {
    const e = {
      type: "GetSessionConfig",
      id: (0, Qo.IntNumber)(this.nextReqId++),
      sessionId: this.session.id
    };
    this.sendData(e);
  }
}
Sh.WalletLinkConnection = kR;
var Yc = {}, Xc = {}, Rp = {};
Object.defineProperty(Rp, "__esModule", { value: !0 });
Rp.default = '@namespace svg "http://www.w3.org/2000/svg";.-cbwsdk-css-reset,.-cbwsdk-css-reset *{animation:none;animation-delay:0;animation-direction:normal;animation-duration:0;animation-fill-mode:none;animation-iteration-count:1;animation-name:none;animation-play-state:running;animation-timing-function:ease;backface-visibility:visible;background:0;background-attachment:scroll;background-clip:border-box;background-color:rgba(0,0,0,0);background-image:none;background-origin:padding-box;background-position:0 0;background-position-x:0;background-position-y:0;background-repeat:repeat;background-size:auto auto;border:0;border-style:none;border-width:medium;border-color:inherit;border-bottom:0;border-bottom-color:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-style:none;border-bottom-width:medium;border-collapse:separate;border-image:none;border-left:0;border-left-color:inherit;border-left-style:none;border-left-width:medium;border-radius:0;border-right:0;border-right-color:inherit;border-right-style:none;border-right-width:medium;border-spacing:0;border-top:0;border-top-color:inherit;border-top-left-radius:0;border-top-right-radius:0;border-top-style:none;border-top-width:medium;box-shadow:none;box-sizing:border-box;caption-side:top;clear:none;clip:auto;color:inherit;columns:auto;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-rule-color:currentColor;column-rule-style:none;column-rule-width:none;column-span:1;column-width:auto;counter-increment:none;counter-reset:none;direction:ltr;empty-cells:show;float:none;font:normal;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;height:auto;hyphens:none;letter-spacing:normal;line-height:normal;list-style:none;list-style-image:none;list-style-position:outside;list-style-type:disc;margin:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;opacity:1;orphans:0;outline:0;outline-color:invert;outline-style:none;outline-width:medium;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;pointer-events:auto;position:static;quotes:"\\201C" "\\201D" "\\2018" "\\2019";tab-size:8;table-layout:auto;text-align:inherit;text-align-last:auto;text-decoration:none;text-decoration-color:inherit;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-shadow:none;text-transform:none;transform:none;transform-style:flat;transition:none;transition-delay:0s;transition-duration:0s;transition-property:none;transition-timing-function:ease;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:0;word-spacing:normal;z-index:auto}.-cbwsdk-css-reset strong{font-weight:bold}.-cbwsdk-css-reset *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;line-height:1}.-cbwsdk-css-reset [class*=container]{margin:0;padding:0}.-cbwsdk-css-reset style{display:none}';
var LR = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Xc, "__esModule", { value: !0 });
Xc.injectCssReset = void 0;
const $R = LR(Rp);
function FR() {
  const t = document.createElement("style");
  t.type = "text/css", t.appendChild(document.createTextNode($R.default)), document.documentElement.appendChild(t);
}
Xc.injectCssReset = FR;
var xh = {}, eu, et, ib, sb, ro, av, ob, B0, ab, Oc = {}, cb = [], BR = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, Rh = Array.isArray;
function Xi(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}
function ub(t) {
  var e = t.parentNode;
  e && e.removeChild(t);
}
function U0(t, e, r) {
  var n, i, o, c = {};
  for (o in e)
    o == "key" ? n = e[o] : o == "ref" ? i = e[o] : c[o] = e[o];
  if (arguments.length > 2 && (c.children = arguments.length > 3 ? eu.call(arguments, 2) : r), typeof t == "function" && t.defaultProps != null)
    for (o in t.defaultProps)
      c[o] === void 0 && (c[o] = t.defaultProps[o]);
  return Cc(t, c, n, i, null);
}
function Cc(t, e, r, n, i) {
  var o = { type: t, props: e, key: r, ref: n, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: i ?? ++ib, __i: -1, __u: 0 };
  return i == null && et.vnode != null && et.vnode(o), o;
}
function UR() {
  return { current: null };
}
function tu(t) {
  return t.children;
}
function Ic(t, e) {
  this.props = t, this.context = e;
}
function _a(t, e) {
  if (e == null)
    return t.__ ? _a(t.__, t.__i + 1) : null;
  for (var r; e < t.__k.length; e++)
    if ((r = t.__k[e]) != null && r.__e != null)
      return r.__e;
  return typeof t.type == "function" ? _a(t) : null;
}
function lb(t) {
  var e, r;
  if ((t = t.__) != null && t.__c != null) {
    for (t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++)
      if ((r = t.__k[e]) != null && r.__e != null) {
        t.__e = t.__c.base = r.__e;
        break;
      }
    return lb(t);
  }
}
function j0(t) {
  (!t.__d && (t.__d = !0) && ro.push(t) && !Xl.__r++ || av !== et.debounceRendering) && ((av = et.debounceRendering) || ob)(Xl);
}
function Xl() {
  var t, e, r, n, i, o, c, u, l;
  for (ro.sort(B0); t = ro.shift(); )
    t.__d && (e = ro.length, n = void 0, o = (i = (r = t).__v).__e, u = [], l = [], (c = r.__P) && ((n = Xi({}, i)).__v = i.__v + 1, et.vnode && et.vnode(n), Ap(c, n, i, r.__n, c.ownerSVGElement !== void 0, 32 & i.__u ? [o] : null, u, o ?? _a(i), !!(32 & i.__u), l), n.__.__k[n.__i] = n, pb(u, n, l), n.__e != o && lb(n)), ro.length > e && ro.sort(B0));
  Xl.__r = 0;
}
function hb(t, e, r, n, i, o, c, u, l, f, p) {
  var g, y, C, R, J, G = n && n.__k || cb, H = e.length;
  for (r.__d = l, jR(r, e, G), l = r.__d, g = 0; g < H; g++)
    (C = r.__k[g]) != null && typeof C != "boolean" && typeof C != "function" && (y = C.__i === -1 ? Oc : G[C.__i] || Oc, C.__i = g, Ap(t, C, y, i, o, c, u, l, f, p), R = C.__e, C.ref && y.ref != C.ref && (y.ref && Mp(y.ref, null, C), p.push(C.ref, C.__c || R, C)), J == null && R != null && (J = R), 65536 & C.__u || y.__k === C.__k ? l = fb(C, l, t) : typeof C.type == "function" && C.__d !== void 0 ? l = C.__d : R && (l = R.nextSibling), C.__d = void 0, C.__u &= -196609);
  r.__d = l, r.__e = J;
}
function jR(t, e, r) {
  var n, i, o, c, u, l = e.length, f = r.length, p = f, g = 0;
  for (t.__k = [], n = 0; n < l; n++)
    (i = t.__k[n] = (i = e[n]) == null || typeof i == "boolean" || typeof i == "function" ? null : typeof i == "string" || typeof i == "number" || typeof i == "bigint" || i.constructor == String ? Cc(null, i, null, null, i) : Rh(i) ? Cc(tu, { children: i }, null, null, null) : i.constructor === void 0 && i.__b > 0 ? Cc(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) != null ? (i.__ = t, i.__b = t.__b + 1, u = HR(i, r, c = n + g, p), i.__i = u, o = null, u !== -1 && (p--, (o = r[u]) && (o.__u |= 131072)), o == null || o.__v === null ? (u == -1 && g--, typeof i.type != "function" && (i.__u |= 65536)) : u !== c && (u === c + 1 ? g++ : u > c ? p > l - c ? g += u - c : g-- : g = u < c && u == c - 1 ? u - c : 0, u !== n + g && (i.__u |= 65536))) : (o = r[n]) && o.key == null && o.__e && (o.__e == t.__d && (t.__d = _a(o)), H0(o, o, !1), r[n] = null, p--);
  if (p)
    for (n = 0; n < f; n++)
      (o = r[n]) != null && !(131072 & o.__u) && (o.__e == t.__d && (t.__d = _a(o)), H0(o, o));
}
function fb(t, e, r) {
  var n, i;
  if (typeof t.type == "function") {
    for (n = t.__k, i = 0; n && i < n.length; i++)
      n[i] && (n[i].__ = t, e = fb(n[i], e, r));
    return e;
  }
  return t.__e != e && (r.insertBefore(t.__e, e || null), e = t.__e), e && e.nextSibling;
}
function db(t, e) {
  return e = e || [], t == null || typeof t == "boolean" || (Rh(t) ? t.some(function(r) {
    db(r, e);
  }) : e.push(t)), e;
}
function HR(t, e, r, n) {
  var i = t.key, o = t.type, c = r - 1, u = r + 1, l = e[r];
  if (l === null || l && i == l.key && o === l.type)
    return r;
  if (n > (l != null && !(131072 & l.__u) ? 1 : 0))
    for (; c >= 0 || u < e.length; ) {
      if (c >= 0) {
        if ((l = e[c]) && !(131072 & l.__u) && i == l.key && o === l.type)
          return c;
        c--;
      }
      if (u < e.length) {
        if ((l = e[u]) && !(131072 & l.__u) && i == l.key && o === l.type)
          return u;
        u++;
      }
    }
  return -1;
}
function cv(t, e, r) {
  e[0] === "-" ? t.setProperty(e, r ?? "") : t[e] = r == null ? "" : typeof r != "number" || BR.test(e) ? r : r + "px";
}
function Cl(t, e, r, n, i) {
  var o;
  e:
    if (e === "style")
      if (typeof r == "string")
        t.style.cssText = r;
      else {
        if (typeof n == "string" && (t.style.cssText = n = ""), n)
          for (e in n)
            r && e in r || cv(t.style, e, "");
        if (r)
          for (e in r)
            n && r[e] === n[e] || cv(t.style, e, r[e]);
      }
    else if (e[0] === "o" && e[1] === "n")
      o = e !== (e = e.replace(/(PointerCapture)$|Capture$/, "$1")), e = e.toLowerCase() in t ? e.toLowerCase().slice(2) : e.slice(2), t.l || (t.l = {}), t.l[e + o] = r, r ? n ? r.u = n.u : (r.u = Date.now(), t.addEventListener(e, o ? lv : uv, o)) : t.removeEventListener(e, o ? lv : uv, o);
    else {
      if (i)
        e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (e !== "width" && e !== "height" && e !== "href" && e !== "list" && e !== "form" && e !== "tabIndex" && e !== "download" && e !== "rowSpan" && e !== "colSpan" && e !== "role" && e in t)
        try {
          t[e] = r ?? "";
          break e;
        } catch {
        }
      typeof r == "function" || (r == null || r === !1 && e[4] !== "-" ? t.removeAttribute(e) : t.setAttribute(e, r));
    }
}
function uv(t) {
  var e = this.l[t.type + !1];
  if (t.t) {
    if (t.t <= e.u)
      return;
  } else
    t.t = Date.now();
  return e(et.event ? et.event(t) : t);
}
function lv(t) {
  return this.l[t.type + !0](et.event ? et.event(t) : t);
}
function Ap(t, e, r, n, i, o, c, u, l, f) {
  var p, g, y, C, R, J, G, H, T, q, B, L, P, v, N, ie = e.type;
  if (e.constructor !== void 0)
    return null;
  128 & r.__u && (l = !!(32 & r.__u), o = [u = e.__e = r.__e]), (p = et.__b) && p(e);
  e:
    if (typeof ie == "function")
      try {
        if (H = e.props, T = (p = ie.contextType) && n[p.__c], q = p ? T ? T.props.value : p.__ : n, r.__c ? G = (g = e.__c = r.__c).__ = g.__E : ("prototype" in ie && ie.prototype.render ? e.__c = g = new ie(H, q) : (e.__c = g = new Ic(H, q), g.constructor = ie, g.render = zR), T && T.sub(g), g.props = H, g.state || (g.state = {}), g.context = q, g.__n = n, y = g.__d = !0, g.__h = [], g._sb = []), g.__s == null && (g.__s = g.state), ie.getDerivedStateFromProps != null && (g.__s == g.state && (g.__s = Xi({}, g.__s)), Xi(g.__s, ie.getDerivedStateFromProps(H, g.__s))), C = g.props, R = g.state, g.__v = e, y)
          ie.getDerivedStateFromProps == null && g.componentWillMount != null && g.componentWillMount(), g.componentDidMount != null && g.__h.push(g.componentDidMount);
        else {
          if (ie.getDerivedStateFromProps == null && H !== C && g.componentWillReceiveProps != null && g.componentWillReceiveProps(H, q), !g.__e && (g.shouldComponentUpdate != null && g.shouldComponentUpdate(H, g.__s, q) === !1 || e.__v === r.__v)) {
            for (e.__v !== r.__v && (g.props = H, g.state = g.__s, g.__d = !1), e.__e = r.__e, e.__k = r.__k, e.__k.forEach(function(le) {
              le && (le.__ = e);
            }), B = 0; B < g._sb.length; B++)
              g.__h.push(g._sb[B]);
            g._sb = [], g.__h.length && c.push(g);
            break e;
          }
          g.componentWillUpdate != null && g.componentWillUpdate(H, g.__s, q), g.componentDidUpdate != null && g.__h.push(function() {
            g.componentDidUpdate(C, R, J);
          });
        }
        if (g.context = q, g.props = H, g.__P = t, g.__e = !1, L = et.__r, P = 0, "prototype" in ie && ie.prototype.render) {
          for (g.state = g.__s, g.__d = !1, L && L(e), p = g.render(g.props, g.state, g.context), v = 0; v < g._sb.length; v++)
            g.__h.push(g._sb[v]);
          g._sb = [];
        } else
          do
            g.__d = !1, L && L(e), p = g.render(g.props, g.state, g.context), g.state = g.__s;
          while (g.__d && ++P < 25);
        g.state = g.__s, g.getChildContext != null && (n = Xi(Xi({}, n), g.getChildContext())), y || g.getSnapshotBeforeUpdate == null || (J = g.getSnapshotBeforeUpdate(C, R)), hb(t, Rh(N = p != null && p.type === tu && p.key == null ? p.props.children : p) ? N : [N], e, r, n, i, o, c, u, l, f), g.base = e.__e, e.__u &= -161, g.__h.length && c.push(g), G && (g.__E = g.__ = null);
      } catch (le) {
        e.__v = null, l || o != null ? (e.__e = u, e.__u |= l ? 160 : 32, o[o.indexOf(u)] = null) : (e.__e = r.__e, e.__k = r.__k), et.__e(le, e, r);
      }
    else
      o == null && e.__v === r.__v ? (e.__k = r.__k, e.__e = r.__e) : e.__e = qR(r.__e, e, r, n, i, o, c, l, f);
  (p = et.diffed) && p(e);
}
function pb(t, e, r) {
  e.__d = void 0;
  for (var n = 0; n < r.length; n++)
    Mp(r[n], r[++n], r[++n]);
  et.__c && et.__c(e, t), t.some(function(i) {
    try {
      t = i.__h, i.__h = [], t.some(function(o) {
        o.call(i);
      });
    } catch (o) {
      et.__e(o, i.__v);
    }
  });
}
function qR(t, e, r, n, i, o, c, u, l) {
  var f, p, g, y, C, R, J, G = r.props, H = e.props, T = e.type;
  if (T === "svg" && (i = !0), o != null) {
    for (f = 0; f < o.length; f++)
      if ((C = o[f]) && "setAttribute" in C == !!T && (T ? C.localName === T : C.nodeType === 3)) {
        t = C, o[f] = null;
        break;
      }
  }
  if (t == null) {
    if (T === null)
      return document.createTextNode(H);
    t = i ? document.createElementNS("http://www.w3.org/2000/svg", T) : document.createElement(T, H.is && H), o = null, u = !1;
  }
  if (T === null)
    G === H || u && t.data === H || (t.data = H);
  else {
    if (o = o && eu.call(t.childNodes), G = r.props || Oc, !u && o != null)
      for (G = {}, f = 0; f < t.attributes.length; f++)
        G[(C = t.attributes[f]).name] = C.value;
    for (f in G)
      C = G[f], f == "children" || (f == "dangerouslySetInnerHTML" ? g = C : f === "key" || f in H || Cl(t, f, null, C, i));
    for (f in H)
      C = H[f], f == "children" ? y = C : f == "dangerouslySetInnerHTML" ? p = C : f == "value" ? R = C : f == "checked" ? J = C : f === "key" || u && typeof C != "function" || G[f] === C || Cl(t, f, C, G[f], i);
    if (p)
      u || g && (p.__html === g.__html || p.__html === t.innerHTML) || (t.innerHTML = p.__html), e.__k = [];
    else if (g && (t.innerHTML = ""), hb(t, Rh(y) ? y : [y], e, r, n, i && T !== "foreignObject", o, c, o ? o[0] : r.__k && _a(r, 0), u, l), o != null)
      for (f = o.length; f--; )
        o[f] != null && ub(o[f]);
    u || (f = "value", R !== void 0 && (R !== t[f] || T === "progress" && !R || T === "option" && R !== G[f]) && Cl(t, f, R, G[f], !1), f = "checked", J !== void 0 && J !== t[f] && Cl(t, f, J, G[f], !1));
  }
  return t;
}
function Mp(t, e, r) {
  try {
    typeof t == "function" ? t(e) : t.current = e;
  } catch (n) {
    et.__e(n, r);
  }
}
function H0(t, e, r) {
  var n, i;
  if (et.unmount && et.unmount(t), (n = t.ref) && (n.current && n.current !== t.__e || Mp(n, null, e)), (n = t.__c) != null) {
    if (n.componentWillUnmount)
      try {
        n.componentWillUnmount();
      } catch (o) {
        et.__e(o, e);
      }
    n.base = n.__P = null, t.__c = void 0;
  }
  if (n = t.__k)
    for (i = 0; i < n.length; i++)
      n[i] && H0(n[i], e, r || typeof t.type != "function");
  r || t.__e == null || ub(t.__e), t.__ = t.__e = t.__d = void 0;
}
function zR(t, e, r) {
  return this.constructor(t, r);
}
function gb(t, e, r) {
  var n, i, o, c;
  et.__ && et.__(t, e), i = (n = typeof r == "function") ? null : r && r.__k || e.__k, o = [], c = [], Ap(e, t = (!n && r || e).__k = U0(tu, null, [t]), i || Oc, Oc, e.ownerSVGElement !== void 0, !n && r ? [r] : i ? null : e.firstChild ? eu.call(e.childNodes) : null, o, !n && r ? r : i ? i.__e : e.firstChild, n, c), pb(o, t, c);
}
function mb(t, e) {
  gb(t, e, mb);
}
function VR(t, e, r) {
  var n, i, o, c, u = Xi({}, t.props);
  for (o in t.type && t.type.defaultProps && (c = t.type.defaultProps), e)
    o == "key" ? n = e[o] : o == "ref" ? i = e[o] : u[o] = e[o] === void 0 && c !== void 0 ? c[o] : e[o];
  return arguments.length > 2 && (u.children = arguments.length > 3 ? eu.call(arguments, 2) : r), Cc(t.type, u, n || t.key, i || t.ref, null);
}
function WR(t, e) {
  var r = { __c: e = "__cC" + ab++, __: t, Consumer: function(n, i) {
    return n.children(i);
  }, Provider: function(n) {
    var i, o;
    return this.getChildContext || (i = [], (o = {})[e] = this, this.getChildContext = function() {
      return o;
    }, this.shouldComponentUpdate = function(c) {
      this.props.value !== c.value && i.some(function(u) {
        u.__e = !0, j0(u);
      });
    }, this.sub = function(c) {
      i.push(c);
      var u = c.componentWillUnmount;
      c.componentWillUnmount = function() {
        i.splice(i.indexOf(c), 1), u && u.call(c);
      };
    }), n.children;
  } };
  return r.Provider.__ = r.Consumer.contextType = r;
}
eu = cb.slice, et = { __e: function(t, e, r, n) {
  for (var i, o, c; e = e.__; )
    if ((i = e.__c) && !i.__)
      try {
        if ((o = i.constructor) && o.getDerivedStateFromError != null && (i.setState(o.getDerivedStateFromError(t)), c = i.__d), i.componentDidCatch != null && (i.componentDidCatch(t, n || {}), c = i.__d), c)
          return i.__E = i;
      } catch (u) {
        t = u;
      }
  throw t;
} }, ib = 0, sb = function(t) {
  return t != null && t.constructor == null;
}, Ic.prototype.setState = function(t, e) {
  var r;
  r = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Xi({}, this.state), typeof t == "function" && (t = t(Xi({}, r), this.props)), t && Xi(r, t), t != null && this.__v && (e && this._sb.push(e), j0(this));
}, Ic.prototype.forceUpdate = function(t) {
  this.__v && (this.__e = !0, t && this.__h.push(t), j0(this));
}, Ic.prototype.render = tu, ro = [], ob = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, B0 = function(t, e) {
  return t.__v.__b - e.__v.__b;
}, Xl.__r = 0, ab = 0;
const KR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Component: Ic,
  Fragment: tu,
  cloneElement: VR,
  createContext: WR,
  createElement: U0,
  createRef: UR,
  h: U0,
  hydrate: mb,
  get isValidElement() {
    return sb;
  },
  get options() {
    return et;
  },
  render: gb,
  toChildArray: db
}, Symbol.toStringTag, { value: "Module" })), pn = /* @__PURE__ */ is(KR);
var Ah = {};
function vb(t) {
  var e, r, n = "";
  if (typeof t == "string" || typeof t == "number")
    n += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (r = vb(t[e])) && (n && (n += " "), n += r);
    else
      for (e in t)
        t[e] && (n && (n += " "), n += e);
  return n;
}
function hv() {
  for (var t, e, r = 0, n = ""; r < arguments.length; )
    (t = arguments[r++]) && (e = vb(t)) && (n && (n += " "), n += e);
  return n;
}
const GR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: hv,
  default: hv
}, Symbol.toStringTag, { value: "Module" })), ru = /* @__PURE__ */ is(GR);
var rs, Jt, kd, fv, wa = 0, yb = [], Hl = [], dv = et.__b, pv = et.__r, gv = et.diffed, mv = et.__c, vv = et.unmount;
function bo(t, e) {
  et.__h && et.__h(Jt, t, wa || e), wa = 0;
  var r = Jt.__H || (Jt.__H = { __: [], __h: [] });
  return t >= r.__.length && r.__.push({ __V: Hl }), r.__[t];
}
function _b(t) {
  return wa = 1, wb(Eb, t);
}
function wb(t, e, r) {
  var n = bo(rs++, 2);
  if (n.t = t, !n.__c && (n.__ = [r ? r(e) : Eb(void 0, e), function(u) {
    var l = n.__N ? n.__N[0] : n.__[0], f = n.t(l, u);
    l !== f && (n.__N = [f, n.__[1]], n.__c.setState({}));
  }], n.__c = Jt, !Jt.u)) {
    var i = function(u, l, f) {
      if (!n.__c.__H)
        return !0;
      var p = n.__c.__H.__.filter(function(y) {
        return y.__c;
      });
      if (p.every(function(y) {
        return !y.__N;
      }))
        return !o || o.call(this, u, l, f);
      var g = !1;
      return p.forEach(function(y) {
        if (y.__N) {
          var C = y.__[0];
          y.__ = y.__N, y.__N = void 0, C !== y.__[0] && (g = !0);
        }
      }), !(!g && n.__c.props === u) && (!o || o.call(this, u, l, f));
    };
    Jt.u = !0;
    var o = Jt.shouldComponentUpdate, c = Jt.componentWillUpdate;
    Jt.componentWillUpdate = function(u, l, f) {
      if (this.__e) {
        var p = o;
        o = void 0, i(u, l, f), o = p;
      }
      c && c.call(this, u, l, f);
    }, Jt.shouldComponentUpdate = i;
  }
  return n.__N || n.__;
}
function JR(t, e) {
  var r = bo(rs++, 3);
  !et.__s && Op(r.__H, e) && (r.__ = t, r.i = e, Jt.__H.__h.push(r));
}
function bb(t, e) {
  var r = bo(rs++, 4);
  !et.__s && Op(r.__H, e) && (r.__ = t, r.i = e, Jt.__h.push(r));
}
function QR(t) {
  return wa = 5, Dp(function() {
    return { current: t };
  }, []);
}
function ZR(t, e, r) {
  wa = 6, bb(function() {
    return typeof t == "function" ? (t(e()), function() {
      return t(null);
    }) : t ? (t.current = e(), function() {
      return t.current = null;
    }) : void 0;
  }, r == null ? r : r.concat(t));
}
function Dp(t, e) {
  var r = bo(rs++, 7);
  return Op(r.__H, e) ? (r.__V = t(), r.i = e, r.__h = t, r.__V) : r.__;
}
function YR(t, e) {
  return wa = 8, Dp(function() {
    return t;
  }, e);
}
function XR(t) {
  var e = Jt.context[t.__c], r = bo(rs++, 9);
  return r.c = t, e ? (r.__ == null && (r.__ = !0, e.sub(Jt)), e.props.value) : t.__;
}
function eA(t, e) {
  et.useDebugValue && et.useDebugValue(e ? e(t) : t);
}
function tA(t) {
  var e = bo(rs++, 10), r = _b();
  return e.__ = t, Jt.componentDidCatch || (Jt.componentDidCatch = function(n, i) {
    e.__ && e.__(n, i), r[1](n);
  }), [r[0], function() {
    r[1](void 0);
  }];
}
function rA() {
  var t = bo(rs++, 11);
  if (!t.__) {
    for (var e = Jt.__v; e !== null && !e.__m && e.__ !== null; )
      e = e.__;
    var r = e.__m || (e.__m = [0, 0]);
    t.__ = "P" + r[0] + "-" + r[1]++;
  }
  return t.__;
}
function nA() {
  for (var t; t = yb.shift(); )
    if (t.__P && t.__H)
      try {
        t.__H.__h.forEach(ql), t.__H.__h.forEach(q0), t.__H.__h = [];
      } catch (e) {
        t.__H.__h = [], et.__e(e, t.__v);
      }
}
et.__b = function(t) {
  Jt = null, dv && dv(t);
}, et.__r = function(t) {
  pv && pv(t), rs = 0;
  var e = (Jt = t.__c).__H;
  e && (kd === Jt ? (e.__h = [], Jt.__h = [], e.__.forEach(function(r) {
    r.__N && (r.__ = r.__N), r.__V = Hl, r.__N = r.i = void 0;
  })) : (e.__h.forEach(ql), e.__h.forEach(q0), e.__h = [], rs = 0)), kd = Jt;
}, et.diffed = function(t) {
  gv && gv(t);
  var e = t.__c;
  e && e.__H && (e.__H.__h.length && (yb.push(e) !== 1 && fv === et.requestAnimationFrame || ((fv = et.requestAnimationFrame) || iA)(nA)), e.__H.__.forEach(function(r) {
    r.i && (r.__H = r.i), r.__V !== Hl && (r.__ = r.__V), r.i = void 0, r.__V = Hl;
  })), kd = Jt = null;
}, et.__c = function(t, e) {
  e.some(function(r) {
    try {
      r.__h.forEach(ql), r.__h = r.__h.filter(function(n) {
        return !n.__ || q0(n);
      });
    } catch (n) {
      e.some(function(i) {
        i.__h && (i.__h = []);
      }), e = [], et.__e(n, r.__v);
    }
  }), mv && mv(t, e);
}, et.unmount = function(t) {
  vv && vv(t);
  var e, r = t.__c;
  r && r.__H && (r.__H.__.forEach(function(n) {
    try {
      ql(n);
    } catch (i) {
      e = i;
    }
  }), r.__H = void 0, e && et.__e(e, r.__v));
};
var yv = typeof requestAnimationFrame == "function";
function iA(t) {
  var e, r = function() {
    clearTimeout(n), yv && cancelAnimationFrame(e), setTimeout(t);
  }, n = setTimeout(r, 100);
  yv && (e = requestAnimationFrame(r));
}
function ql(t) {
  var e = Jt, r = t.__c;
  typeof r == "function" && (t.__c = void 0, r()), Jt = e;
}
function q0(t) {
  var e = Jt;
  t.__c = t.__(), Jt = e;
}
function Op(t, e) {
  return !t || t.length !== e.length || e.some(function(r, n) {
    return r !== t[n];
  });
}
function Eb(t, e) {
  return typeof e == "function" ? e(t) : e;
}
const sA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useCallback: YR,
  useContext: XR,
  useDebugValue: eA,
  useEffect: JR,
  useErrorBoundary: tA,
  useId: rA,
  useImperativeHandle: ZR,
  useLayoutEffect: bb,
  useMemo: Dp,
  useReducer: wb,
  useRef: QR,
  useState: _b
}, Symbol.toStringTag, { value: "Module" })), Mh = /* @__PURE__ */ is(sA);
var ba = {}, Dh = {};
Object.defineProperty(Dh, "__esModule", { value: !0 });
Dh.CloseIcon = void 0;
const _v = pn;
function oA(t) {
  return (0, _v.h)(
    "svg",
    Object.assign({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, t),
    (0, _v.h)("path", { d: "M13.7677 13L12.3535 14.4142L18.3535 20.4142L12.3535 26.4142L13.7677 27.8284L19.7677 21.8284L25.7677 27.8284L27.1819 26.4142L21.1819 20.4142L27.1819 14.4142L25.7677 13L19.7677 19L13.7677 13Z" })
  );
}
Dh.CloseIcon = oA;
var Oh = {};
Object.defineProperty(Oh, "__esModule", { value: !0 });
Oh.CoinbaseWalletRound = void 0;
const Il = pn;
function aA(t) {
  return (0, Il.h)(
    "svg",
    Object.assign({ width: "28", height: "28", viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, t),
    (0, Il.h)("circle", { cx: "14", cy: "14", r: "14", fill: "#0052FF" }),
    (0, Il.h)("path", { d: "M23.8521 14.0003C23.8521 19.455 19.455 23.8521 14.0003 23.8521C8.54559 23.8521 4.14844 19.455 4.14844 14.0003C4.14844 8.54559 8.54559 4.14844 14.0003 4.14844C19.455 4.14844 23.8521 8.54559 23.8521 14.0003Z", fill: "white" }),
    (0, Il.h)("path", { d: "M11.1855 12.5042C11.1855 12.0477 11.1855 11.7942 11.2835 11.642C11.3814 11.4899 11.4793 11.3377 11.6261 11.287C11.8219 11.1855 12.0178 11.1855 12.5073 11.1855H15.4934C15.983 11.1855 16.1788 11.1855 16.3746 11.287C16.5215 11.3884 16.6683 11.4899 16.7173 11.642C16.8152 11.8449 16.8152 12.0477 16.8152 12.5042V15.4965C16.8152 15.953 16.8152 16.2066 16.7173 16.3587C16.6194 16.5109 16.5215 16.663 16.3746 16.7137C16.1788 16.8152 15.983 16.8152 15.4934 16.8152H12.5073C12.0178 16.8152 11.8219 16.8152 11.6261 16.7137C11.4793 16.6123 11.3324 16.5109 11.2835 16.3587C11.1855 16.1558 11.1855 15.953 11.1855 15.4965V12.5042Z", fill: "#0052FF" })
  );
}
Oh.CoinbaseWalletRound = aA;
var Ph = {};
Object.defineProperty(Ph, "__esModule", { value: !0 });
Ph.QRCodeIcon = void 0;
const ac = pn;
function cA(t) {
  return (0, ac.h)(
    "svg",
    Object.assign({ width: "18", height: "18", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, t),
    (0, ac.h)("path", { d: "M3 3V8.99939L5 8.99996V5H9V3H3Z" }),
    (0, ac.h)("path", { d: "M15 21L21 21V15.0006L19 15V19L15 19V21Z" }),
    (0, ac.h)("path", { d: "M21 9H19V5H15.0006L15 3H21V9Z" }),
    (0, ac.h)("path", { d: "M3 15V21H8.99939L8.99996 19H5L5 15H3Z" })
  );
}
Ph.QRCodeIcon = cA;
var Th = {};
function Sb(t) {
  this.mode = Sn.MODE_8BIT_BYTE, this.data = t, this.parsedData = [];
  for (var e = 0, r = this.data.length; e < r; e++) {
    var n = [], i = this.data.charCodeAt(e);
    i > 65536 ? (n[0] = 240 | (i & 1835008) >>> 18, n[1] = 128 | (i & 258048) >>> 12, n[2] = 128 | (i & 4032) >>> 6, n[3] = 128 | i & 63) : i > 2048 ? (n[0] = 224 | (i & 61440) >>> 12, n[1] = 128 | (i & 4032) >>> 6, n[2] = 128 | i & 63) : i > 128 ? (n[0] = 192 | (i & 1984) >>> 6, n[1] = 128 | i & 63) : n[0] = i, this.parsedData.push(n);
  }
  this.parsedData = Array.prototype.concat.apply([], this.parsedData), this.parsedData.length != this.data.length && (this.parsedData.unshift(191), this.parsedData.unshift(187), this.parsedData.unshift(239));
}
Sb.prototype = {
  getLength: function(t) {
    return this.parsedData.length;
  },
  write: function(t) {
    for (var e = 0, r = this.parsedData.length; e < r; e++)
      t.put(this.parsedData[e], 8);
  }
};
function Mi(t, e) {
  this.typeNumber = t, this.errorCorrectLevel = e, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
}
Mi.prototype = { addData: function(t) {
  var e = new Sb(t);
  this.dataList.push(e), this.dataCache = null;
}, isDark: function(t, e) {
  if (t < 0 || this.moduleCount <= t || e < 0 || this.moduleCount <= e)
    throw new Error(t + "," + e);
  return this.modules[t][e];
}, getModuleCount: function() {
  return this.moduleCount;
}, make: function() {
  this.makeImpl(!1, this.getBestMaskPattern());
}, makeImpl: function(t, e) {
  this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
  for (var r = 0; r < this.moduleCount; r++) {
    this.modules[r] = new Array(this.moduleCount);
    for (var n = 0; n < this.moduleCount; n++)
      this.modules[r][n] = null;
  }
  this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(t, e), this.typeNumber >= 7 && this.setupTypeNumber(t), this.dataCache == null && (this.dataCache = Mi.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, e);
}, setupPositionProbePattern: function(t, e) {
  for (var r = -1; r <= 7; r++)
    if (!(t + r <= -1 || this.moduleCount <= t + r))
      for (var n = -1; n <= 7; n++)
        e + n <= -1 || this.moduleCount <= e + n || (0 <= r && r <= 6 && (n == 0 || n == 6) || 0 <= n && n <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= n && n <= 4 ? this.modules[t + r][e + n] = !0 : this.modules[t + r][e + n] = !1);
}, getBestMaskPattern: function() {
  for (var t = 0, e = 0, r = 0; r < 8; r++) {
    this.makeImpl(!0, r);
    var n = nr.getLostPoint(this);
    (r == 0 || t > n) && (t = n, e = r);
  }
  return e;
}, createMovieClip: function(t, e, r) {
  var n = t.createEmptyMovieClip(e, r), i = 1;
  this.make();
  for (var o = 0; o < this.modules.length; o++)
    for (var c = o * i, u = 0; u < this.modules[o].length; u++) {
      var l = u * i, f = this.modules[o][u];
      f && (n.beginFill(0, 100), n.moveTo(l, c), n.lineTo(l + i, c), n.lineTo(l + i, c + i), n.lineTo(l, c + i), n.endFill());
    }
  return n;
}, setupTimingPattern: function() {
  for (var t = 8; t < this.moduleCount - 8; t++)
    this.modules[t][6] == null && (this.modules[t][6] = t % 2 == 0);
  for (var e = 8; e < this.moduleCount - 8; e++)
    this.modules[6][e] == null && (this.modules[6][e] = e % 2 == 0);
}, setupPositionAdjustPattern: function() {
  for (var t = nr.getPatternPosition(this.typeNumber), e = 0; e < t.length; e++)
    for (var r = 0; r < t.length; r++) {
      var n = t[e], i = t[r];
      if (this.modules[n][i] == null)
        for (var o = -2; o <= 2; o++)
          for (var c = -2; c <= 2; c++)
            o == -2 || o == 2 || c == -2 || c == 2 || o == 0 && c == 0 ? this.modules[n + o][i + c] = !0 : this.modules[n + o][i + c] = !1;
    }
}, setupTypeNumber: function(t) {
  for (var e = nr.getBCHTypeNumber(this.typeNumber), r = 0; r < 18; r++) {
    var n = !t && (e >> r & 1) == 1;
    this.modules[Math.floor(r / 3)][r % 3 + this.moduleCount - 8 - 3] = n;
  }
  for (var r = 0; r < 18; r++) {
    var n = !t && (e >> r & 1) == 1;
    this.modules[r % 3 + this.moduleCount - 8 - 3][Math.floor(r / 3)] = n;
  }
}, setupTypeInfo: function(t, e) {
  for (var r = this.errorCorrectLevel << 3 | e, n = nr.getBCHTypeInfo(r), i = 0; i < 15; i++) {
    var o = !t && (n >> i & 1) == 1;
    i < 6 ? this.modules[i][8] = o : i < 8 ? this.modules[i + 1][8] = o : this.modules[this.moduleCount - 15 + i][8] = o;
  }
  for (var i = 0; i < 15; i++) {
    var o = !t && (n >> i & 1) == 1;
    i < 8 ? this.modules[8][this.moduleCount - i - 1] = o : i < 9 ? this.modules[8][15 - i - 1 + 1] = o : this.modules[8][15 - i - 1] = o;
  }
  this.modules[this.moduleCount - 8][8] = !t;
}, mapData: function(t, e) {
  for (var r = -1, n = this.moduleCount - 1, i = 7, o = 0, c = this.moduleCount - 1; c > 0; c -= 2)
    for (c == 6 && c--; ; ) {
      for (var u = 0; u < 2; u++)
        if (this.modules[n][c - u] == null) {
          var l = !1;
          o < t.length && (l = (t[o] >>> i & 1) == 1);
          var f = nr.getMask(e, n, c - u);
          f && (l = !l), this.modules[n][c - u] = l, i--, i == -1 && (o++, i = 7);
        }
      if (n += r, n < 0 || this.moduleCount <= n) {
        n -= r, r = -r;
        break;
      }
    }
} };
Mi.PAD0 = 236;
Mi.PAD1 = 17;
Mi.createData = function(t, e, r) {
  for (var n = Ai.getRSBlocks(t, e), i = new Cb(), o = 0; o < r.length; o++) {
    var c = r[o];
    i.put(c.mode, 4), i.put(c.getLength(), nr.getLengthInBits(c.mode, t)), c.write(i);
  }
  for (var u = 0, o = 0; o < n.length; o++)
    u += n[o].dataCount;
  if (i.getLengthInBits() > u * 8)
    throw new Error("code length overflow. (" + i.getLengthInBits() + ">" + u * 8 + ")");
  for (i.getLengthInBits() + 4 <= u * 8 && i.put(0, 4); i.getLengthInBits() % 8 != 0; )
    i.putBit(!1);
  for (; !(i.getLengthInBits() >= u * 8 || (i.put(Mi.PAD0, 8), i.getLengthInBits() >= u * 8)); )
    i.put(Mi.PAD1, 8);
  return Mi.createBytes(i, n);
};
Mi.createBytes = function(t, e) {
  for (var r = 0, n = 0, i = 0, o = new Array(e.length), c = new Array(e.length), u = 0; u < e.length; u++) {
    var l = e[u].dataCount, f = e[u].totalCount - l;
    n = Math.max(n, l), i = Math.max(i, f), o[u] = new Array(l);
    for (var p = 0; p < o[u].length; p++)
      o[u][p] = 255 & t.buffer[p + r];
    r += l;
    var g = nr.getErrorCorrectPolynomial(f), y = new aa(o[u], g.getLength() - 1), C = y.mod(g);
    c[u] = new Array(g.getLength() - 1);
    for (var p = 0; p < c[u].length; p++) {
      var R = p + C.getLength() - c[u].length;
      c[u][p] = R >= 0 ? C.get(R) : 0;
    }
  }
  for (var J = 0, p = 0; p < e.length; p++)
    J += e[p].totalCount;
  for (var G = new Array(J), H = 0, p = 0; p < n; p++)
    for (var u = 0; u < e.length; u++)
      p < o[u].length && (G[H++] = o[u][p]);
  for (var p = 0; p < i; p++)
    for (var u = 0; u < e.length; u++)
      p < c[u].length && (G[H++] = c[u][p]);
  return G;
};
var Sn = { MODE_NUMBER: 1, MODE_ALPHA_NUM: 2, MODE_8BIT_BYTE: 4, MODE_KANJI: 8 }, Ss = { L: 1, M: 0, Q: 3, H: 2 }, _s = { PATTERN000: 0, PATTERN001: 1, PATTERN010: 2, PATTERN011: 3, PATTERN100: 4, PATTERN101: 5, PATTERN110: 6, PATTERN111: 7 }, nr = { PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], G15: 1335, G18: 7973, G15_MASK: 21522, getBCHTypeInfo: function(t) {
  for (var e = t << 10; nr.getBCHDigit(e) - nr.getBCHDigit(nr.G15) >= 0; )
    e ^= nr.G15 << nr.getBCHDigit(e) - nr.getBCHDigit(nr.G15);
  return (t << 10 | e) ^ nr.G15_MASK;
}, getBCHTypeNumber: function(t) {
  for (var e = t << 12; nr.getBCHDigit(e) - nr.getBCHDigit(nr.G18) >= 0; )
    e ^= nr.G18 << nr.getBCHDigit(e) - nr.getBCHDigit(nr.G18);
  return t << 12 | e;
}, getBCHDigit: function(t) {
  for (var e = 0; t != 0; )
    e++, t >>>= 1;
  return e;
}, getPatternPosition: function(t) {
  return nr.PATTERN_POSITION_TABLE[t - 1];
}, getMask: function(t, e, r) {
  switch (t) {
    case _s.PATTERN000:
      return (e + r) % 2 == 0;
    case _s.PATTERN001:
      return e % 2 == 0;
    case _s.PATTERN010:
      return r % 3 == 0;
    case _s.PATTERN011:
      return (e + r) % 3 == 0;
    case _s.PATTERN100:
      return (Math.floor(e / 2) + Math.floor(r / 3)) % 2 == 0;
    case _s.PATTERN101:
      return e * r % 2 + e * r % 3 == 0;
    case _s.PATTERN110:
      return (e * r % 2 + e * r % 3) % 2 == 0;
    case _s.PATTERN111:
      return (e * r % 3 + (e + r) % 2) % 2 == 0;
    default:
      throw new Error("bad maskPattern:" + t);
  }
}, getErrorCorrectPolynomial: function(t) {
  for (var e = new aa([1], 0), r = 0; r < t; r++)
    e = e.multiply(new aa([1, xr.gexp(r)], 0));
  return e;
}, getLengthInBits: function(t, e) {
  if (1 <= e && e < 10)
    switch (t) {
      case Sn.MODE_NUMBER:
        return 10;
      case Sn.MODE_ALPHA_NUM:
        return 9;
      case Sn.MODE_8BIT_BYTE:
        return 8;
      case Sn.MODE_KANJI:
        return 8;
      default:
        throw new Error("mode:" + t);
    }
  else if (e < 27)
    switch (t) {
      case Sn.MODE_NUMBER:
        return 12;
      case Sn.MODE_ALPHA_NUM:
        return 11;
      case Sn.MODE_8BIT_BYTE:
        return 16;
      case Sn.MODE_KANJI:
        return 10;
      default:
        throw new Error("mode:" + t);
    }
  else if (e < 41)
    switch (t) {
      case Sn.MODE_NUMBER:
        return 14;
      case Sn.MODE_ALPHA_NUM:
        return 13;
      case Sn.MODE_8BIT_BYTE:
        return 16;
      case Sn.MODE_KANJI:
        return 12;
      default:
        throw new Error("mode:" + t);
    }
  else
    throw new Error("type:" + e);
}, getLostPoint: function(t) {
  for (var e = t.getModuleCount(), r = 0, n = 0; n < e; n++)
    for (var i = 0; i < e; i++) {
      for (var o = 0, c = t.isDark(n, i), u = -1; u <= 1; u++)
        if (!(n + u < 0 || e <= n + u))
          for (var l = -1; l <= 1; l++)
            i + l < 0 || e <= i + l || u == 0 && l == 0 || c == t.isDark(n + u, i + l) && o++;
      o > 5 && (r += 3 + o - 5);
    }
  for (var n = 0; n < e - 1; n++)
    for (var i = 0; i < e - 1; i++) {
      var f = 0;
      t.isDark(n, i) && f++, t.isDark(n + 1, i) && f++, t.isDark(n, i + 1) && f++, t.isDark(n + 1, i + 1) && f++, (f == 0 || f == 4) && (r += 3);
    }
  for (var n = 0; n < e; n++)
    for (var i = 0; i < e - 6; i++)
      t.isDark(n, i) && !t.isDark(n, i + 1) && t.isDark(n, i + 2) && t.isDark(n, i + 3) && t.isDark(n, i + 4) && !t.isDark(n, i + 5) && t.isDark(n, i + 6) && (r += 40);
  for (var i = 0; i < e; i++)
    for (var n = 0; n < e - 6; n++)
      t.isDark(n, i) && !t.isDark(n + 1, i) && t.isDark(n + 2, i) && t.isDark(n + 3, i) && t.isDark(n + 4, i) && !t.isDark(n + 5, i) && t.isDark(n + 6, i) && (r += 40);
  for (var p = 0, i = 0; i < e; i++)
    for (var n = 0; n < e; n++)
      t.isDark(n, i) && p++;
  var g = Math.abs(100 * p / e / e - 50) / 5;
  return r += g * 10, r;
} }, xr = { glog: function(t) {
  if (t < 1)
    throw new Error("glog(" + t + ")");
  return xr.LOG_TABLE[t];
}, gexp: function(t) {
  for (; t < 0; )
    t += 255;
  for (; t >= 256; )
    t -= 255;
  return xr.EXP_TABLE[t];
}, EXP_TABLE: new Array(256), LOG_TABLE: new Array(256) };
for (var Or = 0; Or < 8; Or++)
  xr.EXP_TABLE[Or] = 1 << Or;
for (var Or = 8; Or < 256; Or++)
  xr.EXP_TABLE[Or] = xr.EXP_TABLE[Or - 4] ^ xr.EXP_TABLE[Or - 5] ^ xr.EXP_TABLE[Or - 6] ^ xr.EXP_TABLE[Or - 8];
for (var Or = 0; Or < 255; Or++)
  xr.LOG_TABLE[xr.EXP_TABLE[Or]] = Or;
function aa(t, e) {
  if (t.length == null)
    throw new Error(t.length + "/" + e);
  for (var r = 0; r < t.length && t[r] == 0; )
    r++;
  this.num = new Array(t.length - r + e);
  for (var n = 0; n < t.length - r; n++)
    this.num[n] = t[n + r];
}
aa.prototype = { get: function(t) {
  return this.num[t];
}, getLength: function() {
  return this.num.length;
}, multiply: function(t) {
  for (var e = new Array(this.getLength() + t.getLength() - 1), r = 0; r < this.getLength(); r++)
    for (var n = 0; n < t.getLength(); n++)
      e[r + n] ^= xr.gexp(xr.glog(this.get(r)) + xr.glog(t.get(n)));
  return new aa(e, 0);
}, mod: function(t) {
  if (this.getLength() - t.getLength() < 0)
    return this;
  for (var e = xr.glog(this.get(0)) - xr.glog(t.get(0)), r = new Array(this.getLength()), n = 0; n < this.getLength(); n++)
    r[n] = this.get(n);
  for (var n = 0; n < t.getLength(); n++)
    r[n] ^= xr.gexp(xr.glog(t.get(n)) + e);
  return new aa(r, 0).mod(t);
} };
function Ai(t, e) {
  this.totalCount = t, this.dataCount = e;
}
Ai.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];
Ai.getRSBlocks = function(t, e) {
  var r = Ai.getRsBlockTable(t, e);
  if (r == null)
    throw new Error("bad rs block @ typeNumber:" + t + "/errorCorrectLevel:" + e);
  for (var n = r.length / 3, i = [], o = 0; o < n; o++)
    for (var c = r[o * 3 + 0], u = r[o * 3 + 1], l = r[o * 3 + 2], f = 0; f < c; f++)
      i.push(new Ai(u, l));
  return i;
};
Ai.getRsBlockTable = function(t, e) {
  switch (e) {
    case Ss.L:
      return Ai.RS_BLOCK_TABLE[(t - 1) * 4 + 0];
    case Ss.M:
      return Ai.RS_BLOCK_TABLE[(t - 1) * 4 + 1];
    case Ss.Q:
      return Ai.RS_BLOCK_TABLE[(t - 1) * 4 + 2];
    case Ss.H:
      return Ai.RS_BLOCK_TABLE[(t - 1) * 4 + 3];
    default:
      return;
  }
};
function Cb() {
  this.buffer = [], this.length = 0;
}
Cb.prototype = { get: function(t) {
  var e = Math.floor(t / 8);
  return (this.buffer[e] >>> 7 - t % 8 & 1) == 1;
}, put: function(t, e) {
  for (var r = 0; r < e; r++)
    this.putBit((t >>> e - r - 1 & 1) == 1);
}, getLengthInBits: function() {
  return this.length;
}, putBit: function(t) {
  var e = Math.floor(this.length / 8);
  this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
} };
var Ld = [[17, 14, 11, 7], [32, 26, 20, 14], [53, 42, 32, 24], [78, 62, 46, 34], [106, 84, 60, 44], [134, 106, 74, 58], [154, 122, 86, 64], [192, 152, 108, 84], [230, 180, 130, 98], [271, 213, 151, 119], [321, 251, 177, 137], [367, 287, 203, 155], [425, 331, 241, 177], [458, 362, 258, 194], [520, 412, 292, 220], [586, 450, 322, 250], [644, 504, 364, 280], [718, 560, 394, 310], [792, 624, 442, 338], [858, 666, 482, 382], [929, 711, 509, 403], [1003, 779, 565, 439], [1091, 857, 611, 461], [1171, 911, 661, 511], [1273, 997, 715, 535], [1367, 1059, 751, 593], [1465, 1125, 805, 625], [1528, 1190, 868, 658], [1628, 1264, 908, 698], [1732, 1370, 982, 742], [1840, 1452, 1030, 790], [1952, 1538, 1112, 842], [2068, 1628, 1168, 898], [2188, 1722, 1228, 958], [2303, 1809, 1283, 983], [2431, 1911, 1351, 1051], [2563, 1989, 1423, 1093], [2699, 2099, 1499, 1139], [2809, 2213, 1579, 1219], [2953, 2331, 1663, 1273]];
function Ib(t) {
  if (this.options = {
    padding: 4,
    width: 256,
    height: 256,
    typeNumber: 4,
    color: "#000000",
    background: "#ffffff",
    ecl: "M",
    image: {
      svg: "",
      width: 0,
      height: 0
    }
  }, typeof t == "string" && (t = {
    content: t
  }), t)
    for (var e in t)
      this.options[e] = t[e];
  if (typeof this.options.content != "string")
    throw new Error("Expected 'content' as string!");
  if (this.options.content.length === 0)
    throw new Error("Expected 'content' to be non-empty!");
  if (!(this.options.padding >= 0))
    throw new Error("Expected 'padding' value to be non-negative!");
  if (!(this.options.width > 0) || !(this.options.height > 0))
    throw new Error("Expected 'width' or 'height' value to be higher than zero!");
  function r(l) {
    switch (l) {
      case "L":
        return Ss.L;
      case "M":
        return Ss.M;
      case "Q":
        return Ss.Q;
      case "H":
        return Ss.H;
      default:
        throw new Error("Unknwon error correction level: " + l);
    }
  }
  function n(l, f) {
    for (var p = i(l), g = 1, y = 0, C = 0, R = Ld.length; C <= R; C++) {
      var J = Ld[C];
      if (!J)
        throw new Error("Content too long: expected " + y + " but got " + p);
      switch (f) {
        case "L":
          y = J[0];
          break;
        case "M":
          y = J[1];
          break;
        case "Q":
          y = J[2];
          break;
        case "H":
          y = J[3];
          break;
        default:
          throw new Error("Unknwon error correction level: " + f);
      }
      if (p <= y)
        break;
      g++;
    }
    if (g > Ld.length)
      throw new Error("Content too long");
    return g;
  }
  function i(l) {
    var f = encodeURI(l).toString().replace(/\%[0-9a-fA-F]{2}/g, "a");
    return f.length + (f.length != l ? 3 : 0);
  }
  var o = this.options.content, c = n(o, this.options.ecl), u = r(this.options.ecl);
  this.qrcode = new Mi(c, u), this.qrcode.addData(o), this.qrcode.make();
}
Ib.prototype.svg = function(t) {
  var e = this.options || {}, r = this.qrcode.modules;
  typeof t > "u" && (t = { container: e.container || "svg" });
  for (var n = typeof e.pretty < "u" ? !!e.pretty : !0, i = n ? "  " : "", o = n ? `\r
` : "", c = e.width, u = e.height, l = r.length, f = c / (l + 2 * e.padding), p = u / (l + 2 * e.padding), g = typeof e.join < "u" ? !!e.join : !1, y = typeof e.swap < "u" ? !!e.swap : !1, C = typeof e.xmlDeclaration < "u" ? !!e.xmlDeclaration : !0, R = typeof e.predefined < "u" ? !!e.predefined : !1, J = R ? i + '<defs><path id="qrmodule" d="M0 0 h' + p + " v" + f + ' H0 z" style="fill:' + e.color + ';shape-rendering:crispEdges;" /></defs>' + o : "", G = i + '<rect x="0" y="0" width="' + c + '" height="' + u + '" style="fill:' + e.background + ';shape-rendering:crispEdges;"/>' + o, H = "", T = "", q = 0; q < l; q++)
    for (var B = 0; B < l; B++) {
      var L = r[B][q];
      if (L) {
        var P = B * f + e.padding * f, v = q * p + e.padding * p;
        if (y) {
          var N = P;
          P = v, v = N;
        }
        if (g) {
          var ie = f + P, le = p + v;
          P = Number.isInteger(P) ? Number(P) : P.toFixed(2), v = Number.isInteger(v) ? Number(v) : v.toFixed(2), ie = Number.isInteger(ie) ? Number(ie) : ie.toFixed(2), le = Number.isInteger(le) ? Number(le) : le.toFixed(2), T += "M" + P + "," + v + " V" + le + " H" + ie + " V" + v + " H" + P + " Z ";
        } else
          R ? H += i + '<use x="' + P.toString() + '" y="' + v.toString() + '" href="#qrmodule" />' + o : H += i + '<rect x="' + P.toString() + '" y="' + v.toString() + '" width="' + f + '" height="' + p + '" style="fill:' + e.color + ';shape-rendering:crispEdges;"/>' + o;
      }
    }
  g && (H = i + '<path x="0" y="0" style="fill:' + e.color + ';shape-rendering:crispEdges;" d="' + T + '" />');
  let he = "";
  if (this.options.image !== void 0 && this.options.image.svg) {
    const k = c * this.options.image.width / 100, h = u * this.options.image.height / 100, m = c / 2 - k / 2, x = u / 2 - h / 2;
    he += `<svg x="${m}" y="${x}" width="${k}" height="${h}" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">`, he += this.options.image.svg + o, he += "</svg>";
  }
  var ye = "";
  switch (t.container) {
    case "svg":
      C && (ye += '<?xml version="1.0" standalone="yes"?>' + o), ye += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + c + '" height="' + u + '">' + o, ye += J + G + H, ye += he, ye += "</svg>";
      break;
    case "svg-viewbox":
      C && (ye += '<?xml version="1.0" standalone="yes"?>' + o), ye += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + c + " " + u + '">' + o, ye += J + G + H, ye += he, ye += "</svg>";
      break;
    case "g":
      ye += '<g width="' + c + '" height="' + u + '">' + o, ye += J + G + H, ye += he, ye += "</g>";
      break;
    default:
      ye += (J + G + H + he).replace(/^\s+/, "");
      break;
  }
  return ye;
};
var uA = Ib, lA = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Th, "__esModule", { value: !0 });
Th.QRCode = void 0;
const hA = pn, wv = Mh, fA = lA(uA), dA = (t) => {
  const [e, r] = (0, wv.useState)("");
  return (0, wv.useEffect)(() => {
    var n, i;
    const o = new fA.default({
      content: t.content,
      background: t.bgColor || "#ffffff",
      color: t.fgColor || "#000000",
      container: "svg",
      ecl: "M",
      width: (n = t.width) !== null && n !== void 0 ? n : 256,
      height: (i = t.height) !== null && i !== void 0 ? i : 256,
      padding: 0,
      image: t.image
    }), c = Buffer.from(o.svg(), "utf8").toString("base64");
    r(`data:image/svg+xml;base64,${c}`);
  }, [t.bgColor, t.content, t.fgColor, t.height, t.image, t.width]), e ? (0, hA.h)("img", { src: e, alt: "QR Code" }) : null;
};
Th.QRCode = dA;
var Nh = {}, Pp = {};
Object.defineProperty(Pp, "__esModule", { value: !0 });
Pp.default = ".-cbwsdk-css-reset .-cbwsdk-spinner{display:inline-block}.-cbwsdk-css-reset .-cbwsdk-spinner svg{display:inline-block;animation:2s linear infinite -cbwsdk-spinner-svg}.-cbwsdk-css-reset .-cbwsdk-spinner svg circle{animation:1.9s ease-in-out infinite both -cbwsdk-spinner-circle;display:block;fill:rgba(0,0,0,0);stroke-dasharray:283;stroke-dashoffset:280;stroke-linecap:round;stroke-width:10px;transform-origin:50% 50%}@keyframes -cbwsdk-spinner-svg{0%{transform:rotateZ(0deg)}100%{transform:rotateZ(360deg)}}@keyframes -cbwsdk-spinner-circle{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}100%{stroke-dashoffset:280;transform:rotate(360deg)}}";
var pA = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Nh, "__esModule", { value: !0 });
Nh.Spinner = void 0;
const xl = pn, gA = pA(Pp), mA = (t) => {
  var e;
  const r = (e = t.size) !== null && e !== void 0 ? e : 64, n = t.color || "#000";
  return (0, xl.h)(
    "div",
    { class: "-cbwsdk-spinner" },
    (0, xl.h)("style", null, gA.default),
    (0, xl.h)(
      "svg",
      { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", style: { width: r, height: r } },
      (0, xl.h)("circle", { style: { cx: 50, cy: 50, r: 45, stroke: n } })
    )
  );
};
Nh.Spinner = mA;
var Tp = {};
Object.defineProperty(Tp, "__esModule", { value: !0 });
Tp.default = ".-cbwsdk-css-reset .-cbwsdk-connect-content{height:430px;width:700px;border-radius:12px;padding:30px}.-cbwsdk-css-reset .-cbwsdk-connect-content.light{background:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content.dark{background:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-content-header{display:flex;align-items:center;justify-content:space-between;margin:0 0 30px}.-cbwsdk-css-reset .-cbwsdk-connect-content-heading{font-style:normal;font-weight:500;font-size:28px;line-height:36px;margin:0}.-cbwsdk-css-reset .-cbwsdk-connect-content-heading.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-content-heading.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content-layout{display:flex;flex-direction:row}.-cbwsdk-css-reset .-cbwsdk-connect-content-column-left{margin-right:30px;display:flex;flex-direction:column;justify-content:space-between}.-cbwsdk-css-reset .-cbwsdk-connect-content-column-right{flex:25%;margin-right:34px}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-wrapper{width:220px;height:220px;border-radius:12px;display:flex;justify-content:center;align-items:center;background:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting{position:absolute;top:0;bottom:0;left:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.light{background-color:rgba(255,255,255,.95)}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.light>p{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.dark{background-color:rgba(10,11,13,.9)}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.dark>p{color:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting>p{font-size:12px;font-weight:bold;margin-top:16px}.-cbwsdk-css-reset .-cbwsdk-connect-content-update-app{border-radius:8px;font-size:14px;line-height:20px;padding:12px;width:339px}.-cbwsdk-css-reset .-cbwsdk-connect-content-update-app.light{background:#eef0f3;color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-connect-content-update-app.dark{background:#1e2025;color:#8a919e}.-cbwsdk-css-reset .-cbwsdk-cancel-button{-webkit-appearance:none;border:none;background:none;cursor:pointer;padding:0;margin:0}.-cbwsdk-css-reset .-cbwsdk-cancel-button-x{position:relative;display:block;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-wallet-steps{padding:0 0 0 16px;margin:0;width:100%;list-style:decimal}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item{list-style-type:decimal;display:list-item;font-style:normal;font-weight:400;font-size:16px;line-height:24px;margin-top:20px}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item-wrapper{display:flex;align-items:center}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-pad-left{margin-left:6px}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon{display:flex;border-radius:50%;height:24px;width:24px}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon svg{margin:auto;display:block}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon.light{background:#0052ff}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon.dark{background:#588af5}.-cbwsdk-css-reset .-cbwsdk-connect-item{align-items:center;display:flex;flex-direction:row;padding:16px 24px;gap:12px;cursor:pointer;border-radius:100px;font-weight:600}.-cbwsdk-css-reset .-cbwsdk-connect-item.light{background:#f5f8ff;color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-connect-item.dark{background:#001033;color:#588af5}.-cbwsdk-css-reset .-cbwsdk-connect-item-copy-wrapper{margin:0 4px 0 8px}.-cbwsdk-css-reset .-cbwsdk-connect-item-title{margin:0 0 0;font-size:16px;line-height:24px;font-weight:500}.-cbwsdk-css-reset .-cbwsdk-connect-item-description{font-weight:400;font-size:14px;line-height:20px;margin:0}";
var xb = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(ba, "__esModule", { value: !0 });
ba.CoinbaseWalletSteps = ba.ConnectContent = void 0;
const fo = xb(ru), Rt = pn, vA = $e, yA = Aa, _A = Dh, wA = Oh, bA = Ph, EA = Th, SA = Nh, CA = xb(Tp), $d = {
  title: "Coinbase Wallet app",
  description: "Connect with your self-custody wallet",
  steps: Rb
}, IA = (t) => t === "light" ? "#FFFFFF" : "#0A0B0D";
function xA(t) {
  const { theme: e } = t, r = (0, vA.createQrUrl)(t.sessionId, t.sessionSecret, t.linkAPIUrl, t.isParentConnection, t.version, t.chainId), n = $d.steps;
  return (0, Rt.h)(
    "div",
    { "data-testid": "connect-content", className: (0, fo.default)("-cbwsdk-connect-content", e) },
    (0, Rt.h)("style", null, CA.default),
    (0, Rt.h)(
      "div",
      { className: "-cbwsdk-connect-content-header" },
      (0, Rt.h)("h2", { className: (0, fo.default)("-cbwsdk-connect-content-heading", e) }, "Scan to connect with our mobile app"),
      t.onCancel && (0, Rt.h)(
        "button",
        { type: "button", className: "-cbwsdk-cancel-button", onClick: t.onCancel },
        (0, Rt.h)(_A.CloseIcon, { fill: e === "light" ? "#0A0B0D" : "#FFFFFF" })
      )
    ),
    (0, Rt.h)(
      "div",
      { className: "-cbwsdk-connect-content-layout" },
      (0, Rt.h)(
        "div",
        { className: "-cbwsdk-connect-content-column-left" },
        (0, Rt.h)(RA, { title: $d.title, description: $d.description, theme: e })
      ),
      (0, Rt.h)(
        "div",
        { className: "-cbwsdk-connect-content-column-right" },
        (0, Rt.h)(
          "div",
          { className: "-cbwsdk-connect-content-qr-wrapper" },
          (0, Rt.h)(EA.QRCode, { content: r, width: 200, height: 200, fgColor: "#000", bgColor: "transparent" }),
          (0, Rt.h)("input", { type: "hidden", name: "cbw-cbwsdk-version", value: yA.LIB_VERSION }),
          (0, Rt.h)("input", { type: "hidden", value: r })
        ),
        (0, Rt.h)(n, { theme: e }),
        !t.isConnected && (0, Rt.h)(
          "div",
          { "data-testid": "connecting-spinner", className: (0, fo.default)("-cbwsdk-connect-content-qr-connecting", e) },
          (0, Rt.h)(SA.Spinner, { size: 36, color: e === "dark" ? "#FFF" : "#000" }),
          (0, Rt.h)("p", null, "Connecting...")
        )
      )
    )
  );
}
ba.ConnectContent = xA;
function RA({ title: t, description: e, theme: r }) {
  return (0, Rt.h)(
    "div",
    { className: (0, fo.default)("-cbwsdk-connect-item", r) },
    (0, Rt.h)(
      "div",
      null,
      (0, Rt.h)(wA.CoinbaseWalletRound, null)
    ),
    (0, Rt.h)(
      "div",
      { className: "-cbwsdk-connect-item-copy-wrapper" },
      (0, Rt.h)("h3", { className: "-cbwsdk-connect-item-title" }, t),
      (0, Rt.h)("p", { className: "-cbwsdk-connect-item-description" }, e)
    )
  );
}
function Rb({ theme: t }) {
  return (0, Rt.h)(
    "ol",
    { className: "-cbwsdk-wallet-steps" },
    (0, Rt.h)(
      "li",
      { className: (0, fo.default)("-cbwsdk-wallet-steps-item", t) },
      (0, Rt.h)("div", { className: "-cbwsdk-wallet-steps-item-wrapper" }, "Open Coinbase Wallet app")
    ),
    (0, Rt.h)(
      "li",
      { className: (0, fo.default)("-cbwsdk-wallet-steps-item", t) },
      (0, Rt.h)(
        "div",
        { className: "-cbwsdk-wallet-steps-item-wrapper" },
        (0, Rt.h)(
          "span",
          null,
          "Tap ",
          (0, Rt.h)("strong", null, "Scan"),
          " "
        ),
        (0, Rt.h)(
          "span",
          { className: (0, fo.default)("-cbwsdk-wallet-steps-pad-left", "-cbwsdk-wallet-steps-icon", t) },
          (0, Rt.h)(bA.QRCodeIcon, { fill: IA(t) })
        )
      )
    )
  );
}
ba.CoinbaseWalletSteps = Rb;
var kh = {}, Lh = {};
Object.defineProperty(Lh, "__esModule", { value: !0 });
Lh.ArrowLeftIcon = void 0;
const bv = pn;
function AA(t) {
  return (0, bv.h)(
    "svg",
    Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, t),
    (0, bv.h)("path", { d: "M8.60675 0.155884L7.37816 1.28209L12.7723 7.16662H0V8.83328H12.6548L6.82149 14.6666L8 15.8451L15.8201 8.02501L8.60675 0.155884Z" })
  );
}
Lh.ArrowLeftIcon = AA;
var $h = {};
Object.defineProperty($h, "__esModule", { value: !0 });
$h.LaptopIcon = void 0;
const Fd = pn;
function MA(t) {
  return (0, Fd.h)(
    "svg",
    Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, t),
    (0, Fd.h)("path", { d: "M1.8001 2.2002H12.2001V9.40019H1.8001V2.2002ZM3.4001 3.8002V7.80019H10.6001V3.8002H3.4001Z" }),
    (0, Fd.h)("path", { d: "M13.4001 10.2002H0.600098C0.600098 11.0838 1.31644 11.8002 2.2001 11.8002H11.8001C12.6838 11.8002 13.4001 11.0838 13.4001 10.2002Z" })
  );
}
$h.LaptopIcon = MA;
var Fh = {};
Object.defineProperty(Fh, "__esModule", { value: !0 });
Fh.SafeIcon = void 0;
const Ev = pn;
function DA(t) {
  return (0, Ev.h)(
    "svg",
    Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, t),
    (0, Ev.h)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M0.600098 0.600098V11.8001H13.4001V0.600098H0.600098ZM7.0001 9.2001C5.3441 9.2001 4.0001 7.8561 4.0001 6.2001C4.0001 4.5441 5.3441 3.2001 7.0001 3.2001C8.6561 3.2001 10.0001 4.5441 10.0001 6.2001C10.0001 7.8561 8.6561 9.2001 7.0001 9.2001ZM0.600098 12.6001H3.8001V13.4001H0.600098V12.6001ZM10.2001 12.6001H13.4001V13.4001H10.2001V12.6001ZM8.8001 6.2001C8.8001 7.19421 7.99421 8.0001 7.0001 8.0001C6.00598 8.0001 5.2001 7.19421 5.2001 6.2001C5.2001 5.20598 6.00598 4.4001 7.0001 4.4001C7.99421 4.4001 8.8001 5.20598 8.8001 6.2001Z" })
  );
}
Fh.SafeIcon = DA;
var Np = {};
Object.defineProperty(Np, "__esModule", { value: !0 });
Np.default = ".-cbwsdk-css-reset .-cbwsdk-try-extension{display:flex;margin-top:12px;height:202px;width:700px;border-radius:12px;padding:30px}.-cbwsdk-css-reset .-cbwsdk-try-extension.light{background:#fff}.-cbwsdk-css-reset .-cbwsdk-try-extension.dark{background:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-try-extension-column-half{flex:50%}.-cbwsdk-css-reset .-cbwsdk-try-extension-heading{font-style:normal;font-weight:500;font-size:25px;line-height:32px;margin:0;max-width:204px}.-cbwsdk-css-reset .-cbwsdk-try-extension-heading.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-try-extension-heading.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta{appearance:none;border:none;background:none;color:#0052ff;cursor:pointer;padding:0;text-decoration:none;display:block;font-weight:600;font-size:16px;line-height:24px}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta.light{color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta.dark{color:#588af5}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta-wrapper{display:flex;align-items:center;margin-top:12px}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta-icon{display:block;margin-left:4px;height:14px}.-cbwsdk-css-reset .-cbwsdk-try-extension-list{display:flex;flex-direction:column;justify-content:center;align-items:center;margin:0;padding:0;list-style:none;height:100%}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item{display:flex;align-items:center;flex-flow:nowrap;margin-top:24px}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item:first-of-type{margin-top:0}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon-wrapper{display:block}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon{display:flex;height:32px;width:32px;border-radius:50%}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon svg{margin:auto;display:block}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon.light{background:#eef0f3}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon.dark{background:#1e2025}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-copy{display:block;font-weight:400;font-size:14px;line-height:20px;padding-left:12px}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-copy.light{color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-copy.dark{color:#8a919e}";
var Ab = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(kh, "__esModule", { value: !0 });
kh.TryExtensionContent = void 0;
const Gs = Ab(ru), pr = pn, Bd = Mh, OA = Lh, PA = $h, TA = Fh, NA = Ab(Np);
function kA({ theme: t }) {
  const [e, r] = (0, Bd.useState)(!1), n = (0, Bd.useCallback)(() => {
    window.open("https://api.wallet.coinbase.com/rpc/v2/desktop/chrome", "_blank");
  }, []), i = (0, Bd.useCallback)(() => {
    e ? window.location.reload() : (n(), r(!0));
  }, [n, e]);
  return (0, pr.h)(
    "div",
    { class: (0, Gs.default)("-cbwsdk-try-extension", t) },
    (0, pr.h)("style", null, NA.default),
    (0, pr.h)(
      "div",
      { class: "-cbwsdk-try-extension-column-half" },
      (0, pr.h)("h3", { class: (0, Gs.default)("-cbwsdk-try-extension-heading", t) }, "Or try the Coinbase Wallet browser extension"),
      (0, pr.h)(
        "div",
        { class: "-cbwsdk-try-extension-cta-wrapper" },
        (0, pr.h)("button", { class: (0, Gs.default)("-cbwsdk-try-extension-cta", t), onClick: i }, e ? "Refresh" : "Install"),
        (0, pr.h)("div", null, !e && (0, pr.h)(OA.ArrowLeftIcon, { class: "-cbwsdk-try-extension-cta-icon", fill: t === "light" ? "#0052FF" : "#588AF5" }))
      )
    ),
    (0, pr.h)(
      "div",
      { class: "-cbwsdk-try-extension-column-half" },
      (0, pr.h)(
        "ul",
        { class: "-cbwsdk-try-extension-list" },
        (0, pr.h)(
          "li",
          { class: "-cbwsdk-try-extension-list-item" },
          (0, pr.h)(
            "div",
            { class: "-cbwsdk-try-extension-list-item-icon-wrapper" },
            (0, pr.h)(
              "span",
              { class: (0, Gs.default)("-cbwsdk-try-extension-list-item-icon", t) },
              (0, pr.h)(PA.LaptopIcon, { fill: t === "light" ? "#0A0B0D" : "#FFFFFF" })
            )
          ),
          (0, pr.h)("div", { class: (0, Gs.default)("-cbwsdk-try-extension-list-item-copy", t) }, "Connect with dapps with just one click on your desktop browser")
        ),
        (0, pr.h)(
          "li",
          { class: "-cbwsdk-try-extension-list-item" },
          (0, pr.h)(
            "div",
            { class: "-cbwsdk-try-extension-list-item-icon-wrapper" },
            (0, pr.h)(
              "span",
              { class: (0, Gs.default)("-cbwsdk-try-extension-list-item-icon", t) },
              (0, pr.h)(TA.SafeIcon, { fill: t === "light" ? "#0A0B0D" : "#FFFFFF" })
            )
          ),
          (0, pr.h)("div", { class: (0, Gs.default)("-cbwsdk-try-extension-list-item-copy", t) }, "Add an additional layer of security by using a supported Ledger hardware wallet")
        )
      )
    )
  );
}
kh.TryExtensionContent = kA;
var kp = {};
Object.defineProperty(kp, "__esModule", { value: !0 });
kp.default = ".-cbwsdk-css-reset .-cbwsdk-connect-dialog{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;transition:opacity .25s}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop.light{background-color:rgba(0,0,0,.5)}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop.dark{background-color:rgba(50,53,61,.4)}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop-hidden{opacity:0}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-box{display:flex;position:relative;flex-direction:column;transform:scale(1);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-box-hidden{opacity:0;transform:scale(0.85)}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-container{display:block}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-container-hidden{display:none}";
var Mb = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ah, "__esModule", { value: !0 });
Ah.ConnectDialog = void 0;
const Ud = Mb(ru), Js = pn, jd = Mh, LA = ba, $A = kh, FA = Mb(kp), BA = (t) => {
  const { isOpen: e, darkMode: r } = t, [n, i] = (0, jd.useState)(!e), [o, c] = (0, jd.useState)(!e);
  (0, jd.useEffect)(() => {
    const l = [
      window.setTimeout(() => {
        c(!e);
      }, 10)
    ];
    return e ? i(!1) : l.push(window.setTimeout(() => {
      i(!0);
    }, 360)), () => {
      l.forEach(window.clearTimeout);
    };
  }, [e]);
  const u = r ? "dark" : "light";
  return (0, Js.h)(
    "div",
    { class: (0, Ud.default)("-cbwsdk-connect-dialog-container", n && "-cbwsdk-connect-dialog-container-hidden") },
    (0, Js.h)("style", null, FA.default),
    (0, Js.h)("div", { class: (0, Ud.default)("-cbwsdk-connect-dialog-backdrop", u, o && "-cbwsdk-connect-dialog-backdrop-hidden") }),
    (0, Js.h)(
      "div",
      { class: "-cbwsdk-connect-dialog" },
      (0, Js.h)(
        "div",
        { class: (0, Ud.default)("-cbwsdk-connect-dialog-box", o && "-cbwsdk-connect-dialog-box-hidden") },
        t.connectDisabled ? null : (0, Js.h)(LA.ConnectContent, { theme: u, version: t.version, sessionId: t.sessionId, sessionSecret: t.sessionSecret, linkAPIUrl: t.linkAPIUrl, isConnected: t.isConnected, isParentConnection: t.isParentConnection, chainId: t.chainId, onCancel: t.onCancel }),
        (0, Js.h)($A.TryExtensionContent, { theme: u })
      )
    )
  );
};
Ah.ConnectDialog = BA;
Object.defineProperty(xh, "__esModule", { value: !0 });
xh.LinkFlow = void 0;
const Hd = pn, UA = Ah;
class jA {
  constructor(e) {
    this.connected = !1, this.chainId = 1, this.isOpen = !1, this.onCancel = null, this.root = null, this.connectDisabled = !1, this.darkMode = e.darkMode, this.version = e.version, this.sessionId = e.sessionId, this.sessionSecret = e.sessionSecret, this.linkAPIUrl = e.linkAPIUrl, this.isParentConnection = e.isParentConnection;
  }
  attach(e) {
    this.root = document.createElement("div"), this.root.className = "-cbwsdk-link-flow-root", e.appendChild(this.root), this.render();
  }
  setConnected(e) {
    this.connected !== e && (this.connected = e, this.render());
  }
  setChainId(e) {
    this.chainId !== e && (this.chainId = e, this.render());
  }
  detach() {
    var e;
    this.root && ((0, Hd.render)(null, this.root), (e = this.root.parentElement) === null || e === void 0 || e.removeChild(this.root));
  }
  setConnectDisabled(e) {
    this.connectDisabled = e;
  }
  open(e) {
    this.isOpen = !0, this.onCancel = e.onCancel, this.render();
  }
  close() {
    this.isOpen = !1, this.onCancel = null, this.render();
  }
  render() {
    this.root && (0, Hd.render)((0, Hd.h)(UA.ConnectDialog, { darkMode: this.darkMode, version: this.version, sessionId: this.sessionId, sessionSecret: this.sessionSecret, linkAPIUrl: this.linkAPIUrl, isOpen: this.isOpen, isConnected: this.connected, isParentConnection: this.isParentConnection, chainId: this.chainId, onCancel: this.onCancel, connectDisabled: this.connectDisabled }), this.root);
  }
}
xh.LinkFlow = jA;
var Lp = {}, $p = {};
Object.defineProperty($p, "__esModule", { value: !0 });
$p.default = ".-cbwsdk-css-reset .-gear-container{margin-left:16px !important;margin-right:9px !important;display:flex;align-items:center;justify-content:center;width:24px;height:24px;transition:opacity .25s}.-cbwsdk-css-reset .-gear-container *{user-select:none}.-cbwsdk-css-reset .-gear-container svg{opacity:0;position:absolute}.-cbwsdk-css-reset .-gear-icon{height:12px;width:12px;z-index:10000}.-cbwsdk-css-reset .-cbwsdk-snackbar{align-items:flex-end;display:flex;flex-direction:column;position:fixed;right:0;top:0;z-index:2147483647}.-cbwsdk-css-reset .-cbwsdk-snackbar *{user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance{display:flex;flex-direction:column;margin:8px 16px 0 16px;overflow:visible;text-align:left;transform:translateX(0);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header:hover .-gear-container svg{opacity:1}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header{display:flex;align-items:center;background:#fff;overflow:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-cblogo{margin:8px 8px 8px 8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-message{color:#000;font-size:13px;line-height:1.5;user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu{background:#fff;transition:opacity .25s ease-in-out,transform .25s linear,visibility 0s;visibility:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;opacity:0;flex-direction:column;padding-left:8px;padding-right:8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:last-child{margin-bottom:8px !important}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover{background:#f5f7f8;border-radius:6px;transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover span{color:#050f19;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover svg path{fill:#000;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item{visibility:inherit;height:35px;margin-top:8px;margin-bottom:0;display:flex;flex-direction:row;align-items:center;padding:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item *{visibility:inherit;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover{background:rgba(223,95,103,.2);transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover svg path{fill:#df5f67;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover span{color:#df5f67;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-info{color:#aaa;font-size:13px;margin:0 8px 0 32px;position:absolute}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-hidden{opacity:0;text-align:left;transform:translateX(25%);transition:opacity .5s linear}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-expanded .-cbwsdk-snackbar-instance-menu{opacity:1;display:flex;transform:translateY(8px);visibility:visible}";
(function(t) {
  var e = Te && Te.__importDefault || function(g) {
    return g && g.__esModule ? g : { default: g };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.SnackbarInstance = t.SnackbarContainer = t.Snackbar = void 0;
  const r = e(ru), n = pn, i = Mh, o = e($p), c = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNDkyIDEwLjQxOWE4LjkzIDguOTMgMCAwMTguOTMtOC45M2gxMS4xNjNhOC45MyA4LjkzIDAgMDE4LjkzIDguOTN2MTEuMTYzYTguOTMgOC45MyAwIDAxLTguOTMgOC45M0gxMC40MjJhOC45MyA4LjkzIDAgMDEtOC45My04LjkzVjEwLjQxOXoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQxOSAwSDIxLjU4QzI3LjMzNSAwIDMyIDQuNjY1IDMyIDEwLjQxOVYyMS41OEMzMiAyNy4zMzUgMjcuMzM1IDMyIDIxLjU4MSAzMkgxMC40MkM0LjY2NSAzMiAwIDI3LjMzNSAwIDIxLjU4MVYxMC40MkMwIDQuNjY1IDQuNjY1IDAgMTAuNDE5IDB6bTAgMS40ODhhOC45MyA4LjkzIDAgMDAtOC45MyA4LjkzdjExLjE2M2E4LjkzIDguOTMgMCAwMDguOTMgOC45M0gyMS41OGE4LjkzIDguOTMgMCAwMDguOTMtOC45M1YxMC40MmE4LjkzIDguOTMgMCAwMC04LjkzLTguOTNIMTAuNDJ6IiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45OTggMjYuMDQ5Yy01LjU0OSAwLTEwLjA0Ny00LjQ5OC0xMC4wNDctMTAuMDQ3IDAtNS41NDggNC40OTgtMTAuMDQ2IDEwLjA0Ny0xMC4wNDYgNS41NDggMCAxMC4wNDYgNC40OTggMTAuMDQ2IDEwLjA0NiAwIDUuNTQ5LTQuNDk4IDEwLjA0Ny0xMC4wNDYgMTAuMDQ3eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0xMi43NjIgMTQuMjU0YzAtLjgyMi42NjctMS40ODkgMS40ODktMS40ODloMy40OTdjLjgyMiAwIDEuNDg4LjY2NiAxLjQ4OCAxLjQ4OXYzLjQ5N2MwIC44MjItLjY2NiAxLjQ4OC0xLjQ4OCAxLjQ4OGgtMy40OTdhMS40ODggMS40ODggMCAwMS0xLjQ4OS0xLjQ4OHYtMy40OTh6IiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+", u = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDYuNzV2LTEuNWwtMS43Mi0uNTdjLS4wOC0uMjctLjE5LS41Mi0uMzItLjc3bC44MS0xLjYyLTEuMDYtMS4wNi0xLjYyLjgxYy0uMjQtLjEzLS41LS4yNC0uNzctLjMyTDYuNzUgMGgtMS41bC0uNTcgMS43MmMtLjI3LjA4LS41My4xOS0uNzcuMzJsLTEuNjItLjgxLTEuMDYgMS4wNi44MSAxLjYyYy0uMTMuMjQtLjI0LjUtLjMyLjc3TDAgNS4yNXYxLjVsMS43Mi41N2MuMDguMjcuMTkuNTMuMzIuNzdsLS44MSAxLjYyIDEuMDYgMS4wNiAxLjYyLS44MWMuMjQuMTMuNS4yMy43Ny4zMkw1LjI1IDEyaDEuNWwuNTctMS43MmMuMjctLjA4LjUyLS4xOS43Ny0uMzJsMS42Mi44MSAxLjA2LTEuMDYtLjgxLTEuNjJjLjEzLS4yNC4yMy0uNS4zMi0uNzdMMTIgNi43NXpNNiA4LjVhMi41IDIuNSAwIDAxMC01IDIuNSAyLjUgMCAwMTAgNXoiIGZpbGw9IiMwNTBGMTkiLz48L3N2Zz4=";
  class l {
    constructor(y) {
      this.items = /* @__PURE__ */ new Map(), this.nextItemKey = 0, this.root = null, this.darkMode = y.darkMode;
    }
    attach(y) {
      this.root = document.createElement("div"), this.root.className = "-cbwsdk-snackbar-root", y.appendChild(this.root), this.render();
    }
    presentItem(y) {
      const C = this.nextItemKey++;
      return this.items.set(C, y), this.render(), () => {
        this.items.delete(C), this.render();
      };
    }
    clear() {
      this.items.clear(), this.render();
    }
    render() {
      this.root && (0, n.render)((0, n.h)(
        "div",
        null,
        (0, n.h)(t.SnackbarContainer, { darkMode: this.darkMode }, Array.from(this.items.entries()).map(([y, C]) => (0, n.h)(t.SnackbarInstance, Object.assign({}, C, { key: y }))))
      ), this.root);
    }
  }
  t.Snackbar = l;
  const f = (g) => (0, n.h)(
    "div",
    { class: (0, r.default)("-cbwsdk-snackbar-container") },
    (0, n.h)("style", null, o.default),
    (0, n.h)("div", { class: "-cbwsdk-snackbar" }, g.children)
  );
  t.SnackbarContainer = f;
  const p = ({ autoExpand: g, message: y, menuItems: C }) => {
    const [R, J] = (0, i.useState)(!0), [G, H] = (0, i.useState)(g ?? !1);
    (0, i.useEffect)(() => {
      const q = [
        window.setTimeout(() => {
          J(!1);
        }, 1),
        window.setTimeout(() => {
          H(!0);
        }, 1e4)
      ];
      return () => {
        q.forEach(window.clearTimeout);
      };
    });
    const T = () => {
      H(!G);
    };
    return (0, n.h)(
      "div",
      { class: (0, r.default)("-cbwsdk-snackbar-instance", R && "-cbwsdk-snackbar-instance-hidden", G && "-cbwsdk-snackbar-instance-expanded") },
      (0, n.h)(
        "div",
        { class: "-cbwsdk-snackbar-instance-header", onClick: T },
        (0, n.h)("img", { src: c, class: "-cbwsdk-snackbar-instance-header-cblogo" }),
        " ",
        (0, n.h)("div", { class: "-cbwsdk-snackbar-instance-header-message" }, y),
        (0, n.h)(
          "div",
          { class: "-gear-container" },
          !G && (0, n.h)(
            "svg",
            { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            (0, n.h)("circle", { cx: "12", cy: "12", r: "12", fill: "#F5F7F8" })
          ),
          (0, n.h)("img", { src: u, class: "-gear-icon", title: "Expand" })
        )
      ),
      C && C.length > 0 && (0, n.h)("div", { class: "-cbwsdk-snackbar-instance-menu" }, C.map((q, B) => (0, n.h)(
        "div",
        { class: (0, r.default)("-cbwsdk-snackbar-instance-menu-item", q.isRed && "-cbwsdk-snackbar-instance-menu-item-is-red"), onClick: q.onClick, key: B },
        (0, n.h)(
          "svg",
          { width: q.svgWidth, height: q.svgHeight, viewBox: "0 0 10 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
          (0, n.h)("path", { "fill-rule": q.defaultFillRule, "clip-rule": q.defaultClipRule, d: q.path, fill: "#AAAAAA" })
        ),
        (0, n.h)("span", { class: (0, r.default)("-cbwsdk-snackbar-instance-menu-item-info", q.isRed && "-cbwsdk-snackbar-instance-menu-item-info-is-red") }, q.info)
      )))
    );
  };
  t.SnackbarInstance = p;
})(Lp);
Object.defineProperty(Yc, "__esModule", { value: !0 });
Yc.WalletLinkRelayUI = void 0;
const HA = Xc, qA = xh, zA = Lp;
class VA {
  constructor(e) {
    this.standalone = null, this.attached = !1, this.snackbar = new zA.Snackbar({
      darkMode: e.darkMode
    }), this.linkFlow = new qA.LinkFlow({
      darkMode: e.darkMode,
      version: e.version,
      sessionId: e.session.id,
      sessionSecret: e.session.secret,
      linkAPIUrl: e.linkAPIUrl,
      isParentConnection: !1
    });
  }
  attach() {
    if (this.attached)
      throw new Error("Coinbase Wallet SDK UI is already attached");
    const e = document.documentElement, r = document.createElement("div");
    r.className = "-cbwsdk-css-reset", e.appendChild(r), this.linkFlow.attach(r), this.snackbar.attach(r), this.attached = !0, (0, HA.injectCssReset)();
  }
  setConnected(e) {
    this.linkFlow.setConnected(e);
  }
  setChainId(e) {
    this.linkFlow.setChainId(e);
  }
  setConnectDisabled(e) {
    this.linkFlow.setConnectDisabled(e);
  }
  /* istanbul ignore next */
  addEthereumChain() {
  }
  // no-op
  /* istanbul ignore next */
  watchAsset() {
  }
  // no-op
  /* istanbul ignore next */
  switchEthereumChain() {
  }
  // no-op
  requestEthereumAccounts(e) {
    this.linkFlow.open({ onCancel: e.onCancel });
  }
  hideRequestEthereumAccounts() {
    this.linkFlow.close();
  }
  /* istanbul ignore next */
  signEthereumMessage() {
  }
  // no-op
  /* istanbul ignore next */
  signEthereumTransaction() {
  }
  // no-op
  /* istanbul ignore next */
  submitEthereumTransaction() {
  }
  // no-op
  /* istanbul ignore next */
  ethereumAddressFromSignedMessage() {
  }
  // no-op
  showConnecting(e) {
    let r;
    return e.isUnlinkedErrorState ? r = {
      autoExpand: !0,
      message: "Connection lost",
      menuItems: [
        {
          isRed: !1,
          info: "Reset connection",
          svgWidth: "10",
          svgHeight: "11",
          path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
          defaultFillRule: "evenodd",
          defaultClipRule: "evenodd",
          onClick: e.onResetConnection
        }
      ]
    } : r = {
      message: "Confirm on phone",
      menuItems: [
        {
          isRed: !0,
          info: "Cancel transaction",
          svgWidth: "11",
          svgHeight: "11",
          path: "M10.3711 1.52346L9.21775 0.370117L5.37109 4.21022L1.52444 0.370117L0.371094 1.52346L4.2112 5.37012L0.371094 9.21677L1.52444 10.3701L5.37109 6.53001L9.21775 10.3701L10.3711 9.21677L6.53099 5.37012L10.3711 1.52346Z",
          defaultFillRule: "inherit",
          defaultClipRule: "inherit",
          onClick: e.onCancel
        },
        {
          isRed: !1,
          info: "Reset connection",
          svgWidth: "10",
          svgHeight: "11",
          path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
          defaultFillRule: "evenodd",
          defaultClipRule: "evenodd",
          onClick: e.onResetConnection
        }
      ]
    }, this.snackbar.presentItem(r);
  }
  /* istanbul ignore next */
  reloadUI() {
    document.location.reload();
  }
  /* istanbul ignore next */
  inlineAccountsResponse() {
    return !1;
  }
  /* istanbul ignore next */
  inlineAddEthereumChain() {
    return !1;
  }
  /* istanbul ignore next */
  inlineWatchAsset() {
    return !1;
  }
  /* istanbul ignore next */
  inlineSwitchEthereumChain() {
    return !1;
  }
  /* istanbul ignore next */
  setStandalone(e) {
    this.standalone = e;
  }
  /* istanbul ignore next */
  isStandalone() {
    var e;
    return (e = this.standalone) !== null && e !== void 0 ? e : !1;
  }
}
Yc.WalletLinkRelayUI = VA;
Object.defineProperty(Wc, "__esModule", { value: !0 });
Wc.WalletLinkRelay = void 0;
const Yo = jc, WA = _r, rr = $e, Qs = Ma, Sv = Hn, ws = Da, KA = Sh, Zs = Ra, GA = Yc;
class Zi extends Sv.RelayAbstract {
  constructor(e) {
    var r;
    super(), this.accountsCallback = null, this.chainCallbackParams = { chainId: "", jsonRpcUrl: "" }, this.chainCallback = null, this.dappDefaultChain = 1, this.appName = "", this.appLogoUrl = null, this.linkedUpdated = (c) => {
      var u;
      this.isLinked = c;
      const l = this.storage.getItem(Sv.LOCAL_STORAGE_ADDRESSES_KEY);
      if (c && (this.session.linked = c), this.isUnlinkedErrorState = !1, l) {
        const f = l.split(" "), p = this.storage.getItem("IsStandaloneSigning") === "true";
        if (f[0] !== "" && !c && this.session.linked && !p) {
          this.isUnlinkedErrorState = !0;
          const g = this.getSessionIdHash();
          (u = this.diagnostic) === null || u === void 0 || u.log(Qs.EVENTS.UNLINKED_ERROR_STATE, {
            sessionIdHash: g
          });
        }
      }
    }, this.metadataUpdated = (c, u) => {
      this.storage.setItem(c, u);
    }, this.chainUpdated = (c, u) => {
      this.chainCallbackParams.chainId === c && this.chainCallbackParams.jsonRpcUrl === u || (this.chainCallbackParams = {
        chainId: c,
        jsonRpcUrl: u
      }, this.chainCallback && this.chainCallback(c, u));
    }, this.accountUpdated = (c) => {
      this.accountsCallback && this.accountsCallback([c]), Zi.accountRequestCallbackIds.size > 0 && (Array.from(Zi.accountRequestCallbackIds.values()).forEach((u) => {
        const l = {
          type: "WEB3_RESPONSE",
          id: u,
          response: {
            method: "requestEthereumAccounts",
            result: [c]
          }
        };
        this.invokeCallback(Object.assign(Object.assign({}, l), { id: u }));
      }), Zi.accountRequestCallbackIds.clear());
    }, this.connectedUpdated = (c) => {
      this.ui.setConnected(c);
    }, this.resetAndReload = this.resetAndReload.bind(this), this.linkAPIUrl = e.linkAPIUrl, this.storage = e.storage, this.options = e;
    const { session: n, ui: i, connection: o } = this.subscribe();
    this._session = n, this.connection = o, this.relayEventManager = e.relayEventManager, this.diagnostic = e.diagnosticLogger, this._reloadOnDisconnect = (r = e.reloadOnDisconnect) !== null && r !== void 0 ? r : !0, this.ui = i;
  }
  subscribe() {
    const e = ws.Session.load(this.storage) || new ws.Session(this.storage).save(), { linkAPIUrl: r, diagnostic: n } = this, i = new KA.WalletLinkConnection({
      session: e,
      linkAPIUrl: r,
      diagnostic: n,
      listener: this
    }), { version: o, darkMode: c } = this.options, u = this.options.uiConstructor({
      linkAPIUrl: r,
      version: o,
      darkMode: c,
      session: e
    });
    return i.connect(), { session: e, ui: u, connection: i };
  }
  attachUI() {
    this.ui.attach();
  }
  resetAndReload() {
    Promise.race([
      this.connection.setSessionMetadata("__destroyed", "1"),
      new Promise((e) => setTimeout(() => e(null), 1e3))
    ]).then(() => {
      var e, r;
      const n = this.ui.isStandalone();
      (e = this.diagnostic) === null || e === void 0 || e.log(Qs.EVENTS.SESSION_STATE_CHANGE, {
        method: "relay::resetAndReload",
        sessionMetadataChange: "__destroyed, 1",
        sessionIdHash: this.getSessionIdHash()
      }), this.connection.destroy();
      const i = ws.Session.load(this.storage);
      if (i?.id === this._session.id ? this.storage.clear() : i && ((r = this.diagnostic) === null || r === void 0 || r.log(Qs.EVENTS.SKIPPED_CLEARING_SESSION, {
        sessionIdHash: this.getSessionIdHash(),
        storedSessionIdHash: ws.Session.hash(i.id)
      })), this._reloadOnDisconnect) {
        this.ui.reloadUI();
        return;
      }
      this.accountsCallback && this.accountsCallback([], !0);
      const { session: o, ui: c, connection: u } = this.subscribe();
      this._session = o, this.connection = u, this.ui = c, n && this.ui.setStandalone && this.ui.setStandalone(!0), this.attachUI();
    }).catch((e) => {
      var r;
      (r = this.diagnostic) === null || r === void 0 || r.log(Qs.EVENTS.FAILURE, {
        method: "relay::resetAndReload",
        message: `failed to reset and reload with ${e}`,
        sessionIdHash: this.getSessionIdHash()
      });
    });
  }
  setAppInfo(e, r) {
    this.appName = e, this.appLogoUrl = r;
  }
  getStorageItem(e) {
    return this.storage.getItem(e);
  }
  get session() {
    return this._session;
  }
  setStorageItem(e, r) {
    this.storage.setItem(e, r);
  }
  signEthereumMessage(e, r, n, i) {
    return this.sendRequest({
      method: "signEthereumMessage",
      params: {
        message: (0, rr.hexStringFromBuffer)(e, !0),
        address: r,
        addPrefix: n,
        typedDataJson: i || null
      }
    });
  }
  ethereumAddressFromSignedMessage(e, r, n) {
    return this.sendRequest({
      method: "ethereumAddressFromSignedMessage",
      params: {
        message: (0, rr.hexStringFromBuffer)(e, !0),
        signature: (0, rr.hexStringFromBuffer)(r, !0),
        addPrefix: n
      }
    });
  }
  signEthereumTransaction(e) {
    return this.sendRequest({
      method: "signEthereumTransaction",
      params: {
        fromAddress: e.fromAddress,
        toAddress: e.toAddress,
        weiValue: (0, rr.bigIntStringFromBN)(e.weiValue),
        data: (0, rr.hexStringFromBuffer)(e.data, !0),
        nonce: e.nonce,
        gasPriceInWei: e.gasPriceInWei ? (0, rr.bigIntStringFromBN)(e.gasPriceInWei) : null,
        maxFeePerGas: e.gasPriceInWei ? (0, rr.bigIntStringFromBN)(e.gasPriceInWei) : null,
        maxPriorityFeePerGas: e.gasPriceInWei ? (0, rr.bigIntStringFromBN)(e.gasPriceInWei) : null,
        gasLimit: e.gasLimit ? (0, rr.bigIntStringFromBN)(e.gasLimit) : null,
        chainId: e.chainId,
        shouldSubmit: !1
      }
    });
  }
  signAndSubmitEthereumTransaction(e) {
    return this.sendRequest({
      method: "signEthereumTransaction",
      params: {
        fromAddress: e.fromAddress,
        toAddress: e.toAddress,
        weiValue: (0, rr.bigIntStringFromBN)(e.weiValue),
        data: (0, rr.hexStringFromBuffer)(e.data, !0),
        nonce: e.nonce,
        gasPriceInWei: e.gasPriceInWei ? (0, rr.bigIntStringFromBN)(e.gasPriceInWei) : null,
        maxFeePerGas: e.maxFeePerGas ? (0, rr.bigIntStringFromBN)(e.maxFeePerGas) : null,
        maxPriorityFeePerGas: e.maxPriorityFeePerGas ? (0, rr.bigIntStringFromBN)(e.maxPriorityFeePerGas) : null,
        gasLimit: e.gasLimit ? (0, rr.bigIntStringFromBN)(e.gasLimit) : null,
        chainId: e.chainId,
        shouldSubmit: !0
      }
    });
  }
  submitEthereumTransaction(e, r) {
    return this.sendRequest({
      method: "submitEthereumTransaction",
      params: {
        signedTransaction: (0, rr.hexStringFromBuffer)(e, !0),
        chainId: r
      }
    });
  }
  scanQRCode(e) {
    return this.sendRequest({
      method: "scanQRCode",
      params: {
        regExp: e
      }
    });
  }
  getQRCodeUrl() {
    return (0, rr.createQrUrl)(this._session.id, this._session.secret, this.linkAPIUrl, !1, this.options.version, this.dappDefaultChain);
  }
  genericRequest(e, r) {
    return this.sendRequest({
      method: "generic",
      params: {
        action: r,
        data: e
      }
    });
  }
  sendGenericMessage(e) {
    return this.sendRequest(e);
  }
  sendRequest(e) {
    let r = null;
    const n = (0, rr.randomBytesHex)(8), i = (c) => {
      this.publishWeb3RequestCanceledEvent(n), this.handleErrorResponse(n, e.method, c), r?.();
    };
    return { promise: new Promise((c, u) => {
      this.ui.isStandalone() || (r = this.ui.showConnecting({
        isUnlinkedErrorState: this.isUnlinkedErrorState,
        onCancel: i,
        onResetConnection: this.resetAndReload
        // eslint-disable-line @typescript-eslint/unbound-method
      })), this.relayEventManager.callbacks.set(n, (l) => {
        if (r?.(), (0, Zs.isErrorResponse)(l))
          return u(new Error(l.errorMessage));
        c(l);
      }), this.ui.isStandalone() ? this.sendRequestStandalone(n, e) : this.publishWeb3RequestEvent(n, e);
    }), cancel: i };
  }
  setConnectDisabled(e) {
    this.ui.setConnectDisabled(e);
  }
  setAccountsCallback(e) {
    this.accountsCallback = e;
  }
  setChainCallback(e) {
    this.chainCallback = e;
  }
  setDappDefaultChainCallback(e) {
    this.dappDefaultChain = e, this.ui instanceof GA.WalletLinkRelayUI && this.ui.setChainId(e);
  }
  publishWeb3RequestEvent(e, r) {
    var n;
    const i = { type: "WEB3_REQUEST", id: e, request: r }, o = ws.Session.load(this.storage);
    (n = this.diagnostic) === null || n === void 0 || n.log(Qs.EVENTS.WEB3_REQUEST, {
      eventId: i.id,
      method: `relay::${r.method}`,
      sessionIdHash: this.getSessionIdHash(),
      storedSessionIdHash: o ? ws.Session.hash(o.id) : "",
      isSessionMismatched: (o?.id !== this._session.id).toString()
    }), this.publishEvent("Web3Request", i, !0).then((c) => {
      var u;
      (u = this.diagnostic) === null || u === void 0 || u.log(Qs.EVENTS.WEB3_REQUEST_PUBLISHED, {
        eventId: i.id,
        method: `relay::${r.method}`,
        sessionIdHash: this.getSessionIdHash(),
        storedSessionIdHash: o ? ws.Session.hash(o.id) : "",
        isSessionMismatched: (o?.id !== this._session.id).toString()
      });
    }).catch((c) => {
      this.handleWeb3ResponseMessage({
        type: "WEB3_RESPONSE",
        id: i.id,
        response: {
          method: r.method,
          errorMessage: c.message
        }
      });
    });
  }
  publishWeb3RequestCanceledEvent(e) {
    const r = {
      type: "WEB3_REQUEST_CANCELED",
      id: e
    };
    this.publishEvent("Web3RequestCanceled", r, !1).then();
  }
  publishEvent(e, r, n) {
    return this.connection.publishEvent(e, r, n);
  }
  handleWeb3ResponseMessage(e) {
    var r;
    const { response: n } = e;
    if ((r = this.diagnostic) === null || r === void 0 || r.log(Qs.EVENTS.WEB3_RESPONSE, {
      eventId: e.id,
      method: `relay::${n.method}`,
      sessionIdHash: this.getSessionIdHash()
    }), n.method === "requestEthereumAccounts") {
      Zi.accountRequestCallbackIds.forEach((i) => this.invokeCallback(Object.assign(Object.assign({}, e), { id: i }))), Zi.accountRequestCallbackIds.clear();
      return;
    }
    this.invokeCallback(e);
  }
  handleErrorResponse(e, r, n, i) {
    var o;
    const c = (o = n?.message) !== null && o !== void 0 ? o : (0, Yo.getMessageFromCode)(i);
    this.handleWeb3ResponseMessage({
      type: "WEB3_RESPONSE",
      id: e,
      response: {
        method: r,
        errorMessage: c,
        errorCode: i
      }
    });
  }
  invokeCallback(e) {
    const r = this.relayEventManager.callbacks.get(e.id);
    r && (r(e.response), this.relayEventManager.callbacks.delete(e.id));
  }
  requestEthereumAccounts() {
    const e = {
      method: "requestEthereumAccounts",
      params: {
        appName: this.appName,
        appLogoUrl: this.appLogoUrl || null
      }
    }, r = (0, rr.randomBytesHex)(8), n = (o) => {
      this.publishWeb3RequestCanceledEvent(r), this.handleErrorResponse(r, e.method, o);
    };
    return { promise: new Promise((o, c) => {
      if (this.relayEventManager.callbacks.set(r, (u) => {
        if (this.ui.hideRequestEthereumAccounts(), (0, Zs.isErrorResponse)(u))
          return c(new Error(u.errorMessage));
        o(u);
      }), this.ui.inlineAccountsResponse()) {
        const u = (l) => {
          this.handleWeb3ResponseMessage({
            type: "WEB3_RESPONSE",
            id: r,
            response: { method: "requestEthereumAccounts", result: l }
          });
        };
        this.ui.requestEthereumAccounts({
          onCancel: n,
          onAccounts: u
        });
      } else {
        const u = Yo.standardErrors.provider.userRejectedRequest("User denied account authorization");
        this.ui.requestEthereumAccounts({
          onCancel: () => n(u)
        });
      }
      Zi.accountRequestCallbackIds.add(r), !this.ui.inlineAccountsResponse() && !this.ui.isStandalone() && this.publishWeb3RequestEvent(r, e);
    }), cancel: n };
  }
  selectProvider(e) {
    const r = {
      method: "selectProvider",
      params: {
        providerOptions: e
      }
    }, n = (0, rr.randomBytesHex)(8), i = (c) => {
      this.publishWeb3RequestCanceledEvent(n), this.handleErrorResponse(n, r.method, c);
    }, o = new Promise((c, u) => {
      this.relayEventManager.callbacks.set(n, (p) => {
        if ((0, Zs.isErrorResponse)(p))
          return u(new Error(p.errorMessage));
        c(p);
      });
      const l = (p) => {
        this.handleWeb3ResponseMessage({
          type: "WEB3_RESPONSE",
          id: n,
          response: { method: "selectProvider", result: WA.ProviderType.Unselected }
        });
      }, f = (p) => {
        this.handleWeb3ResponseMessage({
          type: "WEB3_RESPONSE",
          id: n,
          response: { method: "selectProvider", result: p }
        });
      };
      this.ui.selectProvider && this.ui.selectProvider({
        onApprove: f,
        onCancel: l,
        providerOptions: e
      });
    });
    return { cancel: i, promise: o };
  }
  watchAsset(e, r, n, i, o, c) {
    const u = {
      method: "watchAsset",
      params: {
        type: e,
        options: {
          address: r,
          symbol: n,
          decimals: i,
          image: o
        },
        chainId: c
      }
    };
    let l = null;
    const f = (0, rr.randomBytesHex)(8), p = (y) => {
      this.publishWeb3RequestCanceledEvent(f), this.handleErrorResponse(f, u.method, y), l?.();
    };
    this.ui.inlineWatchAsset() || (l = this.ui.showConnecting({
      isUnlinkedErrorState: this.isUnlinkedErrorState,
      onCancel: p,
      onResetConnection: this.resetAndReload
      // eslint-disable-line @typescript-eslint/unbound-method
    }));
    const g = new Promise((y, C) => {
      this.relayEventManager.callbacks.set(f, (G) => {
        if (l?.(), (0, Zs.isErrorResponse)(G))
          return C(new Error(G.errorMessage));
        y(G);
      });
      const R = (G) => {
        this.handleWeb3ResponseMessage({
          type: "WEB3_RESPONSE",
          id: f,
          response: {
            method: "watchAsset",
            result: !1
          }
        });
      }, J = () => {
        this.handleWeb3ResponseMessage({
          type: "WEB3_RESPONSE",
          id: f,
          response: {
            method: "watchAsset",
            result: !0
          }
        });
      };
      this.ui.inlineWatchAsset() && this.ui.watchAsset({
        onApprove: J,
        onCancel: R,
        type: e,
        address: r,
        symbol: n,
        decimals: i,
        image: o,
        chainId: c
      }), !this.ui.inlineWatchAsset() && !this.ui.isStandalone() && this.publishWeb3RequestEvent(f, u);
    });
    return { cancel: p, promise: g };
  }
  addEthereumChain(e, r, n, i, o, c) {
    const u = {
      method: "addEthereumChain",
      params: {
        chainId: e,
        rpcUrls: r,
        blockExplorerUrls: i,
        chainName: o,
        iconUrls: n,
        nativeCurrency: c
      }
    };
    let l = null;
    const f = (0, rr.randomBytesHex)(8), p = (y) => {
      this.publishWeb3RequestCanceledEvent(f), this.handleErrorResponse(f, u.method, y), l?.();
    };
    return this.ui.inlineAddEthereumChain(e) || (l = this.ui.showConnecting({
      isUnlinkedErrorState: this.isUnlinkedErrorState,
      onCancel: p,
      onResetConnection: this.resetAndReload
      // eslint-disable-line @typescript-eslint/unbound-method
    })), { promise: new Promise((y, C) => {
      this.relayEventManager.callbacks.set(f, (G) => {
        if (l?.(), (0, Zs.isErrorResponse)(G))
          return C(new Error(G.errorMessage));
        y(G);
      });
      const R = (G) => {
        this.handleWeb3ResponseMessage({
          type: "WEB3_RESPONSE",
          id: f,
          response: {
            method: "addEthereumChain",
            result: {
              isApproved: !1,
              rpcUrl: ""
            }
          }
        });
      }, J = (G) => {
        this.handleWeb3ResponseMessage({
          type: "WEB3_RESPONSE",
          id: f,
          response: {
            method: "addEthereumChain",
            result: {
              isApproved: !0,
              rpcUrl: G
            }
          }
        });
      };
      this.ui.inlineAddEthereumChain(e) && this.ui.addEthereumChain({
        onCancel: R,
        onApprove: J,
        chainId: u.params.chainId,
        rpcUrls: u.params.rpcUrls,
        blockExplorerUrls: u.params.blockExplorerUrls,
        chainName: u.params.chainName,
        iconUrls: u.params.iconUrls,
        nativeCurrency: u.params.nativeCurrency
      }), !this.ui.inlineAddEthereumChain(e) && !this.ui.isStandalone() && this.publishWeb3RequestEvent(f, u);
    }), cancel: p };
  }
  switchEthereumChain(e, r) {
    const n = {
      method: "switchEthereumChain",
      params: Object.assign({ chainId: e }, { address: r })
    }, i = (0, rr.randomBytesHex)(8), o = (u) => {
      this.publishWeb3RequestCanceledEvent(i), this.handleErrorResponse(i, n.method, u);
    };
    return { promise: new Promise((u, l) => {
      this.relayEventManager.callbacks.set(i, (g) => {
        if ((0, Zs.isErrorResponse)(g) && g.errorCode)
          return l(Yo.standardErrors.provider.custom({
            code: g.errorCode,
            message: "Unrecognized chain ID. Try adding the chain using addEthereumChain first."
          }));
        if ((0, Zs.isErrorResponse)(g))
          return l(new Error(g.errorMessage));
        u(g);
      });
      const f = (g) => {
        var y;
        if (g) {
          const C = (y = (0, Yo.getErrorCode)(g)) !== null && y !== void 0 ? y : Yo.standardErrorCodes.provider.unsupportedChain;
          this.handleErrorResponse(i, "switchEthereumChain", g instanceof Error ? g : Yo.standardErrors.provider.unsupportedChain(e), C);
        } else
          this.handleWeb3ResponseMessage({
            type: "WEB3_RESPONSE",
            id: i,
            response: {
              method: "switchEthereumChain",
              result: {
                isApproved: !1,
                rpcUrl: ""
              }
            }
          });
      }, p = (g) => {
        this.handleWeb3ResponseMessage({
          type: "WEB3_RESPONSE",
          id: i,
          response: {
            method: "switchEthereumChain",
            result: {
              isApproved: !0,
              rpcUrl: g
            }
          }
        });
      };
      this.ui.switchEthereumChain({
        onCancel: f,
        onApprove: p,
        chainId: n.params.chainId,
        address: n.params.address
      }), !this.ui.inlineSwitchEthereumChain() && !this.ui.isStandalone() && this.publishWeb3RequestEvent(i, n);
    }), cancel: o };
  }
  inlineAddEthereumChain(e) {
    return this.ui.inlineAddEthereumChain(e);
  }
  getSessionIdHash() {
    return ws.Session.hash(this._session.id);
  }
  sendRequestStandalone(e, r) {
    const n = (o) => {
      this.handleErrorResponse(e, r.method, o);
    }, i = (o) => {
      this.handleWeb3ResponseMessage({
        type: "WEB3_RESPONSE",
        id: e,
        response: o
      });
    };
    switch (r.method) {
      case "signEthereumMessage":
        this.ui.signEthereumMessage({
          request: r,
          onSuccess: i,
          onCancel: n
        });
        break;
      case "signEthereumTransaction":
        this.ui.signEthereumTransaction({
          request: r,
          onSuccess: i,
          onCancel: n
        });
        break;
      case "submitEthereumTransaction":
        this.ui.submitEthereumTransaction({
          request: r,
          onSuccess: i,
          onCancel: n
        });
        break;
      case "ethereumAddressFromSignedMessage":
        this.ui.ethereumAddressFromSignedMessage({
          request: r,
          onSuccess: i
        });
        break;
      default:
        n();
        break;
    }
  }
}
Wc.WalletLinkRelay = Zi;
Zi.accountRequestCallbackIds = /* @__PURE__ */ new Set();
var nu = {}, Bh = {}, Db = {};
(function(t) {
  var e = Te && Te.__createBinding || (Object.create ? function(n, i, o, c) {
    c === void 0 && (c = o);
    var u = Object.getOwnPropertyDescriptor(i, o);
    (!u || ("get" in u ? !i.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(n, c, u);
  } : function(n, i, o, c) {
    c === void 0 && (c = o), n[c] = i[o];
  }), r = Te && Te.__exportStar || function(n, i) {
    for (var o in n)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, n, o);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(Lp, t);
})(Db);
var Fp = {};
Object.defineProperty(Fp, "__esModule", { value: !0 });
Fp.default = ".-cbwsdk-css-reset .-cbwsdk-redirect-dialog-backdrop{position:fixed;top:0;left:0;right:0;bottom:0;transition:opacity .25s;background-color:rgba(10,11,13,.5)}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-backdrop-hidden{opacity:0}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box{display:block;position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);padding:20px;border-radius:8px;background-color:#fff;color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box p{display:block;font-weight:400;font-size:14px;line-height:20px;padding-bottom:12px;color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box button{appearance:none;border:none;background:none;color:#0052ff;padding:0;text-decoration:none;display:block;font-weight:600;font-size:16px;line-height:24px}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.dark{background-color:#0a0b0d;color:#fff}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.dark button{color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.light{background-color:#fff;color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.light button{color:#0052ff}";
var Ob = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Bh, "__esModule", { value: !0 });
Bh.RedirectDialog = void 0;
const JA = Ob(ru), xi = pn, QA = Xc, ZA = Db, YA = Ob(Fp);
class XA {
  constructor() {
    this.root = null;
  }
  attach() {
    const e = document.documentElement;
    this.root = document.createElement("div"), this.root.className = "-cbwsdk-css-reset", e.appendChild(this.root), (0, QA.injectCssReset)();
  }
  present(e) {
    this.render(e);
  }
  clear() {
    this.render(null);
  }
  render(e) {
    this.root && ((0, xi.render)(null, this.root), e && (0, xi.render)((0, xi.h)(eM, Object.assign({}, e, { onDismiss: () => {
      this.clear();
    } })), this.root));
  }
}
Bh.RedirectDialog = XA;
const eM = ({ title: t, buttonText: e, darkMode: r, onButtonClick: n, onDismiss: i }) => {
  const o = r ? "dark" : "light";
  return (0, xi.h)(
    ZA.SnackbarContainer,
    { darkMode: r },
    (0, xi.h)(
      "div",
      { class: "-cbwsdk-redirect-dialog" },
      (0, xi.h)("style", null, YA.default),
      (0, xi.h)("div", { class: "-cbwsdk-redirect-dialog-backdrop", onClick: i }),
      (0, xi.h)(
        "div",
        { class: (0, JA.default)("-cbwsdk-redirect-dialog-box", o) },
        (0, xi.h)("p", null, t),
        (0, xi.h)("button", { onClick: n }, e)
      )
    )
  );
};
Object.defineProperty(nu, "__esModule", { value: !0 });
nu.MobileRelayUI = void 0;
const tM = Bh;
class rM {
  constructor(e) {
    this.attached = !1, this.darkMode = !1, this.openedWindow = null, this.redirectDialog = new tM.RedirectDialog(), this.darkMode = e.darkMode;
  }
  attach() {
    if (this.attached)
      throw new Error("Coinbase Wallet SDK UI is already attached");
    this.redirectDialog.attach(), this.attached = !0;
  }
  setConnected(e) {
  }
  // no-op
  closeOpenedWindow() {
    var e;
    (e = this.openedWindow) === null || e === void 0 || e.close(), this.openedWindow = null;
  }
  redirectToCoinbaseWallet(e) {
    const r = new URL("https://go.cb-w.com/walletlink");
    r.searchParams.append("redirect_url", window.location.href), e && r.searchParams.append("wl_url", e), this.openedWindow = window.open(r.href, "cbw-opener"), this.openedWindow && setTimeout(() => this.closeOpenedWindow(), 5e3);
  }
  openCoinbaseWalletDeeplink(e) {
    this.redirectDialog.present({
      title: "Redirecting to Coinbase Wallet...",
      buttonText: "Open",
      darkMode: this.darkMode,
      onButtonClick: () => {
        this.redirectToCoinbaseWallet(e);
      }
    }), setTimeout(() => {
      this.redirectToCoinbaseWallet(e);
    }, 99);
  }
  showConnecting(e) {
    return () => {
      this.closeOpenedWindow(), this.redirectDialog.clear();
    };
  }
  hideRequestEthereumAccounts() {
    this.closeOpenedWindow(), this.redirectDialog.clear();
  }
  // -- Methods below are not needed for mobile
  requestEthereumAccounts() {
  }
  // no-op
  addEthereumChain() {
  }
  // no-op
  watchAsset() {
  }
  // no-op
  selectProvider() {
  }
  // no-op
  switchEthereumChain() {
  }
  // no-op
  signEthereumMessage() {
  }
  // no-op
  signEthereumTransaction() {
  }
  // no-op
  submitEthereumTransaction() {
  }
  // no-op
  ethereumAddressFromSignedMessage() {
  }
  // no-op
  reloadUI() {
  }
  // no-op
  setStandalone() {
  }
  // no-op
  setConnectDisabled() {
  }
  // no-op
  inlineAccountsResponse() {
    return !1;
  }
  inlineAddEthereumChain() {
    return !1;
  }
  inlineWatchAsset() {
    return !1;
  }
  inlineSwitchEthereumChain() {
    return !1;
  }
  isStandalone() {
    return !1;
  }
}
nu.MobileRelayUI = rM;
Object.defineProperty(Vc, "__esModule", { value: !0 });
Vc.MobileRelay = void 0;
const nM = $e, iM = Wc, Cv = nu;
class sM extends iM.WalletLinkRelay {
  constructor(e) {
    var r;
    super(e), this._enableMobileWalletLink = (r = e.enableMobileWalletLink) !== null && r !== void 0 ? r : !1;
  }
  // override
  requestEthereumAccounts() {
    return this._enableMobileWalletLink ? super.requestEthereumAccounts() : {
      promise: new Promise(() => {
        const e = (0, nM.getLocation)();
        e.href = `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(e.href)}`;
      }),
      cancel: () => {
      }
    };
  }
  // override
  publishWeb3RequestEvent(e, r) {
    if (super.publishWeb3RequestEvent(e, r), !(this._enableMobileWalletLink && this.ui instanceof Cv.MobileRelayUI))
      return;
    let n = !1;
    switch (r.method) {
      case "requestEthereumAccounts":
      case "connectAndSignIn":
        n = !0, this.ui.openCoinbaseWalletDeeplink(this.getQRCodeUrl());
        break;
      case "switchEthereumChain":
        return;
      default:
        n = !0, this.ui.openCoinbaseWalletDeeplink();
        break;
    }
    n && window.addEventListener("blur", () => {
      window.addEventListener("focus", () => {
        this.connection.checkUnseenEvents();
      }, { once: !0 });
    }, { once: !0 });
  }
  // override
  handleWeb3ResponseMessage(e) {
    super.handleWeb3ResponseMessage(e), this._enableMobileWalletLink && this.ui instanceof Cv.MobileRelayUI && this.ui.closeOpenedWindow();
  }
  connectAndSignIn(e) {
    if (!this._enableMobileWalletLink)
      throw new Error("connectAndSignIn is supported only when enableMobileWalletLink is on");
    return this.sendRequest({
      method: "connectAndSignIn",
      params: {
        appName: this.appName,
        appLogoUrl: this.appLogoUrl,
        domain: window.location.hostname,
        aud: window.location.href,
        version: "1",
        type: "eip4361",
        nonce: e.nonce,
        iat: (/* @__PURE__ */ new Date()).toISOString(),
        chainId: `eip155:${this.dappDefaultChain}`,
        statement: e.statement,
        resources: e.resources
      }
    });
  }
}
Vc.MobileRelay = sM;
var Pb = {};
const Iv = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
Pb.p1600 = function(t) {
  for (let e = 0; e < 24; ++e) {
    const r = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40], n = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41], i = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42], o = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43], c = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44], u = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45], l = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46], f = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47], p = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48], g = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49];
    let y = p ^ (i << 1 | o >>> 31), C = g ^ (o << 1 | i >>> 31);
    const R = t[0] ^ y, J = t[1] ^ C, G = t[10] ^ y, H = t[11] ^ C, T = t[20] ^ y, q = t[21] ^ C, B = t[30] ^ y, L = t[31] ^ C, P = t[40] ^ y, v = t[41] ^ C;
    y = r ^ (c << 1 | u >>> 31), C = n ^ (u << 1 | c >>> 31);
    const N = t[2] ^ y, ie = t[3] ^ C, le = t[12] ^ y, he = t[13] ^ C, ye = t[22] ^ y, k = t[23] ^ C, h = t[32] ^ y, m = t[33] ^ C, x = t[42] ^ y, M = t[43] ^ C;
    y = i ^ (l << 1 | f >>> 31), C = o ^ (f << 1 | l >>> 31);
    const A = t[4] ^ y, $ = t[5] ^ C, K = t[14] ^ y, D = t[15] ^ C, w = t[24] ^ y, U = t[25] ^ C, me = t[34] ^ y, pe = t[35] ^ C, ee = t[44] ^ y, V = t[45] ^ C;
    y = c ^ (p << 1 | g >>> 31), C = u ^ (g << 1 | p >>> 31);
    const Q = t[6] ^ y, X = t[7] ^ C, E = t[16] ^ y, I = t[17] ^ C, F = t[26] ^ y, se = t[27] ^ C, fe = t[36] ^ y, Re = t[37] ^ C, j = t[46] ^ y, b = t[47] ^ C;
    y = l ^ (r << 1 | n >>> 31), C = f ^ (n << 1 | r >>> 31);
    const S = t[8] ^ y, Z = t[9] ^ C, re = t[18] ^ y, ue = t[19] ^ C, ge = t[28] ^ y, Ee = t[29] ^ C, Ie = t[38] ^ y, Ae = t[39] ^ C, xe = t[48] ^ y, Se = t[49] ^ C, Le = R, Ne = J, Oe = H << 4 | G >>> 28, it = G << 4 | H >>> 28, Fe = T << 3 | q >>> 29, je = q << 3 | T >>> 29, ut = L << 9 | B >>> 23, Be = B << 9 | L >>> 23, ht = P << 18 | v >>> 14, ar = v << 18 | P >>> 14, bt = N << 1 | ie >>> 31, ft = ie << 1 | N >>> 31, Lr = he << 12 | le >>> 20, It = le << 12 | he >>> 20, Mt = ye << 10 | k >>> 22, Tt = k << 10 | ye >>> 22, Ke = m << 13 | h >>> 19, Qe = h << 13 | m >>> 19, Nt = x << 2 | M >>> 30, Je = M << 2 | x >>> 30, Ge = $ << 30 | A >>> 2, Ht = A << 30 | $ >>> 2, tt = K << 6 | D >>> 26, Ze = D << 6 | K >>> 26, qt = U << 11 | w >>> 21, Ye = w << 11 | U >>> 21, Xe = me << 15 | pe >>> 17, kt = pe << 15 | me >>> 17, qe = V << 29 | ee >>> 3, rt = ee << 29 | V >>> 3, zt = Q << 28 | X >>> 4, $t = X << 28 | Q >>> 4, Ft = I << 23 | E >>> 9, pi = E << 23 | I >>> 9, vt = F << 25 | se >>> 7, Bt = se << 25 | F >>> 7, Wn = fe << 21 | Re >>> 11, Kn = Re << 21 | fe >>> 11, Gn = b << 24 | j >>> 8, Jn = j << 24 | b >>> 8, Ar = S << 27 | Z >>> 5, Xr = Z << 27 | S >>> 5, Qn = re << 20 | ue >>> 12, en = ue << 20 | re >>> 12, Zn = Ee << 7 | ge >>> 25, Yn = ge << 7 | Ee >>> 25, tn = Ie << 8 | Ae >>> 24, Rn = Ae << 8 | Ie >>> 24, An = xe << 14 | Se >>> 18, mr = Se << 14 | xe >>> 18;
    t[0] = Le ^ ~Lr & qt, t[1] = Ne ^ ~It & Ye, t[10] = zt ^ ~Qn & Fe, t[11] = $t ^ ~en & je, t[20] = bt ^ ~tt & vt, t[21] = ft ^ ~Ze & Bt, t[30] = Ar ^ ~Oe & Mt, t[31] = Xr ^ ~it & Tt, t[40] = Ge ^ ~Ft & Zn, t[41] = Ht ^ ~pi & Yn, t[2] = Lr ^ ~qt & Wn, t[3] = It ^ ~Ye & Kn, t[12] = Qn ^ ~Fe & Ke, t[13] = en ^ ~je & Qe, t[22] = tt ^ ~vt & tn, t[23] = Ze ^ ~Bt & Rn, t[32] = Oe ^ ~Mt & Xe, t[33] = it ^ ~Tt & kt, t[42] = Ft ^ ~Zn & ut, t[43] = pi ^ ~Yn & Be, t[4] = qt ^ ~Wn & An, t[5] = Ye ^ ~Kn & mr, t[14] = Fe ^ ~Ke & qe, t[15] = je ^ ~Qe & rt, t[24] = vt ^ ~tn & ht, t[25] = Bt ^ ~Rn & ar, t[34] = Mt ^ ~Xe & Gn, t[35] = Tt ^ ~kt & Jn, t[44] = Zn ^ ~ut & Nt, t[45] = Yn ^ ~Be & Je, t[6] = Wn ^ ~An & Le, t[7] = Kn ^ ~mr & Ne, t[16] = Ke ^ ~qe & zt, t[17] = Qe ^ ~rt & $t, t[26] = tn ^ ~ht & bt, t[27] = Rn ^ ~ar & ft, t[36] = Xe ^ ~Gn & Ar, t[37] = kt ^ ~Jn & Xr, t[46] = ut ^ ~Nt & Ge, t[47] = Be ^ ~Je & Ht, t[8] = An ^ ~Le & Lr, t[9] = mr ^ ~Ne & It, t[18] = qe ^ ~zt & Qn, t[19] = rt ^ ~$t & en, t[28] = ht ^ ~bt & tt, t[29] = ar ^ ~ft & Ze, t[38] = Gn ^ ~Ar & Oe, t[39] = Jn ^ ~Xr & it, t[48] = Nt ^ ~Ge & Ft, t[49] = Je ^ ~Ht & pi, t[0] ^= Iv[e * 2], t[1] ^= Iv[e * 2 + 1];
  }
};
const eh = Pb;
function Pa() {
  this.state = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ], this.blockSize = null, this.count = 0, this.squeezing = !1;
}
Pa.prototype.initialize = function(t, e) {
  for (let r = 0; r < 50; ++r)
    this.state[r] = 0;
  this.blockSize = t / 8, this.count = 0, this.squeezing = !1;
};
Pa.prototype.absorb = function(t) {
  for (let e = 0; e < t.length; ++e)
    this.state[~~(this.count / 4)] ^= t[e] << 8 * (this.count % 4), this.count += 1, this.count === this.blockSize && (eh.p1600(this.state), this.count = 0);
};
Pa.prototype.absorbLastFewBits = function(t) {
  this.state[~~(this.count / 4)] ^= t << 8 * (this.count % 4), t & 128 && this.count === this.blockSize - 1 && eh.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << 8 * ((this.blockSize - 1) % 4), eh.p1600(this.state), this.count = 0, this.squeezing = !0;
};
Pa.prototype.squeeze = function(t) {
  this.squeezing || this.absorbLastFewBits(1);
  const e = Buffer.alloc(t);
  for (let r = 0; r < t; ++r)
    e[r] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 255, this.count += 1, this.count === this.blockSize && (eh.p1600(this.state), this.count = 0);
  return e;
};
Pa.prototype.copy = function(t) {
  for (let e = 0; e < 50; ++e)
    t.state[e] = this.state[e];
  t.blockSize = this.blockSize, t.count = this.count, t.squeezing = this.squeezing;
};
var oM = Pa, z0 = { exports: {} }, Bp = { exports: {} }, ca = typeof Reflect == "object" ? Reflect : null, xv = ca && typeof ca.apply == "function" ? ca.apply : function(e, r, n) {
  return Function.prototype.apply.call(e, r, n);
}, zl;
ca && typeof ca.ownKeys == "function" ? zl = ca.ownKeys : Object.getOwnPropertySymbols ? zl = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : zl = function(e) {
  return Object.getOwnPropertyNames(e);
};
function aM(t) {
  console && console.warn && console.warn(t);
}
var Tb = Number.isNaN || function(e) {
  return e !== e;
};
function jt() {
  jt.init.call(this);
}
Bp.exports = jt;
Bp.exports.once = hM;
jt.EventEmitter = jt;
jt.prototype._events = void 0;
jt.prototype._eventsCount = 0;
jt.prototype._maxListeners = void 0;
var Rv = 10;
function Uh(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(jt, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Rv;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || Tb(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    Rv = t;
  }
});
jt.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
jt.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || Tb(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function Nb(t) {
  return t._maxListeners === void 0 ? jt.defaultMaxListeners : t._maxListeners;
}
jt.prototype.getMaxListeners = function() {
  return Nb(this);
};
jt.prototype.emit = function(e) {
  for (var r = [], n = 1; n < arguments.length; n++)
    r.push(arguments[n]);
  var i = e === "error", o = this._events;
  if (o !== void 0)
    i = i && o.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var c;
    if (r.length > 0 && (c = r[0]), c instanceof Error)
      throw c;
    var u = new Error("Unhandled error." + (c ? " (" + c.message + ")" : ""));
    throw u.context = c, u;
  }
  var l = o[e];
  if (l === void 0)
    return !1;
  if (typeof l == "function")
    xv(l, this, r);
  else
    for (var f = l.length, p = Bb(l, f), n = 0; n < f; ++n)
      xv(p[n], this, r);
  return !0;
};
function kb(t, e, r, n) {
  var i, o, c;
  if (Uh(r), o = t._events, o === void 0 ? (o = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (o.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    r.listener ? r.listener : r
  ), o = t._events), c = o[e]), c === void 0)
    c = o[e] = r, ++t._eventsCount;
  else if (typeof c == "function" ? c = o[e] = n ? [r, c] : [c, r] : n ? c.unshift(r) : c.push(r), i = Nb(t), i > 0 && c.length > i && !c.warned) {
    c.warned = !0;
    var u = new Error("Possible EventEmitter memory leak detected. " + c.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = c.length, aM(u);
  }
  return t;
}
jt.prototype.addListener = function(e, r) {
  return kb(this, e, r, !1);
};
jt.prototype.on = jt.prototype.addListener;
jt.prototype.prependListener = function(e, r) {
  return kb(this, e, r, !0);
};
function cM() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Lb(t, e, r) {
  var n = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r }, i = cM.bind(n);
  return i.listener = r, n.wrapFn = i, i;
}
jt.prototype.once = function(e, r) {
  return Uh(r), this.on(e, Lb(this, e, r)), this;
};
jt.prototype.prependOnceListener = function(e, r) {
  return Uh(r), this.prependListener(e, Lb(this, e, r)), this;
};
jt.prototype.removeListener = function(e, r) {
  var n, i, o, c, u;
  if (Uh(r), i = this._events, i === void 0)
    return this;
  if (n = i[e], n === void 0)
    return this;
  if (n === r || n.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || r));
  else if (typeof n != "function") {
    for (o = -1, c = n.length - 1; c >= 0; c--)
      if (n[c] === r || n[c].listener === r) {
        u = n[c].listener, o = c;
        break;
      }
    if (o < 0)
      return this;
    o === 0 ? n.shift() : uM(n, o), n.length === 1 && (i[e] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", e, u || r);
  }
  return this;
};
jt.prototype.off = jt.prototype.removeListener;
jt.prototype.removeAllListeners = function(e) {
  var r, n, i;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[e]), this;
  if (arguments.length === 0) {
    var o = Object.keys(n), c;
    for (i = 0; i < o.length; ++i)
      c = o[i], c !== "removeListener" && this.removeAllListeners(c);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = n[e], typeof r == "function")
    this.removeListener(e, r);
  else if (r !== void 0)
    for (i = r.length - 1; i >= 0; i--)
      this.removeListener(e, r[i]);
  return this;
};
function $b(t, e, r) {
  var n = t._events;
  if (n === void 0)
    return [];
  var i = n[e];
  return i === void 0 ? [] : typeof i == "function" ? r ? [i.listener || i] : [i] : r ? lM(i) : Bb(i, i.length);
}
jt.prototype.listeners = function(e) {
  return $b(this, e, !0);
};
jt.prototype.rawListeners = function(e) {
  return $b(this, e, !1);
};
jt.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : Fb.call(t, e);
};
jt.prototype.listenerCount = Fb;
function Fb(t) {
  var e = this._events;
  if (e !== void 0) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
jt.prototype.eventNames = function() {
  return this._eventsCount > 0 ? zl(this._events) : [];
};
function Bb(t, e) {
  for (var r = new Array(e), n = 0; n < e; ++n)
    r[n] = t[n];
  return r;
}
function uM(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function lM(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r)
    e[r] = t[r].listener || t[r];
  return e;
}
function hM(t, e) {
  return new Promise(function(r, n) {
    function i(c) {
      t.removeListener(e, o), n(c);
    }
    function o() {
      typeof t.removeListener == "function" && t.removeListener("error", i), r([].slice.call(arguments));
    }
    Ub(t, e, o, { once: !0 }), e !== "error" && fM(t, i, { once: !0 });
  });
}
function fM(t, e, r) {
  typeof t.on == "function" && Ub(t, "error", e, r);
}
function Ub(t, e, r, n) {
  if (typeof t.on == "function")
    n.once ? t.once(e, r) : t.on(e, r);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function i(o) {
      n.once && t.removeEventListener(e, i), r(o);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
var Tr = Bp.exports;
const Up = /* @__PURE__ */ Bc(Tr);
var jb = Tr.EventEmitter, qd, Av;
function dM() {
  if (Av)
    return qd;
  Av = 1;
  function t(R, J) {
    var G = Object.keys(R);
    if (Object.getOwnPropertySymbols) {
      var H = Object.getOwnPropertySymbols(R);
      J && (H = H.filter(function(T) {
        return Object.getOwnPropertyDescriptor(R, T).enumerable;
      })), G.push.apply(G, H);
    }
    return G;
  }
  function e(R) {
    for (var J = 1; J < arguments.length; J++) {
      var G = arguments[J] != null ? arguments[J] : {};
      J % 2 ? t(Object(G), !0).forEach(function(H) {
        r(R, H, G[H]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(G)) : t(Object(G)).forEach(function(H) {
        Object.defineProperty(R, H, Object.getOwnPropertyDescriptor(G, H));
      });
    }
    return R;
  }
  function r(R, J, G) {
    return J = c(J), J in R ? Object.defineProperty(R, J, { value: G, enumerable: !0, configurable: !0, writable: !0 }) : R[J] = G, R;
  }
  function n(R, J) {
    if (!(R instanceof J))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(R, J) {
    for (var G = 0; G < J.length; G++) {
      var H = J[G];
      H.enumerable = H.enumerable || !1, H.configurable = !0, "value" in H && (H.writable = !0), Object.defineProperty(R, c(H.key), H);
    }
  }
  function o(R, J, G) {
    return J && i(R.prototype, J), G && i(R, G), Object.defineProperty(R, "prototype", { writable: !1 }), R;
  }
  function c(R) {
    var J = u(R, "string");
    return typeof J == "symbol" ? J : String(J);
  }
  function u(R, J) {
    if (typeof R != "object" || R === null)
      return R;
    var G = R[Symbol.toPrimitive];
    if (G !== void 0) {
      var H = G.call(R, J || "default");
      if (typeof H != "object")
        return H;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (J === "string" ? String : Number)(R);
  }
  var l = Kc, f = l.Buffer, p = dh, g = p.inspect, y = g && g.custom || "inspect";
  function C(R, J, G) {
    f.prototype.copy.call(R, J, G);
  }
  return qd = /* @__PURE__ */ function() {
    function R() {
      n(this, R), this.head = null, this.tail = null, this.length = 0;
    }
    return o(R, [{
      key: "push",
      value: function(G) {
        var H = {
          data: G,
          next: null
        };
        this.length > 0 ? this.tail.next = H : this.head = H, this.tail = H, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(G) {
        var H = {
          data: G,
          next: this.head
        };
        this.length === 0 && (this.tail = H), this.head = H, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var G = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, G;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(G) {
        if (this.length === 0)
          return "";
        for (var H = this.head, T = "" + H.data; H = H.next; )
          T += G + H.data;
        return T;
      }
    }, {
      key: "concat",
      value: function(G) {
        if (this.length === 0)
          return f.alloc(0);
        for (var H = f.allocUnsafe(G >>> 0), T = this.head, q = 0; T; )
          C(T.data, H, q), q += T.data.length, T = T.next;
        return H;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(G, H) {
        var T;
        return G < this.head.data.length ? (T = this.head.data.slice(0, G), this.head.data = this.head.data.slice(G)) : G === this.head.data.length ? T = this.shift() : T = H ? this._getString(G) : this._getBuffer(G), T;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(G) {
        var H = this.head, T = 1, q = H.data;
        for (G -= q.length; H = H.next; ) {
          var B = H.data, L = G > B.length ? B.length : G;
          if (L === B.length ? q += B : q += B.slice(0, G), G -= L, G === 0) {
            L === B.length ? (++T, H.next ? this.head = H.next : this.head = this.tail = null) : (this.head = H, H.data = B.slice(L));
            break;
          }
          ++T;
        }
        return this.length -= T, q;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(G) {
        var H = f.allocUnsafe(G), T = this.head, q = 1;
        for (T.data.copy(H), G -= T.data.length; T = T.next; ) {
          var B = T.data, L = G > B.length ? B.length : G;
          if (B.copy(H, H.length - G, 0, L), G -= L, G === 0) {
            L === B.length ? (++q, T.next ? this.head = T.next : this.head = this.tail = null) : (this.head = T, T.data = B.slice(L));
            break;
          }
          ++q;
        }
        return this.length -= q, H;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: y,
      value: function(G, H) {
        return g(this, e(e({}, H), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), R;
  }(), qd;
}
function pM(t, e) {
  var r = this, n = this._readableState && this._readableState.destroyed, i = this._writableState && this._writableState.destroyed;
  return n || i ? (e ? e(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(V0, this, t)) : process.nextTick(V0, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(o) {
    !e && o ? r._writableState ? r._writableState.errorEmitted ? process.nextTick(Vl, r) : (r._writableState.errorEmitted = !0, process.nextTick(Mv, r, o)) : process.nextTick(Mv, r, o) : e ? (process.nextTick(Vl, r), e(o)) : process.nextTick(Vl, r);
  }), this);
}
function Mv(t, e) {
  V0(t, e), Vl(t);
}
function Vl(t) {
  t._writableState && !t._writableState.emitClose || t._readableState && !t._readableState.emitClose || t.emit("close");
}
function gM() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function V0(t, e) {
  t.emit("error", e);
}
function mM(t, e) {
  var r = t._readableState, n = t._writableState;
  r && r.autoDestroy || n && n.autoDestroy ? t.destroy(e) : t.emit("error", e);
}
var Hb = {
  destroy: pM,
  undestroy: gM,
  errorOrDestroy: mM
}, Eo = {};
function vM(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
var qb = {};
function Vn(t, e, r) {
  r || (r = Error);
  function n(o, c, u) {
    return typeof e == "string" ? e : e(o, c, u);
  }
  var i = /* @__PURE__ */ function(o) {
    vM(c, o);
    function c(u, l, f) {
      return o.call(this, n(u, l, f)) || this;
    }
    return c;
  }(r);
  i.prototype.name = r.name, i.prototype.code = t, qb[t] = i;
}
function Dv(t, e) {
  if (Array.isArray(t)) {
    var r = t.length;
    return t = t.map(function(n) {
      return String(n);
    }), r > 2 ? "one of ".concat(e, " ").concat(t.slice(0, r - 1).join(", "), ", or ") + t[r - 1] : r === 2 ? "one of ".concat(e, " ").concat(t[0], " or ").concat(t[1]) : "of ".concat(e, " ").concat(t[0]);
  } else
    return "of ".concat(e, " ").concat(String(t));
}
function yM(t, e, r) {
  return t.substr(!r || r < 0 ? 0 : +r, e.length) === e;
}
function _M(t, e, r) {
  return (r === void 0 || r > t.length) && (r = t.length), t.substring(r - e.length, r) === e;
}
function wM(t, e, r) {
  return typeof r != "number" && (r = 0), r + e.length > t.length ? !1 : t.indexOf(e, r) !== -1;
}
Vn("ERR_INVALID_OPT_VALUE", function(t, e) {
  return 'The value "' + e + '" is invalid for option "' + t + '"';
}, TypeError);
Vn("ERR_INVALID_ARG_TYPE", function(t, e, r) {
  var n;
  typeof e == "string" && yM(e, "not ") ? (n = "must not be", e = e.replace(/^not /, "")) : n = "must be";
  var i;
  if (_M(t, " argument"))
    i = "The ".concat(t, " ").concat(n, " ").concat(Dv(e, "type"));
  else {
    var o = wM(t, ".") ? "property" : "argument";
    i = 'The "'.concat(t, '" ').concat(o, " ").concat(n, " ").concat(Dv(e, "type"));
  }
  return i += ". Received type ".concat(typeof r), i;
}, TypeError);
Vn("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
Vn("ERR_METHOD_NOT_IMPLEMENTED", function(t) {
  return "The " + t + " method is not implemented";
});
Vn("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
Vn("ERR_STREAM_DESTROYED", function(t) {
  return "Cannot call " + t + " after a stream was destroyed";
});
Vn("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
Vn("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
Vn("ERR_STREAM_WRITE_AFTER_END", "write after end");
Vn("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
Vn("ERR_UNKNOWN_ENCODING", function(t) {
  return "Unknown encoding: " + t;
}, TypeError);
Vn("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
Eo.codes = qb;
var bM = Eo.codes.ERR_INVALID_OPT_VALUE;
function EM(t, e, r) {
  return t.highWaterMark != null ? t.highWaterMark : e ? t[r] : null;
}
function SM(t, e, r, n) {
  var i = EM(e, n, r);
  if (i != null) {
    if (!(isFinite(i) && Math.floor(i) === i) || i < 0) {
      var o = n ? r : "highWaterMark";
      throw new bM(o, i);
    }
    return Math.floor(i);
  }
  return t.objectMode ? 16 : 16 * 1024;
}
var zb = {
  getHighWaterMark: SM
}, CM = IM;
function IM(t, e) {
  if (zd("noDeprecation"))
    return t;
  var r = !1;
  function n() {
    if (!r) {
      if (zd("throwDeprecation"))
        throw new Error(e);
      zd("traceDeprecation") ? console.trace(e) : console.warn(e), r = !0;
    }
    return t.apply(this, arguments);
  }
  return n;
}
function zd(t) {
  try {
    if (!Te.localStorage)
      return !1;
  } catch {
    return !1;
  }
  var e = Te.localStorage[t];
  return e == null ? !1 : String(e).toLowerCase() === "true";
}
var Vd, Ov;
function Vb() {
  if (Ov)
    return Vd;
  Ov = 1, Vd = N;
  function t(ee) {
    var V = this;
    this.next = null, this.entry = null, this.finish = function() {
      pe(V, ee);
    };
  }
  var e;
  N.WritableState = P;
  var r = {
    deprecate: CM
  }, n = jb, i = Kc.Buffer, o = (typeof Te < "u" ? Te : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function c(ee) {
    return i.from(ee);
  }
  function u(ee) {
    return i.isBuffer(ee) || ee instanceof o;
  }
  var l = Hb, f = zb, p = f.getHighWaterMark, g = Eo.codes, y = g.ERR_INVALID_ARG_TYPE, C = g.ERR_METHOD_NOT_IMPLEMENTED, R = g.ERR_MULTIPLE_CALLBACK, J = g.ERR_STREAM_CANNOT_PIPE, G = g.ERR_STREAM_DESTROYED, H = g.ERR_STREAM_NULL_VALUES, T = g.ERR_STREAM_WRITE_AFTER_END, q = g.ERR_UNKNOWN_ENCODING, B = l.errorOrDestroy;
  hi(N, n);
  function L() {
  }
  function P(ee, V, Q) {
    e = e || Ea(), ee = ee || {}, typeof Q != "boolean" && (Q = V instanceof e), this.objectMode = !!ee.objectMode, Q && (this.objectMode = this.objectMode || !!ee.writableObjectMode), this.highWaterMark = p(this, ee, "writableHighWaterMark", Q), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var X = ee.decodeStrings === !1;
    this.decodeStrings = !X, this.defaultEncoding = ee.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(E) {
      x(V, E);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = ee.emitClose !== !1, this.autoDestroy = !!ee.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  P.prototype.getBuffer = function() {
    for (var V = this.bufferedRequest, Q = []; V; )
      Q.push(V), V = V.next;
    return Q;
  }, function() {
    try {
      Object.defineProperty(P.prototype, "buffer", {
        get: r.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var v;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (v = Function.prototype[Symbol.hasInstance], Object.defineProperty(N, Symbol.hasInstance, {
    value: function(V) {
      return v.call(this, V) ? !0 : this !== N ? !1 : V && V._writableState instanceof P;
    }
  })) : v = function(V) {
    return V instanceof this;
  };
  function N(ee) {
    e = e || Ea();
    var V = this instanceof e;
    if (!V && !v.call(N, this))
      return new N(ee);
    this._writableState = new P(ee, this, V), this.writable = !0, ee && (typeof ee.write == "function" && (this._write = ee.write), typeof ee.writev == "function" && (this._writev = ee.writev), typeof ee.destroy == "function" && (this._destroy = ee.destroy), typeof ee.final == "function" && (this._final = ee.final)), n.call(this);
  }
  N.prototype.pipe = function() {
    B(this, new J());
  };
  function ie(ee, V) {
    var Q = new T();
    B(ee, Q), process.nextTick(V, Q);
  }
  function le(ee, V, Q, X) {
    var E;
    return Q === null ? E = new H() : typeof Q != "string" && !V.objectMode && (E = new y("chunk", ["string", "Buffer"], Q)), E ? (B(ee, E), process.nextTick(X, E), !1) : !0;
  }
  N.prototype.write = function(ee, V, Q) {
    var X = this._writableState, E = !1, I = !X.objectMode && u(ee);
    return I && !i.isBuffer(ee) && (ee = c(ee)), typeof V == "function" && (Q = V, V = null), I ? V = "buffer" : V || (V = X.defaultEncoding), typeof Q != "function" && (Q = L), X.ending ? ie(this, Q) : (I || le(this, X, ee, Q)) && (X.pendingcb++, E = ye(this, X, I, ee, V, Q)), E;
  }, N.prototype.cork = function() {
    this._writableState.corked++;
  }, N.prototype.uncork = function() {
    var ee = this._writableState;
    ee.corked && (ee.corked--, !ee.writing && !ee.corked && !ee.bufferProcessing && ee.bufferedRequest && $(this, ee));
  }, N.prototype.setDefaultEncoding = function(V) {
    if (typeof V == "string" && (V = V.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((V + "").toLowerCase()) > -1))
      throw new q(V);
    return this._writableState.defaultEncoding = V, this;
  }, Object.defineProperty(N.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function he(ee, V, Q) {
    return !ee.objectMode && ee.decodeStrings !== !1 && typeof V == "string" && (V = i.from(V, Q)), V;
  }
  Object.defineProperty(N.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function ye(ee, V, Q, X, E, I) {
    if (!Q) {
      var F = he(V, X, E);
      X !== F && (Q = !0, E = "buffer", X = F);
    }
    var se = V.objectMode ? 1 : X.length;
    V.length += se;
    var fe = V.length < V.highWaterMark;
    if (fe || (V.needDrain = !0), V.writing || V.corked) {
      var Re = V.lastBufferedRequest;
      V.lastBufferedRequest = {
        chunk: X,
        encoding: E,
        isBuf: Q,
        callback: I,
        next: null
      }, Re ? Re.next = V.lastBufferedRequest : V.bufferedRequest = V.lastBufferedRequest, V.bufferedRequestCount += 1;
    } else
      k(ee, V, !1, se, X, E, I);
    return fe;
  }
  function k(ee, V, Q, X, E, I, F) {
    V.writelen = X, V.writecb = F, V.writing = !0, V.sync = !0, V.destroyed ? V.onwrite(new G("write")) : Q ? ee._writev(E, V.onwrite) : ee._write(E, I, V.onwrite), V.sync = !1;
  }
  function h(ee, V, Q, X, E) {
    --V.pendingcb, Q ? (process.nextTick(E, X), process.nextTick(U, ee, V), ee._writableState.errorEmitted = !0, B(ee, X)) : (E(X), ee._writableState.errorEmitted = !0, B(ee, X), U(ee, V));
  }
  function m(ee) {
    ee.writing = !1, ee.writecb = null, ee.length -= ee.writelen, ee.writelen = 0;
  }
  function x(ee, V) {
    var Q = ee._writableState, X = Q.sync, E = Q.writecb;
    if (typeof E != "function")
      throw new R();
    if (m(Q), V)
      h(ee, Q, X, V, E);
    else {
      var I = K(Q) || ee.destroyed;
      !I && !Q.corked && !Q.bufferProcessing && Q.bufferedRequest && $(ee, Q), X ? process.nextTick(M, ee, Q, I, E) : M(ee, Q, I, E);
    }
  }
  function M(ee, V, Q, X) {
    Q || A(ee, V), V.pendingcb--, X(), U(ee, V);
  }
  function A(ee, V) {
    V.length === 0 && V.needDrain && (V.needDrain = !1, ee.emit("drain"));
  }
  function $(ee, V) {
    V.bufferProcessing = !0;
    var Q = V.bufferedRequest;
    if (ee._writev && Q && Q.next) {
      var X = V.bufferedRequestCount, E = new Array(X), I = V.corkedRequestsFree;
      I.entry = Q;
      for (var F = 0, se = !0; Q; )
        E[F] = Q, Q.isBuf || (se = !1), Q = Q.next, F += 1;
      E.allBuffers = se, k(ee, V, !0, V.length, E, "", I.finish), V.pendingcb++, V.lastBufferedRequest = null, I.next ? (V.corkedRequestsFree = I.next, I.next = null) : V.corkedRequestsFree = new t(V), V.bufferedRequestCount = 0;
    } else {
      for (; Q; ) {
        var fe = Q.chunk, Re = Q.encoding, j = Q.callback, b = V.objectMode ? 1 : fe.length;
        if (k(ee, V, !1, b, fe, Re, j), Q = Q.next, V.bufferedRequestCount--, V.writing)
          break;
      }
      Q === null && (V.lastBufferedRequest = null);
    }
    V.bufferedRequest = Q, V.bufferProcessing = !1;
  }
  N.prototype._write = function(ee, V, Q) {
    Q(new C("_write()"));
  }, N.prototype._writev = null, N.prototype.end = function(ee, V, Q) {
    var X = this._writableState;
    return typeof ee == "function" ? (Q = ee, ee = null, V = null) : typeof V == "function" && (Q = V, V = null), ee != null && this.write(ee, V), X.corked && (X.corked = 1, this.uncork()), X.ending || me(this, X, Q), this;
  }, Object.defineProperty(N.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function K(ee) {
    return ee.ending && ee.length === 0 && ee.bufferedRequest === null && !ee.finished && !ee.writing;
  }
  function D(ee, V) {
    ee._final(function(Q) {
      V.pendingcb--, Q && B(ee, Q), V.prefinished = !0, ee.emit("prefinish"), U(ee, V);
    });
  }
  function w(ee, V) {
    !V.prefinished && !V.finalCalled && (typeof ee._final == "function" && !V.destroyed ? (V.pendingcb++, V.finalCalled = !0, process.nextTick(D, ee, V)) : (V.prefinished = !0, ee.emit("prefinish")));
  }
  function U(ee, V) {
    var Q = K(V);
    if (Q && (w(ee, V), V.pendingcb === 0 && (V.finished = !0, ee.emit("finish"), V.autoDestroy))) {
      var X = ee._readableState;
      (!X || X.autoDestroy && X.endEmitted) && ee.destroy();
    }
    return Q;
  }
  function me(ee, V, Q) {
    V.ending = !0, U(ee, V), Q && (V.finished ? process.nextTick(Q) : ee.once("finish", Q)), V.ended = !0, ee.writable = !1;
  }
  function pe(ee, V, Q) {
    var X = ee.entry;
    for (ee.entry = null; X; ) {
      var E = X.callback;
      V.pendingcb--, E(Q), X = X.next;
    }
    V.corkedRequestsFree.next = ee;
  }
  return Object.defineProperty(N.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(V) {
      this._writableState && (this._writableState.destroyed = V);
    }
  }), N.prototype.destroy = l.destroy, N.prototype._undestroy = l.undestroy, N.prototype._destroy = function(ee, V) {
    V(ee);
  }, Vd;
}
var Wd, Pv;
function Ea() {
  if (Pv)
    return Wd;
  Pv = 1;
  var t = Object.keys || function(f) {
    var p = [];
    for (var g in f)
      p.push(g);
    return p;
  };
  Wd = c;
  var e = Kb(), r = Vb();
  hi(c, e);
  for (var n = t(r.prototype), i = 0; i < n.length; i++) {
    var o = n[i];
    c.prototype[o] || (c.prototype[o] = r.prototype[o]);
  }
  function c(f) {
    if (!(this instanceof c))
      return new c(f);
    e.call(this, f), r.call(this, f), this.allowHalfOpen = !0, f && (f.readable === !1 && (this.readable = !1), f.writable === !1 && (this.writable = !1), f.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", u)));
  }
  Object.defineProperty(c.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(c.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(c.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function u() {
    this._writableState.ended || process.nextTick(l, this);
  }
  function l(f) {
    f.end();
  }
  return Object.defineProperty(c.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(p) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = p, this._writableState.destroyed = p);
    }
  }), Wd;
}
var Kd = {}, Tv;
function Nv() {
  if (Tv)
    return Kd;
  Tv = 1;
  var t = As.Buffer, e = t.isEncoding || function(H) {
    switch (H = "" + H, H && H.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function r(H) {
    if (!H)
      return "utf8";
    for (var T; ; )
      switch (H) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return H;
        default:
          if (T)
            return;
          H = ("" + H).toLowerCase(), T = !0;
      }
  }
  function n(H) {
    var T = r(H);
    if (typeof T != "string" && (t.isEncoding === e || !e(H)))
      throw new Error("Unknown encoding: " + H);
    return T || H;
  }
  Kd.StringDecoder = i;
  function i(H) {
    this.encoding = n(H);
    var T;
    switch (this.encoding) {
      case "utf16le":
        this.text = g, this.end = y, T = 4;
        break;
      case "utf8":
        this.fillLast = l, T = 4;
        break;
      case "base64":
        this.text = C, this.end = R, T = 3;
        break;
      default:
        this.write = J, this.end = G;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = t.allocUnsafe(T);
  }
  i.prototype.write = function(H) {
    if (H.length === 0)
      return "";
    var T, q;
    if (this.lastNeed) {
      if (T = this.fillLast(H), T === void 0)
        return "";
      q = this.lastNeed, this.lastNeed = 0;
    } else
      q = 0;
    return q < H.length ? T ? T + this.text(H, q) : this.text(H, q) : T || "";
  }, i.prototype.end = p, i.prototype.text = f, i.prototype.fillLast = function(H) {
    if (this.lastNeed <= H.length)
      return H.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    H.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, H.length), this.lastNeed -= H.length;
  };
  function o(H) {
    return H <= 127 ? 0 : H >> 5 === 6 ? 2 : H >> 4 === 14 ? 3 : H >> 3 === 30 ? 4 : H >> 6 === 2 ? -1 : -2;
  }
  function c(H, T, q) {
    var B = T.length - 1;
    if (B < q)
      return 0;
    var L = o(T[B]);
    return L >= 0 ? (L > 0 && (H.lastNeed = L - 1), L) : --B < q || L === -2 ? 0 : (L = o(T[B]), L >= 0 ? (L > 0 && (H.lastNeed = L - 2), L) : --B < q || L === -2 ? 0 : (L = o(T[B]), L >= 0 ? (L > 0 && (L === 2 ? L = 0 : H.lastNeed = L - 3), L) : 0));
  }
  function u(H, T, q) {
    if ((T[0] & 192) !== 128)
      return H.lastNeed = 0, "�";
    if (H.lastNeed > 1 && T.length > 1) {
      if ((T[1] & 192) !== 128)
        return H.lastNeed = 1, "�";
      if (H.lastNeed > 2 && T.length > 2 && (T[2] & 192) !== 128)
        return H.lastNeed = 2, "�";
    }
  }
  function l(H) {
    var T = this.lastTotal - this.lastNeed, q = u(this, H);
    if (q !== void 0)
      return q;
    if (this.lastNeed <= H.length)
      return H.copy(this.lastChar, T, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    H.copy(this.lastChar, T, 0, H.length), this.lastNeed -= H.length;
  }
  function f(H, T) {
    var q = c(this, H, T);
    if (!this.lastNeed)
      return H.toString("utf8", T);
    this.lastTotal = q;
    var B = H.length - (q - this.lastNeed);
    return H.copy(this.lastChar, 0, B), H.toString("utf8", T, B);
  }
  function p(H) {
    var T = H && H.length ? this.write(H) : "";
    return this.lastNeed ? T + "�" : T;
  }
  function g(H, T) {
    if ((H.length - T) % 2 === 0) {
      var q = H.toString("utf16le", T);
      if (q) {
        var B = q.charCodeAt(q.length - 1);
        if (B >= 55296 && B <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = H[H.length - 2], this.lastChar[1] = H[H.length - 1], q.slice(0, -1);
      }
      return q;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = H[H.length - 1], H.toString("utf16le", T, H.length - 1);
  }
  function y(H) {
    var T = H && H.length ? this.write(H) : "";
    if (this.lastNeed) {
      var q = this.lastTotal - this.lastNeed;
      return T + this.lastChar.toString("utf16le", 0, q);
    }
    return T;
  }
  function C(H, T) {
    var q = (H.length - T) % 3;
    return q === 0 ? H.toString("base64", T) : (this.lastNeed = 3 - q, this.lastTotal = 3, q === 1 ? this.lastChar[0] = H[H.length - 1] : (this.lastChar[0] = H[H.length - 2], this.lastChar[1] = H[H.length - 1]), H.toString("base64", T, H.length - q));
  }
  function R(H) {
    var T = H && H.length ? this.write(H) : "";
    return this.lastNeed ? T + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : T;
  }
  function J(H) {
    return H.toString(this.encoding);
  }
  function G(H) {
    return H && H.length ? this.write(H) : "";
  }
  return Kd;
}
var kv = Eo.codes.ERR_STREAM_PREMATURE_CLOSE;
function xM(t) {
  var e = !1;
  return function() {
    if (!e) {
      e = !0;
      for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
        n[i] = arguments[i];
      t.apply(this, n);
    }
  };
}
function RM() {
}
function AM(t) {
  return t.setHeader && typeof t.abort == "function";
}
function Wb(t, e, r) {
  if (typeof e == "function")
    return Wb(t, null, e);
  e || (e = {}), r = xM(r || RM);
  var n = e.readable || e.readable !== !1 && t.readable, i = e.writable || e.writable !== !1 && t.writable, o = function() {
    t.writable || u();
  }, c = t._writableState && t._writableState.finished, u = function() {
    i = !1, c = !0, n || r.call(t);
  }, l = t._readableState && t._readableState.endEmitted, f = function() {
    n = !1, l = !0, i || r.call(t);
  }, p = function(R) {
    r.call(t, R);
  }, g = function() {
    var R;
    if (n && !l)
      return (!t._readableState || !t._readableState.ended) && (R = new kv()), r.call(t, R);
    if (i && !c)
      return (!t._writableState || !t._writableState.ended) && (R = new kv()), r.call(t, R);
  }, y = function() {
    t.req.on("finish", u);
  };
  return AM(t) ? (t.on("complete", u), t.on("abort", g), t.req ? y() : t.on("request", y)) : i && !t._writableState && (t.on("end", o), t.on("close", o)), t.on("end", f), t.on("finish", u), e.error !== !1 && t.on("error", p), t.on("close", g), function() {
    t.removeListener("complete", u), t.removeListener("abort", g), t.removeListener("request", y), t.req && t.req.removeListener("finish", u), t.removeListener("end", o), t.removeListener("close", o), t.removeListener("finish", u), t.removeListener("end", f), t.removeListener("error", p), t.removeListener("close", g);
  };
}
var jp = Wb, Gd, Lv;
function MM() {
  if (Lv)
    return Gd;
  Lv = 1;
  var t;
  function e(q, B, L) {
    return B = r(B), B in q ? Object.defineProperty(q, B, { value: L, enumerable: !0, configurable: !0, writable: !0 }) : q[B] = L, q;
  }
  function r(q) {
    var B = n(q, "string");
    return typeof B == "symbol" ? B : String(B);
  }
  function n(q, B) {
    if (typeof q != "object" || q === null)
      return q;
    var L = q[Symbol.toPrimitive];
    if (L !== void 0) {
      var P = L.call(q, B || "default");
      if (typeof P != "object")
        return P;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (B === "string" ? String : Number)(q);
  }
  var i = jp, o = Symbol("lastResolve"), c = Symbol("lastReject"), u = Symbol("error"), l = Symbol("ended"), f = Symbol("lastPromise"), p = Symbol("handlePromise"), g = Symbol("stream");
  function y(q, B) {
    return {
      value: q,
      done: B
    };
  }
  function C(q) {
    var B = q[o];
    if (B !== null) {
      var L = q[g].read();
      L !== null && (q[f] = null, q[o] = null, q[c] = null, B(y(L, !1)));
    }
  }
  function R(q) {
    process.nextTick(C, q);
  }
  function J(q, B) {
    return function(L, P) {
      q.then(function() {
        if (B[l]) {
          L(y(void 0, !0));
          return;
        }
        B[p](L, P);
      }, P);
    };
  }
  var G = Object.getPrototypeOf(function() {
  }), H = Object.setPrototypeOf((t = {
    get stream() {
      return this[g];
    },
    next: function() {
      var B = this, L = this[u];
      if (L !== null)
        return Promise.reject(L);
      if (this[l])
        return Promise.resolve(y(void 0, !0));
      if (this[g].destroyed)
        return new Promise(function(ie, le) {
          process.nextTick(function() {
            B[u] ? le(B[u]) : ie(y(void 0, !0));
          });
        });
      var P = this[f], v;
      if (P)
        v = new Promise(J(P, this));
      else {
        var N = this[g].read();
        if (N !== null)
          return Promise.resolve(y(N, !1));
        v = new Promise(this[p]);
      }
      return this[f] = v, v;
    }
  }, e(t, Symbol.asyncIterator, function() {
    return this;
  }), e(t, "return", function() {
    var B = this;
    return new Promise(function(L, P) {
      B[g].destroy(null, function(v) {
        if (v) {
          P(v);
          return;
        }
        L(y(void 0, !0));
      });
    });
  }), t), G), T = function(B) {
    var L, P = Object.create(H, (L = {}, e(L, g, {
      value: B,
      writable: !0
    }), e(L, o, {
      value: null,
      writable: !0
    }), e(L, c, {
      value: null,
      writable: !0
    }), e(L, u, {
      value: null,
      writable: !0
    }), e(L, l, {
      value: B._readableState.endEmitted,
      writable: !0
    }), e(L, p, {
      value: function(N, ie) {
        var le = P[g].read();
        le ? (P[f] = null, P[o] = null, P[c] = null, N(y(le, !1))) : (P[o] = N, P[c] = ie);
      },
      writable: !0
    }), L));
    return P[f] = null, i(B, function(v) {
      if (v && v.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var N = P[c];
        N !== null && (P[f] = null, P[o] = null, P[c] = null, N(v)), P[u] = v;
        return;
      }
      var ie = P[o];
      ie !== null && (P[f] = null, P[o] = null, P[c] = null, ie(y(void 0, !0))), P[l] = !0;
    }), B.on("readable", R.bind(null, P)), P;
  };
  return Gd = T, Gd;
}
var Jd, $v;
function DM() {
  return $v || ($v = 1, Jd = function() {
    throw new Error("Readable.from is not available in the browser");
  }), Jd;
}
var Qd, Fv;
function Kb() {
  if (Fv)
    return Qd;
  Fv = 1, Qd = ie;
  var t;
  ie.ReadableState = N, Tr.EventEmitter;
  var e = function(F, se) {
    return F.listeners(se).length;
  }, r = jb, n = Kc.Buffer, i = (typeof Te < "u" ? Te : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function o(I) {
    return n.from(I);
  }
  function c(I) {
    return n.isBuffer(I) || I instanceof i;
  }
  var u = dh, l;
  u && u.debuglog ? l = u.debuglog("stream") : l = function() {
  };
  var f = dM(), p = Hb, g = zb, y = g.getHighWaterMark, C = Eo.codes, R = C.ERR_INVALID_ARG_TYPE, J = C.ERR_STREAM_PUSH_AFTER_EOF, G = C.ERR_METHOD_NOT_IMPLEMENTED, H = C.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, T, q, B;
  hi(ie, r);
  var L = p.errorOrDestroy, P = ["error", "close", "destroy", "pause", "resume"];
  function v(I, F, se) {
    if (typeof I.prependListener == "function")
      return I.prependListener(F, se);
    !I._events || !I._events[F] ? I.on(F, se) : Array.isArray(I._events[F]) ? I._events[F].unshift(se) : I._events[F] = [se, I._events[F]];
  }
  function N(I, F, se) {
    t = t || Ea(), I = I || {}, typeof se != "boolean" && (se = F instanceof t), this.objectMode = !!I.objectMode, se && (this.objectMode = this.objectMode || !!I.readableObjectMode), this.highWaterMark = y(this, I, "readableHighWaterMark", se), this.buffer = new f(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = I.emitClose !== !1, this.autoDestroy = !!I.autoDestroy, this.destroyed = !1, this.defaultEncoding = I.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, I.encoding && (T || (T = Nv().StringDecoder), this.decoder = new T(I.encoding), this.encoding = I.encoding);
  }
  function ie(I) {
    if (t = t || Ea(), !(this instanceof ie))
      return new ie(I);
    var F = this instanceof t;
    this._readableState = new N(I, this, F), this.readable = !0, I && (typeof I.read == "function" && (this._read = I.read), typeof I.destroy == "function" && (this._destroy = I.destroy)), r.call(this);
  }
  Object.defineProperty(ie.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(F) {
      this._readableState && (this._readableState.destroyed = F);
    }
  }), ie.prototype.destroy = p.destroy, ie.prototype._undestroy = p.undestroy, ie.prototype._destroy = function(I, F) {
    F(I);
  }, ie.prototype.push = function(I, F) {
    var se = this._readableState, fe;
    return se.objectMode ? fe = !0 : typeof I == "string" && (F = F || se.defaultEncoding, F !== se.encoding && (I = n.from(I, F), F = ""), fe = !0), le(this, I, F, !1, fe);
  }, ie.prototype.unshift = function(I) {
    return le(this, I, null, !0, !1);
  };
  function le(I, F, se, fe, Re) {
    l("readableAddChunk", F);
    var j = I._readableState;
    if (F === null)
      j.reading = !1, x(I, j);
    else {
      var b;
      if (Re || (b = ye(j, F)), b)
        L(I, b);
      else if (j.objectMode || F && F.length > 0)
        if (typeof F != "string" && !j.objectMode && Object.getPrototypeOf(F) !== n.prototype && (F = o(F)), fe)
          j.endEmitted ? L(I, new H()) : he(I, j, F, !0);
        else if (j.ended)
          L(I, new J());
        else {
          if (j.destroyed)
            return !1;
          j.reading = !1, j.decoder && !se ? (F = j.decoder.write(F), j.objectMode || F.length !== 0 ? he(I, j, F, !1) : $(I, j)) : he(I, j, F, !1);
        }
      else
        fe || (j.reading = !1, $(I, j));
    }
    return !j.ended && (j.length < j.highWaterMark || j.length === 0);
  }
  function he(I, F, se, fe) {
    F.flowing && F.length === 0 && !F.sync ? (F.awaitDrain = 0, I.emit("data", se)) : (F.length += F.objectMode ? 1 : se.length, fe ? F.buffer.unshift(se) : F.buffer.push(se), F.needReadable && M(I)), $(I, F);
  }
  function ye(I, F) {
    var se;
    return !c(F) && typeof F != "string" && F !== void 0 && !I.objectMode && (se = new R("chunk", ["string", "Buffer", "Uint8Array"], F)), se;
  }
  ie.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, ie.prototype.setEncoding = function(I) {
    T || (T = Nv().StringDecoder);
    var F = new T(I);
    this._readableState.decoder = F, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var se = this._readableState.buffer.head, fe = ""; se !== null; )
      fe += F.write(se.data), se = se.next;
    return this._readableState.buffer.clear(), fe !== "" && this._readableState.buffer.push(fe), this._readableState.length = fe.length, this;
  };
  var k = 1073741824;
  function h(I) {
    return I >= k ? I = k : (I--, I |= I >>> 1, I |= I >>> 2, I |= I >>> 4, I |= I >>> 8, I |= I >>> 16, I++), I;
  }
  function m(I, F) {
    return I <= 0 || F.length === 0 && F.ended ? 0 : F.objectMode ? 1 : I !== I ? F.flowing && F.length ? F.buffer.head.data.length : F.length : (I > F.highWaterMark && (F.highWaterMark = h(I)), I <= F.length ? I : F.ended ? F.length : (F.needReadable = !0, 0));
  }
  ie.prototype.read = function(I) {
    l("read", I), I = parseInt(I, 10);
    var F = this._readableState, se = I;
    if (I !== 0 && (F.emittedReadable = !1), I === 0 && F.needReadable && ((F.highWaterMark !== 0 ? F.length >= F.highWaterMark : F.length > 0) || F.ended))
      return l("read: emitReadable", F.length, F.ended), F.length === 0 && F.ended ? Q(this) : M(this), null;
    if (I = m(I, F), I === 0 && F.ended)
      return F.length === 0 && Q(this), null;
    var fe = F.needReadable;
    l("need readable", fe), (F.length === 0 || F.length - I < F.highWaterMark) && (fe = !0, l("length less than watermark", fe)), F.ended || F.reading ? (fe = !1, l("reading or ended", fe)) : fe && (l("do read"), F.reading = !0, F.sync = !0, F.length === 0 && (F.needReadable = !0), this._read(F.highWaterMark), F.sync = !1, F.reading || (I = m(se, F)));
    var Re;
    return I > 0 ? Re = V(I, F) : Re = null, Re === null ? (F.needReadable = F.length <= F.highWaterMark, I = 0) : (F.length -= I, F.awaitDrain = 0), F.length === 0 && (F.ended || (F.needReadable = !0), se !== I && F.ended && Q(this)), Re !== null && this.emit("data", Re), Re;
  };
  function x(I, F) {
    if (l("onEofChunk"), !F.ended) {
      if (F.decoder) {
        var se = F.decoder.end();
        se && se.length && (F.buffer.push(se), F.length += F.objectMode ? 1 : se.length);
      }
      F.ended = !0, F.sync ? M(I) : (F.needReadable = !1, F.emittedReadable || (F.emittedReadable = !0, A(I)));
    }
  }
  function M(I) {
    var F = I._readableState;
    l("emitReadable", F.needReadable, F.emittedReadable), F.needReadable = !1, F.emittedReadable || (l("emitReadable", F.flowing), F.emittedReadable = !0, process.nextTick(A, I));
  }
  function A(I) {
    var F = I._readableState;
    l("emitReadable_", F.destroyed, F.length, F.ended), !F.destroyed && (F.length || F.ended) && (I.emit("readable"), F.emittedReadable = !1), F.needReadable = !F.flowing && !F.ended && F.length <= F.highWaterMark, ee(I);
  }
  function $(I, F) {
    F.readingMore || (F.readingMore = !0, process.nextTick(K, I, F));
  }
  function K(I, F) {
    for (; !F.reading && !F.ended && (F.length < F.highWaterMark || F.flowing && F.length === 0); ) {
      var se = F.length;
      if (l("maybeReadMore read 0"), I.read(0), se === F.length)
        break;
    }
    F.readingMore = !1;
  }
  ie.prototype._read = function(I) {
    L(this, new G("_read()"));
  }, ie.prototype.pipe = function(I, F) {
    var se = this, fe = this._readableState;
    switch (fe.pipesCount) {
      case 0:
        fe.pipes = I;
        break;
      case 1:
        fe.pipes = [fe.pipes, I];
        break;
      default:
        fe.pipes.push(I);
        break;
    }
    fe.pipesCount += 1, l("pipe count=%d opts=%j", fe.pipesCount, F);
    var Re = (!F || F.end !== !1) && I !== process.stdout && I !== process.stderr, j = Re ? S : xe;
    fe.endEmitted ? process.nextTick(j) : se.once("end", j), I.on("unpipe", b);
    function b(Se, Le) {
      l("onunpipe"), Se === se && Le && Le.hasUnpiped === !1 && (Le.hasUnpiped = !0, ue());
    }
    function S() {
      l("onend"), I.end();
    }
    var Z = D(se);
    I.on("drain", Z);
    var re = !1;
    function ue() {
      l("cleanup"), I.removeListener("close", Ie), I.removeListener("finish", Ae), I.removeListener("drain", Z), I.removeListener("error", Ee), I.removeListener("unpipe", b), se.removeListener("end", S), se.removeListener("end", xe), se.removeListener("data", ge), re = !0, fe.awaitDrain && (!I._writableState || I._writableState.needDrain) && Z();
    }
    se.on("data", ge);
    function ge(Se) {
      l("ondata");
      var Le = I.write(Se);
      l("dest.write", Le), Le === !1 && ((fe.pipesCount === 1 && fe.pipes === I || fe.pipesCount > 1 && E(fe.pipes, I) !== -1) && !re && (l("false write response, pause", fe.awaitDrain), fe.awaitDrain++), se.pause());
    }
    function Ee(Se) {
      l("onerror", Se), xe(), I.removeListener("error", Ee), e(I, "error") === 0 && L(I, Se);
    }
    v(I, "error", Ee);
    function Ie() {
      I.removeListener("finish", Ae), xe();
    }
    I.once("close", Ie);
    function Ae() {
      l("onfinish"), I.removeListener("close", Ie), xe();
    }
    I.once("finish", Ae);
    function xe() {
      l("unpipe"), se.unpipe(I);
    }
    return I.emit("pipe", se), fe.flowing || (l("pipe resume"), se.resume()), I;
  };
  function D(I) {
    return function() {
      var se = I._readableState;
      l("pipeOnDrain", se.awaitDrain), se.awaitDrain && se.awaitDrain--, se.awaitDrain === 0 && e(I, "data") && (se.flowing = !0, ee(I));
    };
  }
  ie.prototype.unpipe = function(I) {
    var F = this._readableState, se = {
      hasUnpiped: !1
    };
    if (F.pipesCount === 0)
      return this;
    if (F.pipesCount === 1)
      return I && I !== F.pipes ? this : (I || (I = F.pipes), F.pipes = null, F.pipesCount = 0, F.flowing = !1, I && I.emit("unpipe", this, se), this);
    if (!I) {
      var fe = F.pipes, Re = F.pipesCount;
      F.pipes = null, F.pipesCount = 0, F.flowing = !1;
      for (var j = 0; j < Re; j++)
        fe[j].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var b = E(F.pipes, I);
    return b === -1 ? this : (F.pipes.splice(b, 1), F.pipesCount -= 1, F.pipesCount === 1 && (F.pipes = F.pipes[0]), I.emit("unpipe", this, se), this);
  }, ie.prototype.on = function(I, F) {
    var se = r.prototype.on.call(this, I, F), fe = this._readableState;
    return I === "data" ? (fe.readableListening = this.listenerCount("readable") > 0, fe.flowing !== !1 && this.resume()) : I === "readable" && !fe.endEmitted && !fe.readableListening && (fe.readableListening = fe.needReadable = !0, fe.flowing = !1, fe.emittedReadable = !1, l("on readable", fe.length, fe.reading), fe.length ? M(this) : fe.reading || process.nextTick(U, this)), se;
  }, ie.prototype.addListener = ie.prototype.on, ie.prototype.removeListener = function(I, F) {
    var se = r.prototype.removeListener.call(this, I, F);
    return I === "readable" && process.nextTick(w, this), se;
  }, ie.prototype.removeAllListeners = function(I) {
    var F = r.prototype.removeAllListeners.apply(this, arguments);
    return (I === "readable" || I === void 0) && process.nextTick(w, this), F;
  };
  function w(I) {
    var F = I._readableState;
    F.readableListening = I.listenerCount("readable") > 0, F.resumeScheduled && !F.paused ? F.flowing = !0 : I.listenerCount("data") > 0 && I.resume();
  }
  function U(I) {
    l("readable nexttick read 0"), I.read(0);
  }
  ie.prototype.resume = function() {
    var I = this._readableState;
    return I.flowing || (l("resume"), I.flowing = !I.readableListening, me(this, I)), I.paused = !1, this;
  };
  function me(I, F) {
    F.resumeScheduled || (F.resumeScheduled = !0, process.nextTick(pe, I, F));
  }
  function pe(I, F) {
    l("resume", F.reading), F.reading || I.read(0), F.resumeScheduled = !1, I.emit("resume"), ee(I), F.flowing && !F.reading && I.read(0);
  }
  ie.prototype.pause = function() {
    return l("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (l("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function ee(I) {
    var F = I._readableState;
    for (l("flow", F.flowing); F.flowing && I.read() !== null; )
      ;
  }
  ie.prototype.wrap = function(I) {
    var F = this, se = this._readableState, fe = !1;
    I.on("end", function() {
      if (l("wrapped end"), se.decoder && !se.ended) {
        var b = se.decoder.end();
        b && b.length && F.push(b);
      }
      F.push(null);
    }), I.on("data", function(b) {
      if (l("wrapped data"), se.decoder && (b = se.decoder.write(b)), !(se.objectMode && b == null) && !(!se.objectMode && (!b || !b.length))) {
        var S = F.push(b);
        S || (fe = !0, I.pause());
      }
    });
    for (var Re in I)
      this[Re] === void 0 && typeof I[Re] == "function" && (this[Re] = /* @__PURE__ */ function(S) {
        return function() {
          return I[S].apply(I, arguments);
        };
      }(Re));
    for (var j = 0; j < P.length; j++)
      I.on(P[j], this.emit.bind(this, P[j]));
    return this._read = function(b) {
      l("wrapped _read", b), fe && (fe = !1, I.resume());
    }, this;
  }, typeof Symbol == "function" && (ie.prototype[Symbol.asyncIterator] = function() {
    return q === void 0 && (q = MM()), q(this);
  }), Object.defineProperty(ie.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(ie.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(ie.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(F) {
      this._readableState && (this._readableState.flowing = F);
    }
  }), ie._fromList = V, Object.defineProperty(ie.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function V(I, F) {
    if (F.length === 0)
      return null;
    var se;
    return F.objectMode ? se = F.buffer.shift() : !I || I >= F.length ? (F.decoder ? se = F.buffer.join("") : F.buffer.length === 1 ? se = F.buffer.first() : se = F.buffer.concat(F.length), F.buffer.clear()) : se = F.buffer.consume(I, F.decoder), se;
  }
  function Q(I) {
    var F = I._readableState;
    l("endReadable", F.endEmitted), F.endEmitted || (F.ended = !0, process.nextTick(X, F, I));
  }
  function X(I, F) {
    if (l("endReadableNT", I.endEmitted, I.length), !I.endEmitted && I.length === 0 && (I.endEmitted = !0, F.readable = !1, F.emit("end"), I.autoDestroy)) {
      var se = F._writableState;
      (!se || se.autoDestroy && se.finished) && F.destroy();
    }
  }
  typeof Symbol == "function" && (ie.from = function(I, F) {
    return B === void 0 && (B = DM()), B(ie, I, F);
  });
  function E(I, F) {
    for (var se = 0, fe = I.length; se < fe; se++)
      if (I[se] === F)
        return se;
    return -1;
  }
  return Qd;
}
var Gb = ns, jh = Eo.codes, OM = jh.ERR_METHOD_NOT_IMPLEMENTED, PM = jh.ERR_MULTIPLE_CALLBACK, TM = jh.ERR_TRANSFORM_ALREADY_TRANSFORMING, NM = jh.ERR_TRANSFORM_WITH_LENGTH_0, Hh = Ea();
hi(ns, Hh);
function kM(t, e) {
  var r = this._transformState;
  r.transforming = !1;
  var n = r.writecb;
  if (n === null)
    return this.emit("error", new PM());
  r.writechunk = null, r.writecb = null, e != null && this.push(e), n(t);
  var i = this._readableState;
  i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
}
function ns(t) {
  if (!(this instanceof ns))
    return new ns(t);
  Hh.call(this, t), this._transformState = {
    afterTransform: kM.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.on("prefinish", LM);
}
function LM() {
  var t = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(e, r) {
    Bv(t, e, r);
  }) : Bv(this, null, null);
}
ns.prototype.push = function(t, e) {
  return this._transformState.needTransform = !1, Hh.prototype.push.call(this, t, e);
};
ns.prototype._transform = function(t, e, r) {
  r(new OM("_transform()"));
};
ns.prototype._write = function(t, e, r) {
  var n = this._transformState;
  if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
ns.prototype._read = function(t) {
  var e = this._transformState;
  e.writechunk !== null && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
ns.prototype._destroy = function(t, e) {
  Hh.prototype._destroy.call(this, t, function(r) {
    e(r);
  });
};
function Bv(t, e, r) {
  if (e)
    return t.emit("error", e);
  if (r != null && t.push(r), t._writableState.length)
    throw new NM();
  if (t._transformState.transforming)
    throw new TM();
  return t.push(null);
}
var $M = Pc, Jb = Gb;
hi(Pc, Jb);
function Pc(t) {
  if (!(this instanceof Pc))
    return new Pc(t);
  Jb.call(this, t);
}
Pc.prototype._transform = function(t, e, r) {
  r(null, t);
};
var Zd;
function FM(t) {
  var e = !1;
  return function() {
    e || (e = !0, t.apply(void 0, arguments));
  };
}
var Qb = Eo.codes, BM = Qb.ERR_MISSING_ARGS, UM = Qb.ERR_STREAM_DESTROYED;
function Uv(t) {
  if (t)
    throw t;
}
function jM(t) {
  return t.setHeader && typeof t.abort == "function";
}
function HM(t, e, r, n) {
  n = FM(n);
  var i = !1;
  t.on("close", function() {
    i = !0;
  }), Zd === void 0 && (Zd = jp), Zd(t, {
    readable: e,
    writable: r
  }, function(c) {
    if (c)
      return n(c);
    i = !0, n();
  });
  var o = !1;
  return function(c) {
    if (!i && !o) {
      if (o = !0, jM(t))
        return t.abort();
      if (typeof t.destroy == "function")
        return t.destroy();
      n(c || new UM("pipe"));
    }
  };
}
function jv(t) {
  t();
}
function qM(t, e) {
  return t.pipe(e);
}
function zM(t) {
  return !t.length || typeof t[t.length - 1] != "function" ? Uv : t.pop();
}
function VM() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var n = zM(e);
  if (Array.isArray(e[0]) && (e = e[0]), e.length < 2)
    throw new BM("streams");
  var i, o = e.map(function(c, u) {
    var l = u < e.length - 1, f = u > 0;
    return HM(c, l, f, function(p) {
      i || (i = p), p && o.forEach(jv), !l && (o.forEach(jv), n(i));
    });
  });
  return e.reduce(qM);
}
var WM = VM;
(function(t, e) {
  e = t.exports = Kb(), e.Stream = e, e.Readable = e, e.Writable = Vb(), e.Duplex = Ea(), e.Transform = Gb, e.PassThrough = $M, e.finished = jp, e.pipeline = WM;
})(z0, z0.exports);
var Zb = z0.exports;
const { Transform: KM } = Zb;
var GM = (t) => class Yb extends KM {
  constructor(r, n, i, o, c) {
    super(c), this._rate = r, this._capacity = n, this._delimitedSuffix = i, this._hashBitLength = o, this._options = c, this._state = new t(), this._state.initialize(r, n), this._finalized = !1;
  }
  _transform(r, n, i) {
    let o = null;
    try {
      this.update(r, n);
    } catch (c) {
      o = c;
    }
    i(o);
  }
  _flush(r) {
    let n = null;
    try {
      this.push(this.digest());
    } catch (i) {
      n = i;
    }
    r(n);
  }
  update(r, n) {
    if (!Buffer.isBuffer(r) && typeof r != "string")
      throw new TypeError("Data must be a string or a buffer");
    if (this._finalized)
      throw new Error("Digest already called");
    return Buffer.isBuffer(r) || (r = Buffer.from(r, n)), this._state.absorb(r), this;
  }
  digest(r) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);
    let n = this._state.squeeze(this._hashBitLength / 8);
    return r !== void 0 && (n = n.toString(r)), this._resetState(), n;
  }
  // remove result from memory
  _resetState() {
    return this._state.initialize(this._rate, this._capacity), this;
  }
  // because sometimes we need hash right now and little later
  _clone() {
    const r = new Yb(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
    return this._state.copy(r._state), r._finalized = this._finalized, r;
  }
};
const { Transform: JM } = Zb;
var QM = (t) => class Xb extends JM {
  constructor(r, n, i, o) {
    super(o), this._rate = r, this._capacity = n, this._delimitedSuffix = i, this._options = o, this._state = new t(), this._state.initialize(r, n), this._finalized = !1;
  }
  _transform(r, n, i) {
    let o = null;
    try {
      this.update(r, n);
    } catch (c) {
      o = c;
    }
    i(o);
  }
  _flush() {
  }
  _read(r) {
    this.push(this.squeeze(r));
  }
  update(r, n) {
    if (!Buffer.isBuffer(r) && typeof r != "string")
      throw new TypeError("Data must be a string or a buffer");
    if (this._finalized)
      throw new Error("Squeeze already called");
    return Buffer.isBuffer(r) || (r = Buffer.from(r, n)), this._state.absorb(r), this;
  }
  squeeze(r, n) {
    this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));
    let i = this._state.squeeze(r);
    return n !== void 0 && (i = i.toString(n)), i;
  }
  _resetState() {
    return this._state.initialize(this._rate, this._capacity), this;
  }
  _clone() {
    const r = new Xb(this._rate, this._capacity, this._delimitedSuffix, this._options);
    return this._state.copy(r._state), r._finalized = this._finalized, r;
  }
};
const ZM = GM, YM = QM;
var XM = function(t) {
  const e = ZM(t), r = YM(t);
  return function(n, i) {
    switch (typeof n == "string" ? n.toLowerCase() : n) {
      case "keccak224":
        return new e(1152, 448, null, 224, i);
      case "keccak256":
        return new e(1088, 512, null, 256, i);
      case "keccak384":
        return new e(832, 768, null, 384, i);
      case "keccak512":
        return new e(576, 1024, null, 512, i);
      case "sha3-224":
        return new e(1152, 448, 6, 224, i);
      case "sha3-256":
        return new e(1088, 512, 6, 256, i);
      case "sha3-384":
        return new e(832, 768, 6, 384, i);
      case "sha3-512":
        return new e(576, 1024, 6, 512, i);
      case "shake128":
        return new r(1344, 256, 31, i);
      case "shake256":
        return new r(1088, 512, 31, i);
      default:
        throw new Error("Invald algorithm: " + n);
    }
  };
}, eD = XM(oM);
const tD = eD, rD = Uc;
function e2(t) {
  return Buffer.allocUnsafe(t).fill(0);
}
function t2(t, e, r) {
  const n = e2(e);
  return t = qh(t), r ? t.length < e ? (t.copy(n), n) : t.slice(0, e) : t.length < e ? (t.copy(n, e - t.length), n) : t.slice(-e);
}
function nD(t, e) {
  return t2(t, e, !0);
}
function qh(t) {
  if (!Buffer.isBuffer(t))
    if (Array.isArray(t))
      t = Buffer.from(t);
    else if (typeof t == "string")
      r2(t) ? t = Buffer.from(oD(n2(t)), "hex") : t = Buffer.from(t);
    else if (typeof t == "number")
      t = intToBuffer(t);
    else if (t == null)
      t = Buffer.allocUnsafe(0);
    else if (rD.isBN(t))
      t = t.toArrayLike(Buffer);
    else if (t.toArray)
      t = Buffer.from(t.toArray());
    else
      throw new Error("invalid type");
  return t;
}
function iD(t) {
  return t = qh(t), "0x" + t.toString("hex");
}
function sD(t, e) {
  return t = qh(t), e || (e = 256), tD("keccak" + e).update(t).digest();
}
function oD(t) {
  return t.length % 2 ? "0" + t : t;
}
function r2(t) {
  return typeof t == "string" && t.match(/^0x[0-9A-Fa-f]*$/);
}
function n2(t) {
  return typeof t == "string" && t.startsWith("0x") ? t.slice(2) : t;
}
var i2 = {
  zeros: e2,
  setLength: t2,
  setLengthRight: nD,
  isHexString: r2,
  stripHexPrefix: n2,
  toBuffer: qh,
  bufferToHex: iD,
  keccak: sD
};
const po = i2, ao = Uc;
function s2(t) {
  return t.startsWith("int[") ? "int256" + t.slice(3) : t === "int" ? "int256" : t.startsWith("uint[") ? "uint256" + t.slice(4) : t === "uint" ? "uint256" : t.startsWith("fixed[") ? "fixed128x128" + t.slice(5) : t === "fixed" ? "fixed128x128" : t.startsWith("ufixed[") ? "ufixed128x128" + t.slice(6) : t === "ufixed" ? "ufixed128x128" : t;
}
function ua(t) {
  return parseInt(/^\D+(\d+)$/.exec(t)[1], 10);
}
function Hv(t) {
  var e = /^\D+(\d+)x(\d+)$/.exec(t);
  return [parseInt(e[1], 10), parseInt(e[2], 10)];
}
function o2(t) {
  var e = t.match(/(.*)\[(.*?)\]$/);
  return e ? e[2] === "" ? "dynamic" : parseInt(e[2], 10) : null;
}
function no(t) {
  var e = typeof t;
  if (e === "string")
    return po.isHexString(t) ? new ao(po.stripHexPrefix(t), 16) : new ao(t, 10);
  if (e === "number")
    return new ao(t);
  if (t.toArray)
    return t;
  throw new Error("Argument is not a number");
}
function Ii(t, e) {
  var r, n, i, o;
  if (t === "address")
    return Ii("uint160", no(e));
  if (t === "bool")
    return Ii("uint8", e ? 1 : 0);
  if (t === "string")
    return Ii("bytes", new Buffer(e, "utf8"));
  if (cD(t)) {
    if (typeof e.length > "u")
      throw new Error("Not an array?");
    if (r = o2(t), r !== "dynamic" && r !== 0 && e.length > r)
      throw new Error("Elements exceed array size: " + r);
    i = [], t = t.slice(0, t.lastIndexOf("[")), typeof e == "string" && (e = JSON.parse(e));
    for (o in e)
      i.push(Ii(t, e[o]));
    if (r === "dynamic") {
      var c = Ii("uint256", e.length);
      i.unshift(c);
    }
    return Buffer.concat(i);
  } else {
    if (t === "bytes")
      return e = new Buffer(e), i = Buffer.concat([Ii("uint256", e.length), e]), e.length % 32 !== 0 && (i = Buffer.concat([i, po.zeros(32 - e.length % 32)])), i;
    if (t.startsWith("bytes")) {
      if (r = ua(t), r < 1 || r > 32)
        throw new Error("Invalid bytes<N> width: " + r);
      return po.setLengthRight(e, 32);
    } else if (t.startsWith("uint")) {
      if (r = ua(t), r % 8 || r < 8 || r > 256)
        throw new Error("Invalid uint<N> width: " + r);
      if (n = no(e), n.bitLength() > r)
        throw new Error("Supplied uint exceeds width: " + r + " vs " + n.bitLength());
      if (n < 0)
        throw new Error("Supplied uint is negative");
      return n.toArrayLike(Buffer, "be", 32);
    } else if (t.startsWith("int")) {
      if (r = ua(t), r % 8 || r < 8 || r > 256)
        throw new Error("Invalid int<N> width: " + r);
      if (n = no(e), n.bitLength() > r)
        throw new Error("Supplied int exceeds width: " + r + " vs " + n.bitLength());
      return n.toTwos(256).toArrayLike(Buffer, "be", 32);
    } else if (t.startsWith("ufixed")) {
      if (r = Hv(t), n = no(e), n < 0)
        throw new Error("Supplied ufixed is negative");
      return Ii("uint256", n.mul(new ao(2).pow(new ao(r[1]))));
    } else if (t.startsWith("fixed"))
      return r = Hv(t), Ii("int256", no(e).mul(new ao(2).pow(new ao(r[1]))));
  }
  throw new Error("Unsupported or invalid type: " + t);
}
function aD(t) {
  return t === "string" || t === "bytes" || o2(t) === "dynamic";
}
function cD(t) {
  return t.lastIndexOf("]") === t.length - 1;
}
function uD(t, e) {
  var r = [], n = [], i = 32 * t.length;
  for (var o in t) {
    var c = s2(t[o]), u = e[o], l = Ii(c, u);
    aD(c) ? (r.push(Ii("uint256", i)), n.push(l), i += l.length) : r.push(l);
  }
  return Buffer.concat(r.concat(n));
}
function a2(t, e) {
  if (t.length !== e.length)
    throw new Error("Number of types are not matching the values");
  for (var r, n, i = [], o = 0; o < t.length; o++) {
    var c = s2(t[o]), u = e[o];
    if (c === "bytes")
      i.push(u);
    else if (c === "string")
      i.push(new Buffer(u, "utf8"));
    else if (c === "bool")
      i.push(new Buffer(u ? "01" : "00", "hex"));
    else if (c === "address")
      i.push(po.setLength(u, 20));
    else if (c.startsWith("bytes")) {
      if (r = ua(c), r < 1 || r > 32)
        throw new Error("Invalid bytes<N> width: " + r);
      i.push(po.setLengthRight(u, r));
    } else if (c.startsWith("uint")) {
      if (r = ua(c), r % 8 || r < 8 || r > 256)
        throw new Error("Invalid uint<N> width: " + r);
      if (n = no(u), n.bitLength() > r)
        throw new Error("Supplied uint exceeds width: " + r + " vs " + n.bitLength());
      i.push(n.toArrayLike(Buffer, "be", r / 8));
    } else if (c.startsWith("int")) {
      if (r = ua(c), r % 8 || r < 8 || r > 256)
        throw new Error("Invalid int<N> width: " + r);
      if (n = no(u), n.bitLength() > r)
        throw new Error("Supplied int exceeds width: " + r + " vs " + n.bitLength());
      i.push(n.toTwos(r).toArrayLike(Buffer, "be", r / 8));
    } else
      throw new Error("Unsupported or invalid type: " + c);
  }
  return Buffer.concat(i);
}
function lD(t, e) {
  return po.keccak(a2(t, e));
}
var hD = {
  rawEncode: uD,
  solidityPack: a2,
  soliditySHA3: lD
};
const si = i2, xc = hD, c2 = {
  type: "object",
  properties: {
    types: {
      type: "object",
      additionalProperties: {
        type: "array",
        items: {
          type: "object",
          properties: {
            name: { type: "string" },
            type: { type: "string" }
          },
          required: ["name", "type"]
        }
      }
    },
    primaryType: { type: "string" },
    domain: { type: "object" },
    message: { type: "object" }
  },
  required: ["types", "primaryType", "domain", "message"]
}, Yd = {
  /**
   * Encodes an object by encoding and concatenating each of its members
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of an object
   */
  encodeData(t, e, r, n = !0) {
    const i = ["bytes32"], o = [this.hashType(t, r)];
    if (n) {
      const c = (u, l, f) => {
        if (r[l] !== void 0)
          return ["bytes32", f == null ? "0x0000000000000000000000000000000000000000000000000000000000000000" : si.keccak(this.encodeData(l, f, r, n))];
        if (f === void 0)
          throw new Error(`missing value for field ${u} of type ${l}`);
        if (l === "bytes")
          return ["bytes32", si.keccak(f)];
        if (l === "string")
          return typeof f == "string" && (f = Buffer.from(f, "utf8")), ["bytes32", si.keccak(f)];
        if (l.lastIndexOf("]") === l.length - 1) {
          const p = l.slice(0, l.lastIndexOf("[")), g = f.map((y) => c(u, p, y));
          return ["bytes32", si.keccak(xc.rawEncode(
            g.map(([y]) => y),
            g.map(([, y]) => y)
          ))];
        }
        return [l, f];
      };
      for (const u of r[t]) {
        const [l, f] = c(u.name, u.type, e[u.name]);
        i.push(l), o.push(f);
      }
    } else
      for (const c of r[t]) {
        let u = e[c.name];
        if (u !== void 0)
          if (c.type === "bytes")
            i.push("bytes32"), u = si.keccak(u), o.push(u);
          else if (c.type === "string")
            i.push("bytes32"), typeof u == "string" && (u = Buffer.from(u, "utf8")), u = si.keccak(u), o.push(u);
          else if (r[c.type] !== void 0)
            i.push("bytes32"), u = si.keccak(this.encodeData(c.type, u, r, n)), o.push(u);
          else {
            if (c.type.lastIndexOf("]") === c.type.length - 1)
              throw new Error("Arrays currently unimplemented in encodeData");
            i.push(c.type), o.push(u);
          }
      }
    return xc.rawEncode(i, o);
  },
  /**
   * Encodes the type of an object by encoding a comma delimited list of its members
   *
   * @param {string} primaryType - Root type to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of the type of an object
   */
  encodeType(t, e) {
    let r = "", n = this.findTypeDependencies(t, e).filter((i) => i !== t);
    n = [t].concat(n.sort());
    for (const i of n) {
      if (!e[i])
        throw new Error("No type definition specified: " + i);
      r += i + "(" + e[i].map(({ name: c, type: u }) => u + " " + c).join(",") + ")";
    }
    return r;
  },
  /**
   * Finds all types within a type defintion object
   *
   * @param {string} primaryType - Root type
   * @param {Object} types - Type definitions
   * @param {Array} results - current set of accumulated types
   * @returns {Array} - Set of all types found in the type definition
   */
  findTypeDependencies(t, e, r = []) {
    if (t = t.match(/^\w*/)[0], r.includes(t) || e[t] === void 0)
      return r;
    r.push(t);
    for (const n of e[t])
      for (const i of this.findTypeDependencies(n.type, e, r))
        !r.includes(i) && r.push(i);
    return r;
  },
  /**
   * Hashes an object
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to hash
   * @param {Object} types - Type definitions
   * @returns {Buffer} - Hash of an object
   */
  hashStruct(t, e, r, n = !0) {
    return si.keccak(this.encodeData(t, e, r, n));
  },
  /**
   * Hashes the type of an object
   *
   * @param {string} primaryType - Root type to hash
   * @param {Object} types - Type definitions
   * @returns {string} - Hash of an object
   */
  hashType(t, e) {
    return si.keccak(this.encodeType(t, e));
  },
  /**
   * Removes properties from a message object that are not defined per EIP-712
   *
   * @param {Object} data - typed message object
   * @returns {Object} - typed message object with only allowed fields
   */
  sanitizeData(t) {
    const e = {};
    for (const r in c2.properties)
      t[r] && (e[r] = t[r]);
    return e.types && (e.types = Object.assign({ EIP712Domain: [] }, e.types)), e;
  },
  /**
   * Returns the hash of a typed message as per EIP-712 for signing
   *
   * @param {Object} typedData - Types message data to sign
   * @returns {string} - sha3 hash for signing
   */
  hash(t, e = !0) {
    const r = this.sanitizeData(t), n = [Buffer.from("1901", "hex")];
    return n.push(this.hashStruct("EIP712Domain", r.domain, r.types, e)), r.primaryType !== "EIP712Domain" && n.push(this.hashStruct(r.primaryType, r.message, r.types, e)), si.keccak(Buffer.concat(n));
  }
};
var fD = {
  TYPED_MESSAGE_SCHEMA: c2,
  TypedDataUtils: Yd,
  hashForSignTypedDataLegacy: function(t) {
    return dD(t.data);
  },
  hashForSignTypedData_v3: function(t) {
    return Yd.hash(t.data, !1);
  },
  hashForSignTypedData_v4: function(t) {
    return Yd.hash(t.data);
  }
};
function dD(t) {
  const e = new Error("Expect argument to be non-empty array");
  if (typeof t != "object" || !t.length)
    throw e;
  const r = t.map(function(o) {
    return o.type === "bytes" ? si.toBuffer(o.value) : o.value;
  }), n = t.map(function(o) {
    return o.type;
  }), i = t.map(function(o) {
    if (!o.name)
      throw e;
    return o.type + " " + o.name;
  });
  return xc.soliditySHA3(
    ["bytes32", "bytes32"],
    [
      xc.soliditySHA3(new Array(t.length).fill("string"), i),
      xc.soliditySHA3(n, r)
    ]
  );
}
var Sa = {};
Object.defineProperty(Sa, "__esModule", { value: !0 });
Sa.filterFromParam = Sa.FilterPolyfill = void 0;
const na = _r, Kr = $e, pD = 5 * 60 * 1e3, io = {
  jsonrpc: "2.0",
  id: 0
};
class gD {
  constructor(e) {
    this.logFilters = /* @__PURE__ */ new Map(), this.blockFilters = /* @__PURE__ */ new Set(), this.pendingTransactionFilters = /* @__PURE__ */ new Set(), this.cursors = /* @__PURE__ */ new Map(), this.timeouts = /* @__PURE__ */ new Map(), this.nextFilterId = (0, na.IntNumber)(1), this.REQUEST_THROTTLE_INTERVAL = 1e3, this.lastFetchTimestamp = /* @__PURE__ */ new Date(0), this.resolvers = [], this.provider = e;
  }
  async newFilter(e) {
    const r = u2(e), n = this.makeFilterId(), i = await this.setInitialCursorPosition(n, r.fromBlock);
    return console.info(`Installing new log filter(${n}):`, r, "initial cursor position:", i), this.logFilters.set(n, r), this.setFilterTimeout(n), (0, Kr.hexStringFromIntNumber)(n);
  }
  async newBlockFilter() {
    const e = this.makeFilterId(), r = await this.setInitialCursorPosition(e, "latest");
    return console.info(`Installing new block filter (${e}) with initial cursor position:`, r), this.blockFilters.add(e), this.setFilterTimeout(e), (0, Kr.hexStringFromIntNumber)(e);
  }
  async newPendingTransactionFilter() {
    const e = this.makeFilterId(), r = await this.setInitialCursorPosition(e, "latest");
    return console.info(`Installing new block filter (${e}) with initial cursor position:`, r), this.pendingTransactionFilters.add(e), this.setFilterTimeout(e), (0, Kr.hexStringFromIntNumber)(e);
  }
  uninstallFilter(e) {
    const r = (0, Kr.intNumberFromHexString)(e);
    return console.info(`Uninstalling filter (${r})`), this.deleteFilter(r), !0;
  }
  getFilterChanges(e) {
    const r = (0, Kr.intNumberFromHexString)(e);
    return this.timeouts.has(r) && this.setFilterTimeout(r), this.logFilters.has(r) ? this.getLogFilterChanges(r) : this.blockFilters.has(r) ? this.getBlockFilterChanges(r) : this.pendingTransactionFilters.has(r) ? this.getPendingTransactionFilterChanges(r) : Promise.resolve(Rl());
  }
  async getFilterLogs(e) {
    const r = (0, Kr.intNumberFromHexString)(e), n = this.logFilters.get(r);
    return n ? this.sendAsyncPromise(Object.assign(Object.assign({}, io), { method: "eth_getLogs", params: [qv(n)] })) : Rl();
  }
  makeFilterId() {
    return (0, na.IntNumber)(++this.nextFilterId);
  }
  sendAsyncPromise(e) {
    return new Promise((r, n) => {
      this.provider.sendAsync(e, (i, o) => {
        if (i)
          return n(i);
        if (Array.isArray(o) || o == null)
          return n(new Error(`unexpected response received: ${JSON.stringify(o)}`));
        r(o);
      });
    });
  }
  deleteFilter(e) {
    console.info(`Deleting filter (${e})`), this.logFilters.delete(e), this.blockFilters.delete(e), this.pendingTransactionFilters.delete(e), this.cursors.delete(e), this.timeouts.delete(e);
  }
  async getLogFilterChanges(e) {
    const r = this.logFilters.get(e), n = this.cursors.get(e);
    if (!n || !r)
      return Rl();
    const i = await this.getCurrentBlockHeight(), o = r.toBlock === "latest" ? i : r.toBlock;
    if (n > i || n > Number(r.toBlock))
      return Al();
    console.info(`Fetching logs from ${n} to ${o} for filter ${e}`);
    const c = await this.sendAsyncPromise(Object.assign(Object.assign({}, io), { method: "eth_getLogs", params: [
      qv(Object.assign(Object.assign({}, r), { fromBlock: n, toBlock: o }))
    ] }));
    if (Array.isArray(c.result)) {
      const u = c.result.map((f) => (0, Kr.intNumberFromHexString)(f.blockNumber || "0x0")), l = Math.max(...u);
      if (l && l > n) {
        const f = (0, na.IntNumber)(l + 1);
        console.info(`Moving cursor position for filter (${e}) from ${n} to ${f}`), this.cursors.set(e, f);
      }
    }
    return c;
  }
  async getBlockFilterChanges(e) {
    const r = this.cursors.get(e);
    if (!r)
      return Rl();
    const n = await this.getCurrentBlockHeight();
    if (r > n)
      return Al();
    console.info(`Fetching blocks from ${r} to ${n} for filter (${e})`);
    const i = (await Promise.all(
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      (0, Kr.range)(r, n + 1).map((c) => this.getBlockHashByNumber((0, na.IntNumber)(c)))
    )).filter((c) => !!c), o = (0, na.IntNumber)(r + i.length);
    return console.info(`Moving cursor position for filter (${e}) from ${r} to ${o}`), this.cursors.set(e, o), Object.assign(Object.assign({}, io), { result: i });
  }
  async getPendingTransactionFilterChanges(e) {
    return Promise.resolve(Al());
  }
  async setInitialCursorPosition(e, r) {
    const n = await this.getCurrentBlockHeight(), i = typeof r == "number" && r > n ? r : n;
    return this.cursors.set(e, i), i;
  }
  setFilterTimeout(e) {
    const r = this.timeouts.get(e);
    r && window.clearTimeout(r);
    const n = window.setTimeout(() => {
      console.info(`Filter (${e}) timed out`), this.deleteFilter(e);
    }, pD);
    this.timeouts.set(e, n);
  }
  // throttle eth_blockNumber requests
  async getCurrentBlockHeight() {
    const e = /* @__PURE__ */ new Date();
    if (e.getTime() - this.lastFetchTimestamp.getTime() > this.REQUEST_THROTTLE_INTERVAL) {
      this.lastFetchTimestamp = e;
      const r = await this._getCurrentBlockHeight();
      this.currentBlockHeight = r, this.resolvers.forEach((n) => n(r)), this.resolvers = [];
    }
    return this.currentBlockHeight ? this.currentBlockHeight : new Promise((r) => this.resolvers.push(r));
  }
  async _getCurrentBlockHeight() {
    const { result: e } = await this.sendAsyncPromise(Object.assign(Object.assign({}, io), { method: "eth_blockNumber", params: [] }));
    return (0, Kr.intNumberFromHexString)((0, Kr.ensureHexString)(e));
  }
  async getBlockHashByNumber(e) {
    const r = await this.sendAsyncPromise(Object.assign(Object.assign({}, io), { method: "eth_getBlockByNumber", params: [(0, Kr.hexStringFromIntNumber)(e), !1] }));
    return r.result && typeof r.result.hash == "string" ? (0, Kr.ensureHexString)(r.result.hash) : null;
  }
}
Sa.FilterPolyfill = gD;
function u2(t) {
  return {
    fromBlock: zv(t.fromBlock),
    toBlock: zv(t.toBlock),
    addresses: t.address === void 0 ? null : Array.isArray(t.address) ? t.address : [t.address],
    topics: t.topics || []
  };
}
Sa.filterFromParam = u2;
function qv(t) {
  const e = {
    fromBlock: Vv(t.fromBlock),
    toBlock: Vv(t.toBlock),
    topics: t.topics
  };
  return t.addresses !== null && (e.address = t.addresses), e;
}
function zv(t) {
  if (t === void 0 || t === "latest" || t === "pending")
    return "latest";
  if (t === "earliest")
    return (0, na.IntNumber)(0);
  if ((0, Kr.isHexString)(t))
    return (0, Kr.intNumberFromHexString)(t);
  throw new Error(`Invalid block option: ${String(t)}`);
}
function Vv(t) {
  return t === "latest" ? t : (0, Kr.hexStringFromIntNumber)(t);
}
function Rl() {
  return Object.assign(Object.assign({}, io), { error: { code: -32e3, message: "filter not found" } });
}
function Al() {
  return Object.assign(Object.assign({}, io), { result: [] });
}
var zh = {}, l2 = {}, Vh = {}, Hp = mD;
function mD(t) {
  t = t || {};
  var e = t.max || Number.MAX_SAFE_INTEGER, r = typeof t.start < "u" ? t.start : Math.floor(Math.random() * e);
  return function() {
    return r = r % e, r++;
  };
}
const Wv = (t, e) => function() {
  const r = e.promiseModule, n = new Array(arguments.length);
  for (let i = 0; i < arguments.length; i++)
    n[i] = arguments[i];
  return new r((i, o) => {
    e.errorFirst ? n.push(function(c, u) {
      if (e.multiArgs) {
        const l = new Array(arguments.length - 1);
        for (let f = 1; f < arguments.length; f++)
          l[f - 1] = arguments[f];
        c ? (l.unshift(c), o(l)) : i(l);
      } else
        c ? o(c) : i(u);
    }) : n.push(function(c) {
      if (e.multiArgs) {
        const u = new Array(arguments.length - 1);
        for (let l = 0; l < arguments.length; l++)
          u[l] = arguments[l];
        i(u);
      } else
        i(c);
    }), t.apply(this, n);
  });
};
var vD = (t, e) => {
  e = Object.assign({
    exclude: [/.+(Sync|Stream)$/],
    errorFirst: !0,
    promiseModule: Promise
  }, e);
  const r = (i) => {
    const o = (c) => typeof c == "string" ? i === c : c.test(i);
    return e.include ? e.include.some(o) : !e.exclude.some(o);
  };
  let n;
  typeof t == "function" ? n = function() {
    return e.excludeMain ? t.apply(this, arguments) : Wv(t, e).apply(this, arguments);
  } : n = Object.create(Object.getPrototypeOf(t));
  for (const i in t) {
    const o = t[i];
    n[i] = typeof o == "function" && r(i) ? Wv(o, e) : o;
  }
  return n;
}, iu = {}, su = {};
Object.defineProperty(su, "__esModule", { value: !0 });
const yD = Tr;
function Kv(t, e, r) {
  try {
    Reflect.apply(t, e, r);
  } catch (n) {
    setTimeout(() => {
      throw n;
    });
  }
}
function _D(t) {
  const e = t.length, r = new Array(e);
  for (let n = 0; n < e; n += 1)
    r[n] = t[n];
  return r;
}
let wD = class extends yD.EventEmitter {
  emit(e, ...r) {
    let n = e === "error";
    const i = this._events;
    if (i !== void 0)
      n = n && i.error === void 0;
    else if (!n)
      return !1;
    if (n) {
      let c;
      if (r.length > 0 && ([c] = r), c instanceof Error)
        throw c;
      const u = new Error(`Unhandled error.${c ? ` (${c.message})` : ""}`);
      throw u.context = c, u;
    }
    const o = i[e];
    if (o === void 0)
      return !1;
    if (typeof o == "function")
      Kv(o, this, r);
    else {
      const c = o.length, u = _D(o);
      for (let l = 0; l < c; l += 1)
        Kv(u[l], this, r);
    }
    return !0;
  }
};
su.default = wD;
var bD = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(iu, "__esModule", { value: !0 });
iu.BaseBlockTracker = void 0;
const ED = bD(su), SD = 1e3, CD = (t, e) => t + e, Gv = ["sync", "latest"];
class ID extends ED.default {
  constructor(e) {
    super(), this._blockResetDuration = e.blockResetDuration || 20 * SD, this._usePastBlocks = e.usePastBlocks || !1, this._currentBlock = null, this._isRunning = !1, this._onNewListener = this._onNewListener.bind(this), this._onRemoveListener = this._onRemoveListener.bind(this), this._resetCurrentBlock = this._resetCurrentBlock.bind(this), this._setupInternalEvents();
  }
  async destroy() {
    this._cancelBlockResetTimeout(), await this._maybeEnd(), super.removeAllListeners();
  }
  isRunning() {
    return this._isRunning;
  }
  getCurrentBlock() {
    return this._currentBlock;
  }
  async getLatestBlock() {
    return this._currentBlock ? this._currentBlock : await new Promise((r) => this.once("latest", r));
  }
  // dont allow module consumer to remove our internal event listeners
  removeAllListeners(e) {
    return e ? super.removeAllListeners(e) : super.removeAllListeners(), this._setupInternalEvents(), this._onRemoveListener(), this;
  }
  _setupInternalEvents() {
    this.removeListener("newListener", this._onNewListener), this.removeListener("removeListener", this._onRemoveListener), this.on("newListener", this._onNewListener), this.on("removeListener", this._onRemoveListener);
  }
  _onNewListener(e) {
    Gv.includes(e) && this._maybeStart();
  }
  _onRemoveListener() {
    this._getBlockTrackerEventCount() > 0 || this._maybeEnd();
  }
  async _maybeStart() {
    this._isRunning || (this._isRunning = !0, this._cancelBlockResetTimeout(), await this._start(), this.emit("_started"));
  }
  async _maybeEnd() {
    this._isRunning && (this._isRunning = !1, this._setupBlockResetTimeout(), await this._end(), this.emit("_ended"));
  }
  _getBlockTrackerEventCount() {
    return Gv.map((e) => this.listenerCount(e)).reduce(CD);
  }
  _shouldUseNewBlock(e) {
    const r = this._currentBlock;
    if (!r)
      return !0;
    const n = Jv(e), i = Jv(r);
    return this._usePastBlocks && n < i || n > i;
  }
  _newPotentialLatest(e) {
    this._shouldUseNewBlock(e) && this._setCurrentBlock(e);
  }
  _setCurrentBlock(e) {
    const r = this._currentBlock;
    this._currentBlock = e, this.emit("latest", e), this.emit("sync", { oldBlock: r, newBlock: e });
  }
  _setupBlockResetTimeout() {
    this._cancelBlockResetTimeout(), this._blockResetTimeout = setTimeout(this._resetCurrentBlock, this._blockResetDuration), this._blockResetTimeout.unref && this._blockResetTimeout.unref();
  }
  _cancelBlockResetTimeout() {
    this._blockResetTimeout && clearTimeout(this._blockResetTimeout);
  }
  _resetCurrentBlock() {
    this._currentBlock = null;
  }
}
iu.BaseBlockTracker = ID;
function Jv(t) {
  return Number.parseInt(t, 16);
}
var h2 = {}, f2 = {}, Pr = {};
class d2 extends TypeError {
  constructor(e, r) {
    let n;
    const { message: i, explanation: o, ...c } = e, { path: u } = e, l = u.length === 0 ? i : `At path: ${u.join(".")} -- ${i}`;
    super(o ?? l), o != null && (this.cause = l), Object.assign(this, c), this.name = this.constructor.name, this.failures = () => n ?? (n = [e, ...r()]);
  }
}
function xD(t) {
  return zn(t) && typeof t[Symbol.iterator] == "function";
}
function zn(t) {
  return typeof t == "object" && t != null;
}
function Qv(t) {
  if (Object.prototype.toString.call(t) !== "[object Object]")
    return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
function wr(t) {
  return typeof t == "symbol" ? t.toString() : typeof t == "string" ? JSON.stringify(t) : `${t}`;
}
function RD(t) {
  const { done: e, value: r } = t.next();
  return e ? void 0 : r;
}
function AD(t, e, r, n) {
  if (t === !0)
    return;
  t === !1 ? t = {} : typeof t == "string" && (t = { message: t });
  const { path: i, branch: o } = e, { type: c } = r, { refinement: u, message: l = `Expected a value of type \`${c}\`${u ? ` with refinement \`${u}\`` : ""}, but received: \`${wr(n)}\`` } = t;
  return {
    value: n,
    type: c,
    refinement: u,
    key: i[i.length - 1],
    path: i,
    branch: o,
    ...t,
    message: l
  };
}
function* W0(t, e, r, n) {
  xD(t) || (t = [t]);
  for (const i of t) {
    const o = AD(i, e, r, n);
    o && (yield o);
  }
}
function* qp(t, e, r = {}) {
  const { path: n = [], branch: i = [t], coerce: o = !1, mask: c = !1 } = r, u = { path: n, branch: i };
  if (o && (t = e.coercer(t, u), c && e.type !== "type" && zn(e.schema) && zn(t) && !Array.isArray(t)))
    for (const f in t)
      e.schema[f] === void 0 && delete t[f];
  let l = "valid";
  for (const f of e.validator(t, u))
    f.explanation = r.message, l = "not_valid", yield [f, void 0];
  for (let [f, p, g] of e.entries(t, u)) {
    const y = qp(p, g, {
      path: f === void 0 ? n : [...n, f],
      branch: f === void 0 ? i : [...i, p],
      coerce: o,
      mask: c,
      message: r.message
    });
    for (const C of y)
      C[0] ? (l = C[0].refinement != null ? "not_refined" : "not_valid", yield [C[0], void 0]) : o && (p = C[1], f === void 0 ? t = p : t instanceof Map ? t.set(f, p) : t instanceof Set ? t.add(p) : zn(t) && (p !== void 0 || f in t) && (t[f] = p));
  }
  if (l !== "not_valid")
    for (const f of e.refiner(t, u))
      f.explanation = r.message, l = "not_refined", yield [f, void 0];
  l === "valid" && (yield [void 0, t]);
}
class hr {
  constructor(e) {
    const { type: r, schema: n, validator: i, refiner: o, coercer: c = (l) => l, entries: u = function* () {
    } } = e;
    this.type = r, this.schema = n, this.entries = u, this.coercer = c, i ? this.validator = (l, f) => {
      const p = i(l, f);
      return W0(p, f, this, l);
    } : this.validator = () => [], o ? this.refiner = (l, f) => {
      const p = o(l, f);
      return W0(p, f, this, l);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(e, r) {
    return p2(e, this, r);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(e, r) {
    return g2(e, this, r);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(e) {
    return zp(e, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(e, r) {
    return m2(e, this, r);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(e, r = {}) {
    return Ta(e, this, r);
  }
}
function p2(t, e, r) {
  const n = Ta(t, e, { message: r });
  if (n[0])
    throw n[0];
}
function g2(t, e, r) {
  const n = Ta(t, e, { coerce: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function m2(t, e, r) {
  const n = Ta(t, e, { coerce: !0, mask: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function zp(t, e) {
  return !Ta(t, e)[0];
}
function Ta(t, e, r = {}) {
  const n = qp(t, e, r), i = RD(n);
  return i[0] ? [new d2(i[0], function* () {
    for (const c of n)
      c[0] && (yield c[0]);
  }), void 0] : [void 0, i[1]];
}
function MD(...t) {
  const e = t[0].type === "type", r = t.map((i) => i.schema), n = Object.assign({}, ...r);
  return e ? Wp(n) : ou(n);
}
function gn(t, e) {
  return new hr({ type: t, schema: null, validator: e });
}
function DD(t, e) {
  return new hr({
    ...t,
    refiner: (r, n) => r === void 0 || t.refiner(r, n),
    validator(r, n) {
      return r === void 0 ? !0 : (e(r, n), t.validator(r, n));
    }
  });
}
function OD(t) {
  return new hr({
    type: "dynamic",
    schema: null,
    *entries(e, r) {
      yield* t(e, r).entries(e, r);
    },
    validator(e, r) {
      return t(e, r).validator(e, r);
    },
    coercer(e, r) {
      return t(e, r).coercer(e, r);
    },
    refiner(e, r) {
      return t(e, r).refiner(e, r);
    }
  });
}
function PD(t) {
  let e;
  return new hr({
    type: "lazy",
    schema: null,
    *entries(r, n) {
      e ?? (e = t()), yield* e.entries(r, n);
    },
    validator(r, n) {
      return e ?? (e = t()), e.validator(r, n);
    },
    coercer(r, n) {
      return e ?? (e = t()), e.coercer(r, n);
    },
    refiner(r, n) {
      return e ?? (e = t()), e.refiner(r, n);
    }
  });
}
function TD(t, e) {
  const { schema: r } = t, n = { ...r };
  for (const i of e)
    delete n[i];
  switch (t.type) {
    case "type":
      return Wp(n);
    default:
      return ou(n);
  }
}
function ND(t) {
  const e = t instanceof hr ? { ...t.schema } : { ...t };
  for (const r in e)
    e[r] = v2(e[r]);
  return ou(e);
}
function kD(t, e) {
  const { schema: r } = t, n = {};
  for (const i of e)
    n[i] = r[i];
  return ou(n);
}
function LD(t, e) {
  return console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`."), gn(t, e);
}
function $D() {
  return gn("any", () => !0);
}
function FD(t) {
  return new hr({
    type: "array",
    schema: t,
    *entries(e) {
      if (t && Array.isArray(e))
        for (const [r, n] of e.entries())
          yield [r, n, t];
    },
    coercer(e) {
      return Array.isArray(e) ? e.slice() : e;
    },
    validator(e) {
      return Array.isArray(e) || `Expected an array value, but received: ${wr(e)}`;
    }
  });
}
function BD() {
  return gn("bigint", (t) => typeof t == "bigint");
}
function UD() {
  return gn("boolean", (t) => typeof t == "boolean");
}
function jD() {
  return gn("date", (t) => t instanceof Date && !isNaN(t.getTime()) || `Expected a valid \`Date\` object, but received: ${wr(t)}`);
}
function HD(t) {
  const e = {}, r = t.map((n) => wr(n)).join();
  for (const n of t)
    e[n] = n;
  return new hr({
    type: "enums",
    schema: e,
    validator(n) {
      return t.includes(n) || `Expected one of \`${r}\`, but received: ${wr(n)}`;
    }
  });
}
function qD() {
  return gn("func", (t) => typeof t == "function" || `Expected a function, but received: ${wr(t)}`);
}
function zD(t) {
  return gn("instance", (e) => e instanceof t || `Expected a \`${t.name}\` instance, but received: ${wr(e)}`);
}
function VD() {
  return gn("integer", (t) => typeof t == "number" && !isNaN(t) && Number.isInteger(t) || `Expected an integer, but received: ${wr(t)}`);
}
function WD(t) {
  return new hr({
    type: "intersection",
    schema: null,
    *entries(e, r) {
      for (const n of t)
        yield* n.entries(e, r);
    },
    *validator(e, r) {
      for (const n of t)
        yield* n.validator(e, r);
    },
    *refiner(e, r) {
      for (const n of t)
        yield* n.refiner(e, r);
    }
  });
}
function KD(t) {
  const e = wr(t), r = typeof t;
  return new hr({
    type: "literal",
    schema: r === "string" || r === "number" || r === "boolean" ? t : null,
    validator(n) {
      return n === t || `Expected the literal \`${e}\`, but received: ${wr(n)}`;
    }
  });
}
function GD(t, e) {
  return new hr({
    type: "map",
    schema: null,
    *entries(r) {
      if (t && e && r instanceof Map)
        for (const [n, i] of r.entries())
          yield [n, n, t], yield [n, i, e];
    },
    coercer(r) {
      return r instanceof Map ? new Map(r) : r;
    },
    validator(r) {
      return r instanceof Map || `Expected a \`Map\` object, but received: ${wr(r)}`;
    }
  });
}
function Vp() {
  return gn("never", () => !1);
}
function JD(t) {
  return new hr({
    ...t,
    validator: (e, r) => e === null || t.validator(e, r),
    refiner: (e, r) => e === null || t.refiner(e, r)
  });
}
function QD() {
  return gn("number", (t) => typeof t == "number" && !isNaN(t) || `Expected a number, but received: ${wr(t)}`);
}
function ou(t) {
  const e = t ? Object.keys(t) : [], r = Vp();
  return new hr({
    type: "object",
    schema: t || null,
    *entries(n) {
      if (t && zn(n)) {
        const i = new Set(Object.keys(n));
        for (const o of e)
          i.delete(o), yield [o, n[o], t[o]];
        for (const o of i)
          yield [o, n[o], r];
      }
    },
    validator(n) {
      return zn(n) || `Expected an object, but received: ${wr(n)}`;
    },
    coercer(n) {
      return zn(n) ? { ...n } : n;
    }
  });
}
function v2(t) {
  return new hr({
    ...t,
    validator: (e, r) => e === void 0 || t.validator(e, r),
    refiner: (e, r) => e === void 0 || t.refiner(e, r)
  });
}
function ZD(t, e) {
  return new hr({
    type: "record",
    schema: null,
    *entries(r) {
      if (zn(r))
        for (const n in r) {
          const i = r[n];
          yield [n, n, t], yield [n, i, e];
        }
    },
    validator(r) {
      return zn(r) || `Expected an object, but received: ${wr(r)}`;
    }
  });
}
function YD() {
  return gn("regexp", (t) => t instanceof RegExp);
}
function XD(t) {
  return new hr({
    type: "set",
    schema: null,
    *entries(e) {
      if (t && e instanceof Set)
        for (const r of e)
          yield [r, r, t];
    },
    coercer(e) {
      return e instanceof Set ? new Set(e) : e;
    },
    validator(e) {
      return e instanceof Set || `Expected a \`Set\` object, but received: ${wr(e)}`;
    }
  });
}
function y2() {
  return gn("string", (t) => typeof t == "string" || `Expected a string, but received: ${wr(t)}`);
}
function eO(t) {
  const e = Vp();
  return new hr({
    type: "tuple",
    schema: null,
    *entries(r) {
      if (Array.isArray(r)) {
        const n = Math.max(t.length, r.length);
        for (let i = 0; i < n; i++)
          yield [i, r[i], t[i] || e];
      }
    },
    validator(r) {
      return Array.isArray(r) || `Expected an array, but received: ${wr(r)}`;
    }
  });
}
function Wp(t) {
  const e = Object.keys(t);
  return new hr({
    type: "type",
    schema: t,
    *entries(r) {
      if (zn(r))
        for (const n of e)
          yield [n, r[n], t[n]];
    },
    validator(r) {
      return zn(r) || `Expected an object, but received: ${wr(r)}`;
    },
    coercer(r) {
      return zn(r) ? { ...r } : r;
    }
  });
}
function tO(t) {
  const e = t.map((r) => r.type).join(" | ");
  return new hr({
    type: "union",
    schema: null,
    coercer(r) {
      for (const n of t) {
        const [i, o] = n.validate(r, { coerce: !0 });
        if (!i)
          return o;
      }
      return r;
    },
    validator(r, n) {
      const i = [];
      for (const o of t) {
        const [...c] = qp(r, o, n), [u] = c;
        if (u[0])
          for (const [l] of c)
            l && i.push(l);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${e}\`, but received: ${wr(r)}`,
        ...i
      ];
    }
  });
}
function _2() {
  return gn("unknown", () => !0);
}
function Kp(t, e, r) {
  return new hr({
    ...t,
    coercer: (n, i) => zp(n, e) ? t.coercer(r(n, i), i) : t.coercer(n, i)
  });
}
function rO(t, e, r = {}) {
  return Kp(t, _2(), (n) => {
    const i = typeof e == "function" ? e() : e;
    if (n === void 0)
      return i;
    if (!r.strict && Qv(n) && Qv(i)) {
      const o = { ...n };
      let c = !1;
      for (const u in i)
        o[u] === void 0 && (o[u] = i[u], c = !0);
      if (c)
        return o;
    }
    return n;
  });
}
function nO(t) {
  return Kp(t, y2(), (e) => e.trim());
}
function iO(t) {
  return So(t, "empty", (e) => {
    const r = w2(e);
    return r === 0 || `Expected an empty ${t.type} but received one with a size of \`${r}\``;
  });
}
function w2(t) {
  return t instanceof Map || t instanceof Set ? t.size : t.length;
}
function sO(t, e, r = {}) {
  const { exclusive: n } = r;
  return So(t, "max", (i) => n ? i < e : i <= e || `Expected a ${t.type} less than ${n ? "" : "or equal to "}${e} but received \`${i}\``);
}
function oO(t, e, r = {}) {
  const { exclusive: n } = r;
  return So(t, "min", (i) => n ? i > e : i >= e || `Expected a ${t.type} greater than ${n ? "" : "or equal to "}${e} but received \`${i}\``);
}
function aO(t) {
  return So(t, "nonempty", (e) => w2(e) > 0 || `Expected a nonempty ${t.type} but received an empty one`);
}
function cO(t, e) {
  return So(t, "pattern", (r) => e.test(r) || `Expected a ${t.type} matching \`/${e.source}/\` but received "${r}"`);
}
function uO(t, e, r = e) {
  const n = `Expected a ${t.type}`, i = e === r ? `of \`${e}\`` : `between \`${e}\` and \`${r}\``;
  return So(t, "size", (o) => {
    if (typeof o == "number" || o instanceof Date)
      return e <= o && o <= r || `${n} ${i} but received \`${o}\``;
    if (o instanceof Map || o instanceof Set) {
      const { size: c } = o;
      return e <= c && c <= r || `${n} with a size ${i} but received one with a size of \`${c}\``;
    } else {
      const { length: c } = o;
      return e <= c && c <= r || `${n} with a length ${i} but received one with a length of \`${c}\``;
    }
  });
}
function So(t, e, r) {
  return new hr({
    ...t,
    *refiner(n, i) {
      yield* t.refiner(n, i);
      const o = r(n, i), c = W0(o, i, t, n);
      for (const u of c)
        yield { ...u, refinement: e };
    }
  });
}
const lO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Struct: hr,
  StructError: d2,
  any: $D,
  array: FD,
  assert: p2,
  assign: MD,
  bigint: BD,
  boolean: UD,
  coerce: Kp,
  create: g2,
  date: jD,
  defaulted: rO,
  define: gn,
  deprecated: DD,
  dynamic: OD,
  empty: iO,
  enums: HD,
  func: qD,
  instance: zD,
  integer: VD,
  intersection: WD,
  is: zp,
  lazy: PD,
  literal: KD,
  map: GD,
  mask: m2,
  max: sO,
  min: oO,
  never: Vp,
  nonempty: aO,
  nullable: JD,
  number: QD,
  object: ou,
  omit: TD,
  optional: v2,
  partial: ND,
  pattern: cO,
  pick: kD,
  record: ZD,
  refine: So,
  regexp: YD,
  set: XD,
  size: uO,
  string: y2,
  struct: LD,
  trimmed: nO,
  tuple: eO,
  type: Wp,
  union: tO,
  unknown: _2,
  validate: Ta
}, Symbol.toStringTag, { value: "Module" })), Co = /* @__PURE__ */ is(lO);
Object.defineProperty(Pr, "__esModule", { value: !0 });
Pr.assertExhaustive = Pr.assertStruct = Pr.assert = Pr.AssertionError = void 0;
const hO = Co;
function fO(t) {
  return typeof t == "object" && t !== null && "message" in t;
}
function dO(t) {
  var e, r;
  return typeof ((r = (e = t?.prototype) === null || e === void 0 ? void 0 : e.constructor) === null || r === void 0 ? void 0 : r.name) == "string";
}
function pO(t) {
  const e = fO(t) ? t.message : String(t);
  return e.endsWith(".") ? e.slice(0, -1) : e;
}
function b2(t, e) {
  return dO(t) ? new t({
    message: e
  }) : t({
    message: e
  });
}
class Gp extends Error {
  constructor(e) {
    super(e.message), this.code = "ERR_ASSERTION";
  }
}
Pr.AssertionError = Gp;
function gO(t, e = "Assertion failed.", r = Gp) {
  if (!t)
    throw e instanceof Error ? e : b2(r, e);
}
Pr.assert = gO;
function mO(t, e, r = "Assertion failed", n = Gp) {
  try {
    (0, hO.assert)(t, e);
  } catch (i) {
    throw b2(n, `${r}: ${pO(i)}.`);
  }
}
Pr.assertStruct = mO;
function vO(t) {
  throw new Error("Invalid branch reached. Should be detected during compilation.");
}
Pr.assertExhaustive = vO;
var au = {};
Object.defineProperty(au, "__esModule", { value: !0 });
au.base64 = void 0;
const yO = Co, _O = Pr, wO = (t, e = {}) => {
  var r, n;
  const i = (r = e.paddingRequired) !== null && r !== void 0 ? r : !1, o = (n = e.characterSet) !== null && n !== void 0 ? n : "base64";
  let c;
  o === "base64" ? c = String.raw`[A-Za-z0-9+\/]` : ((0, _O.assert)(o === "base64url"), c = String.raw`[-_A-Za-z0-9]`);
  let u;
  return i ? u = new RegExp(`^(?:${c}{4})*(?:${c}{3}=|${c}{2}==)?$`, "u") : u = new RegExp(`^(?:${c}{4})*(?:${c}{2,3}|${c}{3}=|${c}{2}==)?$`, "u"), (0, yO.pattern)(t, u);
};
au.base64 = wO;
var At = {}, cu = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.remove0x = t.add0x = t.assertIsStrictHexString = t.assertIsHexString = t.isStrictHexString = t.isHexString = t.StrictHexStruct = t.HexStruct = void 0;
  const e = Co, r = Pr;
  t.HexStruct = (0, e.pattern)((0, e.string)(), /^(?:0x)?[0-9a-f]+$/iu), t.StrictHexStruct = (0, e.pattern)((0, e.string)(), /^0x[0-9a-f]+$/iu);
  function n(f) {
    return (0, e.is)(f, t.HexStruct);
  }
  t.isHexString = n;
  function i(f) {
    return (0, e.is)(f, t.StrictHexStruct);
  }
  t.isStrictHexString = i;
  function o(f) {
    (0, r.assert)(n(f), "Value must be a hexadecimal string.");
  }
  t.assertIsHexString = o;
  function c(f) {
    (0, r.assert)(i(f), 'Value must be a hexadecimal string, starting with "0x".');
  }
  t.assertIsStrictHexString = c;
  function u(f) {
    return f.startsWith("0x") ? f : f.startsWith("0X") ? `0x${f.substring(2)}` : `0x${f}`;
  }
  t.add0x = u;
  function l(f) {
    return f.startsWith("0x") || f.startsWith("0X") ? f.substring(2) : f;
  }
  t.remove0x = l;
})(cu);
Object.defineProperty(At, "__esModule", { value: !0 });
At.createDataView = At.concatBytes = At.valueToBytes = At.stringToBytes = At.numberToBytes = At.signedBigIntToBytes = At.bigIntToBytes = At.hexToBytes = At.bytesToString = At.bytesToNumber = At.bytesToSignedBigInt = At.bytesToBigInt = At.bytesToHex = At.assertIsBytes = At.isBytes = void 0;
const Cn = Pr, K0 = cu, Zv = 48, Yv = 58, Xv = 87;
function bO() {
  const t = [];
  return () => {
    if (t.length === 0)
      for (let e = 0; e < 256; e++)
        t.push(e.toString(16).padStart(2, "0"));
    return t;
  };
}
const EO = bO();
function Jp(t) {
  return t instanceof Uint8Array;
}
At.isBytes = Jp;
function Na(t) {
  (0, Cn.assert)(Jp(t), "Value must be a Uint8Array.");
}
At.assertIsBytes = Na;
function E2(t) {
  if (Na(t), t.length === 0)
    return "0x";
  const e = EO(), r = new Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = e[t[n]];
  return (0, K0.add0x)(r.join(""));
}
At.bytesToHex = E2;
function S2(t) {
  Na(t);
  const e = E2(t);
  return BigInt(e);
}
At.bytesToBigInt = S2;
function SO(t) {
  Na(t);
  let e = BigInt(0);
  for (const r of t)
    e = (e << BigInt(8)) + BigInt(r);
  return BigInt.asIntN(t.length * 8, e);
}
At.bytesToSignedBigInt = SO;
function CO(t) {
  Na(t);
  const e = S2(t);
  return (0, Cn.assert)(e <= BigInt(Number.MAX_SAFE_INTEGER), "Number is not a safe integer. Use `bytesToBigInt` instead."), Number(e);
}
At.bytesToNumber = CO;
function IO(t) {
  return Na(t), new TextDecoder().decode(t);
}
At.bytesToString = IO;
function Wh(t) {
  var e;
  if (((e = t?.toLowerCase) === null || e === void 0 ? void 0 : e.call(t)) === "0x")
    return new Uint8Array();
  (0, K0.assertIsHexString)(t);
  const r = (0, K0.remove0x)(t).toLowerCase(), n = r.length % 2 === 0 ? r : `0${r}`, i = new Uint8Array(n.length / 2);
  for (let o = 0; o < i.length; o++) {
    const c = n.charCodeAt(o * 2), u = n.charCodeAt(o * 2 + 1), l = c - (c < Yv ? Zv : Xv), f = u - (u < Yv ? Zv : Xv);
    i[o] = l * 16 + f;
  }
  return i;
}
At.hexToBytes = Wh;
function C2(t) {
  (0, Cn.assert)(typeof t == "bigint", "Value must be a bigint."), (0, Cn.assert)(t >= BigInt(0), "Value must be a non-negative bigint.");
  const e = t.toString(16);
  return Wh(e);
}
At.bigIntToBytes = C2;
function xO(t, e) {
  (0, Cn.assert)(e > 0);
  const r = t >> BigInt(31);
  return !((~t & r) + (t & ~r) >> BigInt(e * 8 + -1));
}
function RO(t, e) {
  (0, Cn.assert)(typeof t == "bigint", "Value must be a bigint."), (0, Cn.assert)(typeof e == "number", "Byte length must be a number."), (0, Cn.assert)(e > 0, "Byte length must be greater than 0."), (0, Cn.assert)(xO(t, e), "Byte length is too small to represent the given value.");
  let r = t;
  const n = new Uint8Array(e);
  for (let i = 0; i < n.length; i++)
    n[i] = Number(BigInt.asUintN(8, r)), r >>= BigInt(8);
  return n.reverse();
}
At.signedBigIntToBytes = RO;
function I2(t) {
  (0, Cn.assert)(typeof t == "number", "Value must be a number."), (0, Cn.assert)(t >= 0, "Value must be a non-negative number."), (0, Cn.assert)(Number.isSafeInteger(t), "Value is not a safe integer. Use `bigIntToBytes` instead.");
  const e = t.toString(16);
  return Wh(e);
}
At.numberToBytes = I2;
function x2(t) {
  return (0, Cn.assert)(typeof t == "string", "Value must be a string."), new TextEncoder().encode(t);
}
At.stringToBytes = x2;
function R2(t) {
  if (typeof t == "bigint")
    return C2(t);
  if (typeof t == "number")
    return I2(t);
  if (typeof t == "string")
    return t.startsWith("0x") ? Wh(t) : x2(t);
  if (Jp(t))
    return t;
  throw new TypeError(`Unsupported value type: "${typeof t}".`);
}
At.valueToBytes = R2;
function AO(t) {
  const e = new Array(t.length);
  let r = 0;
  for (let i = 0; i < t.length; i++) {
    const o = R2(t[i]);
    e[i] = o, r += o.length;
  }
  const n = new Uint8Array(r);
  for (let i = 0, o = 0; i < e.length; i++)
    n.set(e[i], o), o += e[i].length;
  return n;
}
At.concatBytes = AO;
function MO(t) {
  if (typeof Buffer < "u" && t instanceof Buffer) {
    const e = t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength);
    return new DataView(e);
  }
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
At.createDataView = MO;
var Kh = {};
Object.defineProperty(Kh, "__esModule", { value: !0 });
Kh.ChecksumStruct = void 0;
const ey = Co, DO = au;
Kh.ChecksumStruct = (0, ey.size)((0, DO.base64)((0, ey.string)(), { paddingRequired: !0 }), 44, 44);
var Di = {};
Object.defineProperty(Di, "__esModule", { value: !0 });
Di.createHex = Di.createBytes = Di.createBigInt = Di.createNumber = void 0;
const ir = Co, OO = Pr, A2 = At, Gh = cu, M2 = (0, ir.union)([(0, ir.number)(), (0, ir.bigint)(), (0, ir.string)(), Gh.StrictHexStruct]), PO = (0, ir.coerce)((0, ir.number)(), M2, Number), TO = (0, ir.coerce)((0, ir.bigint)(), M2, BigInt);
(0, ir.union)([Gh.StrictHexStruct, (0, ir.instance)(Uint8Array)]);
const NO = (0, ir.coerce)((0, ir.instance)(Uint8Array), (0, ir.union)([Gh.StrictHexStruct]), A2.hexToBytes), kO = (0, ir.coerce)(Gh.StrictHexStruct, (0, ir.instance)(Uint8Array), A2.bytesToHex);
function LO(t) {
  try {
    const e = (0, ir.create)(t, PO);
    return (0, OO.assert)(Number.isFinite(e), `Expected a number-like value, got "${t}".`), e;
  } catch (e) {
    throw e instanceof ir.StructError ? new Error(`Expected a number-like value, got "${t}".`) : e;
  }
}
Di.createNumber = LO;
function $O(t) {
  try {
    return (0, ir.create)(t, TO);
  } catch (e) {
    throw e instanceof ir.StructError ? new Error(`Expected a number-like value, got "${String(e.value)}".`) : e;
  }
}
Di.createBigInt = $O;
function FO(t) {
  if (typeof t == "string" && t.toLowerCase() === "0x")
    return new Uint8Array();
  try {
    return (0, ir.create)(t, NO);
  } catch (e) {
    throw e instanceof ir.StructError ? new Error(`Expected a bytes-like value, got "${String(e.value)}".`) : e;
  }
}
Di.createBytes = FO;
function BO(t) {
  if (t instanceof Uint8Array && t.length === 0 || typeof t == "string" && t.toLowerCase() === "0x")
    return "0x";
  try {
    return (0, ir.create)(t, kO);
  } catch (e) {
    throw e instanceof ir.StructError ? new Error(`Expected a bytes-like value, got "${String(e.value)}".`) : e;
  }
}
Di.createHex = BO;
var Ca = {}, D2 = Te && Te.__classPrivateFieldSet || function(t, e, r, n, i) {
  if (n === "m")
    throw new TypeError("Private method is not writable");
  if (n === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? i.call(t, r) : i ? i.value = r : e.set(t, r), r;
}, Gr = Te && Te.__classPrivateFieldGet || function(t, e, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}, ii, bi;
Object.defineProperty(Ca, "__esModule", { value: !0 });
Ca.FrozenSet = Ca.FrozenMap = void 0;
class Qp {
  constructor(e) {
    ii.set(this, void 0), D2(this, ii, new Map(e), "f"), Object.freeze(this);
  }
  get size() {
    return Gr(this, ii, "f").size;
  }
  [(ii = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
    return Gr(this, ii, "f")[Symbol.iterator]();
  }
  entries() {
    return Gr(this, ii, "f").entries();
  }
  forEach(e, r) {
    return Gr(this, ii, "f").forEach((n, i, o) => e.call(r, n, i, this));
  }
  get(e) {
    return Gr(this, ii, "f").get(e);
  }
  has(e) {
    return Gr(this, ii, "f").has(e);
  }
  keys() {
    return Gr(this, ii, "f").keys();
  }
  values() {
    return Gr(this, ii, "f").values();
  }
  toString() {
    return `FrozenMap(${this.size}) {${this.size > 0 ? ` ${[...this.entries()].map(([e, r]) => `${String(e)} => ${String(r)}`).join(", ")} ` : ""}}`;
  }
}
Ca.FrozenMap = Qp;
class Zp {
  constructor(e) {
    bi.set(this, void 0), D2(this, bi, new Set(e), "f"), Object.freeze(this);
  }
  get size() {
    return Gr(this, bi, "f").size;
  }
  [(bi = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
    return Gr(this, bi, "f")[Symbol.iterator]();
  }
  entries() {
    return Gr(this, bi, "f").entries();
  }
  forEach(e, r) {
    return Gr(this, bi, "f").forEach((n, i, o) => e.call(r, n, i, this));
  }
  has(e) {
    return Gr(this, bi, "f").has(e);
  }
  keys() {
    return Gr(this, bi, "f").keys();
  }
  values() {
    return Gr(this, bi, "f").values();
  }
  toString() {
    return `FrozenSet(${this.size}) {${this.size > 0 ? ` ${[...this.values()].map((e) => String(e)).join(", ")} ` : ""}}`;
  }
}
Ca.FrozenSet = Zp;
Object.freeze(Qp);
Object.freeze(Qp.prototype);
Object.freeze(Zp);
Object.freeze(Zp.prototype);
var O2 = {};
Object.defineProperty(O2, "__esModule", { value: !0 });
var P2 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getJsonRpcIdValidator = t.assertIsJsonRpcError = t.isJsonRpcError = t.assertIsJsonRpcFailure = t.isJsonRpcFailure = t.assertIsJsonRpcSuccess = t.isJsonRpcSuccess = t.assertIsJsonRpcResponse = t.isJsonRpcResponse = t.assertIsPendingJsonRpcResponse = t.isPendingJsonRpcResponse = t.JsonRpcResponseStruct = t.JsonRpcFailureStruct = t.JsonRpcSuccessStruct = t.PendingJsonRpcResponseStruct = t.assertIsJsonRpcRequest = t.isJsonRpcRequest = t.assertIsJsonRpcNotification = t.isJsonRpcNotification = t.JsonRpcNotificationStruct = t.JsonRpcRequestStruct = t.JsonRpcParamsStruct = t.JsonRpcErrorStruct = t.JsonRpcIdStruct = t.JsonRpcVersionStruct = t.jsonrpc2 = t.getJsonSize = t.isValidJson = t.JsonStruct = t.UnsafeJsonStruct = void 0;
  const e = Co, r = Pr, n = () => (0, e.define)("finite number", (L) => (0, e.is)(L, (0, e.number)()) && Number.isFinite(L));
  t.UnsafeJsonStruct = (0, e.union)([
    (0, e.literal)(null),
    (0, e.boolean)(),
    n(),
    (0, e.string)(),
    (0, e.array)((0, e.lazy)(() => t.UnsafeJsonStruct)),
    (0, e.record)((0, e.string)(), (0, e.lazy)(() => t.UnsafeJsonStruct))
  ]), t.JsonStruct = (0, e.define)("Json", (L, P) => {
    function v(N, ie) {
      const he = [...ie.validator(N, P)];
      return he.length > 0 ? he : !0;
    }
    try {
      const N = v(L, t.UnsafeJsonStruct);
      return N !== !0 ? N : v(JSON.parse(JSON.stringify(L)), t.UnsafeJsonStruct);
    } catch (N) {
      return N instanceof RangeError ? "Circular reference detected" : !1;
    }
  });
  function i(L) {
    return (0, e.is)(L, t.JsonStruct);
  }
  t.isValidJson = i;
  function o(L) {
    (0, r.assertStruct)(L, t.JsonStruct, "Invalid JSON value");
    const P = JSON.stringify(L);
    return new TextEncoder().encode(P).byteLength;
  }
  t.getJsonSize = o, t.jsonrpc2 = "2.0", t.JsonRpcVersionStruct = (0, e.literal)(t.jsonrpc2), t.JsonRpcIdStruct = (0, e.nullable)((0, e.union)([(0, e.number)(), (0, e.string)()])), t.JsonRpcErrorStruct = (0, e.object)({
    code: (0, e.integer)(),
    message: (0, e.string)(),
    data: (0, e.optional)(t.JsonStruct),
    stack: (0, e.optional)((0, e.string)())
  }), t.JsonRpcParamsStruct = (0, e.optional)((0, e.union)([(0, e.record)((0, e.string)(), t.JsonStruct), (0, e.array)(t.JsonStruct)])), t.JsonRpcRequestStruct = (0, e.object)({
    id: t.JsonRpcIdStruct,
    jsonrpc: t.JsonRpcVersionStruct,
    method: (0, e.string)(),
    params: t.JsonRpcParamsStruct
  }), t.JsonRpcNotificationStruct = (0, e.omit)(t.JsonRpcRequestStruct, ["id"]);
  function c(L) {
    return (0, e.is)(L, t.JsonRpcNotificationStruct);
  }
  t.isJsonRpcNotification = c;
  function u(L, P) {
    (0, r.assertStruct)(L, t.JsonRpcNotificationStruct, "Invalid JSON-RPC notification", P);
  }
  t.assertIsJsonRpcNotification = u;
  function l(L) {
    return (0, e.is)(L, t.JsonRpcRequestStruct);
  }
  t.isJsonRpcRequest = l;
  function f(L, P) {
    (0, r.assertStruct)(L, t.JsonRpcRequestStruct, "Invalid JSON-RPC request", P);
  }
  t.assertIsJsonRpcRequest = f, t.PendingJsonRpcResponseStruct = (0, e.object)({
    id: t.JsonRpcIdStruct,
    jsonrpc: t.JsonRpcVersionStruct,
    result: (0, e.optional)((0, e.unknown)()),
    error: (0, e.optional)(t.JsonRpcErrorStruct)
  }), t.JsonRpcSuccessStruct = (0, e.object)({
    id: t.JsonRpcIdStruct,
    jsonrpc: t.JsonRpcVersionStruct,
    result: t.JsonStruct
  }), t.JsonRpcFailureStruct = (0, e.object)({
    id: t.JsonRpcIdStruct,
    jsonrpc: t.JsonRpcVersionStruct,
    error: t.JsonRpcErrorStruct
  }), t.JsonRpcResponseStruct = (0, e.union)([
    t.JsonRpcSuccessStruct,
    t.JsonRpcFailureStruct
  ]);
  function p(L) {
    return (0, e.is)(L, t.PendingJsonRpcResponseStruct);
  }
  t.isPendingJsonRpcResponse = p;
  function g(L, P) {
    (0, r.assertStruct)(L, t.PendingJsonRpcResponseStruct, "Invalid pending JSON-RPC response", P);
  }
  t.assertIsPendingJsonRpcResponse = g;
  function y(L) {
    return (0, e.is)(L, t.JsonRpcResponseStruct);
  }
  t.isJsonRpcResponse = y;
  function C(L, P) {
    (0, r.assertStruct)(L, t.JsonRpcResponseStruct, "Invalid JSON-RPC response", P);
  }
  t.assertIsJsonRpcResponse = C;
  function R(L) {
    return (0, e.is)(L, t.JsonRpcSuccessStruct);
  }
  t.isJsonRpcSuccess = R;
  function J(L, P) {
    (0, r.assertStruct)(L, t.JsonRpcSuccessStruct, "Invalid JSON-RPC success response", P);
  }
  t.assertIsJsonRpcSuccess = J;
  function G(L) {
    return (0, e.is)(L, t.JsonRpcFailureStruct);
  }
  t.isJsonRpcFailure = G;
  function H(L, P) {
    (0, r.assertStruct)(L, t.JsonRpcFailureStruct, "Invalid JSON-RPC failure response", P);
  }
  t.assertIsJsonRpcFailure = H;
  function T(L) {
    return (0, e.is)(L, t.JsonRpcErrorStruct);
  }
  t.isJsonRpcError = T;
  function q(L, P) {
    (0, r.assertStruct)(L, t.JsonRpcErrorStruct, "Invalid JSON-RPC error", P);
  }
  t.assertIsJsonRpcError = q;
  function B(L) {
    const { permitEmptyString: P, permitFractions: v, permitNull: N } = Object.assign({ permitEmptyString: !0, permitFractions: !1, permitNull: !0 }, L);
    return (le) => !!(typeof le == "number" && (v || Number.isInteger(le)) || typeof le == "string" && (P || le.length > 0) || N && le === null);
  }
  t.getJsonRpcIdValidator = B;
})(P2);
var T2 = {};
Object.defineProperty(T2, "__esModule", { value: !0 });
var Ia = {}, G0 = { exports: {} }, Xd, ty;
function UO() {
  if (ty)
    return Xd;
  ty = 1;
  var t = 1e3, e = t * 60, r = e * 60, n = r * 24, i = n * 7, o = n * 365.25;
  Xd = function(p, g) {
    g = g || {};
    var y = typeof p;
    if (y === "string" && p.length > 0)
      return c(p);
    if (y === "number" && isFinite(p))
      return g.long ? l(p) : u(p);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(p)
    );
  };
  function c(p) {
    if (p = String(p), !(p.length > 100)) {
      var g = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        p
      );
      if (g) {
        var y = parseFloat(g[1]), C = (g[2] || "ms").toLowerCase();
        switch (C) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return y * o;
          case "weeks":
          case "week":
          case "w":
            return y * i;
          case "days":
          case "day":
          case "d":
            return y * n;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return y * r;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return y * e;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return y * t;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return y;
          default:
            return;
        }
      }
    }
  }
  function u(p) {
    var g = Math.abs(p);
    return g >= n ? Math.round(p / n) + "d" : g >= r ? Math.round(p / r) + "h" : g >= e ? Math.round(p / e) + "m" : g >= t ? Math.round(p / t) + "s" : p + "ms";
  }
  function l(p) {
    var g = Math.abs(p);
    return g >= n ? f(p, g, n, "day") : g >= r ? f(p, g, r, "hour") : g >= e ? f(p, g, e, "minute") : g >= t ? f(p, g, t, "second") : p + " ms";
  }
  function f(p, g, y, C) {
    var R = g >= y * 1.5;
    return Math.round(p / y) + " " + C + (R ? "s" : "");
  }
  return Xd;
}
function jO(t) {
  r.debug = r, r.default = r, r.coerce = l, r.disable = o, r.enable = i, r.enabled = c, r.humanize = UO(), r.destroy = f, Object.keys(t).forEach((p) => {
    r[p] = t[p];
  }), r.names = [], r.skips = [], r.formatters = {};
  function e(p) {
    let g = 0;
    for (let y = 0; y < p.length; y++)
      g = (g << 5) - g + p.charCodeAt(y), g |= 0;
    return r.colors[Math.abs(g) % r.colors.length];
  }
  r.selectColor = e;
  function r(p) {
    let g, y = null, C, R;
    function J(...G) {
      if (!J.enabled)
        return;
      const H = J, T = Number(/* @__PURE__ */ new Date()), q = T - (g || T);
      H.diff = q, H.prev = g, H.curr = T, g = T, G[0] = r.coerce(G[0]), typeof G[0] != "string" && G.unshift("%O");
      let B = 0;
      G[0] = G[0].replace(/%([a-zA-Z%])/g, (P, v) => {
        if (P === "%%")
          return "%";
        B++;
        const N = r.formatters[v];
        if (typeof N == "function") {
          const ie = G[B];
          P = N.call(H, ie), G.splice(B, 1), B--;
        }
        return P;
      }), r.formatArgs.call(H, G), (H.log || r.log).apply(H, G);
    }
    return J.namespace = p, J.useColors = r.useColors(), J.color = r.selectColor(p), J.extend = n, J.destroy = r.destroy, Object.defineProperty(J, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => y !== null ? y : (C !== r.namespaces && (C = r.namespaces, R = r.enabled(p)), R),
      set: (G) => {
        y = G;
      }
    }), typeof r.init == "function" && r.init(J), J;
  }
  function n(p, g) {
    const y = r(this.namespace + (typeof g > "u" ? ":" : g) + p);
    return y.log = this.log, y;
  }
  function i(p) {
    r.save(p), r.namespaces = p, r.names = [], r.skips = [];
    let g;
    const y = (typeof p == "string" ? p : "").split(/[\s,]+/), C = y.length;
    for (g = 0; g < C; g++)
      y[g] && (p = y[g].replace(/\*/g, ".*?"), p[0] === "-" ? r.skips.push(new RegExp("^" + p.slice(1) + "$")) : r.names.push(new RegExp("^" + p + "$")));
  }
  function o() {
    const p = [
      ...r.names.map(u),
      ...r.skips.map(u).map((g) => "-" + g)
    ].join(",");
    return r.enable(""), p;
  }
  function c(p) {
    if (p[p.length - 1] === "*")
      return !0;
    let g, y;
    for (g = 0, y = r.skips.length; g < y; g++)
      if (r.skips[g].test(p))
        return !1;
    for (g = 0, y = r.names.length; g < y; g++)
      if (r.names[g].test(p))
        return !0;
    return !1;
  }
  function u(p) {
    return p.toString().substring(2, p.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function l(p) {
    return p instanceof Error ? p.stack || p.message : p;
  }
  function f() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return r.enable(r.load()), r;
}
var HO = jO;
(function(t, e) {
  e.formatArgs = n, e.save = i, e.load = o, e.useColors = r, e.storage = c(), e.destroy = /* @__PURE__ */ (() => {
    let l = !1;
    return () => {
      l || (l = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), e.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function r() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function n(l) {
    if (l[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + l[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors)
      return;
    const f = "color: " + this.color;
    l.splice(1, 0, f, "color: inherit");
    let p = 0, g = 0;
    l[0].replace(/%[a-zA-Z%]/g, (y) => {
      y !== "%%" && (p++, y === "%c" && (g = p));
    }), l.splice(g, 0, f);
  }
  e.log = console.debug || console.log || (() => {
  });
  function i(l) {
    try {
      l ? e.storage.setItem("debug", l) : e.storage.removeItem("debug");
    } catch {
    }
  }
  function o() {
    let l;
    try {
      l = e.storage.getItem("debug");
    } catch {
    }
    return !l && typeof process < "u" && "env" in process && (l = process.env.DEBUG), l;
  }
  function c() {
    try {
      return localStorage;
    } catch {
    }
  }
  t.exports = HO(e);
  const { formatters: u } = t.exports;
  u.j = function(l) {
    try {
      return JSON.stringify(l);
    } catch (f) {
      return "[UnexpectedJSONParseError]: " + f.message;
    }
  };
})(G0, G0.exports);
var qO = G0.exports, zO = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ia, "__esModule", { value: !0 });
Ia.createModuleLogger = Ia.createProjectLogger = void 0;
const VO = zO(qO), WO = (0, VO.default)("metamask");
function KO(t) {
  return WO.extend(t);
}
Ia.createProjectLogger = KO;
function GO(t, e) {
  return t.extend(e);
}
Ia.createModuleLogger = GO;
var N2 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.calculateNumberSize = t.calculateStringSize = t.isASCII = t.isPlainObject = t.ESCAPE_CHARACTERS_REGEXP = t.JsonSize = t.hasProperty = t.isObject = t.isNullOrUndefined = t.isNonEmptyArray = void 0;
  function e(f) {
    return Array.isArray(f) && f.length > 0;
  }
  t.isNonEmptyArray = e;
  function r(f) {
    return f == null;
  }
  t.isNullOrUndefined = r;
  function n(f) {
    return !!f && typeof f == "object" && !Array.isArray(f);
  }
  t.isObject = n;
  const i = (f, p) => Object.hasOwnProperty.call(f, p);
  t.hasProperty = i, function(f) {
    f[f.Null = 4] = "Null", f[f.Comma = 1] = "Comma", f[f.Wrapper = 1] = "Wrapper", f[f.True = 4] = "True", f[f.False = 5] = "False", f[f.Quote = 1] = "Quote", f[f.Colon = 1] = "Colon", f[f.Date = 24] = "Date";
  }(t.JsonSize || (t.JsonSize = {})), t.ESCAPE_CHARACTERS_REGEXP = /"|\\|\n|\r|\t/gu;
  function o(f) {
    if (typeof f != "object" || f === null)
      return !1;
    try {
      let p = f;
      for (; Object.getPrototypeOf(p) !== null; )
        p = Object.getPrototypeOf(p);
      return Object.getPrototypeOf(f) === p;
    } catch {
      return !1;
    }
  }
  t.isPlainObject = o;
  function c(f) {
    return f.charCodeAt(0) <= 127;
  }
  t.isASCII = c;
  function u(f) {
    var p;
    return f.split("").reduce((y, C) => c(C) ? y + 1 : y + 2, 0) + ((p = f.match(t.ESCAPE_CHARACTERS_REGEXP)) !== null && p !== void 0 ? p : []).length;
  }
  t.calculateStringSize = u;
  function l(f) {
    return f.toString().length;
  }
  t.calculateNumberSize = l;
})(N2);
var Oi = {};
Object.defineProperty(Oi, "__esModule", { value: !0 });
Oi.hexToBigInt = Oi.hexToNumber = Oi.bigIntToHex = Oi.numberToHex = void 0;
const la = Pr, Tc = cu, JO = (t) => ((0, la.assert)(typeof t == "number", "Value must be a number."), (0, la.assert)(t >= 0, "Value must be a non-negative number."), (0, la.assert)(Number.isSafeInteger(t), "Value is not a safe integer. Use `bigIntToHex` instead."), (0, Tc.add0x)(t.toString(16)));
Oi.numberToHex = JO;
const QO = (t) => ((0, la.assert)(typeof t == "bigint", "Value must be a bigint."), (0, la.assert)(t >= 0, "Value must be a non-negative bigint."), (0, Tc.add0x)(t.toString(16)));
Oi.bigIntToHex = QO;
const ZO = (t) => {
  (0, Tc.assertIsHexString)(t);
  const e = parseInt(t, 16);
  return (0, la.assert)(Number.isSafeInteger(e), "Value is not a safe integer. Use `hexToBigInt` instead."), e;
};
Oi.hexToNumber = ZO;
const YO = (t) => ((0, Tc.assertIsHexString)(t), BigInt((0, Tc.add0x)(t)));
Oi.hexToBigInt = YO;
var k2 = {};
Object.defineProperty(k2, "__esModule", { value: !0 });
var L2 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.timeSince = t.inMilliseconds = t.Duration = void 0, function(o) {
    o[o.Millisecond = 1] = "Millisecond", o[o.Second = 1e3] = "Second", o[o.Minute = 6e4] = "Minute", o[o.Hour = 36e5] = "Hour", o[o.Day = 864e5] = "Day", o[o.Week = 6048e5] = "Week", o[o.Year = 31536e6] = "Year";
  }(t.Duration || (t.Duration = {}));
  const e = (o) => Number.isInteger(o) && o >= 0, r = (o, c) => {
    if (!e(o))
      throw new Error(`"${c}" must be a non-negative integer. Received: "${o}".`);
  };
  function n(o, c) {
    return r(o, "count"), o * c;
  }
  t.inMilliseconds = n;
  function i(o) {
    return r(o, "timestamp"), Date.now() - o;
  }
  t.timeSince = i;
})(L2);
var $2 = {};
Object.defineProperty($2, "__esModule", { value: !0 });
var F2 = {}, J0 = { exports: {} };
const XO = "2.0.0", B2 = 256, eP = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, tP = 16, rP = B2 - 6, nP = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var Jh = {
  MAX_LENGTH: B2,
  MAX_SAFE_COMPONENT_LENGTH: tP,
  MAX_SAFE_BUILD_LENGTH: rP,
  MAX_SAFE_INTEGER: eP,
  RELEASE_TYPES: nP,
  SEMVER_SPEC_VERSION: XO,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
const iP = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...t) => console.error("SEMVER", ...t) : () => {
};
var Qh = iP;
(function(t, e) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: r,
    MAX_SAFE_BUILD_LENGTH: n,
    MAX_LENGTH: i
  } = Jh, o = Qh;
  e = t.exports = {};
  const c = e.re = [], u = e.safeRe = [], l = e.src = [], f = e.t = {};
  let p = 0;
  const g = "[a-zA-Z0-9-]", y = [
    ["\\s", 1],
    ["\\d", i],
    [g, n]
  ], C = (J) => {
    for (const [G, H] of y)
      J = J.split(`${G}*`).join(`${G}{0,${H}}`).split(`${G}+`).join(`${G}{1,${H}}`);
    return J;
  }, R = (J, G, H) => {
    const T = C(G), q = p++;
    o(J, q, G), f[J] = q, l[q] = G, c[q] = new RegExp(G, H ? "g" : void 0), u[q] = new RegExp(T, H ? "g" : void 0);
  };
  R("NUMERICIDENTIFIER", "0|[1-9]\\d*"), R("NUMERICIDENTIFIERLOOSE", "\\d+"), R("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${g}*`), R("MAINVERSION", `(${l[f.NUMERICIDENTIFIER]})\\.(${l[f.NUMERICIDENTIFIER]})\\.(${l[f.NUMERICIDENTIFIER]})`), R("MAINVERSIONLOOSE", `(${l[f.NUMERICIDENTIFIERLOOSE]})\\.(${l[f.NUMERICIDENTIFIERLOOSE]})\\.(${l[f.NUMERICIDENTIFIERLOOSE]})`), R("PRERELEASEIDENTIFIER", `(?:${l[f.NUMERICIDENTIFIER]}|${l[f.NONNUMERICIDENTIFIER]})`), R("PRERELEASEIDENTIFIERLOOSE", `(?:${l[f.NUMERICIDENTIFIERLOOSE]}|${l[f.NONNUMERICIDENTIFIER]})`), R("PRERELEASE", `(?:-(${l[f.PRERELEASEIDENTIFIER]}(?:\\.${l[f.PRERELEASEIDENTIFIER]})*))`), R("PRERELEASELOOSE", `(?:-?(${l[f.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${l[f.PRERELEASEIDENTIFIERLOOSE]})*))`), R("BUILDIDENTIFIER", `${g}+`), R("BUILD", `(?:\\+(${l[f.BUILDIDENTIFIER]}(?:\\.${l[f.BUILDIDENTIFIER]})*))`), R("FULLPLAIN", `v?${l[f.MAINVERSION]}${l[f.PRERELEASE]}?${l[f.BUILD]}?`), R("FULL", `^${l[f.FULLPLAIN]}$`), R("LOOSEPLAIN", `[v=\\s]*${l[f.MAINVERSIONLOOSE]}${l[f.PRERELEASELOOSE]}?${l[f.BUILD]}?`), R("LOOSE", `^${l[f.LOOSEPLAIN]}$`), R("GTLT", "((?:<|>)?=?)"), R("XRANGEIDENTIFIERLOOSE", `${l[f.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), R("XRANGEIDENTIFIER", `${l[f.NUMERICIDENTIFIER]}|x|X|\\*`), R("XRANGEPLAIN", `[v=\\s]*(${l[f.XRANGEIDENTIFIER]})(?:\\.(${l[f.XRANGEIDENTIFIER]})(?:\\.(${l[f.XRANGEIDENTIFIER]})(?:${l[f.PRERELEASE]})?${l[f.BUILD]}?)?)?`), R("XRANGEPLAINLOOSE", `[v=\\s]*(${l[f.XRANGEIDENTIFIERLOOSE]})(?:\\.(${l[f.XRANGEIDENTIFIERLOOSE]})(?:\\.(${l[f.XRANGEIDENTIFIERLOOSE]})(?:${l[f.PRERELEASELOOSE]})?${l[f.BUILD]}?)?)?`), R("XRANGE", `^${l[f.GTLT]}\\s*${l[f.XRANGEPLAIN]}$`), R("XRANGELOOSE", `^${l[f.GTLT]}\\s*${l[f.XRANGEPLAINLOOSE]}$`), R("COERCEPLAIN", `(^|[^\\d])(\\d{1,${r}})(?:\\.(\\d{1,${r}}))?(?:\\.(\\d{1,${r}}))?`), R("COERCE", `${l[f.COERCEPLAIN]}(?:$|[^\\d])`), R("COERCEFULL", l[f.COERCEPLAIN] + `(?:${l[f.PRERELEASE]})?(?:${l[f.BUILD]})?(?:$|[^\\d])`), R("COERCERTL", l[f.COERCE], !0), R("COERCERTLFULL", l[f.COERCEFULL], !0), R("LONETILDE", "(?:~>?)"), R("TILDETRIM", `(\\s*)${l[f.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", R("TILDE", `^${l[f.LONETILDE]}${l[f.XRANGEPLAIN]}$`), R("TILDELOOSE", `^${l[f.LONETILDE]}${l[f.XRANGEPLAINLOOSE]}$`), R("LONECARET", "(?:\\^)"), R("CARETTRIM", `(\\s*)${l[f.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", R("CARET", `^${l[f.LONECARET]}${l[f.XRANGEPLAIN]}$`), R("CARETLOOSE", `^${l[f.LONECARET]}${l[f.XRANGEPLAINLOOSE]}$`), R("COMPARATORLOOSE", `^${l[f.GTLT]}\\s*(${l[f.LOOSEPLAIN]})$|^$`), R("COMPARATOR", `^${l[f.GTLT]}\\s*(${l[f.FULLPLAIN]})$|^$`), R("COMPARATORTRIM", `(\\s*)${l[f.GTLT]}\\s*(${l[f.LOOSEPLAIN]}|${l[f.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", R("HYPHENRANGE", `^\\s*(${l[f.XRANGEPLAIN]})\\s+-\\s+(${l[f.XRANGEPLAIN]})\\s*$`), R("HYPHENRANGELOOSE", `^\\s*(${l[f.XRANGEPLAINLOOSE]})\\s+-\\s+(${l[f.XRANGEPLAINLOOSE]})\\s*$`), R("STAR", "(<|>)?=?\\s*\\*"), R("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), R("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(J0, J0.exports);
var uu = J0.exports;
const sP = Object.freeze({ loose: !0 }), oP = Object.freeze({}), aP = (t) => t ? typeof t != "object" ? sP : t : oP;
var Yp = aP;
const ry = /^[0-9]+$/, U2 = (t, e) => {
  const r = ry.test(t), n = ry.test(e);
  return r && n && (t = +t, e = +e), t === e ? 0 : r && !n ? -1 : n && !r ? 1 : t < e ? -1 : 1;
}, cP = (t, e) => U2(e, t);
var j2 = {
  compareIdentifiers: U2,
  rcompareIdentifiers: cP
};
const Ml = Qh, { MAX_LENGTH: ny, MAX_SAFE_INTEGER: Dl } = Jh, { safeRe: iy, t: sy } = uu, uP = Yp, { compareIdentifiers: Xo } = j2;
let lP = class Ci {
  constructor(e, r) {
    if (r = uP(r), e instanceof Ci) {
      if (e.loose === !!r.loose && e.includePrerelease === !!r.includePrerelease)
        return e;
      e = e.version;
    } else if (typeof e != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof e}".`);
    if (e.length > ny)
      throw new TypeError(
        `version is longer than ${ny} characters`
      );
    Ml("SemVer", e, r), this.options = r, this.loose = !!r.loose, this.includePrerelease = !!r.includePrerelease;
    const n = e.trim().match(r.loose ? iy[sy.LOOSE] : iy[sy.FULL]);
    if (!n)
      throw new TypeError(`Invalid Version: ${e}`);
    if (this.raw = e, this.major = +n[1], this.minor = +n[2], this.patch = +n[3], this.major > Dl || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > Dl || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > Dl || this.patch < 0)
      throw new TypeError("Invalid patch version");
    n[4] ? this.prerelease = n[4].split(".").map((i) => {
      if (/^[0-9]+$/.test(i)) {
        const o = +i;
        if (o >= 0 && o < Dl)
          return o;
      }
      return i;
    }) : this.prerelease = [], this.build = n[5] ? n[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(e) {
    if (Ml("SemVer.compare", this.version, this.options, e), !(e instanceof Ci)) {
      if (typeof e == "string" && e === this.version)
        return 0;
      e = new Ci(e, this.options);
    }
    return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
  }
  compareMain(e) {
    return e instanceof Ci || (e = new Ci(e, this.options)), Xo(this.major, e.major) || Xo(this.minor, e.minor) || Xo(this.patch, e.patch);
  }
  comparePre(e) {
    if (e instanceof Ci || (e = new Ci(e, this.options)), this.prerelease.length && !e.prerelease.length)
      return -1;
    if (!this.prerelease.length && e.prerelease.length)
      return 1;
    if (!this.prerelease.length && !e.prerelease.length)
      return 0;
    let r = 0;
    do {
      const n = this.prerelease[r], i = e.prerelease[r];
      if (Ml("prerelease compare", r, n, i), n === void 0 && i === void 0)
        return 0;
      if (i === void 0)
        return 1;
      if (n === void 0)
        return -1;
      if (n === i)
        continue;
      return Xo(n, i);
    } while (++r);
  }
  compareBuild(e) {
    e instanceof Ci || (e = new Ci(e, this.options));
    let r = 0;
    do {
      const n = this.build[r], i = e.build[r];
      if (Ml("prerelease compare", r, n, i), n === void 0 && i === void 0)
        return 0;
      if (i === void 0)
        return 1;
      if (n === void 0)
        return -1;
      if (n === i)
        continue;
      return Xo(n, i);
    } while (++r);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(e, r, n) {
    switch (e) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", r, n);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", r, n);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", r, n), this.inc("pre", r, n);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", r, n), this.inc("pre", r, n);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const i = Number(n) ? 1 : 0;
        if (!r && n === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (this.prerelease.length === 0)
          this.prerelease = [i];
        else {
          let o = this.prerelease.length;
          for (; --o >= 0; )
            typeof this.prerelease[o] == "number" && (this.prerelease[o]++, o = -2);
          if (o === -1) {
            if (r === this.prerelease.join(".") && n === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(i);
          }
        }
        if (r) {
          let o = [r, i];
          n === !1 && (o = [r]), Xo(this.prerelease[0], r) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = o) : this.prerelease = o;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${e}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
};
var Yr = lP;
const oy = Yr, hP = (t, e, r = !1) => {
  if (t instanceof oy)
    return t;
  try {
    return new oy(t, e);
  } catch (n) {
    if (!r)
      return null;
    throw n;
  }
};
var ka = hP;
const fP = ka, dP = (t, e) => {
  const r = fP(t, e);
  return r ? r.version : null;
};
var pP = dP;
const gP = ka, mP = (t, e) => {
  const r = gP(t.trim().replace(/^[=v]+/, ""), e);
  return r ? r.version : null;
};
var vP = mP;
const ay = Yr, yP = (t, e, r, n, i) => {
  typeof r == "string" && (i = n, n = r, r = void 0);
  try {
    return new ay(
      t instanceof ay ? t.version : t,
      r
    ).inc(e, n, i).version;
  } catch {
    return null;
  }
};
var _P = yP;
const cy = ka, wP = (t, e) => {
  const r = cy(t, null, !0), n = cy(e, null, !0), i = r.compare(n);
  if (i === 0)
    return null;
  const o = i > 0, c = o ? r : n, u = o ? n : r, l = !!c.prerelease.length;
  if (!!u.prerelease.length && !l)
    return !u.patch && !u.minor ? "major" : c.patch ? "patch" : c.minor ? "minor" : "major";
  const p = l ? "pre" : "";
  return r.major !== n.major ? p + "major" : r.minor !== n.minor ? p + "minor" : r.patch !== n.patch ? p + "patch" : "prerelease";
};
var bP = wP;
const EP = Yr, SP = (t, e) => new EP(t, e).major;
var CP = SP;
const IP = Yr, xP = (t, e) => new IP(t, e).minor;
var RP = xP;
const AP = Yr, MP = (t, e) => new AP(t, e).patch;
var DP = MP;
const OP = ka, PP = (t, e) => {
  const r = OP(t, e);
  return r && r.prerelease.length ? r.prerelease : null;
};
var TP = PP;
const uy = Yr, NP = (t, e, r) => new uy(t, r).compare(new uy(e, r));
var fi = NP;
const kP = fi, LP = (t, e, r) => kP(e, t, r);
var $P = LP;
const FP = fi, BP = (t, e) => FP(t, e, !0);
var UP = BP;
const ly = Yr, jP = (t, e, r) => {
  const n = new ly(t, r), i = new ly(e, r);
  return n.compare(i) || n.compareBuild(i);
};
var Xp = jP;
const HP = Xp, qP = (t, e) => t.sort((r, n) => HP(r, n, e));
var zP = qP;
const VP = Xp, WP = (t, e) => t.sort((r, n) => VP(n, r, e));
var KP = WP;
const GP = fi, JP = (t, e, r) => GP(t, e, r) > 0;
var Zh = JP;
const QP = fi, ZP = (t, e, r) => QP(t, e, r) < 0;
var eg = ZP;
const YP = fi, XP = (t, e, r) => YP(t, e, r) === 0;
var H2 = XP;
const eT = fi, tT = (t, e, r) => eT(t, e, r) !== 0;
var q2 = tT;
const rT = fi, nT = (t, e, r) => rT(t, e, r) >= 0;
var tg = nT;
const iT = fi, sT = (t, e, r) => iT(t, e, r) <= 0;
var rg = sT;
const oT = H2, aT = q2, cT = Zh, uT = tg, lT = eg, hT = rg, fT = (t, e, r, n) => {
  switch (e) {
    case "===":
      return typeof t == "object" && (t = t.version), typeof r == "object" && (r = r.version), t === r;
    case "!==":
      return typeof t == "object" && (t = t.version), typeof r == "object" && (r = r.version), t !== r;
    case "":
    case "=":
    case "==":
      return oT(t, r, n);
    case "!=":
      return aT(t, r, n);
    case ">":
      return cT(t, r, n);
    case ">=":
      return uT(t, r, n);
    case "<":
      return lT(t, r, n);
    case "<=":
      return hT(t, r, n);
    default:
      throw new TypeError(`Invalid operator: ${e}`);
  }
};
var z2 = fT;
const dT = Yr, pT = ka, { safeRe: Ol, t: Pl } = uu, gT = (t, e) => {
  if (t instanceof dT)
    return t;
  if (typeof t == "number" && (t = String(t)), typeof t != "string")
    return null;
  e = e || {};
  let r = null;
  if (!e.rtl)
    r = t.match(e.includePrerelease ? Ol[Pl.COERCEFULL] : Ol[Pl.COERCE]);
  else {
    const l = e.includePrerelease ? Ol[Pl.COERCERTLFULL] : Ol[Pl.COERCERTL];
    let f;
    for (; (f = l.exec(t)) && (!r || r.index + r[0].length !== t.length); )
      (!r || f.index + f[0].length !== r.index + r[0].length) && (r = f), l.lastIndex = f.index + f[1].length + f[2].length;
    l.lastIndex = -1;
  }
  if (r === null)
    return null;
  const n = r[2], i = r[3] || "0", o = r[4] || "0", c = e.includePrerelease && r[5] ? `-${r[5]}` : "", u = e.includePrerelease && r[6] ? `+${r[6]}` : "";
  return pT(`${n}.${i}.${o}${c}${u}`, e);
};
var mT = gT, e0, hy;
function vT() {
  return hy || (hy = 1, e0 = function(t) {
    t.prototype[Symbol.iterator] = function* () {
      for (let e = this.head; e; e = e.next)
        yield e.value;
    };
  }), e0;
}
var yT = Dt;
Dt.Node = go;
Dt.create = Dt;
function Dt(t) {
  var e = this;
  if (e instanceof Dt || (e = new Dt()), e.tail = null, e.head = null, e.length = 0, t && typeof t.forEach == "function")
    t.forEach(function(i) {
      e.push(i);
    });
  else if (arguments.length > 0)
    for (var r = 0, n = arguments.length; r < n; r++)
      e.push(arguments[r]);
  return e;
}
Dt.prototype.removeNode = function(t) {
  if (t.list !== this)
    throw new Error("removing node which does not belong to this list");
  var e = t.next, r = t.prev;
  return e && (e.prev = r), r && (r.next = e), t === this.head && (this.head = e), t === this.tail && (this.tail = r), t.list.length--, t.next = null, t.prev = null, t.list = null, e;
};
Dt.prototype.unshiftNode = function(t) {
  if (t !== this.head) {
    t.list && t.list.removeNode(t);
    var e = this.head;
    t.list = this, t.next = e, e && (e.prev = t), this.head = t, this.tail || (this.tail = t), this.length++;
  }
};
Dt.prototype.pushNode = function(t) {
  if (t !== this.tail) {
    t.list && t.list.removeNode(t);
    var e = this.tail;
    t.list = this, t.prev = e, e && (e.next = t), this.tail = t, this.head || (this.head = t), this.length++;
  }
};
Dt.prototype.push = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    wT(this, arguments[t]);
  return this.length;
};
Dt.prototype.unshift = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    bT(this, arguments[t]);
  return this.length;
};
Dt.prototype.pop = function() {
  if (this.tail) {
    var t = this.tail.value;
    return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, t;
  }
};
Dt.prototype.shift = function() {
  if (this.head) {
    var t = this.head.value;
    return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, t;
  }
};
Dt.prototype.forEach = function(t, e) {
  e = e || this;
  for (var r = this.head, n = 0; r !== null; n++)
    t.call(e, r.value, n, this), r = r.next;
};
Dt.prototype.forEachReverse = function(t, e) {
  e = e || this;
  for (var r = this.tail, n = this.length - 1; r !== null; n--)
    t.call(e, r.value, n, this), r = r.prev;
};
Dt.prototype.get = function(t) {
  for (var e = 0, r = this.head; r !== null && e < t; e++)
    r = r.next;
  if (e === t && r !== null)
    return r.value;
};
Dt.prototype.getReverse = function(t) {
  for (var e = 0, r = this.tail; r !== null && e < t; e++)
    r = r.prev;
  if (e === t && r !== null)
    return r.value;
};
Dt.prototype.map = function(t, e) {
  e = e || this;
  for (var r = new Dt(), n = this.head; n !== null; )
    r.push(t.call(e, n.value, this)), n = n.next;
  return r;
};
Dt.prototype.mapReverse = function(t, e) {
  e = e || this;
  for (var r = new Dt(), n = this.tail; n !== null; )
    r.push(t.call(e, n.value, this)), n = n.prev;
  return r;
};
Dt.prototype.reduce = function(t, e) {
  var r, n = this.head;
  if (arguments.length > 1)
    r = e;
  else if (this.head)
    n = this.head.next, r = this.head.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = 0; n !== null; i++)
    r = t(r, n.value, i), n = n.next;
  return r;
};
Dt.prototype.reduceReverse = function(t, e) {
  var r, n = this.tail;
  if (arguments.length > 1)
    r = e;
  else if (this.tail)
    n = this.tail.prev, r = this.tail.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = this.length - 1; n !== null; i--)
    r = t(r, n.value, i), n = n.prev;
  return r;
};
Dt.prototype.toArray = function() {
  for (var t = new Array(this.length), e = 0, r = this.head; r !== null; e++)
    t[e] = r.value, r = r.next;
  return t;
};
Dt.prototype.toArrayReverse = function() {
  for (var t = new Array(this.length), e = 0, r = this.tail; r !== null; e++)
    t[e] = r.value, r = r.prev;
  return t;
};
Dt.prototype.slice = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var r = new Dt();
  if (e < t || e < 0)
    return r;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var n = 0, i = this.head; i !== null && n < t; n++)
    i = i.next;
  for (; i !== null && n < e; n++, i = i.next)
    r.push(i.value);
  return r;
};
Dt.prototype.sliceReverse = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var r = new Dt();
  if (e < t || e < 0)
    return r;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var n = this.length, i = this.tail; i !== null && n > e; n--)
    i = i.prev;
  for (; i !== null && n > t; n--, i = i.prev)
    r.push(i.value);
  return r;
};
Dt.prototype.splice = function(t, e, ...r) {
  t > this.length && (t = this.length - 1), t < 0 && (t = this.length + t);
  for (var n = 0, i = this.head; i !== null && n < t; n++)
    i = i.next;
  for (var o = [], n = 0; i && n < e; n++)
    o.push(i.value), i = this.removeNode(i);
  i === null && (i = this.tail), i !== this.head && i !== this.tail && (i = i.prev);
  for (var n = 0; n < r.length; n++)
    i = _T(this, i, r[n]);
  return o;
};
Dt.prototype.reverse = function() {
  for (var t = this.head, e = this.tail, r = t; r !== null; r = r.prev) {
    var n = r.prev;
    r.prev = r.next, r.next = n;
  }
  return this.head = e, this.tail = t, this;
};
function _T(t, e, r) {
  var n = e === t.head ? new go(r, null, e, t) : new go(r, e, e.next, t);
  return n.next === null && (t.tail = n), n.prev === null && (t.head = n), t.length++, n;
}
function wT(t, e) {
  t.tail = new go(e, t.tail, null, t), t.head || (t.head = t.tail), t.length++;
}
function bT(t, e) {
  t.head = new go(e, null, t.head, t), t.tail || (t.tail = t.head), t.length++;
}
function go(t, e, r, n) {
  if (!(this instanceof go))
    return new go(t, e, r, n);
  this.list = n, this.value = t, e ? (e.next = this, this.prev = e) : this.prev = null, r ? (r.prev = this, this.next = r) : this.next = null;
}
try {
  vT()(Dt);
} catch {
}
const ET = yT, so = Symbol("max"), Yi = Symbol("length"), ea = Symbol("lengthCalculator"), Rc = Symbol("allowStale"), co = Symbol("maxAge"), Gi = Symbol("dispose"), fy = Symbol("noDisposeOnSet"), Ir = Symbol("lruList"), oi = Symbol("cache"), V2 = Symbol("updateAgeOnGet"), t0 = () => 1;
class ST {
  constructor(e) {
    if (typeof e == "number" && (e = { max: e }), e || (e = {}), e.max && (typeof e.max != "number" || e.max < 0))
      throw new TypeError("max must be a non-negative number");
    this[so] = e.max || 1 / 0;
    const r = e.length || t0;
    if (this[ea] = typeof r != "function" ? t0 : r, this[Rc] = e.stale || !1, e.maxAge && typeof e.maxAge != "number")
      throw new TypeError("maxAge must be a number");
    this[co] = e.maxAge || 0, this[Gi] = e.dispose, this[fy] = e.noDisposeOnSet || !1, this[V2] = e.updateAgeOnGet || !1, this.reset();
  }
  // resize the cache when the max changes.
  set max(e) {
    if (typeof e != "number" || e < 0)
      throw new TypeError("max must be a non-negative number");
    this[so] = e || 1 / 0, cc(this);
  }
  get max() {
    return this[so];
  }
  set allowStale(e) {
    this[Rc] = !!e;
  }
  get allowStale() {
    return this[Rc];
  }
  set maxAge(e) {
    if (typeof e != "number")
      throw new TypeError("maxAge must be a non-negative number");
    this[co] = e, cc(this);
  }
  get maxAge() {
    return this[co];
  }
  // resize the cache when the lengthCalculator changes.
  set lengthCalculator(e) {
    typeof e != "function" && (e = t0), e !== this[ea] && (this[ea] = e, this[Yi] = 0, this[Ir].forEach((r) => {
      r.length = this[ea](r.value, r.key), this[Yi] += r.length;
    })), cc(this);
  }
  get lengthCalculator() {
    return this[ea];
  }
  get length() {
    return this[Yi];
  }
  get itemCount() {
    return this[Ir].length;
  }
  rforEach(e, r) {
    r = r || this;
    for (let n = this[Ir].tail; n !== null; ) {
      const i = n.prev;
      dy(this, e, n, r), n = i;
    }
  }
  forEach(e, r) {
    r = r || this;
    for (let n = this[Ir].head; n !== null; ) {
      const i = n.next;
      dy(this, e, n, r), n = i;
    }
  }
  keys() {
    return this[Ir].toArray().map((e) => e.key);
  }
  values() {
    return this[Ir].toArray().map((e) => e.value);
  }
  reset() {
    this[Gi] && this[Ir] && this[Ir].length && this[Ir].forEach((e) => this[Gi](e.key, e.value)), this[oi] = /* @__PURE__ */ new Map(), this[Ir] = new ET(), this[Yi] = 0;
  }
  dump() {
    return this[Ir].map((e) => th(this, e) ? !1 : {
      k: e.key,
      v: e.value,
      e: e.now + (e.maxAge || 0)
    }).toArray().filter((e) => e);
  }
  dumpLru() {
    return this[Ir];
  }
  set(e, r, n) {
    if (n = n || this[co], n && typeof n != "number")
      throw new TypeError("maxAge must be a number");
    const i = n ? Date.now() : 0, o = this[ea](r, e);
    if (this[oi].has(e)) {
      if (o > this[so])
        return ha(this, this[oi].get(e)), !1;
      const l = this[oi].get(e).value;
      return this[Gi] && (this[fy] || this[Gi](e, l.value)), l.now = i, l.maxAge = n, l.value = r, this[Yi] += o - l.length, l.length = o, this.get(e), cc(this), !0;
    }
    const c = new CT(e, r, o, i, n);
    return c.length > this[so] ? (this[Gi] && this[Gi](e, r), !1) : (this[Yi] += c.length, this[Ir].unshift(c), this[oi].set(e, this[Ir].head), cc(this), !0);
  }
  has(e) {
    if (!this[oi].has(e))
      return !1;
    const r = this[oi].get(e).value;
    return !th(this, r);
  }
  get(e) {
    return r0(this, e, !0);
  }
  peek(e) {
    return r0(this, e, !1);
  }
  pop() {
    const e = this[Ir].tail;
    return e ? (ha(this, e), e.value) : null;
  }
  del(e) {
    ha(this, this[oi].get(e));
  }
  load(e) {
    this.reset();
    const r = Date.now();
    for (let n = e.length - 1; n >= 0; n--) {
      const i = e[n], o = i.e || 0;
      if (o === 0)
        this.set(i.k, i.v);
      else {
        const c = o - r;
        c > 0 && this.set(i.k, i.v, c);
      }
    }
  }
  prune() {
    this[oi].forEach((e, r) => r0(this, r, !1));
  }
}
const r0 = (t, e, r) => {
  const n = t[oi].get(e);
  if (n) {
    const i = n.value;
    if (th(t, i)) {
      if (ha(t, n), !t[Rc])
        return;
    } else
      r && (t[V2] && (n.value.now = Date.now()), t[Ir].unshiftNode(n));
    return i.value;
  }
}, th = (t, e) => {
  if (!e || !e.maxAge && !t[co])
    return !1;
  const r = Date.now() - e.now;
  return e.maxAge ? r > e.maxAge : t[co] && r > t[co];
}, cc = (t) => {
  if (t[Yi] > t[so])
    for (let e = t[Ir].tail; t[Yi] > t[so] && e !== null; ) {
      const r = e.prev;
      ha(t, e), e = r;
    }
}, ha = (t, e) => {
  if (e) {
    const r = e.value;
    t[Gi] && t[Gi](r.key, r.value), t[Yi] -= r.length, t[oi].delete(r.key), t[Ir].removeNode(e);
  }
};
class CT {
  constructor(e, r, n, i, o) {
    this.key = e, this.value = r, this.length = n, this.now = i, this.maxAge = o || 0;
  }
}
const dy = (t, e, r, n) => {
  let i = r.value;
  th(t, i) && (ha(t, r), t[Rc] || (i = void 0)), i && e.call(n, i.value, i.key, t);
};
var IT = ST, n0, py;
function di() {
  if (py)
    return n0;
  py = 1;
  class t {
    constructor(h, m) {
      if (m = n(m), h instanceof t)
        return h.loose === !!m.loose && h.includePrerelease === !!m.includePrerelease ? h : new t(h.raw, m);
      if (h instanceof i)
        return this.raw = h.value, this.set = [[h]], this.format(), this;
      if (this.options = m, this.loose = !!m.loose, this.includePrerelease = !!m.includePrerelease, this.raw = h.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map((x) => this.parseRange(x.trim())).filter((x) => x.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const x = this.set[0];
        if (this.set = this.set.filter((M) => !R(M[0])), this.set.length === 0)
          this.set = [x];
        else if (this.set.length > 1) {
          for (const M of this.set)
            if (M.length === 1 && J(M[0])) {
              this.set = [M];
              break;
            }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((h) => h.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(h) {
      const x = ((this.options.includePrerelease && y) | (this.options.loose && C)) + ":" + h, M = r.get(x);
      if (M)
        return M;
      const A = this.options.loose, $ = A ? u[l.HYPHENRANGELOOSE] : u[l.HYPHENRANGE];
      h = h.replace($, he(this.options.includePrerelease)), o("hyphen replace", h), h = h.replace(u[l.COMPARATORTRIM], f), o("comparator trim", h), h = h.replace(u[l.TILDETRIM], p), o("tilde trim", h), h = h.replace(u[l.CARETTRIM], g), o("caret trim", h);
      let K = h.split(" ").map((me) => H(me, this.options)).join(" ").split(/\s+/).map((me) => le(me, this.options));
      A && (K = K.filter((me) => (o("loose invalid filter", me, this.options), !!me.match(u[l.COMPARATORLOOSE])))), o("range list", K);
      const D = /* @__PURE__ */ new Map(), w = K.map((me) => new i(me, this.options));
      for (const me of w) {
        if (R(me))
          return [me];
        D.set(me.value, me);
      }
      D.size > 1 && D.has("") && D.delete("");
      const U = [...D.values()];
      return r.set(x, U), U;
    }
    intersects(h, m) {
      if (!(h instanceof t))
        throw new TypeError("a Range is required");
      return this.set.some((x) => G(x, m) && h.set.some((M) => G(M, m) && x.every((A) => M.every(($) => A.intersects($, m)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(h) {
      if (!h)
        return !1;
      if (typeof h == "string")
        try {
          h = new c(h, this.options);
        } catch {
          return !1;
        }
      for (let m = 0; m < this.set.length; m++)
        if (ye(this.set[m], h, this.options))
          return !0;
      return !1;
    }
  }
  n0 = t;
  const e = IT, r = new e({ max: 1e3 }), n = Yp, i = Yh(), o = Qh, c = Yr, {
    safeRe: u,
    t: l,
    comparatorTrimReplace: f,
    tildeTrimReplace: p,
    caretTrimReplace: g
  } = uu, { FLAG_INCLUDE_PRERELEASE: y, FLAG_LOOSE: C } = Jh, R = (k) => k.value === "<0.0.0-0", J = (k) => k.value === "", G = (k, h) => {
    let m = !0;
    const x = k.slice();
    let M = x.pop();
    for (; m && x.length; )
      m = x.every((A) => M.intersects(A, h)), M = x.pop();
    return m;
  }, H = (k, h) => (o("comp", k, h), k = L(k, h), o("caret", k), k = q(k, h), o("tildes", k), k = v(k, h), o("xrange", k), k = ie(k, h), o("stars", k), k), T = (k) => !k || k.toLowerCase() === "x" || k === "*", q = (k, h) => k.trim().split(/\s+/).map((m) => B(m, h)).join(" "), B = (k, h) => {
    const m = h.loose ? u[l.TILDELOOSE] : u[l.TILDE];
    return k.replace(m, (x, M, A, $, K) => {
      o("tilde", k, x, M, A, $, K);
      let D;
      return T(M) ? D = "" : T(A) ? D = `>=${M}.0.0 <${+M + 1}.0.0-0` : T($) ? D = `>=${M}.${A}.0 <${M}.${+A + 1}.0-0` : K ? (o("replaceTilde pr", K), D = `>=${M}.${A}.${$}-${K} <${M}.${+A + 1}.0-0`) : D = `>=${M}.${A}.${$} <${M}.${+A + 1}.0-0`, o("tilde return", D), D;
    });
  }, L = (k, h) => k.trim().split(/\s+/).map((m) => P(m, h)).join(" "), P = (k, h) => {
    o("caret", k, h);
    const m = h.loose ? u[l.CARETLOOSE] : u[l.CARET], x = h.includePrerelease ? "-0" : "";
    return k.replace(m, (M, A, $, K, D) => {
      o("caret", k, M, A, $, K, D);
      let w;
      return T(A) ? w = "" : T($) ? w = `>=${A}.0.0${x} <${+A + 1}.0.0-0` : T(K) ? A === "0" ? w = `>=${A}.${$}.0${x} <${A}.${+$ + 1}.0-0` : w = `>=${A}.${$}.0${x} <${+A + 1}.0.0-0` : D ? (o("replaceCaret pr", D), A === "0" ? $ === "0" ? w = `>=${A}.${$}.${K}-${D} <${A}.${$}.${+K + 1}-0` : w = `>=${A}.${$}.${K}-${D} <${A}.${+$ + 1}.0-0` : w = `>=${A}.${$}.${K}-${D} <${+A + 1}.0.0-0`) : (o("no pr"), A === "0" ? $ === "0" ? w = `>=${A}.${$}.${K}${x} <${A}.${$}.${+K + 1}-0` : w = `>=${A}.${$}.${K}${x} <${A}.${+$ + 1}.0-0` : w = `>=${A}.${$}.${K} <${+A + 1}.0.0-0`), o("caret return", w), w;
    });
  }, v = (k, h) => (o("replaceXRanges", k, h), k.split(/\s+/).map((m) => N(m, h)).join(" ")), N = (k, h) => {
    k = k.trim();
    const m = h.loose ? u[l.XRANGELOOSE] : u[l.XRANGE];
    return k.replace(m, (x, M, A, $, K, D) => {
      o("xRange", k, x, M, A, $, K, D);
      const w = T(A), U = w || T($), me = U || T(K), pe = me;
      return M === "=" && pe && (M = ""), D = h.includePrerelease ? "-0" : "", w ? M === ">" || M === "<" ? x = "<0.0.0-0" : x = "*" : M && pe ? (U && ($ = 0), K = 0, M === ">" ? (M = ">=", U ? (A = +A + 1, $ = 0, K = 0) : ($ = +$ + 1, K = 0)) : M === "<=" && (M = "<", U ? A = +A + 1 : $ = +$ + 1), M === "<" && (D = "-0"), x = `${M + A}.${$}.${K}${D}`) : U ? x = `>=${A}.0.0${D} <${+A + 1}.0.0-0` : me && (x = `>=${A}.${$}.0${D} <${A}.${+$ + 1}.0-0`), o("xRange return", x), x;
    });
  }, ie = (k, h) => (o("replaceStars", k, h), k.trim().replace(u[l.STAR], "")), le = (k, h) => (o("replaceGTE0", k, h), k.trim().replace(u[h.includePrerelease ? l.GTE0PRE : l.GTE0], "")), he = (k) => (h, m, x, M, A, $, K, D, w, U, me, pe, ee) => (T(x) ? m = "" : T(M) ? m = `>=${x}.0.0${k ? "-0" : ""}` : T(A) ? m = `>=${x}.${M}.0${k ? "-0" : ""}` : $ ? m = `>=${m}` : m = `>=${m}${k ? "-0" : ""}`, T(w) ? D = "" : T(U) ? D = `<${+w + 1}.0.0-0` : T(me) ? D = `<${w}.${+U + 1}.0-0` : pe ? D = `<=${w}.${U}.${me}-${pe}` : k ? D = `<${w}.${U}.${+me + 1}-0` : D = `<=${D}`, `${m} ${D}`.trim()), ye = (k, h, m) => {
    for (let x = 0; x < k.length; x++)
      if (!k[x].test(h))
        return !1;
    if (h.prerelease.length && !m.includePrerelease) {
      for (let x = 0; x < k.length; x++)
        if (o(k[x].semver), k[x].semver !== i.ANY && k[x].semver.prerelease.length > 0) {
          const M = k[x].semver;
          if (M.major === h.major && M.minor === h.minor && M.patch === h.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return n0;
}
var i0, gy;
function Yh() {
  if (gy)
    return i0;
  gy = 1;
  const t = Symbol("SemVer ANY");
  class e {
    static get ANY() {
      return t;
    }
    constructor(p, g) {
      if (g = r(g), p instanceof e) {
        if (p.loose === !!g.loose)
          return p;
        p = p.value;
      }
      p = p.trim().split(/\s+/).join(" "), c("comparator", p, g), this.options = g, this.loose = !!g.loose, this.parse(p), this.semver === t ? this.value = "" : this.value = this.operator + this.semver.version, c("comp", this);
    }
    parse(p) {
      const g = this.options.loose ? n[i.COMPARATORLOOSE] : n[i.COMPARATOR], y = p.match(g);
      if (!y)
        throw new TypeError(`Invalid comparator: ${p}`);
      this.operator = y[1] !== void 0 ? y[1] : "", this.operator === "=" && (this.operator = ""), y[2] ? this.semver = new u(y[2], this.options.loose) : this.semver = t;
    }
    toString() {
      return this.value;
    }
    test(p) {
      if (c("Comparator.test", p, this.options.loose), this.semver === t || p === t)
        return !0;
      if (typeof p == "string")
        try {
          p = new u(p, this.options);
        } catch {
          return !1;
        }
      return o(p, this.operator, this.semver, this.options);
    }
    intersects(p, g) {
      if (!(p instanceof e))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new l(p.value, g).test(this.value) : p.operator === "" ? p.value === "" ? !0 : new l(this.value, g).test(p.semver) : (g = r(g), g.includePrerelease && (this.value === "<0.0.0-0" || p.value === "<0.0.0-0") || !g.includePrerelease && (this.value.startsWith("<0.0.0") || p.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && p.operator.startsWith(">") || this.operator.startsWith("<") && p.operator.startsWith("<") || this.semver.version === p.semver.version && this.operator.includes("=") && p.operator.includes("=") || o(this.semver, "<", p.semver, g) && this.operator.startsWith(">") && p.operator.startsWith("<") || o(this.semver, ">", p.semver, g) && this.operator.startsWith("<") && p.operator.startsWith(">")));
    }
  }
  i0 = e;
  const r = Yp, { safeRe: n, t: i } = uu, o = z2, c = Qh, u = Yr, l = di();
  return i0;
}
const xT = di(), RT = (t, e, r) => {
  try {
    e = new xT(e, r);
  } catch {
    return !1;
  }
  return e.test(t);
};
var Xh = RT;
const AT = di(), MT = (t, e) => new AT(t, e).set.map((r) => r.map((n) => n.value).join(" ").trim().split(" "));
var DT = MT;
const OT = Yr, PT = di(), TT = (t, e, r) => {
  let n = null, i = null, o = null;
  try {
    o = new PT(e, r);
  } catch {
    return null;
  }
  return t.forEach((c) => {
    o.test(c) && (!n || i.compare(c) === -1) && (n = c, i = new OT(n, r));
  }), n;
};
var NT = TT;
const kT = Yr, LT = di(), $T = (t, e, r) => {
  let n = null, i = null, o = null;
  try {
    o = new LT(e, r);
  } catch {
    return null;
  }
  return t.forEach((c) => {
    o.test(c) && (!n || i.compare(c) === 1) && (n = c, i = new kT(n, r));
  }), n;
};
var FT = $T;
const s0 = Yr, BT = di(), my = Zh, UT = (t, e) => {
  t = new BT(t, e);
  let r = new s0("0.0.0");
  if (t.test(r) || (r = new s0("0.0.0-0"), t.test(r)))
    return r;
  r = null;
  for (let n = 0; n < t.set.length; ++n) {
    const i = t.set[n];
    let o = null;
    i.forEach((c) => {
      const u = new s0(c.semver.version);
      switch (c.operator) {
        case ">":
          u.prerelease.length === 0 ? u.patch++ : u.prerelease.push(0), u.raw = u.format();
        case "":
        case ">=":
          (!o || my(u, o)) && (o = u);
          break;
        case "<":
        case "<=":
          break;
        default:
          throw new Error(`Unexpected operation: ${c.operator}`);
      }
    }), o && (!r || my(r, o)) && (r = o);
  }
  return r && t.test(r) ? r : null;
};
var jT = UT;
const HT = di(), qT = (t, e) => {
  try {
    return new HT(t, e).range || "*";
  } catch {
    return null;
  }
};
var zT = qT;
const VT = Yr, W2 = Yh(), { ANY: WT } = W2, KT = di(), GT = Xh, vy = Zh, yy = eg, JT = rg, QT = tg, ZT = (t, e, r, n) => {
  t = new VT(t, n), e = new KT(e, n);
  let i, o, c, u, l;
  switch (r) {
    case ">":
      i = vy, o = JT, c = yy, u = ">", l = ">=";
      break;
    case "<":
      i = yy, o = QT, c = vy, u = "<", l = "<=";
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }
  if (GT(t, e, n))
    return !1;
  for (let f = 0; f < e.set.length; ++f) {
    const p = e.set[f];
    let g = null, y = null;
    if (p.forEach((C) => {
      C.semver === WT && (C = new W2(">=0.0.0")), g = g || C, y = y || C, i(C.semver, g.semver, n) ? g = C : c(C.semver, y.semver, n) && (y = C);
    }), g.operator === u || g.operator === l || (!y.operator || y.operator === u) && o(t, y.semver))
      return !1;
    if (y.operator === l && c(t, y.semver))
      return !1;
  }
  return !0;
};
var ng = ZT;
const YT = ng, XT = (t, e, r) => YT(t, e, ">", r);
var e7 = XT;
const t7 = ng, r7 = (t, e, r) => t7(t, e, "<", r);
var n7 = r7;
const _y = di(), i7 = (t, e, r) => (t = new _y(t, r), e = new _y(e, r), t.intersects(e, r));
var s7 = i7;
const o7 = Xh, a7 = fi;
var c7 = (t, e, r) => {
  const n = [];
  let i = null, o = null;
  const c = t.sort((p, g) => a7(p, g, r));
  for (const p of c)
    o7(p, e, r) ? (o = p, i || (i = p)) : (o && n.push([i, o]), o = null, i = null);
  i && n.push([i, null]);
  const u = [];
  for (const [p, g] of n)
    p === g ? u.push(p) : !g && p === c[0] ? u.push("*") : g ? p === c[0] ? u.push(`<=${g}`) : u.push(`${p} - ${g}`) : u.push(`>=${p}`);
  const l = u.join(" || "), f = typeof e.raw == "string" ? e.raw : String(e);
  return l.length < f.length ? l : e;
};
const wy = di(), ig = Yh(), { ANY: o0 } = ig, uc = Xh, sg = fi, u7 = (t, e, r = {}) => {
  if (t === e)
    return !0;
  t = new wy(t, r), e = new wy(e, r);
  let n = !1;
  e:
    for (const i of t.set) {
      for (const o of e.set) {
        const c = h7(i, o, r);
        if (n = n || c !== null, c)
          continue e;
      }
      if (n)
        return !1;
    }
  return !0;
}, l7 = [new ig(">=0.0.0-0")], by = [new ig(">=0.0.0")], h7 = (t, e, r) => {
  if (t === e)
    return !0;
  if (t.length === 1 && t[0].semver === o0) {
    if (e.length === 1 && e[0].semver === o0)
      return !0;
    r.includePrerelease ? t = l7 : t = by;
  }
  if (e.length === 1 && e[0].semver === o0) {
    if (r.includePrerelease)
      return !0;
    e = by;
  }
  const n = /* @__PURE__ */ new Set();
  let i, o;
  for (const C of t)
    C.operator === ">" || C.operator === ">=" ? i = Ey(i, C, r) : C.operator === "<" || C.operator === "<=" ? o = Sy(o, C, r) : n.add(C.semver);
  if (n.size > 1)
    return null;
  let c;
  if (i && o) {
    if (c = sg(i.semver, o.semver, r), c > 0)
      return null;
    if (c === 0 && (i.operator !== ">=" || o.operator !== "<="))
      return null;
  }
  for (const C of n) {
    if (i && !uc(C, String(i), r) || o && !uc(C, String(o), r))
      return null;
    for (const R of e)
      if (!uc(C, String(R), r))
        return !1;
    return !0;
  }
  let u, l, f, p, g = o && !r.includePrerelease && o.semver.prerelease.length ? o.semver : !1, y = i && !r.includePrerelease && i.semver.prerelease.length ? i.semver : !1;
  g && g.prerelease.length === 1 && o.operator === "<" && g.prerelease[0] === 0 && (g = !1);
  for (const C of e) {
    if (p = p || C.operator === ">" || C.operator === ">=", f = f || C.operator === "<" || C.operator === "<=", i) {
      if (y && C.semver.prerelease && C.semver.prerelease.length && C.semver.major === y.major && C.semver.minor === y.minor && C.semver.patch === y.patch && (y = !1), C.operator === ">" || C.operator === ">=") {
        if (u = Ey(i, C, r), u === C && u !== i)
          return !1;
      } else if (i.operator === ">=" && !uc(i.semver, String(C), r))
        return !1;
    }
    if (o) {
      if (g && C.semver.prerelease && C.semver.prerelease.length && C.semver.major === g.major && C.semver.minor === g.minor && C.semver.patch === g.patch && (g = !1), C.operator === "<" || C.operator === "<=") {
        if (l = Sy(o, C, r), l === C && l !== o)
          return !1;
      } else if (o.operator === "<=" && !uc(o.semver, String(C), r))
        return !1;
    }
    if (!C.operator && (o || i) && c !== 0)
      return !1;
  }
  return !(i && f && !o && c !== 0 || o && p && !i && c !== 0 || y || g);
}, Ey = (t, e, r) => {
  if (!t)
    return e;
  const n = sg(t.semver, e.semver, r);
  return n > 0 ? t : n < 0 || e.operator === ">" && t.operator === ">=" ? e : t;
}, Sy = (t, e, r) => {
  if (!t)
    return e;
  const n = sg(t.semver, e.semver, r);
  return n < 0 ? t : n > 0 || e.operator === "<" && t.operator === "<=" ? e : t;
};
var f7 = u7;
const a0 = uu, Cy = Jh, d7 = Yr, Iy = j2, p7 = ka, g7 = pP, m7 = vP, v7 = _P, y7 = bP, _7 = CP, w7 = RP, b7 = DP, E7 = TP, S7 = fi, C7 = $P, I7 = UP, x7 = Xp, R7 = zP, A7 = KP, M7 = Zh, D7 = eg, O7 = H2, P7 = q2, T7 = tg, N7 = rg, k7 = z2, L7 = mT, $7 = Yh(), F7 = di(), B7 = Xh, U7 = DT, j7 = NT, H7 = FT, q7 = jT, z7 = zT, V7 = ng, W7 = e7, K7 = n7, G7 = s7, J7 = c7, Q7 = f7;
var Z7 = {
  parse: p7,
  valid: g7,
  clean: m7,
  inc: v7,
  diff: y7,
  major: _7,
  minor: w7,
  patch: b7,
  prerelease: E7,
  compare: S7,
  rcompare: C7,
  compareLoose: I7,
  compareBuild: x7,
  sort: R7,
  rsort: A7,
  gt: M7,
  lt: D7,
  eq: O7,
  neq: P7,
  gte: T7,
  lte: N7,
  cmp: k7,
  coerce: L7,
  Comparator: $7,
  Range: F7,
  satisfies: B7,
  toComparators: U7,
  maxSatisfying: j7,
  minSatisfying: H7,
  minVersion: q7,
  validRange: z7,
  outside: V7,
  gtr: W7,
  ltr: K7,
  intersects: G7,
  simplifyRange: J7,
  subset: Q7,
  SemVer: d7,
  re: a0.re,
  src: a0.src,
  tokens: a0.t,
  SEMVER_SPEC_VERSION: Cy.SEMVER_SPEC_VERSION,
  RELEASE_TYPES: Cy.RELEASE_TYPES,
  compareIdentifiers: Iy.compareIdentifiers,
  rcompareIdentifiers: Iy.rcompareIdentifiers
};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.satisfiesVersionRange = t.gtRange = t.gtVersion = t.assertIsSemVerRange = t.assertIsSemVerVersion = t.isValidSemVerRange = t.isValidSemVerVersion = t.VersionRangeStruct = t.VersionStruct = void 0;
  const e = Z7, r = Co, n = Pr;
  t.VersionStruct = (0, r.refine)((0, r.string)(), "Version", (g) => (0, e.valid)(g) === null ? `Expected SemVer version, got "${g}"` : !0), t.VersionRangeStruct = (0, r.refine)((0, r.string)(), "Version range", (g) => (0, e.validRange)(g) === null ? `Expected SemVer range, got "${g}"` : !0);
  function i(g) {
    return (0, r.is)(g, t.VersionStruct);
  }
  t.isValidSemVerVersion = i;
  function o(g) {
    return (0, r.is)(g, t.VersionRangeStruct);
  }
  t.isValidSemVerRange = o;
  function c(g) {
    (0, n.assertStruct)(g, t.VersionStruct);
  }
  t.assertIsSemVerVersion = c;
  function u(g) {
    (0, n.assertStruct)(g, t.VersionRangeStruct);
  }
  t.assertIsSemVerRange = u;
  function l(g, y) {
    return (0, e.gt)(g, y);
  }
  t.gtVersion = l;
  function f(g, y) {
    return (0, e.gtr)(g, y);
  }
  t.gtRange = f;
  function p(g, y) {
    return (0, e.satisfies)(g, y, {
      includePrerelease: !0
    });
  }
  t.satisfiesVersionRange = p;
})(F2);
(function(t) {
  var e = Te && Te.__createBinding || (Object.create ? function(n, i, o, c) {
    c === void 0 && (c = o);
    var u = Object.getOwnPropertyDescriptor(i, o);
    (!u || ("get" in u ? !i.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(n, c, u);
  } : function(n, i, o, c) {
    c === void 0 && (c = o), n[c] = i[o];
  }), r = Te && Te.__exportStar || function(n, i) {
    for (var o in n)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, n, o);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(Pr, t), r(au, t), r(At, t), r(Kh, t), r(Di, t), r(Ca, t), r(O2, t), r(cu, t), r(P2, t), r(T2, t), r(Ia, t), r(N2, t), r(Oi, t), r(k2, t), r(L2, t), r($2, t), r(F2, t);
})(f2);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.createModuleLogger = t.projectLogger = void 0;
  const e = f2;
  Object.defineProperty(t, "createModuleLogger", { enumerable: !0, get: function() {
    return e.createModuleLogger;
  } }), t.projectLogger = (0, e.createProjectLogger)("eth-block-tracker");
})(h2);
var K2 = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Vh, "__esModule", { value: !0 });
Vh.PollingBlockTracker = void 0;
const Y7 = K2(Hp), X7 = K2(vD), eN = iu, xy = h2, Ry = (0, xy.createModuleLogger)(xy.projectLogger, "polling-block-tracker"), tN = (0, Y7.default)(), rN = 1e3;
class nN extends eN.BaseBlockTracker {
  constructor(e = {}) {
    var r;
    if (!e.provider)
      throw new Error("PollingBlockTracker - no provider specified.");
    super(Object.assign(Object.assign({}, e), { blockResetDuration: (r = e.blockResetDuration) !== null && r !== void 0 ? r : e.pollingInterval })), this._provider = e.provider, this._pollingInterval = e.pollingInterval || 20 * rN, this._retryTimeout = e.retryTimeout || this._pollingInterval / 10, this._keepEventLoopActive = e.keepEventLoopActive === void 0 ? !0 : e.keepEventLoopActive, this._setSkipCacheFlag = e.setSkipCacheFlag || !1;
  }
  // trigger block polling
  async checkForLatestBlock() {
    return await this._updateLatestBlock(), await this.getLatestBlock();
  }
  async _start() {
    this._synchronize();
  }
  async _end() {
  }
  async _synchronize() {
    for (var e; this._isRunning; )
      try {
        await this._updateLatestBlock();
        const r = Ay(this._pollingInterval, !this._keepEventLoopActive);
        this.emit("_waitingForNextIteration"), await r;
      } catch (r) {
        const n = new Error(`PollingBlockTracker - encountered an error while attempting to update latest block:
${(e = r.stack) !== null && e !== void 0 ? e : r}`);
        try {
          this.emit("error", n);
        } catch {
          console.error(n);
        }
        const i = Ay(this._retryTimeout, !this._keepEventLoopActive);
        this.emit("_waitingForNextIteration"), await i;
      }
  }
  async _updateLatestBlock() {
    const e = await this._fetchLatestBlock();
    this._newPotentialLatest(e);
  }
  async _fetchLatestBlock() {
    const e = {
      jsonrpc: "2.0",
      id: tN(),
      method: "eth_blockNumber",
      params: []
    };
    this._setSkipCacheFlag && (e.skipCache = !0), Ry("Making request", e);
    const r = await (0, X7.default)((n) => this._provider.sendAsync(e, n))();
    if (Ry("Got response", r), r.error)
      throw new Error(`PollingBlockTracker - encountered error fetching block:
${r.error.message}`);
    return r.result;
  }
}
Vh.PollingBlockTracker = nN;
function Ay(t, e) {
  return new Promise((r) => {
    const n = setTimeout(r, t);
    n.unref && e && n.unref();
  });
}
var ef = {}, iN = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(ef, "__esModule", { value: !0 });
ef.SubscribeBlockTracker = void 0;
const sN = iN(Hp), oN = iu, aN = (0, sN.default)();
class cN extends oN.BaseBlockTracker {
  constructor(e = {}) {
    if (!e.provider)
      throw new Error("SubscribeBlockTracker - no provider specified.");
    super(e), this._provider = e.provider, this._subscriptionId = null;
  }
  async checkForLatestBlock() {
    return await this.getLatestBlock();
  }
  async _start() {
    if (this._subscriptionId === void 0 || this._subscriptionId === null)
      try {
        const e = await this._call("eth_blockNumber");
        this._subscriptionId = await this._call("eth_subscribe", "newHeads"), this._provider.on("data", this._handleSubData.bind(this)), this._newPotentialLatest(e);
      } catch (e) {
        this.emit("error", e);
      }
  }
  async _end() {
    if (this._subscriptionId !== null && this._subscriptionId !== void 0)
      try {
        await this._call("eth_unsubscribe", this._subscriptionId), this._subscriptionId = null;
      } catch (e) {
        this.emit("error", e);
      }
  }
  _call(e, ...r) {
    return new Promise((n, i) => {
      this._provider.sendAsync({
        id: aN(),
        method: e,
        params: r,
        jsonrpc: "2.0"
      }, (o, c) => {
        o ? i(o) : n(c.result);
      });
    });
  }
  _handleSubData(e, r) {
    var n;
    r.method === "eth_subscription" && ((n = r.params) === null || n === void 0 ? void 0 : n.subscription) === this._subscriptionId && this._newPotentialLatest(r.params.result.number);
  }
}
ef.SubscribeBlockTracker = cN;
(function(t) {
  var e = Te && Te.__createBinding || (Object.create ? function(n, i, o, c) {
    c === void 0 && (c = o), Object.defineProperty(n, c, { enumerable: !0, get: function() {
      return i[o];
    } });
  } : function(n, i, o, c) {
    c === void 0 && (c = o), n[c] = i[o];
  }), r = Te && Te.__exportStar || function(n, i) {
    for (var o in n)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, n, o);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(Vh, t), r(ef, t);
})(l2);
var og = {}, tf = {}, lu = {};
Object.defineProperty(lu, "__esModule", { value: !0 });
lu.getUniqueId = void 0;
const G2 = 4294967295;
let c0 = Math.floor(Math.random() * G2);
function uN() {
  return c0 = (c0 + 1) % G2, c0;
}
lu.getUniqueId = uN;
Object.defineProperty(tf, "__esModule", { value: !0 });
tf.createIdRemapMiddleware = void 0;
const lN = lu;
function hN() {
  return (t, e, r, n) => {
    const i = t.id, o = lN.getUniqueId();
    t.id = o, e.id = o, r((c) => {
      t.id = i, e.id = i, c();
    });
  };
}
tf.createIdRemapMiddleware = hN;
var rf = {};
Object.defineProperty(rf, "__esModule", { value: !0 });
rf.createAsyncMiddleware = void 0;
function fN(t) {
  return async (e, r, n, i) => {
    let o;
    const c = new Promise((p) => {
      o = p;
    });
    let u = null, l = !1;
    const f = async () => {
      l = !0, n((p) => {
        u = p, o();
      }), await c;
    };
    try {
      await t(e, r, f), l ? (await c, u(null)) : i(null);
    } catch (p) {
      u ? u(p) : i(p);
    }
  };
}
rf.createAsyncMiddleware = fN;
var nf = {};
Object.defineProperty(nf, "__esModule", { value: !0 });
nf.createScaffoldMiddleware = void 0;
function dN(t) {
  return (e, r, n, i) => {
    const o = t[e.method];
    return o === void 0 ? n() : typeof o == "function" ? o(e, r, n, i) : (r.result = o, i());
  };
}
nf.createScaffoldMiddleware = dN;
var hu = {}, ag = {};
Object.defineProperty(ag, "__esModule", { value: !0 });
const pN = Tr;
function My(t, e, r) {
  try {
    Reflect.apply(t, e, r);
  } catch (n) {
    setTimeout(() => {
      throw n;
    });
  }
}
function gN(t) {
  const e = t.length, r = new Array(e);
  for (let n = 0; n < e; n += 1)
    r[n] = t[n];
  return r;
}
let mN = class extends pN.EventEmitter {
  emit(e, ...r) {
    let n = e === "error";
    const i = this._events;
    if (i !== void 0)
      n = n && i.error === void 0;
    else if (!n)
      return !1;
    if (n) {
      let c;
      if (r.length > 0 && ([c] = r), c instanceof Error)
        throw c;
      const u = new Error(`Unhandled error.${c ? ` (${c.message})` : ""}`);
      throw u.context = c, u;
    }
    const o = i[e];
    if (o === void 0)
      return !1;
    if (typeof o == "function")
      My(o, this, r);
    else {
      const c = o.length, u = gN(o);
      for (let l = 0; l < c; l += 1)
        My(u[l], this, r);
    }
    return !0;
  }
};
ag.default = mN;
var J2 = {}, Cs = {}, vN = Nc;
Nc.default = Nc;
Nc.stable = Y2;
Nc.stableStringify = Y2;
var rh = "[...]", Q2 = "[Circular]", mo = [], uo = [];
function Z2() {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  };
}
function Nc(t, e, r, n) {
  typeof n > "u" && (n = Z2()), Q0(t, "", 0, [], void 0, 0, n);
  var i;
  try {
    uo.length === 0 ? i = JSON.stringify(t, e, r) : i = JSON.stringify(t, X2(e), r);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; mo.length !== 0; ) {
      var o = mo.pop();
      o.length === 4 ? Object.defineProperty(o[0], o[1], o[3]) : o[0][o[1]] = o[2];
    }
  }
  return i;
}
function fa(t, e, r, n) {
  var i = Object.getOwnPropertyDescriptor(n, r);
  i.get !== void 0 ? i.configurable ? (Object.defineProperty(n, r, { value: t }), mo.push([n, r, e, i])) : uo.push([e, r, t]) : (n[r] = t, mo.push([n, r, e]));
}
function Q0(t, e, r, n, i, o, c) {
  o += 1;
  var u;
  if (typeof t == "object" && t !== null) {
    for (u = 0; u < n.length; u++)
      if (n[u] === t) {
        fa(Q2, t, e, i);
        return;
      }
    if (typeof c.depthLimit < "u" && o > c.depthLimit) {
      fa(rh, t, e, i);
      return;
    }
    if (typeof c.edgesLimit < "u" && r + 1 > c.edgesLimit) {
      fa(rh, t, e, i);
      return;
    }
    if (n.push(t), Array.isArray(t))
      for (u = 0; u < t.length; u++)
        Q0(t[u], u, u, n, t, o, c);
    else {
      var l = Object.keys(t);
      for (u = 0; u < l.length; u++) {
        var f = l[u];
        Q0(t[f], f, u, n, t, o, c);
      }
    }
    n.pop();
  }
}
function yN(t, e) {
  return t < e ? -1 : t > e ? 1 : 0;
}
function Y2(t, e, r, n) {
  typeof n > "u" && (n = Z2());
  var i = Z0(t, "", 0, [], void 0, 0, n) || t, o;
  try {
    uo.length === 0 ? o = JSON.stringify(i, e, r) : o = JSON.stringify(i, X2(e), r);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; mo.length !== 0; ) {
      var c = mo.pop();
      c.length === 4 ? Object.defineProperty(c[0], c[1], c[3]) : c[0][c[1]] = c[2];
    }
  }
  return o;
}
function Z0(t, e, r, n, i, o, c) {
  o += 1;
  var u;
  if (typeof t == "object" && t !== null) {
    for (u = 0; u < n.length; u++)
      if (n[u] === t) {
        fa(Q2, t, e, i);
        return;
      }
    try {
      if (typeof t.toJSON == "function")
        return;
    } catch {
      return;
    }
    if (typeof c.depthLimit < "u" && o > c.depthLimit) {
      fa(rh, t, e, i);
      return;
    }
    if (typeof c.edgesLimit < "u" && r + 1 > c.edgesLimit) {
      fa(rh, t, e, i);
      return;
    }
    if (n.push(t), Array.isArray(t))
      for (u = 0; u < t.length; u++)
        Z0(t[u], u, u, n, t, o, c);
    else {
      var l = {}, f = Object.keys(t).sort(yN);
      for (u = 0; u < f.length; u++) {
        var p = f[u];
        Z0(t[p], p, u, n, t, o, c), l[p] = t[p];
      }
      if (typeof i < "u")
        mo.push([i, e, t]), i[e] = l;
      else
        return l;
    }
    n.pop();
  }
}
function X2(t) {
  return t = typeof t < "u" ? t : function(e, r) {
    return r;
  }, function(e, r) {
    if (uo.length > 0)
      for (var n = 0; n < uo.length; n++) {
        var i = uo[n];
        if (i[1] === e && i[0] === r) {
          r = i[2], uo.splice(n, 1);
          break;
        }
      }
    return t.call(this, e, r);
  };
}
Object.defineProperty(Cs, "__esModule", { value: !0 });
Cs.EthereumProviderError = Cs.EthereumRpcError = void 0;
const _N = vN;
class eE extends Error {
  constructor(e, r, n) {
    if (!Number.isInteger(e))
      throw new Error('"code" must be an integer.');
    if (!r || typeof r != "string")
      throw new Error('"message" must be a nonempty string.');
    super(r), this.code = e, n !== void 0 && (this.data = n);
  }
  /**
   * Returns a plain object with all public class properties.
   */
  serialize() {
    const e = {
      code: this.code,
      message: this.message
    };
    return this.data !== void 0 && (e.data = this.data), this.stack && (e.stack = this.stack), e;
  }
  /**
   * Return a string representation of the serialized error, omitting
   * any circular references.
   */
  toString() {
    return _N.default(this.serialize(), EN, 2);
  }
}
Cs.EthereumRpcError = eE;
class wN extends eE {
  /**
   * Create an Ethereum Provider JSON-RPC error.
   * `code` must be an integer in the 1000 <= 4999 range.
   */
  constructor(e, r, n) {
    if (!bN(e))
      throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    super(e, r, n);
  }
}
Cs.EthereumProviderError = wN;
function bN(t) {
  return Number.isInteger(t) && t >= 1e3 && t <= 4999;
}
function EN(t, e) {
  if (e !== "[Circular]")
    return e;
}
var cg = {}, Is = {};
Object.defineProperty(Is, "__esModule", { value: !0 });
Is.errorValues = Is.errorCodes = void 0;
Is.errorCodes = {
  rpc: {
    invalidInput: -32e3,
    resourceNotFound: -32001,
    resourceUnavailable: -32002,
    transactionRejected: -32003,
    methodNotSupported: -32004,
    limitExceeded: -32005,
    parse: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603
  },
  provider: {
    userRejectedRequest: 4001,
    unauthorized: 4100,
    unsupportedMethod: 4200,
    disconnected: 4900,
    chainDisconnected: 4901
  }
};
Is.errorValues = {
  "-32700": {
    standard: "JSON RPC 2.0",
    message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
  },
  "-32600": {
    standard: "JSON RPC 2.0",
    message: "The JSON sent is not a valid Request object."
  },
  "-32601": {
    standard: "JSON RPC 2.0",
    message: "The method does not exist / is not available."
  },
  "-32602": {
    standard: "JSON RPC 2.0",
    message: "Invalid method parameter(s)."
  },
  "-32603": {
    standard: "JSON RPC 2.0",
    message: "Internal JSON-RPC error."
  },
  "-32000": {
    standard: "EIP-1474",
    message: "Invalid input."
  },
  "-32001": {
    standard: "EIP-1474",
    message: "Resource not found."
  },
  "-32002": {
    standard: "EIP-1474",
    message: "Resource unavailable."
  },
  "-32003": {
    standard: "EIP-1474",
    message: "Transaction rejected."
  },
  "-32004": {
    standard: "EIP-1474",
    message: "Method not supported."
  },
  "-32005": {
    standard: "EIP-1474",
    message: "Request limit exceeded."
  },
  4001: {
    standard: "EIP-1193",
    message: "User rejected the request."
  },
  4100: {
    standard: "EIP-1193",
    message: "The requested account and/or method has not been authorized by the user."
  },
  4200: {
    standard: "EIP-1193",
    message: "The requested method is not supported by this Ethereum provider."
  },
  4900: {
    standard: "EIP-1193",
    message: "The provider is disconnected from all chains."
  },
  4901: {
    standard: "EIP-1193",
    message: "The provider is disconnected from the specified chain."
  }
};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.serializeError = t.isValidCode = t.getMessageFromCode = t.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
  const e = Is, r = Cs, n = e.errorCodes.rpc.internal, i = "Unspecified error message. This is a bug, please report it.", o = {
    code: n,
    message: c(n)
  };
  t.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
  function c(y, C = i) {
    if (Number.isInteger(y)) {
      const R = y.toString();
      if (g(e.errorValues, R))
        return e.errorValues[R].message;
      if (f(y))
        return t.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return C;
  }
  t.getMessageFromCode = c;
  function u(y) {
    if (!Number.isInteger(y))
      return !1;
    const C = y.toString();
    return !!(e.errorValues[C] || f(y));
  }
  t.isValidCode = u;
  function l(y, { fallbackError: C = o, shouldIncludeStack: R = !1 } = {}) {
    var J, G;
    if (!C || !Number.isInteger(C.code) || typeof C.message != "string")
      throw new Error("Must provide fallback error with integer number code and string message.");
    if (y instanceof r.EthereumRpcError)
      return y.serialize();
    const H = {};
    if (y && typeof y == "object" && !Array.isArray(y) && g(y, "code") && u(y.code)) {
      const q = y;
      H.code = q.code, q.message && typeof q.message == "string" ? (H.message = q.message, g(q, "data") && (H.data = q.data)) : (H.message = c(H.code), H.data = { originalError: p(y) });
    } else {
      H.code = C.code;
      const q = (J = y) === null || J === void 0 ? void 0 : J.message;
      H.message = q && typeof q == "string" ? q : C.message, H.data = { originalError: p(y) };
    }
    const T = (G = y) === null || G === void 0 ? void 0 : G.stack;
    return R && y && T && typeof T == "string" && (H.stack = T), H;
  }
  t.serializeError = l;
  function f(y) {
    return y >= -32099 && y <= -32e3;
  }
  function p(y) {
    return y && typeof y == "object" && !Array.isArray(y) ? Object.assign({}, y) : y;
  }
  function g(y, C) {
    return Object.prototype.hasOwnProperty.call(y, C);
  }
})(cg);
var sf = {};
Object.defineProperty(sf, "__esModule", { value: !0 });
sf.ethErrors = void 0;
const ug = Cs, tE = cg, Br = Is;
sf.ethErrors = {
  rpc: {
    /**
     * Get a JSON RPC 2.0 Parse (-32700) error.
     */
    parse: (t) => Fn(Br.errorCodes.rpc.parse, t),
    /**
     * Get a JSON RPC 2.0 Invalid Request (-32600) error.
     */
    invalidRequest: (t) => Fn(Br.errorCodes.rpc.invalidRequest, t),
    /**
     * Get a JSON RPC 2.0 Invalid Params (-32602) error.
     */
    invalidParams: (t) => Fn(Br.errorCodes.rpc.invalidParams, t),
    /**
     * Get a JSON RPC 2.0 Method Not Found (-32601) error.
     */
    methodNotFound: (t) => Fn(Br.errorCodes.rpc.methodNotFound, t),
    /**
     * Get a JSON RPC 2.0 Internal (-32603) error.
     */
    internal: (t) => Fn(Br.errorCodes.rpc.internal, t),
    /**
     * Get a JSON RPC 2.0 Server error.
     * Permits integer error codes in the [ -32099 <= -32005 ] range.
     * Codes -32000 through -32004 are reserved by EIP-1474.
     */
    server: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum RPC Server errors must provide single object argument.");
      const { code: e } = t;
      if (!Number.isInteger(e) || e > -32005 || e < -32099)
        throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
      return Fn(e, t);
    },
    /**
     * Get an Ethereum JSON RPC Invalid Input (-32000) error.
     */
    invalidInput: (t) => Fn(Br.errorCodes.rpc.invalidInput, t),
    /**
     * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
     */
    resourceNotFound: (t) => Fn(Br.errorCodes.rpc.resourceNotFound, t),
    /**
     * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
     */
    resourceUnavailable: (t) => Fn(Br.errorCodes.rpc.resourceUnavailable, t),
    /**
     * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
     */
    transactionRejected: (t) => Fn(Br.errorCodes.rpc.transactionRejected, t),
    /**
     * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
     */
    methodNotSupported: (t) => Fn(Br.errorCodes.rpc.methodNotSupported, t),
    /**
     * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
     */
    limitExceeded: (t) => Fn(Br.errorCodes.rpc.limitExceeded, t)
  },
  provider: {
    /**
     * Get an Ethereum Provider User Rejected Request (4001) error.
     */
    userRejectedRequest: (t) => lc(Br.errorCodes.provider.userRejectedRequest, t),
    /**
     * Get an Ethereum Provider Unauthorized (4100) error.
     */
    unauthorized: (t) => lc(Br.errorCodes.provider.unauthorized, t),
    /**
     * Get an Ethereum Provider Unsupported Method (4200) error.
     */
    unsupportedMethod: (t) => lc(Br.errorCodes.provider.unsupportedMethod, t),
    /**
     * Get an Ethereum Provider Not Connected (4900) error.
     */
    disconnected: (t) => lc(Br.errorCodes.provider.disconnected, t),
    /**
     * Get an Ethereum Provider Chain Not Connected (4901) error.
     */
    chainDisconnected: (t) => lc(Br.errorCodes.provider.chainDisconnected, t),
    /**
     * Get a custom Ethereum Provider error.
     */
    custom: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum Provider custom errors must provide single object argument.");
      const { code: e, message: r, data: n } = t;
      if (!r || typeof r != "string")
        throw new Error('"message" must be a nonempty string');
      return new ug.EthereumProviderError(e, r, n);
    }
  }
};
function Fn(t, e) {
  const [r, n] = rE(e);
  return new ug.EthereumRpcError(t, r || tE.getMessageFromCode(t), n);
}
function lc(t, e) {
  const [r, n] = rE(e);
  return new ug.EthereumProviderError(t, r || tE.getMessageFromCode(t), n);
}
function rE(t) {
  if (t) {
    if (typeof t == "string")
      return [t];
    if (typeof t == "object" && !Array.isArray(t)) {
      const { message: e, data: r } = t;
      if (e && typeof e != "string")
        throw new Error("Must specify string message.");
      return [e || void 0, r];
    }
  }
  return [];
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getMessageFromCode = t.serializeError = t.EthereumProviderError = t.EthereumRpcError = t.ethErrors = t.errorCodes = void 0;
  const e = Cs;
  Object.defineProperty(t, "EthereumRpcError", { enumerable: !0, get: function() {
    return e.EthereumRpcError;
  } }), Object.defineProperty(t, "EthereumProviderError", { enumerable: !0, get: function() {
    return e.EthereumProviderError;
  } });
  const r = cg;
  Object.defineProperty(t, "serializeError", { enumerable: !0, get: function() {
    return r.serializeError;
  } }), Object.defineProperty(t, "getMessageFromCode", { enumerable: !0, get: function() {
    return r.getMessageFromCode;
  } });
  const n = sf;
  Object.defineProperty(t, "ethErrors", { enumerable: !0, get: function() {
    return n.ethErrors;
  } });
  const i = Is;
  Object.defineProperty(t, "errorCodes", { enumerable: !0, get: function() {
    return i.errorCodes;
  } });
})(J2);
var SN = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(hu, "__esModule", { value: !0 });
hu.JsonRpcEngine = void 0;
const CN = SN(ag), Bn = J2;
class Ji extends CN.default {
  constructor() {
    super(), this._middleware = [];
  }
  /**
   * Add a middleware function to the engine's middleware stack.
   *
   * @param middleware - The middleware function to add.
   */
  push(e) {
    this._middleware.push(e);
  }
  handle(e, r) {
    if (r && typeof r != "function")
      throw new Error('"callback" must be a function if provided.');
    return Array.isArray(e) ? r ? this._handleBatch(e, r) : this._handleBatch(e) : r ? this._handle(e, r) : this._promiseHandle(e);
  }
  /**
   * Returns this engine as a middleware function that can be pushed to other
   * engines.
   *
   * @returns This engine as a middleware function.
   */
  asMiddleware() {
    return async (e, r, n, i) => {
      try {
        const [o, c, u] = await Ji._runAllMiddleware(e, r, this._middleware);
        return c ? (await Ji._runReturnHandlers(u), i(o)) : n(async (l) => {
          try {
            await Ji._runReturnHandlers(u);
          } catch (f) {
            return l(f);
          }
          return l();
        });
      } catch (o) {
        return i(o);
      }
    };
  }
  async _handleBatch(e, r) {
    try {
      const n = await Promise.all(
        // 1. Begin executing each request in the order received
        e.map(this._promiseHandle.bind(this))
      );
      return r ? r(null, n) : n;
    } catch (n) {
      if (r)
        return r(n);
      throw n;
    }
  }
  /**
   * A promise-wrapped _handle.
   */
  _promiseHandle(e) {
    return new Promise((r) => {
      this._handle(e, (n, i) => {
        r(i);
      });
    });
  }
  /**
   * Ensures that the request object is valid, processes it, and passes any
   * error and the response object to the given callback.
   *
   * Does not reject.
   */
  async _handle(e, r) {
    if (!e || Array.isArray(e) || typeof e != "object") {
      const c = new Bn.EthereumRpcError(Bn.errorCodes.rpc.invalidRequest, `Requests must be plain objects. Received: ${typeof e}`, { request: e });
      return r(c, { id: void 0, jsonrpc: "2.0", error: c });
    }
    if (typeof e.method != "string") {
      const c = new Bn.EthereumRpcError(Bn.errorCodes.rpc.invalidRequest, `Must specify a string method. Received: ${typeof e.method}`, { request: e });
      return r(c, { id: e.id, jsonrpc: "2.0", error: c });
    }
    const n = Object.assign({}, e), i = {
      id: n.id,
      jsonrpc: n.jsonrpc
    };
    let o = null;
    try {
      await this._processRequest(n, i);
    } catch (c) {
      o = c;
    }
    return o && (delete i.result, i.error || (i.error = Bn.serializeError(o))), r(o, i);
  }
  /**
   * For the given request and response, runs all middleware and their return
   * handlers, if any, and ensures that internal request processing semantics
   * are satisfied.
   */
  async _processRequest(e, r) {
    const [n, i, o] = await Ji._runAllMiddleware(e, r, this._middleware);
    if (Ji._checkForCompletion(e, r, i), await Ji._runReturnHandlers(o), n)
      throw n;
  }
  /**
   * Serially executes the given stack of middleware.
   *
   * @returns An array of any error encountered during middleware execution,
   * a boolean indicating whether the request was completed, and an array of
   * middleware-defined return handlers.
   */
  static async _runAllMiddleware(e, r, n) {
    const i = [];
    let o = null, c = !1;
    for (const u of n)
      if ([o, c] = await Ji._runMiddleware(e, r, u, i), c)
        break;
    return [o, c, i.reverse()];
  }
  /**
   * Runs an individual middleware.
   *
   * @returns An array of any error encountered during middleware exection,
   * and a boolean indicating whether the request should end.
   */
  static _runMiddleware(e, r, n, i) {
    return new Promise((o) => {
      const c = (l) => {
        const f = l || r.error;
        f && (r.error = Bn.serializeError(f)), o([f, !0]);
      }, u = (l) => {
        r.error ? c(r.error) : (l && (typeof l != "function" && c(new Bn.EthereumRpcError(Bn.errorCodes.rpc.internal, `JsonRpcEngine: "next" return handlers must be functions. Received "${typeof l}" for request:
${u0(e)}`, { request: e })), i.push(l)), o([null, !1]));
      };
      try {
        n(e, r, u, c);
      } catch (l) {
        c(l);
      }
    });
  }
  /**
   * Serially executes array of return handlers. The request and response are
   * assumed to be in their scope.
   */
  static async _runReturnHandlers(e) {
    for (const r of e)
      await new Promise((n, i) => {
        r((o) => o ? i(o) : n());
      });
  }
  /**
   * Throws an error if the response has neither a result nor an error, or if
   * the "isComplete" flag is falsy.
   */
  static _checkForCompletion(e, r, n) {
    if (!("result" in r) && !("error" in r))
      throw new Bn.EthereumRpcError(Bn.errorCodes.rpc.internal, `JsonRpcEngine: Response has no error or result for request:
${u0(e)}`, { request: e });
    if (!n)
      throw new Bn.EthereumRpcError(Bn.errorCodes.rpc.internal, `JsonRpcEngine: Nothing ended request:
${u0(e)}`, { request: e });
  }
}
hu.JsonRpcEngine = Ji;
function u0(t) {
  return JSON.stringify(t, null, 2);
}
var of = {};
Object.defineProperty(of, "__esModule", { value: !0 });
of.mergeMiddleware = void 0;
const IN = hu;
function xN(t) {
  const e = new IN.JsonRpcEngine();
  return t.forEach((r) => e.push(r)), e.asMiddleware();
}
of.mergeMiddleware = xN;
(function(t) {
  var e = Te && Te.__createBinding || (Object.create ? function(n, i, o, c) {
    c === void 0 && (c = o), Object.defineProperty(n, c, { enumerable: !0, get: function() {
      return i[o];
    } });
  } : function(n, i, o, c) {
    c === void 0 && (c = o), n[c] = i[o];
  }), r = Te && Te.__exportStar || function(n, i) {
    for (var o in n)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, n, o);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(tf, t), r(rf, t), r(nf, t), r(lu, t), r(hu, t), r(of, t);
})(og);
var nE = {}, lg = {}, Y0 = function(t, e) {
  return Y0 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Y0(t, e);
};
function RN(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Y0(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var X0 = function() {
  return X0 = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, X0.apply(this, arguments);
};
function AN(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(t); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[i]) && (r[n[i]] = t[n[i]]);
  return r;
}
function MN(t, e, r, n) {
  var i = arguments.length, o = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, r) : n, c;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(t, e, r, n);
  else
    for (var u = t.length - 1; u >= 0; u--)
      (c = t[u]) && (o = (i < 3 ? c(o) : i > 3 ? c(e, r, o) : c(e, r)) || o);
  return i > 3 && o && Object.defineProperty(e, r, o), o;
}
function DN(t, e) {
  return function(r, n) {
    e(r, n, t);
  };
}
function ON(t, e, r, n, i, o) {
  function c(H) {
    if (H !== void 0 && typeof H != "function")
      throw new TypeError("Function expected");
    return H;
  }
  for (var u = n.kind, l = u === "getter" ? "get" : u === "setter" ? "set" : "value", f = !e && t ? n.static ? t : t.prototype : null, p = e || (f ? Object.getOwnPropertyDescriptor(f, n.name) : {}), g, y = !1, C = r.length - 1; C >= 0; C--) {
    var R = {};
    for (var J in n)
      R[J] = J === "access" ? {} : n[J];
    for (var J in n.access)
      R.access[J] = n.access[J];
    R.addInitializer = function(H) {
      if (y)
        throw new TypeError("Cannot add initializers after decoration has completed");
      o.push(c(H || null));
    };
    var G = (0, r[C])(u === "accessor" ? { get: p.get, set: p.set } : p[l], R);
    if (u === "accessor") {
      if (G === void 0)
        continue;
      if (G === null || typeof G != "object")
        throw new TypeError("Object expected");
      (g = c(G.get)) && (p.get = g), (g = c(G.set)) && (p.set = g), (g = c(G.init)) && i.push(g);
    } else
      (g = c(G)) && (u === "field" ? i.push(g) : p[l] = g);
  }
  f && Object.defineProperty(f, n.name, p), y = !0;
}
function PN(t, e, r) {
  for (var n = arguments.length > 2, i = 0; i < e.length; i++)
    r = n ? e[i].call(t, r) : e[i].call(t);
  return n ? r : void 0;
}
function TN(t) {
  return typeof t == "symbol" ? t : "".concat(t);
}
function NN(t, e, r) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(t, "name", { configurable: !0, value: r ? "".concat(r, " ", e) : e });
}
function kN(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t, e);
}
function LN(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(c) {
      c(o);
    });
  }
  return new (r || (r = Promise))(function(o, c) {
    function u(p) {
      try {
        f(n.next(p));
      } catch (g) {
        c(g);
      }
    }
    function l(p) {
      try {
        f(n.throw(p));
      } catch (g) {
        c(g);
      }
    }
    function f(p) {
      p.done ? o(p.value) : i(p.value).then(u, l);
    }
    f((n = n.apply(t, e || [])).next());
  });
}
function $N(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, c;
  return c = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function u(f) {
    return function(p) {
      return l([f, p]);
    };
  }
  function l(f) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; c && (c = 0, f[0] && (r = 0)), r; )
      try {
        if (n = 1, i && (o = f[0] & 2 ? i.return : f[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, f[1])).done)
          return o;
        switch (i = 0, o && (f = [f[0] & 2, o.value]), f[0]) {
          case 0:
          case 1:
            o = f;
            break;
          case 4:
            return r.label++, { value: f[1], done: !1 };
          case 5:
            r.label++, i = f[1], f = [0];
            continue;
          case 7:
            f = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              r = 0;
              continue;
            }
            if (f[0] === 3 && (!o || f[1] > o[0] && f[1] < o[3])) {
              r.label = f[1];
              break;
            }
            if (f[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = f;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(f);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        f = e.call(t, r);
      } catch (p) {
        f = [6, p], i = 0;
      } finally {
        n = o = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
var hg = Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(e, r);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[r];
  } }), Object.defineProperty(t, n, i);
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
};
function FN(t, e) {
  for (var r in t)
    r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && hg(e, t, r);
}
function ep(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r)
    return r.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function iE(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var n = r.call(t), i, o = [], c;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (u) {
    c = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (c)
        throw c.error;
    }
  }
  return o;
}
function BN() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(iE(arguments[e]));
  return t;
}
function UN() {
  for (var t = 0, e = 0, r = arguments.length; e < r; e++)
    t += arguments[e].length;
  for (var n = Array(t), i = 0, e = 0; e < r; e++)
    for (var o = arguments[e], c = 0, u = o.length; c < u; c++, i++)
      n[i] = o[c];
  return n;
}
function jN(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}
function kc(t) {
  return this instanceof kc ? (this.v = t, this) : new kc(t);
}
function HN(t, e, r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(t, e || []), i, o = [];
  return i = {}, c("next"), c("throw"), c("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function c(y) {
    n[y] && (i[y] = function(C) {
      return new Promise(function(R, J) {
        o.push([y, C, R, J]) > 1 || u(y, C);
      });
    });
  }
  function u(y, C) {
    try {
      l(n[y](C));
    } catch (R) {
      g(o[0][3], R);
    }
  }
  function l(y) {
    y.value instanceof kc ? Promise.resolve(y.value.v).then(f, p) : g(o[0][2], y);
  }
  function f(y) {
    u("next", y);
  }
  function p(y) {
    u("throw", y);
  }
  function g(y, C) {
    y(C), o.shift(), o.length && u(o[0][0], o[0][1]);
  }
}
function qN(t) {
  var e, r;
  return e = {}, n("next"), n("throw", function(i) {
    throw i;
  }), n("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function n(i, o) {
    e[i] = t[i] ? function(c) {
      return (r = !r) ? { value: kc(t[i](c)), done: !1 } : o ? o(c) : c;
    } : o;
  }
}
function zN(t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], r;
  return e ? e.call(t) : (t = typeof ep == "function" ? ep(t) : t[Symbol.iterator](), r = {}, n("next"), n("throw"), n("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function n(o) {
    r[o] = t[o] && function(c) {
      return new Promise(function(u, l) {
        c = t[o](c), i(u, l, c.done, c.value);
      });
    };
  }
  function i(o, c, u, l) {
    Promise.resolve(l).then(function(f) {
      o({ value: f, done: u });
    }, c);
  }
}
function VN(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
var WN = Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
};
function KN(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var r in t)
      r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && hg(e, t, r);
  return WN(e, t), e;
}
function GN(t) {
  return t && t.__esModule ? t : { default: t };
}
function JN(t, e, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}
function QN(t, e, r, n, i) {
  if (n === "m")
    throw new TypeError("Private method is not writable");
  if (n === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? i.call(t, r) : i ? i.value = r : e.set(t, r), r;
}
function ZN(t, e) {
  if (e === null || typeof e != "object" && typeof e != "function")
    throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof t == "function" ? e === t : t.has(e);
}
const YN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return X0;
  },
  __asyncDelegator: qN,
  __asyncGenerator: HN,
  __asyncValues: zN,
  __await: kc,
  __awaiter: LN,
  __classPrivateFieldGet: JN,
  __classPrivateFieldIn: ZN,
  __classPrivateFieldSet: QN,
  __createBinding: hg,
  __decorate: MN,
  __esDecorate: ON,
  __exportStar: FN,
  __extends: RN,
  __generator: $N,
  __importDefault: GN,
  __importStar: KN,
  __makeTemplateObject: VN,
  __metadata: kN,
  __param: DN,
  __propKey: TN,
  __read: iE,
  __rest: AN,
  __runInitializers: PN,
  __setFunctionName: NN,
  __spread: BN,
  __spreadArray: jN,
  __spreadArrays: UN,
  __values: ep
}, Symbol.toStringTag, { value: "Module" })), fg = /* @__PURE__ */ is(YN);
var af = {};
Object.defineProperty(af, "__esModule", { value: !0 });
var Dy = fg, XN = (
  /** @class */
  function() {
    function t(e) {
      if (this._maxConcurrency = e, this._queue = [], e <= 0)
        throw new Error("semaphore must be initialized to a positive value");
      this._value = e;
    }
    return t.prototype.acquire = function() {
      var e = this, r = this.isLocked(), n = new Promise(function(i) {
        return e._queue.push(i);
      });
      return r || this._dispatch(), n;
    }, t.prototype.runExclusive = function(e) {
      return Dy.__awaiter(this, void 0, void 0, function() {
        var r, n, i;
        return Dy.__generator(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, this.acquire()];
            case 1:
              r = o.sent(), n = r[0], i = r[1], o.label = 2;
            case 2:
              return o.trys.push([2, , 4, 5]), [4, e(n)];
            case 3:
              return [2, o.sent()];
            case 4:
              return i(), [
                7
                /*endfinally*/
              ];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.isLocked = function() {
      return this._value <= 0;
    }, t.prototype.release = function() {
      if (this._maxConcurrency > 1)
        throw new Error("this method is unavailabel on semaphores with concurrency > 1; use the scoped release returned by acquire instead");
      if (this._currentReleaser) {
        var e = this._currentReleaser;
        this._currentReleaser = void 0, e();
      }
    }, t.prototype._dispatch = function() {
      var e = this, r = this._queue.shift();
      if (r) {
        var n = !1;
        this._currentReleaser = function() {
          n || (n = !0, e._value++, e._dispatch());
        }, r([this._value--, this._currentReleaser]);
      }
    }, t;
  }()
);
af.default = XN;
Object.defineProperty(lg, "__esModule", { value: !0 });
var Oy = fg, ek = af, tk = (
  /** @class */
  function() {
    function t() {
      this._semaphore = new ek.default(1);
    }
    return t.prototype.acquire = function() {
      return Oy.__awaiter(this, void 0, void 0, function() {
        var e, r;
        return Oy.__generator(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this._semaphore.acquire()];
            case 1:
              return e = n.sent(), r = e[1], [2, r];
          }
        });
      });
    }, t.prototype.runExclusive = function(e) {
      return this._semaphore.runExclusive(function() {
        return e();
      });
    }, t.prototype.isLocked = function() {
      return this._semaphore.isLocked();
    }, t.prototype.release = function() {
      this._semaphore.release();
    }, t;
  }()
);
lg.default = tk;
var cf = {};
Object.defineProperty(cf, "__esModule", { value: !0 });
cf.withTimeout = void 0;
var Tl = fg;
function rk(t, e, r) {
  var n = this;
  return r === void 0 && (r = new Error("timeout")), {
    acquire: function() {
      return new Promise(function(i, o) {
        return Tl.__awaiter(n, void 0, void 0, function() {
          var c, u, l;
          return Tl.__generator(this, function(f) {
            switch (f.label) {
              case 0:
                return c = !1, setTimeout(function() {
                  c = !0, o(r);
                }, e), [4, t.acquire()];
              case 1:
                return u = f.sent(), c ? (l = Array.isArray(u) ? u[1] : u, l()) : i(u), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    },
    runExclusive: function(i) {
      return Tl.__awaiter(this, void 0, void 0, function() {
        var o, c;
        return Tl.__generator(this, function(u) {
          switch (u.label) {
            case 0:
              o = function() {
              }, u.label = 1;
            case 1:
              return u.trys.push([1, , 7, 8]), [4, this.acquire()];
            case 2:
              return c = u.sent(), Array.isArray(c) ? (o = c[1], [4, i(c[0])]) : [3, 4];
            case 3:
              return [2, u.sent()];
            case 4:
              return o = c, [4, i()];
            case 5:
              return [2, u.sent()];
            case 6:
              return [3, 8];
            case 7:
              return o(), [
                7
                /*endfinally*/
              ];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    },
    release: function() {
      t.release();
    },
    isLocked: function() {
      return t.isLocked();
    }
  };
}
cf.withTimeout = rk;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.withTimeout = t.Semaphore = t.Mutex = void 0;
  var e = lg;
  Object.defineProperty(t, "Mutex", { enumerable: !0, get: function() {
    return e.default;
  } });
  var r = af;
  Object.defineProperty(t, "Semaphore", { enumerable: !0, get: function() {
    return r.default;
  } });
  var n = cf;
  Object.defineProperty(t, "withTimeout", { enumerable: !0, get: function() {
    return n.withTimeout;
  } });
})(nE);
var nk = sk, ik = Object.prototype.hasOwnProperty;
function sk() {
  for (var t = {}, e = 0; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      ik.call(r, n) && (t[n] = r[n]);
  }
  return t;
}
const ok = nk, ak = Hp();
var ck = nt;
function nt(t) {
  const e = this;
  e.currentProvider = t;
}
nt.prototype.getBalance = fu(2, "eth_getBalance");
nt.prototype.getCode = fu(2, "eth_getCode");
nt.prototype.getTransactionCount = fu(2, "eth_getTransactionCount");
nt.prototype.getStorageAt = fu(3, "eth_getStorageAt");
nt.prototype.call = fu(2, "eth_call");
nt.prototype.protocolVersion = mt("eth_protocolVersion");
nt.prototype.syncing = mt("eth_syncing");
nt.prototype.coinbase = mt("eth_coinbase");
nt.prototype.mining = mt("eth_mining");
nt.prototype.hashrate = mt("eth_hashrate");
nt.prototype.gasPrice = mt("eth_gasPrice");
nt.prototype.accounts = mt("eth_accounts");
nt.prototype.blockNumber = mt("eth_blockNumber");
nt.prototype.getBlockTransactionCountByHash = mt("eth_getBlockTransactionCountByHash");
nt.prototype.getBlockTransactionCountByNumber = mt("eth_getBlockTransactionCountByNumber");
nt.prototype.getUncleCountByBlockHash = mt("eth_getUncleCountByBlockHash");
nt.prototype.getUncleCountByBlockNumber = mt("eth_getUncleCountByBlockNumber");
nt.prototype.sign = mt("eth_sign");
nt.prototype.sendTransaction = mt("eth_sendTransaction");
nt.prototype.sendRawTransaction = mt("eth_sendRawTransaction");
nt.prototype.estimateGas = mt("eth_estimateGas");
nt.prototype.getBlockByHash = mt("eth_getBlockByHash");
nt.prototype.getBlockByNumber = mt("eth_getBlockByNumber");
nt.prototype.getTransactionByHash = mt("eth_getTransactionByHash");
nt.prototype.getTransactionByBlockHashAndIndex = mt("eth_getTransactionByBlockHashAndIndex");
nt.prototype.getTransactionByBlockNumberAndIndex = mt("eth_getTransactionByBlockNumberAndIndex");
nt.prototype.getTransactionReceipt = mt("eth_getTransactionReceipt");
nt.prototype.getUncleByBlockHashAndIndex = mt("eth_getUncleByBlockHashAndIndex");
nt.prototype.getUncleByBlockNumberAndIndex = mt("eth_getUncleByBlockNumberAndIndex");
nt.prototype.getCompilers = mt("eth_getCompilers");
nt.prototype.compileLLL = mt("eth_compileLLL");
nt.prototype.compileSolidity = mt("eth_compileSolidity");
nt.prototype.compileSerpent = mt("eth_compileSerpent");
nt.prototype.newFilter = mt("eth_newFilter");
nt.prototype.newBlockFilter = mt("eth_newBlockFilter");
nt.prototype.newPendingTransactionFilter = mt("eth_newPendingTransactionFilter");
nt.prototype.uninstallFilter = mt("eth_uninstallFilter");
nt.prototype.getFilterChanges = mt("eth_getFilterChanges");
nt.prototype.getFilterLogs = mt("eth_getFilterLogs");
nt.prototype.getLogs = mt("eth_getLogs");
nt.prototype.getWork = mt("eth_getWork");
nt.prototype.submitWork = mt("eth_submitWork");
nt.prototype.submitHashrate = mt("eth_submitHashrate");
nt.prototype.sendAsync = function(t, e) {
  this.currentProvider.sendAsync(uk(t), function(n, i) {
    if (!n && i.error && (n = new Error("EthQuery - RPC Error - " + i.error.message)), n)
      return e(n);
    e(null, i.result);
  });
};
function mt(t) {
  return function() {
    const e = this;
    var r = [].slice.call(arguments), n = r.pop();
    e.sendAsync({
      method: t,
      params: r
    }, n);
  };
}
function fu(t, e) {
  return function() {
    const r = this;
    var n = [].slice.call(arguments), i = n.pop();
    n.length < t && n.push("latest"), r.sendAsync({
      method: e,
      params: n
    }, i);
  };
}
function uk(t) {
  return ok({
    // defaults
    id: ak(),
    jsonrpc: "2.0",
    params: []
    // user-specified
  }, t);
}
const Py = (t, e, r, n) => function(...i) {
  const o = e.promiseModule;
  return new o((c, u) => {
    e.multiArgs ? i.push((...f) => {
      e.errorFirst ? f[0] ? u(f) : (f.shift(), c(f)) : c(f);
    }) : e.errorFirst ? i.push((f, p) => {
      f ? u(f) : c(p);
    }) : i.push(c), Reflect.apply(t, this === r ? n : this, i);
  });
}, Ty = /* @__PURE__ */ new WeakMap();
var lk = (t, e) => {
  e = {
    exclude: [/.+(?:Sync|Stream)$/],
    errorFirst: !0,
    promiseModule: Promise,
    ...e
  };
  const r = typeof t;
  if (!(t !== null && (r === "object" || r === "function")))
    throw new TypeError(`Expected \`input\` to be a \`Function\` or \`Object\`, got \`${t === null ? "null" : r}\``);
  const n = (c, u) => {
    let l = Ty.get(c);
    if (l || (l = {}, Ty.set(c, l)), u in l)
      return l[u];
    const f = (R) => typeof R == "string" || typeof u == "symbol" ? u === R : R.test(u), p = Reflect.getOwnPropertyDescriptor(c, u), g = p === void 0 || p.writable || p.configurable, C = (e.include ? e.include.some(f) : !e.exclude.some(f)) && g;
    return l[u] = C, C;
  }, i = /* @__PURE__ */ new WeakMap(), o = new Proxy(t, {
    apply(c, u, l) {
      const f = i.get(c);
      if (f)
        return Reflect.apply(f, u, l);
      const p = e.excludeMain ? c : Py(c, e, o, c);
      return i.set(c, p), Reflect.apply(p, u, l);
    },
    get(c, u) {
      const l = c[u];
      if (!n(c, u) || l === Function.prototype[u])
        return l;
      const f = i.get(l);
      if (f)
        return f;
      if (typeof l == "function") {
        const p = Py(l, e, o, c);
        return i.set(l, p), p;
      }
      return l;
    }
  });
  return o;
};
const hk = su.default;
let fk = class extends hk {
  constructor() {
    super(), this.updates = [];
  }
  async initialize() {
  }
  async update() {
    throw new Error("BaseFilter - no update method specified");
  }
  addResults(e) {
    this.updates = this.updates.concat(e), e.forEach((r) => this.emit("update", r));
  }
  addInitialResults(e) {
  }
  getChangesAndClear() {
    const e = this.updates;
    return this.updates = [], e;
  }
};
var dg = fk;
const dk = dg;
let pk = class extends dk {
  constructor() {
    super(), this.allResults = [];
  }
  async update() {
    throw new Error("BaseFilterWithHistory - no update method specified");
  }
  addResults(e) {
    this.allResults = this.allResults.concat(e), super.addResults(e);
  }
  addInitialResults(e) {
    this.allResults = this.allResults.concat(e), super.addInitialResults(e);
  }
  getAllResults() {
    return this.allResults;
  }
};
var gk = pk, du = {
  minBlockRef: mk,
  maxBlockRef: vk,
  sortBlockRefs: pg,
  bnToHex: yk,
  blockRefIsNumber: _k,
  hexToInt: nh,
  incrementHexInt: wk,
  intToHex: sE,
  unsafeRandomBytes: bk
};
function mk(...t) {
  return pg(t)[0];
}
function vk(...t) {
  const e = pg(t);
  return e[e.length - 1];
}
function pg(t) {
  return t.sort((e, r) => e === "latest" || r === "earliest" ? 1 : r === "latest" || e === "earliest" ? -1 : nh(e) - nh(r));
}
function yk(t) {
  return "0x" + t.toString(16);
}
function _k(t) {
  return t && !["earliest", "latest", "pending"].includes(t);
}
function nh(t) {
  return t == null ? t : Number.parseInt(t, 16);
}
function wk(t) {
  if (t == null)
    return t;
  const e = nh(t);
  return sE(e + 1);
}
function sE(t) {
  if (t == null)
    return t;
  let e = t.toString(16);
  return e.length % 2 && (e = "0" + e), "0x" + e;
}
function bk(t) {
  let e = "0x";
  for (let r = 0; r < t; r++)
    e += Ny(), e += Ny();
  return e;
}
function Ny() {
  return Math.floor(Math.random() * 16).toString(16);
}
const Ek = ck, Sk = lk, Ck = gk, { bnToHex: AV, hexToInt: Nl, incrementHexInt: Ik, minBlockRef: xk, blockRefIsNumber: Rk } = du;
let Ak = class extends Ck {
  constructor({ provider: e, params: r }) {
    super(), this.type = "log", this.ethQuery = new Ek(e), this.params = Object.assign({
      fromBlock: "latest",
      toBlock: "latest",
      address: void 0,
      topics: []
    }, r), this.params.address && (Array.isArray(this.params.address) || (this.params.address = [this.params.address]), this.params.address = this.params.address.map((n) => n.toLowerCase()));
  }
  async initialize({ currentBlock: e }) {
    let r = this.params.fromBlock;
    ["latest", "pending"].includes(r) && (r = e), r === "earliest" && (r = "0x0"), this.params.fromBlock = r;
    const n = xk(this.params.toBlock, e), i = Object.assign({}, this.params, { toBlock: n }), o = await this._fetchLogs(i);
    this.addInitialResults(o);
  }
  async update({ oldBlock: e, newBlock: r }) {
    const n = r;
    let i;
    e ? i = Ik(e) : i = r;
    const o = Object.assign({}, this.params, { fromBlock: i, toBlock: n }), u = (await this._fetchLogs(o)).filter((l) => this.matchLog(l));
    this.addResults(u);
  }
  async _fetchLogs(e) {
    return await Sk((n) => this.ethQuery.getLogs(e, n))();
  }
  matchLog(e) {
    if (Nl(this.params.fromBlock) >= Nl(e.blockNumber) || Rk(this.params.toBlock) && Nl(this.params.toBlock) <= Nl(e.blockNumber))
      return !1;
    const r = e.address && e.address.toLowerCase();
    return this.params.address && r && !this.params.address.includes(r) ? !1 : this.params.topics.every((i, o) => {
      let c = e.topics[o];
      if (!c)
        return !1;
      c = c.toLowerCase();
      let u = Array.isArray(i) ? i : [i];
      return u.includes(null) ? !0 : (u = u.map((p) => p.toLowerCase()), u.includes(c));
    });
  }
};
var Mk = Ak, gg = Dk;
async function Dk({ provider: t, fromBlock: e, toBlock: r }) {
  e || (e = r);
  const n = ky(e), o = ky(r) - n + 1, c = Array(o).fill().map((l, f) => n + f).map(Ok);
  let u = await Promise.all(
    c.map((l) => Tk(t, "eth_getBlockByNumber", [l, !1]))
  );
  return u = u.filter((l) => l !== null), u;
}
function ky(t) {
  return t == null ? t : Number.parseInt(t, 16);
}
function Ok(t) {
  return t == null ? t : "0x" + t.toString(16);
}
function Pk(t, e) {
  return new Promise((r, n) => {
    t.sendAsync(e, (i, o) => {
      i ? n(i) : o.error ? n(o.error) : o.result ? r(o.result) : n(new Error("Result was empty"));
    });
  });
}
async function Tk(t, e, r) {
  for (let n = 0; n < 3; n++)
    try {
      return await Pk(t, {
        id: 1,
        jsonrpc: "2.0",
        method: e,
        params: r
      });
    } catch (i) {
      console.error(
        `provider.sendAsync failed: ${i.stack || i.message || i}`
      );
    }
  return null;
}
const Nk = dg, kk = gg, { incrementHexInt: Lk } = du;
let $k = class extends Nk {
  constructor({ provider: e, params: r }) {
    super(), this.type = "block", this.provider = e;
  }
  async update({ oldBlock: e, newBlock: r }) {
    const n = r, i = Lk(e), c = (await kk({ provider: this.provider, fromBlock: i, toBlock: n })).map((u) => u.hash);
    this.addResults(c);
  }
};
var Fk = $k;
const Bk = dg, Uk = gg, { incrementHexInt: jk } = du;
let Hk = class extends Bk {
  constructor({ provider: e }) {
    super(), this.type = "tx", this.provider = e;
  }
  async update({ oldBlock: e }) {
    const r = e, n = jk(e), i = await Uk({ provider: this.provider, fromBlock: n, toBlock: r }), o = [];
    for (const c of i)
      o.push(...c.transactions);
    this.addResults(o);
  }
};
var qk = Hk;
const zk = nE.Mutex, { createAsyncMiddleware: Vk, createScaffoldMiddleware: Wk } = og, Kk = Mk, Gk = Fk, Jk = qk, { intToHex: oE, hexToInt: l0 } = du;
var Qk = Zk;
function Zk({ blockTracker: t, provider: e }) {
  let r = 0, n = {};
  const i = new zk(), o = Yk({ mutex: i }), c = Wk({
    // install filters
    eth_newFilter: o(h0(l)),
    eth_newBlockFilter: o(h0(f)),
    eth_newPendingTransactionFilter: o(h0(p)),
    // uninstall filters
    eth_uninstallFilter: o(Wl(C)),
    // checking filter changes
    eth_getFilterChanges: o(Wl(g)),
    eth_getFilterLogs: o(Wl(y))
  }), u = async ({ oldBlock: T, newBlock: q }) => {
    if (n.length === 0)
      return;
    const B = await i.acquire();
    try {
      await Promise.all(ta(n).map(async (L) => {
        try {
          await L.update({ oldBlock: T, newBlock: q });
        } catch (P) {
          console.error(P);
        }
      }));
    } catch (L) {
      console.error(L);
    }
    B();
  };
  return c.newLogFilter = l, c.newBlockFilter = f, c.newPendingTransactionFilter = p, c.uninstallFilter = C, c.getFilterChanges = g, c.getFilterLogs = y, c.destroy = () => {
    G();
  }, c;
  async function l(T) {
    const q = new Kk({ provider: e, params: T });
    return await R(q), q;
  }
  async function f() {
    const T = new Gk({ provider: e });
    return await R(T), T;
  }
  async function p() {
    const T = new Jk({ provider: e });
    return await R(T), T;
  }
  async function g(T) {
    const q = l0(T), B = n[q];
    if (!B)
      throw new Error(`No filter for index "${q}"`);
    return B.getChangesAndClear();
  }
  async function y(T) {
    const q = l0(T), B = n[q];
    if (!B)
      throw new Error(`No filter for index "${q}"`);
    let L = [];
    return B.type === "log" && (L = B.getAllResults()), L;
  }
  async function C(T) {
    const q = l0(T), L = !!n[q];
    return L && await J(q), L;
  }
  async function R(T) {
    const q = ta(n).length, B = await t.getLatestBlock();
    await T.initialize({ currentBlock: B }), r++, n[r] = T, T.id = r, T.idHex = oE(r);
    const L = ta(n).length;
    return H({ prevFilterCount: q, newFilterCount: L }), r;
  }
  async function J(T) {
    const q = ta(n).length;
    delete n[T];
    const B = ta(n).length;
    H({ prevFilterCount: q, newFilterCount: B });
  }
  async function G() {
    const T = ta(n).length;
    n = {}, H({ prevFilterCount: T, newFilterCount: 0 });
  }
  function H({ prevFilterCount: T, newFilterCount: q }) {
    if (T === 0 && q > 0) {
      t.on("sync", u);
      return;
    }
    if (T > 0 && q === 0) {
      t.removeListener("sync", u);
      return;
    }
  }
}
function h0(t) {
  return Wl(async (...e) => {
    const r = await t(...e);
    return oE(r.id);
  });
}
function Wl(t) {
  return Vk(async (e, r) => {
    const n = await t.apply(null, e.params);
    r.result = n;
  });
}
function Yk({ mutex: t }) {
  return (e) => async (r, n, i, o) => {
    (await t.acquire())(), e(r, n, i, o);
  };
}
function ta(t, e) {
  const r = [];
  for (let n in t)
    r.push(t[n]);
  return r;
}
const Xk = su.default, { createAsyncMiddleware: Ly, createScaffoldMiddleware: eL } = og, tL = Qk, { unsafeRandomBytes: rL, incrementHexInt: nL } = du, iL = gg;
var sL = oL;
function oL({ blockTracker: t, provider: e }) {
  const r = {}, n = tL({ blockTracker: t, provider: e });
  let i = !1;
  const o = new Xk(), c = eL({
    eth_subscribe: Ly(u),
    eth_unsubscribe: Ly(l)
  });
  return c.destroy = p, { events: o, middleware: c };
  async function u(g, y) {
    if (i)
      throw new Error(
        "SubscriptionManager - attempting to use after destroying"
      );
    const C = g.params[0], R = rL(16);
    let J;
    switch (C) {
      case "newHeads":
        J = G({ subId: R });
        break;
      case "logs":
        const T = g.params[1], q = await n.newLogFilter(T);
        J = H({ subId: R, filter: q });
        break;
      default:
        throw new Error(`SubscriptionManager - unsupported subscription type "${C}"`);
    }
    r[R] = J, y.result = R;
    return;
    function G({ subId: T }) {
      const q = {
        type: C,
        destroy: async () => {
          t.removeListener("sync", q.update);
        },
        update: async ({ oldBlock: B, newBlock: L }) => {
          const P = L, v = nL(B);
          (await iL({ provider: e, fromBlock: v, toBlock: P })).map(aL).filter((le) => le !== null).forEach((le) => {
            f(T, le);
          });
        }
      };
      return t.on("sync", q.update), q;
    }
    function H({ subId: T, filter: q }) {
      return q.on("update", (L) => f(T, L)), {
        type: C,
        destroy: async () => await n.uninstallFilter(q.idHex)
      };
    }
  }
  async function l(g, y) {
    if (i)
      throw new Error(
        "SubscriptionManager - attempting to use after destroying"
      );
    const C = g.params[0], R = r[C];
    if (!R) {
      y.result = !1;
      return;
    }
    delete r[C], await R.destroy(), y.result = !0;
  }
  function f(g, y) {
    o.emit("notification", {
      jsonrpc: "2.0",
      method: "eth_subscription",
      params: {
        subscription: g,
        result: y
      }
    });
  }
  function p() {
    o.removeAllListeners();
    for (const g in r)
      r[g].destroy(), delete r[g];
    i = !0;
  }
}
function aL(t) {
  return t == null ? null : {
    hash: t.hash,
    parentHash: t.parentHash,
    sha3Uncles: t.sha3Uncles,
    miner: t.miner,
    stateRoot: t.stateRoot,
    transactionsRoot: t.transactionsRoot,
    receiptsRoot: t.receiptsRoot,
    logsBloom: t.logsBloom,
    difficulty: t.difficulty,
    number: t.number,
    gasLimit: t.gasLimit,
    gasUsed: t.gasUsed,
    nonce: t.nonce,
    mixHash: t.mixHash,
    timestamp: t.timestamp,
    extraData: t.extraData
  };
}
Object.defineProperty(zh, "__esModule", { value: !0 });
zh.SubscriptionManager = void 0;
const cL = l2, uL = sL, $y = () => {
};
class lL {
  constructor(e) {
    const r = new cL.PollingBlockTracker({
      provider: e,
      pollingInterval: 15e3,
      setSkipCacheFlag: !0
    }), { events: n, middleware: i } = uL({
      blockTracker: r,
      provider: e
    });
    this.events = n, this.subscriptionMiddleware = i;
  }
  async handleRequest(e) {
    const r = {};
    return await this.subscriptionMiddleware(e, r, $y, $y), r;
  }
  destroy() {
    this.subscriptionMiddleware.destroy();
  }
}
zh.SubscriptionManager = lL;
var aE = Te && Te.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(va, "__esModule", { value: !0 });
va.CoinbaseWalletProvider = void 0;
const hL = aE(Uc), fL = pI, xt = jc, pt = $e, dL = Vc, Fy = Hn, kl = Da, En = Ra, f0 = aE(fD), hc = Ma, pL = Sa, gL = zh, By = "DefaultChainId", Uy = "DefaultJsonRpcUrl";
class mL extends fL.EventEmitter {
  constructor(e) {
    var r, n;
    super(), this._filterPolyfill = new pL.FilterPolyfill(this), this._subscriptionManager = new gL.SubscriptionManager(this), this._relay = null, this._addresses = [], this.hasMadeFirstChainChangedEmission = !1, this.setProviderInfo = this.setProviderInfo.bind(this), this.updateProviderInfo = this.updateProviderInfo.bind(this), this.getChainId = this.getChainId.bind(this), this.setAppInfo = this.setAppInfo.bind(this), this.enable = this.enable.bind(this), this.close = this.close.bind(this), this.send = this.send.bind(this), this.sendAsync = this.sendAsync.bind(this), this.request = this.request.bind(this), this._setAddresses = this._setAddresses.bind(this), this.scanQRCode = this.scanQRCode.bind(this), this.genericRequest = this.genericRequest.bind(this), this._chainIdFromOpts = e.chainId, this._jsonRpcUrlFromOpts = e.jsonRpcUrl, this._overrideIsMetaMask = e.overrideIsMetaMask, this._relayProvider = e.relayProvider, this._storage = e.storage, this._relayEventManager = e.relayEventManager, this.diagnostic = e.diagnosticLogger, this.reloadOnDisconnect = !0, this.isCoinbaseWallet = (r = e.overrideIsCoinbaseWallet) !== null && r !== void 0 ? r : !0, this.isCoinbaseBrowser = (n = e.overrideIsCoinbaseBrowser) !== null && n !== void 0 ? n : !1, this.qrUrl = e.qrUrl;
    const i = this.getChainId(), o = (0, pt.prepend0x)(i.toString(16));
    this.emit("connect", { chainIdStr: o });
    const c = this._storage.getItem(Fy.LOCAL_STORAGE_ADDRESSES_KEY);
    if (c) {
      const u = c.split(" ");
      u[0] !== "" && (this._addresses = u.map((l) => (0, pt.ensureAddressString)(l)), this.emit("accountsChanged", u));
    }
    this._subscriptionManager.events.on("notification", (u) => {
      this.emit("message", {
        type: u.method,
        data: u.params
      });
    }), this._isAuthorized() && this.initializeRelay(), window.addEventListener("message", (u) => {
      var l;
      if (!(u.origin !== location.origin || u.source !== window) && u.data.type === "walletLinkMessage" && u.data.data.action === "dappChainSwitched") {
        const f = u.data.data.chainId, p = (l = u.data.data.jsonRpcUrl) !== null && l !== void 0 ? l : this.jsonRpcUrl;
        this.updateProviderInfo(p, Number(f));
      }
    });
  }
  /** @deprecated Use `.request({ method: 'eth_accounts' })` instead. */
  get selectedAddress() {
    return this._addresses[0] || void 0;
  }
  /** @deprecated Use the chain ID. If you still need the network ID, use `.request({ method: 'net_version' })`. */
  get networkVersion() {
    return this.getChainId().toString(10);
  }
  /** @deprecated Use `.request({ method: 'eth_chainId' })` instead. */
  get chainId() {
    return (0, pt.prepend0x)(this.getChainId().toString(16));
  }
  get isWalletLink() {
    return !0;
  }
  /**
   * Some DApps (i.e. Alpha Homora) seem to require the window.ethereum object return
   * true for this method.
   */
  get isMetaMask() {
    return this._overrideIsMetaMask;
  }
  get host() {
    return this.jsonRpcUrl;
  }
  get connected() {
    return !0;
  }
  isConnected() {
    return !0;
  }
  get jsonRpcUrl() {
    var e;
    return (e = this._storage.getItem(Uy)) !== null && e !== void 0 ? e : this._jsonRpcUrlFromOpts;
  }
  set jsonRpcUrl(e) {
    this._storage.setItem(Uy, e);
  }
  disableReloadOnDisconnect() {
    this.reloadOnDisconnect = !1;
  }
  setProviderInfo(e, r) {
    this.isCoinbaseBrowser || (this._chainIdFromOpts = r, this._jsonRpcUrlFromOpts = e), this.updateProviderInfo(this.jsonRpcUrl, this.getChainId());
  }
  updateProviderInfo(e, r) {
    this.jsonRpcUrl = e;
    const n = this.getChainId();
    this._storage.setItem(By, r.toString(10)), ((0, pt.ensureIntNumber)(r) !== n || !this.hasMadeFirstChainChangedEmission) && (this.emit("chainChanged", this.getChainId()), this.hasMadeFirstChainChangedEmission = !0);
  }
  async watchAsset(e, r, n, i, o, c) {
    const l = await (await this.initializeRelay()).watchAsset(e, r, n, i, o, c?.toString()).promise;
    return (0, En.isErrorResponse)(l) ? !1 : !!l.result;
  }
  async addEthereumChain(e, r, n, i, o, c) {
    var u, l;
    if ((0, pt.ensureIntNumber)(e) === this.getChainId())
      return !1;
    const f = await this.initializeRelay(), p = f.inlineAddEthereumChain(e.toString());
    !this._isAuthorized() && !p && await f.requestEthereumAccounts().promise;
    const g = await f.addEthereumChain(e.toString(), r, o, n, i, c).promise;
    return (0, En.isErrorResponse)(g) ? !1 : (((u = g.result) === null || u === void 0 ? void 0 : u.isApproved) === !0 && this.updateProviderInfo(r[0], e), ((l = g.result) === null || l === void 0 ? void 0 : l.isApproved) === !0);
  }
  async switchEthereumChain(e) {
    const n = await (await this.initializeRelay()).switchEthereumChain(e.toString(10), this.selectedAddress || void 0).promise;
    if ((0, En.isErrorResponse)(n)) {
      if (!n.errorCode)
        return;
      throw n.errorCode === xt.standardErrorCodes.provider.unsupportedChain ? xt.standardErrors.provider.unsupportedChain() : xt.standardErrors.provider.custom({
        message: n.errorMessage,
        code: n.errorCode
      });
    }
    const i = n.result;
    i.isApproved && i.rpcUrl.length > 0 && this.updateProviderInfo(i.rpcUrl, e);
  }
  setAppInfo(e, r) {
    this.initializeRelay().then((n) => n.setAppInfo(e, r));
  }
  /** @deprecated Use `.request({ method: 'eth_requestAccounts' })` instead. */
  async enable() {
    var e;
    return (e = this.diagnostic) === null || e === void 0 || e.log(hc.EVENTS.ETH_ACCOUNTS_STATE, {
      method: "provider::enable",
      addresses_length: this._addresses.length,
      sessionIdHash: this._relay ? kl.Session.hash(this._relay.session.id) : void 0
    }), this._isAuthorized() ? [...this._addresses] : await this.send("eth_requestAccounts");
  }
  async close() {
    (await this.initializeRelay()).resetAndReload();
  }
  send(e, r) {
    try {
      const n = this._send(e, r);
      if (n instanceof Promise)
        return n.catch((i) => {
          throw (0, xt.serializeError)(i, e);
        });
    } catch (n) {
      throw (0, xt.serializeError)(n, e);
    }
  }
  _send(e, r) {
    if (typeof e == "string") {
      const i = e, o = Array.isArray(r) ? r : r !== void 0 ? [r] : [], c = {
        jsonrpc: "2.0",
        id: 0,
        method: i,
        params: o
      };
      return this._sendRequestAsync(c).then((u) => u.result);
    }
    if (typeof r == "function") {
      const i = e, o = r;
      return this._sendAsync(i, o);
    }
    if (Array.isArray(e))
      return e.map((o) => this._sendRequest(o));
    const n = e;
    return this._sendRequest(n);
  }
  async sendAsync(e, r) {
    try {
      return this._sendAsync(e, r).catch((n) => {
        throw (0, xt.serializeError)(n, e);
      });
    } catch (n) {
      return Promise.reject((0, xt.serializeError)(n, e));
    }
  }
  async _sendAsync(e, r) {
    if (typeof r != "function")
      throw new Error("callback is required");
    if (Array.isArray(e)) {
      const i = r;
      this._sendMultipleRequestsAsync(e).then((o) => i(null, o)).catch((o) => i(o, null));
      return;
    }
    const n = r;
    return this._sendRequestAsync(e).then((i) => n(null, i)).catch((i) => n(i, null));
  }
  async request(e) {
    try {
      return this._request(e).catch((r) => {
        throw (0, xt.serializeError)(r, e.method);
      });
    } catch (r) {
      return Promise.reject((0, xt.serializeError)(r, e.method));
    }
  }
  async _request(e) {
    if (!e || typeof e != "object" || Array.isArray(e))
      throw xt.standardErrors.rpc.invalidRequest({
        message: "Expected a single, non-array, object argument.",
        data: e
      });
    const { method: r, params: n } = e;
    if (typeof r != "string" || r.length === 0)
      throw xt.standardErrors.rpc.invalidRequest({
        message: "'args.method' must be a non-empty string.",
        data: e
      });
    if (n !== void 0 && !Array.isArray(n) && (typeof n != "object" || n === null))
      throw xt.standardErrors.rpc.invalidRequest({
        message: "'args.params' must be an object or array if provided.",
        data: e
      });
    const i = n === void 0 ? [] : n, o = this._relayEventManager.makeRequestId();
    return (await this._sendRequestAsync({
      method: r,
      params: i,
      jsonrpc: "2.0",
      id: o
    })).result;
  }
  async scanQRCode(e) {
    const n = await (await this.initializeRelay()).scanQRCode((0, pt.ensureRegExpString)(e)).promise;
    if ((0, En.isErrorResponse)(n))
      throw (0, xt.serializeError)(n.errorMessage, "scanQRCode");
    if (typeof n.result != "string")
      throw (0, xt.serializeError)("result was not a string", "scanQRCode");
    return n.result;
  }
  async genericRequest(e, r) {
    const i = await (await this.initializeRelay()).genericRequest(e, r).promise;
    if ((0, En.isErrorResponse)(i))
      throw (0, xt.serializeError)(i.errorMessage, "generic");
    if (typeof i.result != "string")
      throw (0, xt.serializeError)("result was not a string", "generic");
    return i.result;
  }
  /**
   * @beta
   * This method is currently in beta. While it is available for use, please note that it is still under testing and may undergo significant changes.
   *
   * @remarks
   * IMPORTANT: Signature validation is not performed by this method. Users of this method are advised to perform their own signature validation.
   * Common web3 frontend libraries such as ethers.js and viem provide the `verifyMessage` utility function that can be used for signature validation.
   *
   * It combines `eth_requestAccounts` and "Sign-In with Ethereum" (EIP-4361) into a single call.
   * The returned account and signed message can be used to authenticate the user.
   *
   * @param {Object} params - An object with the following properties:
   * - `nonce` {string}: A unique string to prevent replay attacks.
   * - `statement` {string}: An optional human-readable ASCII assertion that the user will sign.
   * - `resources` {string[]}: An optional list of information the user wishes to have resolved as part of authentication by the relying party.
   *
   * @returns {Promise<ConnectAndSignInResponse>} A promise that resolves to an object with the following properties:
   * - `accounts` {string[]}: The Ethereum accounts of the user.
   * - `message` {string}: The overall message that the user signed. Hex encoded.
   * - `signature` {string}: The signature of the message, signed with the user's private key. Hex encoded.
   */
  async connectAndSignIn(e) {
    var r;
    (r = this.diagnostic) === null || r === void 0 || r.log(hc.EVENTS.ETH_ACCOUNTS_STATE, {
      method: "provider::connectAndSignIn",
      sessionIdHash: this._relay ? kl.Session.hash(this._relay.session.id) : void 0
    });
    let n;
    try {
      const o = await this.initializeRelay();
      if (!(o instanceof dL.MobileRelay))
        throw new Error("connectAndSignIn is only supported on mobile");
      if (n = await o.connectAndSignIn(e).promise, (0, En.isErrorResponse)(n))
        throw new Error(n.errorMessage);
    } catch (o) {
      throw typeof o.message == "string" && o.message.match(/(denied|rejected)/i) ? xt.standardErrors.provider.userRejectedRequest("User denied account authorization") : o;
    }
    if (!n.result)
      throw new Error("accounts received is empty");
    const { accounts: i } = n.result;
    return this._setAddresses(i), this.isCoinbaseBrowser || await this.switchEthereumChain(this.getChainId()), n.result;
  }
  async selectProvider(e) {
    const n = await (await this.initializeRelay()).selectProvider(e).promise;
    if ((0, En.isErrorResponse)(n))
      throw (0, xt.serializeError)(n.errorMessage, "selectProvider");
    if (typeof n.result != "string")
      throw (0, xt.serializeError)("result was not a string", "selectProvider");
    return n.result;
  }
  supportsSubscriptions() {
    return !1;
  }
  subscribe() {
    throw new Error("Subscriptions are not supported");
  }
  unsubscribe() {
    throw new Error("Subscriptions are not supported");
  }
  disconnect() {
    return !0;
  }
  _sendRequest(e) {
    const r = {
      jsonrpc: "2.0",
      id: e.id
    }, { method: n } = e;
    if (r.result = this._handleSynchronousMethods(e), r.result === void 0)
      throw new Error(`Coinbase Wallet does not support calling ${n} synchronously without a callback. Please provide a callback parameter to call ${n} asynchronously.`);
    return r;
  }
  _setAddresses(e, r) {
    if (!Array.isArray(e))
      throw new Error("addresses is not an array");
    const n = e.map((i) => (0, pt.ensureAddressString)(i));
    JSON.stringify(n) !== JSON.stringify(this._addresses) && (this._addresses = n, this.emit("accountsChanged", this._addresses), this._storage.setItem(Fy.LOCAL_STORAGE_ADDRESSES_KEY, n.join(" ")));
  }
  _sendRequestAsync(e) {
    return new Promise((r, n) => {
      try {
        const i = this._handleSynchronousMethods(e);
        if (i !== void 0)
          return r({
            jsonrpc: "2.0",
            id: e.id,
            result: i
          });
        const o = this._handleAsynchronousFilterMethods(e);
        if (o !== void 0) {
          o.then((u) => r(Object.assign(Object.assign({}, u), { id: e.id }))).catch((u) => n(u));
          return;
        }
        const c = this._handleSubscriptionMethods(e);
        if (c !== void 0) {
          c.then((u) => r({
            jsonrpc: "2.0",
            id: e.id,
            result: u.result
          })).catch((u) => n(u));
          return;
        }
      } catch (i) {
        return n(i);
      }
      this._handleAsynchronousMethods(e).then((i) => i && r(Object.assign(Object.assign({}, i), { id: e.id }))).catch((i) => n(i));
    });
  }
  _sendMultipleRequestsAsync(e) {
    return Promise.all(e.map((r) => this._sendRequestAsync(r)));
  }
  _handleSynchronousMethods(e) {
    const { method: r } = e, n = e.params || [];
    switch (r) {
      case "eth_accounts":
        return this._eth_accounts();
      case "eth_coinbase":
        return this._eth_coinbase();
      case "eth_uninstallFilter":
        return this._eth_uninstallFilter(n);
      case "net_version":
        return this._net_version();
      case "eth_chainId":
        return this._eth_chainId();
      default:
        return;
    }
  }
  async _handleAsynchronousMethods(e) {
    const { method: r } = e, n = e.params || [];
    switch (r) {
      case "eth_requestAccounts":
        return this._eth_requestAccounts();
      case "eth_sign":
        return this._eth_sign(n);
      case "eth_ecRecover":
        return this._eth_ecRecover(n);
      case "personal_sign":
        return this._personal_sign(n);
      case "personal_ecRecover":
        return this._personal_ecRecover(n);
      case "eth_signTransaction":
        return this._eth_signTransaction(n);
      case "eth_sendRawTransaction":
        return this._eth_sendRawTransaction(n);
      case "eth_sendTransaction":
        return this._eth_sendTransaction(n);
      case "eth_signTypedData_v1":
        return this._eth_signTypedData_v1(n);
      case "eth_signTypedData_v2":
        return this._throwUnsupportedMethodError();
      case "eth_signTypedData_v3":
        return this._eth_signTypedData_v3(n);
      case "eth_signTypedData_v4":
      case "eth_signTypedData":
        return this._eth_signTypedData_v4(n);
      case "cbWallet_arbitrary":
        return this._cbwallet_arbitrary(n);
      case "wallet_addEthereumChain":
        return this._wallet_addEthereumChain(n);
      case "wallet_switchEthereumChain":
        return this._wallet_switchEthereumChain(n);
      case "wallet_watchAsset":
        return this._wallet_watchAsset(n);
    }
    return (await this.initializeRelay()).makeEthereumJSONRPCRequest(e, this.jsonRpcUrl).catch((o) => {
      var c;
      throw (o.code === xt.standardErrorCodes.rpc.methodNotFound || o.code === xt.standardErrorCodes.rpc.methodNotSupported) && ((c = this.diagnostic) === null || c === void 0 || c.log(hc.EVENTS.METHOD_NOT_IMPLEMENTED, {
        method: e.method,
        sessionIdHash: this._relay ? kl.Session.hash(this._relay.session.id) : void 0
      })), o;
    });
  }
  _handleAsynchronousFilterMethods(e) {
    const { method: r } = e, n = e.params || [];
    switch (r) {
      case "eth_newFilter":
        return this._eth_newFilter(n);
      case "eth_newBlockFilter":
        return this._eth_newBlockFilter();
      case "eth_newPendingTransactionFilter":
        return this._eth_newPendingTransactionFilter();
      case "eth_getFilterChanges":
        return this._eth_getFilterChanges(n);
      case "eth_getFilterLogs":
        return this._eth_getFilterLogs(n);
    }
  }
  _handleSubscriptionMethods(e) {
    switch (e.method) {
      case "eth_subscribe":
      case "eth_unsubscribe":
        return this._subscriptionManager.handleRequest(e);
    }
  }
  _isKnownAddress(e) {
    try {
      const r = (0, pt.ensureAddressString)(e);
      return this._addresses.map((i) => (0, pt.ensureAddressString)(i)).includes(r);
    } catch {
    }
    return !1;
  }
  _ensureKnownAddress(e) {
    var r;
    if (!this._isKnownAddress(e))
      throw (r = this.diagnostic) === null || r === void 0 || r.log(hc.EVENTS.UNKNOWN_ADDRESS_ENCOUNTERED), new Error("Unknown Ethereum address");
  }
  _prepareTransactionParams(e) {
    const r = e.from ? (0, pt.ensureAddressString)(e.from) : this.selectedAddress;
    if (!r)
      throw new Error("Ethereum address is unavailable");
    this._ensureKnownAddress(r);
    const n = e.to ? (0, pt.ensureAddressString)(e.to) : null, i = e.value != null ? (0, pt.ensureBN)(e.value) : new hL.default(0), o = e.data ? (0, pt.ensureBuffer)(e.data) : Buffer.alloc(0), c = e.nonce != null ? (0, pt.ensureIntNumber)(e.nonce) : null, u = e.gasPrice != null ? (0, pt.ensureBN)(e.gasPrice) : null, l = e.maxFeePerGas != null ? (0, pt.ensureBN)(e.maxFeePerGas) : null, f = e.maxPriorityFeePerGas != null ? (0, pt.ensureBN)(e.maxPriorityFeePerGas) : null, p = e.gas != null ? (0, pt.ensureBN)(e.gas) : null, g = e.chainId ? (0, pt.ensureIntNumber)(e.chainId) : this.getChainId();
    return {
      fromAddress: r,
      toAddress: n,
      weiValue: i,
      data: o,
      nonce: c,
      gasPriceInWei: u,
      maxFeePerGas: l,
      maxPriorityFeePerGas: f,
      gasLimit: p,
      chainId: g
    };
  }
  _isAuthorized() {
    return this._addresses.length > 0;
  }
  _requireAuthorization() {
    if (!this._isAuthorized())
      throw xt.standardErrors.provider.unauthorized({});
  }
  _throwUnsupportedMethodError() {
    throw xt.standardErrors.provider.unsupportedMethod({});
  }
  async _signEthereumMessage(e, r, n, i) {
    this._ensureKnownAddress(r);
    try {
      const c = await (await this.initializeRelay()).signEthereumMessage(e, r, n, i).promise;
      if ((0, En.isErrorResponse)(c))
        throw new Error(c.errorMessage);
      return { jsonrpc: "2.0", id: 0, result: c.result };
    } catch (o) {
      throw typeof o.message == "string" && o.message.match(/(denied|rejected)/i) ? xt.standardErrors.provider.userRejectedRequest("User denied message signature") : o;
    }
  }
  async _ethereumAddressFromSignedMessage(e, r, n) {
    const o = await (await this.initializeRelay()).ethereumAddressFromSignedMessage(e, r, n).promise;
    if ((0, En.isErrorResponse)(o))
      throw new Error(o.errorMessage);
    return { jsonrpc: "2.0", id: 0, result: o.result };
  }
  _eth_accounts() {
    return [...this._addresses];
  }
  _eth_coinbase() {
    return this.selectedAddress || null;
  }
  _net_version() {
    return this.getChainId().toString(10);
  }
  _eth_chainId() {
    return (0, pt.hexStringFromIntNumber)(this.getChainId());
  }
  getChainId() {
    const e = this._storage.getItem(By);
    if (!e)
      return (0, pt.ensureIntNumber)(this._chainIdFromOpts);
    const r = parseInt(e, 10);
    return (0, pt.ensureIntNumber)(r);
  }
  async _eth_requestAccounts() {
    var e;
    if ((e = this.diagnostic) === null || e === void 0 || e.log(hc.EVENTS.ETH_ACCOUNTS_STATE, {
      method: "provider::_eth_requestAccounts",
      addresses_length: this._addresses.length,
      sessionIdHash: this._relay ? kl.Session.hash(this._relay.session.id) : void 0
    }), this._isAuthorized())
      return Promise.resolve({
        jsonrpc: "2.0",
        id: 0,
        result: this._addresses
      });
    let r;
    try {
      if (r = await (await this.initializeRelay()).requestEthereumAccounts().promise, (0, En.isErrorResponse)(r))
        throw new Error(r.errorMessage);
    } catch (n) {
      throw typeof n.message == "string" && n.message.match(/(denied|rejected)/i) ? xt.standardErrors.provider.userRejectedRequest("User denied account authorization") : n;
    }
    if (!r.result)
      throw new Error("accounts received is empty");
    return this._setAddresses(r.result), this.isCoinbaseBrowser || await this.switchEthereumChain(this.getChainId()), { jsonrpc: "2.0", id: 0, result: this._addresses };
  }
  _eth_sign(e) {
    this._requireAuthorization();
    const r = (0, pt.ensureAddressString)(e[0]), n = (0, pt.ensureBuffer)(e[1]);
    return this._signEthereumMessage(n, r, !1);
  }
  _eth_ecRecover(e) {
    const r = (0, pt.ensureBuffer)(e[0]), n = (0, pt.ensureBuffer)(e[1]);
    return this._ethereumAddressFromSignedMessage(r, n, !1);
  }
  _personal_sign(e) {
    this._requireAuthorization();
    const r = (0, pt.ensureBuffer)(e[0]), n = (0, pt.ensureAddressString)(e[1]);
    return this._signEthereumMessage(r, n, !0);
  }
  _personal_ecRecover(e) {
    const r = (0, pt.ensureBuffer)(e[0]), n = (0, pt.ensureBuffer)(e[1]);
    return this._ethereumAddressFromSignedMessage(r, n, !0);
  }
  async _eth_signTransaction(e) {
    this._requireAuthorization();
    const r = this._prepareTransactionParams(e[0] || {});
    try {
      const i = await (await this.initializeRelay()).signEthereumTransaction(r).promise;
      if ((0, En.isErrorResponse)(i))
        throw new Error(i.errorMessage);
      return { jsonrpc: "2.0", id: 0, result: i.result };
    } catch (n) {
      throw typeof n.message == "string" && n.message.match(/(denied|rejected)/i) ? xt.standardErrors.provider.userRejectedRequest("User denied transaction signature") : n;
    }
  }
  async _eth_sendRawTransaction(e) {
    const r = (0, pt.ensureBuffer)(e[0]), i = await (await this.initializeRelay()).submitEthereumTransaction(r, this.getChainId()).promise;
    if ((0, En.isErrorResponse)(i))
      throw new Error(i.errorMessage);
    return { jsonrpc: "2.0", id: 0, result: i.result };
  }
  async _eth_sendTransaction(e) {
    this._requireAuthorization();
    const r = this._prepareTransactionParams(e[0] || {});
    try {
      const i = await (await this.initializeRelay()).signAndSubmitEthereumTransaction(r).promise;
      if ((0, En.isErrorResponse)(i))
        throw new Error(i.errorMessage);
      return { jsonrpc: "2.0", id: 0, result: i.result };
    } catch (n) {
      throw typeof n.message == "string" && n.message.match(/(denied|rejected)/i) ? xt.standardErrors.provider.userRejectedRequest("User denied transaction signature") : n;
    }
  }
  async _eth_signTypedData_v1(e) {
    this._requireAuthorization();
    const r = (0, pt.ensureParsedJSONObject)(e[0]), n = (0, pt.ensureAddressString)(e[1]);
    this._ensureKnownAddress(n);
    const i = f0.default.hashForSignTypedDataLegacy({ data: r }), o = JSON.stringify(r, null, 2);
    return this._signEthereumMessage(i, n, !1, o);
  }
  async _eth_signTypedData_v3(e) {
    this._requireAuthorization();
    const r = (0, pt.ensureAddressString)(e[0]), n = (0, pt.ensureParsedJSONObject)(e[1]);
    this._ensureKnownAddress(r);
    const i = f0.default.hashForSignTypedData_v3({ data: n }), o = JSON.stringify(n, null, 2);
    return this._signEthereumMessage(i, r, !1, o);
  }
  async _eth_signTypedData_v4(e) {
    this._requireAuthorization();
    const r = (0, pt.ensureAddressString)(e[0]), n = (0, pt.ensureParsedJSONObject)(e[1]);
    this._ensureKnownAddress(r);
    const i = f0.default.hashForSignTypedData_v4({ data: n }), o = JSON.stringify(n, null, 2);
    return this._signEthereumMessage(i, r, !1, o);
  }
  /** @deprecated */
  async _cbwallet_arbitrary(e) {
    const r = e[0], n = e[1];
    if (typeof n != "string")
      throw new Error("parameter must be a string");
    if (typeof r != "object" || r === null)
      throw new Error("parameter must be an object");
    return { jsonrpc: "2.0", id: 0, result: await this.genericRequest(r, n) };
  }
  async _wallet_addEthereumChain(e) {
    var r, n, i, o;
    const c = e[0];
    if (((r = c.rpcUrls) === null || r === void 0 ? void 0 : r.length) === 0)
      return {
        jsonrpc: "2.0",
        id: 0,
        error: { code: 2, message: "please pass in at least 1 rpcUrl" }
      };
    if (!c.chainName || c.chainName.trim() === "")
      throw xt.standardErrors.rpc.invalidParams("chainName is a required field");
    if (!c.nativeCurrency)
      throw xt.standardErrors.rpc.invalidParams("nativeCurrency is a required field");
    const u = parseInt(c.chainId, 16);
    return await this.addEthereumChain(u, (n = c.rpcUrls) !== null && n !== void 0 ? n : [], (i = c.blockExplorerUrls) !== null && i !== void 0 ? i : [], c.chainName, (o = c.iconUrls) !== null && o !== void 0 ? o : [], c.nativeCurrency) ? { jsonrpc: "2.0", id: 0, result: null } : {
      jsonrpc: "2.0",
      id: 0,
      error: { code: 2, message: "unable to add ethereum chain" }
    };
  }
  async _wallet_switchEthereumChain(e) {
    const r = e[0];
    return await this.switchEthereumChain(parseInt(r.chainId, 16)), { jsonrpc: "2.0", id: 0, result: null };
  }
  async _wallet_watchAsset(e) {
    const r = Array.isArray(e) ? e[0] : e;
    if (!r.type)
      throw xt.standardErrors.rpc.invalidParams("Type is required");
    if (r?.type !== "ERC20")
      throw xt.standardErrors.rpc.invalidParams(`Asset of type '${r.type}' is not supported`);
    if (!r?.options)
      throw xt.standardErrors.rpc.invalidParams("Options are required");
    if (!r?.options.address)
      throw xt.standardErrors.rpc.invalidParams("Address is required");
    const n = this.getChainId(), { address: i, symbol: o, image: c, decimals: u } = r.options;
    return { jsonrpc: "2.0", id: 0, result: await this.watchAsset(r.type, i, o, u, c, n) };
  }
  _eth_uninstallFilter(e) {
    const r = (0, pt.ensureHexString)(e[0]);
    return this._filterPolyfill.uninstallFilter(r);
  }
  async _eth_newFilter(e) {
    const r = e[0];
    return { jsonrpc: "2.0", id: 0, result: await this._filterPolyfill.newFilter(r) };
  }
  async _eth_newBlockFilter() {
    return { jsonrpc: "2.0", id: 0, result: await this._filterPolyfill.newBlockFilter() };
  }
  async _eth_newPendingTransactionFilter() {
    return { jsonrpc: "2.0", id: 0, result: await this._filterPolyfill.newPendingTransactionFilter() };
  }
  _eth_getFilterChanges(e) {
    const r = (0, pt.ensureHexString)(e[0]);
    return this._filterPolyfill.getFilterChanges(r);
  }
  _eth_getFilterLogs(e) {
    const r = (0, pt.ensureHexString)(e[0]);
    return this._filterPolyfill.getFilterLogs(r);
  }
  initializeRelay() {
    return this._relay ? Promise.resolve(this._relay) : this._relayProvider().then((e) => (e.setAccountsCallback((r, n) => this._setAddresses(r, n)), e.setChainCallback((r, n) => {
      this.updateProviderInfo(n, parseInt(r, 10));
    }), e.setDappDefaultChainCallback(this._chainIdFromOpts), this._relay = e, e));
  }
}
va.CoinbaseWalletProvider = mL;
var uf = {};
Object.defineProperty(uf, "__esModule", { value: !0 });
uf.RelayEventManager = void 0;
const vL = $e;
class yL {
  constructor() {
    this._nextRequestId = 0, this.callbacks = /* @__PURE__ */ new Map();
  }
  makeRequestId() {
    this._nextRequestId = (this._nextRequestId + 1) % 2147483647;
    const e = this._nextRequestId, r = (0, vL.prepend0x)(e.toString(16));
    return this.callbacks.get(r) && this.callbacks.delete(r), e;
  }
}
uf.RelayEventManager = yL;
Object.defineProperty(Dc, "__esModule", { value: !0 });
Dc.CoinbaseWalletSDK = void 0;
const _L = hh, wL = fh, jy = $e, bL = yh, EL = va, SL = Vc, CL = nu, IL = uf, xL = Yc, RL = Wc, cE = Aa;
class lf {
  /**
   * Constructor
   * @param options Coinbase Wallet SDK constructor options
   */
  constructor(e) {
    var r, n, i;
    this._appName = "", this._appLogoUrl = null, this._relay = null, this._relayEventManager = null;
    const o = e.linkAPIUrl || wL.LINK_API_URL;
    typeof e.overrideIsMetaMask > "u" ? this._overrideIsMetaMask = !1 : this._overrideIsMetaMask = e.overrideIsMetaMask, this._overrideIsCoinbaseWallet = (r = e.overrideIsCoinbaseWallet) !== null && r !== void 0 ? r : !0, this._overrideIsCoinbaseBrowser = (n = e.overrideIsCoinbaseBrowser) !== null && n !== void 0 ? n : !1, this._diagnosticLogger = e.diagnosticLogger, this._reloadOnDisconnect = (i = e.reloadOnDisconnect) !== null && i !== void 0 ? i : !0;
    const c = new URL(o), u = `${c.protocol}//${c.host}`;
    if (this._storage = new bL.ScopedLocalStorage(`-walletlink:${u}`), this._storage.setItem("version", lf.VERSION), this.walletExtension || this.coinbaseBrowser)
      return;
    this._relayEventManager = new IL.RelayEventManager();
    const l = (0, jy.isMobileWeb)(), f = e.uiConstructor || ((g) => l ? new CL.MobileRelayUI(g) : new xL.WalletLinkRelayUI(g)), p = {
      linkAPIUrl: o,
      version: cE.LIB_VERSION,
      darkMode: !!e.darkMode,
      uiConstructor: f,
      storage: this._storage,
      relayEventManager: this._relayEventManager,
      diagnosticLogger: this._diagnosticLogger,
      reloadOnDisconnect: this._reloadOnDisconnect,
      enableMobileWalletLink: e.enableMobileWalletLink
    };
    this._relay = l ? new SL.MobileRelay(p) : new RL.WalletLinkRelay(p), this.setAppInfo(e.appName, e.appLogoUrl), !e.headlessMode && this._relay.attachUI();
  }
  /**
   * Create a Web3 Provider object
   * @param jsonRpcUrl Ethereum JSON RPC URL (Default: "")
   * @param chainId Ethereum Chain ID (Default: 1)
   * @returns A Web3 Provider
   */
  makeWeb3Provider(e = "", r = 1) {
    const n = this.walletExtension;
    if (n)
      return this.isCipherProvider(n) || n.setProviderInfo(e, r), this._reloadOnDisconnect === !1 && typeof n.disableReloadOnDisconnect == "function" && n.disableReloadOnDisconnect(), n;
    const i = this.coinbaseBrowser;
    if (i)
      return i;
    const o = this._relay;
    if (!o || !this._relayEventManager || !this._storage)
      throw new Error("Relay not initialized, should never happen");
    return e || o.setConnectDisabled(!0), new EL.CoinbaseWalletProvider({
      relayProvider: () => Promise.resolve(o),
      relayEventManager: this._relayEventManager,
      storage: this._storage,
      jsonRpcUrl: e,
      chainId: r,
      qrUrl: this.getQrUrl(),
      diagnosticLogger: this._diagnosticLogger,
      overrideIsMetaMask: this._overrideIsMetaMask,
      overrideIsCoinbaseWallet: this._overrideIsCoinbaseWallet,
      overrideIsCoinbaseBrowser: this._overrideIsCoinbaseBrowser
    });
  }
  /**
   * Set application information
   * @param appName Application name
   * @param appLogoUrl Application logo image URL
   */
  setAppInfo(e, r) {
    var n;
    this._appName = e || "DApp", this._appLogoUrl = r || (0, jy.getFavicon)();
    const i = this.walletExtension;
    i ? this.isCipherProvider(i) || i.setAppInfo(this._appName, this._appLogoUrl) : (n = this._relay) === null || n === void 0 || n.setAppInfo(this._appName, this._appLogoUrl);
  }
  /**
   * Disconnect. After disconnecting, this will reload the web page to ensure
   * all potential stale state is cleared.
   */
  disconnect() {
    var e;
    const r = this === null || this === void 0 ? void 0 : this.walletExtension;
    r ? r.close() : (e = this._relay) === null || e === void 0 || e.resetAndReload();
  }
  /**
   * Return QR URL for mobile wallet connection, will return null if extension is installed
   */
  getQrUrl() {
    var e, r;
    return (r = (e = this._relay) === null || e === void 0 ? void 0 : e.getQRCodeUrl()) !== null && r !== void 0 ? r : null;
  }
  /**
   * Official Coinbase Wallet logo for developers to use on their frontend
   * @param type Type of wallet logo: "standard" | "circle" | "text" | "textWithLogo" | "textLight" | "textWithLogoLight"
   * @param width Width of the logo (Optional)
   * @returns SVG Data URI
   */
  getCoinbaseWalletLogo(e, r = 240) {
    return (0, _L.walletLogo)(e, r);
  }
  get walletExtension() {
    var e;
    return (e = window.coinbaseWalletExtension) !== null && e !== void 0 ? e : window.walletLinkExtension;
  }
  get coinbaseBrowser() {
    var e, r;
    try {
      const n = (e = window.ethereum) !== null && e !== void 0 ? e : (r = window.top) === null || r === void 0 ? void 0 : r.ethereum;
      return n && "isCoinbaseBrowser" in n && n.isCoinbaseBrowser ? n : void 0;
    } catch {
      return;
    }
  }
  isCipherProvider(e) {
    return typeof e.isCipher == "boolean" && e.isCipher;
  }
}
Dc.CoinbaseWalletSDK = lf;
lf.VERSION = cE.LIB_VERSION;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.CoinbaseWalletProvider = t.CoinbaseWalletSDK = void 0;
  const e = Dc, r = va;
  var n = Dc;
  Object.defineProperty(t, "CoinbaseWalletSDK", { enumerable: !0, get: function() {
    return n.CoinbaseWalletSDK;
  } });
  var i = va;
  Object.defineProperty(t, "CoinbaseWalletProvider", { enumerable: !0, get: function() {
    return i.CoinbaseWalletProvider;
  } }), t.default = e.CoinbaseWalletSDK, typeof window < "u" && (window.CoinbaseWalletSDK = e.CoinbaseWalletSDK, window.CoinbaseWalletProvider = r.CoinbaseWalletProvider, window.WalletLink = e.CoinbaseWalletSDK, window.WalletLinkProvider = r.CoinbaseWalletProvider);
})(Lw);
mg.type = "coinbaseWallet";
function mg(t) {
  let r, n;
  return yo((i) => ({
    id: "coinbaseWalletSDK",
    name: "Coinbase Wallet",
    type: mg.type,
    async connect({ chainId: o } = {}) {
      try {
        const c = await this.getProvider(), u = (await c.request({
          method: "eth_requestAccounts"
        })).map((f) => es(f));
        c.on("accountsChanged", this.onAccountsChanged), c.on("chainChanged", this.onChainChanged), c.on("disconnect", this.onDisconnect.bind(this));
        let l = await this.getChainId();
        return o && l !== o && (l = (await this.switchChain({ chainId: o }).catch((p) => {
          if (p.code === ho.code)
            throw p;
          return { id: l };
        }))?.id ?? l), { accounts: u, chainId: l };
      } catch (c) {
        throw /(user closed modal|accounts received is empty|user denied account)/i.test(c.message) ? new ho(c) : c;
      }
    },
    async disconnect() {
      const o = await this.getProvider();
      o.removeListener("accountsChanged", this.onAccountsChanged), o.removeListener("chainChanged", this.onChainChanged), o.removeListener("disconnect", this.onDisconnect.bind(this)), o.disconnect(), o.close();
    },
    async getAccounts() {
      return (await (await this.getProvider()).request({
        method: "eth_accounts"
      })).map((c) => es(c));
    },
    async getChainId() {
      const o = await this.getProvider();
      return ma(o.chainId);
    },
    async getProvider() {
      if (!n) {
        r = new Lw.CoinbaseWalletSDK({ reloadOnDisconnect: !1, ...t });
        const o = r.walletExtension?.getChainId(), c = i.chains.find((f) => t.chainId ? f.id === t.chainId : f.id === o) || i.chains[0], u = t.chainId || c?.id, l = t.jsonRpcUrl || c?.rpcUrls.default.http[0];
        n = r.makeWeb3Provider(l, u);
      }
      return n;
    },
    async isAuthorized() {
      try {
        return !!(await this.getAccounts()).length;
      } catch {
        return !1;
      }
    },
    async switchChain({ chainId: o }) {
      const c = i.chains.find((f) => f.id === o);
      if (!c)
        throw new Mc(new Rw());
      const u = await this.getProvider(), l = Yl(c.id);
      try {
        return await u.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: l }]
        }), c;
      } catch (f) {
        if (f.code === 4902)
          try {
            return await u.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: l,
                  chainName: c.name,
                  nativeCurrency: c.nativeCurrency,
                  rpcUrls: [c.rpcUrls.default?.http[0] ?? ""],
                  blockExplorerUrls: [c.blockExplorers?.default.url]
                }
              ]
            }), c;
          } catch (p) {
            throw new ho(p);
          }
        throw new Mc(f);
      }
    },
    onAccountsChanged(o) {
      o.length === 0 ? i.emitter.emit("disconnect") : i.emitter.emit("change", {
        accounts: o.map((c) => es(c))
      });
    },
    onChainChanged(o) {
      const c = ma(o);
      i.emitter.emit("change", { chainId: c });
    },
    async onDisconnect(o) {
      i.emitter.emit("disconnect");
      const c = await this.getProvider();
      c.removeListener("accountsChanged", this.onAccountsChanged), c.removeListener("chainChanged", this.onChainChanged), c.removeListener("disconnect", this.onDisconnect.bind(this));
    }
  }));
}
var vg = {}, hf = {}, ct = {}, uE = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  function e(u, l) {
    var f = u >>> 16 & 65535, p = u & 65535, g = l >>> 16 & 65535, y = l & 65535;
    return p * y + (f * y + p * g << 16 >>> 0) | 0;
  }
  t.mul = Math.imul || e;
  function r(u, l) {
    return u + l | 0;
  }
  t.add = r;
  function n(u, l) {
    return u - l | 0;
  }
  t.sub = n;
  function i(u, l) {
    return u << l | u >>> 32 - l;
  }
  t.rotl = i;
  function o(u, l) {
    return u << 32 - l | u >>> l;
  }
  t.rotr = o;
  function c(u) {
    return typeof u == "number" && isFinite(u) && Math.floor(u) === u;
  }
  t.isInteger = Number.isInteger || c, t.MAX_SAFE_INTEGER = 9007199254740991, t.isSafeInteger = function(u) {
    return t.isInteger(u) && u >= -t.MAX_SAFE_INTEGER && u <= t.MAX_SAFE_INTEGER;
  };
})(uE);
Object.defineProperty(ct, "__esModule", { value: !0 });
var lE = uE;
function AL(t, e) {
  return e === void 0 && (e = 0), (t[e + 0] << 8 | t[e + 1]) << 16 >> 16;
}
ct.readInt16BE = AL;
function ML(t, e) {
  return e === void 0 && (e = 0), (t[e + 0] << 8 | t[e + 1]) >>> 0;
}
ct.readUint16BE = ML;
function DL(t, e) {
  return e === void 0 && (e = 0), (t[e + 1] << 8 | t[e]) << 16 >> 16;
}
ct.readInt16LE = DL;
function OL(t, e) {
  return e === void 0 && (e = 0), (t[e + 1] << 8 | t[e]) >>> 0;
}
ct.readUint16LE = OL;
function hE(t, e, r) {
  return e === void 0 && (e = new Uint8Array(2)), r === void 0 && (r = 0), e[r + 0] = t >>> 8, e[r + 1] = t >>> 0, e;
}
ct.writeUint16BE = hE;
ct.writeInt16BE = hE;
function fE(t, e, r) {
  return e === void 0 && (e = new Uint8Array(2)), r === void 0 && (r = 0), e[r + 0] = t >>> 0, e[r + 1] = t >>> 8, e;
}
ct.writeUint16LE = fE;
ct.writeInt16LE = fE;
function tp(t, e) {
  return e === void 0 && (e = 0), t[e] << 24 | t[e + 1] << 16 | t[e + 2] << 8 | t[e + 3];
}
ct.readInt32BE = tp;
function rp(t, e) {
  return e === void 0 && (e = 0), (t[e] << 24 | t[e + 1] << 16 | t[e + 2] << 8 | t[e + 3]) >>> 0;
}
ct.readUint32BE = rp;
function np(t, e) {
  return e === void 0 && (e = 0), t[e + 3] << 24 | t[e + 2] << 16 | t[e + 1] << 8 | t[e];
}
ct.readInt32LE = np;
function ip(t, e) {
  return e === void 0 && (e = 0), (t[e + 3] << 24 | t[e + 2] << 16 | t[e + 1] << 8 | t[e]) >>> 0;
}
ct.readUint32LE = ip;
function ih(t, e, r) {
  return e === void 0 && (e = new Uint8Array(4)), r === void 0 && (r = 0), e[r + 0] = t >>> 24, e[r + 1] = t >>> 16, e[r + 2] = t >>> 8, e[r + 3] = t >>> 0, e;
}
ct.writeUint32BE = ih;
ct.writeInt32BE = ih;
function sh(t, e, r) {
  return e === void 0 && (e = new Uint8Array(4)), r === void 0 && (r = 0), e[r + 0] = t >>> 0, e[r + 1] = t >>> 8, e[r + 2] = t >>> 16, e[r + 3] = t >>> 24, e;
}
ct.writeUint32LE = sh;
ct.writeInt32LE = sh;
function PL(t, e) {
  e === void 0 && (e = 0);
  var r = tp(t, e), n = tp(t, e + 4);
  return r * 4294967296 + n - (n >> 31) * 4294967296;
}
ct.readInt64BE = PL;
function TL(t, e) {
  e === void 0 && (e = 0);
  var r = rp(t, e), n = rp(t, e + 4);
  return r * 4294967296 + n;
}
ct.readUint64BE = TL;
function NL(t, e) {
  e === void 0 && (e = 0);
  var r = np(t, e), n = np(t, e + 4);
  return n * 4294967296 + r - (r >> 31) * 4294967296;
}
ct.readInt64LE = NL;
function kL(t, e) {
  e === void 0 && (e = 0);
  var r = ip(t, e), n = ip(t, e + 4);
  return n * 4294967296 + r;
}
ct.readUint64LE = kL;
function dE(t, e, r) {
  return e === void 0 && (e = new Uint8Array(8)), r === void 0 && (r = 0), ih(t / 4294967296 >>> 0, e, r), ih(t >>> 0, e, r + 4), e;
}
ct.writeUint64BE = dE;
ct.writeInt64BE = dE;
function pE(t, e, r) {
  return e === void 0 && (e = new Uint8Array(8)), r === void 0 && (r = 0), sh(t >>> 0, e, r), sh(t / 4294967296 >>> 0, e, r + 4), e;
}
ct.writeUint64LE = pE;
ct.writeInt64LE = pE;
function LL(t, e, r) {
  if (r === void 0 && (r = 0), t % 8 !== 0)
    throw new Error("readUintBE supports only bitLengths divisible by 8");
  if (t / 8 > e.length - r)
    throw new Error("readUintBE: array is too short for the given bitLength");
  for (var n = 0, i = 1, o = t / 8 + r - 1; o >= r; o--)
    n += e[o] * i, i *= 256;
  return n;
}
ct.readUintBE = LL;
function $L(t, e, r) {
  if (r === void 0 && (r = 0), t % 8 !== 0)
    throw new Error("readUintLE supports only bitLengths divisible by 8");
  if (t / 8 > e.length - r)
    throw new Error("readUintLE: array is too short for the given bitLength");
  for (var n = 0, i = 1, o = r; o < r + t / 8; o++)
    n += e[o] * i, i *= 256;
  return n;
}
ct.readUintLE = $L;
function FL(t, e, r, n) {
  if (r === void 0 && (r = new Uint8Array(t / 8)), n === void 0 && (n = 0), t % 8 !== 0)
    throw new Error("writeUintBE supports only bitLengths divisible by 8");
  if (!lE.isSafeInteger(e))
    throw new Error("writeUintBE value must be an integer");
  for (var i = 1, o = t / 8 + n - 1; o >= n; o--)
    r[o] = e / i & 255, i *= 256;
  return r;
}
ct.writeUintBE = FL;
function BL(t, e, r, n) {
  if (r === void 0 && (r = new Uint8Array(t / 8)), n === void 0 && (n = 0), t % 8 !== 0)
    throw new Error("writeUintLE supports only bitLengths divisible by 8");
  if (!lE.isSafeInteger(e))
    throw new Error("writeUintLE value must be an integer");
  for (var i = 1, o = n; o < n + t / 8; o++)
    r[o] = e / i & 255, i *= 256;
  return r;
}
ct.writeUintLE = BL;
function UL(t, e) {
  e === void 0 && (e = 0);
  var r = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return r.getFloat32(e);
}
ct.readFloat32BE = UL;
function jL(t, e) {
  e === void 0 && (e = 0);
  var r = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return r.getFloat32(e, !0);
}
ct.readFloat32LE = jL;
function HL(t, e) {
  e === void 0 && (e = 0);
  var r = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return r.getFloat64(e);
}
ct.readFloat64BE = HL;
function qL(t, e) {
  e === void 0 && (e = 0);
  var r = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return r.getFloat64(e, !0);
}
ct.readFloat64LE = qL;
function zL(t, e, r) {
  e === void 0 && (e = new Uint8Array(4)), r === void 0 && (r = 0);
  var n = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return n.setFloat32(r, t), e;
}
ct.writeFloat32BE = zL;
function VL(t, e, r) {
  e === void 0 && (e = new Uint8Array(4)), r === void 0 && (r = 0);
  var n = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return n.setFloat32(r, t, !0), e;
}
ct.writeFloat32LE = VL;
function WL(t, e, r) {
  e === void 0 && (e = new Uint8Array(8)), r === void 0 && (r = 0);
  var n = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return n.setFloat64(r, t), e;
}
ct.writeFloat64BE = WL;
function KL(t, e, r) {
  e === void 0 && (e = new Uint8Array(8)), r === void 0 && (r = 0);
  var n = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return n.setFloat64(r, t, !0), e;
}
ct.writeFloat64LE = KL;
var xn = {};
Object.defineProperty(xn, "__esModule", { value: !0 });
function GL(t) {
  for (var e = 0; e < t.length; e++)
    t[e] = 0;
  return t;
}
xn.wipe = GL;
Object.defineProperty(hf, "__esModule", { value: !0 });
var Ur = ct, sp = xn, JL = 20;
function QL(t, e, r) {
  for (var n = 1634760805, i = 857760878, o = 2036477234, c = 1797285236, u = r[3] << 24 | r[2] << 16 | r[1] << 8 | r[0], l = r[7] << 24 | r[6] << 16 | r[5] << 8 | r[4], f = r[11] << 24 | r[10] << 16 | r[9] << 8 | r[8], p = r[15] << 24 | r[14] << 16 | r[13] << 8 | r[12], g = r[19] << 24 | r[18] << 16 | r[17] << 8 | r[16], y = r[23] << 24 | r[22] << 16 | r[21] << 8 | r[20], C = r[27] << 24 | r[26] << 16 | r[25] << 8 | r[24], R = r[31] << 24 | r[30] << 16 | r[29] << 8 | r[28], J = e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0], G = e[7] << 24 | e[6] << 16 | e[5] << 8 | e[4], H = e[11] << 24 | e[10] << 16 | e[9] << 8 | e[8], T = e[15] << 24 | e[14] << 16 | e[13] << 8 | e[12], q = n, B = i, L = o, P = c, v = u, N = l, ie = f, le = p, he = g, ye = y, k = C, h = R, m = J, x = G, M = H, A = T, $ = 0; $ < JL; $ += 2)
    q = q + v | 0, m ^= q, m = m >>> 16 | m << 16, he = he + m | 0, v ^= he, v = v >>> 20 | v << 12, B = B + N | 0, x ^= B, x = x >>> 16 | x << 16, ye = ye + x | 0, N ^= ye, N = N >>> 20 | N << 12, L = L + ie | 0, M ^= L, M = M >>> 16 | M << 16, k = k + M | 0, ie ^= k, ie = ie >>> 20 | ie << 12, P = P + le | 0, A ^= P, A = A >>> 16 | A << 16, h = h + A | 0, le ^= h, le = le >>> 20 | le << 12, L = L + ie | 0, M ^= L, M = M >>> 24 | M << 8, k = k + M | 0, ie ^= k, ie = ie >>> 25 | ie << 7, P = P + le | 0, A ^= P, A = A >>> 24 | A << 8, h = h + A | 0, le ^= h, le = le >>> 25 | le << 7, B = B + N | 0, x ^= B, x = x >>> 24 | x << 8, ye = ye + x | 0, N ^= ye, N = N >>> 25 | N << 7, q = q + v | 0, m ^= q, m = m >>> 24 | m << 8, he = he + m | 0, v ^= he, v = v >>> 25 | v << 7, q = q + N | 0, A ^= q, A = A >>> 16 | A << 16, k = k + A | 0, N ^= k, N = N >>> 20 | N << 12, B = B + ie | 0, m ^= B, m = m >>> 16 | m << 16, h = h + m | 0, ie ^= h, ie = ie >>> 20 | ie << 12, L = L + le | 0, x ^= L, x = x >>> 16 | x << 16, he = he + x | 0, le ^= he, le = le >>> 20 | le << 12, P = P + v | 0, M ^= P, M = M >>> 16 | M << 16, ye = ye + M | 0, v ^= ye, v = v >>> 20 | v << 12, L = L + le | 0, x ^= L, x = x >>> 24 | x << 8, he = he + x | 0, le ^= he, le = le >>> 25 | le << 7, P = P + v | 0, M ^= P, M = M >>> 24 | M << 8, ye = ye + M | 0, v ^= ye, v = v >>> 25 | v << 7, B = B + ie | 0, m ^= B, m = m >>> 24 | m << 8, h = h + m | 0, ie ^= h, ie = ie >>> 25 | ie << 7, q = q + N | 0, A ^= q, A = A >>> 24 | A << 8, k = k + A | 0, N ^= k, N = N >>> 25 | N << 7;
  Ur.writeUint32LE(q + n | 0, t, 0), Ur.writeUint32LE(B + i | 0, t, 4), Ur.writeUint32LE(L + o | 0, t, 8), Ur.writeUint32LE(P + c | 0, t, 12), Ur.writeUint32LE(v + u | 0, t, 16), Ur.writeUint32LE(N + l | 0, t, 20), Ur.writeUint32LE(ie + f | 0, t, 24), Ur.writeUint32LE(le + p | 0, t, 28), Ur.writeUint32LE(he + g | 0, t, 32), Ur.writeUint32LE(ye + y | 0, t, 36), Ur.writeUint32LE(k + C | 0, t, 40), Ur.writeUint32LE(h + R | 0, t, 44), Ur.writeUint32LE(m + J | 0, t, 48), Ur.writeUint32LE(x + G | 0, t, 52), Ur.writeUint32LE(M + H | 0, t, 56), Ur.writeUint32LE(A + T | 0, t, 60);
}
function gE(t, e, r, n, i) {
  if (i === void 0 && (i = 0), t.length !== 32)
    throw new Error("ChaCha: key size must be 32 bytes");
  if (n.length < r.length)
    throw new Error("ChaCha: destination is shorter than source");
  var o, c;
  if (i === 0) {
    if (e.length !== 8 && e.length !== 12)
      throw new Error("ChaCha nonce must be 8 or 12 bytes");
    o = new Uint8Array(16), c = o.length - e.length, o.set(e, c);
  } else {
    if (e.length !== 16)
      throw new Error("ChaCha nonce with counter must be 16 bytes");
    o = e, c = i;
  }
  for (var u = new Uint8Array(64), l = 0; l < r.length; l += 64) {
    QL(u, o, t);
    for (var f = l; f < l + 64 && f < r.length; f++)
      n[f] = r[f] ^ u[f - l];
    YL(o, 0, c);
  }
  return sp.wipe(u), i === 0 && sp.wipe(o), n;
}
hf.streamXOR = gE;
function ZL(t, e, r, n) {
  return n === void 0 && (n = 0), sp.wipe(r), gE(t, e, r, r, n);
}
hf.stream = ZL;
function YL(t, e, r) {
  for (var n = 1; r--; )
    n = n + (t[e] & 255) | 0, t[e] = n & 255, n >>>= 8, e++;
  if (n > 0)
    throw new Error("ChaCha: counter overflow");
}
var mE = {}, Ms = {};
Object.defineProperty(Ms, "__esModule", { value: !0 });
function XL(t, e, r) {
  return ~(t - 1) & e | t - 1 & r;
}
Ms.select = XL;
function e9(t, e) {
  return (t | 0) - (e | 0) - 1 >>> 31 & 1;
}
Ms.lessOrEqual = e9;
function vE(t, e) {
  if (t.length !== e.length)
    return 0;
  for (var r = 0, n = 0; n < t.length; n++)
    r |= t[n] ^ e[n];
  return 1 & r - 1 >>> 8;
}
Ms.compare = vE;
function t9(t, e) {
  return t.length === 0 || e.length === 0 ? !1 : vE(t, e) !== 0;
}
Ms.equal = t9;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = Ms, r = xn;
  t.DIGEST_LENGTH = 16;
  var n = (
    /** @class */
    function() {
      function c(u) {
        this.digestLength = t.DIGEST_LENGTH, this._buffer = new Uint8Array(16), this._r = new Uint16Array(10), this._h = new Uint16Array(10), this._pad = new Uint16Array(8), this._leftover = 0, this._fin = 0, this._finished = !1;
        var l = u[0] | u[1] << 8;
        this._r[0] = l & 8191;
        var f = u[2] | u[3] << 8;
        this._r[1] = (l >>> 13 | f << 3) & 8191;
        var p = u[4] | u[5] << 8;
        this._r[2] = (f >>> 10 | p << 6) & 7939;
        var g = u[6] | u[7] << 8;
        this._r[3] = (p >>> 7 | g << 9) & 8191;
        var y = u[8] | u[9] << 8;
        this._r[4] = (g >>> 4 | y << 12) & 255, this._r[5] = y >>> 1 & 8190;
        var C = u[10] | u[11] << 8;
        this._r[6] = (y >>> 14 | C << 2) & 8191;
        var R = u[12] | u[13] << 8;
        this._r[7] = (C >>> 11 | R << 5) & 8065;
        var J = u[14] | u[15] << 8;
        this._r[8] = (R >>> 8 | J << 8) & 8191, this._r[9] = J >>> 5 & 127, this._pad[0] = u[16] | u[17] << 8, this._pad[1] = u[18] | u[19] << 8, this._pad[2] = u[20] | u[21] << 8, this._pad[3] = u[22] | u[23] << 8, this._pad[4] = u[24] | u[25] << 8, this._pad[5] = u[26] | u[27] << 8, this._pad[6] = u[28] | u[29] << 8, this._pad[7] = u[30] | u[31] << 8;
      }
      return c.prototype._blocks = function(u, l, f) {
        for (var p = this._fin ? 0 : 2048, g = this._h[0], y = this._h[1], C = this._h[2], R = this._h[3], J = this._h[4], G = this._h[5], H = this._h[6], T = this._h[7], q = this._h[8], B = this._h[9], L = this._r[0], P = this._r[1], v = this._r[2], N = this._r[3], ie = this._r[4], le = this._r[5], he = this._r[6], ye = this._r[7], k = this._r[8], h = this._r[9]; f >= 16; ) {
          var m = u[l + 0] | u[l + 1] << 8;
          g += m & 8191;
          var x = u[l + 2] | u[l + 3] << 8;
          y += (m >>> 13 | x << 3) & 8191;
          var M = u[l + 4] | u[l + 5] << 8;
          C += (x >>> 10 | M << 6) & 8191;
          var A = u[l + 6] | u[l + 7] << 8;
          R += (M >>> 7 | A << 9) & 8191;
          var $ = u[l + 8] | u[l + 9] << 8;
          J += (A >>> 4 | $ << 12) & 8191, G += $ >>> 1 & 8191;
          var K = u[l + 10] | u[l + 11] << 8;
          H += ($ >>> 14 | K << 2) & 8191;
          var D = u[l + 12] | u[l + 13] << 8;
          T += (K >>> 11 | D << 5) & 8191;
          var w = u[l + 14] | u[l + 15] << 8;
          q += (D >>> 8 | w << 8) & 8191, B += w >>> 5 | p;
          var U = 0, me = U;
          me += g * L, me += y * (5 * h), me += C * (5 * k), me += R * (5 * ye), me += J * (5 * he), U = me >>> 13, me &= 8191, me += G * (5 * le), me += H * (5 * ie), me += T * (5 * N), me += q * (5 * v), me += B * (5 * P), U += me >>> 13, me &= 8191;
          var pe = U;
          pe += g * P, pe += y * L, pe += C * (5 * h), pe += R * (5 * k), pe += J * (5 * ye), U = pe >>> 13, pe &= 8191, pe += G * (5 * he), pe += H * (5 * le), pe += T * (5 * ie), pe += q * (5 * N), pe += B * (5 * v), U += pe >>> 13, pe &= 8191;
          var ee = U;
          ee += g * v, ee += y * P, ee += C * L, ee += R * (5 * h), ee += J * (5 * k), U = ee >>> 13, ee &= 8191, ee += G * (5 * ye), ee += H * (5 * he), ee += T * (5 * le), ee += q * (5 * ie), ee += B * (5 * N), U += ee >>> 13, ee &= 8191;
          var V = U;
          V += g * N, V += y * v, V += C * P, V += R * L, V += J * (5 * h), U = V >>> 13, V &= 8191, V += G * (5 * k), V += H * (5 * ye), V += T * (5 * he), V += q * (5 * le), V += B * (5 * ie), U += V >>> 13, V &= 8191;
          var Q = U;
          Q += g * ie, Q += y * N, Q += C * v, Q += R * P, Q += J * L, U = Q >>> 13, Q &= 8191, Q += G * (5 * h), Q += H * (5 * k), Q += T * (5 * ye), Q += q * (5 * he), Q += B * (5 * le), U += Q >>> 13, Q &= 8191;
          var X = U;
          X += g * le, X += y * ie, X += C * N, X += R * v, X += J * P, U = X >>> 13, X &= 8191, X += G * L, X += H * (5 * h), X += T * (5 * k), X += q * (5 * ye), X += B * (5 * he), U += X >>> 13, X &= 8191;
          var E = U;
          E += g * he, E += y * le, E += C * ie, E += R * N, E += J * v, U = E >>> 13, E &= 8191, E += G * P, E += H * L, E += T * (5 * h), E += q * (5 * k), E += B * (5 * ye), U += E >>> 13, E &= 8191;
          var I = U;
          I += g * ye, I += y * he, I += C * le, I += R * ie, I += J * N, U = I >>> 13, I &= 8191, I += G * v, I += H * P, I += T * L, I += q * (5 * h), I += B * (5 * k), U += I >>> 13, I &= 8191;
          var F = U;
          F += g * k, F += y * ye, F += C * he, F += R * le, F += J * ie, U = F >>> 13, F &= 8191, F += G * N, F += H * v, F += T * P, F += q * L, F += B * (5 * h), U += F >>> 13, F &= 8191;
          var se = U;
          se += g * h, se += y * k, se += C * ye, se += R * he, se += J * le, U = se >>> 13, se &= 8191, se += G * ie, se += H * N, se += T * v, se += q * P, se += B * L, U += se >>> 13, se &= 8191, U = (U << 2) + U | 0, U = U + me | 0, me = U & 8191, U = U >>> 13, pe += U, g = me, y = pe, C = ee, R = V, J = Q, G = X, H = E, T = I, q = F, B = se, l += 16, f -= 16;
        }
        this._h[0] = g, this._h[1] = y, this._h[2] = C, this._h[3] = R, this._h[4] = J, this._h[5] = G, this._h[6] = H, this._h[7] = T, this._h[8] = q, this._h[9] = B;
      }, c.prototype.finish = function(u, l) {
        l === void 0 && (l = 0);
        var f = new Uint16Array(10), p, g, y, C;
        if (this._leftover) {
          for (C = this._leftover, this._buffer[C++] = 1; C < 16; C++)
            this._buffer[C] = 0;
          this._fin = 1, this._blocks(this._buffer, 0, 16);
        }
        for (p = this._h[1] >>> 13, this._h[1] &= 8191, C = 2; C < 10; C++)
          this._h[C] += p, p = this._h[C] >>> 13, this._h[C] &= 8191;
        for (this._h[0] += p * 5, p = this._h[0] >>> 13, this._h[0] &= 8191, this._h[1] += p, p = this._h[1] >>> 13, this._h[1] &= 8191, this._h[2] += p, f[0] = this._h[0] + 5, p = f[0] >>> 13, f[0] &= 8191, C = 1; C < 10; C++)
          f[C] = this._h[C] + p, p = f[C] >>> 13, f[C] &= 8191;
        for (f[9] -= 8192, g = (p ^ 1) - 1, C = 0; C < 10; C++)
          f[C] &= g;
        for (g = ~g, C = 0; C < 10; C++)
          this._h[C] = this._h[C] & g | f[C];
        for (this._h[0] = (this._h[0] | this._h[1] << 13) & 65535, this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 65535, this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 65535, this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 65535, this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 65535, this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 65535, this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 65535, this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 65535, y = this._h[0] + this._pad[0], this._h[0] = y & 65535, C = 1; C < 8; C++)
          y = (this._h[C] + this._pad[C] | 0) + (y >>> 16) | 0, this._h[C] = y & 65535;
        return u[l + 0] = this._h[0] >>> 0, u[l + 1] = this._h[0] >>> 8, u[l + 2] = this._h[1] >>> 0, u[l + 3] = this._h[1] >>> 8, u[l + 4] = this._h[2] >>> 0, u[l + 5] = this._h[2] >>> 8, u[l + 6] = this._h[3] >>> 0, u[l + 7] = this._h[3] >>> 8, u[l + 8] = this._h[4] >>> 0, u[l + 9] = this._h[4] >>> 8, u[l + 10] = this._h[5] >>> 0, u[l + 11] = this._h[5] >>> 8, u[l + 12] = this._h[6] >>> 0, u[l + 13] = this._h[6] >>> 8, u[l + 14] = this._h[7] >>> 0, u[l + 15] = this._h[7] >>> 8, this._finished = !0, this;
      }, c.prototype.update = function(u) {
        var l = 0, f = u.length, p;
        if (this._leftover) {
          p = 16 - this._leftover, p > f && (p = f);
          for (var g = 0; g < p; g++)
            this._buffer[this._leftover + g] = u[l + g];
          if (f -= p, l += p, this._leftover += p, this._leftover < 16)
            return this;
          this._blocks(this._buffer, 0, 16), this._leftover = 0;
        }
        if (f >= 16 && (p = f - f % 16, this._blocks(u, l, p), l += p, f -= p), f) {
          for (var g = 0; g < f; g++)
            this._buffer[this._leftover + g] = u[l + g];
          this._leftover += f;
        }
        return this;
      }, c.prototype.digest = function() {
        if (this._finished)
          throw new Error("Poly1305 was finished");
        var u = new Uint8Array(16);
        return this.finish(u), u;
      }, c.prototype.clean = function() {
        return r.wipe(this._buffer), r.wipe(this._r), r.wipe(this._h), r.wipe(this._pad), this._leftover = 0, this._fin = 0, this._finished = !0, this;
      }, c;
    }()
  );
  t.Poly1305 = n;
  function i(c, u) {
    var l = new n(c);
    l.update(u);
    var f = l.digest();
    return l.clean(), f;
  }
  t.oneTimeAuth = i;
  function o(c, u) {
    return c.length !== t.DIGEST_LENGTH || u.length !== t.DIGEST_LENGTH ? !1 : e.equal(c, u);
  }
  t.equal = o;
})(mE);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = hf, r = mE, n = xn, i = ct, o = Ms;
  t.KEY_LENGTH = 32, t.NONCE_LENGTH = 12, t.TAG_LENGTH = 16;
  var c = new Uint8Array(16), u = (
    /** @class */
    function() {
      function l(f) {
        if (this.nonceLength = t.NONCE_LENGTH, this.tagLength = t.TAG_LENGTH, f.length !== t.KEY_LENGTH)
          throw new Error("ChaCha20Poly1305 needs 32-byte key");
        this._key = new Uint8Array(f);
      }
      return l.prototype.seal = function(f, p, g, y) {
        if (f.length > 16)
          throw new Error("ChaCha20Poly1305: incorrect nonce length");
        var C = new Uint8Array(16);
        C.set(f, C.length - f.length);
        var R = new Uint8Array(32);
        e.stream(this._key, C, R, 4);
        var J = p.length + this.tagLength, G;
        if (y) {
          if (y.length !== J)
            throw new Error("ChaCha20Poly1305: incorrect destination length");
          G = y;
        } else
          G = new Uint8Array(J);
        return e.streamXOR(this._key, C, p, G, 4), this._authenticate(G.subarray(G.length - this.tagLength, G.length), R, G.subarray(0, G.length - this.tagLength), g), n.wipe(C), G;
      }, l.prototype.open = function(f, p, g, y) {
        if (f.length > 16)
          throw new Error("ChaCha20Poly1305: incorrect nonce length");
        if (p.length < this.tagLength)
          return null;
        var C = new Uint8Array(16);
        C.set(f, C.length - f.length);
        var R = new Uint8Array(32);
        e.stream(this._key, C, R, 4);
        var J = new Uint8Array(this.tagLength);
        if (this._authenticate(J, R, p.subarray(0, p.length - this.tagLength), g), !o.equal(J, p.subarray(p.length - this.tagLength, p.length)))
          return null;
        var G = p.length - this.tagLength, H;
        if (y) {
          if (y.length !== G)
            throw new Error("ChaCha20Poly1305: incorrect destination length");
          H = y;
        } else
          H = new Uint8Array(G);
        return e.streamXOR(this._key, C, p.subarray(0, p.length - this.tagLength), H, 4), n.wipe(C), H;
      }, l.prototype.clean = function() {
        return n.wipe(this._key), this;
      }, l.prototype._authenticate = function(f, p, g, y) {
        var C = new r.Poly1305(p);
        y && (C.update(y), y.length % 16 > 0 && C.update(c.subarray(y.length % 16))), C.update(g), g.length % 16 > 0 && C.update(c.subarray(g.length % 16));
        var R = new Uint8Array(8);
        y && i.writeUint64LE(y.length, R), C.update(R), i.writeUint64LE(g.length, R), C.update(R);
        for (var J = C.digest(), G = 0; G < J.length; G++)
          f[G] = J[G];
        C.clean(), n.wipe(J), n.wipe(R);
      }, l;
    }()
  );
  t.ChaCha20Poly1305 = u;
})(vg);
var yE = {}, pu = {}, yg = {};
Object.defineProperty(yg, "__esModule", { value: !0 });
function r9(t) {
  return typeof t.saveState < "u" && typeof t.restoreState < "u" && typeof t.cleanSavedState < "u";
}
yg.isSerializableHash = r9;
Object.defineProperty(pu, "__esModule", { value: !0 });
var Ei = yg, n9 = Ms, i9 = xn, _E = (
  /** @class */
  function() {
    function t(e, r) {
      this._finished = !1, this._inner = new e(), this._outer = new e(), this.blockSize = this._outer.blockSize, this.digestLength = this._outer.digestLength;
      var n = new Uint8Array(this.blockSize);
      r.length > this.blockSize ? this._inner.update(r).finish(n).clean() : n.set(r);
      for (var i = 0; i < n.length; i++)
        n[i] ^= 54;
      this._inner.update(n);
      for (var i = 0; i < n.length; i++)
        n[i] ^= 106;
      this._outer.update(n), Ei.isSerializableHash(this._inner) && Ei.isSerializableHash(this._outer) && (this._innerKeyedState = this._inner.saveState(), this._outerKeyedState = this._outer.saveState()), i9.wipe(n);
    }
    return t.prototype.reset = function() {
      if (!Ei.isSerializableHash(this._inner) || !Ei.isSerializableHash(this._outer))
        throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
      return this._inner.restoreState(this._innerKeyedState), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
    }, t.prototype.clean = function() {
      Ei.isSerializableHash(this._inner) && this._inner.cleanSavedState(this._innerKeyedState), Ei.isSerializableHash(this._outer) && this._outer.cleanSavedState(this._outerKeyedState), this._inner.clean(), this._outer.clean();
    }, t.prototype.update = function(e) {
      return this._inner.update(e), this;
    }, t.prototype.finish = function(e) {
      return this._finished ? (this._outer.finish(e), this) : (this._inner.finish(e), this._outer.update(e.subarray(0, this.digestLength)).finish(e), this._finished = !0, this);
    }, t.prototype.digest = function() {
      var e = new Uint8Array(this.digestLength);
      return this.finish(e), e;
    }, t.prototype.saveState = function() {
      if (!Ei.isSerializableHash(this._inner))
        throw new Error("hmac: can't saveState() because hash doesn't implement it");
      return this._inner.saveState();
    }, t.prototype.restoreState = function(e) {
      if (!Ei.isSerializableHash(this._inner) || !Ei.isSerializableHash(this._outer))
        throw new Error("hmac: can't restoreState() because hash doesn't implement it");
      return this._inner.restoreState(e), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
    }, t.prototype.cleanSavedState = function(e) {
      if (!Ei.isSerializableHash(this._inner))
        throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
      this._inner.cleanSavedState(e);
    }, t;
  }()
);
pu.HMAC = _E;
function s9(t, e, r) {
  var n = new _E(t, e);
  n.update(r);
  var i = n.digest();
  return n.clean(), i;
}
pu.hmac = s9;
pu.equal = n9.equal;
Object.defineProperty(yE, "__esModule", { value: !0 });
var Hy = pu, qy = xn, o9 = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      n === void 0 && (n = new Uint8Array(0)), this._counter = new Uint8Array(1), this._hash = e, this._info = i;
      var o = Hy.hmac(this._hash, n, r);
      this._hmac = new Hy.HMAC(e, o), this._buffer = new Uint8Array(this._hmac.digestLength), this._bufpos = this._buffer.length;
    }
    return t.prototype._fillBuffer = function() {
      this._counter[0]++;
      var e = this._counter[0];
      if (e === 0)
        throw new Error("hkdf: cannot expand more");
      this._hmac.reset(), e > 1 && this._hmac.update(this._buffer), this._info && this._hmac.update(this._info), this._hmac.update(this._counter), this._hmac.finish(this._buffer), this._bufpos = 0;
    }, t.prototype.expand = function(e) {
      for (var r = new Uint8Array(e), n = 0; n < r.length; n++)
        this._bufpos === this._buffer.length && this._fillBuffer(), r[n] = this._buffer[this._bufpos++];
      return r;
    }, t.prototype.clean = function() {
      this._hmac.clean(), qy.wipe(this._buffer), qy.wipe(this._counter), this._bufpos = 0;
    }, t;
  }()
), a9 = yE.HKDF = o9, La = {}, ff = {}, df = {};
Object.defineProperty(df, "__esModule", { value: !0 });
df.BrowserRandomSource = void 0;
const zy = 65536;
class c9 {
  constructor() {
    this.isAvailable = !1, this.isInstantiated = !1;
    const e = typeof self < "u" ? self.crypto || self.msCrypto : null;
    e && e.getRandomValues !== void 0 && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Browser random byte generator is not available.");
    const r = new Uint8Array(e);
    for (let n = 0; n < r.length; n += zy)
      this._crypto.getRandomValues(r.subarray(n, n + Math.min(r.length - n, zy)));
    return r;
  }
}
df.BrowserRandomSource = c9;
function u9(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pf = {};
Object.defineProperty(pf, "__esModule", { value: !0 });
pf.NodeRandomSource = void 0;
const l9 = xn;
class h9 {
  constructor() {
    if (this.isAvailable = !1, this.isInstantiated = !1, typeof u9 < "u") {
      const e = dh;
      e && e.randomBytes && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
    }
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Node.js random byte generator is not available.");
    let r = this._crypto.randomBytes(e);
    if (r.length !== e)
      throw new Error("NodeRandomSource: got fewer bytes than requested");
    const n = new Uint8Array(e);
    for (let i = 0; i < n.length; i++)
      n[i] = r[i];
    return (0, l9.wipe)(r), n;
  }
}
pf.NodeRandomSource = h9;
Object.defineProperty(ff, "__esModule", { value: !0 });
ff.SystemRandomSource = void 0;
const f9 = df, d9 = pf;
class p9 {
  constructor() {
    if (this.isAvailable = !1, this.name = "", this._source = new f9.BrowserRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Browser";
      return;
    }
    if (this._source = new d9.NodeRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Node";
      return;
    }
  }
  randomBytes(e) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    return this._source.randomBytes(e);
  }
}
ff.SystemRandomSource = p9;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.randomStringForEntropy = t.randomString = t.randomUint32 = t.randomBytes = t.defaultRandomSource = void 0;
  const e = ff, r = ct, n = xn;
  t.defaultRandomSource = new e.SystemRandomSource();
  function i(f, p = t.defaultRandomSource) {
    return p.randomBytes(f);
  }
  t.randomBytes = i;
  function o(f = t.defaultRandomSource) {
    const p = i(4, f), g = (0, r.readUint32LE)(p);
    return (0, n.wipe)(p), g;
  }
  t.randomUint32 = o;
  const c = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  function u(f, p = c, g = t.defaultRandomSource) {
    if (p.length < 2)
      throw new Error("randomString charset is too short");
    if (p.length > 256)
      throw new Error("randomString charset is too long");
    let y = "";
    const C = p.length, R = 256 - 256 % C;
    for (; f > 0; ) {
      const J = i(Math.ceil(f * 256 / R), g);
      for (let G = 0; G < J.length && f > 0; G++) {
        const H = J[G];
        H < R && (y += p.charAt(H % C), f--);
      }
      (0, n.wipe)(J);
    }
    return y;
  }
  t.randomString = u;
  function l(f, p = c, g = t.defaultRandomSource) {
    const y = Math.ceil(f / (Math.log(p.length) / Math.LN2));
    return u(y, p, g);
  }
  t.randomStringForEntropy = l;
})(La);
var gf = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = ct, r = xn;
  t.DIGEST_LENGTH = 32, t.BLOCK_SIZE = 64;
  var n = (
    /** @class */
    function() {
      function u() {
        this.digestLength = t.DIGEST_LENGTH, this.blockSize = t.BLOCK_SIZE, this._state = new Int32Array(8), this._temp = new Int32Array(64), this._buffer = new Uint8Array(128), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
      }
      return u.prototype._initState = function() {
        this._state[0] = 1779033703, this._state[1] = 3144134277, this._state[2] = 1013904242, this._state[3] = 2773480762, this._state[4] = 1359893119, this._state[5] = 2600822924, this._state[6] = 528734635, this._state[7] = 1541459225;
      }, u.prototype.reset = function() {
        return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
      }, u.prototype.clean = function() {
        r.wipe(this._buffer), r.wipe(this._temp), this.reset();
      }, u.prototype.update = function(l, f) {
        if (f === void 0 && (f = l.length), this._finished)
          throw new Error("SHA256: can't update because hash was finished.");
        var p = 0;
        if (this._bytesHashed += f, this._bufferLength > 0) {
          for (; this._bufferLength < this.blockSize && f > 0; )
            this._buffer[this._bufferLength++] = l[p++], f--;
          this._bufferLength === this.blockSize && (o(this._temp, this._state, this._buffer, 0, this.blockSize), this._bufferLength = 0);
        }
        for (f >= this.blockSize && (p = o(this._temp, this._state, l, p, f), f %= this.blockSize); f > 0; )
          this._buffer[this._bufferLength++] = l[p++], f--;
        return this;
      }, u.prototype.finish = function(l) {
        if (!this._finished) {
          var f = this._bytesHashed, p = this._bufferLength, g = f / 536870912 | 0, y = f << 3, C = f % 64 < 56 ? 64 : 128;
          this._buffer[p] = 128;
          for (var R = p + 1; R < C - 8; R++)
            this._buffer[R] = 0;
          e.writeUint32BE(g, this._buffer, C - 8), e.writeUint32BE(y, this._buffer, C - 4), o(this._temp, this._state, this._buffer, 0, C), this._finished = !0;
        }
        for (var R = 0; R < this.digestLength / 4; R++)
          e.writeUint32BE(this._state[R], l, R * 4);
        return this;
      }, u.prototype.digest = function() {
        var l = new Uint8Array(this.digestLength);
        return this.finish(l), l;
      }, u.prototype.saveState = function() {
        if (this._finished)
          throw new Error("SHA256: cannot save finished state");
        return {
          state: new Int32Array(this._state),
          buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
          bufferLength: this._bufferLength,
          bytesHashed: this._bytesHashed
        };
      }, u.prototype.restoreState = function(l) {
        return this._state.set(l.state), this._bufferLength = l.bufferLength, l.buffer && this._buffer.set(l.buffer), this._bytesHashed = l.bytesHashed, this._finished = !1, this;
      }, u.prototype.cleanSavedState = function(l) {
        r.wipe(l.state), l.buffer && r.wipe(l.buffer), l.bufferLength = 0, l.bytesHashed = 0;
      }, u;
    }()
  );
  t.SHA256 = n;
  var i = new Int32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]);
  function o(u, l, f, p, g) {
    for (; g >= 64; ) {
      for (var y = l[0], C = l[1], R = l[2], J = l[3], G = l[4], H = l[5], T = l[6], q = l[7], B = 0; B < 16; B++) {
        var L = p + B * 4;
        u[B] = e.readUint32BE(f, L);
      }
      for (var B = 16; B < 64; B++) {
        var P = u[B - 2], v = (P >>> 17 | P << 15) ^ (P >>> 19 | P << 13) ^ P >>> 10;
        P = u[B - 15];
        var N = (P >>> 7 | P << 25) ^ (P >>> 18 | P << 14) ^ P >>> 3;
        u[B] = (v + u[B - 7] | 0) + (N + u[B - 16] | 0);
      }
      for (var B = 0; B < 64; B++) {
        var v = (((G >>> 6 | G << 26) ^ (G >>> 11 | G << 21) ^ (G >>> 25 | G << 7)) + (G & H ^ ~G & T) | 0) + (q + (i[B] + u[B] | 0) | 0) | 0, N = ((y >>> 2 | y << 30) ^ (y >>> 13 | y << 19) ^ (y >>> 22 | y << 10)) + (y & C ^ y & R ^ C & R) | 0;
        q = T, T = H, H = G, G = J + v | 0, J = R, R = C, C = y, y = v + N | 0;
      }
      l[0] += y, l[1] += C, l[2] += R, l[3] += J, l[4] += G, l[5] += H, l[6] += T, l[7] += q, p += 64, g -= 64;
    }
    return p;
  }
  function c(u) {
    var l = new n();
    l.update(u);
    var f = l.digest();
    return l.clean(), f;
  }
  t.hash = c;
})(gf);
var _g = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.sharedKey = t.generateKeyPair = t.generateKeyPairFromSeed = t.scalarMultBase = t.scalarMult = t.SHARED_KEY_LENGTH = t.SECRET_KEY_LENGTH = t.PUBLIC_KEY_LENGTH = void 0;
  const e = La, r = xn;
  t.PUBLIC_KEY_LENGTH = 32, t.SECRET_KEY_LENGTH = 32, t.SHARED_KEY_LENGTH = 32;
  function n(B) {
    const L = new Float64Array(16);
    if (B)
      for (let P = 0; P < B.length; P++)
        L[P] = B[P];
    return L;
  }
  const i = new Uint8Array(32);
  i[0] = 9;
  const o = n([56129, 1]);
  function c(B) {
    let L = 1;
    for (let P = 0; P < 16; P++) {
      let v = B[P] + L + 65535;
      L = Math.floor(v / 65536), B[P] = v - L * 65536;
    }
    B[0] += L - 1 + 37 * (L - 1);
  }
  function u(B, L, P) {
    const v = ~(P - 1);
    for (let N = 0; N < 16; N++) {
      const ie = v & (B[N] ^ L[N]);
      B[N] ^= ie, L[N] ^= ie;
    }
  }
  function l(B, L) {
    const P = n(), v = n();
    for (let N = 0; N < 16; N++)
      v[N] = L[N];
    c(v), c(v), c(v);
    for (let N = 0; N < 2; N++) {
      P[0] = v[0] - 65517;
      for (let le = 1; le < 15; le++)
        P[le] = v[le] - 65535 - (P[le - 1] >> 16 & 1), P[le - 1] &= 65535;
      P[15] = v[15] - 32767 - (P[14] >> 16 & 1);
      const ie = P[15] >> 16 & 1;
      P[14] &= 65535, u(v, P, 1 - ie);
    }
    for (let N = 0; N < 16; N++)
      B[2 * N] = v[N] & 255, B[2 * N + 1] = v[N] >> 8;
  }
  function f(B, L) {
    for (let P = 0; P < 16; P++)
      B[P] = L[2 * P] + (L[2 * P + 1] << 8);
    B[15] &= 32767;
  }
  function p(B, L, P) {
    for (let v = 0; v < 16; v++)
      B[v] = L[v] + P[v];
  }
  function g(B, L, P) {
    for (let v = 0; v < 16; v++)
      B[v] = L[v] - P[v];
  }
  function y(B, L, P) {
    let v, N, ie = 0, le = 0, he = 0, ye = 0, k = 0, h = 0, m = 0, x = 0, M = 0, A = 0, $ = 0, K = 0, D = 0, w = 0, U = 0, me = 0, pe = 0, ee = 0, V = 0, Q = 0, X = 0, E = 0, I = 0, F = 0, se = 0, fe = 0, Re = 0, j = 0, b = 0, S = 0, Z = 0, re = P[0], ue = P[1], ge = P[2], Ee = P[3], Ie = P[4], Ae = P[5], xe = P[6], Se = P[7], Le = P[8], Ne = P[9], Oe = P[10], it = P[11], Fe = P[12], je = P[13], ut = P[14], Be = P[15];
    v = L[0], ie += v * re, le += v * ue, he += v * ge, ye += v * Ee, k += v * Ie, h += v * Ae, m += v * xe, x += v * Se, M += v * Le, A += v * Ne, $ += v * Oe, K += v * it, D += v * Fe, w += v * je, U += v * ut, me += v * Be, v = L[1], le += v * re, he += v * ue, ye += v * ge, k += v * Ee, h += v * Ie, m += v * Ae, x += v * xe, M += v * Se, A += v * Le, $ += v * Ne, K += v * Oe, D += v * it, w += v * Fe, U += v * je, me += v * ut, pe += v * Be, v = L[2], he += v * re, ye += v * ue, k += v * ge, h += v * Ee, m += v * Ie, x += v * Ae, M += v * xe, A += v * Se, $ += v * Le, K += v * Ne, D += v * Oe, w += v * it, U += v * Fe, me += v * je, pe += v * ut, ee += v * Be, v = L[3], ye += v * re, k += v * ue, h += v * ge, m += v * Ee, x += v * Ie, M += v * Ae, A += v * xe, $ += v * Se, K += v * Le, D += v * Ne, w += v * Oe, U += v * it, me += v * Fe, pe += v * je, ee += v * ut, V += v * Be, v = L[4], k += v * re, h += v * ue, m += v * ge, x += v * Ee, M += v * Ie, A += v * Ae, $ += v * xe, K += v * Se, D += v * Le, w += v * Ne, U += v * Oe, me += v * it, pe += v * Fe, ee += v * je, V += v * ut, Q += v * Be, v = L[5], h += v * re, m += v * ue, x += v * ge, M += v * Ee, A += v * Ie, $ += v * Ae, K += v * xe, D += v * Se, w += v * Le, U += v * Ne, me += v * Oe, pe += v * it, ee += v * Fe, V += v * je, Q += v * ut, X += v * Be, v = L[6], m += v * re, x += v * ue, M += v * ge, A += v * Ee, $ += v * Ie, K += v * Ae, D += v * xe, w += v * Se, U += v * Le, me += v * Ne, pe += v * Oe, ee += v * it, V += v * Fe, Q += v * je, X += v * ut, E += v * Be, v = L[7], x += v * re, M += v * ue, A += v * ge, $ += v * Ee, K += v * Ie, D += v * Ae, w += v * xe, U += v * Se, me += v * Le, pe += v * Ne, ee += v * Oe, V += v * it, Q += v * Fe, X += v * je, E += v * ut, I += v * Be, v = L[8], M += v * re, A += v * ue, $ += v * ge, K += v * Ee, D += v * Ie, w += v * Ae, U += v * xe, me += v * Se, pe += v * Le, ee += v * Ne, V += v * Oe, Q += v * it, X += v * Fe, E += v * je, I += v * ut, F += v * Be, v = L[9], A += v * re, $ += v * ue, K += v * ge, D += v * Ee, w += v * Ie, U += v * Ae, me += v * xe, pe += v * Se, ee += v * Le, V += v * Ne, Q += v * Oe, X += v * it, E += v * Fe, I += v * je, F += v * ut, se += v * Be, v = L[10], $ += v * re, K += v * ue, D += v * ge, w += v * Ee, U += v * Ie, me += v * Ae, pe += v * xe, ee += v * Se, V += v * Le, Q += v * Ne, X += v * Oe, E += v * it, I += v * Fe, F += v * je, se += v * ut, fe += v * Be, v = L[11], K += v * re, D += v * ue, w += v * ge, U += v * Ee, me += v * Ie, pe += v * Ae, ee += v * xe, V += v * Se, Q += v * Le, X += v * Ne, E += v * Oe, I += v * it, F += v * Fe, se += v * je, fe += v * ut, Re += v * Be, v = L[12], D += v * re, w += v * ue, U += v * ge, me += v * Ee, pe += v * Ie, ee += v * Ae, V += v * xe, Q += v * Se, X += v * Le, E += v * Ne, I += v * Oe, F += v * it, se += v * Fe, fe += v * je, Re += v * ut, j += v * Be, v = L[13], w += v * re, U += v * ue, me += v * ge, pe += v * Ee, ee += v * Ie, V += v * Ae, Q += v * xe, X += v * Se, E += v * Le, I += v * Ne, F += v * Oe, se += v * it, fe += v * Fe, Re += v * je, j += v * ut, b += v * Be, v = L[14], U += v * re, me += v * ue, pe += v * ge, ee += v * Ee, V += v * Ie, Q += v * Ae, X += v * xe, E += v * Se, I += v * Le, F += v * Ne, se += v * Oe, fe += v * it, Re += v * Fe, j += v * je, b += v * ut, S += v * Be, v = L[15], me += v * re, pe += v * ue, ee += v * ge, V += v * Ee, Q += v * Ie, X += v * Ae, E += v * xe, I += v * Se, F += v * Le, se += v * Ne, fe += v * Oe, Re += v * it, j += v * Fe, b += v * je, S += v * ut, Z += v * Be, ie += 38 * pe, le += 38 * ee, he += 38 * V, ye += 38 * Q, k += 38 * X, h += 38 * E, m += 38 * I, x += 38 * F, M += 38 * se, A += 38 * fe, $ += 38 * Re, K += 38 * j, D += 38 * b, w += 38 * S, U += 38 * Z, N = 1, v = ie + N + 65535, N = Math.floor(v / 65536), ie = v - N * 65536, v = le + N + 65535, N = Math.floor(v / 65536), le = v - N * 65536, v = he + N + 65535, N = Math.floor(v / 65536), he = v - N * 65536, v = ye + N + 65535, N = Math.floor(v / 65536), ye = v - N * 65536, v = k + N + 65535, N = Math.floor(v / 65536), k = v - N * 65536, v = h + N + 65535, N = Math.floor(v / 65536), h = v - N * 65536, v = m + N + 65535, N = Math.floor(v / 65536), m = v - N * 65536, v = x + N + 65535, N = Math.floor(v / 65536), x = v - N * 65536, v = M + N + 65535, N = Math.floor(v / 65536), M = v - N * 65536, v = A + N + 65535, N = Math.floor(v / 65536), A = v - N * 65536, v = $ + N + 65535, N = Math.floor(v / 65536), $ = v - N * 65536, v = K + N + 65535, N = Math.floor(v / 65536), K = v - N * 65536, v = D + N + 65535, N = Math.floor(v / 65536), D = v - N * 65536, v = w + N + 65535, N = Math.floor(v / 65536), w = v - N * 65536, v = U + N + 65535, N = Math.floor(v / 65536), U = v - N * 65536, v = me + N + 65535, N = Math.floor(v / 65536), me = v - N * 65536, ie += N - 1 + 37 * (N - 1), N = 1, v = ie + N + 65535, N = Math.floor(v / 65536), ie = v - N * 65536, v = le + N + 65535, N = Math.floor(v / 65536), le = v - N * 65536, v = he + N + 65535, N = Math.floor(v / 65536), he = v - N * 65536, v = ye + N + 65535, N = Math.floor(v / 65536), ye = v - N * 65536, v = k + N + 65535, N = Math.floor(v / 65536), k = v - N * 65536, v = h + N + 65535, N = Math.floor(v / 65536), h = v - N * 65536, v = m + N + 65535, N = Math.floor(v / 65536), m = v - N * 65536, v = x + N + 65535, N = Math.floor(v / 65536), x = v - N * 65536, v = M + N + 65535, N = Math.floor(v / 65536), M = v - N * 65536, v = A + N + 65535, N = Math.floor(v / 65536), A = v - N * 65536, v = $ + N + 65535, N = Math.floor(v / 65536), $ = v - N * 65536, v = K + N + 65535, N = Math.floor(v / 65536), K = v - N * 65536, v = D + N + 65535, N = Math.floor(v / 65536), D = v - N * 65536, v = w + N + 65535, N = Math.floor(v / 65536), w = v - N * 65536, v = U + N + 65535, N = Math.floor(v / 65536), U = v - N * 65536, v = me + N + 65535, N = Math.floor(v / 65536), me = v - N * 65536, ie += N - 1 + 37 * (N - 1), B[0] = ie, B[1] = le, B[2] = he, B[3] = ye, B[4] = k, B[5] = h, B[6] = m, B[7] = x, B[8] = M, B[9] = A, B[10] = $, B[11] = K, B[12] = D, B[13] = w, B[14] = U, B[15] = me;
  }
  function C(B, L) {
    y(B, L, L);
  }
  function R(B, L) {
    const P = n();
    for (let v = 0; v < 16; v++)
      P[v] = L[v];
    for (let v = 253; v >= 0; v--)
      C(P, P), v !== 2 && v !== 4 && y(P, P, L);
    for (let v = 0; v < 16; v++)
      B[v] = P[v];
  }
  function J(B, L) {
    const P = new Uint8Array(32), v = new Float64Array(80), N = n(), ie = n(), le = n(), he = n(), ye = n(), k = n();
    for (let M = 0; M < 31; M++)
      P[M] = B[M];
    P[31] = B[31] & 127 | 64, P[0] &= 248, f(v, L);
    for (let M = 0; M < 16; M++)
      ie[M] = v[M];
    N[0] = he[0] = 1;
    for (let M = 254; M >= 0; --M) {
      const A = P[M >>> 3] >>> (M & 7) & 1;
      u(N, ie, A), u(le, he, A), p(ye, N, le), g(N, N, le), p(le, ie, he), g(ie, ie, he), C(he, ye), C(k, N), y(N, le, N), y(le, ie, ye), p(ye, N, le), g(N, N, le), C(ie, N), g(le, he, k), y(N, le, o), p(N, N, he), y(le, le, N), y(N, he, k), y(he, ie, v), C(ie, ye), u(N, ie, A), u(le, he, A);
    }
    for (let M = 0; M < 16; M++)
      v[M + 16] = N[M], v[M + 32] = le[M], v[M + 48] = ie[M], v[M + 64] = he[M];
    const h = v.subarray(32), m = v.subarray(16);
    R(h, h), y(m, m, h);
    const x = new Uint8Array(32);
    return l(x, m), x;
  }
  t.scalarMult = J;
  function G(B) {
    return J(B, i);
  }
  t.scalarMultBase = G;
  function H(B) {
    if (B.length !== t.SECRET_KEY_LENGTH)
      throw new Error(`x25519: seed must be ${t.SECRET_KEY_LENGTH} bytes`);
    const L = new Uint8Array(B);
    return {
      publicKey: G(L),
      secretKey: L
    };
  }
  t.generateKeyPairFromSeed = H;
  function T(B) {
    const L = (0, e.randomBytes)(32, B), P = H(L);
    return (0, r.wipe)(L), P;
  }
  t.generateKeyPair = T;
  function q(B, L, P = !1) {
    if (B.length !== t.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect secret key length");
    if (L.length !== t.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect public key length");
    const v = J(B, L);
    if (P) {
      let N = 0;
      for (let ie = 0; ie < v.length; ie++)
        N |= v[ie];
      if (N === 0)
        throw new Error("X25519: invalid shared key");
    }
    return v;
  }
  t.sharedKey = q;
})(_g);
function wg(t) {
  return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function wE(t = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? wg(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function op(t, e) {
  e || (e = t.reduce((i, o) => i + o.length, 0));
  const r = wE(e);
  let n = 0;
  for (const i of t)
    r.set(i, n), n += i.length;
  return wg(r);
}
function g9(t, e) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var r = new Uint8Array(256), n = 0; n < r.length; n++)
    r[n] = 255;
  for (var i = 0; i < t.length; i++) {
    var o = t.charAt(i), c = o.charCodeAt(0);
    if (r[c] !== 255)
      throw new TypeError(o + " is ambiguous");
    r[c] = i;
  }
  var u = t.length, l = t.charAt(0), f = Math.log(u) / Math.log(256), p = Math.log(256) / Math.log(u);
  function g(R) {
    if (R instanceof Uint8Array || (ArrayBuffer.isView(R) ? R = new Uint8Array(R.buffer, R.byteOffset, R.byteLength) : Array.isArray(R) && (R = Uint8Array.from(R))), !(R instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (R.length === 0)
      return "";
    for (var J = 0, G = 0, H = 0, T = R.length; H !== T && R[H] === 0; )
      H++, J++;
    for (var q = (T - H) * p + 1 >>> 0, B = new Uint8Array(q); H !== T; ) {
      for (var L = R[H], P = 0, v = q - 1; (L !== 0 || P < G) && v !== -1; v--, P++)
        L += 256 * B[v] >>> 0, B[v] = L % u >>> 0, L = L / u >>> 0;
      if (L !== 0)
        throw new Error("Non-zero carry");
      G = P, H++;
    }
    for (var N = q - G; N !== q && B[N] === 0; )
      N++;
    for (var ie = l.repeat(J); N < q; ++N)
      ie += t.charAt(B[N]);
    return ie;
  }
  function y(R) {
    if (typeof R != "string")
      throw new TypeError("Expected String");
    if (R.length === 0)
      return new Uint8Array();
    var J = 0;
    if (R[J] !== " ") {
      for (var G = 0, H = 0; R[J] === l; )
        G++, J++;
      for (var T = (R.length - J) * f + 1 >>> 0, q = new Uint8Array(T); R[J]; ) {
        var B = r[R.charCodeAt(J)];
        if (B === 255)
          return;
        for (var L = 0, P = T - 1; (B !== 0 || L < H) && P !== -1; P--, L++)
          B += u * q[P] >>> 0, q[P] = B % 256 >>> 0, B = B / 256 >>> 0;
        if (B !== 0)
          throw new Error("Non-zero carry");
        H = L, J++;
      }
      if (R[J] !== " ") {
        for (var v = T - H; v !== T && q[v] === 0; )
          v++;
        for (var N = new Uint8Array(G + (T - v)), ie = G; v !== T; )
          N[ie++] = q[v++];
        return N;
      }
    }
  }
  function C(R) {
    var J = y(R);
    if (J)
      return J;
    throw new Error(`Non-${e} character`);
  }
  return {
    encode: g,
    decodeUnsafe: y,
    decode: C
  };
}
var m9 = g9, v9 = m9;
const y9 = (t) => {
  if (t instanceof Uint8Array && t.constructor.name === "Uint8Array")
    return t;
  if (t instanceof ArrayBuffer)
    return new Uint8Array(t);
  if (ArrayBuffer.isView(t))
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  throw new Error("Unknown type, must be binary type");
}, _9 = (t) => new TextEncoder().encode(t), w9 = (t) => new TextDecoder().decode(t);
class b9 {
  constructor(e, r, n) {
    this.name = e, this.prefix = r, this.baseEncode = n;
  }
  encode(e) {
    if (e instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class E9 {
  constructor(e, r, n) {
    if (this.name = e, this.prefix = r, r.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = r.codePointAt(0), this.baseDecode = n;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(e) {
    return bE(this, e);
  }
}
class S9 {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return bE(this, e);
  }
  decode(e) {
    const r = e[0], n = this.decoders[r];
    if (n)
      return n.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const bE = (t, e) => new S9({
  ...t.decoders || { [t.prefix]: t },
  ...e.decoders || { [e.prefix]: e }
});
class C9 {
  constructor(e, r, n, i) {
    this.name = e, this.prefix = r, this.baseEncode = n, this.baseDecode = i, this.encoder = new b9(e, r, n), this.decoder = new E9(e, r, i);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
}
const mf = ({ name: t, prefix: e, encode: r, decode: n }) => new C9(t, e, r, n), gu = ({ prefix: t, name: e, alphabet: r }) => {
  const { encode: n, decode: i } = v9(r, e);
  return mf({
    prefix: t,
    name: e,
    encode: n,
    decode: (o) => y9(i(o))
  });
}, I9 = (t, e, r, n) => {
  const i = {};
  for (let p = 0; p < e.length; ++p)
    i[e[p]] = p;
  let o = t.length;
  for (; t[o - 1] === "="; )
    --o;
  const c = new Uint8Array(o * r / 8 | 0);
  let u = 0, l = 0, f = 0;
  for (let p = 0; p < o; ++p) {
    const g = i[t[p]];
    if (g === void 0)
      throw new SyntaxError(`Non-${n} character`);
    l = l << r | g, u += r, u >= 8 && (u -= 8, c[f++] = 255 & l >> u);
  }
  if (u >= r || 255 & l << 8 - u)
    throw new SyntaxError("Unexpected end of data");
  return c;
}, x9 = (t, e, r) => {
  const n = e[e.length - 1] === "=", i = (1 << r) - 1;
  let o = "", c = 0, u = 0;
  for (let l = 0; l < t.length; ++l)
    for (u = u << 8 | t[l], c += 8; c > r; )
      c -= r, o += e[i & u >> c];
  if (c && (o += e[i & u << r - c]), n)
    for (; o.length * r & 7; )
      o += "=";
  return o;
}, Nr = ({ name: t, prefix: e, bitsPerChar: r, alphabet: n }) => mf({
  prefix: e,
  name: t,
  encode(i) {
    return x9(i, n, r);
  },
  decode(i) {
    return I9(i, n, r, t);
  }
}), R9 = mf({
  prefix: "\0",
  name: "identity",
  encode: (t) => w9(t),
  decode: (t) => _9(t)
}), A9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  identity: R9
}, Symbol.toStringTag, { value: "Module" })), M9 = Nr({
  prefix: "0",
  name: "base2",
  alphabet: "01",
  bitsPerChar: 1
}), D9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base2: M9
}, Symbol.toStringTag, { value: "Module" })), O9 = Nr({
  prefix: "7",
  name: "base8",
  alphabet: "01234567",
  bitsPerChar: 3
}), P9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base8: O9
}, Symbol.toStringTag, { value: "Module" })), T9 = gu({
  prefix: "9",
  name: "base10",
  alphabet: "0123456789"
}), N9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base10: T9
}, Symbol.toStringTag, { value: "Module" })), k9 = Nr({
  prefix: "f",
  name: "base16",
  alphabet: "0123456789abcdef",
  bitsPerChar: 4
}), L9 = Nr({
  prefix: "F",
  name: "base16upper",
  alphabet: "0123456789ABCDEF",
  bitsPerChar: 4
}), $9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base16: k9,
  base16upper: L9
}, Symbol.toStringTag, { value: "Module" })), F9 = Nr({
  prefix: "b",
  name: "base32",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567",
  bitsPerChar: 5
}), B9 = Nr({
  prefix: "B",
  name: "base32upper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
  bitsPerChar: 5
}), U9 = Nr({
  prefix: "c",
  name: "base32pad",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
  bitsPerChar: 5
}), j9 = Nr({
  prefix: "C",
  name: "base32padupper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
  bitsPerChar: 5
}), H9 = Nr({
  prefix: "v",
  name: "base32hex",
  alphabet: "0123456789abcdefghijklmnopqrstuv",
  bitsPerChar: 5
}), q9 = Nr({
  prefix: "V",
  name: "base32hexupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
  bitsPerChar: 5
}), z9 = Nr({
  prefix: "t",
  name: "base32hexpad",
  alphabet: "0123456789abcdefghijklmnopqrstuv=",
  bitsPerChar: 5
}), V9 = Nr({
  prefix: "T",
  name: "base32hexpadupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
  bitsPerChar: 5
}), W9 = Nr({
  prefix: "h",
  name: "base32z",
  alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
  bitsPerChar: 5
}), K9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base32: F9,
  base32hex: H9,
  base32hexpad: z9,
  base32hexpadupper: V9,
  base32hexupper: q9,
  base32pad: U9,
  base32padupper: j9,
  base32upper: B9,
  base32z: W9
}, Symbol.toStringTag, { value: "Module" })), G9 = gu({
  prefix: "k",
  name: "base36",
  alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), J9 = gu({
  prefix: "K",
  name: "base36upper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
}), Q9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base36: G9,
  base36upper: J9
}, Symbol.toStringTag, { value: "Module" })), Z9 = gu({
  name: "base58btc",
  prefix: "z",
  alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), Y9 = gu({
  name: "base58flickr",
  prefix: "Z",
  alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
}), X9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base58btc: Z9,
  base58flickr: Y9
}, Symbol.toStringTag, { value: "Module" })), e$ = Nr({
  prefix: "m",
  name: "base64",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  bitsPerChar: 6
}), t$ = Nr({
  prefix: "M",
  name: "base64pad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  bitsPerChar: 6
}), r$ = Nr({
  prefix: "u",
  name: "base64url",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
  bitsPerChar: 6
}), n$ = Nr({
  prefix: "U",
  name: "base64urlpad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
  bitsPerChar: 6
}), i$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base64: e$,
  base64pad: t$,
  base64url: r$,
  base64urlpad: n$
}, Symbol.toStringTag, { value: "Module" })), EE = Array.from("🚀🪐☄🛰🌌🌑🌒🌓🌔🌕🌖🌗🌘🌍🌏🌎🐉☀💻🖥💾💿😂❤😍🤣😊🙏💕😭😘👍😅👏😁🔥🥰💔💖💙😢🤔😆🙄💪😉☺👌🤗💜😔😎😇🌹🤦🎉💞✌✨🤷😱😌🌸🙌😋💗💚😏💛🙂💓🤩😄😀🖤😃💯🙈👇🎶😒🤭❣😜💋👀😪😑💥🙋😞😩😡🤪👊🥳😥🤤👉💃😳✋😚😝😴🌟😬🙃🍀🌷😻😓⭐✅🥺🌈😈🤘💦✔😣🏃💐☹🎊💘😠☝😕🌺🎂🌻😐🖕💝🙊😹🗣💫💀👑🎵🤞😛🔴😤🌼😫⚽🤙☕🏆🤫👈😮🙆🍻🍃🐶💁😲🌿🧡🎁⚡🌞🎈❌✊👋😰🤨😶🤝🚶💰🍓💢🤟🙁🚨💨🤬✈🎀🍺🤓😙💟🌱😖👶🥴▶➡❓💎💸⬇😨🌚🦋😷🕺⚠🙅😟😵👎🤲🤠🤧📌🔵💅🧐🐾🍒😗🤑🌊🤯🐷☎💧😯💆👆🎤🙇🍑❄🌴💣🐸💌📍🥀🤢👅💡💩👐📸👻🤐🤮🎼🥵🚩🍎🍊👼💍📣🥂"), s$ = EE.reduce((t, e, r) => (t[r] = e, t), []), o$ = EE.reduce((t, e, r) => (t[e.codePointAt(0)] = r, t), []);
function a$(t) {
  return t.reduce((e, r) => (e += s$[r], e), "");
}
function c$(t) {
  const e = [];
  for (const r of t) {
    const n = o$[r.codePointAt(0)];
    if (n === void 0)
      throw new Error(`Non-base256emoji character: ${r}`);
    e.push(n);
  }
  return new Uint8Array(e);
}
const u$ = mf({
  prefix: "🚀",
  name: "base256emoji",
  encode: a$,
  decode: c$
}), l$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base256emoji: u$
}, Symbol.toStringTag, { value: "Module" }));
new TextEncoder();
new TextDecoder();
const Vy = {
  ...A9,
  ...D9,
  ...P9,
  ...N9,
  ...$9,
  ...K9,
  ...Q9,
  ...X9,
  ...i$,
  ...l$
};
function SE(t, e, r, n) {
  return {
    name: t,
    prefix: e,
    encoder: {
      name: t,
      prefix: e,
      encode: r
    },
    decoder: { decode: n }
  };
}
const Wy = SE("utf8", "u", (t) => "u" + new TextDecoder("utf8").decode(t), (t) => new TextEncoder().encode(t.substring(1))), d0 = SE("ascii", "a", (t) => {
  let e = "a";
  for (let r = 0; r < t.length; r++)
    e += String.fromCharCode(t[r]);
  return e;
}, (t) => {
  t = t.substring(1);
  const e = wE(t.length);
  for (let r = 0; r < t.length; r++)
    e[r] = t.charCodeAt(r);
  return e;
}), CE = {
  utf8: Wy,
  "utf-8": Wy,
  hex: Vy.base16,
  latin1: d0,
  ascii: d0,
  binary: d0,
  ...Vy
};
function dn(t, e = "utf8") {
  const r = CE[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? wg(globalThis.Buffer.from(t, "utf-8")) : r.decoder.decode(`${r.prefix}${t}`);
}
function Zr(t, e = "utf8") {
  const r = CE[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("utf8") : r.encoder.encode(t).substring(1);
}
var Ky = function(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, h$ = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, r, n) {
      this.name = e, this.version = r, this.os = n, this.type = "browser";
    }
    return t;
  }()
), f$ = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.version = e, this.type = "node", this.name = "node", this.os = process.platform;
    }
    return t;
  }()
), d$ = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, r, n, i) {
      this.name = e, this.version = r, this.os = n, this.bot = i, this.type = "bot-device";
    }
    return t;
  }()
), p$ = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
    }
    return t;
  }()
), g$ = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
    }
    return t;
  }()
), m$ = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/, v$ = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, Gy = 3, y$ = [
  ["aol", /AOLShield\/([0-9\._]+)/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["edge-ios", /EdgiOS\/([0-9\._]+)/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/],
  ["samsung", /SamsungBrowser\/([0-9\.]+)/],
  ["silk", /\bSilk\/([0-9._-]+)\b/],
  ["miui", /MiuiBrowser\/([0-9\.]+)$/],
  ["beaker", /BeakerBrowser\/([0-9\.]+)/],
  ["edge-chromium", /EdgA?\/([0-9\.]+)/],
  [
    "chromium-webview",
    /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/],
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["fxios", /FxiOS\/([0-9\.]+)/],
  ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)/],
  ["pie", /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
  ["pie", /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
  ["netfront", /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["facebook", /FB[AS]V\/([0-9\.]+)/],
  ["instagram", /Instagram\s([0-9\.]+)/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
  ["curl", /^curl\/([0-9\.]+)$/],
  ["searchbot", m$]
], Jy = [
  ["iOS", /iP(hone|od|ad)/],
  ["Android OS", /Android/],
  ["BlackBerry OS", /BlackBerry|BB10/],
  ["Windows Mobile", /IEMobile/],
  ["Amazon OS", /Kindle/],
  ["Windows 3.11", /Win16/],
  ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/],
  ["Windows 98", /(Windows 98)|(Win98)/],
  ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/],
  ["Windows XP", /(Windows NT 5.1)|(Windows XP)/],
  ["Windows Server 2003", /(Windows NT 5.2)/],
  ["Windows Vista", /(Windows NT 6.0)/],
  ["Windows 7", /(Windows NT 6.1)/],
  ["Windows 8", /(Windows NT 6.2)/],
  ["Windows 8.1", /(Windows NT 6.3)/],
  ["Windows 10", /(Windows NT 10.0)/],
  ["Windows ME", /Windows ME/],
  ["Windows CE", /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
  ["Open BSD", /OpenBSD/],
  ["Sun OS", /SunOS/],
  ["Chrome OS", /CrOS/],
  ["Linux", /(Linux)|(X11)/],
  ["Mac OS", /(Mac_PowerPC)|(Macintosh)/],
  ["QNX", /QNX/],
  ["BeOS", /BeOS/],
  ["OS/2", /OS\/2/]
];
function _$(t) {
  return t ? Qy(t) : typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative" ? new g$() : typeof navigator < "u" ? Qy(navigator.userAgent) : E$();
}
function w$(t) {
  return t !== "" && y$.reduce(function(e, r) {
    var n = r[0], i = r[1];
    if (e)
      return e;
    var o = i.exec(t);
    return !!o && [n, o];
  }, !1);
}
function Qy(t) {
  var e = w$(t);
  if (!e)
    return null;
  var r = e[0], n = e[1];
  if (r === "searchbot")
    return new p$();
  var i = n[1] && n[1].split(".").join("_").split("_").slice(0, 3);
  i ? i.length < Gy && (i = Ky(Ky([], i, !0), S$(Gy - i.length), !0)) : i = [];
  var o = i.join("."), c = b$(t), u = v$.exec(t);
  return u && u[1] ? new d$(r, o, c, u[1]) : new h$(r, o, c);
}
function b$(t) {
  for (var e = 0, r = Jy.length; e < r; e++) {
    var n = Jy[e], i = n[0], o = n[1], c = o.exec(t);
    if (c)
      return i;
  }
  return null;
}
function E$() {
  var t = typeof process < "u" && process.version;
  return t ? new f$(process.version.slice(1)) : null;
}
function S$(t) {
  for (var e = [], r = 0; r < t; r++)
    e.push("0");
  return e;
}
var He = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ap = function(t, e) {
  return ap = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (r[i] = n[i]);
  }, ap(t, e);
};
function C$(t, e) {
  ap(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var cp = function() {
  return cp = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, cp.apply(this, arguments);
};
function I$(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(t); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[i]) && (r[n[i]] = t[n[i]]);
  return r;
}
function x$(t, e, r, n) {
  var i = arguments.length, o = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, r) : n, c;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(t, e, r, n);
  else
    for (var u = t.length - 1; u >= 0; u--)
      (c = t[u]) && (o = (i < 3 ? c(o) : i > 3 ? c(e, r, o) : c(e, r)) || o);
  return i > 3 && o && Object.defineProperty(e, r, o), o;
}
function R$(t, e) {
  return function(r, n) {
    e(r, n, t);
  };
}
function A$(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t, e);
}
function M$(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(c) {
      c(o);
    });
  }
  return new (r || (r = Promise))(function(o, c) {
    function u(p) {
      try {
        f(n.next(p));
      } catch (g) {
        c(g);
      }
    }
    function l(p) {
      try {
        f(n.throw(p));
      } catch (g) {
        c(g);
      }
    }
    function f(p) {
      p.done ? o(p.value) : i(p.value).then(u, l);
    }
    f((n = n.apply(t, e || [])).next());
  });
}
function D$(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, c;
  return c = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function u(f) {
    return function(p) {
      return l([f, p]);
    };
  }
  function l(f) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, i && (o = f[0] & 2 ? i.return : f[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, f[1])).done)
          return o;
        switch (i = 0, o && (f = [f[0] & 2, o.value]), f[0]) {
          case 0:
          case 1:
            o = f;
            break;
          case 4:
            return r.label++, { value: f[1], done: !1 };
          case 5:
            r.label++, i = f[1], f = [0];
            continue;
          case 7:
            f = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              r = 0;
              continue;
            }
            if (f[0] === 3 && (!o || f[1] > o[0] && f[1] < o[3])) {
              r.label = f[1];
              break;
            }
            if (f[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = f;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(f);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        f = e.call(t, r);
      } catch (p) {
        f = [6, p], i = 0;
      } finally {
        n = o = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function O$(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
}
function P$(t, e) {
  for (var r in t)
    r !== "default" && !e.hasOwnProperty(r) && (e[r] = t[r]);
}
function up(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r)
    return r.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function IE(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var n = r.call(t), i, o = [], c;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (u) {
    c = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (c)
        throw c.error;
    }
  }
  return o;
}
function T$() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(IE(arguments[e]));
  return t;
}
function N$() {
  for (var t = 0, e = 0, r = arguments.length; e < r; e++)
    t += arguments[e].length;
  for (var n = Array(t), i = 0, e = 0; e < r; e++)
    for (var o = arguments[e], c = 0, u = o.length; c < u; c++, i++)
      n[i] = o[c];
  return n;
}
function Lc(t) {
  return this instanceof Lc ? (this.v = t, this) : new Lc(t);
}
function k$(t, e, r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(t, e || []), i, o = [];
  return i = {}, c("next"), c("throw"), c("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function c(y) {
    n[y] && (i[y] = function(C) {
      return new Promise(function(R, J) {
        o.push([y, C, R, J]) > 1 || u(y, C);
      });
    });
  }
  function u(y, C) {
    try {
      l(n[y](C));
    } catch (R) {
      g(o[0][3], R);
    }
  }
  function l(y) {
    y.value instanceof Lc ? Promise.resolve(y.value.v).then(f, p) : g(o[0][2], y);
  }
  function f(y) {
    u("next", y);
  }
  function p(y) {
    u("throw", y);
  }
  function g(y, C) {
    y(C), o.shift(), o.length && u(o[0][0], o[0][1]);
  }
}
function L$(t) {
  var e, r;
  return e = {}, n("next"), n("throw", function(i) {
    throw i;
  }), n("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function n(i, o) {
    e[i] = t[i] ? function(c) {
      return (r = !r) ? { value: Lc(t[i](c)), done: i === "return" } : o ? o(c) : c;
    } : o;
  }
}
function $$(t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], r;
  return e ? e.call(t) : (t = typeof up == "function" ? up(t) : t[Symbol.iterator](), r = {}, n("next"), n("throw"), n("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function n(o) {
    r[o] = t[o] && function(c) {
      return new Promise(function(u, l) {
        c = t[o](c), i(u, l, c.done, c.value);
      });
    };
  }
  function i(o, c, u, l) {
    Promise.resolve(l).then(function(f) {
      o({ value: f, done: u });
    }, c);
  }
}
function F$(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
function B$(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var r in t)
      Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e.default = t, e;
}
function U$(t) {
  return t && t.__esModule ? t : { default: t };
}
function j$(t, e) {
  if (!e.has(t))
    throw new TypeError("attempted to get private field on non-instance");
  return e.get(t);
}
function H$(t, e, r) {
  if (!e.has(t))
    throw new TypeError("attempted to set private field on non-instance");
  return e.set(t, r), r;
}
const q$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return cp;
  },
  __asyncDelegator: L$,
  __asyncGenerator: k$,
  __asyncValues: $$,
  __await: Lc,
  __awaiter: M$,
  __classPrivateFieldGet: j$,
  __classPrivateFieldSet: H$,
  __createBinding: O$,
  __decorate: x$,
  __exportStar: P$,
  __extends: C$,
  __generator: D$,
  __importDefault: U$,
  __importStar: B$,
  __makeTemplateObject: F$,
  __metadata: A$,
  __param: R$,
  __read: IE,
  __rest: I$,
  __spread: T$,
  __spreadArrays: N$,
  __values: up
}, Symbol.toStringTag, { value: "Module" })), Ti = /* @__PURE__ */ is(q$);
var p0 = {}, fc = {}, Zy;
function z$() {
  if (Zy)
    return fc;
  Zy = 1, Object.defineProperty(fc, "__esModule", { value: !0 }), fc.delay = void 0;
  function t(e) {
    return new Promise((r) => {
      setTimeout(() => {
        r(!0);
      }, e);
    });
  }
  return fc.delay = t, fc;
}
var Ys = {}, g0 = {}, Xs = {}, Yy;
function V$() {
  return Yy || (Yy = 1, Object.defineProperty(Xs, "__esModule", { value: !0 }), Xs.ONE_THOUSAND = Xs.ONE_HUNDRED = void 0, Xs.ONE_HUNDRED = 100, Xs.ONE_THOUSAND = 1e3), Xs;
}
var m0 = {}, Xy;
function W$() {
  return Xy || (Xy = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ONE_YEAR = t.FOUR_WEEKS = t.THREE_WEEKS = t.TWO_WEEKS = t.ONE_WEEK = t.THIRTY_DAYS = t.SEVEN_DAYS = t.FIVE_DAYS = t.THREE_DAYS = t.ONE_DAY = t.TWENTY_FOUR_HOURS = t.TWELVE_HOURS = t.SIX_HOURS = t.THREE_HOURS = t.ONE_HOUR = t.SIXTY_MINUTES = t.THIRTY_MINUTES = t.TEN_MINUTES = t.FIVE_MINUTES = t.ONE_MINUTE = t.SIXTY_SECONDS = t.THIRTY_SECONDS = t.TEN_SECONDS = t.FIVE_SECONDS = t.ONE_SECOND = void 0, t.ONE_SECOND = 1, t.FIVE_SECONDS = 5, t.TEN_SECONDS = 10, t.THIRTY_SECONDS = 30, t.SIXTY_SECONDS = 60, t.ONE_MINUTE = t.SIXTY_SECONDS, t.FIVE_MINUTES = t.ONE_MINUTE * 5, t.TEN_MINUTES = t.ONE_MINUTE * 10, t.THIRTY_MINUTES = t.ONE_MINUTE * 30, t.SIXTY_MINUTES = t.ONE_MINUTE * 60, t.ONE_HOUR = t.SIXTY_MINUTES, t.THREE_HOURS = t.ONE_HOUR * 3, t.SIX_HOURS = t.ONE_HOUR * 6, t.TWELVE_HOURS = t.ONE_HOUR * 12, t.TWENTY_FOUR_HOURS = t.ONE_HOUR * 24, t.ONE_DAY = t.TWENTY_FOUR_HOURS, t.THREE_DAYS = t.ONE_DAY * 3, t.FIVE_DAYS = t.ONE_DAY * 5, t.SEVEN_DAYS = t.ONE_DAY * 7, t.THIRTY_DAYS = t.ONE_DAY * 30, t.ONE_WEEK = t.SEVEN_DAYS, t.TWO_WEEKS = t.ONE_WEEK * 2, t.THREE_WEEKS = t.ONE_WEEK * 3, t.FOUR_WEEKS = t.ONE_WEEK * 4, t.ONE_YEAR = t.ONE_DAY * 365;
  }(m0)), m0;
}
var e_;
function xE() {
  return e_ || (e_ = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = Ti;
    e.__exportStar(V$(), t), e.__exportStar(W$(), t);
  }(g0)), g0;
}
var t_;
function K$() {
  if (t_)
    return Ys;
  t_ = 1, Object.defineProperty(Ys, "__esModule", { value: !0 }), Ys.fromMiliseconds = Ys.toMiliseconds = void 0;
  const t = xE();
  function e(n) {
    return n * t.ONE_THOUSAND;
  }
  Ys.toMiliseconds = e;
  function r(n) {
    return Math.floor(n / t.ONE_THOUSAND);
  }
  return Ys.fromMiliseconds = r, Ys;
}
var r_;
function G$() {
  return r_ || (r_ = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = Ti;
    e.__exportStar(z$(), t), e.__exportStar(K$(), t);
  }(p0)), p0;
}
var ra = {}, n_;
function J$() {
  if (n_)
    return ra;
  n_ = 1, Object.defineProperty(ra, "__esModule", { value: !0 }), ra.Watch = void 0;
  class t {
    constructor() {
      this.timestamps = /* @__PURE__ */ new Map();
    }
    start(r) {
      if (this.timestamps.has(r))
        throw new Error(`Watch already started for label: ${r}`);
      this.timestamps.set(r, { started: Date.now() });
    }
    stop(r) {
      const n = this.get(r);
      if (typeof n.elapsed < "u")
        throw new Error(`Watch already stopped for label: ${r}`);
      const i = Date.now() - n.started;
      this.timestamps.set(r, { started: n.started, elapsed: i });
    }
    get(r) {
      const n = this.timestamps.get(r);
      if (typeof n > "u")
        throw new Error(`No timestamp found for label: ${r}`);
      return n;
    }
    elapsed(r) {
      const n = this.get(r);
      return n.elapsed || Date.now() - n.started;
    }
  }
  return ra.Watch = t, ra.default = t, ra;
}
var v0 = {}, dc = {}, i_;
function Q$() {
  if (i_)
    return dc;
  i_ = 1, Object.defineProperty(dc, "__esModule", { value: !0 }), dc.IWatch = void 0;
  class t {
  }
  return dc.IWatch = t, dc;
}
var s_;
function Z$() {
  return s_ || (s_ = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), Ti.__exportStar(Q$(), t);
  }(v0)), v0;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const e = Ti;
  e.__exportStar(G$(), t), e.__exportStar(J$(), t), e.__exportStar(Z$(), t), e.__exportStar(xE(), t);
})(He);
var Qt = {};
Object.defineProperty(Qt, "__esModule", { value: !0 });
Qt.getLocalStorage = Qt.getLocalStorageOrThrow = Qt.getCrypto = Qt.getCryptoOrThrow = RE = Qt.getLocation = Qt.getLocationOrThrow = Eg = Qt.getNavigator = Qt.getNavigatorOrThrow = bg = Qt.getDocument = Qt.getDocumentOrThrow = Qt.getFromWindowOrThrow = Qt.getFromWindow = void 0;
function Io(t) {
  let e;
  return typeof window < "u" && typeof window[t] < "u" && (e = window[t]), e;
}
Qt.getFromWindow = Io;
function $a(t) {
  const e = Io(t);
  if (!e)
    throw new Error(`${t} is not defined in Window`);
  return e;
}
Qt.getFromWindowOrThrow = $a;
function Y$() {
  return $a("document");
}
Qt.getDocumentOrThrow = Y$;
function X$() {
  return Io("document");
}
var bg = Qt.getDocument = X$;
function eF() {
  return $a("navigator");
}
Qt.getNavigatorOrThrow = eF;
function tF() {
  return Io("navigator");
}
var Eg = Qt.getNavigator = tF;
function rF() {
  return $a("location");
}
Qt.getLocationOrThrow = rF;
function nF() {
  return Io("location");
}
var RE = Qt.getLocation = nF;
function iF() {
  return $a("crypto");
}
Qt.getCryptoOrThrow = iF;
function sF() {
  return Io("crypto");
}
Qt.getCrypto = sF;
function oF() {
  return $a("localStorage");
}
Qt.getLocalStorageOrThrow = oF;
function aF() {
  return Io("localStorage");
}
Qt.getLocalStorage = aF;
var Sg = {};
Object.defineProperty(Sg, "__esModule", { value: !0 });
var AE = Sg.getWindowMetadata = void 0;
const o_ = Qt;
function cF() {
  let t, e;
  try {
    t = o_.getDocumentOrThrow(), e = o_.getLocationOrThrow();
  } catch {
    return null;
  }
  function r() {
    const g = t.getElementsByTagName("link"), y = [];
    for (let C = 0; C < g.length; C++) {
      const R = g[C], J = R.getAttribute("rel");
      if (J && J.toLowerCase().indexOf("icon") > -1) {
        const G = R.getAttribute("href");
        if (G)
          if (G.toLowerCase().indexOf("https:") === -1 && G.toLowerCase().indexOf("http:") === -1 && G.indexOf("//") !== 0) {
            let H = e.protocol + "//" + e.host;
            if (G.indexOf("/") === 0)
              H += G;
            else {
              const T = e.pathname.split("/");
              T.pop();
              const q = T.join("/");
              H += q + "/" + G;
            }
            y.push(H);
          } else if (G.indexOf("//") === 0) {
            const H = e.protocol + G;
            y.push(H);
          } else
            y.push(G);
      }
    }
    return y;
  }
  function n(...g) {
    const y = t.getElementsByTagName("meta");
    for (let C = 0; C < y.length; C++) {
      const R = y[C], J = ["itemprop", "property", "name"].map((G) => R.getAttribute(G)).filter((G) => G ? g.includes(G) : !1);
      if (J.length && J) {
        const G = R.getAttribute("content");
        if (G)
          return G;
      }
    }
    return "";
  }
  function i() {
    let g = n("name", "og:site_name", "og:title", "twitter:title");
    return g || (g = t.title), g;
  }
  function o() {
    return n("description", "og:description", "twitter:description", "keywords");
  }
  const c = i(), u = o(), l = e.origin, f = r();
  return {
    description: u,
    url: l,
    icons: f,
    name: c
  };
}
AE = Sg.getWindowMetadata = cF;
var $c = {}, uF = (t) => encodeURIComponent(t).replace(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), ME = "%[a-f0-9]{2}", a_ = new RegExp("(" + ME + ")|([^%]+?)", "gi"), c_ = new RegExp("(" + ME + ")+", "gi");
function lp(t, e) {
  try {
    return [decodeURIComponent(t.join(""))];
  } catch {
  }
  if (t.length === 1)
    return t;
  e = e || 1;
  var r = t.slice(0, e), n = t.slice(e);
  return Array.prototype.concat.call([], lp(r), lp(n));
}
function lF(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    for (var e = t.match(a_) || [], r = 1; r < e.length; r++)
      t = lp(e, r).join(""), e = t.match(a_) || [];
    return t;
  }
}
function hF(t) {
  for (var e = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, r = c_.exec(t); r; ) {
    try {
      e[r[0]] = decodeURIComponent(r[0]);
    } catch {
      var n = lF(r[0]);
      n !== r[0] && (e[r[0]] = n);
    }
    r = c_.exec(t);
  }
  e["%C2"] = "�";
  for (var i = Object.keys(e), o = 0; o < i.length; o++) {
    var c = i[o];
    t = t.replace(new RegExp(c, "g"), e[c]);
  }
  return t;
}
var fF = function(t) {
  if (typeof t != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof t + "`");
  try {
    return t = t.replace(/\+/g, " "), decodeURIComponent(t);
  } catch {
    return hF(t);
  }
}, dF = (t, e) => {
  if (!(typeof t == "string" && typeof e == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "")
    return [t];
  const r = t.indexOf(e);
  return r === -1 ? [t] : [
    t.slice(0, r),
    t.slice(r + e.length)
  ];
}, pF = function(t, e) {
  for (var r = {}, n = Object.keys(t), i = Array.isArray(e), o = 0; o < n.length; o++) {
    var c = n[o], u = t[c];
    (i ? e.indexOf(c) !== -1 : e(c, u, t)) && (r[c] = u);
  }
  return r;
};
(function(t) {
  const e = uF, r = fF, n = dF, i = pF, o = (T) => T == null, c = Symbol("encodeFragmentIdentifier");
  function u(T) {
    switch (T.arrayFormat) {
      case "index":
        return (q) => (B, L) => {
          const P = B.length;
          return L === void 0 || T.skipNull && L === null || T.skipEmptyString && L === "" ? B : L === null ? [...B, [p(q, T), "[", P, "]"].join("")] : [
            ...B,
            [p(q, T), "[", p(P, T), "]=", p(L, T)].join("")
          ];
        };
      case "bracket":
        return (q) => (B, L) => L === void 0 || T.skipNull && L === null || T.skipEmptyString && L === "" ? B : L === null ? [...B, [p(q, T), "[]"].join("")] : [...B, [p(q, T), "[]=", p(L, T)].join("")];
      case "colon-list-separator":
        return (q) => (B, L) => L === void 0 || T.skipNull && L === null || T.skipEmptyString && L === "" ? B : L === null ? [...B, [p(q, T), ":list="].join("")] : [...B, [p(q, T), ":list=", p(L, T)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const q = T.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (B) => (L, P) => P === void 0 || T.skipNull && P === null || T.skipEmptyString && P === "" ? L : (P = P === null ? "" : P, L.length === 0 ? [[p(B, T), q, p(P, T)].join("")] : [[L, p(P, T)].join(T.arrayFormatSeparator)]);
      }
      default:
        return (q) => (B, L) => L === void 0 || T.skipNull && L === null || T.skipEmptyString && L === "" ? B : L === null ? [...B, p(q, T)] : [...B, [p(q, T), "=", p(L, T)].join("")];
    }
  }
  function l(T) {
    let q;
    switch (T.arrayFormat) {
      case "index":
        return (B, L, P) => {
          if (q = /\[(\d*)\]$/.exec(B), B = B.replace(/\[\d*\]$/, ""), !q) {
            P[B] = L;
            return;
          }
          P[B] === void 0 && (P[B] = {}), P[B][q[1]] = L;
        };
      case "bracket":
        return (B, L, P) => {
          if (q = /(\[\])$/.exec(B), B = B.replace(/\[\]$/, ""), !q) {
            P[B] = L;
            return;
          }
          if (P[B] === void 0) {
            P[B] = [L];
            return;
          }
          P[B] = [].concat(P[B], L);
        };
      case "colon-list-separator":
        return (B, L, P) => {
          if (q = /(:list)$/.exec(B), B = B.replace(/:list$/, ""), !q) {
            P[B] = L;
            return;
          }
          if (P[B] === void 0) {
            P[B] = [L];
            return;
          }
          P[B] = [].concat(P[B], L);
        };
      case "comma":
      case "separator":
        return (B, L, P) => {
          const v = typeof L == "string" && L.includes(T.arrayFormatSeparator), N = typeof L == "string" && !v && g(L, T).includes(T.arrayFormatSeparator);
          L = N ? g(L, T) : L;
          const ie = v || N ? L.split(T.arrayFormatSeparator).map((le) => g(le, T)) : L === null ? L : g(L, T);
          P[B] = ie;
        };
      case "bracket-separator":
        return (B, L, P) => {
          const v = /(\[\])$/.test(B);
          if (B = B.replace(/\[\]$/, ""), !v) {
            P[B] = L && g(L, T);
            return;
          }
          const N = L === null ? [] : L.split(T.arrayFormatSeparator).map((ie) => g(ie, T));
          if (P[B] === void 0) {
            P[B] = N;
            return;
          }
          P[B] = [].concat(P[B], N);
        };
      default:
        return (B, L, P) => {
          if (P[B] === void 0) {
            P[B] = L;
            return;
          }
          P[B] = [].concat(P[B], L);
        };
    }
  }
  function f(T) {
    if (typeof T != "string" || T.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function p(T, q) {
    return q.encode ? q.strict ? e(T) : encodeURIComponent(T) : T;
  }
  function g(T, q) {
    return q.decode ? r(T) : T;
  }
  function y(T) {
    return Array.isArray(T) ? T.sort() : typeof T == "object" ? y(Object.keys(T)).sort((q, B) => Number(q) - Number(B)).map((q) => T[q]) : T;
  }
  function C(T) {
    const q = T.indexOf("#");
    return q !== -1 && (T = T.slice(0, q)), T;
  }
  function R(T) {
    let q = "";
    const B = T.indexOf("#");
    return B !== -1 && (q = T.slice(B)), q;
  }
  function J(T) {
    T = C(T);
    const q = T.indexOf("?");
    return q === -1 ? "" : T.slice(q + 1);
  }
  function G(T, q) {
    return q.parseNumbers && !Number.isNaN(Number(T)) && typeof T == "string" && T.trim() !== "" ? T = Number(T) : q.parseBooleans && T !== null && (T.toLowerCase() === "true" || T.toLowerCase() === "false") && (T = T.toLowerCase() === "true"), T;
  }
  function H(T, q) {
    q = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, q), f(q.arrayFormatSeparator);
    const B = l(q), L = /* @__PURE__ */ Object.create(null);
    if (typeof T != "string" || (T = T.trim().replace(/^[?#&]/, ""), !T))
      return L;
    for (const P of T.split("&")) {
      if (P === "")
        continue;
      let [v, N] = n(q.decode ? P.replace(/\+/g, " ") : P, "=");
      N = N === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(q.arrayFormat) ? N : g(N, q), B(g(v, q), N, L);
    }
    for (const P of Object.keys(L)) {
      const v = L[P];
      if (typeof v == "object" && v !== null)
        for (const N of Object.keys(v))
          v[N] = G(v[N], q);
      else
        L[P] = G(v, q);
    }
    return q.sort === !1 ? L : (q.sort === !0 ? Object.keys(L).sort() : Object.keys(L).sort(q.sort)).reduce((P, v) => {
      const N = L[v];
      return N && typeof N == "object" && !Array.isArray(N) ? P[v] = y(N) : P[v] = N, P;
    }, /* @__PURE__ */ Object.create(null));
  }
  t.extract = J, t.parse = H, t.stringify = (T, q) => {
    if (!T)
      return "";
    q = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, q), f(q.arrayFormatSeparator);
    const B = (N) => q.skipNull && o(T[N]) || q.skipEmptyString && T[N] === "", L = u(q), P = {};
    for (const N of Object.keys(T))
      B(N) || (P[N] = T[N]);
    const v = Object.keys(P);
    return q.sort !== !1 && v.sort(q.sort), v.map((N) => {
      const ie = T[N];
      return ie === void 0 ? "" : ie === null ? p(N, q) : Array.isArray(ie) ? ie.length === 0 && q.arrayFormat === "bracket-separator" ? p(N, q) + "[]" : ie.reduce(L(N), []).join("&") : p(N, q) + "=" + p(ie, q);
    }).filter((N) => N.length > 0).join("&");
  }, t.parseUrl = (T, q) => {
    q = Object.assign({
      decode: !0
    }, q);
    const [B, L] = n(T, "#");
    return Object.assign(
      {
        url: B.split("?")[0] || "",
        query: H(J(T), q)
      },
      q && q.parseFragmentIdentifier && L ? { fragmentIdentifier: g(L, q) } : {}
    );
  }, t.stringifyUrl = (T, q) => {
    q = Object.assign({
      encode: !0,
      strict: !0,
      [c]: !0
    }, q);
    const B = C(T.url).split("?")[0] || "", L = t.extract(T.url), P = t.parse(L, { sort: !1 }), v = Object.assign(P, T.query);
    let N = t.stringify(v, q);
    N && (N = `?${N}`);
    let ie = R(T.url);
    return T.fragmentIdentifier && (ie = `#${q[c] ? p(T.fragmentIdentifier, q) : T.fragmentIdentifier}`), `${B}${N}${ie}`;
  }, t.pick = (T, q, B) => {
    B = Object.assign({
      parseFragmentIdentifier: !0,
      [c]: !1
    }, B);
    const { url: L, query: P, fragmentIdentifier: v } = t.parseUrl(T, B);
    return t.stringifyUrl({
      url: L,
      query: i(P, q),
      fragmentIdentifier: v
    }, B);
  }, t.exclude = (T, q, B) => {
    const L = Array.isArray(q) ? (P) => !q.includes(P) : (P, v) => !q(P, v);
    return t.pick(T, L, B);
  };
})($c);
const gF = {
  waku: {
    publish: "waku_publish",
    batchPublish: "waku_batchPublish",
    subscribe: "waku_subscribe",
    batchSubscribe: "waku_batchSubscribe",
    subscription: "waku_subscription",
    unsubscribe: "waku_unsubscribe",
    batchUnsubscribe: "waku_batchUnsubscribe"
  },
  irn: {
    publish: "irn_publish",
    batchPublish: "irn_batchPublish",
    subscribe: "irn_subscribe",
    batchSubscribe: "irn_batchSubscribe",
    subscription: "irn_subscription",
    unsubscribe: "irn_unsubscribe",
    batchUnsubscribe: "irn_batchUnsubscribe"
  },
  iridium: {
    publish: "iridium_publish",
    batchPublish: "iridium_batchPublish",
    subscribe: "iridium_subscribe",
    batchSubscribe: "iridium_batchSubscribe",
    subscription: "iridium_subscription",
    unsubscribe: "iridium_unsubscribe",
    batchUnsubscribe: "iridium_batchUnsubscribe"
  }
}, mF = ":";
function vF(t) {
  const [e, r] = t.split(mF);
  return { namespace: e, reference: r };
}
function yF(t, e = []) {
  const r = [];
  return Object.keys(t).forEach((n) => {
    if (e.length && !e.includes(n))
      return;
    const i = t[n];
    r.push(...i.accounts);
  }), r;
}
function DE(t, e) {
  return t.includes(":") ? [t] : e.chains || [];
}
const OE = "base10", Qr = "base16", hp = "base64pad", Cg = "utf8", PE = 0, xo = 1, _F = 0, u_ = 1, fp = 12, Ig = 32;
function wF() {
  const t = _g.generateKeyPair();
  return { privateKey: Zr(t.secretKey, Qr), publicKey: Zr(t.publicKey, Qr) };
}
function dp() {
  const t = La.randomBytes(Ig);
  return Zr(t, Qr);
}
function bF(t, e) {
  const r = _g.sharedKey(dn(t, Qr), dn(e, Qr), !0), n = new a9(gf.SHA256, r).expand(Ig);
  return Zr(n, Qr);
}
function EF(t) {
  const e = gf.hash(dn(t, Qr));
  return Zr(e, Qr);
}
function da(t) {
  const e = gf.hash(dn(t, Cg));
  return Zr(e, Qr);
}
function SF(t) {
  return dn(`${t}`, OE);
}
function mu(t) {
  return Number(Zr(t, OE));
}
function CF(t) {
  const e = SF(typeof t.type < "u" ? t.type : PE);
  if (mu(e) === xo && typeof t.senderPublicKey > "u")
    throw new Error("Missing sender public key for type 1 envelope");
  const r = typeof t.senderPublicKey < "u" ? dn(t.senderPublicKey, Qr) : void 0, n = typeof t.iv < "u" ? dn(t.iv, Qr) : La.randomBytes(fp), i = new vg.ChaCha20Poly1305(dn(t.symKey, Qr)).seal(n, dn(t.message, Cg));
  return xF({ type: e, sealed: i, iv: n, senderPublicKey: r });
}
function IF(t) {
  const e = new vg.ChaCha20Poly1305(dn(t.symKey, Qr)), { sealed: r, iv: n } = oh(t.encoded), i = e.open(n, r);
  if (i === null)
    throw new Error("Failed to decrypt");
  return Zr(i, Cg);
}
function xF(t) {
  if (mu(t.type) === xo) {
    if (typeof t.senderPublicKey > "u")
      throw new Error("Missing sender public key for type 1 envelope");
    return Zr(op([t.type, t.senderPublicKey, t.iv, t.sealed]), hp);
  }
  return Zr(op([t.type, t.iv, t.sealed]), hp);
}
function oh(t) {
  const e = dn(t, hp), r = e.slice(_F, u_), n = u_;
  if (mu(r) === xo) {
    const u = n + Ig, l = u + fp, f = e.slice(n, u), p = e.slice(u, l), g = e.slice(l);
    return { type: r, sealed: g, iv: p, senderPublicKey: f };
  }
  const i = n + fp, o = e.slice(n, i), c = e.slice(i);
  return { type: r, sealed: c, iv: o };
}
function RF(t, e) {
  const r = oh(t);
  return TE({ type: mu(r.type), senderPublicKey: typeof r.senderPublicKey < "u" ? Zr(r.senderPublicKey, Qr) : void 0, receiverPublicKey: e?.receiverPublicKey });
}
function TE(t) {
  const e = t?.type || PE;
  if (e === xo) {
    if (typeof t?.senderPublicKey > "u")
      throw new Error("missing sender public key");
    if (typeof t?.receiverPublicKey > "u")
      throw new Error("missing receiver public key");
  }
  return { type: e, senderPublicKey: t?.senderPublicKey, receiverPublicKey: t?.receiverPublicKey };
}
function l_(t) {
  return t.type === xo && typeof t.senderPublicKey == "string" && typeof t.receiverPublicKey == "string";
}
var AF = Object.defineProperty, h_ = Object.getOwnPropertySymbols, MF = Object.prototype.hasOwnProperty, DF = Object.prototype.propertyIsEnumerable, f_ = (t, e, r) => e in t ? AF(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, d_ = (t, e) => {
  for (var r in e || (e = {}))
    MF.call(e, r) && f_(t, r, e[r]);
  if (h_)
    for (var r of h_(e))
      DF.call(e, r) && f_(t, r, e[r]);
  return t;
};
const OF = "ReactNative", In = { reactNative: "react-native", node: "node", browser: "browser", unknown: "unknown" }, PF = "js";
function xg() {
  return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
}
function Fa() {
  return !bg() && !!Eg() && navigator.product === OF;
}
function Ba() {
  return !xg() && !!Eg() && !!bg();
}
function vu() {
  return Fa() ? In.reactNative : xg() ? In.node : Ba() ? In.browser : In.unknown;
}
function TF() {
  var t;
  try {
    return Fa() && typeof global < "u" && typeof (global == null ? void 0 : global.Application) < "u" ? (t = global.Application) == null ? void 0 : t.applicationId : void 0;
  } catch {
    return;
  }
}
function NF(t, e) {
  let r = $c.parse(t);
  return r = d_(d_({}, r), e), t = $c.stringify(r), t;
}
function kF() {
  return AE() || { name: "", description: "", url: "", icons: [""] };
}
function LF() {
  if (vu() === In.reactNative && typeof global < "u" && typeof (global == null ? void 0 : global.Platform) < "u") {
    const { OS: r, Version: n } = global.Platform;
    return [r, n].join("-");
  }
  const t = _$();
  if (t === null)
    return "unknown";
  const e = t.os ? t.os.replace(" ", "").toLowerCase() : "unknown";
  return t.type === "browser" ? [e, t.name, t.version].join("-") : [e, t.version].join("-");
}
function $F() {
  var t;
  const e = vu();
  return e === In.browser ? [e, ((t = RE()) == null ? void 0 : t.host) || "unknown"].join(":") : e;
}
function FF(t, e, r) {
  const n = LF(), i = $F();
  return [[t, e].join("-"), [PF, r].join("-"), n, i].join("/");
}
function BF({ protocol: t, version: e, relayUrl: r, sdkVersion: n, auth: i, projectId: o, useOnCloseEvent: c, bundleId: u }) {
  const l = r.split("?"), f = FF(t, e, n), p = { auth: i, ua: f, projectId: o, useOnCloseEvent: c || void 0, origin: u || void 0 }, g = NF(l[1] || "", p);
  return l[0] + "?" + g;
}
function lo(t, e) {
  return t.filter((r) => e.includes(r)).length === t.length;
}
function NE(t) {
  return Object.fromEntries(t.entries());
}
function kE(t) {
  return new Map(Object.entries(t));
}
function ia(t = He.FIVE_MINUTES, e) {
  const r = He.toMiliseconds(t || He.FIVE_MINUTES);
  let n, i, o;
  return { resolve: (c) => {
    o && n && (clearTimeout(o), n(c));
  }, reject: (c) => {
    o && i && (clearTimeout(o), i(c));
  }, done: () => new Promise((c, u) => {
    o = setTimeout(() => {
      u(new Error(e));
    }, r), n = c, i = u;
  }) };
}
function Fc(t, e, r) {
  return new Promise(async (n, i) => {
    const o = setTimeout(() => i(new Error(r)), e);
    try {
      const c = await t;
      n(c);
    } catch (c) {
      i(c);
    }
    clearTimeout(o);
  });
}
function LE(t, e) {
  if (typeof e == "string" && e.startsWith(`${t}:`))
    return e;
  if (t.toLowerCase() === "topic") {
    if (typeof e != "string")
      throw new Error('Value must be "string" for expirer target type: topic');
    return `topic:${e}`;
  } else if (t.toLowerCase() === "id") {
    if (typeof e != "number")
      throw new Error('Value must be "number" for expirer target type: id');
    return `id:${e}`;
  }
  throw new Error(`Unknown expirer target type: ${t}`);
}
function UF(t) {
  return LE("topic", t);
}
function jF(t) {
  return LE("id", t);
}
function $E(t) {
  const [e, r] = t.split(":"), n = { id: void 0, topic: void 0 };
  if (e === "topic" && typeof r == "string")
    n.topic = r;
  else if (e === "id" && Number.isInteger(Number(r)))
    n.id = Number(r);
  else
    throw new Error(`Invalid target, expected id:number or topic:string, got ${e}:${r}`);
  return n;
}
function ui(t, e) {
  return He.fromMiliseconds((e || Date.now()) + He.toMiliseconds(t));
}
function bs(t) {
  return Date.now() >= He.toMiliseconds(t);
}
function gr(t, e) {
  return `${t}${e ? `:${e}` : ""}`;
}
function y0(t = [], e = []) {
  return [.../* @__PURE__ */ new Set([...t, ...e])];
}
async function HF({ id: t, topic: e, wcDeepLink: r }) {
  try {
    if (!r)
      return;
    let i = (typeof r == "string" ? JSON.parse(r) : r)?.href;
    if (typeof i != "string")
      return;
    i.endsWith("/") && (i = i.slice(0, -1));
    const o = `${i}/wc?requestId=${t}&sessionTopic=${e}`, c = vu();
    c === In.browser ? o.startsWith("https://") ? window.open(o, "_blank", "noreferrer noopener") : window.open(o, "_self", "noreferrer noopener") : c === In.reactNative && typeof (global == null ? void 0 : global.Linking) < "u" && await global.Linking.openURL(o);
  } catch (n) {
    console.error(n);
  }
}
async function qF(t, e) {
  try {
    return await t.getItem(e) || (Ba() ? localStorage.getItem(e) : void 0);
  } catch (r) {
    console.error(r);
  }
}
const zF = "irn";
function pp(t) {
  return t?.relay || { protocol: zF };
}
function Kl(t) {
  const e = gF[t];
  if (typeof e > "u")
    throw new Error(`Relay Protocol not supported: ${t}`);
  return e;
}
var VF = Object.defineProperty, p_ = Object.getOwnPropertySymbols, WF = Object.prototype.hasOwnProperty, KF = Object.prototype.propertyIsEnumerable, g_ = (t, e, r) => e in t ? VF(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, GF = (t, e) => {
  for (var r in e || (e = {}))
    WF.call(e, r) && g_(t, r, e[r]);
  if (p_)
    for (var r of p_(e))
      KF.call(e, r) && g_(t, r, e[r]);
  return t;
};
function JF(t, e = "-") {
  const r = {}, n = "relay" + e;
  return Object.keys(t).forEach((i) => {
    if (i.startsWith(n)) {
      const o = i.replace(n, ""), c = t[i];
      r[o] = c;
    }
  }), r;
}
function m_(t) {
  t = t.includes("wc://") ? t.replace("wc://", "") : t, t = t.includes("wc:") ? t.replace("wc:", "") : t;
  const e = t.indexOf(":"), r = t.indexOf("?") !== -1 ? t.indexOf("?") : void 0, n = t.substring(0, e), i = t.substring(e + 1, r).split("@"), o = typeof r < "u" ? t.substring(r) : "", c = $c.parse(o);
  return { protocol: n, topic: QF(i[0]), version: parseInt(i[1], 10), symKey: c.symKey, relay: JF(c) };
}
function QF(t) {
  return t.startsWith("//") ? t.substring(2) : t;
}
function ZF(t, e = "-") {
  const r = "relay", n = {};
  return Object.keys(t).forEach((i) => {
    const o = r + e + i;
    t[i] && (n[o] = t[i]);
  }), n;
}
function YF(t) {
  return `${t.protocol}:${t.topic}@${t.version}?` + $c.stringify(GF({ symKey: t.symKey }, ZF(t.relay)));
}
function Ua(t) {
  const e = [];
  return t.forEach((r) => {
    const [n, i] = r.split(":");
    e.push(`${n}:${i}`);
  }), e;
}
function XF(t) {
  const e = [];
  return Object.values(t).forEach((r) => {
    e.push(...Ua(r.accounts));
  }), e;
}
function eB(t, e) {
  const r = [];
  return Object.values(t).forEach((n) => {
    Ua(n.accounts).includes(e) && r.push(...n.methods);
  }), r;
}
function tB(t, e) {
  const r = [];
  return Object.values(t).forEach((n) => {
    Ua(n.accounts).includes(e) && r.push(...n.events);
  }), r;
}
function rB(t, e) {
  const r = Gl(t, e);
  if (r)
    throw new Error(r.message);
  const n = {};
  for (const [i, o] of Object.entries(t))
    n[i] = { methods: o.methods, events: o.events, chains: o.accounts.map((c) => `${c.split(":")[0]}:${c.split(":")[1]}`) };
  return n;
}
function Rg(t) {
  return t.includes(":");
}
function bc(t) {
  return Rg(t) ? t.split(":")[0] : t;
}
const nB = { INVALID_METHOD: { message: "Invalid method.", code: 1001 }, INVALID_EVENT: { message: "Invalid event.", code: 1002 }, INVALID_UPDATE_REQUEST: { message: "Invalid update request.", code: 1003 }, INVALID_EXTEND_REQUEST: { message: "Invalid extend request.", code: 1004 }, INVALID_SESSION_SETTLE_REQUEST: { message: "Invalid session settle request.", code: 1005 }, UNAUTHORIZED_METHOD: { message: "Unauthorized method.", code: 3001 }, UNAUTHORIZED_EVENT: { message: "Unauthorized event.", code: 3002 }, UNAUTHORIZED_UPDATE_REQUEST: { message: "Unauthorized update request.", code: 3003 }, UNAUTHORIZED_EXTEND_REQUEST: { message: "Unauthorized extend request.", code: 3004 }, USER_REJECTED: { message: "User rejected.", code: 5e3 }, USER_REJECTED_CHAINS: { message: "User rejected chains.", code: 5001 }, USER_REJECTED_METHODS: { message: "User rejected methods.", code: 5002 }, USER_REJECTED_EVENTS: { message: "User rejected events.", code: 5003 }, UNSUPPORTED_CHAINS: { message: "Unsupported chains.", code: 5100 }, UNSUPPORTED_METHODS: { message: "Unsupported methods.", code: 5101 }, UNSUPPORTED_EVENTS: { message: "Unsupported events.", code: 5102 }, UNSUPPORTED_ACCOUNTS: { message: "Unsupported accounts.", code: 5103 }, UNSUPPORTED_NAMESPACE_KEY: { message: "Unsupported namespace key.", code: 5104 }, USER_DISCONNECTED: { message: "User disconnected.", code: 6e3 }, SESSION_SETTLEMENT_FAILED: { message: "Session settlement failed.", code: 7e3 }, WC_METHOD_UNSUPPORTED: { message: "Unsupported wc_ method.", code: 10001 } }, iB = { NOT_INITIALIZED: { message: "Not initialized.", code: 1 }, NO_MATCHING_KEY: { message: "No matching key.", code: 2 }, RESTORE_WILL_OVERRIDE: { message: "Restore will override.", code: 3 }, RESUBSCRIBED: { message: "Resubscribed.", code: 4 }, MISSING_OR_INVALID: { message: "Missing or invalid.", code: 5 }, EXPIRED: { message: "Expired.", code: 6 }, UNKNOWN_TYPE: { message: "Unknown type.", code: 7 }, MISMATCHED_TOPIC: { message: "Mismatched topic.", code: 8 }, NON_CONFORMING_NAMESPACES: { message: "Non conforming namespaces.", code: 9 } };
function Me(t, e) {
  const { message: r, code: n } = iB[t];
  return { message: e ? `${r} ${e}` : r, code: n };
}
function or(t, e) {
  const { message: r, code: n } = nB[t];
  return { message: e ? `${r} ${e}` : r, code: n };
}
function Pi(t, e) {
  return Array.isArray(t) ? typeof e < "u" && t.length ? t.every(e) : !0 : !1;
}
function pa(t) {
  return Object.getPrototypeOf(t) === Object.prototype && Object.keys(t).length;
}
function Jr(t) {
  return typeof t > "u";
}
function Rr(t, e) {
  return e && Jr(t) ? !0 : typeof t == "string" && !!t.trim().length;
}
function Ag(t, e) {
  return e && Jr(t) ? !0 : typeof t == "number" && !isNaN(t);
}
function sB(t, e) {
  const { requiredNamespaces: r } = e, n = Object.keys(t.namespaces), i = Object.keys(r);
  let o = !0;
  return lo(i, n) ? (n.forEach((c) => {
    const { accounts: u, methods: l, events: f } = t.namespaces[c], p = Ua(u), g = r[c];
    (!lo(DE(c, g), p) || !lo(g.methods, l) || !lo(g.events, f)) && (o = !1);
  }), o) : !1;
}
function ah(t) {
  return Rr(t, !1) && t.includes(":") ? t.split(":").length === 2 : !1;
}
function oB(t) {
  if (Rr(t, !1) && t.includes(":")) {
    const e = t.split(":");
    if (e.length === 3) {
      const r = e[0] + ":" + e[1];
      return !!e[2] && ah(r);
    }
  }
  return !1;
}
function aB(t) {
  if (Rr(t, !1))
    try {
      return typeof new URL(t) < "u";
    } catch {
      return !1;
    }
  return !1;
}
function cB(t) {
  var e;
  return (e = t?.proposer) == null ? void 0 : e.publicKey;
}
function uB(t) {
  return t?.topic;
}
function lB(t, e) {
  let r = null;
  return Rr(t?.publicKey, !1) || (r = Me("MISSING_OR_INVALID", `${e} controller public key should be a string`)), r;
}
function v_(t) {
  let e = !0;
  return Pi(t) ? t.length && (e = t.every((r) => Rr(r, !1))) : e = !1, e;
}
function hB(t, e, r) {
  let n = null;
  return Pi(e) && e.length ? e.forEach((i) => {
    n || ah(i) || (n = or("UNSUPPORTED_CHAINS", `${r}, chain ${i} should be a string and conform to "namespace:chainId" format`));
  }) : ah(t) || (n = or("UNSUPPORTED_CHAINS", `${r}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), n;
}
function fB(t, e, r) {
  let n = null;
  return Object.entries(t).forEach(([i, o]) => {
    if (n)
      return;
    const c = hB(i, DE(i, o), `${e} ${r}`);
    c && (n = c);
  }), n;
}
function dB(t, e) {
  let r = null;
  return Pi(t) ? t.forEach((n) => {
    r || oB(n) || (r = or("UNSUPPORTED_ACCOUNTS", `${e}, account ${n} should be a string and conform to "namespace:chainId:address" format`));
  }) : r = or("UNSUPPORTED_ACCOUNTS", `${e}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), r;
}
function pB(t, e) {
  let r = null;
  return Object.values(t).forEach((n) => {
    if (r)
      return;
    const i = dB(n?.accounts, `${e} namespace`);
    i && (r = i);
  }), r;
}
function gB(t, e) {
  let r = null;
  return v_(t?.methods) ? v_(t?.events) || (r = or("UNSUPPORTED_EVENTS", `${e}, events should be an array of strings or empty array for no events`)) : r = or("UNSUPPORTED_METHODS", `${e}, methods should be an array of strings or empty array for no methods`), r;
}
function FE(t, e) {
  let r = null;
  return Object.values(t).forEach((n) => {
    if (r)
      return;
    const i = gB(n, `${e}, namespace`);
    i && (r = i);
  }), r;
}
function mB(t, e, r) {
  let n = null;
  if (t && pa(t)) {
    const i = FE(t, e);
    i && (n = i);
    const o = fB(t, e, r);
    o && (n = o);
  } else
    n = Me("MISSING_OR_INVALID", `${e}, ${r} should be an object with data`);
  return n;
}
function Gl(t, e) {
  let r = null;
  if (t && pa(t)) {
    const n = FE(t, e);
    n && (r = n);
    const i = pB(t, e);
    i && (r = i);
  } else
    r = Me("MISSING_OR_INVALID", `${e}, namespaces should be an object with data`);
  return r;
}
function BE(t) {
  return Rr(t.protocol, !0);
}
function vB(t, e) {
  let r = !1;
  return e && !t ? r = !0 : t && Pi(t) && t.length && t.forEach((n) => {
    r = BE(n);
  }), r;
}
function yB(t) {
  return typeof t == "number";
}
function ln(t) {
  return typeof t < "u" && typeof t !== null;
}
function _B(t) {
  return !(!t || typeof t != "object" || !t.code || !Ag(t.code, !1) || !t.message || !Rr(t.message, !1));
}
function wB(t) {
  return !(Jr(t) || !Rr(t.method, !1));
}
function bB(t) {
  return !(Jr(t) || Jr(t.result) && Jr(t.error) || !Ag(t.id, !1) || !Rr(t.jsonrpc, !1));
}
function EB(t) {
  return !(Jr(t) || !Rr(t.name, !1));
}
function y_(t, e) {
  return !(!ah(e) || !XF(t).includes(e));
}
function SB(t, e, r) {
  return Rr(r, !1) ? eB(t, e).includes(r) : !1;
}
function CB(t, e, r) {
  return Rr(r, !1) ? tB(t, e).includes(r) : !1;
}
function __(t, e, r) {
  let n = null;
  const i = IB(t), o = xB(e), c = Object.keys(i), u = Object.keys(o), l = w_(Object.keys(t)), f = w_(Object.keys(e)), p = l.filter((g) => !f.includes(g));
  return p.length && (n = Me("NON_CONFORMING_NAMESPACES", `${r} namespaces keys don't satisfy requiredNamespaces.
      Required: ${p.toString()}
      Received: ${Object.keys(e).toString()}`)), lo(c, u) || (n = Me("NON_CONFORMING_NAMESPACES", `${r} namespaces chains don't satisfy required namespaces.
      Required: ${c.toString()}
      Approved: ${u.toString()}`)), Object.keys(e).forEach((g) => {
    if (!g.includes(":") || n)
      return;
    const y = Ua(e[g].accounts);
    y.includes(g) || (n = Me("NON_CONFORMING_NAMESPACES", `${r} namespaces accounts don't satisfy namespace accounts for ${g}
        Required: ${g}
        Approved: ${y.toString()}`));
  }), c.forEach((g) => {
    n || (lo(i[g].methods, o[g].methods) ? lo(i[g].events, o[g].events) || (n = Me("NON_CONFORMING_NAMESPACES", `${r} namespaces events don't satisfy namespace events for ${g}`)) : n = Me("NON_CONFORMING_NAMESPACES", `${r} namespaces methods don't satisfy namespace methods for ${g}`));
  }), n;
}
function IB(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    var n;
    r.includes(":") ? e[r] = t[r] : (n = t[r].chains) == null || n.forEach((i) => {
      e[i] = { methods: t[r].methods, events: t[r].events };
    });
  }), e;
}
function w_(t) {
  return [...new Set(t.map((e) => e.includes(":") ? e.split(":")[0] : e))];
}
function xB(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    r.includes(":") ? e[r] = t[r] : Ua(t[r].accounts)?.forEach((i) => {
      e[i] = { accounts: t[r].accounts.filter((o) => o.includes(`${i}:`)), methods: t[r].methods, events: t[r].events };
    });
  }), e;
}
function RB(t, e) {
  return Ag(t, !1) && t <= e.max && t >= e.min;
}
function b_() {
  const t = vu();
  return new Promise((e) => {
    switch (t) {
      case In.browser:
        e(AB());
        break;
      case In.reactNative:
        e(MB());
        break;
      case In.node:
        e(DB());
        break;
      default:
        e(!0);
    }
  });
}
function AB() {
  return Ba() && navigator?.onLine;
}
async function MB() {
  return Fa() && typeof global < "u" && global != null && global.NetInfo ? (await (global == null ? void 0 : global.NetInfo.fetch()))?.isConnected : !0;
}
function DB() {
  return !0;
}
function OB(t) {
  switch (vu()) {
    case In.browser:
      PB(t);
      break;
    case In.reactNative:
      TB(t);
      break;
  }
}
function PB(t) {
  !Fa() && Ba() && (window.addEventListener("online", () => t(!0)), window.addEventListener("offline", () => t(!1)));
}
function TB(t) {
  Fa() && typeof global < "u" && global != null && global.NetInfo && global?.NetInfo.addEventListener((e) => t(e?.isConnected));
}
const _0 = {};
let Ll = class {
  static get(e) {
    return _0[e];
  }
  static set(e, r) {
    _0[e] = r;
  }
  static delete(e) {
    delete _0[e];
  }
};
const NB = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, kB = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, LB = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $B(t, e) {
  if (t === "__proto__" || t === "constructor" && e && typeof e == "object" && "prototype" in e) {
    FB(t);
    return;
  }
  return e;
}
function FB(t) {
  console.warn(`[destr] Dropping "${t}" key to prevent prototype pollution.`);
}
function $l(t, e = {}) {
  if (typeof t != "string")
    return t;
  const r = t.trim();
  if (
    // eslint-disable-next-line unicorn/prefer-at
    t[0] === '"' && t.at(-1) === '"' && !t.includes("\\")
  )
    return r.slice(1, -1);
  if (r.length <= 9) {
    const n = r.toLowerCase();
    if (n === "true")
      return !0;
    if (n === "false")
      return !1;
    if (n === "undefined")
      return;
    if (n === "null")
      return null;
    if (n === "nan")
      return Number.NaN;
    if (n === "infinity")
      return Number.POSITIVE_INFINITY;
    if (n === "-infinity")
      return Number.NEGATIVE_INFINITY;
  }
  if (!LB.test(t)) {
    if (e.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return t;
  }
  try {
    if (NB.test(t) || kB.test(t)) {
      if (e.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(t, $B);
    }
    return JSON.parse(t);
  } catch (n) {
    if (e.strict)
      throw n;
    return t;
  }
}
function BB(t) {
  return !t || typeof t.then != "function" ? Promise.resolve(t) : t;
}
function Cr(t, ...e) {
  try {
    return BB(t(...e));
  } catch (r) {
    return Promise.reject(r);
  }
}
function UB(t) {
  const e = typeof t;
  return t === null || e !== "object" && e !== "function";
}
function jB(t) {
  const e = Object.getPrototypeOf(t);
  return !e || e.isPrototypeOf(Object);
}
function Jl(t) {
  if (UB(t))
    return String(t);
  if (jB(t) || Array.isArray(t))
    return JSON.stringify(t);
  if (typeof t.toJSON == "function")
    return Jl(t.toJSON());
  throw new Error("[unstorage] Cannot stringify value!");
}
function UE() {
  if (typeof Buffer === void 0)
    throw new TypeError("[unstorage] Buffer is not supported!");
}
const gp = "base64:";
function HB(t) {
  if (typeof t == "string")
    return t;
  UE();
  const e = Buffer.from(t).toString("base64");
  return gp + e;
}
function qB(t) {
  return typeof t != "string" || !t.startsWith(gp) ? t : (UE(), Buffer.from(t.slice(gp.length), "base64"));
}
function un(t) {
  return t ? t.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "") : "";
}
function zB(...t) {
  return un(t.join(":"));
}
function Fl(t) {
  return t = un(t), t ? t + ":" : "";
}
const VB = "memory", WB = () => {
  const t = /* @__PURE__ */ new Map();
  return {
    name: VB,
    options: {},
    hasItem(e) {
      return t.has(e);
    },
    getItem(e) {
      return t.get(e) ?? null;
    },
    getItemRaw(e) {
      return t.get(e) ?? null;
    },
    setItem(e, r) {
      t.set(e, r);
    },
    setItemRaw(e, r) {
      t.set(e, r);
    },
    removeItem(e) {
      t.delete(e);
    },
    getKeys() {
      return Array.from(t.keys());
    },
    clear() {
      t.clear();
    },
    dispose() {
      t.clear();
    }
  };
};
function KB(t = {}) {
  const e = {
    mounts: { "": t.driver || WB() },
    mountpoints: [""],
    watching: !1,
    watchListeners: [],
    unwatch: {}
  }, r = (f) => {
    for (const p of e.mountpoints)
      if (f.startsWith(p))
        return {
          base: p,
          relativeKey: f.slice(p.length),
          driver: e.mounts[p]
        };
    return {
      base: "",
      relativeKey: f,
      driver: e.mounts[""]
    };
  }, n = (f, p) => e.mountpoints.filter(
    (g) => g.startsWith(f) || p && f.startsWith(g)
  ).map((g) => ({
    relativeBase: f.length > g.length ? f.slice(g.length) : void 0,
    mountpoint: g,
    driver: e.mounts[g]
  })), i = (f, p) => {
    if (e.watching) {
      p = un(p);
      for (const g of e.watchListeners)
        g(f, p);
    }
  }, o = async () => {
    if (!e.watching) {
      e.watching = !0;
      for (const f in e.mounts)
        e.unwatch[f] = await E_(
          e.mounts[f],
          i,
          f
        );
    }
  }, c = async () => {
    if (e.watching) {
      for (const f in e.unwatch)
        await e.unwatch[f]();
      e.unwatch = {}, e.watching = !1;
    }
  }, u = (f, p, g) => {
    const y = /* @__PURE__ */ new Map(), C = (R) => {
      let J = y.get(R.base);
      return J || (J = {
        driver: R.driver,
        base: R.base,
        items: []
      }, y.set(R.base, J)), J;
    };
    for (const R of f) {
      const J = typeof R == "string", G = un(J ? R : R.key), H = J ? void 0 : R.value, T = J || !R.options ? p : { ...p, ...R.options }, q = r(G);
      C(q).items.push({
        key: G,
        value: H,
        relativeKey: q.relativeKey,
        options: T
      });
    }
    return Promise.all([...y.values()].map((R) => g(R))).then(
      (R) => R.flat()
    );
  }, l = {
    // Item
    hasItem(f, p = {}) {
      f = un(f);
      const { relativeKey: g, driver: y } = r(f);
      return Cr(y.hasItem, g, p);
    },
    getItem(f, p = {}) {
      f = un(f);
      const { relativeKey: g, driver: y } = r(f);
      return Cr(y.getItem, g, p).then(
        (C) => $l(C)
      );
    },
    getItems(f, p) {
      return u(f, p, (g) => g.driver.getItems ? Cr(
        g.driver.getItems,
        g.items.map((y) => ({
          key: y.relativeKey,
          options: y.options
        })),
        p
      ).then(
        (y) => y.map((C) => ({
          key: zB(g.base, C.key),
          value: $l(C.value)
        }))
      ) : Promise.all(
        g.items.map((y) => Cr(
          g.driver.getItem,
          y.relativeKey,
          y.options
        ).then((C) => ({
          key: y.key,
          value: $l(C)
        })))
      ));
    },
    getItemRaw(f, p = {}) {
      f = un(f);
      const { relativeKey: g, driver: y } = r(f);
      return y.getItemRaw ? Cr(y.getItemRaw, g, p) : Cr(y.getItem, g, p).then(
        (C) => qB(C)
      );
    },
    async setItem(f, p, g = {}) {
      if (p === void 0)
        return l.removeItem(f);
      f = un(f);
      const { relativeKey: y, driver: C } = r(f);
      C.setItem && (await Cr(C.setItem, y, Jl(p), g), C.watch || i("update", f));
    },
    async setItems(f, p) {
      await u(f, p, async (g) => {
        g.driver.setItems && await Cr(
          g.driver.setItems,
          g.items.map((y) => ({
            key: y.relativeKey,
            value: Jl(y.value),
            options: y.options
          })),
          p
        ), g.driver.setItem && await Promise.all(
          g.items.map((y) => Cr(
            g.driver.setItem,
            y.relativeKey,
            Jl(y.value),
            y.options
          ))
        );
      });
    },
    async setItemRaw(f, p, g = {}) {
      if (p === void 0)
        return l.removeItem(f, g);
      f = un(f);
      const { relativeKey: y, driver: C } = r(f);
      if (C.setItemRaw)
        await Cr(C.setItemRaw, y, p, g);
      else if (C.setItem)
        await Cr(C.setItem, y, HB(p), g);
      else
        return;
      C.watch || i("update", f);
    },
    async removeItem(f, p = {}) {
      typeof p == "boolean" && (p = { removeMeta: p }), f = un(f);
      const { relativeKey: g, driver: y } = r(f);
      y.removeItem && (await Cr(y.removeItem, g, p), (p.removeMeta || p.removeMata) && await Cr(y.removeItem, g + "$", p), y.watch || i("remove", f));
    },
    // Meta
    async getMeta(f, p = {}) {
      typeof p == "boolean" && (p = { nativeOnly: p }), f = un(f);
      const { relativeKey: g, driver: y } = r(f), C = /* @__PURE__ */ Object.create(null);
      if (y.getMeta && Object.assign(C, await Cr(y.getMeta, g, p)), !p.nativeOnly) {
        const R = await Cr(
          y.getItem,
          g + "$",
          p
        ).then((J) => $l(J));
        R && typeof R == "object" && (typeof R.atime == "string" && (R.atime = new Date(R.atime)), typeof R.mtime == "string" && (R.mtime = new Date(R.mtime)), Object.assign(C, R));
      }
      return C;
    },
    setMeta(f, p, g = {}) {
      return this.setItem(f + "$", p, g);
    },
    removeMeta(f, p = {}) {
      return this.removeItem(f + "$", p);
    },
    // Keys
    async getKeys(f, p = {}) {
      f = Fl(f);
      const g = n(f, !0);
      let y = [];
      const C = [];
      for (const R of g) {
        const G = (await Cr(
          R.driver.getKeys,
          R.relativeBase,
          p
        )).map((H) => R.mountpoint + un(H)).filter((H) => !y.some((T) => H.startsWith(T)));
        C.push(...G), y = [
          R.mountpoint,
          ...y.filter((H) => !H.startsWith(R.mountpoint))
        ];
      }
      return f ? C.filter((R) => R.startsWith(f) && !R.endsWith("$")) : C.filter((R) => !R.endsWith("$"));
    },
    // Utils
    async clear(f, p = {}) {
      f = Fl(f), await Promise.all(
        n(f, !1).map(async (g) => {
          if (g.driver.clear)
            return Cr(g.driver.clear, g.relativeBase, p);
          if (g.driver.removeItem) {
            const y = await g.driver.getKeys(g.relativeBase || "", p);
            return Promise.all(
              y.map((C) => g.driver.removeItem(C, p))
            );
          }
        })
      );
    },
    async dispose() {
      await Promise.all(
        Object.values(e.mounts).map((f) => S_(f))
      );
    },
    async watch(f) {
      return await o(), e.watchListeners.push(f), async () => {
        e.watchListeners = e.watchListeners.filter(
          (p) => p !== f
        ), e.watchListeners.length === 0 && await c();
      };
    },
    async unwatch() {
      e.watchListeners = [], await c();
    },
    // Mount
    mount(f, p) {
      if (f = Fl(f), f && e.mounts[f])
        throw new Error(`already mounted at ${f}`);
      return f && (e.mountpoints.push(f), e.mountpoints.sort((g, y) => y.length - g.length)), e.mounts[f] = p, e.watching && Promise.resolve(E_(p, i, f)).then((g) => {
        e.unwatch[f] = g;
      }).catch(console.error), l;
    },
    async unmount(f, p = !0) {
      f = Fl(f), !(!f || !e.mounts[f]) && (e.watching && f in e.unwatch && (e.unwatch[f](), delete e.unwatch[f]), p && await S_(e.mounts[f]), e.mountpoints = e.mountpoints.filter((g) => g !== f), delete e.mounts[f]);
    },
    getMount(f = "") {
      f = un(f) + ":";
      const p = r(f);
      return {
        driver: p.driver,
        base: p.base
      };
    },
    getMounts(f = "", p = {}) {
      return f = un(f), n(f, p.parents).map((y) => ({
        driver: y.driver,
        base: y.mountpoint
      }));
    }
  };
  return l;
}
function E_(t, e, r) {
  return t.watch ? t.watch((n, i) => e(n, r + i)) : () => {
  };
}
async function S_(t) {
  typeof t.dispose == "function" && await Cr(t.dispose);
}
function Ro(t) {
  return new Promise((e, r) => {
    t.oncomplete = t.onsuccess = () => e(t.result), t.onabort = t.onerror = () => r(t.error);
  });
}
function jE(t, e) {
  const r = indexedDB.open(t);
  r.onupgradeneeded = () => r.result.createObjectStore(e);
  const n = Ro(r);
  return (i, o) => n.then((c) => o(c.transaction(e, i).objectStore(e)));
}
let w0;
function yu() {
  return w0 || (w0 = jE("keyval-store", "keyval")), w0;
}
function C_(t, e = yu()) {
  return e("readonly", (r) => Ro(r.get(t)));
}
function GB(t, e, r = yu()) {
  return r("readwrite", (n) => (n.put(e, t), Ro(n.transaction)));
}
function JB(t, e = yu()) {
  return e("readwrite", (r) => (r.delete(t), Ro(r.transaction)));
}
function QB(t = yu()) {
  return t("readwrite", (e) => (e.clear(), Ro(e.transaction)));
}
function ZB(t, e) {
  return t.openCursor().onsuccess = function() {
    this.result && (e(this.result), this.result.continue());
  }, Ro(t.transaction);
}
function YB(t = yu()) {
  return t("readonly", (e) => {
    if (e.getAllKeys)
      return Ro(e.getAllKeys());
    const r = [];
    return ZB(e, (n) => r.push(n.key)).then(() => r);
  });
}
const XB = (t) => JSON.stringify(t, (e, r) => typeof r == "bigint" ? r.toString() + "n" : r), eU = (t) => {
  const e = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g, r = t.replace(e, '$1"$2n"$3');
  return JSON.parse(r, (n, i) => typeof i == "string" && i.match(/^\d+n$/) ? BigInt(i.substring(0, i.length - 1)) : i);
};
function _u(t) {
  if (typeof t != "string")
    throw new Error(`Cannot safe json parse value of type ${typeof t}`);
  try {
    return eU(t);
  } catch {
    return t;
  }
}
function vo(t) {
  return typeof t == "string" ? t : XB(t) || "";
}
const tU = "idb-keyval";
var rU = (t = {}) => {
  const e = t.base && t.base.length > 0 ? `${t.base}:` : "", r = (i) => e + i;
  let n;
  return t.dbName && t.storeName && (n = jE(t.dbName, t.storeName)), { name: tU, options: t, async hasItem(i) {
    return !(typeof await C_(r(i), n) > "u");
  }, async getItem(i) {
    return await C_(r(i), n) ?? null;
  }, setItem(i, o) {
    return GB(r(i), o, n);
  }, removeItem(i) {
    return JB(r(i), n);
  }, getKeys() {
    return YB(n);
  }, clear() {
    return QB(n);
  } };
};
const nU = "WALLET_CONNECT_V2_INDEXED_DB", iU = "keyvaluestorage";
let sU = class {
  constructor() {
    this.indexedDb = KB({ driver: rU({ dbName: nU, storeName: iU }) });
  }
  async getKeys() {
    return this.indexedDb.getKeys();
  }
  async getEntries() {
    return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((e) => [e.key, e.value]);
  }
  async getItem(e) {
    const r = await this.indexedDb.getItem(e);
    if (r !== null)
      return r;
  }
  async setItem(e, r) {
    await this.indexedDb.setItem(e, vo(r));
  }
  async removeItem(e) {
    await this.indexedDb.removeItem(e);
  }
};
var b0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ql = { exports: {} };
(function() {
  let t;
  function e() {
  }
  t = e, t.prototype.getItem = function(r) {
    return this.hasOwnProperty(r) ? String(this[r]) : null;
  }, t.prototype.setItem = function(r, n) {
    this[r] = String(n);
  }, t.prototype.removeItem = function(r) {
    delete this[r];
  }, t.prototype.clear = function() {
    const r = this;
    Object.keys(r).forEach(function(n) {
      r[n] = void 0, delete r[n];
    });
  }, t.prototype.key = function(r) {
    return r = r || 0, Object.keys(this)[r];
  }, t.prototype.__defineGetter__("length", function() {
    return Object.keys(this).length;
  }), typeof b0 < "u" && b0.localStorage ? Ql.exports = b0.localStorage : typeof window < "u" && window.localStorage ? Ql.exports = window.localStorage : Ql.exports = new e();
})();
function oU(t) {
  var e;
  return [t[0], _u((e = t[1]) != null ? e : "")];
}
class aU {
  constructor() {
    this.localStorage = Ql.exports;
  }
  async getKeys() {
    return Object.keys(this.localStorage);
  }
  async getEntries() {
    return Object.entries(this.localStorage).map(oU);
  }
  async getItem(e) {
    const r = this.localStorage.getItem(e);
    if (r !== null)
      return _u(r);
  }
  async setItem(e, r) {
    this.localStorage.setItem(e, vo(r));
  }
  async removeItem(e) {
    this.localStorage.removeItem(e);
  }
}
const cU = "wc_storage_version", I_ = 1, uU = async (t, e, r) => {
  const n = cU, i = await e.getItem(n);
  if (i && i >= I_) {
    r(e);
    return;
  }
  const o = await t.getKeys();
  if (!o.length) {
    r(e);
    return;
  }
  const c = [];
  for (; o.length; ) {
    const u = o.shift();
    if (!u)
      continue;
    const l = u.toLowerCase();
    if (l.includes("wc@") || l.includes("walletconnect") || l.includes("wc_") || l.includes("wallet_connect")) {
      const f = await t.getItem(u);
      await e.setItem(u, f), c.push(u);
    }
  }
  await e.setItem(n, I_), r(e), lU(t, c);
}, lU = async (t, e) => {
  e.length && e.forEach(async (r) => {
    await t.removeItem(r);
  });
};
let hU = class {
  constructor() {
    this.initialized = !1, this.setInitialized = (r) => {
      this.storage = r, this.initialized = !0;
    };
    const e = new aU();
    this.storage = e;
    try {
      const r = new sU();
      uU(e, r, this.setInitialized);
    } catch {
      this.initialized = !0;
    }
  }
  async getKeys() {
    return await this.initialize(), this.storage.getKeys();
  }
  async getEntries() {
    return await this.initialize(), this.storage.getEntries();
  }
  async getItem(e) {
    return await this.initialize(), this.storage.getItem(e);
  }
  async setItem(e, r) {
    return await this.initialize(), this.storage.setItem(e, r);
  }
  async removeItem(e) {
    return await this.initialize(), this.storage.removeItem(e);
  }
  async initialize() {
    this.initialized || await new Promise((e) => {
      const r = setInterval(() => {
        this.initialized && (clearInterval(r), e());
      }, 20);
    });
  }
};
var ja = {}, pc = {}, E0 = {}, gc = {};
let Ao = class {
};
const fU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IEvents: Ao
}, Symbol.toStringTag, { value: "Module" })), dU = /* @__PURE__ */ is(fU);
var x_;
function pU() {
  if (x_)
    return gc;
  x_ = 1, Object.defineProperty(gc, "__esModule", { value: !0 }), gc.IHeartBeat = void 0;
  const t = dU;
  class e extends t.IEvents {
    constructor(n) {
      super();
    }
  }
  return gc.IHeartBeat = e, gc;
}
var R_;
function HE() {
  return R_ || (R_ = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), Ti.__exportStar(pU(), t);
  }(E0)), E0;
}
var S0 = {}, eo = {}, A_;
function gU() {
  if (A_)
    return eo;
  A_ = 1, Object.defineProperty(eo, "__esModule", { value: !0 }), eo.HEARTBEAT_EVENTS = eo.HEARTBEAT_INTERVAL = void 0;
  const t = He;
  return eo.HEARTBEAT_INTERVAL = t.FIVE_SECONDS, eo.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
  }, eo;
}
var M_;
function qE() {
  return M_ || (M_ = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), Ti.__exportStar(gU(), t);
  }(S0)), S0;
}
var D_;
function mU() {
  if (D_)
    return pc;
  D_ = 1, Object.defineProperty(pc, "__esModule", { value: !0 }), pc.HeartBeat = void 0;
  const t = Ti, e = Tr, r = He, n = HE(), i = qE();
  class o extends n.IHeartBeat {
    constructor(u) {
      super(u), this.events = new e.EventEmitter(), this.interval = i.HEARTBEAT_INTERVAL, this.interval = u?.interval || i.HEARTBEAT_INTERVAL;
    }
    static init(u) {
      return t.__awaiter(this, void 0, void 0, function* () {
        const l = new o(u);
        return yield l.init(), l;
      });
    }
    init() {
      return t.__awaiter(this, void 0, void 0, function* () {
        yield this.initialize();
      });
    }
    stop() {
      clearInterval(this.intervalRef);
    }
    on(u, l) {
      this.events.on(u, l);
    }
    once(u, l) {
      this.events.once(u, l);
    }
    off(u, l) {
      this.events.off(u, l);
    }
    removeListener(u, l) {
      this.events.removeListener(u, l);
    }
    initialize() {
      return t.__awaiter(this, void 0, void 0, function* () {
        this.intervalRef = setInterval(() => this.pulse(), r.toMiliseconds(this.interval));
      });
    }
    pulse() {
      this.events.emit(i.HEARTBEAT_EVENTS.pulse);
    }
  }
  return pc.HeartBeat = o, pc;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const e = Ti;
  e.__exportStar(mU(), t), e.__exportStar(HE(), t), e.__exportStar(qE(), t);
})(ja);
var wt = {}, C0, O_;
function vU() {
  if (O_)
    return C0;
  O_ = 1;
  function t(r) {
    try {
      return JSON.stringify(r);
    } catch {
      return '"[Circular]"';
    }
  }
  C0 = e;
  function e(r, n, i) {
    var o = i && i.stringify || t, c = 1;
    if (typeof r == "object" && r !== null) {
      var u = n.length + c;
      if (u === 1)
        return r;
      var l = new Array(u);
      l[0] = o(r);
      for (var f = 1; f < u; f++)
        l[f] = o(n[f]);
      return l.join(" ");
    }
    if (typeof r != "string")
      return r;
    var p = n.length;
    if (p === 0)
      return r;
    for (var g = "", y = 1 - c, C = -1, R = r && r.length || 0, J = 0; J < R; ) {
      if (r.charCodeAt(J) === 37 && J + 1 < R) {
        switch (C = C > -1 ? C : 0, r.charCodeAt(J + 1)) {
          case 100:
          case 102:
            if (y >= p || n[y] == null)
              break;
            C < J && (g += r.slice(C, J)), g += Number(n[y]), C = J + 2, J++;
            break;
          case 105:
            if (y >= p || n[y] == null)
              break;
            C < J && (g += r.slice(C, J)), g += Math.floor(Number(n[y])), C = J + 2, J++;
            break;
          case 79:
          case 111:
          case 106:
            if (y >= p || n[y] === void 0)
              break;
            C < J && (g += r.slice(C, J));
            var G = typeof n[y];
            if (G === "string") {
              g += "'" + n[y] + "'", C = J + 2, J++;
              break;
            }
            if (G === "function") {
              g += n[y].name || "<anonymous>", C = J + 2, J++;
              break;
            }
            g += o(n[y]), C = J + 2, J++;
            break;
          case 115:
            if (y >= p)
              break;
            C < J && (g += r.slice(C, J)), g += String(n[y]), C = J + 2, J++;
            break;
          case 37:
            C < J && (g += r.slice(C, J)), g += "%", C = J + 2, J++, y--;
            break;
        }
        ++y;
      }
      ++J;
    }
    return C === -1 ? r : (C < R && (g += r.slice(C)), g);
  }
  return C0;
}
var I0, P_;
function yU() {
  if (P_)
    return I0;
  P_ = 1;
  const t = vU();
  I0 = i;
  const e = L().console || {}, r = {
    mapHttpRequest: R,
    mapHttpResponse: R,
    wrapRequestSerializer: J,
    wrapResponseSerializer: J,
    wrapErrorSerializer: J,
    req: R,
    res: R,
    err: y
  };
  function n(P, v) {
    return Array.isArray(P) ? P.filter(function(ie) {
      return ie !== "!stdSerializers.err";
    }) : P === !0 ? Object.keys(v) : !1;
  }
  function i(P) {
    P = P || {}, P.browser = P.browser || {};
    const v = P.browser.transmit;
    if (v && typeof v.send != "function")
      throw Error("pino: transmit option must have a send function");
    const N = P.browser.write || e;
    P.browser.write && (P.browser.asObject = !0);
    const ie = P.serializers || {}, le = n(P.browser.serialize, ie);
    let he = P.browser.serialize;
    Array.isArray(P.browser.serialize) && P.browser.serialize.indexOf("!stdSerializers.err") > -1 && (he = !1);
    const ye = ["error", "fatal", "warn", "info", "debug", "trace"];
    typeof N == "function" && (N.error = N.fatal = N.warn = N.info = N.debug = N.trace = N), P.enabled === !1 && (P.level = "silent");
    const k = P.level || "info", h = Object.create(N);
    h.log || (h.log = G), Object.defineProperty(h, "levelVal", {
      get: x
    }), Object.defineProperty(h, "level", {
      get: M,
      set: A
    });
    const m = {
      transmit: v,
      serialize: le,
      asObject: P.browser.asObject,
      levels: ye,
      timestamp: C(P)
    };
    h.levels = i.levels, h.level = k, h.setMaxListeners = h.getMaxListeners = h.emit = h.addListener = h.on = h.prependListener = h.once = h.prependOnceListener = h.removeListener = h.removeAllListeners = h.listeners = h.listenerCount = h.eventNames = h.write = h.flush = G, h.serializers = ie, h._serialize = le, h._stdErrSerialize = he, h.child = $, v && (h._logEvent = g());
    function x() {
      return this.level === "silent" ? 1 / 0 : this.levels.values[this.level];
    }
    function M() {
      return this._level;
    }
    function A(K) {
      if (K !== "silent" && !this.levels.values[K])
        throw Error("unknown level " + K);
      this._level = K, o(m, h, "error", "log"), o(m, h, "fatal", "error"), o(m, h, "warn", "error"), o(m, h, "info", "log"), o(m, h, "debug", "log"), o(m, h, "trace", "log");
    }
    function $(K, D) {
      if (!K)
        throw new Error("missing bindings for child Pino");
      D = D || {}, le && K.serializers && (D.serializers = K.serializers);
      const w = D.serializers;
      if (le && w) {
        var U = Object.assign({}, ie, w), me = P.browser.serialize === !0 ? Object.keys(U) : le;
        delete K.serializers, l([K], me, U, this._stdErrSerialize);
      }
      function pe(ee) {
        this._childLevel = (ee._childLevel | 0) + 1, this.error = f(ee, K, "error"), this.fatal = f(ee, K, "fatal"), this.warn = f(ee, K, "warn"), this.info = f(ee, K, "info"), this.debug = f(ee, K, "debug"), this.trace = f(ee, K, "trace"), U && (this.serializers = U, this._serialize = me), v && (this._logEvent = g(
          [].concat(ee._logEvent.bindings, K)
        ));
      }
      return pe.prototype = this, new pe(this);
    }
    return h;
  }
  i.levels = {
    values: {
      fatal: 60,
      error: 50,
      warn: 40,
      info: 30,
      debug: 20,
      trace: 10
    },
    labels: {
      10: "trace",
      20: "debug",
      30: "info",
      40: "warn",
      50: "error",
      60: "fatal"
    }
  }, i.stdSerializers = r, i.stdTimeFunctions = Object.assign({}, { nullTime: H, epochTime: T, unixTime: q, isoTime: B });
  function o(P, v, N, ie) {
    const le = Object.getPrototypeOf(v);
    v[N] = v.levelVal > v.levels.values[N] ? G : le[N] ? le[N] : e[N] || e[ie] || G, c(P, v, N);
  }
  function c(P, v, N) {
    !P.transmit && v[N] === G || (v[N] = /* @__PURE__ */ function(ie) {
      return function() {
        const he = P.timestamp(), ye = new Array(arguments.length), k = Object.getPrototypeOf && Object.getPrototypeOf(this) === e ? e : this;
        for (var h = 0; h < ye.length; h++)
          ye[h] = arguments[h];
        if (P.serialize && !P.asObject && l(ye, this._serialize, this.serializers, this._stdErrSerialize), P.asObject ? ie.call(k, u(this, N, ye, he)) : ie.apply(k, ye), P.transmit) {
          const m = P.transmit.level || v.level, x = i.levels.values[m], M = i.levels.values[N];
          if (M < x)
            return;
          p(this, {
            ts: he,
            methodLevel: N,
            methodValue: M,
            transmitLevel: m,
            transmitValue: i.levels.values[P.transmit.level || v.level],
            send: P.transmit.send,
            val: v.levelVal
          }, ye);
        }
      };
    }(v[N]));
  }
  function u(P, v, N, ie) {
    P._serialize && l(N, P._serialize, P.serializers, P._stdErrSerialize);
    const le = N.slice();
    let he = le[0];
    const ye = {};
    ie && (ye.time = ie), ye.level = i.levels.values[v];
    let k = (P._childLevel | 0) + 1;
    if (k < 1 && (k = 1), he !== null && typeof he == "object") {
      for (; k-- && typeof le[0] == "object"; )
        Object.assign(ye, le.shift());
      he = le.length ? t(le.shift(), le) : void 0;
    } else
      typeof he == "string" && (he = t(le.shift(), le));
    return he !== void 0 && (ye.msg = he), ye;
  }
  function l(P, v, N, ie) {
    for (const le in P)
      if (ie && P[le] instanceof Error)
        P[le] = i.stdSerializers.err(P[le]);
      else if (typeof P[le] == "object" && !Array.isArray(P[le]))
        for (const he in P[le])
          v && v.indexOf(he) > -1 && he in N && (P[le][he] = N[he](P[le][he]));
  }
  function f(P, v, N) {
    return function() {
      const ie = new Array(1 + arguments.length);
      ie[0] = v;
      for (var le = 1; le < ie.length; le++)
        ie[le] = arguments[le - 1];
      return P[N].apply(this, ie);
    };
  }
  function p(P, v, N) {
    const ie = v.send, le = v.ts, he = v.methodLevel, ye = v.methodValue, k = v.val, h = P._logEvent.bindings;
    l(
      N,
      P._serialize || Object.keys(P.serializers),
      P.serializers,
      P._stdErrSerialize === void 0 ? !0 : P._stdErrSerialize
    ), P._logEvent.ts = le, P._logEvent.messages = N.filter(function(m) {
      return h.indexOf(m) === -1;
    }), P._logEvent.level.label = he, P._logEvent.level.value = ye, ie(he, P._logEvent, k), P._logEvent = g(h);
  }
  function g(P) {
    return {
      ts: 0,
      messages: [],
      bindings: P || [],
      level: { label: "", value: 0 }
    };
  }
  function y(P) {
    const v = {
      type: P.constructor.name,
      msg: P.message,
      stack: P.stack
    };
    for (const N in P)
      v[N] === void 0 && (v[N] = P[N]);
    return v;
  }
  function C(P) {
    return typeof P.timestamp == "function" ? P.timestamp : P.timestamp === !1 ? H : T;
  }
  function R() {
    return {};
  }
  function J(P) {
    return P;
  }
  function G() {
  }
  function H() {
    return !1;
  }
  function T() {
    return Date.now();
  }
  function q() {
    return Math.round(Date.now() / 1e3);
  }
  function B() {
    return new Date(Date.now()).toISOString();
  }
  function L() {
    function P(v) {
      return typeof v < "u" && v;
    }
    try {
      return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
        get: function() {
          return delete Object.prototype.globalThis, this.globalThis = this;
        },
        configurable: !0
      }), globalThis;
    } catch {
      return P(self) || P(window) || P(this) || {};
    }
  }
  return I0;
}
var to = {}, T_;
function zE() {
  return T_ || (T_ = 1, Object.defineProperty(to, "__esModule", { value: !0 }), to.PINO_CUSTOM_CONTEXT_KEY = to.PINO_LOGGER_DEFAULTS = void 0, to.PINO_LOGGER_DEFAULTS = {
    level: "info"
  }, to.PINO_CUSTOM_CONTEXT_KEY = "custom_context"), to;
}
var Wr = {}, N_;
function _U() {
  if (N_)
    return Wr;
  N_ = 1, Object.defineProperty(Wr, "__esModule", { value: !0 }), Wr.generateChildLogger = Wr.formatChildLoggerContext = Wr.getLoggerContext = Wr.setBrowserLoggerContext = Wr.getBrowserLoggerContext = Wr.getDefaultLoggerOptions = void 0;
  const t = zE();
  function e(u) {
    return Object.assign(Object.assign({}, u), { level: u?.level || t.PINO_LOGGER_DEFAULTS.level });
  }
  Wr.getDefaultLoggerOptions = e;
  function r(u, l = t.PINO_CUSTOM_CONTEXT_KEY) {
    return u[l] || "";
  }
  Wr.getBrowserLoggerContext = r;
  function n(u, l, f = t.PINO_CUSTOM_CONTEXT_KEY) {
    return u[f] = l, u;
  }
  Wr.setBrowserLoggerContext = n;
  function i(u, l = t.PINO_CUSTOM_CONTEXT_KEY) {
    let f = "";
    return typeof u.bindings > "u" ? f = r(u, l) : f = u.bindings().context || "", f;
  }
  Wr.getLoggerContext = i;
  function o(u, l, f = t.PINO_CUSTOM_CONTEXT_KEY) {
    const p = i(u, f);
    return p.trim() ? `${p}/${l}` : l;
  }
  Wr.formatChildLoggerContext = o;
  function c(u, l, f = t.PINO_CUSTOM_CONTEXT_KEY) {
    const p = o(u, l, f), g = u.child({ context: p });
    return n(g, p, f);
  }
  return Wr.generateChildLogger = c, Wr;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.pino = void 0;
  const e = Ti, r = e.__importDefault(yU());
  Object.defineProperty(t, "pino", { enumerable: !0, get: function() {
    return r.default;
  } }), e.__exportStar(zE(), t), e.__exportStar(_U(), t);
})(wt);
class wU extends Ao {
  constructor(e) {
    super(), this.opts = e, this.protocol = "wc", this.version = 2;
  }
}
let bU = class extends Ao {
  constructor(e, r) {
    super(), this.core = e, this.logger = r, this.records = /* @__PURE__ */ new Map();
  }
}, EU = class {
  constructor(e, r) {
    this.logger = e, this.core = r;
  }
}, SU = class extends Ao {
  constructor(e, r) {
    super(), this.relayer = e, this.logger = r;
  }
}, CU = class extends Ao {
  constructor(e) {
    super();
  }
}, IU = class {
  constructor(e, r, n, i) {
    this.core = e, this.logger = r, this.name = n;
  }
};
class xU extends Ao {
  constructor(e, r) {
    super(), this.relayer = e, this.logger = r;
  }
}
let RU = class extends Ao {
  constructor(e, r) {
    super(), this.core = e, this.logger = r;
  }
}, AU = class {
  constructor(e, r) {
    this.projectId = e, this.logger = r;
  }
}, MU = class {
  constructor(e, r) {
    this.projectId = e, this.logger = r;
  }
}, DU = class {
  constructor(e) {
    this.opts = e, this.protocol = "wc", this.version = 2;
  }
}, OU = class {
  constructor(e) {
    this.client = e;
  }
};
var Mg = {}, VE = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = ct, r = xn;
  t.DIGEST_LENGTH = 64, t.BLOCK_SIZE = 128;
  var n = (
    /** @class */
    function() {
      function u() {
        this.digestLength = t.DIGEST_LENGTH, this.blockSize = t.BLOCK_SIZE, this._stateHi = new Int32Array(8), this._stateLo = new Int32Array(8), this._tempHi = new Int32Array(16), this._tempLo = new Int32Array(16), this._buffer = new Uint8Array(256), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
      }
      return u.prototype._initState = function() {
        this._stateHi[0] = 1779033703, this._stateHi[1] = 3144134277, this._stateHi[2] = 1013904242, this._stateHi[3] = 2773480762, this._stateHi[4] = 1359893119, this._stateHi[5] = 2600822924, this._stateHi[6] = 528734635, this._stateHi[7] = 1541459225, this._stateLo[0] = 4089235720, this._stateLo[1] = 2227873595, this._stateLo[2] = 4271175723, this._stateLo[3] = 1595750129, this._stateLo[4] = 2917565137, this._stateLo[5] = 725511199, this._stateLo[6] = 4215389547, this._stateLo[7] = 327033209;
      }, u.prototype.reset = function() {
        return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
      }, u.prototype.clean = function() {
        r.wipe(this._buffer), r.wipe(this._tempHi), r.wipe(this._tempLo), this.reset();
      }, u.prototype.update = function(l, f) {
        if (f === void 0 && (f = l.length), this._finished)
          throw new Error("SHA512: can't update because hash was finished.");
        var p = 0;
        if (this._bytesHashed += f, this._bufferLength > 0) {
          for (; this._bufferLength < t.BLOCK_SIZE && f > 0; )
            this._buffer[this._bufferLength++] = l[p++], f--;
          this._bufferLength === this.blockSize && (o(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize), this._bufferLength = 0);
        }
        for (f >= this.blockSize && (p = o(this._tempHi, this._tempLo, this._stateHi, this._stateLo, l, p, f), f %= this.blockSize); f > 0; )
          this._buffer[this._bufferLength++] = l[p++], f--;
        return this;
      }, u.prototype.finish = function(l) {
        if (!this._finished) {
          var f = this._bytesHashed, p = this._bufferLength, g = f / 536870912 | 0, y = f << 3, C = f % 128 < 112 ? 128 : 256;
          this._buffer[p] = 128;
          for (var R = p + 1; R < C - 8; R++)
            this._buffer[R] = 0;
          e.writeUint32BE(g, this._buffer, C - 8), e.writeUint32BE(y, this._buffer, C - 4), o(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, C), this._finished = !0;
        }
        for (var R = 0; R < this.digestLength / 8; R++)
          e.writeUint32BE(this._stateHi[R], l, R * 8), e.writeUint32BE(this._stateLo[R], l, R * 8 + 4);
        return this;
      }, u.prototype.digest = function() {
        var l = new Uint8Array(this.digestLength);
        return this.finish(l), l;
      }, u.prototype.saveState = function() {
        if (this._finished)
          throw new Error("SHA256: cannot save finished state");
        return {
          stateHi: new Int32Array(this._stateHi),
          stateLo: new Int32Array(this._stateLo),
          buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
          bufferLength: this._bufferLength,
          bytesHashed: this._bytesHashed
        };
      }, u.prototype.restoreState = function(l) {
        return this._stateHi.set(l.stateHi), this._stateLo.set(l.stateLo), this._bufferLength = l.bufferLength, l.buffer && this._buffer.set(l.buffer), this._bytesHashed = l.bytesHashed, this._finished = !1, this;
      }, u.prototype.cleanSavedState = function(l) {
        r.wipe(l.stateHi), r.wipe(l.stateLo), l.buffer && r.wipe(l.buffer), l.bufferLength = 0, l.bytesHashed = 0;
      }, u;
    }()
  );
  t.SHA512 = n;
  var i = new Int32Array([
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ]);
  function o(u, l, f, p, g, y, C) {
    for (var R = f[0], J = f[1], G = f[2], H = f[3], T = f[4], q = f[5], B = f[6], L = f[7], P = p[0], v = p[1], N = p[2], ie = p[3], le = p[4], he = p[5], ye = p[6], k = p[7], h, m, x, M, A, $, K, D; C >= 128; ) {
      for (var w = 0; w < 16; w++) {
        var U = 8 * w + y;
        u[w] = e.readUint32BE(g, U), l[w] = e.readUint32BE(g, U + 4);
      }
      for (var w = 0; w < 80; w++) {
        var me = R, pe = J, ee = G, V = H, Q = T, X = q, E = B, I = L, F = P, se = v, fe = N, Re = ie, j = le, b = he, S = ye, Z = k;
        if (h = L, m = k, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = (T >>> 14 | le << 18) ^ (T >>> 18 | le << 14) ^ (le >>> 9 | T << 23), m = (le >>> 14 | T << 18) ^ (le >>> 18 | T << 14) ^ (T >>> 9 | le << 23), A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, h = T & q ^ ~T & B, m = le & he ^ ~le & ye, A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, h = i[w * 2], m = i[w * 2 + 1], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, h = u[w % 16], m = l[w % 16], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, x = K & 65535 | D << 16, M = A & 65535 | $ << 16, h = x, m = M, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = (R >>> 28 | P << 4) ^ (P >>> 2 | R << 30) ^ (P >>> 7 | R << 25), m = (P >>> 28 | R << 4) ^ (R >>> 2 | P << 30) ^ (R >>> 7 | P << 25), A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, h = R & J ^ R & G ^ J & G, m = P & v ^ P & N ^ v & N, A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, I = K & 65535 | D << 16, Z = A & 65535 | $ << 16, h = V, m = Re, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = x, m = M, A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, V = K & 65535 | D << 16, Re = A & 65535 | $ << 16, J = me, G = pe, H = ee, T = V, q = Q, B = X, L = E, R = I, v = F, N = se, ie = fe, le = Re, he = j, ye = b, k = S, P = Z, w % 16 === 15)
          for (var U = 0; U < 16; U++)
            h = u[U], m = l[U], A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = u[(U + 9) % 16], m = l[(U + 9) % 16], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, x = u[(U + 1) % 16], M = l[(U + 1) % 16], h = (x >>> 1 | M << 31) ^ (x >>> 8 | M << 24) ^ x >>> 7, m = (M >>> 1 | x << 31) ^ (M >>> 8 | x << 24) ^ (M >>> 7 | x << 25), A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, x = u[(U + 14) % 16], M = l[(U + 14) % 16], h = (x >>> 19 | M << 13) ^ (M >>> 29 | x << 3) ^ x >>> 6, m = (M >>> 19 | x << 13) ^ (x >>> 29 | M << 3) ^ (M >>> 6 | x << 26), A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, u[U] = K & 65535 | D << 16, l[U] = A & 65535 | $ << 16;
      }
      h = R, m = P, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = f[0], m = p[0], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, f[0] = R = K & 65535 | D << 16, p[0] = P = A & 65535 | $ << 16, h = J, m = v, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = f[1], m = p[1], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, f[1] = J = K & 65535 | D << 16, p[1] = v = A & 65535 | $ << 16, h = G, m = N, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = f[2], m = p[2], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, f[2] = G = K & 65535 | D << 16, p[2] = N = A & 65535 | $ << 16, h = H, m = ie, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = f[3], m = p[3], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, f[3] = H = K & 65535 | D << 16, p[3] = ie = A & 65535 | $ << 16, h = T, m = le, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = f[4], m = p[4], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, f[4] = T = K & 65535 | D << 16, p[4] = le = A & 65535 | $ << 16, h = q, m = he, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = f[5], m = p[5], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, f[5] = q = K & 65535 | D << 16, p[5] = he = A & 65535 | $ << 16, h = B, m = ye, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = f[6], m = p[6], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, f[6] = B = K & 65535 | D << 16, p[6] = ye = A & 65535 | $ << 16, h = L, m = k, A = m & 65535, $ = m >>> 16, K = h & 65535, D = h >>> 16, h = f[7], m = p[7], A += m & 65535, $ += m >>> 16, K += h & 65535, D += h >>> 16, $ += A >>> 16, K += $ >>> 16, D += K >>> 16, f[7] = L = K & 65535 | D << 16, p[7] = k = A & 65535 | $ << 16, y += 128, C -= 128;
    }
    return y;
  }
  function c(u) {
    var l = new n();
    l.update(u);
    var f = l.digest();
    return l.clean(), f;
  }
  t.hash = c;
})(VE);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.convertSecretKeyToX25519 = t.convertPublicKeyToX25519 = t.verify = t.sign = t.extractPublicKeyFromSecretKey = t.generateKeyPair = t.generateKeyPairFromSeed = t.SEED_LENGTH = t.SECRET_KEY_LENGTH = t.PUBLIC_KEY_LENGTH = t.SIGNATURE_LENGTH = void 0;
  const e = La, r = VE, n = xn;
  t.SIGNATURE_LENGTH = 64, t.PUBLIC_KEY_LENGTH = 32, t.SECRET_KEY_LENGTH = 64, t.SEED_LENGTH = 32;
  function i(V) {
    const Q = new Float64Array(16);
    if (V)
      for (let X = 0; X < V.length; X++)
        Q[X] = V[X];
    return Q;
  }
  const o = new Uint8Array(32);
  o[0] = 9;
  const c = i(), u = i([1]), l = i([
    30883,
    4953,
    19914,
    30187,
    55467,
    16705,
    2637,
    112,
    59544,
    30585,
    16505,
    36039,
    65139,
    11119,
    27886,
    20995
  ]), f = i([
    61785,
    9906,
    39828,
    60374,
    45398,
    33411,
    5274,
    224,
    53552,
    61171,
    33010,
    6542,
    64743,
    22239,
    55772,
    9222
  ]), p = i([
    54554,
    36645,
    11616,
    51542,
    42930,
    38181,
    51040,
    26924,
    56412,
    64982,
    57905,
    49316,
    21502,
    52590,
    14035,
    8553
  ]), g = i([
    26200,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214
  ]), y = i([
    41136,
    18958,
    6951,
    50414,
    58488,
    44335,
    6150,
    12099,
    55207,
    15867,
    153,
    11085,
    57099,
    20417,
    9344,
    11139
  ]);
  function C(V, Q) {
    for (let X = 0; X < 16; X++)
      V[X] = Q[X] | 0;
  }
  function R(V) {
    let Q = 1;
    for (let X = 0; X < 16; X++) {
      let E = V[X] + Q + 65535;
      Q = Math.floor(E / 65536), V[X] = E - Q * 65536;
    }
    V[0] += Q - 1 + 37 * (Q - 1);
  }
  function J(V, Q, X) {
    const E = ~(X - 1);
    for (let I = 0; I < 16; I++) {
      const F = E & (V[I] ^ Q[I]);
      V[I] ^= F, Q[I] ^= F;
    }
  }
  function G(V, Q) {
    const X = i(), E = i();
    for (let I = 0; I < 16; I++)
      E[I] = Q[I];
    R(E), R(E), R(E);
    for (let I = 0; I < 2; I++) {
      X[0] = E[0] - 65517;
      for (let se = 1; se < 15; se++)
        X[se] = E[se] - 65535 - (X[se - 1] >> 16 & 1), X[se - 1] &= 65535;
      X[15] = E[15] - 32767 - (X[14] >> 16 & 1);
      const F = X[15] >> 16 & 1;
      X[14] &= 65535, J(E, X, 1 - F);
    }
    for (let I = 0; I < 16; I++)
      V[2 * I] = E[I] & 255, V[2 * I + 1] = E[I] >> 8;
  }
  function H(V, Q) {
    let X = 0;
    for (let E = 0; E < 32; E++)
      X |= V[E] ^ Q[E];
    return (1 & X - 1 >>> 8) - 1;
  }
  function T(V, Q) {
    const X = new Uint8Array(32), E = new Uint8Array(32);
    return G(X, V), G(E, Q), H(X, E);
  }
  function q(V) {
    const Q = new Uint8Array(32);
    return G(Q, V), Q[0] & 1;
  }
  function B(V, Q) {
    for (let X = 0; X < 16; X++)
      V[X] = Q[2 * X] + (Q[2 * X + 1] << 8);
    V[15] &= 32767;
  }
  function L(V, Q, X) {
    for (let E = 0; E < 16; E++)
      V[E] = Q[E] + X[E];
  }
  function P(V, Q, X) {
    for (let E = 0; E < 16; E++)
      V[E] = Q[E] - X[E];
  }
  function v(V, Q, X) {
    let E, I, F = 0, se = 0, fe = 0, Re = 0, j = 0, b = 0, S = 0, Z = 0, re = 0, ue = 0, ge = 0, Ee = 0, Ie = 0, Ae = 0, xe = 0, Se = 0, Le = 0, Ne = 0, Oe = 0, it = 0, Fe = 0, je = 0, ut = 0, Be = 0, ht = 0, ar = 0, bt = 0, ft = 0, Lr = 0, It = 0, Mt = 0, Tt = X[0], Ke = X[1], Qe = X[2], Nt = X[3], Je = X[4], Ge = X[5], Ht = X[6], tt = X[7], Ze = X[8], qt = X[9], Ye = X[10], Xe = X[11], kt = X[12], qe = X[13], rt = X[14], zt = X[15];
    E = Q[0], F += E * Tt, se += E * Ke, fe += E * Qe, Re += E * Nt, j += E * Je, b += E * Ge, S += E * Ht, Z += E * tt, re += E * Ze, ue += E * qt, ge += E * Ye, Ee += E * Xe, Ie += E * kt, Ae += E * qe, xe += E * rt, Se += E * zt, E = Q[1], se += E * Tt, fe += E * Ke, Re += E * Qe, j += E * Nt, b += E * Je, S += E * Ge, Z += E * Ht, re += E * tt, ue += E * Ze, ge += E * qt, Ee += E * Ye, Ie += E * Xe, Ae += E * kt, xe += E * qe, Se += E * rt, Le += E * zt, E = Q[2], fe += E * Tt, Re += E * Ke, j += E * Qe, b += E * Nt, S += E * Je, Z += E * Ge, re += E * Ht, ue += E * tt, ge += E * Ze, Ee += E * qt, Ie += E * Ye, Ae += E * Xe, xe += E * kt, Se += E * qe, Le += E * rt, Ne += E * zt, E = Q[3], Re += E * Tt, j += E * Ke, b += E * Qe, S += E * Nt, Z += E * Je, re += E * Ge, ue += E * Ht, ge += E * tt, Ee += E * Ze, Ie += E * qt, Ae += E * Ye, xe += E * Xe, Se += E * kt, Le += E * qe, Ne += E * rt, Oe += E * zt, E = Q[4], j += E * Tt, b += E * Ke, S += E * Qe, Z += E * Nt, re += E * Je, ue += E * Ge, ge += E * Ht, Ee += E * tt, Ie += E * Ze, Ae += E * qt, xe += E * Ye, Se += E * Xe, Le += E * kt, Ne += E * qe, Oe += E * rt, it += E * zt, E = Q[5], b += E * Tt, S += E * Ke, Z += E * Qe, re += E * Nt, ue += E * Je, ge += E * Ge, Ee += E * Ht, Ie += E * tt, Ae += E * Ze, xe += E * qt, Se += E * Ye, Le += E * Xe, Ne += E * kt, Oe += E * qe, it += E * rt, Fe += E * zt, E = Q[6], S += E * Tt, Z += E * Ke, re += E * Qe, ue += E * Nt, ge += E * Je, Ee += E * Ge, Ie += E * Ht, Ae += E * tt, xe += E * Ze, Se += E * qt, Le += E * Ye, Ne += E * Xe, Oe += E * kt, it += E * qe, Fe += E * rt, je += E * zt, E = Q[7], Z += E * Tt, re += E * Ke, ue += E * Qe, ge += E * Nt, Ee += E * Je, Ie += E * Ge, Ae += E * Ht, xe += E * tt, Se += E * Ze, Le += E * qt, Ne += E * Ye, Oe += E * Xe, it += E * kt, Fe += E * qe, je += E * rt, ut += E * zt, E = Q[8], re += E * Tt, ue += E * Ke, ge += E * Qe, Ee += E * Nt, Ie += E * Je, Ae += E * Ge, xe += E * Ht, Se += E * tt, Le += E * Ze, Ne += E * qt, Oe += E * Ye, it += E * Xe, Fe += E * kt, je += E * qe, ut += E * rt, Be += E * zt, E = Q[9], ue += E * Tt, ge += E * Ke, Ee += E * Qe, Ie += E * Nt, Ae += E * Je, xe += E * Ge, Se += E * Ht, Le += E * tt, Ne += E * Ze, Oe += E * qt, it += E * Ye, Fe += E * Xe, je += E * kt, ut += E * qe, Be += E * rt, ht += E * zt, E = Q[10], ge += E * Tt, Ee += E * Ke, Ie += E * Qe, Ae += E * Nt, xe += E * Je, Se += E * Ge, Le += E * Ht, Ne += E * tt, Oe += E * Ze, it += E * qt, Fe += E * Ye, je += E * Xe, ut += E * kt, Be += E * qe, ht += E * rt, ar += E * zt, E = Q[11], Ee += E * Tt, Ie += E * Ke, Ae += E * Qe, xe += E * Nt, Se += E * Je, Le += E * Ge, Ne += E * Ht, Oe += E * tt, it += E * Ze, Fe += E * qt, je += E * Ye, ut += E * Xe, Be += E * kt, ht += E * qe, ar += E * rt, bt += E * zt, E = Q[12], Ie += E * Tt, Ae += E * Ke, xe += E * Qe, Se += E * Nt, Le += E * Je, Ne += E * Ge, Oe += E * Ht, it += E * tt, Fe += E * Ze, je += E * qt, ut += E * Ye, Be += E * Xe, ht += E * kt, ar += E * qe, bt += E * rt, ft += E * zt, E = Q[13], Ae += E * Tt, xe += E * Ke, Se += E * Qe, Le += E * Nt, Ne += E * Je, Oe += E * Ge, it += E * Ht, Fe += E * tt, je += E * Ze, ut += E * qt, Be += E * Ye, ht += E * Xe, ar += E * kt, bt += E * qe, ft += E * rt, Lr += E * zt, E = Q[14], xe += E * Tt, Se += E * Ke, Le += E * Qe, Ne += E * Nt, Oe += E * Je, it += E * Ge, Fe += E * Ht, je += E * tt, ut += E * Ze, Be += E * qt, ht += E * Ye, ar += E * Xe, bt += E * kt, ft += E * qe, Lr += E * rt, It += E * zt, E = Q[15], Se += E * Tt, Le += E * Ke, Ne += E * Qe, Oe += E * Nt, it += E * Je, Fe += E * Ge, je += E * Ht, ut += E * tt, Be += E * Ze, ht += E * qt, ar += E * Ye, bt += E * Xe, ft += E * kt, Lr += E * qe, It += E * rt, Mt += E * zt, F += 38 * Le, se += 38 * Ne, fe += 38 * Oe, Re += 38 * it, j += 38 * Fe, b += 38 * je, S += 38 * ut, Z += 38 * Be, re += 38 * ht, ue += 38 * ar, ge += 38 * bt, Ee += 38 * ft, Ie += 38 * Lr, Ae += 38 * It, xe += 38 * Mt, I = 1, E = F + I + 65535, I = Math.floor(E / 65536), F = E - I * 65536, E = se + I + 65535, I = Math.floor(E / 65536), se = E - I * 65536, E = fe + I + 65535, I = Math.floor(E / 65536), fe = E - I * 65536, E = Re + I + 65535, I = Math.floor(E / 65536), Re = E - I * 65536, E = j + I + 65535, I = Math.floor(E / 65536), j = E - I * 65536, E = b + I + 65535, I = Math.floor(E / 65536), b = E - I * 65536, E = S + I + 65535, I = Math.floor(E / 65536), S = E - I * 65536, E = Z + I + 65535, I = Math.floor(E / 65536), Z = E - I * 65536, E = re + I + 65535, I = Math.floor(E / 65536), re = E - I * 65536, E = ue + I + 65535, I = Math.floor(E / 65536), ue = E - I * 65536, E = ge + I + 65535, I = Math.floor(E / 65536), ge = E - I * 65536, E = Ee + I + 65535, I = Math.floor(E / 65536), Ee = E - I * 65536, E = Ie + I + 65535, I = Math.floor(E / 65536), Ie = E - I * 65536, E = Ae + I + 65535, I = Math.floor(E / 65536), Ae = E - I * 65536, E = xe + I + 65535, I = Math.floor(E / 65536), xe = E - I * 65536, E = Se + I + 65535, I = Math.floor(E / 65536), Se = E - I * 65536, F += I - 1 + 37 * (I - 1), I = 1, E = F + I + 65535, I = Math.floor(E / 65536), F = E - I * 65536, E = se + I + 65535, I = Math.floor(E / 65536), se = E - I * 65536, E = fe + I + 65535, I = Math.floor(E / 65536), fe = E - I * 65536, E = Re + I + 65535, I = Math.floor(E / 65536), Re = E - I * 65536, E = j + I + 65535, I = Math.floor(E / 65536), j = E - I * 65536, E = b + I + 65535, I = Math.floor(E / 65536), b = E - I * 65536, E = S + I + 65535, I = Math.floor(E / 65536), S = E - I * 65536, E = Z + I + 65535, I = Math.floor(E / 65536), Z = E - I * 65536, E = re + I + 65535, I = Math.floor(E / 65536), re = E - I * 65536, E = ue + I + 65535, I = Math.floor(E / 65536), ue = E - I * 65536, E = ge + I + 65535, I = Math.floor(E / 65536), ge = E - I * 65536, E = Ee + I + 65535, I = Math.floor(E / 65536), Ee = E - I * 65536, E = Ie + I + 65535, I = Math.floor(E / 65536), Ie = E - I * 65536, E = Ae + I + 65535, I = Math.floor(E / 65536), Ae = E - I * 65536, E = xe + I + 65535, I = Math.floor(E / 65536), xe = E - I * 65536, E = Se + I + 65535, I = Math.floor(E / 65536), Se = E - I * 65536, F += I - 1 + 37 * (I - 1), V[0] = F, V[1] = se, V[2] = fe, V[3] = Re, V[4] = j, V[5] = b, V[6] = S, V[7] = Z, V[8] = re, V[9] = ue, V[10] = ge, V[11] = Ee, V[12] = Ie, V[13] = Ae, V[14] = xe, V[15] = Se;
  }
  function N(V, Q) {
    v(V, Q, Q);
  }
  function ie(V, Q) {
    const X = i();
    let E;
    for (E = 0; E < 16; E++)
      X[E] = Q[E];
    for (E = 253; E >= 0; E--)
      N(X, X), E !== 2 && E !== 4 && v(X, X, Q);
    for (E = 0; E < 16; E++)
      V[E] = X[E];
  }
  function le(V, Q) {
    const X = i();
    let E;
    for (E = 0; E < 16; E++)
      X[E] = Q[E];
    for (E = 250; E >= 0; E--)
      N(X, X), E !== 1 && v(X, X, Q);
    for (E = 0; E < 16; E++)
      V[E] = X[E];
  }
  function he(V, Q) {
    const X = i(), E = i(), I = i(), F = i(), se = i(), fe = i(), Re = i(), j = i(), b = i();
    P(X, V[1], V[0]), P(b, Q[1], Q[0]), v(X, X, b), L(E, V[0], V[1]), L(b, Q[0], Q[1]), v(E, E, b), v(I, V[3], Q[3]), v(I, I, f), v(F, V[2], Q[2]), L(F, F, F), P(se, E, X), P(fe, F, I), L(Re, F, I), L(j, E, X), v(V[0], se, fe), v(V[1], j, Re), v(V[2], Re, fe), v(V[3], se, j);
  }
  function ye(V, Q, X) {
    for (let E = 0; E < 4; E++)
      J(V[E], Q[E], X);
  }
  function k(V, Q) {
    const X = i(), E = i(), I = i();
    ie(I, Q[2]), v(X, Q[0], I), v(E, Q[1], I), G(V, E), V[31] ^= q(X) << 7;
  }
  function h(V, Q, X) {
    C(V[0], c), C(V[1], u), C(V[2], u), C(V[3], c);
    for (let E = 255; E >= 0; --E) {
      const I = X[E / 8 | 0] >> (E & 7) & 1;
      ye(V, Q, I), he(Q, V), he(V, V), ye(V, Q, I);
    }
  }
  function m(V, Q) {
    const X = [i(), i(), i(), i()];
    C(X[0], p), C(X[1], g), C(X[2], u), v(X[3], p, g), h(V, X, Q);
  }
  function x(V) {
    if (V.length !== t.SEED_LENGTH)
      throw new Error(`ed25519: seed must be ${t.SEED_LENGTH} bytes`);
    const Q = (0, r.hash)(V);
    Q[0] &= 248, Q[31] &= 127, Q[31] |= 64;
    const X = new Uint8Array(32), E = [i(), i(), i(), i()];
    m(E, Q), k(X, E);
    const I = new Uint8Array(64);
    return I.set(V), I.set(X, 32), {
      publicKey: X,
      secretKey: I
    };
  }
  t.generateKeyPairFromSeed = x;
  function M(V) {
    const Q = (0, e.randomBytes)(32, V), X = x(Q);
    return (0, n.wipe)(Q), X;
  }
  t.generateKeyPair = M;
  function A(V) {
    if (V.length !== t.SECRET_KEY_LENGTH)
      throw new Error(`ed25519: secret key must be ${t.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(V.subarray(32));
  }
  t.extractPublicKeyFromSecretKey = A;
  const $ = new Float64Array([
    237,
    211,
    245,
    92,
    26,
    99,
    18,
    88,
    214,
    156,
    247,
    162,
    222,
    249,
    222,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    16
  ]);
  function K(V, Q) {
    let X, E, I, F;
    for (E = 63; E >= 32; --E) {
      for (X = 0, I = E - 32, F = E - 12; I < F; ++I)
        Q[I] += X - 16 * Q[E] * $[I - (E - 32)], X = Math.floor((Q[I] + 128) / 256), Q[I] -= X * 256;
      Q[I] += X, Q[E] = 0;
    }
    for (X = 0, I = 0; I < 32; I++)
      Q[I] += X - (Q[31] >> 4) * $[I], X = Q[I] >> 8, Q[I] &= 255;
    for (I = 0; I < 32; I++)
      Q[I] -= X * $[I];
    for (E = 0; E < 32; E++)
      Q[E + 1] += Q[E] >> 8, V[E] = Q[E] & 255;
  }
  function D(V) {
    const Q = new Float64Array(64);
    for (let X = 0; X < 64; X++)
      Q[X] = V[X];
    for (let X = 0; X < 64; X++)
      V[X] = 0;
    K(V, Q);
  }
  function w(V, Q) {
    const X = new Float64Array(64), E = [i(), i(), i(), i()], I = (0, r.hash)(V.subarray(0, 32));
    I[0] &= 248, I[31] &= 127, I[31] |= 64;
    const F = new Uint8Array(64);
    F.set(I.subarray(32), 32);
    const se = new r.SHA512();
    se.update(F.subarray(32)), se.update(Q);
    const fe = se.digest();
    se.clean(), D(fe), m(E, fe), k(F, E), se.reset(), se.update(F.subarray(0, 32)), se.update(V.subarray(32)), se.update(Q);
    const Re = se.digest();
    D(Re);
    for (let j = 0; j < 32; j++)
      X[j] = fe[j];
    for (let j = 0; j < 32; j++)
      for (let b = 0; b < 32; b++)
        X[j + b] += Re[j] * I[b];
    return K(F.subarray(32), X), F;
  }
  t.sign = w;
  function U(V, Q) {
    const X = i(), E = i(), I = i(), F = i(), se = i(), fe = i(), Re = i();
    return C(V[2], u), B(V[1], Q), N(I, V[1]), v(F, I, l), P(I, I, V[2]), L(F, V[2], F), N(se, F), N(fe, se), v(Re, fe, se), v(X, Re, I), v(X, X, F), le(X, X), v(X, X, I), v(X, X, F), v(X, X, F), v(V[0], X, F), N(E, V[0]), v(E, E, F), T(E, I) && v(V[0], V[0], y), N(E, V[0]), v(E, E, F), T(E, I) ? -1 : (q(V[0]) === Q[31] >> 7 && P(V[0], c, V[0]), v(V[3], V[0], V[1]), 0);
  }
  function me(V, Q, X) {
    const E = new Uint8Array(32), I = [i(), i(), i(), i()], F = [i(), i(), i(), i()];
    if (X.length !== t.SIGNATURE_LENGTH)
      throw new Error(`ed25519: signature must be ${t.SIGNATURE_LENGTH} bytes`);
    if (U(F, V))
      return !1;
    const se = new r.SHA512();
    se.update(X.subarray(0, 32)), se.update(V), se.update(Q);
    const fe = se.digest();
    return D(fe), h(I, F, fe), m(F, X.subarray(32)), he(I, F), k(E, I), !H(X, E);
  }
  t.verify = me;
  function pe(V) {
    let Q = [i(), i(), i(), i()];
    if (U(Q, V))
      throw new Error("Ed25519: invalid public key");
    let X = i(), E = i(), I = Q[1];
    L(X, u, I), P(E, u, I), ie(E, E), v(X, X, E);
    let F = new Uint8Array(32);
    return G(F, X), F;
  }
  t.convertPublicKeyToX25519 = pe;
  function ee(V) {
    const Q = (0, r.hash)(V.subarray(0, 32));
    Q[0] &= 248, Q[31] &= 127, Q[31] |= 64;
    const X = new Uint8Array(Q.subarray(0, 32));
    return (0, n.wipe)(Q), X;
  }
  t.convertSecretKeyToX25519 = ee;
})(Mg);
const PU = "EdDSA", TU = "JWT", WE = ".", KE = "base64url", NU = "utf8", kU = "utf8", LU = ":", $U = "did", FU = "key", k_ = "base58btc", BU = "z", UU = "K36", jU = 32;
function ch(t) {
  return Zr(dn(vo(t), NU), KE);
}
function GE(t) {
  const e = dn(UU, k_), r = BU + Zr(op([e, t]), k_);
  return [$U, FU, r].join(LU);
}
function HU(t) {
  return Zr(t, KE);
}
function qU(t) {
  return dn([ch(t.header), ch(t.payload)].join(WE), kU);
}
function zU(t) {
  return [
    ch(t.header),
    ch(t.payload),
    HU(t.signature)
  ].join(WE);
}
function L_(t = La.randomBytes(jU)) {
  return Mg.generateKeyPairFromSeed(t);
}
async function VU(t, e, r, n, i = He.fromMiliseconds(Date.now())) {
  const o = { alg: PU, typ: TU }, c = GE(n.publicKey), u = i + r, l = { iss: c, sub: t, aud: e, iat: i, exp: u }, f = qU({ header: o, payload: l }), p = Mg.sign(n.secretKey, f);
  return zU({ header: o, payload: l, signature: p });
}
const WU = "PARSE_ERROR", KU = "INVALID_REQUEST", GU = "METHOD_NOT_FOUND", JU = "INVALID_PARAMS", JE = "INTERNAL_ERROR", Dg = "SERVER_ERROR", QU = [-32700, -32600, -32601, -32602, -32603], Ac = {
  [WU]: { code: -32700, message: "Parse error" },
  [KU]: { code: -32600, message: "Invalid Request" },
  [GU]: { code: -32601, message: "Method not found" },
  [JU]: { code: -32602, message: "Invalid params" },
  [JE]: { code: -32603, message: "Internal error" },
  [Dg]: { code: -32e3, message: "Server error" }
}, QE = Dg;
function ZU(t) {
  return QU.includes(t);
}
function $_(t) {
  return Object.keys(Ac).includes(t) ? Ac[t] : Ac[QE];
}
function YU(t) {
  const e = Object.values(Ac).find((r) => r.code === t);
  return e || Ac[QE];
}
function ZE(t, e, r) {
  return t.message.includes("getaddrinfo ENOTFOUND") || t.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${r} RPC url at ${e}`) : t;
}
var YE = {}, zi = {}, F_;
function XU() {
  if (F_)
    return zi;
  F_ = 1, Object.defineProperty(zi, "__esModule", { value: !0 }), zi.isBrowserCryptoAvailable = zi.getSubtleCrypto = zi.getBrowerCrypto = void 0;
  function t() {
    return (Te === null || Te === void 0 ? void 0 : Te.crypto) || (Te === null || Te === void 0 ? void 0 : Te.msCrypto) || {};
  }
  zi.getBrowerCrypto = t;
  function e() {
    const n = t();
    return n.subtle || n.webkitSubtle;
  }
  zi.getSubtleCrypto = e;
  function r() {
    return !!t() && !!e();
  }
  return zi.isBrowserCryptoAvailable = r, zi;
}
var Vi = {}, B_;
function ej() {
  if (B_)
    return Vi;
  B_ = 1, Object.defineProperty(Vi, "__esModule", { value: !0 }), Vi.isBrowser = Vi.isNode = Vi.isReactNative = void 0;
  function t() {
    return typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative";
  }
  Vi.isReactNative = t;
  function e() {
    return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
  }
  Vi.isNode = e;
  function r() {
    return !t() && !e();
  }
  return Vi.isBrowser = r, Vi;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const e = Ti;
  e.__exportStar(XU(), t), e.__exportStar(ej(), t);
})(YE);
function Og(t = 3) {
  const e = Date.now() * Math.pow(10, t), r = Math.floor(Math.random() * Math.pow(10, t));
  return e + r;
}
function XE(t = 6) {
  return BigInt(Og(t));
}
function ga(t, e, r) {
  return {
    id: r || Og(),
    jsonrpc: "2.0",
    method: t,
    params: e
  };
}
function vf(t, e) {
  return {
    id: t,
    jsonrpc: "2.0",
    result: e
  };
}
function yf(t, e, r) {
  return {
    id: t,
    jsonrpc: "2.0",
    error: tj(e, r)
  };
}
function tj(t, e) {
  return typeof t > "u" ? $_(JE) : (typeof t == "string" && (t = Object.assign(Object.assign({}, $_(Dg)), { message: t })), typeof e < "u" && (t.data = e), ZU(t.code) && (t = YU(t.code)), t);
}
class rj {
}
class nj extends rj {
  constructor() {
    super();
  }
}
class ij extends nj {
  constructor(e) {
    super();
  }
}
const sj = "^https?:", oj = "^wss?:";
function aj(t) {
  const e = t.match(new RegExp(/^\w+:/, "gi"));
  if (!(!e || !e.length))
    return e[0];
}
function e3(t, e) {
  const r = aj(t);
  return typeof r > "u" ? !1 : new RegExp(e).test(r);
}
function U_(t) {
  return e3(t, sj);
}
function j_(t) {
  return e3(t, oj);
}
function cj(t) {
  return new RegExp("wss?://localhost(:d{2,5})?").test(t);
}
function t3(t) {
  return typeof t == "object" && "id" in t && "jsonrpc" in t && t.jsonrpc === "2.0";
}
function Pg(t) {
  return t3(t) && "method" in t;
}
function _f(t) {
  return t3(t) && (Qi(t) || li(t));
}
function Qi(t) {
  return "result" in t;
}
function li(t) {
  return "error" in t;
}
class ss extends ij {
  constructor(e) {
    super(e), this.events = new Tr.EventEmitter(), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(e), this.connection.connected && this.registerEventListeners();
  }
  async connect(e = this.connection) {
    await this.open(e);
  }
  async disconnect() {
    await this.close();
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async request(e, r) {
    return this.requestStrict(ga(e.method, e.params || [], e.id || XE().toString()), r);
  }
  async requestStrict(e, r) {
    return new Promise(async (n, i) => {
      if (!this.connection.connected)
        try {
          await this.open();
        } catch (o) {
          i(o);
        }
      this.events.on(`${e.id}`, (o) => {
        li(o) ? i(o.error) : n(o.result);
      });
      try {
        await this.connection.send(e, r);
      } catch (o) {
        i(o);
      }
    });
  }
  setConnection(e = this.connection) {
    return e;
  }
  onPayload(e) {
    this.events.emit("payload", e), _f(e) ? this.events.emit(`${e.id}`, e) : this.events.emit("message", {
      type: e.method,
      data: e.params
    });
  }
  onClose(e) {
    e && e.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${e.code} ${e.reason ? `(${e.reason})` : ""}`)), this.events.emit("disconnect");
  }
  async open(e = this.connection) {
    this.connection === e && this.connection.connected || (this.connection.connected && this.close(), typeof e == "string" && (await this.connection.open(e), e = this.connection), this.connection = this.setConnection(e), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
  }
  async close() {
    await this.connection.close();
  }
  registerEventListeners() {
    this.hasRegisteredEventListeners || (this.connection.on("payload", (e) => this.onPayload(e)), this.connection.on("close", (e) => this.onClose(e)), this.connection.on("error", (e) => this.events.emit("error", e)), this.connection.on("register_error", (e) => this.onClose()), this.hasRegisteredEventListeners = !0);
  }
}
const uj = () => typeof WebSocket < "u" ? WebSocket : typeof global < "u" && typeof global.WebSocket < "u" ? global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : require("ws"), lj = () => typeof WebSocket < "u" || typeof global < "u" && typeof global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", H_ = (t) => t.split("?")[0], q_ = 10, hj = uj();
let fj = class {
  constructor(e) {
    if (this.url = e, this.events = new Tr.EventEmitter(), this.registering = !1, !j_(e))
      throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
    this.url = e;
  }
  get connected() {
    return typeof this.socket < "u";
  }
  get connecting() {
    return this.registering;
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async open(e = this.url) {
    await this.register(e);
  }
  async close() {
    return new Promise((e, r) => {
      if (typeof this.socket > "u") {
        r(new Error("Connection already closed"));
        return;
      }
      this.socket.onclose = (n) => {
        this.onClose(n), e();
      }, this.socket.close();
    });
  }
  async send(e) {
    typeof this.socket > "u" && (this.socket = await this.register());
    try {
      this.socket.send(vo(e));
    } catch (r) {
      this.onError(e.id, r);
    }
  }
  register(e = this.url) {
    if (!j_(e))
      throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
    if (this.registering) {
      const r = this.events.getMaxListeners();
      return (this.events.listenerCount("register_error") >= r || this.events.listenerCount("open") >= r) && this.events.setMaxListeners(r + 1), new Promise((n, i) => {
        this.events.once("register_error", (o) => {
          this.resetMaxListeners(), i(o);
        }), this.events.once("open", () => {
          if (this.resetMaxListeners(), typeof this.socket > "u")
            return i(new Error("WebSocket connection is missing or invalid"));
          n(this.socket);
        });
      });
    }
    return this.url = e, this.registering = !0, new Promise((r, n) => {
      const i = new URLSearchParams(e).get("origin"), o = YE.isReactNative() ? { headers: { origin: i } } : { rejectUnauthorized: !cj(e) }, c = new hj(e, [], o);
      lj() ? c.onerror = (u) => {
        const l = u;
        n(this.emitError(l.error));
      } : c.on("error", (u) => {
        n(this.emitError(u));
      }), c.onopen = () => {
        this.onOpen(c), r(c);
      };
    });
  }
  onOpen(e) {
    e.onmessage = (r) => this.onPayload(r), e.onclose = (r) => this.onClose(r), this.socket = e, this.registering = !1, this.events.emit("open");
  }
  onClose(e) {
    this.socket = void 0, this.registering = !1, this.events.emit("close", e);
  }
  onPayload(e) {
    if (typeof e.data > "u")
      return;
    const r = typeof e.data == "string" ? _u(e.data) : e.data;
    this.events.emit("payload", r);
  }
  onError(e, r) {
    const n = this.parseError(r), i = n.message || n.toString(), o = yf(e, i);
    this.events.emit("payload", o);
  }
  parseError(e, r = this.url) {
    return ZE(e, H_(r), "WS");
  }
  resetMaxListeners() {
    this.events.getMaxListeners() > q_ && this.events.setMaxListeners(q_);
  }
  emitError(e) {
    const r = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${H_(this.url)}`));
    return this.events.emit("register_error", r), r;
  }
};
var uh = { exports: {} };
uh.exports;
(function(t, e) {
  var r = 200, n = "__lodash_hash_undefined__", i = 1, o = 2, c = 9007199254740991, u = "[object Arguments]", l = "[object Array]", f = "[object AsyncFunction]", p = "[object Boolean]", g = "[object Date]", y = "[object Error]", C = "[object Function]", R = "[object GeneratorFunction]", J = "[object Map]", G = "[object Number]", H = "[object Null]", T = "[object Object]", q = "[object Promise]", B = "[object Proxy]", L = "[object RegExp]", P = "[object Set]", v = "[object String]", N = "[object Symbol]", ie = "[object Undefined]", le = "[object WeakMap]", he = "[object ArrayBuffer]", ye = "[object DataView]", k = "[object Float32Array]", h = "[object Float64Array]", m = "[object Int8Array]", x = "[object Int16Array]", M = "[object Int32Array]", A = "[object Uint8Array]", $ = "[object Uint8ClampedArray]", K = "[object Uint16Array]", D = "[object Uint32Array]", w = /[\\^$.*+?()[\]{}|]/g, U = /^\[object .+?Constructor\]$/, me = /^(?:0|[1-9]\d*)$/, pe = {};
  pe[k] = pe[h] = pe[m] = pe[x] = pe[M] = pe[A] = pe[$] = pe[K] = pe[D] = !0, pe[u] = pe[l] = pe[he] = pe[p] = pe[ye] = pe[g] = pe[y] = pe[C] = pe[J] = pe[G] = pe[T] = pe[L] = pe[P] = pe[v] = pe[le] = !1;
  var ee = typeof Te == "object" && Te && Te.Object === Object && Te, V = typeof self == "object" && self && self.Object === Object && self, Q = ee || V || Function("return this")(), X = e && !e.nodeType && e, E = X && !0 && t && !t.nodeType && t, I = E && E.exports === X, F = I && ee.process, se = function() {
    try {
      return F && F.binding && F.binding("util");
    } catch {
    }
  }(), fe = se && se.isTypedArray;
  function Re(Y, oe) {
    for (var be = -1, Pe = Y == null ? 0 : Y.length, Wt = 0, ot = []; ++be < Pe; ) {
      var Zt = Y[be];
      oe(Zt, be, Y) && (ot[Wt++] = Zt);
    }
    return ot;
  }
  function j(Y, oe) {
    for (var be = -1, Pe = oe.length, Wt = Y.length; ++be < Pe; )
      Y[Wt + be] = oe[be];
    return Y;
  }
  function b(Y, oe) {
    for (var be = -1, Pe = Y == null ? 0 : Y.length; ++be < Pe; )
      if (oe(Y[be], be, Y))
        return !0;
    return !1;
  }
  function S(Y, oe) {
    for (var be = -1, Pe = Array(Y); ++be < Y; )
      Pe[be] = oe(be);
    return Pe;
  }
  function Z(Y) {
    return function(oe) {
      return Y(oe);
    };
  }
  function re(Y, oe) {
    return Y.has(oe);
  }
  function ue(Y, oe) {
    return Y?.[oe];
  }
  function ge(Y) {
    var oe = -1, be = Array(Y.size);
    return Y.forEach(function(Pe, Wt) {
      be[++oe] = [Wt, Pe];
    }), be;
  }
  function Ee(Y, oe) {
    return function(be) {
      return Y(oe(be));
    };
  }
  function Ie(Y) {
    var oe = -1, be = Array(Y.size);
    return Y.forEach(function(Pe) {
      be[++oe] = Pe;
    }), be;
  }
  var Ae = Array.prototype, xe = Function.prototype, Se = Object.prototype, Le = Q["__core-js_shared__"], Ne = xe.toString, Oe = Se.hasOwnProperty, it = function() {
    var Y = /[^.]+$/.exec(Le && Le.keys && Le.keys.IE_PROTO || "");
    return Y ? "Symbol(src)_1." + Y : "";
  }(), Fe = Se.toString, je = RegExp(
    "^" + Ne.call(Oe).replace(w, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), ut = I ? Q.Buffer : void 0, Be = Q.Symbol, ht = Q.Uint8Array, ar = Se.propertyIsEnumerable, bt = Ae.splice, ft = Be ? Be.toStringTag : void 0, Lr = Object.getOwnPropertySymbols, It = ut ? ut.isBuffer : void 0, Mt = Ee(Object.keys, Object), Tt = mn(Q, "DataView"), Ke = mn(Q, "Map"), Qe = mn(Q, "Promise"), Nt = mn(Q, "Set"), Je = mn(Q, "WeakMap"), Ge = mn(Object, "create"), Ht = Ni(Tt), tt = Ni(Ke), Ze = Ni(Qe), qt = Ni(Nt), Ye = Ni(Je), Xe = Be ? Be.prototype : void 0, kt = Xe ? Xe.valueOf : void 0;
  function qe(Y) {
    var oe = -1, be = Y == null ? 0 : Y.length;
    for (this.clear(); ++oe < be; ) {
      var Pe = Y[oe];
      this.set(Pe[0], Pe[1]);
    }
  }
  function rt() {
    this.__data__ = Ge ? Ge(null) : {}, this.size = 0;
  }
  function zt(Y) {
    var oe = this.has(Y) && delete this.__data__[Y];
    return this.size -= oe ? 1 : 0, oe;
  }
  function $t(Y) {
    var oe = this.__data__;
    if (Ge) {
      var be = oe[Y];
      return be === n ? void 0 : be;
    }
    return Oe.call(oe, Y) ? oe[Y] : void 0;
  }
  function Ft(Y) {
    var oe = this.__data__;
    return Ge ? oe[Y] !== void 0 : Oe.call(oe, Y);
  }
  function pi(Y, oe) {
    var be = this.__data__;
    return this.size += this.has(Y) ? 0 : 1, be[Y] = Ge && oe === void 0 ? n : oe, this;
  }
  qe.prototype.clear = rt, qe.prototype.delete = zt, qe.prototype.get = $t, qe.prototype.has = Ft, qe.prototype.set = pi;
  function vt(Y) {
    var oe = -1, be = Y == null ? 0 : Y.length;
    for (this.clear(); ++oe < be; ) {
      var Pe = Y[oe];
      this.set(Pe[0], Pe[1]);
    }
  }
  function Bt() {
    this.__data__ = [], this.size = 0;
  }
  function Wn(Y) {
    var oe = this.__data__, be = ks(oe, Y);
    if (be < 0)
      return !1;
    var Pe = oe.length - 1;
    return be == Pe ? oe.pop() : bt.call(oe, be, 1), --this.size, !0;
  }
  function Kn(Y) {
    var oe = this.__data__, be = ks(oe, Y);
    return be < 0 ? void 0 : oe[be][1];
  }
  function Gn(Y) {
    return ks(this.__data__, Y) > -1;
  }
  function Jn(Y, oe) {
    var be = this.__data__, Pe = ks(be, Y);
    return Pe < 0 ? (++this.size, be.push([Y, oe])) : be[Pe][1] = oe, this;
  }
  vt.prototype.clear = Bt, vt.prototype.delete = Wn, vt.prototype.get = Kn, vt.prototype.has = Gn, vt.prototype.set = Jn;
  function Ar(Y) {
    var oe = -1, be = Y == null ? 0 : Y.length;
    for (this.clear(); ++oe < be; ) {
      var Pe = Y[oe];
      this.set(Pe[0], Pe[1]);
    }
  }
  function Xr() {
    this.size = 0, this.__data__ = {
      hash: new qe(),
      map: new (Ke || vt)(),
      string: new qe()
    };
  }
  function Qn(Y) {
    var oe = cs(this, Y).delete(Y);
    return this.size -= oe ? 1 : 0, oe;
  }
  function en(Y) {
    return cs(this, Y).get(Y);
  }
  function Zn(Y) {
    return cs(this, Y).has(Y);
  }
  function Yn(Y, oe) {
    var be = cs(this, Y), Pe = be.size;
    return be.set(Y, oe), this.size += be.size == Pe ? 0 : 1, this;
  }
  Ar.prototype.clear = Xr, Ar.prototype.delete = Qn, Ar.prototype.get = en, Ar.prototype.has = Zn, Ar.prototype.set = Yn;
  function tn(Y) {
    var oe = -1, be = Y == null ? 0 : Y.length;
    for (this.__data__ = new Ar(); ++oe < be; )
      this.add(Y[oe]);
  }
  function Rn(Y) {
    return this.__data__.set(Y, n), this;
  }
  function An(Y) {
    return this.__data__.has(Y);
  }
  tn.prototype.add = tn.prototype.push = Rn, tn.prototype.has = An;
  function mr(Y) {
    var oe = this.__data__ = new vt(Y);
    this.size = oe.size;
  }
  function Os() {
    this.__data__ = new vt(), this.size = 0;
  }
  function Ps(Y) {
    var oe = this.__data__, be = oe.delete(Y);
    return this.size = oe.size, be;
  }
  function Ts(Y) {
    return this.__data__.get(Y);
  }
  function Ns(Y) {
    return this.__data__.has(Y);
  }
  function as(Y, oe) {
    var be = this.__data__;
    if (be instanceof vt) {
      var Pe = be.__data__;
      if (!Ke || Pe.length < r - 1)
        return Pe.push([Y, oe]), this.size = ++be.size, this;
      be = this.__data__ = new Ar(Pe);
    }
    return be.set(Y, oe), this.size = be.size, this;
  }
  mr.prototype.clear = Os, mr.prototype.delete = Ps, mr.prototype.get = Ts, mr.prototype.has = Ns, mr.prototype.set = as;
  function bu(Y, oe) {
    var be = Po(Y), Pe = !be && Tu(Y), Wt = !be && !Pe && za(Y), ot = !be && !Pe && !Wt && Lu(Y), Zt = be || Pe || Wt || ot, fr = Zt ? S(Y.length, String) : [], Et = fr.length;
    for (var Kt in Y)
      (oe || Oe.call(Y, Kt)) && !(Zt && // Safari 9 has enumerable `arguments.length` in strict mode.
      (Kt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      Wt && (Kt == "offset" || Kt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      ot && (Kt == "buffer" || Kt == "byteLength" || Kt == "byteOffset") || // Skip index properties.
      Au(Kt, Et))) && fr.push(Kt);
    return fr;
  }
  function ks(Y, oe) {
    for (var be = Y.length; be--; )
      if (Pu(Y[be][0], oe))
        return be;
    return -1;
  }
  function Ha(Y, oe, be) {
    var Pe = oe(Y);
    return Po(Y) ? Pe : j(Pe, be(Y));
  }
  function Ls(Y) {
    return Y == null ? Y === void 0 ? ie : H : ft && ft in Object(Y) ? xu(Y) : Cf(Y);
  }
  function qa(Y) {
    return Fs(Y) && Ls(Y) == u;
  }
  function $s(Y, oe, be, Pe, Wt) {
    return Y === oe ? !0 : Y == null || oe == null || !Fs(Y) && !Fs(oe) ? Y !== Y && oe !== oe : Eu(Y, oe, be, Pe, $s, Wt);
  }
  function Eu(Y, oe, be, Pe, Wt, ot) {
    var Zt = Po(Y), fr = Po(oe), Et = Zt ? l : gi(Y), Kt = fr ? l : gi(oe);
    Et = Et == u ? T : Et, Kt = Kt == u ? T : Kt;
    var cr = Et == T, rn = Kt == T, dr = Et == Kt;
    if (dr && za(Y)) {
      if (!za(oe))
        return !1;
      Zt = !0, cr = !1;
    }
    if (dr && !cr)
      return ot || (ot = new mr()), Zt || Lu(Y) ? Do(Y, oe, be, Pe, Wt, ot) : Sf(Y, oe, Et, be, Pe, Wt, ot);
    if (!(be & i)) {
      var Yt = cr && Oe.call(Y, "__wrapped__"), Hr = rn && Oe.call(oe, "__wrapped__");
      if (Yt || Hr) {
        var Xn = Yt ? Y.value() : Y, Mn = Hr ? oe.value() : oe;
        return ot || (ot = new mr()), Wt(Xn, Mn, be, Pe, ot);
      }
    }
    return dr ? (ot || (ot = new mr()), Iu(Y, oe, be, Pe, Wt, ot)) : !1;
  }
  function Ef(Y) {
    if (!ku(Y) || Du(Y))
      return !1;
    var oe = To(Y) ? je : U;
    return oe.test(Ni(Y));
  }
  function Su(Y) {
    return Fs(Y) && Nu(Y.length) && !!pe[Ls(Y)];
  }
  function Cu(Y) {
    if (!Ou(Y))
      return Mt(Y);
    var oe = [];
    for (var be in Object(Y))
      Oe.call(Y, be) && be != "constructor" && oe.push(be);
    return oe;
  }
  function Do(Y, oe, be, Pe, Wt, ot) {
    var Zt = be & i, fr = Y.length, Et = oe.length;
    if (fr != Et && !(Zt && Et > fr))
      return !1;
    var Kt = ot.get(Y);
    if (Kt && ot.get(oe))
      return Kt == oe;
    var cr = -1, rn = !0, dr = be & o ? new tn() : void 0;
    for (ot.set(Y, oe), ot.set(oe, Y); ++cr < fr; ) {
      var Yt = Y[cr], Hr = oe[cr];
      if (Pe)
        var Xn = Zt ? Pe(Hr, Yt, cr, oe, Y, ot) : Pe(Yt, Hr, cr, Y, oe, ot);
      if (Xn !== void 0) {
        if (Xn)
          continue;
        rn = !1;
        break;
      }
      if (dr) {
        if (!b(oe, function(Mn, mi) {
          if (!re(dr, mi) && (Yt === Mn || Wt(Yt, Mn, be, Pe, ot)))
            return dr.push(mi);
        })) {
          rn = !1;
          break;
        }
      } else if (!(Yt === Hr || Wt(Yt, Hr, be, Pe, ot))) {
        rn = !1;
        break;
      }
    }
    return ot.delete(Y), ot.delete(oe), rn;
  }
  function Sf(Y, oe, be, Pe, Wt, ot, Zt) {
    switch (be) {
      case ye:
        if (Y.byteLength != oe.byteLength || Y.byteOffset != oe.byteOffset)
          return !1;
        Y = Y.buffer, oe = oe.buffer;
      case he:
        return !(Y.byteLength != oe.byteLength || !ot(new ht(Y), new ht(oe)));
      case p:
      case g:
      case G:
        return Pu(+Y, +oe);
      case y:
        return Y.name == oe.name && Y.message == oe.message;
      case L:
      case v:
        return Y == oe + "";
      case J:
        var fr = ge;
      case P:
        var Et = Pe & i;
        if (fr || (fr = Ie), Y.size != oe.size && !Et)
          return !1;
        var Kt = Zt.get(Y);
        if (Kt)
          return Kt == oe;
        Pe |= o, Zt.set(Y, oe);
        var cr = Do(fr(Y), fr(oe), Pe, Wt, ot, Zt);
        return Zt.delete(Y), cr;
      case N:
        if (kt)
          return kt.call(Y) == kt.call(oe);
    }
    return !1;
  }
  function Iu(Y, oe, be, Pe, Wt, ot) {
    var Zt = be & i, fr = Oo(Y), Et = fr.length, Kt = Oo(oe), cr = Kt.length;
    if (Et != cr && !Zt)
      return !1;
    for (var rn = Et; rn--; ) {
      var dr = fr[rn];
      if (!(Zt ? dr in oe : Oe.call(oe, dr)))
        return !1;
    }
    var Yt = ot.get(Y);
    if (Yt && ot.get(oe))
      return Yt == oe;
    var Hr = !0;
    ot.set(Y, oe), ot.set(oe, Y);
    for (var Xn = Zt; ++rn < Et; ) {
      dr = fr[rn];
      var Mn = Y[dr], mi = oe[dr];
      if (Pe)
        var Va = Zt ? Pe(mi, Mn, dr, oe, Y, ot) : Pe(Mn, mi, dr, Y, oe, ot);
      if (!(Va === void 0 ? Mn === mi || Wt(Mn, mi, be, Pe, ot) : Va)) {
        Hr = !1;
        break;
      }
      Xn || (Xn = dr == "constructor");
    }
    if (Hr && !Xn) {
      var Bs = Y.constructor, br = oe.constructor;
      Bs != br && "constructor" in Y && "constructor" in oe && !(typeof Bs == "function" && Bs instanceof Bs && typeof br == "function" && br instanceof br) && (Hr = !1);
    }
    return ot.delete(Y), ot.delete(oe), Hr;
  }
  function Oo(Y) {
    return Ha(Y, Rf, Ru);
  }
  function cs(Y, oe) {
    var be = Y.__data__;
    return Mu(oe) ? be[typeof oe == "string" ? "string" : "hash"] : be.map;
  }
  function mn(Y, oe) {
    var be = ue(Y, oe);
    return Ef(be) ? be : void 0;
  }
  function xu(Y) {
    var oe = Oe.call(Y, ft), be = Y[ft];
    try {
      Y[ft] = void 0;
      var Pe = !0;
    } catch {
    }
    var Wt = Fe.call(Y);
    return Pe && (oe ? Y[ft] = be : delete Y[ft]), Wt;
  }
  var Ru = Lr ? function(Y) {
    return Y == null ? [] : (Y = Object(Y), Re(Lr(Y), function(oe) {
      return ar.call(Y, oe);
    }));
  } : Vt, gi = Ls;
  (Tt && gi(new Tt(new ArrayBuffer(1))) != ye || Ke && gi(new Ke()) != J || Qe && gi(Qe.resolve()) != q || Nt && gi(new Nt()) != P || Je && gi(new Je()) != le) && (gi = function(Y) {
    var oe = Ls(Y), be = oe == T ? Y.constructor : void 0, Pe = be ? Ni(be) : "";
    if (Pe)
      switch (Pe) {
        case Ht:
          return ye;
        case tt:
          return J;
        case Ze:
          return q;
        case qt:
          return P;
        case Ye:
          return le;
      }
    return oe;
  });
  function Au(Y, oe) {
    return oe = oe ?? c, !!oe && (typeof Y == "number" || me.test(Y)) && Y > -1 && Y % 1 == 0 && Y < oe;
  }
  function Mu(Y) {
    var oe = typeof Y;
    return oe == "string" || oe == "number" || oe == "symbol" || oe == "boolean" ? Y !== "__proto__" : Y === null;
  }
  function Du(Y) {
    return !!it && it in Y;
  }
  function Ou(Y) {
    var oe = Y && Y.constructor, be = typeof oe == "function" && oe.prototype || Se;
    return Y === be;
  }
  function Cf(Y) {
    return Fe.call(Y);
  }
  function Ni(Y) {
    if (Y != null) {
      try {
        return Ne.call(Y);
      } catch {
      }
      try {
        return Y + "";
      } catch {
      }
    }
    return "";
  }
  function Pu(Y, oe) {
    return Y === oe || Y !== Y && oe !== oe;
  }
  var Tu = qa(/* @__PURE__ */ function() {
    return arguments;
  }()) ? qa : function(Y) {
    return Fs(Y) && Oe.call(Y, "callee") && !ar.call(Y, "callee");
  }, Po = Array.isArray;
  function If(Y) {
    return Y != null && Nu(Y.length) && !To(Y);
  }
  var za = It || Ut;
  function xf(Y, oe) {
    return $s(Y, oe);
  }
  function To(Y) {
    if (!ku(Y))
      return !1;
    var oe = Ls(Y);
    return oe == C || oe == R || oe == f || oe == B;
  }
  function Nu(Y) {
    return typeof Y == "number" && Y > -1 && Y % 1 == 0 && Y <= c;
  }
  function ku(Y) {
    var oe = typeof Y;
    return Y != null && (oe == "object" || oe == "function");
  }
  function Fs(Y) {
    return Y != null && typeof Y == "object";
  }
  var Lu = fe ? Z(fe) : Su;
  function Rf(Y) {
    return If(Y) ? bu(Y) : Cu(Y);
  }
  function Vt() {
    return [];
  }
  function Ut() {
    return !1;
  }
  t.exports = xf;
})(uh, uh.exports);
var dj = uh.exports;
const pj = /* @__PURE__ */ Bc(dj);
function gj(t, e) {
  return e = e || {}, new Promise(function(r, n) {
    var i = new XMLHttpRequest(), o = [], c = [], u = {}, l = function() {
      return { ok: (i.status / 100 | 0) == 2, statusText: i.statusText, status: i.status, url: i.responseURL, text: function() {
        return Promise.resolve(i.responseText);
      }, json: function() {
        return Promise.resolve(i.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([i.response]));
      }, clone: l, headers: { keys: function() {
        return o;
      }, entries: function() {
        return c;
      }, get: function(p) {
        return u[p.toLowerCase()];
      }, has: function(p) {
        return p.toLowerCase() in u;
      } } };
    };
    for (var f in i.open(e.method || "get", t, !0), i.onload = function() {
      i.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(p, g, y) {
        o.push(g = g.toLowerCase()), c.push([g, y]), u[g] = u[g] ? u[g] + "," + y : y;
      }), r(l());
    }, i.onerror = n, i.withCredentials = e.credentials == "include", e.headers)
      i.setRequestHeader(f, e.headers[f]);
    i.send(e.body || null);
  });
}
const mj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gj
}, Symbol.toStringTag, { value: "Module" })), z_ = /* @__PURE__ */ is(mj);
var vj = self.fetch || (self.fetch = z_.default || z_);
const yj = /* @__PURE__ */ Bc(vj);
function _j(t, e) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var r = new Uint8Array(256), n = 0; n < r.length; n++)
    r[n] = 255;
  for (var i = 0; i < t.length; i++) {
    var o = t.charAt(i), c = o.charCodeAt(0);
    if (r[c] !== 255)
      throw new TypeError(o + " is ambiguous");
    r[c] = i;
  }
  var u = t.length, l = t.charAt(0), f = Math.log(u) / Math.log(256), p = Math.log(256) / Math.log(u);
  function g(R) {
    if (R instanceof Uint8Array || (ArrayBuffer.isView(R) ? R = new Uint8Array(R.buffer, R.byteOffset, R.byteLength) : Array.isArray(R) && (R = Uint8Array.from(R))), !(R instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (R.length === 0)
      return "";
    for (var J = 0, G = 0, H = 0, T = R.length; H !== T && R[H] === 0; )
      H++, J++;
    for (var q = (T - H) * p + 1 >>> 0, B = new Uint8Array(q); H !== T; ) {
      for (var L = R[H], P = 0, v = q - 1; (L !== 0 || P < G) && v !== -1; v--, P++)
        L += 256 * B[v] >>> 0, B[v] = L % u >>> 0, L = L / u >>> 0;
      if (L !== 0)
        throw new Error("Non-zero carry");
      G = P, H++;
    }
    for (var N = q - G; N !== q && B[N] === 0; )
      N++;
    for (var ie = l.repeat(J); N < q; ++N)
      ie += t.charAt(B[N]);
    return ie;
  }
  function y(R) {
    if (typeof R != "string")
      throw new TypeError("Expected String");
    if (R.length === 0)
      return new Uint8Array();
    var J = 0;
    if (R[J] !== " ") {
      for (var G = 0, H = 0; R[J] === l; )
        G++, J++;
      for (var T = (R.length - J) * f + 1 >>> 0, q = new Uint8Array(T); R[J]; ) {
        var B = r[R.charCodeAt(J)];
        if (B === 255)
          return;
        for (var L = 0, P = T - 1; (B !== 0 || L < H) && P !== -1; P--, L++)
          B += u * q[P] >>> 0, q[P] = B % 256 >>> 0, B = B / 256 >>> 0;
        if (B !== 0)
          throw new Error("Non-zero carry");
        H = L, J++;
      }
      if (R[J] !== " ") {
        for (var v = T - H; v !== T && q[v] === 0; )
          v++;
        for (var N = new Uint8Array(G + (T - v)), ie = G; v !== T; )
          N[ie++] = q[v++];
        return N;
      }
    }
  }
  function C(R) {
    var J = y(R);
    if (J)
      return J;
    throw new Error(`Non-${e} character`);
  }
  return { encode: g, decodeUnsafe: y, decode: C };
}
var wj = _j, bj = wj;
const r3 = (t) => {
  if (t instanceof Uint8Array && t.constructor.name === "Uint8Array")
    return t;
  if (t instanceof ArrayBuffer)
    return new Uint8Array(t);
  if (ArrayBuffer.isView(t))
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  throw new Error("Unknown type, must be binary type");
}, Ej = (t) => new TextEncoder().encode(t), Sj = (t) => new TextDecoder().decode(t);
class Cj {
  constructor(e, r, n) {
    this.name = e, this.prefix = r, this.baseEncode = n;
  }
  encode(e) {
    if (e instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class Ij {
  constructor(e, r, n) {
    if (this.name = e, this.prefix = r, r.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = r.codePointAt(0), this.baseDecode = n;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(e) {
    return n3(this, e);
  }
}
class xj {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return n3(this, e);
  }
  decode(e) {
    const r = e[0], n = this.decoders[r];
    if (n)
      return n.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const n3 = (t, e) => new xj({ ...t.decoders || { [t.prefix]: t }, ...e.decoders || { [e.prefix]: e } });
class Rj {
  constructor(e, r, n, i) {
    this.name = e, this.prefix = r, this.baseEncode = n, this.baseDecode = i, this.encoder = new Cj(e, r, n), this.decoder = new Ij(e, r, i);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
}
const wf = ({ name: t, prefix: e, encode: r, decode: n }) => new Rj(t, e, r, n), wu = ({ prefix: t, name: e, alphabet: r }) => {
  const { encode: n, decode: i } = bj(r, e);
  return wf({ prefix: t, name: e, encode: n, decode: (o) => r3(i(o)) });
}, Aj = (t, e, r, n) => {
  const i = {};
  for (let p = 0; p < e.length; ++p)
    i[e[p]] = p;
  let o = t.length;
  for (; t[o - 1] === "="; )
    --o;
  const c = new Uint8Array(o * r / 8 | 0);
  let u = 0, l = 0, f = 0;
  for (let p = 0; p < o; ++p) {
    const g = i[t[p]];
    if (g === void 0)
      throw new SyntaxError(`Non-${n} character`);
    l = l << r | g, u += r, u >= 8 && (u -= 8, c[f++] = 255 & l >> u);
  }
  if (u >= r || 255 & l << 8 - u)
    throw new SyntaxError("Unexpected end of data");
  return c;
}, Mj = (t, e, r) => {
  const n = e[e.length - 1] === "=", i = (1 << r) - 1;
  let o = "", c = 0, u = 0;
  for (let l = 0; l < t.length; ++l)
    for (u = u << 8 | t[l], c += 8; c > r; )
      c -= r, o += e[i & u >> c];
  if (c && (o += e[i & u << r - c]), n)
    for (; o.length * r & 7; )
      o += "=";
  return o;
}, kr = ({ name: t, prefix: e, bitsPerChar: r, alphabet: n }) => wf({ prefix: e, name: t, encode(i) {
  return Mj(i, n, r);
}, decode(i) {
  return Aj(i, n, r, t);
} }), Dj = wf({ prefix: "\0", name: "identity", encode: (t) => Sj(t), decode: (t) => Ej(t) });
var Oj = Object.freeze({ __proto__: null, identity: Dj });
const Pj = kr({ prefix: "0", name: "base2", alphabet: "01", bitsPerChar: 1 });
var Tj = Object.freeze({ __proto__: null, base2: Pj });
const Nj = kr({ prefix: "7", name: "base8", alphabet: "01234567", bitsPerChar: 3 });
var kj = Object.freeze({ __proto__: null, base8: Nj });
const Lj = wu({ prefix: "9", name: "base10", alphabet: "0123456789" });
var $j = Object.freeze({ __proto__: null, base10: Lj });
const Fj = kr({ prefix: "f", name: "base16", alphabet: "0123456789abcdef", bitsPerChar: 4 }), Bj = kr({ prefix: "F", name: "base16upper", alphabet: "0123456789ABCDEF", bitsPerChar: 4 });
var Uj = Object.freeze({ __proto__: null, base16: Fj, base16upper: Bj });
const jj = kr({ prefix: "b", name: "base32", alphabet: "abcdefghijklmnopqrstuvwxyz234567", bitsPerChar: 5 }), Hj = kr({ prefix: "B", name: "base32upper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", bitsPerChar: 5 }), qj = kr({ prefix: "c", name: "base32pad", alphabet: "abcdefghijklmnopqrstuvwxyz234567=", bitsPerChar: 5 }), zj = kr({ prefix: "C", name: "base32padupper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=", bitsPerChar: 5 }), Vj = kr({ prefix: "v", name: "base32hex", alphabet: "0123456789abcdefghijklmnopqrstuv", bitsPerChar: 5 }), Wj = kr({ prefix: "V", name: "base32hexupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV", bitsPerChar: 5 }), Kj = kr({ prefix: "t", name: "base32hexpad", alphabet: "0123456789abcdefghijklmnopqrstuv=", bitsPerChar: 5 }), Gj = kr({ prefix: "T", name: "base32hexpadupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=", bitsPerChar: 5 }), Jj = kr({ prefix: "h", name: "base32z", alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769", bitsPerChar: 5 });
var Qj = Object.freeze({ __proto__: null, base32: jj, base32upper: Hj, base32pad: qj, base32padupper: zj, base32hex: Vj, base32hexupper: Wj, base32hexpad: Kj, base32hexpadupper: Gj, base32z: Jj });
const Zj = wu({ prefix: "k", name: "base36", alphabet: "0123456789abcdefghijklmnopqrstuvwxyz" }), Yj = wu({ prefix: "K", name: "base36upper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ" });
var Xj = Object.freeze({ __proto__: null, base36: Zj, base36upper: Yj });
const eH = wu({ name: "base58btc", prefix: "z", alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz" }), tH = wu({ name: "base58flickr", prefix: "Z", alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ" });
var rH = Object.freeze({ __proto__: null, base58btc: eH, base58flickr: tH });
const nH = kr({ prefix: "m", name: "base64", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", bitsPerChar: 6 }), iH = kr({ prefix: "M", name: "base64pad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", bitsPerChar: 6 }), sH = kr({ prefix: "u", name: "base64url", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", bitsPerChar: 6 }), oH = kr({ prefix: "U", name: "base64urlpad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=", bitsPerChar: 6 });
var aH = Object.freeze({ __proto__: null, base64: nH, base64pad: iH, base64url: sH, base64urlpad: oH });
const i3 = Array.from("🚀🪐☄🛰🌌🌑🌒🌓🌔🌕🌖🌗🌘🌍🌏🌎🐉☀💻🖥💾💿😂❤😍🤣😊🙏💕😭😘👍😅👏😁🔥🥰💔💖💙😢🤔😆🙄💪😉☺👌🤗💜😔😎😇🌹🤦🎉💞✌✨🤷😱😌🌸🙌😋💗💚😏💛🙂💓🤩😄😀🖤😃💯🙈👇🎶😒🤭❣😜💋👀😪😑💥🙋😞😩😡🤪👊🥳😥🤤👉💃😳✋😚😝😴🌟😬🙃🍀🌷😻😓⭐✅🥺🌈😈🤘💦✔😣🏃💐☹🎊💘😠☝😕🌺🎂🌻😐🖕💝🙊😹🗣💫💀👑🎵🤞😛🔴😤🌼😫⚽🤙☕🏆🤫👈😮🙆🍻🍃🐶💁😲🌿🧡🎁⚡🌞🎈❌✊👋😰🤨😶🤝🚶💰🍓💢🤟🙁🚨💨🤬✈🎀🍺🤓😙💟🌱😖👶🥴▶➡❓💎💸⬇😨🌚🦋😷🕺⚠🙅😟😵👎🤲🤠🤧📌🔵💅🧐🐾🍒😗🤑🌊🤯🐷☎💧😯💆👆🎤🙇🍑❄🌴💣🐸💌📍🥀🤢👅💡💩👐📸👻🤐🤮🎼🥵🚩🍎🍊👼💍📣🥂"), cH = i3.reduce((t, e, r) => (t[r] = e, t), []), uH = i3.reduce((t, e, r) => (t[e.codePointAt(0)] = r, t), []);
function lH(t) {
  return t.reduce((e, r) => (e += cH[r], e), "");
}
function hH(t) {
  const e = [];
  for (const r of t) {
    const n = uH[r.codePointAt(0)];
    if (n === void 0)
      throw new Error(`Non-base256emoji character: ${r}`);
    e.push(n);
  }
  return new Uint8Array(e);
}
const fH = wf({ prefix: "🚀", name: "base256emoji", encode: lH, decode: hH });
var dH = Object.freeze({ __proto__: null, base256emoji: fH }), pH = s3, V_ = 128, gH = 127, mH = ~gH, vH = Math.pow(2, 31);
function s3(t, e, r) {
  e = e || [], r = r || 0;
  for (var n = r; t >= vH; )
    e[r++] = t & 255 | V_, t /= 128;
  for (; t & mH; )
    e[r++] = t & 255 | V_, t >>>= 7;
  return e[r] = t | 0, s3.bytes = r - n + 1, e;
}
var yH = mp, _H = 128, W_ = 127;
function mp(t, n) {
  var r = 0, n = n || 0, i = 0, o = n, c, u = t.length;
  do {
    if (o >= u)
      throw mp.bytes = 0, new RangeError("Could not decode varint");
    c = t[o++], r += i < 28 ? (c & W_) << i : (c & W_) * Math.pow(2, i), i += 7;
  } while (c >= _H);
  return mp.bytes = o - n, r;
}
var wH = Math.pow(2, 7), bH = Math.pow(2, 14), EH = Math.pow(2, 21), SH = Math.pow(2, 28), CH = Math.pow(2, 35), IH = Math.pow(2, 42), xH = Math.pow(2, 49), RH = Math.pow(2, 56), AH = Math.pow(2, 63), MH = function(t) {
  return t < wH ? 1 : t < bH ? 2 : t < EH ? 3 : t < SH ? 4 : t < CH ? 5 : t < IH ? 6 : t < xH ? 7 : t < RH ? 8 : t < AH ? 9 : 10;
}, DH = { encode: pH, decode: yH, encodingLength: MH }, o3 = DH;
const K_ = (t, e, r = 0) => (o3.encode(t, e, r), e), G_ = (t) => o3.encodingLength(t), vp = (t, e) => {
  const r = e.byteLength, n = G_(t), i = n + G_(r), o = new Uint8Array(i + r);
  return K_(t, o, 0), K_(r, o, n), o.set(e, i), new OH(t, r, e, o);
};
class OH {
  constructor(e, r, n, i) {
    this.code = e, this.size = r, this.digest = n, this.bytes = i;
  }
}
const a3 = ({ name: t, code: e, encode: r }) => new PH(t, e, r);
class PH {
  constructor(e, r, n) {
    this.name = e, this.code = r, this.encode = n;
  }
  digest(e) {
    if (e instanceof Uint8Array) {
      const r = this.encode(e);
      return r instanceof Uint8Array ? vp(this.code, r) : r.then((n) => vp(this.code, n));
    } else
      throw Error("Unknown type, must be binary type");
  }
}
const c3 = (t) => async (e) => new Uint8Array(await crypto.subtle.digest(t, e)), TH = a3({ name: "sha2-256", code: 18, encode: c3("SHA-256") }), NH = a3({ name: "sha2-512", code: 19, encode: c3("SHA-512") });
var kH = Object.freeze({ __proto__: null, sha256: TH, sha512: NH });
const u3 = 0, LH = "identity", l3 = r3, $H = (t) => vp(u3, l3(t)), FH = { code: u3, name: LH, encode: l3, digest: $H };
var BH = Object.freeze({ __proto__: null, identity: FH });
new TextEncoder(), new TextDecoder();
const J_ = { ...Oj, ...Tj, ...kj, ...$j, ...Uj, ...Qj, ...Xj, ...rH, ...aH, ...dH };
({ ...kH, ...BH });
function h3(t) {
  return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function UH(t = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? h3(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function f3(t, e, r, n) {
  return { name: t, prefix: e, encoder: { name: t, prefix: e, encode: r }, decoder: { decode: n } };
}
const Q_ = f3("utf8", "u", (t) => "u" + new TextDecoder("utf8").decode(t), (t) => new TextEncoder().encode(t.substring(1))), x0 = f3("ascii", "a", (t) => {
  let e = "a";
  for (let r = 0; r < t.length; r++)
    e += String.fromCharCode(t[r]);
  return e;
}, (t) => {
  t = t.substring(1);
  const e = UH(t.length);
  for (let r = 0; r < t.length; r++)
    e[r] = t.charCodeAt(r);
  return e;
}), jH = { utf8: Q_, "utf-8": Q_, hex: J_.base16, latin1: x0, ascii: x0, binary: x0, ...J_ };
function HH(t, e = "utf8") {
  const r = jH[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? h3(globalThis.Buffer.from(t, "utf-8")) : r.decoder.decode(`${r.prefix}${t}`);
}
const d3 = "wc", qH = 2, Tg = "core", xs = `${d3}@2:${Tg}:`, zH = { name: Tg, logger: "error" }, VH = { database: ":memory:" }, WH = "crypto", Z_ = "client_ed25519_seed", KH = He.ONE_DAY, GH = "keychain", JH = "0.3", QH = "messages", ZH = "0.3", YH = He.SIX_HOURS, XH = "publisher", p3 = "irn", eq = "error", g3 = "wss://relay.walletconnect.com", Y_ = "wss://relay.walletconnect.org", tq = "relayer", jr = { message: "relayer_message", message_ack: "relayer_message_ack", connect: "relayer_connect", disconnect: "relayer_disconnect", error: "relayer_error", connection_stalled: "relayer_connection_stalled", transport_closed: "relayer_transport_closed", publish: "relayer_publish" }, rq = "_subscription", Wi = { payload: "payload", connect: "connect", disconnect: "disconnect", error: "error" }, nq = He.ONE_SECOND, iq = "2.11.0", sq = 1e4, oq = "0.3", aq = "WALLETCONNECT_CLIENT_ID", ci = { created: "subscription_created", deleted: "subscription_deleted", expired: "subscription_expired", disabled: "subscription_disabled", sync: "subscription_sync", resubscribed: "subscription_resubscribed" }, cq = "subscription", uq = "0.3", lq = He.FIVE_SECONDS * 1e3, hq = "pairing", fq = "0.3", mc = { wc_pairingDelete: { req: { ttl: He.ONE_DAY, prompt: !1, tag: 1e3 }, res: { ttl: He.ONE_DAY, prompt: !1, tag: 1001 } }, wc_pairingPing: { req: { ttl: He.THIRTY_SECONDS, prompt: !1, tag: 1002 }, res: { ttl: He.THIRTY_SECONDS, prompt: !1, tag: 1003 } }, unregistered_method: { req: { ttl: He.ONE_DAY, prompt: !1, tag: 0 }, res: { ttl: He.ONE_DAY, prompt: !1, tag: 0 } } }, Ec = { create: "pairing_create", expire: "pairing_expire", delete: "pairing_delete", ping: "pairing_ping" }, Si = { created: "history_created", updated: "history_updated", deleted: "history_deleted", sync: "history_sync" }, dq = "history", pq = "0.3", gq = "expirer", Un = { created: "expirer_created", deleted: "expirer_deleted", expired: "expirer_expired", sync: "expirer_sync" }, mq = "0.3", R0 = "verify-api", oa = "https://verify.walletconnect.com", yp = "https://verify.walletconnect.org", vq = [oa, yp], yq = "echo", _q = "https://echo.walletconnect.com";
class wq {
  constructor(e, r) {
    this.core = e, this.logger = r, this.keychain = /* @__PURE__ */ new Map(), this.name = GH, this.version = JH, this.initialized = !1, this.storagePrefix = xs, this.init = async () => {
      if (!this.initialized) {
        const n = await this.getKeyChain();
        typeof n < "u" && (this.keychain = n), this.initialized = !0;
      }
    }, this.has = (n) => (this.isInitialized(), this.keychain.has(n)), this.set = async (n, i) => {
      this.isInitialized(), this.keychain.set(n, i), await this.persist();
    }, this.get = (n) => {
      this.isInitialized();
      const i = this.keychain.get(n);
      if (typeof i > "u") {
        const { message: o } = Me("NO_MATCHING_KEY", `${this.name}: ${n}`);
        throw new Error(o);
      }
      return i;
    }, this.del = async (n) => {
      this.isInitialized(), this.keychain.delete(n), await this.persist();
    }, this.core = e, this.logger = wt.generateChildLogger(r, this.name);
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  async setKeyChain(e) {
    await this.core.storage.setItem(this.storageKey, NE(e));
  }
  async getKeyChain() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? kE(e) : void 0;
  }
  async persist() {
    await this.setKeyChain(this.keychain);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class bq {
  constructor(e, r, n) {
    this.core = e, this.logger = r, this.name = WH, this.initialized = !1, this.init = async () => {
      this.initialized || (await this.keychain.init(), this.initialized = !0);
    }, this.hasKeys = (i) => (this.isInitialized(), this.keychain.has(i)), this.getClientId = async () => {
      this.isInitialized();
      const i = await this.getClientSeed(), o = L_(i);
      return GE(o.publicKey);
    }, this.generateKeyPair = () => {
      this.isInitialized();
      const i = wF();
      return this.setPrivateKey(i.publicKey, i.privateKey);
    }, this.signJWT = async (i) => {
      this.isInitialized();
      const o = await this.getClientSeed(), c = L_(o), u = dp();
      return await VU(u, i, KH, c);
    }, this.generateSharedKey = (i, o, c) => {
      this.isInitialized();
      const u = this.getPrivateKey(i), l = bF(u, o);
      return this.setSymKey(l, c);
    }, this.setSymKey = async (i, o) => {
      this.isInitialized();
      const c = o || EF(i);
      return await this.keychain.set(c, i), c;
    }, this.deleteKeyPair = async (i) => {
      this.isInitialized(), await this.keychain.del(i);
    }, this.deleteSymKey = async (i) => {
      this.isInitialized(), await this.keychain.del(i);
    }, this.encode = async (i, o, c) => {
      this.isInitialized();
      const u = TE(c), l = vo(o);
      if (l_(u)) {
        const y = u.senderPublicKey, C = u.receiverPublicKey;
        i = await this.generateSharedKey(y, C);
      }
      const f = this.getSymKey(i), { type: p, senderPublicKey: g } = u;
      return CF({ type: p, symKey: f, message: l, senderPublicKey: g });
    }, this.decode = async (i, o, c) => {
      this.isInitialized();
      const u = RF(o, c);
      if (l_(u)) {
        const l = u.receiverPublicKey, f = u.senderPublicKey;
        i = await this.generateSharedKey(l, f);
      }
      try {
        const l = this.getSymKey(i), f = IF({ symKey: l, encoded: o });
        return _u(f);
      } catch (l) {
        this.logger.error(`Failed to decode message from topic: '${i}', clientId: '${await this.getClientId()}'`), this.logger.error(l);
      }
    }, this.getPayloadType = (i) => {
      const o = oh(i);
      return mu(o.type);
    }, this.getPayloadSenderPublicKey = (i) => {
      const o = oh(i);
      return o.senderPublicKey ? Zr(o.senderPublicKey, Qr) : void 0;
    }, this.core = e, this.logger = wt.generateChildLogger(r, this.name), this.keychain = n || new wq(this.core, this.logger);
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  async setPrivateKey(e, r) {
    return await this.keychain.set(e, r), e;
  }
  getPrivateKey(e) {
    return this.keychain.get(e);
  }
  async getClientSeed() {
    let e = "";
    try {
      e = this.keychain.get(Z_);
    } catch {
      e = dp(), await this.keychain.set(Z_, e);
    }
    return HH(e, "base16");
  }
  getSymKey(e) {
    return this.keychain.get(e);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class Eq extends EU {
  constructor(e, r) {
    super(e, r), this.logger = e, this.core = r, this.messages = /* @__PURE__ */ new Map(), this.name = QH, this.version = ZH, this.initialized = !1, this.storagePrefix = xs, this.init = async () => {
      if (!this.initialized) {
        this.logger.trace("Initialized");
        try {
          const n = await this.getRelayerMessages();
          typeof n < "u" && (this.messages = n), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", size: this.messages.size });
        } catch (n) {
          this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(n);
        } finally {
          this.initialized = !0;
        }
      }
    }, this.set = async (n, i) => {
      this.isInitialized();
      const o = da(i);
      let c = this.messages.get(n);
      return typeof c > "u" && (c = {}), typeof c[o] < "u" || (c[o] = i, this.messages.set(n, c), await this.persist()), o;
    }, this.get = (n) => {
      this.isInitialized();
      let i = this.messages.get(n);
      return typeof i > "u" && (i = {}), i;
    }, this.has = (n, i) => {
      this.isInitialized();
      const o = this.get(n), c = da(i);
      return typeof o[c] < "u";
    }, this.del = async (n) => {
      this.isInitialized(), this.messages.delete(n), await this.persist();
    }, this.logger = wt.generateChildLogger(e, this.name), this.core = r;
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  async setRelayerMessages(e) {
    await this.core.storage.setItem(this.storageKey, NE(e));
  }
  async getRelayerMessages() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? kE(e) : void 0;
  }
  async persist() {
    await this.setRelayerMessages(this.messages);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class Sq extends SU {
  constructor(e, r) {
    super(e, r), this.relayer = e, this.logger = r, this.events = new Tr.EventEmitter(), this.name = XH, this.queue = /* @__PURE__ */ new Map(), this.publishTimeout = He.toMiliseconds(He.TEN_SECONDS), this.needsTransportRestart = !1, this.publish = async (n, i, o) => {
      var c;
      this.logger.debug("Publishing Payload"), this.logger.trace({ type: "method", method: "publish", params: { topic: n, message: i, opts: o } });
      try {
        const u = o?.ttl || YH, l = pp(o), f = o?.prompt || !1, p = o?.tag || 0, g = o?.id || XE().toString(), y = { topic: n, message: i, opts: { ttl: u, relay: l, prompt: f, tag: p, id: g } }, C = setTimeout(() => this.queue.set(g, y), this.publishTimeout);
        try {
          await await Fc(this.rpcPublish(n, i, u, l, f, p, g), this.publishTimeout, "Failed to publish payload, please try again."), this.removeRequestFromQueue(g), this.relayer.events.emit(jr.publish, y);
        } catch (R) {
          if (this.logger.debug("Publishing Payload stalled"), this.needsTransportRestart = !0, (c = o?.internal) != null && c.throwOnFailedPublish)
            throw this.removeRequestFromQueue(g), R;
          return;
        } finally {
          clearTimeout(C);
        }
        this.logger.debug("Successfully Published Payload"), this.logger.trace({ type: "method", method: "publish", params: { topic: n, message: i, opts: o } });
      } catch (u) {
        throw this.logger.debug("Failed to Publish Payload"), this.logger.error(u), u;
      }
    }, this.on = (n, i) => {
      this.events.on(n, i);
    }, this.once = (n, i) => {
      this.events.once(n, i);
    }, this.off = (n, i) => {
      this.events.off(n, i);
    }, this.removeListener = (n, i) => {
      this.events.removeListener(n, i);
    }, this.relayer = e, this.logger = wt.generateChildLogger(r, this.name), this.registerEventListeners();
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  rpcPublish(e, r, n, i, o, c, u) {
    var l, f, p, g;
    const y = { method: Kl(i.protocol).publish, params: { topic: e, message: r, ttl: n, prompt: o, tag: c }, id: u };
    return Jr((l = y.params) == null ? void 0 : l.prompt) && ((f = y.params) == null || delete f.prompt), Jr((p = y.params) == null ? void 0 : p.tag) && ((g = y.params) == null || delete g.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "message", direction: "outgoing", request: y }), this.relayer.request(y);
  }
  removeRequestFromQueue(e) {
    this.queue.delete(e);
  }
  checkQueue() {
    this.queue.forEach(async (e) => {
      const { topic: r, message: n, opts: i } = e;
      await this.publish(r, n, i);
    });
  }
  registerEventListeners() {
    this.relayer.core.heartbeat.on(ja.HEARTBEAT_EVENTS.pulse, () => {
      if (this.needsTransportRestart) {
        this.needsTransportRestart = !1, this.relayer.events.emit(jr.connection_stalled);
        return;
      }
      this.checkQueue();
    }), this.relayer.on(jr.message_ack, (e) => {
      this.removeRequestFromQueue(e.id.toString());
    });
  }
}
class Cq {
  constructor() {
    this.map = /* @__PURE__ */ new Map(), this.set = (e, r) => {
      const n = this.get(e);
      this.exists(e, r) || this.map.set(e, [...n, r]);
    }, this.get = (e) => this.map.get(e) || [], this.exists = (e, r) => this.get(e).includes(r), this.delete = (e, r) => {
      if (typeof r > "u") {
        this.map.delete(e);
        return;
      }
      if (!this.map.has(e))
        return;
      const n = this.get(e);
      if (!this.exists(e, r))
        return;
      const i = n.filter((o) => o !== r);
      if (!i.length) {
        this.map.delete(e);
        return;
      }
      this.map.set(e, i);
    }, this.clear = () => {
      this.map.clear();
    };
  }
  get topics() {
    return Array.from(this.map.keys());
  }
}
var Iq = Object.defineProperty, xq = Object.defineProperties, Rq = Object.getOwnPropertyDescriptors, X_ = Object.getOwnPropertySymbols, Aq = Object.prototype.hasOwnProperty, Mq = Object.prototype.propertyIsEnumerable, ew = (t, e, r) => e in t ? Iq(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, vc = (t, e) => {
  for (var r in e || (e = {}))
    Aq.call(e, r) && ew(t, r, e[r]);
  if (X_)
    for (var r of X_(e))
      Mq.call(e, r) && ew(t, r, e[r]);
  return t;
}, A0 = (t, e) => xq(t, Rq(e));
class Dq extends xU {
  constructor(e, r) {
    super(e, r), this.relayer = e, this.logger = r, this.subscriptions = /* @__PURE__ */ new Map(), this.topicMap = new Cq(), this.events = new Tr.EventEmitter(), this.name = cq, this.version = uq, this.pending = /* @__PURE__ */ new Map(), this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = xs, this.subscribeTimeout = 1e4, this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
    }, this.subscribe = async (n, i) => {
      await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: n, opts: i } });
      try {
        const o = pp(i), c = { topic: n, relay: o };
        this.pending.set(n, c);
        const u = await this.rpcSubscribe(n, o);
        return this.onSubscribe(u, c), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: n, opts: i } }), u;
      } catch (o) {
        throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(o), o;
      }
    }, this.unsubscribe = async (n, i) => {
      await this.restartToComplete(), this.isInitialized(), typeof i?.id < "u" ? await this.unsubscribeById(n, i.id, i) : await this.unsubscribeByTopic(n, i);
    }, this.isSubscribed = async (n) => this.topics.includes(n) ? !0 : await new Promise((i, o) => {
      const c = new He.Watch();
      c.start(this.pendingSubscriptionWatchLabel);
      const u = setInterval(() => {
        !this.pending.has(n) && this.topics.includes(n) && (clearInterval(u), c.stop(this.pendingSubscriptionWatchLabel), i(!0)), c.elapsed(this.pendingSubscriptionWatchLabel) >= lq && (clearInterval(u), c.stop(this.pendingSubscriptionWatchLabel), o(new Error("Subscription resolution timeout")));
      }, this.pollingInterval);
    }).catch(() => !1), this.on = (n, i) => {
      this.events.on(n, i);
    }, this.once = (n, i) => {
      this.events.once(n, i);
    }, this.off = (n, i) => {
      this.events.off(n, i);
    }, this.removeListener = (n, i) => {
      this.events.removeListener(n, i);
    }, this.restart = async () => {
      this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
    }, this.relayer = e, this.logger = wt.generateChildLogger(r, this.name), this.clientId = "";
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.subscriptions.size;
  }
  get ids() {
    return Array.from(this.subscriptions.keys());
  }
  get values() {
    return Array.from(this.subscriptions.values());
  }
  get topics() {
    return this.topicMap.topics;
  }
  hasSubscription(e, r) {
    let n = !1;
    try {
      n = this.getSubscription(e).topic === r;
    } catch {
    }
    return n;
  }
  onEnable() {
    this.cached = [], this.initialized = !0;
  }
  onDisable() {
    this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
  }
  async unsubscribeByTopic(e, r) {
    const n = this.topicMap.get(e);
    await Promise.all(n.map(async (i) => await this.unsubscribeById(e, i, r)));
  }
  async unsubscribeById(e, r, n) {
    this.logger.debug("Unsubscribing Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: r, opts: n } });
    try {
      const i = pp(n);
      await this.rpcUnsubscribe(e, r, i);
      const o = or("USER_DISCONNECTED", `${this.name}, ${e}`);
      await this.onUnsubscribe(e, r, o), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: r, opts: n } });
    } catch (i) {
      throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(i), i;
    }
  }
  async rpcSubscribe(e, r) {
    const n = { method: Kl(r.protocol).subscribe, params: { topic: e } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: n });
    try {
      await await Fc(this.relayer.request(n), this.subscribeTimeout);
    } catch {
      this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit(jr.connection_stalled);
    }
    return da(e + this.clientId);
  }
  async rpcBatchSubscribe(e) {
    if (!e.length)
      return;
    const r = e[0].relay, n = { method: Kl(r.protocol).batchSubscribe, params: { topics: e.map((i) => i.topic) } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: n });
    try {
      return await await Fc(this.relayer.request(n), this.subscribeTimeout);
    } catch {
      this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit(jr.connection_stalled);
    }
  }
  rpcUnsubscribe(e, r, n) {
    const i = { method: Kl(n.protocol).unsubscribe, params: { topic: e, id: r } };
    return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: i }), this.relayer.request(i);
  }
  onSubscribe(e, r) {
    this.setSubscription(e, A0(vc({}, r), { id: e })), this.pending.delete(r.topic);
  }
  onBatchSubscribe(e) {
    e.length && e.forEach((r) => {
      this.setSubscription(r.id, vc({}, r)), this.pending.delete(r.topic);
    });
  }
  async onUnsubscribe(e, r, n) {
    this.events.removeAllListeners(r), this.hasSubscription(r, e) && this.deleteSubscription(r, n), await this.relayer.messages.del(e);
  }
  async setRelayerSubscriptions(e) {
    await this.relayer.core.storage.setItem(this.storageKey, e);
  }
  async getRelayerSubscriptions() {
    return await this.relayer.core.storage.getItem(this.storageKey);
  }
  setSubscription(e, r) {
    this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({ type: "method", method: "setSubscription", id: e, subscription: r }), this.addSubscription(e, r));
  }
  addSubscription(e, r) {
    this.subscriptions.set(e, vc({}, r)), this.topicMap.set(r.topic, e), this.events.emit(ci.created, r);
  }
  getSubscription(e) {
    this.logger.debug("Getting subscription"), this.logger.trace({ type: "method", method: "getSubscription", id: e });
    const r = this.subscriptions.get(e);
    if (!r) {
      const { message: n } = Me("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(n);
    }
    return r;
  }
  deleteSubscription(e, r) {
    this.logger.debug("Deleting subscription"), this.logger.trace({ type: "method", method: "deleteSubscription", id: e, reason: r });
    const n = this.getSubscription(e);
    this.subscriptions.delete(e), this.topicMap.delete(n.topic, e), this.events.emit(ci.deleted, A0(vc({}, n), { reason: r }));
  }
  async persist() {
    await this.setRelayerSubscriptions(this.values), this.events.emit(ci.sync);
  }
  async reset() {
    if (this.cached.length) {
      const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
      for (let r = 0; r < e; r++) {
        const n = this.cached.splice(0, this.batchSubscribeTopicsLimit);
        await this.batchSubscribe(n);
      }
    }
    this.events.emit(ci.resubscribed);
  }
  async restore() {
    try {
      const e = await this.getRelayerSubscriptions();
      if (typeof e > "u" || !e.length)
        return;
      if (this.subscriptions.size) {
        const { message: r } = Me("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({ type: "method", method: "restore", subscriptions: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
    }
  }
  async batchSubscribe(e) {
    if (!e.length)
      return;
    const r = await this.rpcBatchSubscribe(e);
    Pi(r) && this.onBatchSubscribe(r.map((n, i) => A0(vc({}, e[i]), { id: n })));
  }
  async onConnect() {
    this.restartInProgress || (await this.restart(), this.onEnable());
  }
  onDisconnect() {
    this.onDisable();
  }
  async checkPending() {
    if (!this.initialized || this.relayer.transportExplicitlyClosed)
      return;
    const e = [];
    this.pending.forEach((r) => {
      e.push(r);
    }), await this.batchSubscribe(e);
  }
  registerEventListeners() {
    this.relayer.core.heartbeat.on(ja.HEARTBEAT_EVENTS.pulse, async () => {
      await this.checkPending();
    }), this.relayer.on(jr.connect, async () => {
      await this.onConnect();
    }), this.relayer.on(jr.disconnect, () => {
      this.onDisconnect();
    }), this.events.on(ci.created, async (e) => {
      const r = ci.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), await this.persist();
    }), this.events.on(ci.deleted, async (e) => {
      const r = ci.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), await this.persist();
    });
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async restartToComplete() {
    this.restartInProgress && await new Promise((e) => {
      const r = setInterval(() => {
        this.restartInProgress || (clearInterval(r), e());
      }, this.pollingInterval);
    });
  }
}
var Oq = Object.defineProperty, tw = Object.getOwnPropertySymbols, Pq = Object.prototype.hasOwnProperty, Tq = Object.prototype.propertyIsEnumerable, rw = (t, e, r) => e in t ? Oq(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Nq = (t, e) => {
  for (var r in e || (e = {}))
    Pq.call(e, r) && rw(t, r, e[r]);
  if (tw)
    for (var r of tw(e))
      Tq.call(e, r) && rw(t, r, e[r]);
  return t;
};
class kq extends CU {
  constructor(e) {
    super(e), this.protocol = "wc", this.version = 2, this.events = new Tr.EventEmitter(), this.name = tq, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = ["socket hang up", "socket stalled"], this.hasExperiencedNetworkDisruption = !1, this.request = async (r) => {
      this.logger.debug("Publishing Request Payload");
      try {
        return await this.toEstablishConnection(), await this.provider.request(r);
      } catch (n) {
        throw this.logger.debug("Failed to Publish Request"), this.logger.error(n), n;
      }
    }, this.onPayloadHandler = (r) => {
      this.onProviderPayload(r);
    }, this.onConnectHandler = () => {
      this.events.emit(jr.connect);
    }, this.onDisconnectHandler = () => {
      this.onProviderDisconnect();
    }, this.onProviderErrorHandler = (r) => {
      this.logger.error(r), this.events.emit(jr.error, r), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
    }, this.registerProviderListeners = () => {
      this.provider.on(Wi.payload, this.onPayloadHandler), this.provider.on(Wi.connect, this.onConnectHandler), this.provider.on(Wi.disconnect, this.onDisconnectHandler), this.provider.on(Wi.error, this.onProviderErrorHandler);
    }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? wt.generateChildLogger(e.logger, this.name) : wt.pino(wt.getDefaultLoggerOptions({ level: e.logger || eq })), this.messages = new Eq(this.logger, e.core), this.subscriber = new Dq(this, this.logger), this.publisher = new Sq(this, this.logger), this.relayUrl = e?.relayUrl || g3, this.projectId = e.projectId, this.bundleId = TF(), this.provider = {};
  }
  async init() {
    this.logger.trace("Initialized"), this.registerEventListeners(), await this.createProvider(), await Promise.all([this.messages.init(), this.subscriber.init()]);
    try {
      await this.transportOpen();
    } catch {
      this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${Y_}...`), await this.restartTransport(Y_);
    }
    this.initialized = !0, setTimeout(async () => {
      this.subscriber.topics.length === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
    }, sq);
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  get connected() {
    return this.provider.connection.connected;
  }
  get connecting() {
    return this.provider.connection.connecting;
  }
  async publish(e, r, n) {
    this.isInitialized(), await this.publisher.publish(e, r, n), await this.recordMessageEvent({ topic: e, message: r, publishedAt: Date.now() });
  }
  async subscribe(e, r) {
    var n;
    this.isInitialized();
    let i = ((n = this.subscriber.topicMap.get(e)) == null ? void 0 : n[0]) || "";
    if (i)
      return i;
    let o;
    const c = (u) => {
      u.topic === e && (this.subscriber.off(ci.created, c), o());
    };
    return await Promise.all([new Promise((u) => {
      o = u, this.subscriber.on(ci.created, c);
    }), new Promise(async (u) => {
      i = await this.subscriber.subscribe(e, r), u();
    })]), i;
  }
  async unsubscribe(e, r) {
    this.isInitialized(), await this.subscriber.unsubscribe(e, r);
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async transportClose() {
    this.transportExplicitlyClosed = !0, this.hasExperiencedNetworkDisruption && this.connected ? await Fc(this.provider.disconnect(), 1e3, "provider.disconnect()").catch(() => this.onProviderDisconnect()) : this.connected && await this.provider.disconnect();
  }
  async transportOpen(e) {
    if (this.transportExplicitlyClosed = !1, await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress) {
      e && e !== this.relayUrl && (this.relayUrl = e, await this.transportClose(), await this.createProvider()), this.connectionAttemptInProgress = !0;
      try {
        await Promise.all([new Promise((r) => {
          if (!this.initialized)
            return r();
          this.subscriber.once(ci.resubscribed, () => {
            r();
          });
        }), new Promise(async (r, n) => {
          try {
            await Fc(this.provider.connect(), 1e4, `Socket stalled when trying to connect to ${this.relayUrl}`);
          } catch (i) {
            n(i);
            return;
          }
          r();
        })]);
      } catch (r) {
        this.logger.error(r);
        const n = r;
        if (!this.isConnectionStalled(n.message))
          throw r;
        this.provider.events.emit(Wi.disconnect);
      } finally {
        this.connectionAttemptInProgress = !1, this.hasExperiencedNetworkDisruption = !1;
      }
    }
  }
  async restartTransport(e) {
    await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.transportClose(), await this.createProvider(), await this.transportOpen());
  }
  async confirmOnlineStateOrThrow() {
    if (!await b_())
      throw new Error("No internet connection detected. Please restart your network and try again.");
  }
  isConnectionStalled(e) {
    return this.staleConnectionErrors.some((r) => e.includes(r));
  }
  async createProvider() {
    this.provider.connection && this.unregisterProviderListeners();
    const e = await this.core.crypto.signJWT(this.relayUrl);
    this.provider = new ss(new fj(BF({ sdkVersion: iq, protocol: this.protocol, version: this.version, relayUrl: this.relayUrl, projectId: this.projectId, auth: e, useOnCloseEvent: !0, bundleId: this.bundleId }))), this.registerProviderListeners();
  }
  async recordMessageEvent(e) {
    const { topic: r, message: n } = e;
    await this.messages.set(r, n);
  }
  async shouldIgnoreMessageEvent(e) {
    const { topic: r, message: n } = e;
    if (!n || n.length === 0)
      return this.logger.debug(`Ignoring invalid/empty message: ${n}`), !0;
    if (!await this.subscriber.isSubscribed(r))
      return this.logger.debug(`Ignoring message for non-subscribed topic ${r}`), !0;
    const i = this.messages.has(r, n);
    return i && this.logger.debug(`Ignoring duplicate message: ${n}`), i;
  }
  async onProviderPayload(e) {
    if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({ type: "payload", direction: "incoming", payload: e }), Pg(e)) {
      if (!e.method.endsWith(rq))
        return;
      const r = e.params, { topic: n, message: i, publishedAt: o } = r.data, c = { topic: n, message: i, publishedAt: o };
      this.logger.debug("Emitting Relayer Payload"), this.logger.trace(Nq({ type: "event", event: r.id }, c)), this.events.emit(r.id, c), await this.acknowledgePayload(e), await this.onMessageEvent(c);
    } else
      _f(e) && this.events.emit(jr.message_ack, e);
  }
  async onMessageEvent(e) {
    await this.shouldIgnoreMessageEvent(e) || (this.events.emit(jr.message, e), await this.recordMessageEvent(e));
  }
  async acknowledgePayload(e) {
    const r = vf(e.id, !0);
    await this.provider.connection.send(r);
  }
  unregisterProviderListeners() {
    this.provider.off(Wi.payload, this.onPayloadHandler), this.provider.off(Wi.connect, this.onConnectHandler), this.provider.off(Wi.disconnect, this.onDisconnectHandler), this.provider.off(Wi.error, this.onProviderErrorHandler);
  }
  async registerEventListeners() {
    this.events.on(jr.connection_stalled, () => {
      this.restartTransport().catch((r) => this.logger.error(r));
    });
    let e = await b_();
    OB(async (r) => {
      this.initialized && e !== r && (e = r, r ? await this.restartTransport().catch((n) => this.logger.error(n)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportClose().catch((n) => this.logger.error(n))));
    });
  }
  onProviderDisconnect() {
    this.events.emit(jr.disconnect), this.attemptToReconnect();
  }
  attemptToReconnect() {
    this.transportExplicitlyClosed || (this.logger.info("attemptToReconnect called. Connecting..."), setTimeout(async () => {
      await this.restartTransport().catch((e) => this.logger.error(e));
    }, He.toMiliseconds(nq)));
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async toEstablishConnection() {
    if (await this.confirmOnlineStateOrThrow(), !this.connected) {
      if (this.connectionAttemptInProgress)
        return await new Promise((e) => {
          const r = setInterval(() => {
            this.connected && (clearInterval(r), e());
          }, this.connectionStatusPollingInterval);
        });
      await this.restartTransport();
    }
  }
}
var Lq = Object.defineProperty, nw = Object.getOwnPropertySymbols, $q = Object.prototype.hasOwnProperty, Fq = Object.prototype.propertyIsEnumerable, iw = (t, e, r) => e in t ? Lq(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, sw = (t, e) => {
  for (var r in e || (e = {}))
    $q.call(e, r) && iw(t, r, e[r]);
  if (nw)
    for (var r of nw(e))
      Fq.call(e, r) && iw(t, r, e[r]);
  return t;
};
class bf extends IU {
  constructor(e, r, n, i = xs, o = void 0) {
    super(e, r, n, i), this.core = e, this.logger = r, this.name = n, this.map = /* @__PURE__ */ new Map(), this.version = oq, this.cached = [], this.initialized = !1, this.storagePrefix = xs, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((c) => {
        this.getKey && c !== null && !Jr(c) ? this.map.set(this.getKey(c), c) : cB(c) ? this.map.set(c.id, c) : uB(c) && this.map.set(c.topic, c);
      }), this.cached = [], this.initialized = !0);
    }, this.set = async (c, u) => {
      this.isInitialized(), this.map.has(c) ? await this.update(c, u) : (this.logger.debug("Setting value"), this.logger.trace({ type: "method", method: "set", key: c, value: u }), this.map.set(c, u), await this.persist());
    }, this.get = (c) => (this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({ type: "method", method: "get", key: c }), this.getData(c)), this.getAll = (c) => (this.isInitialized(), c ? this.values.filter((u) => Object.keys(c).every((l) => pj(u[l], c[l]))) : this.values), this.update = async (c, u) => {
      this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({ type: "method", method: "update", key: c, update: u });
      const l = sw(sw({}, this.getData(c)), u);
      this.map.set(c, l), await this.persist();
    }, this.delete = async (c, u) => {
      this.isInitialized(), this.map.has(c) && (this.logger.debug("Deleting value"), this.logger.trace({ type: "method", method: "delete", key: c, reason: u }), this.map.delete(c), await this.persist());
    }, this.logger = wt.generateChildLogger(r, this.name), this.storagePrefix = i, this.getKey = o;
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.map.size;
  }
  get keys() {
    return Array.from(this.map.keys());
  }
  get values() {
    return Array.from(this.map.values());
  }
  async setDataStore(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getDataStore() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getData(e) {
    const r = this.map.get(e);
    if (!r) {
      const { message: n } = Me("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.error(n), new Error(n);
    }
    return r;
  }
  async persist() {
    await this.setDataStore(this.values);
  }
  async restore() {
    try {
      const e = await this.getDataStore();
      if (typeof e > "u" || !e.length)
        return;
      if (this.map.size) {
        const { message: r } = Me("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({ type: "method", method: "restore", value: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class Bq {
  constructor(e, r) {
    this.core = e, this.logger = r, this.name = hq, this.version = fq, this.events = new Up(), this.initialized = !1, this.storagePrefix = xs, this.ignoredPayloadTypes = [xo], this.registeredMethods = [], this.init = async () => {
      this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
    }, this.register = ({ methods: n }) => {
      this.isInitialized(), this.registeredMethods = [.../* @__PURE__ */ new Set([...this.registeredMethods, ...n])];
    }, this.create = async () => {
      this.isInitialized();
      const n = dp(), i = await this.core.crypto.setSymKey(n), o = ui(He.FIVE_MINUTES), c = { protocol: p3 }, u = { topic: i, expiry: o, relay: c, active: !1 }, l = YF({ protocol: this.core.protocol, version: this.core.version, topic: i, symKey: n, relay: c });
      return await this.pairings.set(i, u), await this.core.relayer.subscribe(i), this.core.expirer.set(i, o), { topic: i, uri: l };
    }, this.pair = async (n) => {
      this.isInitialized(), this.isValidPair(n);
      const { topic: i, symKey: o, relay: c } = m_(n.uri);
      let u;
      if (this.pairings.keys.includes(i) && (u = this.pairings.get(i), u.active))
        throw new Error(`Pairing already exists: ${i}. Please try again with a new connection URI.`);
      const l = ui(He.FIVE_MINUTES), f = { topic: i, relay: c, expiry: l, active: !1 };
      return await this.pairings.set(i, f), this.core.expirer.set(i, l), n.activatePairing && await this.activate({ topic: i }), this.events.emit(Ec.create, f), this.core.crypto.keychain.has(i) || (await this.core.crypto.setSymKey(o, i), await this.core.relayer.subscribe(i, { relay: c })), f;
    }, this.activate = async ({ topic: n }) => {
      this.isInitialized();
      const i = ui(He.THIRTY_DAYS);
      await this.pairings.update(n, { active: !0, expiry: i }), this.core.expirer.set(n, i);
    }, this.ping = async (n) => {
      this.isInitialized(), await this.isValidPing(n);
      const { topic: i } = n;
      if (this.pairings.keys.includes(i)) {
        const o = await this.sendRequest(i, "wc_pairingPing", {}), { done: c, resolve: u, reject: l } = ia();
        this.events.once(gr("pairing_ping", o), ({ error: f }) => {
          f ? l(f) : u();
        }), await c();
      }
    }, this.updateExpiry = async ({ topic: n, expiry: i }) => {
      this.isInitialized(), await this.pairings.update(n, { expiry: i });
    }, this.updateMetadata = async ({ topic: n, metadata: i }) => {
      this.isInitialized(), await this.pairings.update(n, { peerMetadata: i });
    }, this.getPairings = () => (this.isInitialized(), this.pairings.values), this.disconnect = async (n) => {
      this.isInitialized(), await this.isValidDisconnect(n);
      const { topic: i } = n;
      this.pairings.keys.includes(i) && (await this.sendRequest(i, "wc_pairingDelete", or("USER_DISCONNECTED")), await this.deletePairing(i));
    }, this.sendRequest = async (n, i, o) => {
      const c = ga(i, o), u = await this.core.crypto.encode(n, c), l = mc[i].req;
      return this.core.history.set(n, c), this.core.relayer.publish(n, u, l), c.id;
    }, this.sendResult = async (n, i, o) => {
      const c = vf(n, o), u = await this.core.crypto.encode(i, c), l = await this.core.history.get(i, n), f = mc[l.request.method].res;
      await this.core.relayer.publish(i, u, f), await this.core.history.resolve(c);
    }, this.sendError = async (n, i, o) => {
      const c = yf(n, o), u = await this.core.crypto.encode(i, c), l = await this.core.history.get(i, n), f = mc[l.request.method] ? mc[l.request.method].res : mc.unregistered_method.res;
      await this.core.relayer.publish(i, u, f), await this.core.history.resolve(c);
    }, this.deletePairing = async (n, i) => {
      await this.core.relayer.unsubscribe(n), await Promise.all([this.pairings.delete(n, or("USER_DISCONNECTED")), this.core.crypto.deleteSymKey(n), i ? Promise.resolve() : this.core.expirer.del(n)]);
    }, this.cleanup = async () => {
      const n = this.pairings.getAll().filter((i) => bs(i.expiry));
      await Promise.all(n.map((i) => this.deletePairing(i.topic)));
    }, this.onRelayEventRequest = (n) => {
      const { topic: i, payload: o } = n;
      switch (o.method) {
        case "wc_pairingPing":
          return this.onPairingPingRequest(i, o);
        case "wc_pairingDelete":
          return this.onPairingDeleteRequest(i, o);
        default:
          return this.onUnknownRpcMethodRequest(i, o);
      }
    }, this.onRelayEventResponse = async (n) => {
      const { topic: i, payload: o } = n, c = (await this.core.history.get(i, o.id)).request.method;
      switch (c) {
        case "wc_pairingPing":
          return this.onPairingPingResponse(i, o);
        default:
          return this.onUnknownRpcMethodResponse(c);
      }
    }, this.onPairingPingRequest = async (n, i) => {
      const { id: o } = i;
      try {
        this.isValidPing({ topic: n }), await this.sendResult(o, n, !0), this.events.emit(Ec.ping, { id: o, topic: n });
      } catch (c) {
        await this.sendError(o, n, c), this.logger.error(c);
      }
    }, this.onPairingPingResponse = (n, i) => {
      const { id: o } = i;
      setTimeout(() => {
        Qi(i) ? this.events.emit(gr("pairing_ping", o), {}) : li(i) && this.events.emit(gr("pairing_ping", o), { error: i.error });
      }, 500);
    }, this.onPairingDeleteRequest = async (n, i) => {
      const { id: o } = i;
      try {
        this.isValidDisconnect({ topic: n }), await this.deletePairing(n), this.events.emit(Ec.delete, { id: o, topic: n });
      } catch (c) {
        await this.sendError(o, n, c), this.logger.error(c);
      }
    }, this.onUnknownRpcMethodRequest = async (n, i) => {
      const { id: o, method: c } = i;
      try {
        if (this.registeredMethods.includes(c))
          return;
        const u = or("WC_METHOD_UNSUPPORTED", c);
        await this.sendError(o, n, u), this.logger.error(u);
      } catch (u) {
        await this.sendError(o, n, u), this.logger.error(u);
      }
    }, this.onUnknownRpcMethodResponse = (n) => {
      this.registeredMethods.includes(n) || this.logger.error(or("WC_METHOD_UNSUPPORTED", n));
    }, this.isValidPair = (n) => {
      var i;
      if (!ln(n)) {
        const { message: c } = Me("MISSING_OR_INVALID", `pair() params: ${n}`);
        throw new Error(c);
      }
      if (!aB(n.uri)) {
        const { message: c } = Me("MISSING_OR_INVALID", `pair() uri: ${n.uri}`);
        throw new Error(c);
      }
      const o = m_(n.uri);
      if (!((i = o?.relay) != null && i.protocol)) {
        const { message: c } = Me("MISSING_OR_INVALID", "pair() uri#relay-protocol");
        throw new Error(c);
      }
      if (!(o != null && o.symKey)) {
        const { message: c } = Me("MISSING_OR_INVALID", "pair() uri#symKey");
        throw new Error(c);
      }
    }, this.isValidPing = async (n) => {
      if (!ln(n)) {
        const { message: o } = Me("MISSING_OR_INVALID", `ping() params: ${n}`);
        throw new Error(o);
      }
      const { topic: i } = n;
      await this.isValidPairingTopic(i);
    }, this.isValidDisconnect = async (n) => {
      if (!ln(n)) {
        const { message: o } = Me("MISSING_OR_INVALID", `disconnect() params: ${n}`);
        throw new Error(o);
      }
      const { topic: i } = n;
      await this.isValidPairingTopic(i);
    }, this.isValidPairingTopic = async (n) => {
      if (!Rr(n, !1)) {
        const { message: i } = Me("MISSING_OR_INVALID", `pairing topic should be a string: ${n}`);
        throw new Error(i);
      }
      if (!this.pairings.keys.includes(n)) {
        const { message: i } = Me("NO_MATCHING_KEY", `pairing topic doesn't exist: ${n}`);
        throw new Error(i);
      }
      if (bs(this.pairings.get(n).expiry)) {
        await this.deletePairing(n);
        const { message: i } = Me("EXPIRED", `pairing topic: ${n}`);
        throw new Error(i);
      }
    }, this.core = e, this.logger = wt.generateChildLogger(r, this.name), this.pairings = new bf(this.core, this.logger, this.name, this.storagePrefix);
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  registerRelayerEvents() {
    this.core.relayer.on(jr.message, async (e) => {
      const { topic: r, message: n } = e;
      if (!this.pairings.keys.includes(r) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(n)))
        return;
      const i = await this.core.crypto.decode(r, n);
      try {
        Pg(i) ? (this.core.history.set(r, i), this.onRelayEventRequest({ topic: r, payload: i })) : _f(i) && (await this.core.history.resolve(i), await this.onRelayEventResponse({ topic: r, payload: i }), this.core.history.delete(r, i.id));
      } catch (o) {
        this.logger.error(o);
      }
    });
  }
  registerExpirerEvents() {
    this.core.expirer.on(Un.expired, async (e) => {
      const { topic: r } = $E(e.target);
      r && this.pairings.keys.includes(r) && (await this.deletePairing(r, !0), this.events.emit(Ec.expire, { topic: r }));
    });
  }
}
class Uq extends bU {
  constructor(e, r) {
    super(e, r), this.core = e, this.logger = r, this.records = /* @__PURE__ */ new Map(), this.events = new Tr.EventEmitter(), this.name = dq, this.version = pq, this.cached = [], this.initialized = !1, this.storagePrefix = xs, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((n) => this.records.set(n.id, n)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }, this.set = (n, i, o) => {
      if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({ type: "method", method: "set", topic: n, request: i, chainId: o }), this.records.has(i.id))
        return;
      const c = { id: i.id, topic: n, request: { method: i.method, params: i.params || null }, chainId: o, expiry: ui(He.THIRTY_DAYS) };
      this.records.set(c.id, c), this.events.emit(Si.created, c);
    }, this.resolve = async (n) => {
      if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({ type: "method", method: "update", response: n }), !this.records.has(n.id))
        return;
      const i = await this.getRecord(n.id);
      typeof i.response > "u" && (i.response = li(n) ? { error: n.error } : { result: n.result }, this.records.set(i.id, i), this.events.emit(Si.updated, i));
    }, this.get = async (n, i) => (this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({ type: "method", method: "get", topic: n, id: i }), await this.getRecord(i)), this.delete = (n, i) => {
      this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({ type: "method", method: "delete", id: i }), this.values.forEach((o) => {
        if (o.topic === n) {
          if (typeof i < "u" && o.id !== i)
            return;
          this.records.delete(o.id), this.events.emit(Si.deleted, o);
        }
      });
    }, this.exists = async (n, i) => (this.isInitialized(), this.records.has(i) ? (await this.getRecord(i)).topic === n : !1), this.on = (n, i) => {
      this.events.on(n, i);
    }, this.once = (n, i) => {
      this.events.once(n, i);
    }, this.off = (n, i) => {
      this.events.off(n, i);
    }, this.removeListener = (n, i) => {
      this.events.removeListener(n, i);
    }, this.logger = wt.generateChildLogger(r, this.name);
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get size() {
    return this.records.size;
  }
  get keys() {
    return Array.from(this.records.keys());
  }
  get values() {
    return Array.from(this.records.values());
  }
  get pending() {
    const e = [];
    return this.values.forEach((r) => {
      if (typeof r.response < "u")
        return;
      const n = { topic: r.topic, request: ga(r.request.method, r.request.params, r.id), chainId: r.chainId };
      return e.push(n);
    }), e;
  }
  async setJsonRpcRecords(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getJsonRpcRecords() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getRecord(e) {
    this.isInitialized();
    const r = this.records.get(e);
    if (!r) {
      const { message: n } = Me("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(n);
    }
    return r;
  }
  async persist() {
    await this.setJsonRpcRecords(this.values), this.events.emit(Si.sync);
  }
  async restore() {
    try {
      const e = await this.getJsonRpcRecords();
      if (typeof e > "u" || !e.length)
        return;
      if (this.records.size) {
        const { message: r } = Me("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", records: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
    }
  }
  registerEventListeners() {
    this.events.on(Si.created, (e) => {
      const r = Si.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e }), this.persist();
    }), this.events.on(Si.updated, (e) => {
      const r = Si.updated;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e }), this.persist();
    }), this.events.on(Si.deleted, (e) => {
      const r = Si.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e }), this.persist();
    }), this.core.heartbeat.on(ja.HEARTBEAT_EVENTS.pulse, () => {
      this.cleanup();
    });
  }
  cleanup() {
    try {
      this.records.forEach((e) => {
        He.toMiliseconds(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
      });
    } catch (e) {
      this.logger.warn(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class jq extends RU {
  constructor(e, r) {
    super(e, r), this.core = e, this.logger = r, this.expirations = /* @__PURE__ */ new Map(), this.events = new Tr.EventEmitter(), this.name = gq, this.version = mq, this.cached = [], this.initialized = !1, this.storagePrefix = xs, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((n) => this.expirations.set(n.target, n)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }, this.has = (n) => {
      try {
        const i = this.formatTarget(n);
        return typeof this.getExpiration(i) < "u";
      } catch {
        return !1;
      }
    }, this.set = (n, i) => {
      this.isInitialized();
      const o = this.formatTarget(n), c = { target: o, expiry: i };
      this.expirations.set(o, c), this.checkExpiry(o, c), this.events.emit(Un.created, { target: o, expiration: c });
    }, this.get = (n) => {
      this.isInitialized();
      const i = this.formatTarget(n);
      return this.getExpiration(i);
    }, this.del = (n) => {
      if (this.isInitialized(), this.has(n)) {
        const i = this.formatTarget(n), o = this.getExpiration(i);
        this.expirations.delete(i), this.events.emit(Un.deleted, { target: i, expiration: o });
      }
    }, this.on = (n, i) => {
      this.events.on(n, i);
    }, this.once = (n, i) => {
      this.events.once(n, i);
    }, this.off = (n, i) => {
      this.events.off(n, i);
    }, this.removeListener = (n, i) => {
      this.events.removeListener(n, i);
    }, this.logger = wt.generateChildLogger(r, this.name);
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.expirations.size;
  }
  get keys() {
    return Array.from(this.expirations.keys());
  }
  get values() {
    return Array.from(this.expirations.values());
  }
  formatTarget(e) {
    if (typeof e == "string")
      return UF(e);
    if (typeof e == "number")
      return jF(e);
    const { message: r } = Me("UNKNOWN_TYPE", `Target type: ${typeof e}`);
    throw new Error(r);
  }
  async setExpirations(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getExpirations() {
    return await this.core.storage.getItem(this.storageKey);
  }
  async persist() {
    await this.setExpirations(this.values), this.events.emit(Un.sync);
  }
  async restore() {
    try {
      const e = await this.getExpirations();
      if (typeof e > "u" || !e.length)
        return;
      if (this.expirations.size) {
        const { message: r } = Me("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({ type: "method", method: "restore", expirations: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
    }
  }
  getExpiration(e) {
    const r = this.expirations.get(e);
    if (!r) {
      const { message: n } = Me("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.error(n), new Error(n);
    }
    return r;
  }
  checkExpiry(e, r) {
    const { expiry: n } = r;
    He.toMiliseconds(n) - Date.now() <= 0 && this.expire(e, r);
  }
  expire(e, r) {
    this.expirations.delete(e), this.events.emit(Un.expired, { target: e, expiration: r });
  }
  checkExpirations() {
    this.core.relayer.connected && this.expirations.forEach((e, r) => this.checkExpiry(r, e));
  }
  registerEventListeners() {
    this.core.heartbeat.on(ja.HEARTBEAT_EVENTS.pulse, () => this.checkExpirations()), this.events.on(Un.created, (e) => {
      const r = Un.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    }), this.events.on(Un.expired, (e) => {
      const r = Un.expired;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    }), this.events.on(Un.deleted, (e) => {
      const r = Un.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    });
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class Hq extends AU {
  constructor(e, r) {
    super(e, r), this.projectId = e, this.logger = r, this.name = R0, this.initialized = !1, this.queue = [], this.verifyDisabled = !1, this.init = async (n) => {
      if (this.verifyDisabled || Fa() || !Ba())
        return;
      const i = this.getVerifyUrl(n?.verifyUrl);
      this.verifyUrl !== i && this.removeIframe(), this.verifyUrl = i;
      try {
        await this.createIframe();
      } catch (o) {
        this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(o);
      }
      if (!this.initialized) {
        this.removeIframe(), this.verifyUrl = yp;
        try {
          await this.createIframe();
        } catch (o) {
          this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(o), this.verifyDisabled = !0;
        }
      }
    }, this.register = async (n) => {
      this.initialized ? this.sendPost(n.attestationId) : (this.addToQueue(n.attestationId), await this.init());
    }, this.resolve = async (n) => {
      if (this.isDevEnv)
        return "";
      const i = this.getVerifyUrl(n?.verifyUrl);
      let o;
      try {
        o = await this.fetchAttestation(n.attestationId, i);
      } catch (c) {
        this.logger.info(`failed to resolve attestation: ${n.attestationId} from url: ${i}`), this.logger.info(c), o = await this.fetchAttestation(n.attestationId, yp);
      }
      return o;
    }, this.fetchAttestation = async (n, i) => {
      this.logger.info(`resolving attestation: ${n} from url: ${i}`);
      const o = this.startAbortTimer(He.ONE_SECOND * 2), c = await fetch(`${i}/attestation/${n}`, { signal: this.abortController.signal });
      return clearTimeout(o), c.status === 200 ? await c.json() : void 0;
    }, this.addToQueue = (n) => {
      this.queue.push(n);
    }, this.processQueue = () => {
      this.queue.length !== 0 && (this.queue.forEach((n) => this.sendPost(n)), this.queue = []);
    }, this.sendPost = (n) => {
      var i;
      try {
        if (!this.iframe)
          return;
        (i = this.iframe.contentWindow) == null || i.postMessage(n, "*"), this.logger.info(`postMessage sent: ${n} ${this.verifyUrl}`);
      } catch {
      }
    }, this.createIframe = async () => {
      let n;
      const i = (o) => {
        o.data === "verify_ready" && (this.initialized = !0, this.processQueue(), window.removeEventListener("message", i), n());
      };
      await Promise.race([new Promise((o) => {
        if (document.getElementById(R0))
          return o();
        window.addEventListener("message", i);
        const c = document.createElement("iframe");
        c.id = R0, c.src = `${this.verifyUrl}/${this.projectId}`, c.style.display = "none", document.body.append(c), this.iframe = c, n = o;
      }), new Promise((o, c) => setTimeout(() => {
        window.removeEventListener("message", i), c("verify iframe load timeout");
      }, He.toMiliseconds(He.FIVE_SECONDS)))]);
    }, this.removeIframe = () => {
      this.iframe && (this.iframe.remove(), this.iframe = void 0, this.initialized = !1);
    }, this.getVerifyUrl = (n) => {
      let i = n || oa;
      return vq.includes(i) || (this.logger.info(`verify url: ${i}, not included in trusted list, assigning default: ${oa}`), i = oa), i;
    }, this.logger = wt.generateChildLogger(r, this.name), this.verifyUrl = oa, this.abortController = new AbortController(), this.isDevEnv = xg() && process.env.IS_VITEST;
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  startAbortTimer(e) {
    return this.abortController = new AbortController(), setTimeout(() => this.abortController.abort(), He.toMiliseconds(e));
  }
}
class qq extends MU {
  constructor(e, r) {
    super(e, r), this.projectId = e, this.logger = r, this.context = yq, this.registerDeviceToken = async (n) => {
      const { clientId: i, token: o, notificationType: c, enableEncrypted: u = !1 } = n, l = `${_q}/${this.projectId}/clients`;
      await yj(l, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ client_id: i, type: c, token: o, always_raw: u }) });
    }, this.logger = wt.generateChildLogger(r, this.context);
  }
}
var zq = Object.defineProperty, ow = Object.getOwnPropertySymbols, Vq = Object.prototype.hasOwnProperty, Wq = Object.prototype.propertyIsEnumerable, aw = (t, e, r) => e in t ? zq(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, cw = (t, e) => {
  for (var r in e || (e = {}))
    Vq.call(e, r) && aw(t, r, e[r]);
  if (ow)
    for (var r of ow(e))
      Wq.call(e, r) && aw(t, r, e[r]);
  return t;
};
class Ng extends wU {
  constructor(e) {
    super(e), this.protocol = d3, this.version = qH, this.name = Tg, this.events = new Tr.EventEmitter(), this.initialized = !1, this.on = (n, i) => this.events.on(n, i), this.once = (n, i) => this.events.once(n, i), this.off = (n, i) => this.events.off(n, i), this.removeListener = (n, i) => this.events.removeListener(n, i), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || g3, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
    const r = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : wt.pino(wt.getDefaultLoggerOptions({ level: e?.logger || zH.logger }));
    this.logger = wt.generateChildLogger(r, this.name), this.heartbeat = new ja.HeartBeat(), this.crypto = new bq(this, this.logger, e?.keychain), this.history = new Uq(this, this.logger), this.expirer = new jq(this, this.logger), this.storage = e != null && e.storage ? e.storage : new hU(cw(cw({}, VH), e?.storageOptions)), this.relayer = new kq({ core: this, logger: this.logger, relayUrl: this.relayUrl, projectId: this.projectId }), this.pairing = new Bq(this, this.logger), this.verify = new Hq(this.projectId || "", this.logger), this.echoClient = new qq(this.projectId || "", this.logger);
  }
  static async init(e) {
    const r = new Ng(e);
    await r.initialize();
    const n = await r.crypto.getClientId();
    return await r.storage.setItem(aq, n), r;
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  async start() {
    this.initialized || await this.initialize();
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
    } catch (e) {
      throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
    }
  }
}
const Kq = Ng, m3 = "wc", v3 = 2, y3 = "client", kg = `${m3}@${v3}:${y3}:`, M0 = { name: y3, logger: "error", controller: !1, relayUrl: "wss://relay.walletconnect.com" }, uw = "WALLETCONNECT_DEEPLINK_CHOICE", Gq = "proposal", _3 = "Proposal expired", Jq = "session", Bl = He.SEVEN_DAYS, Qq = "engine", yc = { wc_sessionPropose: { req: { ttl: He.FIVE_MINUTES, prompt: !0, tag: 1100 }, res: { ttl: He.FIVE_MINUTES, prompt: !1, tag: 1101 } }, wc_sessionSettle: { req: { ttl: He.FIVE_MINUTES, prompt: !1, tag: 1102 }, res: { ttl: He.FIVE_MINUTES, prompt: !1, tag: 1103 } }, wc_sessionUpdate: { req: { ttl: He.ONE_DAY, prompt: !1, tag: 1104 }, res: { ttl: He.ONE_DAY, prompt: !1, tag: 1105 } }, wc_sessionExtend: { req: { ttl: He.ONE_DAY, prompt: !1, tag: 1106 }, res: { ttl: He.ONE_DAY, prompt: !1, tag: 1107 } }, wc_sessionRequest: { req: { ttl: He.FIVE_MINUTES, prompt: !0, tag: 1108 }, res: { ttl: He.FIVE_MINUTES, prompt: !1, tag: 1109 } }, wc_sessionEvent: { req: { ttl: He.FIVE_MINUTES, prompt: !0, tag: 1110 }, res: { ttl: He.FIVE_MINUTES, prompt: !1, tag: 1111 } }, wc_sessionDelete: { req: { ttl: He.ONE_DAY, prompt: !1, tag: 1112 }, res: { ttl: He.ONE_DAY, prompt: !1, tag: 1113 } }, wc_sessionPing: { req: { ttl: He.THIRTY_SECONDS, prompt: !1, tag: 1114 }, res: { ttl: He.THIRTY_SECONDS, prompt: !1, tag: 1115 } } }, D0 = { min: He.FIVE_MINUTES, max: He.SEVEN_DAYS }, Ki = { idle: "IDLE", active: "ACTIVE" }, Zq = "request", Yq = ["wc_sessionPropose", "wc_sessionRequest", "wc_authRequest"];
var Xq = Object.defineProperty, ez = Object.defineProperties, tz = Object.getOwnPropertyDescriptors, lw = Object.getOwnPropertySymbols, rz = Object.prototype.hasOwnProperty, nz = Object.prototype.propertyIsEnumerable, hw = (t, e, r) => e in t ? Xq(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, cn = (t, e) => {
  for (var r in e || (e = {}))
    rz.call(e, r) && hw(t, r, e[r]);
  if (lw)
    for (var r of lw(e))
      nz.call(e, r) && hw(t, r, e[r]);
  return t;
}, _c = (t, e) => ez(t, tz(e));
class iz extends OU {
  constructor(e) {
    super(e), this.name = Qq, this.events = new Up(), this.initialized = !1, this.ignoredPayloadTypes = [xo], this.requestQueue = { state: Ki.idle, queue: [] }, this.sessionRequestQueue = { state: Ki.idle, queue: [] }, this.requestQueueDelay = He.ONE_SECOND, this.init = async () => {
      this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({ methods: Object.keys(yc) }), this.initialized = !0, setTimeout(() => {
        this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
      }, He.toMiliseconds(this.requestQueueDelay)));
    }, this.connect = async (r) => {
      await this.isInitialized();
      const n = _c(cn({}, r), { requiredNamespaces: r.requiredNamespaces || {}, optionalNamespaces: r.optionalNamespaces || {} });
      await this.isValidConnect(n);
      const { pairingTopic: i, requiredNamespaces: o, optionalNamespaces: c, sessionProperties: u, relays: l } = n;
      let f = i, p, g = !1;
      if (f && (g = this.client.core.pairing.pairings.get(f).active), !f || !g) {
        const { topic: q, uri: B } = await this.client.core.pairing.create();
        f = q, p = B;
      }
      const y = await this.client.core.crypto.generateKeyPair(), C = cn({ requiredNamespaces: o, optionalNamespaces: c, relays: l ?? [{ protocol: p3 }], proposer: { publicKey: y, metadata: this.client.metadata } }, u && { sessionProperties: u }), { reject: R, resolve: J, done: G } = ia(He.FIVE_MINUTES, _3);
      if (this.events.once(gr("session_connect"), async ({ error: q, session: B }) => {
        if (q)
          R(q);
        else if (B) {
          B.self.publicKey = y;
          const L = _c(cn({}, B), { requiredNamespaces: B.requiredNamespaces, optionalNamespaces: B.optionalNamespaces });
          await this.client.session.set(B.topic, L), await this.setExpiry(B.topic, B.expiry), f && await this.client.core.pairing.updateMetadata({ topic: f, metadata: B.peer.metadata }), J(L);
        }
      }), !f) {
        const { message: q } = Me("NO_MATCHING_KEY", `connect() pairing topic: ${f}`);
        throw new Error(q);
      }
      const H = await this.sendRequest({ topic: f, method: "wc_sessionPropose", params: C }), T = ui(He.FIVE_MINUTES);
      return await this.setProposal(H, cn({ id: H, expiry: T }, C)), { uri: p, approval: G };
    }, this.pair = async (r) => (await this.isInitialized(), await this.client.core.pairing.pair(r)), this.approve = async (r) => {
      await this.isInitialized(), await this.isValidApprove(r);
      const { id: n, relayProtocol: i, namespaces: o, sessionProperties: c } = r, u = this.client.proposal.get(n);
      let { pairingTopic: l, proposer: f, requiredNamespaces: p, optionalNamespaces: g } = u;
      l = l || "", pa(p) || (p = rB(o, "approve()"));
      const y = await this.client.core.crypto.generateKeyPair(), C = f.publicKey, R = await this.client.core.crypto.generateSharedKey(y, C);
      l && n && (await this.client.core.pairing.updateMetadata({ topic: l, metadata: f.metadata }), await this.sendResult({ id: n, topic: l, result: { relay: { protocol: i ?? "irn" }, responderPublicKey: y } }), await this.client.proposal.delete(n, or("USER_DISCONNECTED")), await this.client.core.pairing.activate({ topic: l }));
      const J = cn({ relay: { protocol: i ?? "irn" }, namespaces: o, requiredNamespaces: p, optionalNamespaces: g, pairingTopic: l, controller: { publicKey: y, metadata: this.client.metadata }, expiry: ui(Bl) }, c && { sessionProperties: c });
      await this.client.core.relayer.subscribe(R), await this.sendRequest({ topic: R, method: "wc_sessionSettle", params: J, throwOnFailedPublish: !0 });
      const G = _c(cn({}, J), { topic: R, pairingTopic: l, acknowledged: !1, self: J.controller, peer: { publicKey: f.publicKey, metadata: f.metadata }, controller: y });
      return await this.client.session.set(R, G), await this.setExpiry(R, ui(Bl)), { topic: R, acknowledged: () => new Promise((H) => setTimeout(() => H(this.client.session.get(R)), 500)) };
    }, this.reject = async (r) => {
      await this.isInitialized(), await this.isValidReject(r);
      const { id: n, reason: i } = r, { pairingTopic: o } = this.client.proposal.get(n);
      o && (await this.sendError(n, o, i), await this.client.proposal.delete(n, or("USER_DISCONNECTED")));
    }, this.update = async (r) => {
      await this.isInitialized(), await this.isValidUpdate(r);
      const { topic: n, namespaces: i } = r, o = await this.sendRequest({ topic: n, method: "wc_sessionUpdate", params: { namespaces: i } }), { done: c, resolve: u, reject: l } = ia();
      return this.events.once(gr("session_update", o), ({ error: f }) => {
        f ? l(f) : u();
      }), await this.client.session.update(n, { namespaces: i }), { acknowledged: c };
    }, this.extend = async (r) => {
      await this.isInitialized(), await this.isValidExtend(r);
      const { topic: n } = r, i = await this.sendRequest({ topic: n, method: "wc_sessionExtend", params: {} }), { done: o, resolve: c, reject: u } = ia();
      return this.events.once(gr("session_extend", i), ({ error: l }) => {
        l ? u(l) : c();
      }), await this.setExpiry(n, ui(Bl)), { acknowledged: o };
    }, this.request = async (r) => {
      await this.isInitialized(), await this.isValidRequest(r);
      const { chainId: n, request: i, topic: o, expiry: c } = r, u = Og(), { done: l, resolve: f, reject: p } = ia(c, "Request expired. Please try again.");
      return this.events.once(gr("session_request", u), ({ error: g, result: y }) => {
        g ? p(g) : f(y);
      }), await Promise.all([new Promise(async (g) => {
        await this.sendRequest({ clientRpcId: u, topic: o, method: "wc_sessionRequest", params: { request: i, chainId: n }, expiry: c, throwOnFailedPublish: !0 }).catch((y) => p(y)), this.client.events.emit("session_request_sent", { topic: o, request: i, chainId: n, id: u }), g();
      }), new Promise(async (g) => {
        const y = await qF(this.client.core.storage, uw);
        HF({ id: u, topic: o, wcDeepLink: y }), g();
      }), l()]).then((g) => g[2]);
    }, this.respond = async (r) => {
      await this.isInitialized(), await this.isValidRespond(r);
      const { topic: n, response: i } = r, { id: o } = i;
      Qi(i) ? await this.sendResult({ id: o, topic: n, result: i.result, throwOnFailedPublish: !0 }) : li(i) && await this.sendError(o, n, i.error), this.cleanupAfterResponse(r);
    }, this.ping = async (r) => {
      await this.isInitialized(), await this.isValidPing(r);
      const { topic: n } = r;
      if (this.client.session.keys.includes(n)) {
        const i = await this.sendRequest({ topic: n, method: "wc_sessionPing", params: {} }), { done: o, resolve: c, reject: u } = ia();
        this.events.once(gr("session_ping", i), ({ error: l }) => {
          l ? u(l) : c();
        }), await o();
      } else
        this.client.core.pairing.pairings.keys.includes(n) && await this.client.core.pairing.ping({ topic: n });
    }, this.emit = async (r) => {
      await this.isInitialized(), await this.isValidEmit(r);
      const { topic: n, event: i, chainId: o } = r;
      await this.sendRequest({ topic: n, method: "wc_sessionEvent", params: { event: i, chainId: o } });
    }, this.disconnect = async (r) => {
      await this.isInitialized(), await this.isValidDisconnect(r);
      const { topic: n } = r;
      this.client.session.keys.includes(n) ? (await this.sendRequest({ topic: n, method: "wc_sessionDelete", params: or("USER_DISCONNECTED"), throwOnFailedPublish: !0 }), await this.deleteSession(n)) : await this.client.core.pairing.disconnect({ topic: n });
    }, this.find = (r) => (this.isInitialized(), this.client.session.getAll().filter((n) => sB(n, r))), this.getPendingSessionRequests = () => (this.isInitialized(), this.client.pendingRequest.getAll()), this.cleanupDuplicatePairings = async (r) => {
      if (r.pairingTopic)
        try {
          const n = this.client.core.pairing.pairings.get(r.pairingTopic), i = this.client.core.pairing.pairings.getAll().filter((o) => {
            var c, u;
            return ((c = o.peerMetadata) == null ? void 0 : c.url) && ((u = o.peerMetadata) == null ? void 0 : u.url) === r.peer.metadata.url && o.topic && o.topic !== n.topic;
          });
          if (i.length === 0)
            return;
          this.client.logger.info(`Cleaning up ${i.length} duplicate pairing(s)`), await Promise.all(i.map((o) => this.client.core.pairing.disconnect({ topic: o.topic }))), this.client.logger.info("Duplicate pairings clean up finished");
        } catch (n) {
          this.client.logger.error(n);
        }
    }, this.deleteSession = async (r, n) => {
      const { self: i } = this.client.session.get(r);
      await this.client.core.relayer.unsubscribe(r), this.client.session.delete(r, or("USER_DISCONNECTED")), this.client.core.crypto.keychain.has(i.publicKey) && await this.client.core.crypto.deleteKeyPair(i.publicKey), this.client.core.crypto.keychain.has(r) && await this.client.core.crypto.deleteSymKey(r), n || this.client.core.expirer.del(r), this.client.core.storage.removeItem(uw).catch((o) => this.client.logger.warn(o)), this.getPendingSessionRequests().forEach((o) => {
        o.topic === r && this.deletePendingSessionRequest(o.id, or("USER_DISCONNECTED"));
      });
    }, this.deleteProposal = async (r, n) => {
      await Promise.all([this.client.proposal.delete(r, or("USER_DISCONNECTED")), n ? Promise.resolve() : this.client.core.expirer.del(r)]);
    }, this.deletePendingSessionRequest = async (r, n, i = !1) => {
      await Promise.all([this.client.pendingRequest.delete(r, n), i ? Promise.resolve() : this.client.core.expirer.del(r)]), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((o) => o.id !== r), i && (this.sessionRequestQueue.state = Ki.idle);
    }, this.setExpiry = async (r, n) => {
      this.client.session.keys.includes(r) && await this.client.session.update(r, { expiry: n }), this.client.core.expirer.set(r, n);
    }, this.setProposal = async (r, n) => {
      await this.client.proposal.set(r, n), this.client.core.expirer.set(r, n.expiry);
    }, this.setPendingSessionRequest = async (r) => {
      const n = yc.wc_sessionRequest.req.ttl, { id: i, topic: o, params: c, verifyContext: u } = r;
      await this.client.pendingRequest.set(i, { id: i, topic: o, params: c, verifyContext: u }), n && this.client.core.expirer.set(i, ui(n));
    }, this.sendRequest = async (r) => {
      const { topic: n, method: i, params: o, expiry: c, relayRpcId: u, clientRpcId: l, throwOnFailedPublish: f } = r, p = ga(i, o, l);
      if (Ba() && Yq.includes(i)) {
        const C = da(JSON.stringify(p));
        this.client.core.verify.register({ attestationId: C });
      }
      const g = await this.client.core.crypto.encode(n, p), y = yc[i].req;
      return c && (y.ttl = c), u && (y.id = u), this.client.core.history.set(n, p), f ? (y.internal = _c(cn({}, y.internal), { throwOnFailedPublish: !0 }), await this.client.core.relayer.publish(n, g, y)) : this.client.core.relayer.publish(n, g, y).catch((C) => this.client.logger.error(C)), p.id;
    }, this.sendResult = async (r) => {
      const { id: n, topic: i, result: o, throwOnFailedPublish: c } = r, u = vf(n, o), l = await this.client.core.crypto.encode(i, u), f = await this.client.core.history.get(i, n), p = yc[f.request.method].res;
      c ? (p.internal = _c(cn({}, p.internal), { throwOnFailedPublish: !0 }), await this.client.core.relayer.publish(i, l, p)) : this.client.core.relayer.publish(i, l, p).catch((g) => this.client.logger.error(g)), await this.client.core.history.resolve(u);
    }, this.sendError = async (r, n, i) => {
      const o = yf(r, i), c = await this.client.core.crypto.encode(n, o), u = await this.client.core.history.get(n, r), l = yc[u.request.method].res;
      this.client.core.relayer.publish(n, c, l), await this.client.core.history.resolve(o);
    }, this.cleanup = async () => {
      const r = [], n = [];
      this.client.session.getAll().forEach((i) => {
        bs(i.expiry) && r.push(i.topic);
      }), this.client.proposal.getAll().forEach((i) => {
        bs(i.expiry) && n.push(i.id);
      }), await Promise.all([...r.map((i) => this.deleteSession(i)), ...n.map((i) => this.deleteProposal(i))]);
    }, this.onRelayEventRequest = async (r) => {
      this.requestQueue.queue.push(r), await this.processRequestsQueue();
    }, this.processRequestsQueue = async () => {
      if (this.requestQueue.state === Ki.active) {
        this.client.logger.info("Request queue already active, skipping...");
        return;
      }
      for (this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0; ) {
        this.requestQueue.state = Ki.active;
        const r = this.requestQueue.queue.shift();
        if (r)
          try {
            this.processRequest(r), await new Promise((n) => setTimeout(n, 300));
          } catch (n) {
            this.client.logger.warn(n);
          }
      }
      this.requestQueue.state = Ki.idle;
    }, this.processRequest = (r) => {
      const { topic: n, payload: i } = r, o = i.method;
      switch (o) {
        case "wc_sessionPropose":
          return this.onSessionProposeRequest(n, i);
        case "wc_sessionSettle":
          return this.onSessionSettleRequest(n, i);
        case "wc_sessionUpdate":
          return this.onSessionUpdateRequest(n, i);
        case "wc_sessionExtend":
          return this.onSessionExtendRequest(n, i);
        case "wc_sessionPing":
          return this.onSessionPingRequest(n, i);
        case "wc_sessionDelete":
          return this.onSessionDeleteRequest(n, i);
        case "wc_sessionRequest":
          return this.onSessionRequest(n, i);
        case "wc_sessionEvent":
          return this.onSessionEventRequest(n, i);
        default:
          return this.client.logger.info(`Unsupported request method ${o}`);
      }
    }, this.onRelayEventResponse = async (r) => {
      const { topic: n, payload: i } = r, o = (await this.client.core.history.get(n, i.id)).request.method;
      switch (o) {
        case "wc_sessionPropose":
          return this.onSessionProposeResponse(n, i);
        case "wc_sessionSettle":
          return this.onSessionSettleResponse(n, i);
        case "wc_sessionUpdate":
          return this.onSessionUpdateResponse(n, i);
        case "wc_sessionExtend":
          return this.onSessionExtendResponse(n, i);
        case "wc_sessionPing":
          return this.onSessionPingResponse(n, i);
        case "wc_sessionRequest":
          return this.onSessionRequestResponse(n, i);
        default:
          return this.client.logger.info(`Unsupported response method ${o}`);
      }
    }, this.onRelayEventUnknownPayload = (r) => {
      const { topic: n } = r, { message: i } = Me("MISSING_OR_INVALID", `Decoded payload on topic ${n} is not identifiable as a JSON-RPC request or a response.`);
      throw new Error(i);
    }, this.onSessionProposeRequest = async (r, n) => {
      const { params: i, id: o } = n;
      try {
        this.isValidConnect(cn({}, n.params));
        const c = ui(He.FIVE_MINUTES), u = cn({ id: o, pairingTopic: r, expiry: c }, i);
        await this.setProposal(o, u);
        const l = da(JSON.stringify(n)), f = await this.getVerifyContext(l, u.proposer.metadata);
        this.client.events.emit("session_proposal", { id: o, params: u, verifyContext: f });
      } catch (c) {
        await this.sendError(o, r, c), this.client.logger.error(c);
      }
    }, this.onSessionProposeResponse = async (r, n) => {
      const { id: i } = n;
      if (Qi(n)) {
        const { result: o } = n;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", result: o });
        const c = this.client.proposal.get(i);
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", proposal: c });
        const u = c.proposer.publicKey;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", selfPublicKey: u });
        const l = o.responderPublicKey;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", peerPublicKey: l });
        const f = await this.client.core.crypto.generateSharedKey(u, l);
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", sessionTopic: f });
        const p = await this.client.core.relayer.subscribe(f);
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", subscriptionId: p }), await this.client.core.pairing.activate({ topic: r });
      } else
        li(n) && (await this.client.proposal.delete(i, or("USER_DISCONNECTED")), this.events.emit(gr("session_connect"), { error: n.error }));
    }, this.onSessionSettleRequest = async (r, n) => {
      const { id: i, params: o } = n;
      try {
        this.isValidSessionSettleRequest(o);
        const { relay: c, controller: u, expiry: l, namespaces: f, requiredNamespaces: p, optionalNamespaces: g, sessionProperties: y, pairingTopic: C } = n.params, R = cn({ topic: r, relay: c, expiry: l, namespaces: f, acknowledged: !0, pairingTopic: C, requiredNamespaces: p, optionalNamespaces: g, controller: u.publicKey, self: { publicKey: "", metadata: this.client.metadata }, peer: { publicKey: u.publicKey, metadata: u.metadata } }, y && { sessionProperties: y });
        await this.sendResult({ id: n.id, topic: r, result: !0 }), this.events.emit(gr("session_connect"), { session: R }), this.cleanupDuplicatePairings(R);
      } catch (c) {
        await this.sendError(i, r, c), this.client.logger.error(c);
      }
    }, this.onSessionSettleResponse = async (r, n) => {
      const { id: i } = n;
      Qi(n) ? (await this.client.session.update(r, { acknowledged: !0 }), this.events.emit(gr("session_approve", i), {})) : li(n) && (await this.client.session.delete(r, or("USER_DISCONNECTED")), this.events.emit(gr("session_approve", i), { error: n.error }));
    }, this.onSessionUpdateRequest = async (r, n) => {
      const { params: i, id: o } = n;
      try {
        const c = `${r}_session_update`, u = Ll.get(c);
        if (u && this.isRequestOutOfSync(u, o)) {
          this.client.logger.info(`Discarding out of sync request - ${o}`);
          return;
        }
        this.isValidUpdate(cn({ topic: r }, i)), await this.client.session.update(r, { namespaces: i.namespaces }), await this.sendResult({ id: o, topic: r, result: !0 }), this.client.events.emit("session_update", { id: o, topic: r, params: i }), Ll.set(c, o);
      } catch (c) {
        await this.sendError(o, r, c), this.client.logger.error(c);
      }
    }, this.isRequestOutOfSync = (r, n) => parseInt(n.toString().slice(0, -3)) <= parseInt(r.toString().slice(0, -3)), this.onSessionUpdateResponse = (r, n) => {
      const { id: i } = n;
      Qi(n) ? this.events.emit(gr("session_update", i), {}) : li(n) && this.events.emit(gr("session_update", i), { error: n.error });
    }, this.onSessionExtendRequest = async (r, n) => {
      const { id: i } = n;
      try {
        this.isValidExtend({ topic: r }), await this.setExpiry(r, ui(Bl)), await this.sendResult({ id: i, topic: r, result: !0 }), this.client.events.emit("session_extend", { id: i, topic: r });
      } catch (o) {
        await this.sendError(i, r, o), this.client.logger.error(o);
      }
    }, this.onSessionExtendResponse = (r, n) => {
      const { id: i } = n;
      Qi(n) ? this.events.emit(gr("session_extend", i), {}) : li(n) && this.events.emit(gr("session_extend", i), { error: n.error });
    }, this.onSessionPingRequest = async (r, n) => {
      const { id: i } = n;
      try {
        this.isValidPing({ topic: r }), await this.sendResult({ id: i, topic: r, result: !0 }), this.client.events.emit("session_ping", { id: i, topic: r });
      } catch (o) {
        await this.sendError(i, r, o), this.client.logger.error(o);
      }
    }, this.onSessionPingResponse = (r, n) => {
      const { id: i } = n;
      setTimeout(() => {
        Qi(n) ? this.events.emit(gr("session_ping", i), {}) : li(n) && this.events.emit(gr("session_ping", i), { error: n.error });
      }, 500);
    }, this.onSessionDeleteRequest = async (r, n) => {
      const { id: i } = n;
      try {
        this.isValidDisconnect({ topic: r, reason: n.params }), await Promise.all([new Promise((o) => {
          this.client.core.relayer.once(jr.publish, async () => {
            o(await this.deleteSession(r));
          });
        }), this.sendResult({ id: i, topic: r, result: !0 })]), this.client.events.emit("session_delete", { id: i, topic: r });
      } catch (o) {
        this.client.logger.error(o);
      }
    }, this.onSessionRequest = async (r, n) => {
      const { id: i, params: o } = n;
      try {
        this.isValidRequest(cn({ topic: r }, o));
        const c = da(JSON.stringify(ga("wc_sessionRequest", o, i))), u = this.client.session.get(r), l = await this.getVerifyContext(c, u.peer.metadata), f = { id: i, topic: r, params: o, verifyContext: l };
        await this.setPendingSessionRequest(f), this.addSessionRequestToSessionRequestQueue(f), this.processSessionRequestQueue();
      } catch (c) {
        await this.sendError(i, r, c), this.client.logger.error(c);
      }
    }, this.onSessionRequestResponse = (r, n) => {
      const { id: i } = n;
      Qi(n) ? this.events.emit(gr("session_request", i), { result: n.result }) : li(n) && this.events.emit(gr("session_request", i), { error: n.error });
    }, this.onSessionEventRequest = async (r, n) => {
      const { id: i, params: o } = n;
      try {
        const c = `${r}_session_event_${o.event.name}`, u = Ll.get(c);
        if (u && this.isRequestOutOfSync(u, i)) {
          this.client.logger.info(`Discarding out of sync request - ${i}`);
          return;
        }
        this.isValidEmit(cn({ topic: r }, o)), this.client.events.emit("session_event", { id: i, topic: r, params: o }), Ll.set(c, i);
      } catch (c) {
        await this.sendError(i, r, c), this.client.logger.error(c);
      }
    }, this.addSessionRequestToSessionRequestQueue = (r) => {
      this.sessionRequestQueue.queue.push(r);
    }, this.cleanupAfterResponse = (r) => {
      this.deletePendingSessionRequest(r.response.id, { message: "fulfilled", code: 0 }), setTimeout(() => {
        this.sessionRequestQueue.state = Ki.idle, this.processSessionRequestQueue();
      }, He.toMiliseconds(this.requestQueueDelay));
    }, this.processSessionRequestQueue = () => {
      if (this.sessionRequestQueue.state === Ki.active) {
        this.client.logger.info("session request queue is already active.");
        return;
      }
      const r = this.sessionRequestQueue.queue[0];
      if (!r) {
        this.client.logger.info("session request queue is empty.");
        return;
      }
      try {
        this.sessionRequestQueue.state = Ki.active, this.client.events.emit("session_request", r);
      } catch (n) {
        this.client.logger.error(n);
      }
    }, this.onPairingCreated = (r) => {
      if (r.active)
        return;
      const n = this.client.proposal.getAll().find((i) => i.pairingTopic === r.topic);
      n && this.onSessionProposeRequest(r.topic, ga("wc_sessionPropose", { requiredNamespaces: n.requiredNamespaces, optionalNamespaces: n.optionalNamespaces, relays: n.relays, proposer: n.proposer, sessionProperties: n.sessionProperties }, n.id));
    }, this.isValidConnect = async (r) => {
      if (!ln(r)) {
        const { message: l } = Me("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(r)}`);
        throw new Error(l);
      }
      const { pairingTopic: n, requiredNamespaces: i, optionalNamespaces: o, sessionProperties: c, relays: u } = r;
      if (Jr(n) || await this.isValidPairingTopic(n), !vB(u, !0)) {
        const { message: l } = Me("MISSING_OR_INVALID", `connect() relays: ${u}`);
        throw new Error(l);
      }
      !Jr(i) && pa(i) !== 0 && this.validateNamespaces(i, "requiredNamespaces"), !Jr(o) && pa(o) !== 0 && this.validateNamespaces(o, "optionalNamespaces"), Jr(c) || this.validateSessionProps(c, "sessionProperties");
    }, this.validateNamespaces = (r, n) => {
      const i = mB(r, "connect()", n);
      if (i)
        throw new Error(i.message);
    }, this.isValidApprove = async (r) => {
      if (!ln(r))
        throw new Error(Me("MISSING_OR_INVALID", `approve() params: ${r}`).message);
      const { id: n, namespaces: i, relayProtocol: o, sessionProperties: c } = r;
      await this.isValidProposalId(n);
      const u = this.client.proposal.get(n), l = Gl(i, "approve()");
      if (l)
        throw new Error(l.message);
      const f = __(u.requiredNamespaces, i, "approve()");
      if (f)
        throw new Error(f.message);
      if (!Rr(o, !0)) {
        const { message: p } = Me("MISSING_OR_INVALID", `approve() relayProtocol: ${o}`);
        throw new Error(p);
      }
      Jr(c) || this.validateSessionProps(c, "sessionProperties");
    }, this.isValidReject = async (r) => {
      if (!ln(r)) {
        const { message: o } = Me("MISSING_OR_INVALID", `reject() params: ${r}`);
        throw new Error(o);
      }
      const { id: n, reason: i } = r;
      if (await this.isValidProposalId(n), !_B(i)) {
        const { message: o } = Me("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(i)}`);
        throw new Error(o);
      }
    }, this.isValidSessionSettleRequest = (r) => {
      if (!ln(r)) {
        const { message: f } = Me("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${r}`);
        throw new Error(f);
      }
      const { relay: n, controller: i, namespaces: o, expiry: c } = r;
      if (!BE(n)) {
        const { message: f } = Me("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
        throw new Error(f);
      }
      const u = lB(i, "onSessionSettleRequest()");
      if (u)
        throw new Error(u.message);
      const l = Gl(o, "onSessionSettleRequest()");
      if (l)
        throw new Error(l.message);
      if (bs(c)) {
        const { message: f } = Me("EXPIRED", "onSessionSettleRequest()");
        throw new Error(f);
      }
    }, this.isValidUpdate = async (r) => {
      if (!ln(r)) {
        const { message: l } = Me("MISSING_OR_INVALID", `update() params: ${r}`);
        throw new Error(l);
      }
      const { topic: n, namespaces: i } = r;
      await this.isValidSessionTopic(n);
      const o = this.client.session.get(n), c = Gl(i, "update()");
      if (c)
        throw new Error(c.message);
      const u = __(o.requiredNamespaces, i, "update()");
      if (u)
        throw new Error(u.message);
    }, this.isValidExtend = async (r) => {
      if (!ln(r)) {
        const { message: i } = Me("MISSING_OR_INVALID", `extend() params: ${r}`);
        throw new Error(i);
      }
      const { topic: n } = r;
      await this.isValidSessionTopic(n);
    }, this.isValidRequest = async (r) => {
      if (!ln(r)) {
        const { message: l } = Me("MISSING_OR_INVALID", `request() params: ${r}`);
        throw new Error(l);
      }
      const { topic: n, request: i, chainId: o, expiry: c } = r;
      await this.isValidSessionTopic(n);
      const { namespaces: u } = this.client.session.get(n);
      if (!y_(u, o)) {
        const { message: l } = Me("MISSING_OR_INVALID", `request() chainId: ${o}`);
        throw new Error(l);
      }
      if (!wB(i)) {
        const { message: l } = Me("MISSING_OR_INVALID", `request() ${JSON.stringify(i)}`);
        throw new Error(l);
      }
      if (!SB(u, o, i.method)) {
        const { message: l } = Me("MISSING_OR_INVALID", `request() method: ${i.method}`);
        throw new Error(l);
      }
      if (c && !RB(c, D0)) {
        const { message: l } = Me("MISSING_OR_INVALID", `request() expiry: ${c}. Expiry must be a number (in seconds) between ${D0.min} and ${D0.max}`);
        throw new Error(l);
      }
    }, this.isValidRespond = async (r) => {
      var n;
      if (!ln(r)) {
        const { message: c } = Me("MISSING_OR_INVALID", `respond() params: ${r}`);
        throw new Error(c);
      }
      const { topic: i, response: o } = r;
      try {
        await this.isValidSessionTopic(i);
      } catch (c) {
        throw (n = r?.response) != null && n.id && this.cleanupAfterResponse(r), c;
      }
      if (!bB(o)) {
        const { message: c } = Me("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(o)}`);
        throw new Error(c);
      }
    }, this.isValidPing = async (r) => {
      if (!ln(r)) {
        const { message: i } = Me("MISSING_OR_INVALID", `ping() params: ${r}`);
        throw new Error(i);
      }
      const { topic: n } = r;
      await this.isValidSessionOrPairingTopic(n);
    }, this.isValidEmit = async (r) => {
      if (!ln(r)) {
        const { message: u } = Me("MISSING_OR_INVALID", `emit() params: ${r}`);
        throw new Error(u);
      }
      const { topic: n, event: i, chainId: o } = r;
      await this.isValidSessionTopic(n);
      const { namespaces: c } = this.client.session.get(n);
      if (!y_(c, o)) {
        const { message: u } = Me("MISSING_OR_INVALID", `emit() chainId: ${o}`);
        throw new Error(u);
      }
      if (!EB(i)) {
        const { message: u } = Me("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(i)}`);
        throw new Error(u);
      }
      if (!CB(c, o, i.name)) {
        const { message: u } = Me("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(i)}`);
        throw new Error(u);
      }
    }, this.isValidDisconnect = async (r) => {
      if (!ln(r)) {
        const { message: i } = Me("MISSING_OR_INVALID", `disconnect() params: ${r}`);
        throw new Error(i);
      }
      const { topic: n } = r;
      await this.isValidSessionOrPairingTopic(n);
    }, this.getVerifyContext = async (r, n) => {
      const i = { verified: { verifyUrl: n.verifyUrl || oa, validation: "UNKNOWN", origin: n.url || "" } };
      try {
        const o = await this.client.core.verify.resolve({ attestationId: r, verifyUrl: n.verifyUrl });
        o && (i.verified.origin = o.origin, i.verified.isScam = o.isScam, i.verified.validation = o.origin === new URL(n.url).origin ? "VALID" : "INVALID");
      } catch (o) {
        this.client.logger.info(o);
      }
      return this.client.logger.info(`Verify context: ${JSON.stringify(i)}`), i;
    }, this.validateSessionProps = (r, n) => {
      Object.values(r).forEach((i) => {
        if (!Rr(i, !1)) {
          const { message: o } = Me("MISSING_OR_INVALID", `${n} must be in Record<string, string> format. Received: ${JSON.stringify(i)}`);
          throw new Error(o);
        }
      });
    };
  }
  async isInitialized() {
    if (!this.initialized) {
      const { message: e } = Me("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
    await this.client.core.relayer.confirmOnlineStateOrThrow();
  }
  registerRelayerEvents() {
    this.client.core.relayer.on(jr.message, async (e) => {
      const { topic: r, message: n } = e;
      if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(n)))
        return;
      const i = await this.client.core.crypto.decode(r, n);
      try {
        Pg(i) ? (this.client.core.history.set(r, i), this.onRelayEventRequest({ topic: r, payload: i })) : _f(i) ? (await this.client.core.history.resolve(i), await this.onRelayEventResponse({ topic: r, payload: i }), this.client.core.history.delete(r, i.id)) : this.onRelayEventUnknownPayload({ topic: r, payload: i });
      } catch (o) {
        this.client.logger.error(o);
      }
    });
  }
  registerExpirerEvents() {
    this.client.core.expirer.on(Un.expired, async (e) => {
      const { topic: r, id: n } = $E(e.target);
      if (n && this.client.pendingRequest.keys.includes(n))
        return await this.deletePendingSessionRequest(n, Me("EXPIRED"), !0);
      r ? this.client.session.keys.includes(r) && (await this.deleteSession(r, !0), this.client.events.emit("session_expire", { topic: r })) : n && (await this.deleteProposal(n, !0), this.client.events.emit("proposal_expire", { id: n }));
    });
  }
  registerPairingEvents() {
    this.client.core.pairing.events.on(Ec.create, (e) => this.onPairingCreated(e));
  }
  isValidPairingTopic(e) {
    if (!Rr(e, !1)) {
      const { message: r } = Me("MISSING_OR_INVALID", `pairing topic should be a string: ${e}`);
      throw new Error(r);
    }
    if (!this.client.core.pairing.pairings.keys.includes(e)) {
      const { message: r } = Me("NO_MATCHING_KEY", `pairing topic doesn't exist: ${e}`);
      throw new Error(r);
    }
    if (bs(this.client.core.pairing.pairings.get(e).expiry)) {
      const { message: r } = Me("EXPIRED", `pairing topic: ${e}`);
      throw new Error(r);
    }
  }
  async isValidSessionTopic(e) {
    if (!Rr(e, !1)) {
      const { message: r } = Me("MISSING_OR_INVALID", `session topic should be a string: ${e}`);
      throw new Error(r);
    }
    if (!this.client.session.keys.includes(e)) {
      const { message: r } = Me("NO_MATCHING_KEY", `session topic doesn't exist: ${e}`);
      throw new Error(r);
    }
    if (bs(this.client.session.get(e).expiry)) {
      await this.deleteSession(e);
      const { message: r } = Me("EXPIRED", `session topic: ${e}`);
      throw new Error(r);
    }
  }
  async isValidSessionOrPairingTopic(e) {
    if (this.client.session.keys.includes(e))
      await this.isValidSessionTopic(e);
    else if (this.client.core.pairing.pairings.keys.includes(e))
      this.isValidPairingTopic(e);
    else if (Rr(e, !1)) {
      const { message: r } = Me("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${e}`);
      throw new Error(r);
    } else {
      const { message: r } = Me("MISSING_OR_INVALID", `session or pairing topic should be a string: ${e}`);
      throw new Error(r);
    }
  }
  async isValidProposalId(e) {
    if (!yB(e)) {
      const { message: r } = Me("MISSING_OR_INVALID", `proposal id should be a number: ${e}`);
      throw new Error(r);
    }
    if (!this.client.proposal.keys.includes(e)) {
      const { message: r } = Me("NO_MATCHING_KEY", `proposal id doesn't exist: ${e}`);
      throw new Error(r);
    }
    if (bs(this.client.proposal.get(e).expiry)) {
      await this.deleteProposal(e);
      const { message: r } = Me("EXPIRED", `proposal id: ${e}`);
      throw new Error(r);
    }
  }
}
class sz extends bf {
  constructor(e, r) {
    super(e, r, Gq, kg), this.core = e, this.logger = r;
  }
}
class oz extends bf {
  constructor(e, r) {
    super(e, r, Jq, kg), this.core = e, this.logger = r;
  }
}
class az extends bf {
  constructor(e, r) {
    super(e, r, Zq, kg, (n) => n.id), this.core = e, this.logger = r;
  }
}
let cz = class w3 extends DU {
  constructor(e) {
    super(e), this.protocol = m3, this.version = v3, this.name = M0.name, this.events = new Tr.EventEmitter(), this.on = (n, i) => this.events.on(n, i), this.once = (n, i) => this.events.once(n, i), this.off = (n, i) => this.events.off(n, i), this.removeListener = (n, i) => this.events.removeListener(n, i), this.removeAllListeners = (n) => this.events.removeAllListeners(n), this.connect = async (n) => {
      try {
        return await this.engine.connect(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.pair = async (n) => {
      try {
        return await this.engine.pair(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.approve = async (n) => {
      try {
        return await this.engine.approve(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.reject = async (n) => {
      try {
        return await this.engine.reject(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.update = async (n) => {
      try {
        return await this.engine.update(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.extend = async (n) => {
      try {
        return await this.engine.extend(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.request = async (n) => {
      try {
        return await this.engine.request(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.respond = async (n) => {
      try {
        return await this.engine.respond(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.ping = async (n) => {
      try {
        return await this.engine.ping(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.emit = async (n) => {
      try {
        return await this.engine.emit(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.disconnect = async (n) => {
      try {
        return await this.engine.disconnect(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.find = (n) => {
      try {
        return this.engine.find(n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.getPendingSessionRequests = () => {
      try {
        return this.engine.getPendingSessionRequests();
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }, this.name = e?.name || M0.name, this.metadata = e?.metadata || kF();
    const r = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : wt.pino(wt.getDefaultLoggerOptions({ level: e?.logger || M0.logger }));
    this.core = e?.core || new Kq(e), this.logger = wt.generateChildLogger(r, this.name), this.session = new oz(this.core, this.logger), this.proposal = new sz(this.core, this.logger), this.pendingRequest = new az(this.core, this.logger), this.engine = new iz(this);
  }
  static async init(e) {
    const r = new w3(e);
    return await r.initialize(), r;
  }
  get context() {
    return wt.getLoggerContext(this.logger);
  }
  get pairing() {
    return this.core.pairing.pairings;
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({ verifyUrl: this.metadata.verifyUrl }), this.logger.info("SignClient Initialization Success");
    } catch (e) {
      throw this.logger.info("SignClient Initialization Failure"), this.logger.error(e.message), e;
    }
  }
};
var _p = { exports: {} };
(function(t, e) {
  var r = typeof self < "u" ? self : Te, n = function() {
    function o() {
      this.fetch = !1, this.DOMException = r.DOMException;
    }
    return o.prototype = r, new o();
  }();
  (function(o) {
    (function(c) {
      var u = {
        searchParams: "URLSearchParams" in o,
        iterable: "Symbol" in o && "iterator" in Symbol,
        blob: "FileReader" in o && "Blob" in o && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in o,
        arrayBuffer: "ArrayBuffer" in o
      };
      function l(h) {
        return h && DataView.prototype.isPrototypeOf(h);
      }
      if (u.arrayBuffer)
        var f = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], p = ArrayBuffer.isView || function(h) {
          return h && f.indexOf(Object.prototype.toString.call(h)) > -1;
        };
      function g(h) {
        if (typeof h != "string" && (h = String(h)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(h))
          throw new TypeError("Invalid character in header field name");
        return h.toLowerCase();
      }
      function y(h) {
        return typeof h != "string" && (h = String(h)), h;
      }
      function C(h) {
        var m = {
          next: function() {
            var x = h.shift();
            return { done: x === void 0, value: x };
          }
        };
        return u.iterable && (m[Symbol.iterator] = function() {
          return m;
        }), m;
      }
      function R(h) {
        this.map = {}, h instanceof R ? h.forEach(function(m, x) {
          this.append(x, m);
        }, this) : Array.isArray(h) ? h.forEach(function(m) {
          this.append(m[0], m[1]);
        }, this) : h && Object.getOwnPropertyNames(h).forEach(function(m) {
          this.append(m, h[m]);
        }, this);
      }
      R.prototype.append = function(h, m) {
        h = g(h), m = y(m);
        var x = this.map[h];
        this.map[h] = x ? x + ", " + m : m;
      }, R.prototype.delete = function(h) {
        delete this.map[g(h)];
      }, R.prototype.get = function(h) {
        return h = g(h), this.has(h) ? this.map[h] : null;
      }, R.prototype.has = function(h) {
        return this.map.hasOwnProperty(g(h));
      }, R.prototype.set = function(h, m) {
        this.map[g(h)] = y(m);
      }, R.prototype.forEach = function(h, m) {
        for (var x in this.map)
          this.map.hasOwnProperty(x) && h.call(m, this.map[x], x, this);
      }, R.prototype.keys = function() {
        var h = [];
        return this.forEach(function(m, x) {
          h.push(x);
        }), C(h);
      }, R.prototype.values = function() {
        var h = [];
        return this.forEach(function(m) {
          h.push(m);
        }), C(h);
      }, R.prototype.entries = function() {
        var h = [];
        return this.forEach(function(m, x) {
          h.push([x, m]);
        }), C(h);
      }, u.iterable && (R.prototype[Symbol.iterator] = R.prototype.entries);
      function J(h) {
        if (h.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        h.bodyUsed = !0;
      }
      function G(h) {
        return new Promise(function(m, x) {
          h.onload = function() {
            m(h.result);
          }, h.onerror = function() {
            x(h.error);
          };
        });
      }
      function H(h) {
        var m = new FileReader(), x = G(m);
        return m.readAsArrayBuffer(h), x;
      }
      function T(h) {
        var m = new FileReader(), x = G(m);
        return m.readAsText(h), x;
      }
      function q(h) {
        for (var m = new Uint8Array(h), x = new Array(m.length), M = 0; M < m.length; M++)
          x[M] = String.fromCharCode(m[M]);
        return x.join("");
      }
      function B(h) {
        if (h.slice)
          return h.slice(0);
        var m = new Uint8Array(h.byteLength);
        return m.set(new Uint8Array(h)), m.buffer;
      }
      function L() {
        return this.bodyUsed = !1, this._initBody = function(h) {
          this._bodyInit = h, h ? typeof h == "string" ? this._bodyText = h : u.blob && Blob.prototype.isPrototypeOf(h) ? this._bodyBlob = h : u.formData && FormData.prototype.isPrototypeOf(h) ? this._bodyFormData = h : u.searchParams && URLSearchParams.prototype.isPrototypeOf(h) ? this._bodyText = h.toString() : u.arrayBuffer && u.blob && l(h) ? (this._bodyArrayBuffer = B(h.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : u.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(h) || p(h)) ? this._bodyArrayBuffer = B(h) : this._bodyText = h = Object.prototype.toString.call(h) : this._bodyText = "", this.headers.get("content-type") || (typeof h == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : u.searchParams && URLSearchParams.prototype.isPrototypeOf(h) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, u.blob && (this.blob = function() {
          var h = J(this);
          if (h)
            return h;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? J(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(H);
        }), this.text = function() {
          var h = J(this);
          if (h)
            return h;
          if (this._bodyBlob)
            return T(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(q(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, u.formData && (this.formData = function() {
          return this.text().then(ie);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var P = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function v(h) {
        var m = h.toUpperCase();
        return P.indexOf(m) > -1 ? m : h;
      }
      function N(h, m) {
        m = m || {};
        var x = m.body;
        if (h instanceof N) {
          if (h.bodyUsed)
            throw new TypeError("Already read");
          this.url = h.url, this.credentials = h.credentials, m.headers || (this.headers = new R(h.headers)), this.method = h.method, this.mode = h.mode, this.signal = h.signal, !x && h._bodyInit != null && (x = h._bodyInit, h.bodyUsed = !0);
        } else
          this.url = String(h);
        if (this.credentials = m.credentials || this.credentials || "same-origin", (m.headers || !this.headers) && (this.headers = new R(m.headers)), this.method = v(m.method || this.method || "GET"), this.mode = m.mode || this.mode || null, this.signal = m.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && x)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(x);
      }
      N.prototype.clone = function() {
        return new N(this, { body: this._bodyInit });
      };
      function ie(h) {
        var m = new FormData();
        return h.trim().split("&").forEach(function(x) {
          if (x) {
            var M = x.split("="), A = M.shift().replace(/\+/g, " "), $ = M.join("=").replace(/\+/g, " ");
            m.append(decodeURIComponent(A), decodeURIComponent($));
          }
        }), m;
      }
      function le(h) {
        var m = new R(), x = h.replace(/\r?\n[\t ]+/g, " ");
        return x.split(/\r?\n/).forEach(function(M) {
          var A = M.split(":"), $ = A.shift().trim();
          if ($) {
            var K = A.join(":").trim();
            m.append($, K);
          }
        }), m;
      }
      L.call(N.prototype);
      function he(h, m) {
        m || (m = {}), this.type = "default", this.status = m.status === void 0 ? 200 : m.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in m ? m.statusText : "OK", this.headers = new R(m.headers), this.url = m.url || "", this._initBody(h);
      }
      L.call(he.prototype), he.prototype.clone = function() {
        return new he(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new R(this.headers),
          url: this.url
        });
      }, he.error = function() {
        var h = new he(null, { status: 0, statusText: "" });
        return h.type = "error", h;
      };
      var ye = [301, 302, 303, 307, 308];
      he.redirect = function(h, m) {
        if (ye.indexOf(m) === -1)
          throw new RangeError("Invalid status code");
        return new he(null, { status: m, headers: { location: h } });
      }, c.DOMException = o.DOMException;
      try {
        new c.DOMException();
      } catch {
        c.DOMException = function(m, x) {
          this.message = m, this.name = x;
          var M = Error(m);
          this.stack = M.stack;
        }, c.DOMException.prototype = Object.create(Error.prototype), c.DOMException.prototype.constructor = c.DOMException;
      }
      function k(h, m) {
        return new Promise(function(x, M) {
          var A = new N(h, m);
          if (A.signal && A.signal.aborted)
            return M(new c.DOMException("Aborted", "AbortError"));
          var $ = new XMLHttpRequest();
          function K() {
            $.abort();
          }
          $.onload = function() {
            var D = {
              status: $.status,
              statusText: $.statusText,
              headers: le($.getAllResponseHeaders() || "")
            };
            D.url = "responseURL" in $ ? $.responseURL : D.headers.get("X-Request-URL");
            var w = "response" in $ ? $.response : $.responseText;
            x(new he(w, D));
          }, $.onerror = function() {
            M(new TypeError("Network request failed"));
          }, $.ontimeout = function() {
            M(new TypeError("Network request failed"));
          }, $.onabort = function() {
            M(new c.DOMException("Aborted", "AbortError"));
          }, $.open(A.method, A.url, !0), A.credentials === "include" ? $.withCredentials = !0 : A.credentials === "omit" && ($.withCredentials = !1), "responseType" in $ && u.blob && ($.responseType = "blob"), A.headers.forEach(function(D, w) {
            $.setRequestHeader(w, D);
          }), A.signal && (A.signal.addEventListener("abort", K), $.onreadystatechange = function() {
            $.readyState === 4 && A.signal.removeEventListener("abort", K);
          }), $.send(typeof A._bodyInit > "u" ? null : A._bodyInit);
        });
      }
      return k.polyfill = !0, o.fetch || (o.fetch = k, o.Headers = R, o.Request = N, o.Response = he), c.Headers = R, c.Request = N, c.Response = he, c.fetch = k, Object.defineProperty(c, "__esModule", { value: !0 }), c;
    })({});
  })(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
  var i = n;
  e = i.fetch, e.default = i.fetch, e.fetch = i.fetch, e.Headers = i.Headers, e.Request = i.Request, e.Response = i.Response, t.exports = e;
})(_p, _p.exports);
var uz = _p.exports;
const fw = /* @__PURE__ */ Bc(uz), lz = {
  Accept: "application/json",
  "Content-Type": "application/json"
}, hz = "POST", dw = {
  headers: lz,
  method: hz
}, pw = 10;
class Ds {
  constructor(e, r = !1) {
    if (this.url = e, this.disableProviderPing = r, this.events = new Tr.EventEmitter(), this.isAvailable = !1, this.registering = !1, !U_(e))
      throw new Error(`Provided URL is not compatible with HTTP connection: ${e}`);
    this.url = e, this.disableProviderPing = r;
  }
  get connected() {
    return this.isAvailable;
  }
  get connecting() {
    return this.registering;
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async open(e = this.url) {
    await this.register(e);
  }
  async close() {
    if (!this.isAvailable)
      throw new Error("Connection already closed");
    this.onClose();
  }
  async send(e, r) {
    this.isAvailable || await this.register();
    try {
      const n = vo(e), o = await (await fw(this.url, Object.assign(Object.assign({}, dw), { body: n }))).json();
      this.onPayload({ data: o });
    } catch (n) {
      this.onError(e.id, n);
    }
  }
  async register(e = this.url) {
    if (!U_(e))
      throw new Error(`Provided URL is not compatible with HTTP connection: ${e}`);
    if (this.registering) {
      const r = this.events.getMaxListeners();
      return (this.events.listenerCount("register_error") >= r || this.events.listenerCount("open") >= r) && this.events.setMaxListeners(r + 1), new Promise((n, i) => {
        this.events.once("register_error", (o) => {
          this.resetMaxListeners(), i(o);
        }), this.events.once("open", () => {
          if (this.resetMaxListeners(), typeof this.isAvailable > "u")
            return i(new Error("HTTP connection is missing or invalid"));
          n();
        });
      });
    }
    this.url = e, this.registering = !0;
    try {
      if (!this.disableProviderPing) {
        const r = vo({ id: 1, jsonrpc: "2.0", method: "test", params: [] });
        await fw(e, Object.assign(Object.assign({}, dw), { body: r }));
      }
      this.onOpen();
    } catch (r) {
      const n = this.parseError(r);
      throw this.events.emit("register_error", n), this.onClose(), n;
    }
  }
  onOpen() {
    this.isAvailable = !0, this.registering = !1, this.events.emit("open");
  }
  onClose() {
    this.isAvailable = !1, this.registering = !1, this.events.emit("close");
  }
  onPayload(e) {
    if (typeof e.data > "u")
      return;
    const r = typeof e.data == "string" ? _u(e.data) : e.data;
    this.events.emit("payload", r);
  }
  onError(e, r) {
    const n = this.parseError(r), i = n.message || n.toString(), o = yf(e, i);
    this.events.emit("payload", o);
  }
  parseError(e, r = this.url) {
    return ZE(e, r, "HTTP");
  }
  resetMaxListeners() {
    this.events.getMaxListeners() > pw && this.events.setMaxListeners(pw);
  }
}
const gw = "error", fz = "wss://relay.walletconnect.com", dz = "wc", pz = "universal_provider", mw = `${dz}@2:${pz}:`, gz = "https://rpc.walletconnect.com/v1/", os = { DEFAULT_CHAIN_CHANGED: "default_chain_changed" };
var wc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, wp = { exports: {} };
/**
* @license
* Lodash <https://lodash.com/>
* Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
* Released under MIT license <https://lodash.com/license>
* Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
* Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
*/
(function(t, e) {
  (function() {
    var r, n = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", c = "Expected a function", u = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", f = 500, p = "__lodash_placeholder__", g = 1, y = 2, C = 4, R = 1, J = 2, G = 1, H = 2, T = 4, q = 8, B = 16, L = 32, P = 64, v = 128, N = 256, ie = 512, le = 30, he = "...", ye = 800, k = 16, h = 1, m = 2, x = 3, M = 1 / 0, A = 9007199254740991, $ = 17976931348623157e292, K = NaN, D = 4294967295, w = D - 1, U = D >>> 1, me = [["ary", v], ["bind", G], ["bindKey", H], ["curry", q], ["curryRight", B], ["flip", ie], ["partial", L], ["partialRight", P], ["rearg", N]], pe = "[object Arguments]", ee = "[object Array]", V = "[object AsyncFunction]", Q = "[object Boolean]", X = "[object Date]", E = "[object DOMException]", I = "[object Error]", F = "[object Function]", se = "[object GeneratorFunction]", fe = "[object Map]", Re = "[object Number]", j = "[object Null]", b = "[object Object]", S = "[object Promise]", Z = "[object Proxy]", re = "[object RegExp]", ue = "[object Set]", ge = "[object String]", Ee = "[object Symbol]", Ie = "[object Undefined]", Ae = "[object WeakMap]", xe = "[object WeakSet]", Se = "[object ArrayBuffer]", Le = "[object DataView]", Ne = "[object Float32Array]", Oe = "[object Float64Array]", it = "[object Int8Array]", Fe = "[object Int16Array]", je = "[object Int32Array]", ut = "[object Uint8Array]", Be = "[object Uint8ClampedArray]", ht = "[object Uint16Array]", ar = "[object Uint32Array]", bt = /\b__p \+= '';/g, ft = /\b(__p \+=) '' \+/g, Lr = /(__e\(.*?\)|\b__t\)) \+\n'';/g, It = /&(?:amp|lt|gt|quot|#39);/g, Mt = /[&<>"']/g, Tt = RegExp(It.source), Ke = RegExp(Mt.source), Qe = /<%-([\s\S]+?)%>/g, Nt = /<%([\s\S]+?)%>/g, Je = /<%=([\s\S]+?)%>/g, Ge = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ht = /^\w*$/, tt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ze = /[\\^$.*+?()[\]{}|]/g, qt = RegExp(Ze.source), Ye = /^\s+/, Xe = /\s/, kt = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, qe = /\{\n\/\* \[wrapped with (.+)\] \*/, rt = /,? & /, zt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, $t = /[()=,{}\[\]\/\s]/, Ft = /\\(\\)?/g, pi = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, vt = /\w*$/, Bt = /^[-+]0x[0-9a-f]+$/i, Wn = /^0b[01]+$/i, Kn = /^\[object .+?Constructor\]$/, Gn = /^0o[0-7]+$/i, Jn = /^(?:0|[1-9]\d*)$/, Ar = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Xr = /($^)/, Qn = /['\n\r\u2028\u2029\\]/g, en = "\\ud800-\\udfff", Zn = "\\u0300-\\u036f", Yn = "\\ufe20-\\ufe2f", tn = "\\u20d0-\\u20ff", Rn = Zn + Yn + tn, An = "\\u2700-\\u27bf", mr = "a-z\\xdf-\\xf6\\xf8-\\xff", Os = "\\xac\\xb1\\xd7\\xf7", Ps = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ts = "\\u2000-\\u206f", Ns = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", as = "A-Z\\xc0-\\xd6\\xd8-\\xde", bu = "\\ufe0e\\ufe0f", ks = Os + Ps + Ts + Ns, Ha = "['’]", Ls = "[" + en + "]", qa = "[" + ks + "]", $s = "[" + Rn + "]", Eu = "\\d+", Ef = "[" + An + "]", Su = "[" + mr + "]", Cu = "[^" + en + ks + Eu + An + mr + as + "]", Do = "\\ud83c[\\udffb-\\udfff]", Sf = "(?:" + $s + "|" + Do + ")", Iu = "[^" + en + "]", Oo = "(?:\\ud83c[\\udde6-\\uddff]){2}", cs = "[\\ud800-\\udbff][\\udc00-\\udfff]", mn = "[" + as + "]", xu = "\\u200d", Ru = "(?:" + Su + "|" + Cu + ")", gi = "(?:" + mn + "|" + Cu + ")", Au = "(?:" + Ha + "(?:d|ll|m|re|s|t|ve))?", Mu = "(?:" + Ha + "(?:D|LL|M|RE|S|T|VE))?", Du = Sf + "?", Ou = "[" + bu + "]?", Cf = "(?:" + xu + "(?:" + [Iu, Oo, cs].join("|") + ")" + Ou + Du + ")*", Ni = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Pu = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Tu = Ou + Du + Cf, Po = "(?:" + [Ef, Oo, cs].join("|") + ")" + Tu, If = "(?:" + [Iu + $s + "?", $s, Oo, cs, Ls].join("|") + ")", za = RegExp(Ha, "g"), xf = RegExp($s, "g"), To = RegExp(Do + "(?=" + Do + ")|" + If + Tu, "g"), Nu = RegExp([mn + "?" + Su + "+" + Au + "(?=" + [qa, mn, "$"].join("|") + ")", gi + "+" + Mu + "(?=" + [qa, mn + Ru, "$"].join("|") + ")", mn + "?" + Ru + "+" + Au, mn + "+" + Mu, Pu, Ni, Eu, Po].join("|"), "g"), ku = RegExp("[" + xu + en + Rn + bu + "]"), Fs = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Lu = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], Rf = -1, Vt = {};
    Vt[Ne] = Vt[Oe] = Vt[it] = Vt[Fe] = Vt[je] = Vt[ut] = Vt[Be] = Vt[ht] = Vt[ar] = !0, Vt[pe] = Vt[ee] = Vt[Se] = Vt[Q] = Vt[Le] = Vt[X] = Vt[I] = Vt[F] = Vt[fe] = Vt[Re] = Vt[b] = Vt[re] = Vt[ue] = Vt[ge] = Vt[Ae] = !1;
    var Ut = {};
    Ut[pe] = Ut[ee] = Ut[Se] = Ut[Le] = Ut[Q] = Ut[X] = Ut[Ne] = Ut[Oe] = Ut[it] = Ut[Fe] = Ut[je] = Ut[fe] = Ut[Re] = Ut[b] = Ut[re] = Ut[ue] = Ut[ge] = Ut[Ee] = Ut[ut] = Ut[Be] = Ut[ht] = Ut[ar] = !0, Ut[I] = Ut[F] = Ut[Ae] = !1;
    var Y = { À: "A", Á: "A", Â: "A", Ã: "A", Ä: "A", Å: "A", à: "a", á: "a", â: "a", ã: "a", ä: "a", å: "a", Ç: "C", ç: "c", Ð: "D", ð: "d", È: "E", É: "E", Ê: "E", Ë: "E", è: "e", é: "e", ê: "e", ë: "e", Ì: "I", Í: "I", Î: "I", Ï: "I", ì: "i", í: "i", î: "i", ï: "i", Ñ: "N", ñ: "n", Ò: "O", Ó: "O", Ô: "O", Õ: "O", Ö: "O", Ø: "O", ò: "o", ó: "o", ô: "o", õ: "o", ö: "o", ø: "o", Ù: "U", Ú: "U", Û: "U", Ü: "U", ù: "u", ú: "u", û: "u", ü: "u", Ý: "Y", ý: "y", ÿ: "y", Æ: "Ae", æ: "ae", Þ: "Th", þ: "th", ß: "ss", Ā: "A", Ă: "A", Ą: "A", ā: "a", ă: "a", ą: "a", Ć: "C", Ĉ: "C", Ċ: "C", Č: "C", ć: "c", ĉ: "c", ċ: "c", č: "c", Ď: "D", Đ: "D", ď: "d", đ: "d", Ē: "E", Ĕ: "E", Ė: "E", Ę: "E", Ě: "E", ē: "e", ĕ: "e", ė: "e", ę: "e", ě: "e", Ĝ: "G", Ğ: "G", Ġ: "G", Ģ: "G", ĝ: "g", ğ: "g", ġ: "g", ģ: "g", Ĥ: "H", Ħ: "H", ĥ: "h", ħ: "h", Ĩ: "I", Ī: "I", Ĭ: "I", Į: "I", İ: "I", ĩ: "i", ī: "i", ĭ: "i", į: "i", ı: "i", Ĵ: "J", ĵ: "j", Ķ: "K", ķ: "k", ĸ: "k", Ĺ: "L", Ļ: "L", Ľ: "L", Ŀ: "L", Ł: "L", ĺ: "l", ļ: "l", ľ: "l", ŀ: "l", ł: "l", Ń: "N", Ņ: "N", Ň: "N", Ŋ: "N", ń: "n", ņ: "n", ň: "n", ŋ: "n", Ō: "O", Ŏ: "O", Ő: "O", ō: "o", ŏ: "o", ő: "o", Ŕ: "R", Ŗ: "R", Ř: "R", ŕ: "r", ŗ: "r", ř: "r", Ś: "S", Ŝ: "S", Ş: "S", Š: "S", ś: "s", ŝ: "s", ş: "s", š: "s", Ţ: "T", Ť: "T", Ŧ: "T", ţ: "t", ť: "t", ŧ: "t", Ũ: "U", Ū: "U", Ŭ: "U", Ů: "U", Ű: "U", Ų: "U", ũ: "u", ū: "u", ŭ: "u", ů: "u", ű: "u", ų: "u", Ŵ: "W", ŵ: "w", Ŷ: "Y", ŷ: "y", Ÿ: "Y", Ź: "Z", Ż: "Z", Ž: "Z", ź: "z", ż: "z", ž: "z", Ĳ: "IJ", ĳ: "ij", Œ: "Oe", œ: "oe", ŉ: "'n", ſ: "s" }, oe = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, be = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, Pe = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, Wt = parseFloat, ot = parseInt, Zt = typeof wc == "object" && wc && wc.Object === Object && wc, fr = typeof self == "object" && self && self.Object === Object && self, Et = Zt || fr || Function("return this")(), Kt = e && !e.nodeType && e, cr = Kt && !0 && t && !t.nodeType && t, rn = cr && cr.exports === Kt, dr = rn && Zt.process, Yt = function() {
      try {
        var ae = cr && cr.require && cr.require("util").types;
        return ae || dr && dr.binding && dr.binding("util");
      } catch {
      }
    }(), Hr = Yt && Yt.isArrayBuffer, Xn = Yt && Yt.isDate, Mn = Yt && Yt.isMap, mi = Yt && Yt.isRegExp, Va = Yt && Yt.isSet, Bs = Yt && Yt.isTypedArray;
    function br(ae, ve, de) {
      switch (de.length) {
        case 0:
          return ae.call(ve);
        case 1:
          return ae.call(ve, de[0]);
        case 2:
          return ae.call(ve, de[0], de[1]);
        case 3:
          return ae.call(ve, de[0], de[1], de[2]);
      }
      return ae.apply(ve, de);
    }
    function C3(ae, ve, de, ke) {
      for (var st = -1, Ot = ae == null ? 0 : ae.length; ++st < Ot; ) {
        var vr = ae[st];
        ve(ke, vr, de(vr), ae);
      }
      return ke;
    }
    function Dn(ae, ve) {
      for (var de = -1, ke = ae == null ? 0 : ae.length; ++de < ke && ve(ae[de], de, ae) !== !1; )
        ;
      return ae;
    }
    function I3(ae, ve) {
      for (var de = ae == null ? 0 : ae.length; de-- && ve(ae[de], de, ae) !== !1; )
        ;
      return ae;
    }
    function Bg(ae, ve) {
      for (var de = -1, ke = ae == null ? 0 : ae.length; ++de < ke; )
        if (!ve(ae[de], de, ae))
          return !1;
      return !0;
    }
    function us(ae, ve) {
      for (var de = -1, ke = ae == null ? 0 : ae.length, st = 0, Ot = []; ++de < ke; ) {
        var vr = ae[de];
        ve(vr, de, ae) && (Ot[st++] = vr);
      }
      return Ot;
    }
    function $u(ae, ve) {
      var de = ae == null ? 0 : ae.length;
      return !!de && No(ae, ve, 0) > -1;
    }
    function Af(ae, ve, de) {
      for (var ke = -1, st = ae == null ? 0 : ae.length; ++ke < st; )
        if (de(ve, ae[ke]))
          return !0;
      return !1;
    }
    function Xt(ae, ve) {
      for (var de = -1, ke = ae == null ? 0 : ae.length, st = Array(ke); ++de < ke; )
        st[de] = ve(ae[de], de, ae);
      return st;
    }
    function ls(ae, ve) {
      for (var de = -1, ke = ve.length, st = ae.length; ++de < ke; )
        ae[st + de] = ve[de];
      return ae;
    }
    function Mf(ae, ve, de, ke) {
      var st = -1, Ot = ae == null ? 0 : ae.length;
      for (ke && Ot && (de = ae[++st]); ++st < Ot; )
        de = ve(de, ae[st], st, ae);
      return de;
    }
    function x3(ae, ve, de, ke) {
      var st = ae == null ? 0 : ae.length;
      for (ke && st && (de = ae[--st]); st--; )
        de = ve(de, ae[st], st, ae);
      return de;
    }
    function Df(ae, ve) {
      for (var de = -1, ke = ae == null ? 0 : ae.length; ++de < ke; )
        if (ve(ae[de], de, ae))
          return !0;
      return !1;
    }
    var R3 = Of("length");
    function A3(ae) {
      return ae.split("");
    }
    function M3(ae) {
      return ae.match(zt) || [];
    }
    function Ug(ae, ve, de) {
      var ke;
      return de(ae, function(st, Ot, vr) {
        if (ve(st, Ot, vr))
          return ke = Ot, !1;
      }), ke;
    }
    function Fu(ae, ve, de, ke) {
      for (var st = ae.length, Ot = de + (ke ? 1 : -1); ke ? Ot-- : ++Ot < st; )
        if (ve(ae[Ot], Ot, ae))
          return Ot;
      return -1;
    }
    function No(ae, ve, de) {
      return ve === ve ? j3(ae, ve, de) : Fu(ae, jg, de);
    }
    function D3(ae, ve, de, ke) {
      for (var st = de - 1, Ot = ae.length; ++st < Ot; )
        if (ke(ae[st], ve))
          return st;
      return -1;
    }
    function jg(ae) {
      return ae !== ae;
    }
    function Hg(ae, ve) {
      var de = ae == null ? 0 : ae.length;
      return de ? Tf(ae, ve) / de : K;
    }
    function Of(ae) {
      return function(ve) {
        return ve == null ? r : ve[ae];
      };
    }
    function Pf(ae) {
      return function(ve) {
        return ae == null ? r : ae[ve];
      };
    }
    function qg(ae, ve, de, ke, st) {
      return st(ae, function(Ot, vr, Gt) {
        de = ke ? (ke = !1, Ot) : ve(de, Ot, vr, Gt);
      }), de;
    }
    function O3(ae, ve) {
      var de = ae.length;
      for (ae.sort(ve); de--; )
        ae[de] = ae[de].value;
      return ae;
    }
    function Tf(ae, ve) {
      for (var de, ke = -1, st = ae.length; ++ke < st; ) {
        var Ot = ve(ae[ke]);
        Ot !== r && (de = de === r ? Ot : de + Ot);
      }
      return de;
    }
    function Nf(ae, ve) {
      for (var de = -1, ke = Array(ae); ++de < ae; )
        ke[de] = ve(de);
      return ke;
    }
    function P3(ae, ve) {
      return Xt(ve, function(de) {
        return [de, ae[de]];
      });
    }
    function zg(ae) {
      return ae && ae.slice(0, Gg(ae) + 1).replace(Ye, "");
    }
    function vn(ae) {
      return function(ve) {
        return ae(ve);
      };
    }
    function kf(ae, ve) {
      return Xt(ve, function(de) {
        return ae[de];
      });
    }
    function Wa(ae, ve) {
      return ae.has(ve);
    }
    function Vg(ae, ve) {
      for (var de = -1, ke = ae.length; ++de < ke && No(ve, ae[de], 0) > -1; )
        ;
      return de;
    }
    function Wg(ae, ve) {
      for (var de = ae.length; de-- && No(ve, ae[de], 0) > -1; )
        ;
      return de;
    }
    function T3(ae, ve) {
      for (var de = ae.length, ke = 0; de--; )
        ae[de] === ve && ++ke;
      return ke;
    }
    var N3 = Pf(Y), k3 = Pf(oe);
    function L3(ae) {
      return "\\" + Pe[ae];
    }
    function $3(ae, ve) {
      return ae == null ? r : ae[ve];
    }
    function ko(ae) {
      return ku.test(ae);
    }
    function F3(ae) {
      return Fs.test(ae);
    }
    function B3(ae) {
      for (var ve, de = []; !(ve = ae.next()).done; )
        de.push(ve.value);
      return de;
    }
    function Lf(ae) {
      var ve = -1, de = Array(ae.size);
      return ae.forEach(function(ke, st) {
        de[++ve] = [st, ke];
      }), de;
    }
    function Kg(ae, ve) {
      return function(de) {
        return ae(ve(de));
      };
    }
    function hs(ae, ve) {
      for (var de = -1, ke = ae.length, st = 0, Ot = []; ++de < ke; ) {
        var vr = ae[de];
        (vr === ve || vr === p) && (ae[de] = p, Ot[st++] = de);
      }
      return Ot;
    }
    function Bu(ae) {
      var ve = -1, de = Array(ae.size);
      return ae.forEach(function(ke) {
        de[++ve] = ke;
      }), de;
    }
    function U3(ae) {
      var ve = -1, de = Array(ae.size);
      return ae.forEach(function(ke) {
        de[++ve] = [ke, ke];
      }), de;
    }
    function j3(ae, ve, de) {
      for (var ke = de - 1, st = ae.length; ++ke < st; )
        if (ae[ke] === ve)
          return ke;
      return -1;
    }
    function H3(ae, ve, de) {
      for (var ke = de + 1; ke--; )
        if (ae[ke] === ve)
          return ke;
      return ke;
    }
    function Lo(ae) {
      return ko(ae) ? z3(ae) : R3(ae);
    }
    function ei(ae) {
      return ko(ae) ? V3(ae) : A3(ae);
    }
    function Gg(ae) {
      for (var ve = ae.length; ve-- && Xe.test(ae.charAt(ve)); )
        ;
      return ve;
    }
    var q3 = Pf(be);
    function z3(ae) {
      for (var ve = To.lastIndex = 0; To.test(ae); )
        ++ve;
      return ve;
    }
    function V3(ae) {
      return ae.match(To) || [];
    }
    function W3(ae) {
      return ae.match(Nu) || [];
    }
    var K3 = function ae(ve) {
      ve = ve == null ? Et : $o.defaults(Et.Object(), ve, $o.pick(Et, Lu));
      var de = ve.Array, ke = ve.Date, st = ve.Error, Ot = ve.Function, vr = ve.Math, Gt = ve.Object, $f = ve.RegExp, G3 = ve.String, On = ve.TypeError, Uu = de.prototype, J3 = Ot.prototype, Fo = Gt.prototype, ju = ve["__core-js_shared__"], Hu = J3.toString, Lt = Fo.hasOwnProperty, Q3 = 0, Jg = function() {
        var s = /[^.]+$/.exec(ju && ju.keys && ju.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), qu = Fo.toString, Z3 = Hu.call(Gt), Y3 = Et._, X3 = $f("^" + Hu.call(Lt).replace(Ze, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), zu = rn ? ve.Buffer : r, fs = ve.Symbol, Vu = ve.Uint8Array, Qg = zu ? zu.allocUnsafe : r, Wu = Kg(Gt.getPrototypeOf, Gt), Zg = Gt.create, Yg = Fo.propertyIsEnumerable, Ku = Uu.splice, Xg = fs ? fs.isConcatSpreadable : r, Ka = fs ? fs.iterator : r, Us = fs ? fs.toStringTag : r, Gu = function() {
        try {
          var s = Vs(Gt, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), e6 = ve.clearTimeout !== Et.clearTimeout && ve.clearTimeout, t6 = ke && ke.now !== Et.Date.now && ke.now, r6 = ve.setTimeout !== Et.setTimeout && ve.setTimeout, Ju = vr.ceil, Qu = vr.floor, Ff = Gt.getOwnPropertySymbols, n6 = zu ? zu.isBuffer : r, e1 = ve.isFinite, i6 = Uu.join, s6 = Kg(Gt.keys, Gt), yr = vr.max, $r = vr.min, o6 = ke.now, a6 = ve.parseInt, t1 = vr.random, c6 = Uu.reverse, Bf = Vs(ve, "DataView"), Ga = Vs(ve, "Map"), Uf = Vs(ve, "Promise"), Bo = Vs(ve, "Set"), Ja = Vs(ve, "WeakMap"), Qa = Vs(Gt, "create"), Zu = Ja && new Ja(), Uo = {}, u6 = Ws(Bf), l6 = Ws(Ga), h6 = Ws(Uf), f6 = Ws(Bo), d6 = Ws(Ja), Yu = fs ? fs.prototype : r, Za = Yu ? Yu.valueOf : r, r1 = Yu ? Yu.toString : r;
      function z(s) {
        if (sr(s) && !at(s) && !(s instanceof _t)) {
          if (s instanceof Pn)
            return s;
          if (Lt.call(s, "__wrapped__"))
            return nm(s);
        }
        return new Pn(s);
      }
      var jo = /* @__PURE__ */ function() {
        function s() {
        }
        return function(a) {
          if (!tr(a))
            return {};
          if (Zg)
            return Zg(a);
          s.prototype = a;
          var d = new s();
          return s.prototype = r, d;
        };
      }();
      function Xu() {
      }
      function Pn(s, a) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!a, this.__index__ = 0, this.__values__ = r;
      }
      z.templateSettings = { escape: Qe, evaluate: Nt, interpolate: Je, variable: "", imports: { _: z } }, z.prototype = Xu.prototype, z.prototype.constructor = z, Pn.prototype = jo(Xu.prototype), Pn.prototype.constructor = Pn;
      function _t(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = D, this.__views__ = [];
      }
      function p6() {
        var s = new _t(this.__wrapped__);
        return s.__actions__ = nn(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = nn(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = nn(this.__views__), s;
      }
      function g6() {
        if (this.__filtered__) {
          var s = new _t(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function m6() {
        var s = this.__wrapped__.value(), a = this.__dir__, d = at(s), _ = a < 0, O = d ? s.length : 0, W = A5(0, O, this.__views__), te = W.start, ne = W.end, ce = ne - te, _e = _ ? ne : te - 1, we = this.__iteratees__, Ce = we.length, De = 0, Ue = $r(ce, this.__takeCount__);
        if (!d || !_ && O == ce && Ue == ce)
          return x1(s, this.__actions__);
        var Ve = [];
        e:
          for (; ce-- && De < Ue; ) {
            _e += a;
            for (var dt = -1, We = s[_e]; ++dt < Ce; ) {
              var yt = we[dt], St = yt.iteratee, wn = yt.type, Vr = St(We);
              if (wn == m)
                We = Vr;
              else if (!Vr) {
                if (wn == h)
                  continue e;
                break e;
              }
            }
            Ve[De++] = We;
          }
        return Ve;
      }
      _t.prototype = jo(Xu.prototype), _t.prototype.constructor = _t;
      function js(s) {
        var a = -1, d = s == null ? 0 : s.length;
        for (this.clear(); ++a < d; ) {
          var _ = s[a];
          this.set(_[0], _[1]);
        }
      }
      function v6() {
        this.__data__ = Qa ? Qa(null) : {}, this.size = 0;
      }
      function y6(s) {
        var a = this.has(s) && delete this.__data__[s];
        return this.size -= a ? 1 : 0, a;
      }
      function _6(s) {
        var a = this.__data__;
        if (Qa) {
          var d = a[s];
          return d === l ? r : d;
        }
        return Lt.call(a, s) ? a[s] : r;
      }
      function w6(s) {
        var a = this.__data__;
        return Qa ? a[s] !== r : Lt.call(a, s);
      }
      function b6(s, a) {
        var d = this.__data__;
        return this.size += this.has(s) ? 0 : 1, d[s] = Qa && a === r ? l : a, this;
      }
      js.prototype.clear = v6, js.prototype.delete = y6, js.prototype.get = _6, js.prototype.has = w6, js.prototype.set = b6;
      function ki(s) {
        var a = -1, d = s == null ? 0 : s.length;
        for (this.clear(); ++a < d; ) {
          var _ = s[a];
          this.set(_[0], _[1]);
        }
      }
      function E6() {
        this.__data__ = [], this.size = 0;
      }
      function S6(s) {
        var a = this.__data__, d = el(a, s);
        if (d < 0)
          return !1;
        var _ = a.length - 1;
        return d == _ ? a.pop() : Ku.call(a, d, 1), --this.size, !0;
      }
      function C6(s) {
        var a = this.__data__, d = el(a, s);
        return d < 0 ? r : a[d][1];
      }
      function I6(s) {
        return el(this.__data__, s) > -1;
      }
      function x6(s, a) {
        var d = this.__data__, _ = el(d, s);
        return _ < 0 ? (++this.size, d.push([s, a])) : d[_][1] = a, this;
      }
      ki.prototype.clear = E6, ki.prototype.delete = S6, ki.prototype.get = C6, ki.prototype.has = I6, ki.prototype.set = x6;
      function Li(s) {
        var a = -1, d = s == null ? 0 : s.length;
        for (this.clear(); ++a < d; ) {
          var _ = s[a];
          this.set(_[0], _[1]);
        }
      }
      function R6() {
        this.size = 0, this.__data__ = { hash: new js(), map: new (Ga || ki)(), string: new js() };
      }
      function A6(s) {
        var a = fl(this, s).delete(s);
        return this.size -= a ? 1 : 0, a;
      }
      function M6(s) {
        return fl(this, s).get(s);
      }
      function D6(s) {
        return fl(this, s).has(s);
      }
      function O6(s, a) {
        var d = fl(this, s), _ = d.size;
        return d.set(s, a), this.size += d.size == _ ? 0 : 1, this;
      }
      Li.prototype.clear = R6, Li.prototype.delete = A6, Li.prototype.get = M6, Li.prototype.has = D6, Li.prototype.set = O6;
      function Hs(s) {
        var a = -1, d = s == null ? 0 : s.length;
        for (this.__data__ = new Li(); ++a < d; )
          this.add(s[a]);
      }
      function P6(s) {
        return this.__data__.set(s, l), this;
      }
      function T6(s) {
        return this.__data__.has(s);
      }
      Hs.prototype.add = Hs.prototype.push = P6, Hs.prototype.has = T6;
      function ti(s) {
        var a = this.__data__ = new ki(s);
        this.size = a.size;
      }
      function N6() {
        this.__data__ = new ki(), this.size = 0;
      }
      function k6(s) {
        var a = this.__data__, d = a.delete(s);
        return this.size = a.size, d;
      }
      function L6(s) {
        return this.__data__.get(s);
      }
      function $6(s) {
        return this.__data__.has(s);
      }
      function F6(s, a) {
        var d = this.__data__;
        if (d instanceof ki) {
          var _ = d.__data__;
          if (!Ga || _.length < i - 1)
            return _.push([s, a]), this.size = ++d.size, this;
          d = this.__data__ = new Li(_);
        }
        return d.set(s, a), this.size = d.size, this;
      }
      ti.prototype.clear = N6, ti.prototype.delete = k6, ti.prototype.get = L6, ti.prototype.has = $6, ti.prototype.set = F6;
      function n1(s, a) {
        var d = at(s), _ = !d && Ks(s), O = !d && !_ && vs(s), W = !d && !_ && !O && Vo(s), te = d || _ || O || W, ne = te ? Nf(s.length, G3) : [], ce = ne.length;
        for (var _e in s)
          (a || Lt.call(s, _e)) && !(te && (_e == "length" || O && (_e == "offset" || _e == "parent") || W && (_e == "buffer" || _e == "byteLength" || _e == "byteOffset") || Ui(_e, ce))) && ne.push(_e);
        return ne;
      }
      function i1(s) {
        var a = s.length;
        return a ? s[Zf(0, a - 1)] : r;
      }
      function B6(s, a) {
        return dl(nn(s), qs(a, 0, s.length));
      }
      function U6(s) {
        return dl(nn(s));
      }
      function jf(s, a, d) {
        (d !== r && !ri(s[a], d) || d === r && !(a in s)) && $i(s, a, d);
      }
      function Ya(s, a, d) {
        var _ = s[a];
        (!(Lt.call(s, a) && ri(_, d)) || d === r && !(a in s)) && $i(s, a, d);
      }
      function el(s, a) {
        for (var d = s.length; d--; )
          if (ri(s[d][0], a))
            return d;
        return -1;
      }
      function j6(s, a, d, _) {
        return ds(s, function(O, W, te) {
          a(_, O, d(O), te);
        }), _;
      }
      function s1(s, a) {
        return s && yi(a, Er(a), s);
      }
      function H6(s, a) {
        return s && yi(a, on(a), s);
      }
      function $i(s, a, d) {
        a == "__proto__" && Gu ? Gu(s, a, { configurable: !0, enumerable: !0, value: d, writable: !0 }) : s[a] = d;
      }
      function Hf(s, a) {
        for (var d = -1, _ = a.length, O = de(_), W = s == null; ++d < _; )
          O[d] = W ? r : Ed(s, a[d]);
        return O;
      }
      function qs(s, a, d) {
        return s === s && (d !== r && (s = s <= d ? s : d), a !== r && (s = s >= a ? s : a)), s;
      }
      function Tn(s, a, d, _, O, W) {
        var te, ne = a & g, ce = a & y, _e = a & C;
        if (d && (te = O ? d(s, _, O, W) : d(s)), te !== r)
          return te;
        if (!tr(s))
          return s;
        var we = at(s);
        if (we) {
          if (te = D5(s), !ne)
            return nn(s, te);
        } else {
          var Ce = Fr(s), De = Ce == F || Ce == se;
          if (vs(s))
            return M1(s, ne);
          if (Ce == b || Ce == pe || De && !O) {
            if (te = ce || De ? {} : G1(s), !ne)
              return ce ? _5(s, H6(te, s)) : y5(s, s1(te, s));
          } else {
            if (!Ut[Ce])
              return O ? s : {};
            te = O5(s, Ce, ne);
          }
        }
        W || (W = new ti());
        var Ue = W.get(s);
        if (Ue)
          return Ue;
        W.set(s, te), Sm(s) ? s.forEach(function(We) {
          te.add(Tn(We, a, d, We, s, W));
        }) : bm(s) && s.forEach(function(We, yt) {
          te.set(yt, Tn(We, a, d, yt, s, W));
        });
        var Ve = _e ? ce ? cd : ad : ce ? on : Er, dt = we ? r : Ve(s);
        return Dn(dt || s, function(We, yt) {
          dt && (yt = We, We = s[yt]), Ya(te, yt, Tn(We, a, d, yt, s, W));
        }), te;
      }
      function q6(s) {
        var a = Er(s);
        return function(d) {
          return o1(d, s, a);
        };
      }
      function o1(s, a, d) {
        var _ = d.length;
        if (s == null)
          return !_;
        for (s = Gt(s); _--; ) {
          var O = d[_], W = a[O], te = s[O];
          if (te === r && !(O in s) || !W(te))
            return !1;
        }
        return !0;
      }
      function a1(s, a, d) {
        if (typeof s != "function")
          throw new On(c);
        return sc(function() {
          s.apply(r, d);
        }, a);
      }
      function Xa(s, a, d, _) {
        var O = -1, W = $u, te = !0, ne = s.length, ce = [], _e = a.length;
        if (!ne)
          return ce;
        d && (a = Xt(a, vn(d))), _ ? (W = Af, te = !1) : a.length >= i && (W = Wa, te = !1, a = new Hs(a));
        e:
          for (; ++O < ne; ) {
            var we = s[O], Ce = d == null ? we : d(we);
            if (we = _ || we !== 0 ? we : 0, te && Ce === Ce) {
              for (var De = _e; De--; )
                if (a[De] === Ce)
                  continue e;
              ce.push(we);
            } else
              W(a, Ce, _) || ce.push(we);
          }
        return ce;
      }
      var ds = N1(vi), c1 = N1(zf, !0);
      function z6(s, a) {
        var d = !0;
        return ds(s, function(_, O, W) {
          return d = !!a(_, O, W), d;
        }), d;
      }
      function tl(s, a, d) {
        for (var _ = -1, O = s.length; ++_ < O; ) {
          var W = s[_], te = a(W);
          if (te != null && (ne === r ? te === te && !_n(te) : d(te, ne)))
            var ne = te, ce = W;
        }
        return ce;
      }
      function V6(s, a, d, _) {
        var O = s.length;
        for (d = lt(d), d < 0 && (d = -d > O ? 0 : O + d), _ = _ === r || _ > O ? O : lt(_), _ < 0 && (_ += O), _ = d > _ ? 0 : Im(_); d < _; )
          s[d++] = a;
        return s;
      }
      function u1(s, a) {
        var d = [];
        return ds(s, function(_, O, W) {
          a(_, O, W) && d.push(_);
        }), d;
      }
      function Mr(s, a, d, _, O) {
        var W = -1, te = s.length;
        for (d || (d = T5), O || (O = []); ++W < te; ) {
          var ne = s[W];
          a > 0 && d(ne) ? a > 1 ? Mr(ne, a - 1, d, _, O) : ls(O, ne) : _ || (O[O.length] = ne);
        }
        return O;
      }
      var qf = k1(), l1 = k1(!0);
      function vi(s, a) {
        return s && qf(s, a, Er);
      }
      function zf(s, a) {
        return s && l1(s, a, Er);
      }
      function rl(s, a) {
        return us(a, function(d) {
          return ji(s[d]);
        });
      }
      function zs(s, a) {
        a = gs(a, s);
        for (var d = 0, _ = a.length; s != null && d < _; )
          s = s[_i(a[d++])];
        return d && d == _ ? s : r;
      }
      function h1(s, a, d) {
        var _ = a(s);
        return at(s) ? _ : ls(_, d(s));
      }
      function qr(s) {
        return s == null ? s === r ? Ie : j : Us && Us in Gt(s) ? R5(s) : U5(s);
      }
      function Vf(s, a) {
        return s > a;
      }
      function W6(s, a) {
        return s != null && Lt.call(s, a);
      }
      function K6(s, a) {
        return s != null && a in Gt(s);
      }
      function G6(s, a, d) {
        return s >= $r(a, d) && s < yr(a, d);
      }
      function Wf(s, a, d) {
        for (var _ = d ? Af : $u, O = s[0].length, W = s.length, te = W, ne = de(W), ce = 1 / 0, _e = []; te--; ) {
          var we = s[te];
          te && a && (we = Xt(we, vn(a))), ce = $r(we.length, ce), ne[te] = !d && (a || O >= 120 && we.length >= 120) ? new Hs(te && we) : r;
        }
        we = s[0];
        var Ce = -1, De = ne[0];
        e:
          for (; ++Ce < O && _e.length < ce; ) {
            var Ue = we[Ce], Ve = a ? a(Ue) : Ue;
            if (Ue = d || Ue !== 0 ? Ue : 0, !(De ? Wa(De, Ve) : _(_e, Ve, d))) {
              for (te = W; --te; ) {
                var dt = ne[te];
                if (!(dt ? Wa(dt, Ve) : _(s[te], Ve, d)))
                  continue e;
              }
              De && De.push(Ve), _e.push(Ue);
            }
          }
        return _e;
      }
      function J6(s, a, d, _) {
        return vi(s, function(O, W, te) {
          a(_, d(O), W, te);
        }), _;
      }
      function ec(s, a, d) {
        a = gs(a, s), s = Y1(s, a);
        var _ = s == null ? s : s[_i(kn(a))];
        return _ == null ? r : br(_, s, d);
      }
      function f1(s) {
        return sr(s) && qr(s) == pe;
      }
      function Q6(s) {
        return sr(s) && qr(s) == Se;
      }
      function Z6(s) {
        return sr(s) && qr(s) == X;
      }
      function tc(s, a, d, _, O) {
        return s === a ? !0 : s == null || a == null || !sr(s) && !sr(a) ? s !== s && a !== a : Y6(s, a, d, _, tc, O);
      }
      function Y6(s, a, d, _, O, W) {
        var te = at(s), ne = at(a), ce = te ? ee : Fr(s), _e = ne ? ee : Fr(a);
        ce = ce == pe ? b : ce, _e = _e == pe ? b : _e;
        var we = ce == b, Ce = _e == b, De = ce == _e;
        if (De && vs(s)) {
          if (!vs(a))
            return !1;
          te = !0, we = !1;
        }
        if (De && !we)
          return W || (W = new ti()), te || Vo(s) ? V1(s, a, d, _, O, W) : I5(s, a, ce, d, _, O, W);
        if (!(d & R)) {
          var Ue = we && Lt.call(s, "__wrapped__"), Ve = Ce && Lt.call(a, "__wrapped__");
          if (Ue || Ve) {
            var dt = Ue ? s.value() : s, We = Ve ? a.value() : a;
            return W || (W = new ti()), O(dt, We, d, _, W);
          }
        }
        return De ? (W || (W = new ti()), x5(s, a, d, _, O, W)) : !1;
      }
      function X6(s) {
        return sr(s) && Fr(s) == fe;
      }
      function Kf(s, a, d, _) {
        var O = d.length, W = O, te = !_;
        if (s == null)
          return !W;
        for (s = Gt(s); O--; ) {
          var ne = d[O];
          if (te && ne[2] ? ne[1] !== s[ne[0]] : !(ne[0] in s))
            return !1;
        }
        for (; ++O < W; ) {
          ne = d[O];
          var ce = ne[0], _e = s[ce], we = ne[1];
          if (te && ne[2]) {
            if (_e === r && !(ce in s))
              return !1;
          } else {
            var Ce = new ti();
            if (_)
              var De = _(_e, we, ce, s, a, Ce);
            if (!(De === r ? tc(we, _e, R | J, _, Ce) : De))
              return !1;
          }
        }
        return !0;
      }
      function d1(s) {
        if (!tr(s) || k5(s))
          return !1;
        var a = ji(s) ? X3 : Kn;
        return a.test(Ws(s));
      }
      function e5(s) {
        return sr(s) && qr(s) == re;
      }
      function t5(s) {
        return sr(s) && Fr(s) == ue;
      }
      function r5(s) {
        return sr(s) && _l(s.length) && !!Vt[qr(s)];
      }
      function p1(s) {
        return typeof s == "function" ? s : s == null ? an : typeof s == "object" ? at(s) ? v1(s[0], s[1]) : m1(s) : Lm(s);
      }
      function Gf(s) {
        if (!ic(s))
          return s6(s);
        var a = [];
        for (var d in Gt(s))
          Lt.call(s, d) && d != "constructor" && a.push(d);
        return a;
      }
      function n5(s) {
        if (!tr(s))
          return B5(s);
        var a = ic(s), d = [];
        for (var _ in s)
          _ == "constructor" && (a || !Lt.call(s, _)) || d.push(_);
        return d;
      }
      function Jf(s, a) {
        return s < a;
      }
      function g1(s, a) {
        var d = -1, _ = sn(s) ? de(s.length) : [];
        return ds(s, function(O, W, te) {
          _[++d] = a(O, W, te);
        }), _;
      }
      function m1(s) {
        var a = ld(s);
        return a.length == 1 && a[0][2] ? Q1(a[0][0], a[0][1]) : function(d) {
          return d === s || Kf(d, s, a);
        };
      }
      function v1(s, a) {
        return fd(s) && J1(a) ? Q1(_i(s), a) : function(d) {
          var _ = Ed(d, s);
          return _ === r && _ === a ? Sd(d, s) : tc(a, _, R | J);
        };
      }
      function nl(s, a, d, _, O) {
        s !== a && qf(a, function(W, te) {
          if (O || (O = new ti()), tr(W))
            i5(s, a, te, d, nl, _, O);
          else {
            var ne = _ ? _(pd(s, te), W, te + "", s, a, O) : r;
            ne === r && (ne = W), jf(s, te, ne);
          }
        }, on);
      }
      function i5(s, a, d, _, O, W, te) {
        var ne = pd(s, d), ce = pd(a, d), _e = te.get(ce);
        if (_e) {
          jf(s, d, _e);
          return;
        }
        var we = W ? W(ne, ce, d + "", s, a, te) : r, Ce = we === r;
        if (Ce) {
          var De = at(ce), Ue = !De && vs(ce), Ve = !De && !Ue && Vo(ce);
          we = ce, De || Ue || Ve ? at(ne) ? we = ne : ur(ne) ? we = nn(ne) : Ue ? (Ce = !1, we = M1(ce, !0)) : Ve ? (Ce = !1, we = D1(ce, !0)) : we = [] : oc(ce) || Ks(ce) ? (we = ne, Ks(ne) ? we = xm(ne) : (!tr(ne) || ji(ne)) && (we = G1(ce))) : Ce = !1;
        }
        Ce && (te.set(ce, we), O(we, ce, _, W, te), te.delete(ce)), jf(s, d, we);
      }
      function y1(s, a) {
        var d = s.length;
        if (d)
          return a += a < 0 ? d : 0, Ui(a, d) ? s[a] : r;
      }
      function _1(s, a, d) {
        a.length ? a = Xt(a, function(W) {
          return at(W) ? function(te) {
            return zs(te, W.length === 1 ? W[0] : W);
          } : W;
        }) : a = [an];
        var _ = -1;
        a = Xt(a, vn(ze()));
        var O = g1(s, function(W, te, ne) {
          var ce = Xt(a, function(_e) {
            return _e(W);
          });
          return { criteria: ce, index: ++_, value: W };
        });
        return O3(O, function(W, te) {
          return v5(W, te, d);
        });
      }
      function s5(s, a) {
        return w1(s, a, function(d, _) {
          return Sd(s, _);
        });
      }
      function w1(s, a, d) {
        for (var _ = -1, O = a.length, W = {}; ++_ < O; ) {
          var te = a[_], ne = zs(s, te);
          d(ne, te) && rc(W, gs(te, s), ne);
        }
        return W;
      }
      function o5(s) {
        return function(a) {
          return zs(a, s);
        };
      }
      function Qf(s, a, d, _) {
        var O = _ ? D3 : No, W = -1, te = a.length, ne = s;
        for (s === a && (a = nn(a)), d && (ne = Xt(s, vn(d))); ++W < te; )
          for (var ce = 0, _e = a[W], we = d ? d(_e) : _e; (ce = O(ne, we, ce, _)) > -1; )
            ne !== s && Ku.call(ne, ce, 1), Ku.call(s, ce, 1);
        return s;
      }
      function b1(s, a) {
        for (var d = s ? a.length : 0, _ = d - 1; d--; ) {
          var O = a[d];
          if (d == _ || O !== W) {
            var W = O;
            Ui(O) ? Ku.call(s, O, 1) : ed(s, O);
          }
        }
        return s;
      }
      function Zf(s, a) {
        return s + Qu(t1() * (a - s + 1));
      }
      function a5(s, a, d, _) {
        for (var O = -1, W = yr(Ju((a - s) / (d || 1)), 0), te = de(W); W--; )
          te[_ ? W : ++O] = s, s += d;
        return te;
      }
      function Yf(s, a) {
        var d = "";
        if (!s || a < 1 || a > A)
          return d;
        do
          a % 2 && (d += s), a = Qu(a / 2), a && (s += s);
        while (a);
        return d;
      }
      function gt(s, a) {
        return gd(Z1(s, a, an), s + "");
      }
      function c5(s) {
        return i1(Wo(s));
      }
      function u5(s, a) {
        var d = Wo(s);
        return dl(d, qs(a, 0, d.length));
      }
      function rc(s, a, d, _) {
        if (!tr(s))
          return s;
        a = gs(a, s);
        for (var O = -1, W = a.length, te = W - 1, ne = s; ne != null && ++O < W; ) {
          var ce = _i(a[O]), _e = d;
          if (ce === "__proto__" || ce === "constructor" || ce === "prototype")
            return s;
          if (O != te) {
            var we = ne[ce];
            _e = _ ? _(we, ce, ne) : r, _e === r && (_e = tr(we) ? we : Ui(a[O + 1]) ? [] : {});
          }
          Ya(ne, ce, _e), ne = ne[ce];
        }
        return s;
      }
      var E1 = Zu ? function(s, a) {
        return Zu.set(s, a), s;
      } : an, l5 = Gu ? function(s, a) {
        return Gu(s, "toString", { configurable: !0, enumerable: !1, value: Id(a), writable: !0 });
      } : an;
      function h5(s) {
        return dl(Wo(s));
      }
      function Nn(s, a, d) {
        var _ = -1, O = s.length;
        a < 0 && (a = -a > O ? 0 : O + a), d = d > O ? O : d, d < 0 && (d += O), O = a > d ? 0 : d - a >>> 0, a >>>= 0;
        for (var W = de(O); ++_ < O; )
          W[_] = s[_ + a];
        return W;
      }
      function f5(s, a) {
        var d;
        return ds(s, function(_, O, W) {
          return d = a(_, O, W), !d;
        }), !!d;
      }
      function il(s, a, d) {
        var _ = 0, O = s == null ? _ : s.length;
        if (typeof a == "number" && a === a && O <= U) {
          for (; _ < O; ) {
            var W = _ + O >>> 1, te = s[W];
            te !== null && !_n(te) && (d ? te <= a : te < a) ? _ = W + 1 : O = W;
          }
          return O;
        }
        return Xf(s, a, an, d);
      }
      function Xf(s, a, d, _) {
        var O = 0, W = s == null ? 0 : s.length;
        if (W === 0)
          return 0;
        a = d(a);
        for (var te = a !== a, ne = a === null, ce = _n(a), _e = a === r; O < W; ) {
          var we = Qu((O + W) / 2), Ce = d(s[we]), De = Ce !== r, Ue = Ce === null, Ve = Ce === Ce, dt = _n(Ce);
          if (te)
            var We = _ || Ve;
          else
            _e ? We = Ve && (_ || De) : ne ? We = Ve && De && (_ || !Ue) : ce ? We = Ve && De && !Ue && (_ || !dt) : Ue || dt ? We = !1 : We = _ ? Ce <= a : Ce < a;
          We ? O = we + 1 : W = we;
        }
        return $r(W, w);
      }
      function S1(s, a) {
        for (var d = -1, _ = s.length, O = 0, W = []; ++d < _; ) {
          var te = s[d], ne = a ? a(te) : te;
          if (!d || !ri(ne, ce)) {
            var ce = ne;
            W[O++] = te === 0 ? 0 : te;
          }
        }
        return W;
      }
      function C1(s) {
        return typeof s == "number" ? s : _n(s) ? K : +s;
      }
      function yn(s) {
        if (typeof s == "string")
          return s;
        if (at(s))
          return Xt(s, yn) + "";
        if (_n(s))
          return r1 ? r1.call(s) : "";
        var a = s + "";
        return a == "0" && 1 / s == -M ? "-0" : a;
      }
      function ps(s, a, d) {
        var _ = -1, O = $u, W = s.length, te = !0, ne = [], ce = ne;
        if (d)
          te = !1, O = Af;
        else if (W >= i) {
          var _e = a ? null : S5(s);
          if (_e)
            return Bu(_e);
          te = !1, O = Wa, ce = new Hs();
        } else
          ce = a ? [] : ne;
        e:
          for (; ++_ < W; ) {
            var we = s[_], Ce = a ? a(we) : we;
            if (we = d || we !== 0 ? we : 0, te && Ce === Ce) {
              for (var De = ce.length; De--; )
                if (ce[De] === Ce)
                  continue e;
              a && ce.push(Ce), ne.push(we);
            } else
              O(ce, Ce, d) || (ce !== ne && ce.push(Ce), ne.push(we));
          }
        return ne;
      }
      function ed(s, a) {
        return a = gs(a, s), s = Y1(s, a), s == null || delete s[_i(kn(a))];
      }
      function I1(s, a, d, _) {
        return rc(s, a, d(zs(s, a)), _);
      }
      function sl(s, a, d, _) {
        for (var O = s.length, W = _ ? O : -1; (_ ? W-- : ++W < O) && a(s[W], W, s); )
          ;
        return d ? Nn(s, _ ? 0 : W, _ ? W + 1 : O) : Nn(s, _ ? W + 1 : 0, _ ? O : W);
      }
      function x1(s, a) {
        var d = s;
        return d instanceof _t && (d = d.value()), Mf(a, function(_, O) {
          return O.func.apply(O.thisArg, ls([_], O.args));
        }, d);
      }
      function td(s, a, d) {
        var _ = s.length;
        if (_ < 2)
          return _ ? ps(s[0]) : [];
        for (var O = -1, W = de(_); ++O < _; )
          for (var te = s[O], ne = -1; ++ne < _; )
            ne != O && (W[O] = Xa(W[O] || te, s[ne], a, d));
        return ps(Mr(W, 1), a, d);
      }
      function R1(s, a, d) {
        for (var _ = -1, O = s.length, W = a.length, te = {}; ++_ < O; ) {
          var ne = _ < W ? a[_] : r;
          d(te, s[_], ne);
        }
        return te;
      }
      function rd(s) {
        return ur(s) ? s : [];
      }
      function nd(s) {
        return typeof s == "function" ? s : an;
      }
      function gs(s, a) {
        return at(s) ? s : fd(s, a) ? [s] : rm(Pt(s));
      }
      var d5 = gt;
      function ms(s, a, d) {
        var _ = s.length;
        return d = d === r ? _ : d, !a && d >= _ ? s : Nn(s, a, d);
      }
      var A1 = e6 || function(s) {
        return Et.clearTimeout(s);
      };
      function M1(s, a) {
        if (a)
          return s.slice();
        var d = s.length, _ = Qg ? Qg(d) : new s.constructor(d);
        return s.copy(_), _;
      }
      function id(s) {
        var a = new s.constructor(s.byteLength);
        return new Vu(a).set(new Vu(s)), a;
      }
      function p5(s, a) {
        var d = a ? id(s.buffer) : s.buffer;
        return new s.constructor(d, s.byteOffset, s.byteLength);
      }
      function g5(s) {
        var a = new s.constructor(s.source, vt.exec(s));
        return a.lastIndex = s.lastIndex, a;
      }
      function m5(s) {
        return Za ? Gt(Za.call(s)) : {};
      }
      function D1(s, a) {
        var d = a ? id(s.buffer) : s.buffer;
        return new s.constructor(d, s.byteOffset, s.length);
      }
      function O1(s, a) {
        if (s !== a) {
          var d = s !== r, _ = s === null, O = s === s, W = _n(s), te = a !== r, ne = a === null, ce = a === a, _e = _n(a);
          if (!ne && !_e && !W && s > a || W && te && ce && !ne && !_e || _ && te && ce || !d && ce || !O)
            return 1;
          if (!_ && !W && !_e && s < a || _e && d && O && !_ && !W || ne && d && O || !te && O || !ce)
            return -1;
        }
        return 0;
      }
      function v5(s, a, d) {
        for (var _ = -1, O = s.criteria, W = a.criteria, te = O.length, ne = d.length; ++_ < te; ) {
          var ce = O1(O[_], W[_]);
          if (ce) {
            if (_ >= ne)
              return ce;
            var _e = d[_];
            return ce * (_e == "desc" ? -1 : 1);
          }
        }
        return s.index - a.index;
      }
      function P1(s, a, d, _) {
        for (var O = -1, W = s.length, te = d.length, ne = -1, ce = a.length, _e = yr(W - te, 0), we = de(ce + _e), Ce = !_; ++ne < ce; )
          we[ne] = a[ne];
        for (; ++O < te; )
          (Ce || O < W) && (we[d[O]] = s[O]);
        for (; _e--; )
          we[ne++] = s[O++];
        return we;
      }
      function T1(s, a, d, _) {
        for (var O = -1, W = s.length, te = -1, ne = d.length, ce = -1, _e = a.length, we = yr(W - ne, 0), Ce = de(we + _e), De = !_; ++O < we; )
          Ce[O] = s[O];
        for (var Ue = O; ++ce < _e; )
          Ce[Ue + ce] = a[ce];
        for (; ++te < ne; )
          (De || O < W) && (Ce[Ue + d[te]] = s[O++]);
        return Ce;
      }
      function nn(s, a) {
        var d = -1, _ = s.length;
        for (a || (a = de(_)); ++d < _; )
          a[d] = s[d];
        return a;
      }
      function yi(s, a, d, _) {
        var O = !d;
        d || (d = {});
        for (var W = -1, te = a.length; ++W < te; ) {
          var ne = a[W], ce = _ ? _(d[ne], s[ne], ne, d, s) : r;
          ce === r && (ce = s[ne]), O ? $i(d, ne, ce) : Ya(d, ne, ce);
        }
        return d;
      }
      function y5(s, a) {
        return yi(s, hd(s), a);
      }
      function _5(s, a) {
        return yi(s, W1(s), a);
      }
      function ol(s, a) {
        return function(d, _) {
          var O = at(d) ? C3 : j6, W = a ? a() : {};
          return O(d, s, ze(_, 2), W);
        };
      }
      function Ho(s) {
        return gt(function(a, d) {
          var _ = -1, O = d.length, W = O > 1 ? d[O - 1] : r, te = O > 2 ? d[2] : r;
          for (W = s.length > 3 && typeof W == "function" ? (O--, W) : r, te && zr(d[0], d[1], te) && (W = O < 3 ? r : W, O = 1), a = Gt(a); ++_ < O; ) {
            var ne = d[_];
            ne && s(a, ne, _, W);
          }
          return a;
        });
      }
      function N1(s, a) {
        return function(d, _) {
          if (d == null)
            return d;
          if (!sn(d))
            return s(d, _);
          for (var O = d.length, W = a ? O : -1, te = Gt(d); (a ? W-- : ++W < O) && _(te[W], W, te) !== !1; )
            ;
          return d;
        };
      }
      function k1(s) {
        return function(a, d, _) {
          for (var O = -1, W = Gt(a), te = _(a), ne = te.length; ne--; ) {
            var ce = te[s ? ne : ++O];
            if (d(W[ce], ce, W) === !1)
              break;
          }
          return a;
        };
      }
      function w5(s, a, d) {
        var _ = a & G, O = nc(s);
        function W() {
          var te = this && this !== Et && this instanceof W ? O : s;
          return te.apply(_ ? d : this, arguments);
        }
        return W;
      }
      function L1(s) {
        return function(a) {
          a = Pt(a);
          var d = ko(a) ? ei(a) : r, _ = d ? d[0] : a.charAt(0), O = d ? ms(d, 1).join("") : a.slice(1);
          return _[s]() + O;
        };
      }
      function qo(s) {
        return function(a) {
          return Mf(Nm(Tm(a).replace(za, "")), s, "");
        };
      }
      function nc(s) {
        return function() {
          var a = arguments;
          switch (a.length) {
            case 0:
              return new s();
            case 1:
              return new s(a[0]);
            case 2:
              return new s(a[0], a[1]);
            case 3:
              return new s(a[0], a[1], a[2]);
            case 4:
              return new s(a[0], a[1], a[2], a[3]);
            case 5:
              return new s(a[0], a[1], a[2], a[3], a[4]);
            case 6:
              return new s(a[0], a[1], a[2], a[3], a[4], a[5]);
            case 7:
              return new s(a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
          }
          var d = jo(s.prototype), _ = s.apply(d, a);
          return tr(_) ? _ : d;
        };
      }
      function b5(s, a, d) {
        var _ = nc(s);
        function O() {
          for (var W = arguments.length, te = de(W), ne = W, ce = zo(O); ne--; )
            te[ne] = arguments[ne];
          var _e = W < 3 && te[0] !== ce && te[W - 1] !== ce ? [] : hs(te, ce);
          if (W -= _e.length, W < d)
            return j1(s, a, al, O.placeholder, r, te, _e, r, r, d - W);
          var we = this && this !== Et && this instanceof O ? _ : s;
          return br(we, this, te);
        }
        return O;
      }
      function $1(s) {
        return function(a, d, _) {
          var O = Gt(a);
          if (!sn(a)) {
            var W = ze(d, 3);
            a = Er(a), d = function(ne) {
              return W(O[ne], ne, O);
            };
          }
          var te = s(a, d, _);
          return te > -1 ? O[W ? a[te] : te] : r;
        };
      }
      function F1(s) {
        return Bi(function(a) {
          var d = a.length, _ = d, O = Pn.prototype.thru;
          for (s && a.reverse(); _--; ) {
            var W = a[_];
            if (typeof W != "function")
              throw new On(c);
            if (O && !te && hl(W) == "wrapper")
              var te = new Pn([], !0);
          }
          for (_ = te ? _ : d; ++_ < d; ) {
            W = a[_];
            var ne = hl(W), ce = ne == "wrapper" ? ud(W) : r;
            ce && dd(ce[0]) && ce[1] == (v | q | L | N) && !ce[4].length && ce[9] == 1 ? te = te[hl(ce[0])].apply(te, ce[3]) : te = W.length == 1 && dd(W) ? te[ne]() : te.thru(W);
          }
          return function() {
            var _e = arguments, we = _e[0];
            if (te && _e.length == 1 && at(we))
              return te.plant(we).value();
            for (var Ce = 0, De = d ? a[Ce].apply(this, _e) : we; ++Ce < d; )
              De = a[Ce].call(this, De);
            return De;
          };
        });
      }
      function al(s, a, d, _, O, W, te, ne, ce, _e) {
        var we = a & v, Ce = a & G, De = a & H, Ue = a & (q | B), Ve = a & ie, dt = De ? r : nc(s);
        function We() {
          for (var yt = arguments.length, St = de(yt), wn = yt; wn--; )
            St[wn] = arguments[wn];
          if (Ue)
            var Vr = zo(We), bn = T3(St, Vr);
          if (_ && (St = P1(St, _, O, Ue)), W && (St = T1(St, W, te, Ue)), yt -= bn, Ue && yt < _e) {
            var lr = hs(St, Vr);
            return j1(s, a, al, We.placeholder, d, St, lr, ne, ce, _e - yt);
          }
          var ni = Ce ? d : this, qi = De ? ni[s] : s;
          return yt = St.length, ne ? St = j5(St, ne) : Ve && yt > 1 && St.reverse(), we && ce < yt && (St.length = ce), this && this !== Et && this instanceof We && (qi = dt || nc(qi)), qi.apply(ni, St);
        }
        return We;
      }
      function B1(s, a) {
        return function(d, _) {
          return J6(d, s, a(_), {});
        };
      }
      function cl(s, a) {
        return function(d, _) {
          var O;
          if (d === r && _ === r)
            return a;
          if (d !== r && (O = d), _ !== r) {
            if (O === r)
              return _;
            typeof d == "string" || typeof _ == "string" ? (d = yn(d), _ = yn(_)) : (d = C1(d), _ = C1(_)), O = s(d, _);
          }
          return O;
        };
      }
      function sd(s) {
        return Bi(function(a) {
          return a = Xt(a, vn(ze())), gt(function(d) {
            var _ = this;
            return s(a, function(O) {
              return br(O, _, d);
            });
          });
        });
      }
      function ul(s, a) {
        a = a === r ? " " : yn(a);
        var d = a.length;
        if (d < 2)
          return d ? Yf(a, s) : a;
        var _ = Yf(a, Ju(s / Lo(a)));
        return ko(a) ? ms(ei(_), 0, s).join("") : _.slice(0, s);
      }
      function E5(s, a, d, _) {
        var O = a & G, W = nc(s);
        function te() {
          for (var ne = -1, ce = arguments.length, _e = -1, we = _.length, Ce = de(we + ce), De = this && this !== Et && this instanceof te ? W : s; ++_e < we; )
            Ce[_e] = _[_e];
          for (; ce--; )
            Ce[_e++] = arguments[++ne];
          return br(De, O ? d : this, Ce);
        }
        return te;
      }
      function U1(s) {
        return function(a, d, _) {
          return _ && typeof _ != "number" && zr(a, d, _) && (d = _ = r), a = Hi(a), d === r ? (d = a, a = 0) : d = Hi(d), _ = _ === r ? a < d ? 1 : -1 : Hi(_), a5(a, d, _, s);
        };
      }
      function ll(s) {
        return function(a, d) {
          return typeof a == "string" && typeof d == "string" || (a = Ln(a), d = Ln(d)), s(a, d);
        };
      }
      function j1(s, a, d, _, O, W, te, ne, ce, _e) {
        var we = a & q, Ce = we ? te : r, De = we ? r : te, Ue = we ? W : r, Ve = we ? r : W;
        a |= we ? L : P, a &= ~(we ? P : L), a & T || (a &= ~(G | H));
        var dt = [s, a, O, Ue, Ce, Ve, De, ne, ce, _e], We = d.apply(r, dt);
        return dd(s) && X1(We, dt), We.placeholder = _, em(We, s, a);
      }
      function od(s) {
        var a = vr[s];
        return function(d, _) {
          if (d = Ln(d), _ = _ == null ? 0 : $r(lt(_), 292), _ && e1(d)) {
            var O = (Pt(d) + "e").split("e"), W = a(O[0] + "e" + (+O[1] + _));
            return O = (Pt(W) + "e").split("e"), +(O[0] + "e" + (+O[1] - _));
          }
          return a(d);
        };
      }
      var S5 = Bo && 1 / Bu(new Bo([, -0]))[1] == M ? function(s) {
        return new Bo(s);
      } : Ad;
      function H1(s) {
        return function(a) {
          var d = Fr(a);
          return d == fe ? Lf(a) : d == ue ? U3(a) : P3(a, s(a));
        };
      }
      function Fi(s, a, d, _, O, W, te, ne) {
        var ce = a & H;
        if (!ce && typeof s != "function")
          throw new On(c);
        var _e = _ ? _.length : 0;
        if (_e || (a &= ~(L | P), _ = O = r), te = te === r ? te : yr(lt(te), 0), ne = ne === r ? ne : lt(ne), _e -= O ? O.length : 0, a & P) {
          var we = _, Ce = O;
          _ = O = r;
        }
        var De = ce ? r : ud(s), Ue = [s, a, d, _, O, we, Ce, W, te, ne];
        if (De && F5(Ue, De), s = Ue[0], a = Ue[1], d = Ue[2], _ = Ue[3], O = Ue[4], ne = Ue[9] = Ue[9] === r ? ce ? 0 : s.length : yr(Ue[9] - _e, 0), !ne && a & (q | B) && (a &= ~(q | B)), !a || a == G)
          var Ve = w5(s, a, d);
        else
          a == q || a == B ? Ve = b5(s, a, ne) : (a == L || a == (G | L)) && !O.length ? Ve = E5(s, a, d, _) : Ve = al.apply(r, Ue);
        var dt = De ? E1 : X1;
        return em(dt(Ve, Ue), s, a);
      }
      function q1(s, a, d, _) {
        return s === r || ri(s, Fo[d]) && !Lt.call(_, d) ? a : s;
      }
      function z1(s, a, d, _, O, W) {
        return tr(s) && tr(a) && (W.set(a, s), nl(s, a, r, z1, W), W.delete(a)), s;
      }
      function C5(s) {
        return oc(s) ? r : s;
      }
      function V1(s, a, d, _, O, W) {
        var te = d & R, ne = s.length, ce = a.length;
        if (ne != ce && !(te && ce > ne))
          return !1;
        var _e = W.get(s), we = W.get(a);
        if (_e && we)
          return _e == a && we == s;
        var Ce = -1, De = !0, Ue = d & J ? new Hs() : r;
        for (W.set(s, a), W.set(a, s); ++Ce < ne; ) {
          var Ve = s[Ce], dt = a[Ce];
          if (_)
            var We = te ? _(dt, Ve, Ce, a, s, W) : _(Ve, dt, Ce, s, a, W);
          if (We !== r) {
            if (We)
              continue;
            De = !1;
            break;
          }
          if (Ue) {
            if (!Df(a, function(yt, St) {
              if (!Wa(Ue, St) && (Ve === yt || O(Ve, yt, d, _, W)))
                return Ue.push(St);
            })) {
              De = !1;
              break;
            }
          } else if (!(Ve === dt || O(Ve, dt, d, _, W))) {
            De = !1;
            break;
          }
        }
        return W.delete(s), W.delete(a), De;
      }
      function I5(s, a, d, _, O, W, te) {
        switch (d) {
          case Le:
            if (s.byteLength != a.byteLength || s.byteOffset != a.byteOffset)
              return !1;
            s = s.buffer, a = a.buffer;
          case Se:
            return !(s.byteLength != a.byteLength || !W(new Vu(s), new Vu(a)));
          case Q:
          case X:
          case Re:
            return ri(+s, +a);
          case I:
            return s.name == a.name && s.message == a.message;
          case re:
          case ge:
            return s == a + "";
          case fe:
            var ne = Lf;
          case ue:
            var ce = _ & R;
            if (ne || (ne = Bu), s.size != a.size && !ce)
              return !1;
            var _e = te.get(s);
            if (_e)
              return _e == a;
            _ |= J, te.set(s, a);
            var we = V1(ne(s), ne(a), _, O, W, te);
            return te.delete(s), we;
          case Ee:
            if (Za)
              return Za.call(s) == Za.call(a);
        }
        return !1;
      }
      function x5(s, a, d, _, O, W) {
        var te = d & R, ne = ad(s), ce = ne.length, _e = ad(a), we = _e.length;
        if (ce != we && !te)
          return !1;
        for (var Ce = ce; Ce--; ) {
          var De = ne[Ce];
          if (!(te ? De in a : Lt.call(a, De)))
            return !1;
        }
        var Ue = W.get(s), Ve = W.get(a);
        if (Ue && Ve)
          return Ue == a && Ve == s;
        var dt = !0;
        W.set(s, a), W.set(a, s);
        for (var We = te; ++Ce < ce; ) {
          De = ne[Ce];
          var yt = s[De], St = a[De];
          if (_)
            var wn = te ? _(St, yt, De, a, s, W) : _(yt, St, De, s, a, W);
          if (!(wn === r ? yt === St || O(yt, St, d, _, W) : wn)) {
            dt = !1;
            break;
          }
          We || (We = De == "constructor");
        }
        if (dt && !We) {
          var Vr = s.constructor, bn = a.constructor;
          Vr != bn && "constructor" in s && "constructor" in a && !(typeof Vr == "function" && Vr instanceof Vr && typeof bn == "function" && bn instanceof bn) && (dt = !1);
        }
        return W.delete(s), W.delete(a), dt;
      }
      function Bi(s) {
        return gd(Z1(s, r, om), s + "");
      }
      function ad(s) {
        return h1(s, Er, hd);
      }
      function cd(s) {
        return h1(s, on, W1);
      }
      var ud = Zu ? function(s) {
        return Zu.get(s);
      } : Ad;
      function hl(s) {
        for (var a = s.name + "", d = Uo[a], _ = Lt.call(Uo, a) ? d.length : 0; _--; ) {
          var O = d[_], W = O.func;
          if (W == null || W == s)
            return O.name;
        }
        return a;
      }
      function zo(s) {
        var a = Lt.call(z, "placeholder") ? z : s;
        return a.placeholder;
      }
      function ze() {
        var s = z.iteratee || xd;
        return s = s === xd ? p1 : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function fl(s, a) {
        var d = s.__data__;
        return N5(a) ? d[typeof a == "string" ? "string" : "hash"] : d.map;
      }
      function ld(s) {
        for (var a = Er(s), d = a.length; d--; ) {
          var _ = a[d], O = s[_];
          a[d] = [_, O, J1(O)];
        }
        return a;
      }
      function Vs(s, a) {
        var d = $3(s, a);
        return d1(d) ? d : r;
      }
      function R5(s) {
        var a = Lt.call(s, Us), d = s[Us];
        try {
          s[Us] = r;
          var _ = !0;
        } catch {
        }
        var O = qu.call(s);
        return _ && (a ? s[Us] = d : delete s[Us]), O;
      }
      var hd = Ff ? function(s) {
        return s == null ? [] : (s = Gt(s), us(Ff(s), function(a) {
          return Yg.call(s, a);
        }));
      } : Md, W1 = Ff ? function(s) {
        for (var a = []; s; )
          ls(a, hd(s)), s = Wu(s);
        return a;
      } : Md, Fr = qr;
      (Bf && Fr(new Bf(new ArrayBuffer(1))) != Le || Ga && Fr(new Ga()) != fe || Uf && Fr(Uf.resolve()) != S || Bo && Fr(new Bo()) != ue || Ja && Fr(new Ja()) != Ae) && (Fr = function(s) {
        var a = qr(s), d = a == b ? s.constructor : r, _ = d ? Ws(d) : "";
        if (_)
          switch (_) {
            case u6:
              return Le;
            case l6:
              return fe;
            case h6:
              return S;
            case f6:
              return ue;
            case d6:
              return Ae;
          }
        return a;
      });
      function A5(s, a, d) {
        for (var _ = -1, O = d.length; ++_ < O; ) {
          var W = d[_], te = W.size;
          switch (W.type) {
            case "drop":
              s += te;
              break;
            case "dropRight":
              a -= te;
              break;
            case "take":
              a = $r(a, s + te);
              break;
            case "takeRight":
              s = yr(s, a - te);
              break;
          }
        }
        return { start: s, end: a };
      }
      function M5(s) {
        var a = s.match(qe);
        return a ? a[1].split(rt) : [];
      }
      function K1(s, a, d) {
        a = gs(a, s);
        for (var _ = -1, O = a.length, W = !1; ++_ < O; ) {
          var te = _i(a[_]);
          if (!(W = s != null && d(s, te)))
            break;
          s = s[te];
        }
        return W || ++_ != O ? W : (O = s == null ? 0 : s.length, !!O && _l(O) && Ui(te, O) && (at(s) || Ks(s)));
      }
      function D5(s) {
        var a = s.length, d = new s.constructor(a);
        return a && typeof s[0] == "string" && Lt.call(s, "index") && (d.index = s.index, d.input = s.input), d;
      }
      function G1(s) {
        return typeof s.constructor == "function" && !ic(s) ? jo(Wu(s)) : {};
      }
      function O5(s, a, d) {
        var _ = s.constructor;
        switch (a) {
          case Se:
            return id(s);
          case Q:
          case X:
            return new _(+s);
          case Le:
            return p5(s, d);
          case Ne:
          case Oe:
          case it:
          case Fe:
          case je:
          case ut:
          case Be:
          case ht:
          case ar:
            return D1(s, d);
          case fe:
            return new _();
          case Re:
          case ge:
            return new _(s);
          case re:
            return g5(s);
          case ue:
            return new _();
          case Ee:
            return m5(s);
        }
      }
      function P5(s, a) {
        var d = a.length;
        if (!d)
          return s;
        var _ = d - 1;
        return a[_] = (d > 1 ? "& " : "") + a[_], a = a.join(d > 2 ? ", " : " "), s.replace(kt, `{
/* [wrapped with ` + a + `] */
`);
      }
      function T5(s) {
        return at(s) || Ks(s) || !!(Xg && s && s[Xg]);
      }
      function Ui(s, a) {
        var d = typeof s;
        return a = a ?? A, !!a && (d == "number" || d != "symbol" && Jn.test(s)) && s > -1 && s % 1 == 0 && s < a;
      }
      function zr(s, a, d) {
        if (!tr(d))
          return !1;
        var _ = typeof a;
        return (_ == "number" ? sn(d) && Ui(a, d.length) : _ == "string" && a in d) ? ri(d[a], s) : !1;
      }
      function fd(s, a) {
        if (at(s))
          return !1;
        var d = typeof s;
        return d == "number" || d == "symbol" || d == "boolean" || s == null || _n(s) ? !0 : Ht.test(s) || !Ge.test(s) || a != null && s in Gt(a);
      }
      function N5(s) {
        var a = typeof s;
        return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? s !== "__proto__" : s === null;
      }
      function dd(s) {
        var a = hl(s), d = z[a];
        if (typeof d != "function" || !(a in _t.prototype))
          return !1;
        if (s === d)
          return !0;
        var _ = ud(d);
        return !!_ && s === _[0];
      }
      function k5(s) {
        return !!Jg && Jg in s;
      }
      var L5 = ju ? ji : Dd;
      function ic(s) {
        var a = s && s.constructor, d = typeof a == "function" && a.prototype || Fo;
        return s === d;
      }
      function J1(s) {
        return s === s && !tr(s);
      }
      function Q1(s, a) {
        return function(d) {
          return d == null ? !1 : d[s] === a && (a !== r || s in Gt(d));
        };
      }
      function $5(s) {
        var a = vl(s, function(_) {
          return d.size === f && d.clear(), _;
        }), d = a.cache;
        return a;
      }
      function F5(s, a) {
        var d = s[1], _ = a[1], O = d | _, W = O < (G | H | v), te = _ == v && d == q || _ == v && d == N && s[7].length <= a[8] || _ == (v | N) && a[7].length <= a[8] && d == q;
        if (!(W || te))
          return s;
        _ & G && (s[2] = a[2], O |= d & G ? 0 : T);
        var ne = a[3];
        if (ne) {
          var ce = s[3];
          s[3] = ce ? P1(ce, ne, a[4]) : ne, s[4] = ce ? hs(s[3], p) : a[4];
        }
        return ne = a[5], ne && (ce = s[5], s[5] = ce ? T1(ce, ne, a[6]) : ne, s[6] = ce ? hs(s[5], p) : a[6]), ne = a[7], ne && (s[7] = ne), _ & v && (s[8] = s[8] == null ? a[8] : $r(s[8], a[8])), s[9] == null && (s[9] = a[9]), s[0] = a[0], s[1] = O, s;
      }
      function B5(s) {
        var a = [];
        if (s != null)
          for (var d in Gt(s))
            a.push(d);
        return a;
      }
      function U5(s) {
        return qu.call(s);
      }
      function Z1(s, a, d) {
        return a = yr(a === r ? s.length - 1 : a, 0), function() {
          for (var _ = arguments, O = -1, W = yr(_.length - a, 0), te = de(W); ++O < W; )
            te[O] = _[a + O];
          O = -1;
          for (var ne = de(a + 1); ++O < a; )
            ne[O] = _[O];
          return ne[a] = d(te), br(s, this, ne);
        };
      }
      function Y1(s, a) {
        return a.length < 2 ? s : zs(s, Nn(a, 0, -1));
      }
      function j5(s, a) {
        for (var d = s.length, _ = $r(a.length, d), O = nn(s); _--; ) {
          var W = a[_];
          s[_] = Ui(W, d) ? O[W] : r;
        }
        return s;
      }
      function pd(s, a) {
        if (!(a === "constructor" && typeof s[a] == "function") && a != "__proto__")
          return s[a];
      }
      var X1 = tm(E1), sc = r6 || function(s, a) {
        return Et.setTimeout(s, a);
      }, gd = tm(l5);
      function em(s, a, d) {
        var _ = a + "";
        return gd(s, P5(_, H5(M5(_), d)));
      }
      function tm(s) {
        var a = 0, d = 0;
        return function() {
          var _ = o6(), O = k - (_ - d);
          if (d = _, O > 0) {
            if (++a >= ye)
              return arguments[0];
          } else
            a = 0;
          return s.apply(r, arguments);
        };
      }
      function dl(s, a) {
        var d = -1, _ = s.length, O = _ - 1;
        for (a = a === r ? _ : a; ++d < a; ) {
          var W = Zf(d, O), te = s[W];
          s[W] = s[d], s[d] = te;
        }
        return s.length = a, s;
      }
      var rm = $5(function(s) {
        var a = [];
        return s.charCodeAt(0) === 46 && a.push(""), s.replace(tt, function(d, _, O, W) {
          a.push(O ? W.replace(Ft, "$1") : _ || d);
        }), a;
      });
      function _i(s) {
        if (typeof s == "string" || _n(s))
          return s;
        var a = s + "";
        return a == "0" && 1 / s == -M ? "-0" : a;
      }
      function Ws(s) {
        if (s != null) {
          try {
            return Hu.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function H5(s, a) {
        return Dn(me, function(d) {
          var _ = "_." + d[0];
          a & d[1] && !$u(s, _) && s.push(_);
        }), s.sort();
      }
      function nm(s) {
        if (s instanceof _t)
          return s.clone();
        var a = new Pn(s.__wrapped__, s.__chain__);
        return a.__actions__ = nn(s.__actions__), a.__index__ = s.__index__, a.__values__ = s.__values__, a;
      }
      function q5(s, a, d) {
        (d ? zr(s, a, d) : a === r) ? a = 1 : a = yr(lt(a), 0);
        var _ = s == null ? 0 : s.length;
        if (!_ || a < 1)
          return [];
        for (var O = 0, W = 0, te = de(Ju(_ / a)); O < _; )
          te[W++] = Nn(s, O, O += a);
        return te;
      }
      function z5(s) {
        for (var a = -1, d = s == null ? 0 : s.length, _ = 0, O = []; ++a < d; ) {
          var W = s[a];
          W && (O[_++] = W);
        }
        return O;
      }
      function V5() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var a = de(s - 1), d = arguments[0], _ = s; _--; )
          a[_ - 1] = arguments[_];
        return ls(at(d) ? nn(d) : [d], Mr(a, 1));
      }
      var W5 = gt(function(s, a) {
        return ur(s) ? Xa(s, Mr(a, 1, ur, !0)) : [];
      }), K5 = gt(function(s, a) {
        var d = kn(a);
        return ur(d) && (d = r), ur(s) ? Xa(s, Mr(a, 1, ur, !0), ze(d, 2)) : [];
      }), G5 = gt(function(s, a) {
        var d = kn(a);
        return ur(d) && (d = r), ur(s) ? Xa(s, Mr(a, 1, ur, !0), r, d) : [];
      });
      function J5(s, a, d) {
        var _ = s == null ? 0 : s.length;
        return _ ? (a = d || a === r ? 1 : lt(a), Nn(s, a < 0 ? 0 : a, _)) : [];
      }
      function Q5(s, a, d) {
        var _ = s == null ? 0 : s.length;
        return _ ? (a = d || a === r ? 1 : lt(a), a = _ - a, Nn(s, 0, a < 0 ? 0 : a)) : [];
      }
      function Z5(s, a) {
        return s && s.length ? sl(s, ze(a, 3), !0, !0) : [];
      }
      function Y5(s, a) {
        return s && s.length ? sl(s, ze(a, 3), !0) : [];
      }
      function X5(s, a, d, _) {
        var O = s == null ? 0 : s.length;
        return O ? (d && typeof d != "number" && zr(s, a, d) && (d = 0, _ = O), V6(s, a, d, _)) : [];
      }
      function im(s, a, d) {
        var _ = s == null ? 0 : s.length;
        if (!_)
          return -1;
        var O = d == null ? 0 : lt(d);
        return O < 0 && (O = yr(_ + O, 0)), Fu(s, ze(a, 3), O);
      }
      function sm(s, a, d) {
        var _ = s == null ? 0 : s.length;
        if (!_)
          return -1;
        var O = _ - 1;
        return d !== r && (O = lt(d), O = d < 0 ? yr(_ + O, 0) : $r(O, _ - 1)), Fu(s, ze(a, 3), O, !0);
      }
      function om(s) {
        var a = s == null ? 0 : s.length;
        return a ? Mr(s, 1) : [];
      }
      function eS(s) {
        var a = s == null ? 0 : s.length;
        return a ? Mr(s, M) : [];
      }
      function tS(s, a) {
        var d = s == null ? 0 : s.length;
        return d ? (a = a === r ? 1 : lt(a), Mr(s, a)) : [];
      }
      function rS(s) {
        for (var a = -1, d = s == null ? 0 : s.length, _ = {}; ++a < d; ) {
          var O = s[a];
          _[O[0]] = O[1];
        }
        return _;
      }
      function am(s) {
        return s && s.length ? s[0] : r;
      }
      function nS(s, a, d) {
        var _ = s == null ? 0 : s.length;
        if (!_)
          return -1;
        var O = d == null ? 0 : lt(d);
        return O < 0 && (O = yr(_ + O, 0)), No(s, a, O);
      }
      function iS(s) {
        var a = s == null ? 0 : s.length;
        return a ? Nn(s, 0, -1) : [];
      }
      var sS = gt(function(s) {
        var a = Xt(s, rd);
        return a.length && a[0] === s[0] ? Wf(a) : [];
      }), oS = gt(function(s) {
        var a = kn(s), d = Xt(s, rd);
        return a === kn(d) ? a = r : d.pop(), d.length && d[0] === s[0] ? Wf(d, ze(a, 2)) : [];
      }), aS = gt(function(s) {
        var a = kn(s), d = Xt(s, rd);
        return a = typeof a == "function" ? a : r, a && d.pop(), d.length && d[0] === s[0] ? Wf(d, r, a) : [];
      });
      function cS(s, a) {
        return s == null ? "" : i6.call(s, a);
      }
      function kn(s) {
        var a = s == null ? 0 : s.length;
        return a ? s[a - 1] : r;
      }
      function uS(s, a, d) {
        var _ = s == null ? 0 : s.length;
        if (!_)
          return -1;
        var O = _;
        return d !== r && (O = lt(d), O = O < 0 ? yr(_ + O, 0) : $r(O, _ - 1)), a === a ? H3(s, a, O) : Fu(s, jg, O, !0);
      }
      function lS(s, a) {
        return s && s.length ? y1(s, lt(a)) : r;
      }
      var hS = gt(cm);
      function cm(s, a) {
        return s && s.length && a && a.length ? Qf(s, a) : s;
      }
      function fS(s, a, d) {
        return s && s.length && a && a.length ? Qf(s, a, ze(d, 2)) : s;
      }
      function dS(s, a, d) {
        return s && s.length && a && a.length ? Qf(s, a, r, d) : s;
      }
      var pS = Bi(function(s, a) {
        var d = s == null ? 0 : s.length, _ = Hf(s, a);
        return b1(s, Xt(a, function(O) {
          return Ui(O, d) ? +O : O;
        }).sort(O1)), _;
      });
      function gS(s, a) {
        var d = [];
        if (!(s && s.length))
          return d;
        var _ = -1, O = [], W = s.length;
        for (a = ze(a, 3); ++_ < W; ) {
          var te = s[_];
          a(te, _, s) && (d.push(te), O.push(_));
        }
        return b1(s, O), d;
      }
      function md(s) {
        return s == null ? s : c6.call(s);
      }
      function mS(s, a, d) {
        var _ = s == null ? 0 : s.length;
        return _ ? (d && typeof d != "number" && zr(s, a, d) ? (a = 0, d = _) : (a = a == null ? 0 : lt(a), d = d === r ? _ : lt(d)), Nn(s, a, d)) : [];
      }
      function vS(s, a) {
        return il(s, a);
      }
      function yS(s, a, d) {
        return Xf(s, a, ze(d, 2));
      }
      function _S(s, a) {
        var d = s == null ? 0 : s.length;
        if (d) {
          var _ = il(s, a);
          if (_ < d && ri(s[_], a))
            return _;
        }
        return -1;
      }
      function wS(s, a) {
        return il(s, a, !0);
      }
      function bS(s, a, d) {
        return Xf(s, a, ze(d, 2), !0);
      }
      function ES(s, a) {
        var d = s == null ? 0 : s.length;
        if (d) {
          var _ = il(s, a, !0) - 1;
          if (ri(s[_], a))
            return _;
        }
        return -1;
      }
      function SS(s) {
        return s && s.length ? S1(s) : [];
      }
      function CS(s, a) {
        return s && s.length ? S1(s, ze(a, 2)) : [];
      }
      function IS(s) {
        var a = s == null ? 0 : s.length;
        return a ? Nn(s, 1, a) : [];
      }
      function xS(s, a, d) {
        return s && s.length ? (a = d || a === r ? 1 : lt(a), Nn(s, 0, a < 0 ? 0 : a)) : [];
      }
      function RS(s, a, d) {
        var _ = s == null ? 0 : s.length;
        return _ ? (a = d || a === r ? 1 : lt(a), a = _ - a, Nn(s, a < 0 ? 0 : a, _)) : [];
      }
      function AS(s, a) {
        return s && s.length ? sl(s, ze(a, 3), !1, !0) : [];
      }
      function MS(s, a) {
        return s && s.length ? sl(s, ze(a, 3)) : [];
      }
      var DS = gt(function(s) {
        return ps(Mr(s, 1, ur, !0));
      }), OS = gt(function(s) {
        var a = kn(s);
        return ur(a) && (a = r), ps(Mr(s, 1, ur, !0), ze(a, 2));
      }), PS = gt(function(s) {
        var a = kn(s);
        return a = typeof a == "function" ? a : r, ps(Mr(s, 1, ur, !0), r, a);
      });
      function TS(s) {
        return s && s.length ? ps(s) : [];
      }
      function NS(s, a) {
        return s && s.length ? ps(s, ze(a, 2)) : [];
      }
      function kS(s, a) {
        return a = typeof a == "function" ? a : r, s && s.length ? ps(s, r, a) : [];
      }
      function vd(s) {
        if (!(s && s.length))
          return [];
        var a = 0;
        return s = us(s, function(d) {
          if (ur(d))
            return a = yr(d.length, a), !0;
        }), Nf(a, function(d) {
          return Xt(s, Of(d));
        });
      }
      function um(s, a) {
        if (!(s && s.length))
          return [];
        var d = vd(s);
        return a == null ? d : Xt(d, function(_) {
          return br(a, r, _);
        });
      }
      var LS = gt(function(s, a) {
        return ur(s) ? Xa(s, a) : [];
      }), $S = gt(function(s) {
        return td(us(s, ur));
      }), FS = gt(function(s) {
        var a = kn(s);
        return ur(a) && (a = r), td(us(s, ur), ze(a, 2));
      }), BS = gt(function(s) {
        var a = kn(s);
        return a = typeof a == "function" ? a : r, td(us(s, ur), r, a);
      }), US = gt(vd);
      function jS(s, a) {
        return R1(s || [], a || [], Ya);
      }
      function HS(s, a) {
        return R1(s || [], a || [], rc);
      }
      var qS = gt(function(s) {
        var a = s.length, d = a > 1 ? s[a - 1] : r;
        return d = typeof d == "function" ? (s.pop(), d) : r, um(s, d);
      });
      function lm(s) {
        var a = z(s);
        return a.__chain__ = !0, a;
      }
      function zS(s, a) {
        return a(s), s;
      }
      function pl(s, a) {
        return a(s);
      }
      var VS = Bi(function(s) {
        var a = s.length, d = a ? s[0] : 0, _ = this.__wrapped__, O = function(W) {
          return Hf(W, s);
        };
        return a > 1 || this.__actions__.length || !(_ instanceof _t) || !Ui(d) ? this.thru(O) : (_ = _.slice(d, +d + (a ? 1 : 0)), _.__actions__.push({ func: pl, args: [O], thisArg: r }), new Pn(_, this.__chain__).thru(function(W) {
          return a && !W.length && W.push(r), W;
        }));
      });
      function WS() {
        return lm(this);
      }
      function KS() {
        return new Pn(this.value(), this.__chain__);
      }
      function GS() {
        this.__values__ === r && (this.__values__ = Cm(this.value()));
        var s = this.__index__ >= this.__values__.length, a = s ? r : this.__values__[this.__index__++];
        return { done: s, value: a };
      }
      function JS() {
        return this;
      }
      function QS(s) {
        for (var a, d = this; d instanceof Xu; ) {
          var _ = nm(d);
          _.__index__ = 0, _.__values__ = r, a ? O.__wrapped__ = _ : a = _;
          var O = _;
          d = d.__wrapped__;
        }
        return O.__wrapped__ = s, a;
      }
      function ZS() {
        var s = this.__wrapped__;
        if (s instanceof _t) {
          var a = s;
          return this.__actions__.length && (a = new _t(this)), a = a.reverse(), a.__actions__.push({ func: pl, args: [md], thisArg: r }), new Pn(a, this.__chain__);
        }
        return this.thru(md);
      }
      function YS() {
        return x1(this.__wrapped__, this.__actions__);
      }
      var XS = ol(function(s, a, d) {
        Lt.call(s, d) ? ++s[d] : $i(s, d, 1);
      });
      function e4(s, a, d) {
        var _ = at(s) ? Bg : z6;
        return d && zr(s, a, d) && (a = r), _(s, ze(a, 3));
      }
      function t4(s, a) {
        var d = at(s) ? us : u1;
        return d(s, ze(a, 3));
      }
      var r4 = $1(im), n4 = $1(sm);
      function i4(s, a) {
        return Mr(gl(s, a), 1);
      }
      function s4(s, a) {
        return Mr(gl(s, a), M);
      }
      function o4(s, a, d) {
        return d = d === r ? 1 : lt(d), Mr(gl(s, a), d);
      }
      function hm(s, a) {
        var d = at(s) ? Dn : ds;
        return d(s, ze(a, 3));
      }
      function fm(s, a) {
        var d = at(s) ? I3 : c1;
        return d(s, ze(a, 3));
      }
      var a4 = ol(function(s, a, d) {
        Lt.call(s, d) ? s[d].push(a) : $i(s, d, [a]);
      });
      function c4(s, a, d, _) {
        s = sn(s) ? s : Wo(s), d = d && !_ ? lt(d) : 0;
        var O = s.length;
        return d < 0 && (d = yr(O + d, 0)), wl(s) ? d <= O && s.indexOf(a, d) > -1 : !!O && No(s, a, d) > -1;
      }
      var u4 = gt(function(s, a, d) {
        var _ = -1, O = typeof a == "function", W = sn(s) ? de(s.length) : [];
        return ds(s, function(te) {
          W[++_] = O ? br(a, te, d) : ec(te, a, d);
        }), W;
      }), l4 = ol(function(s, a, d) {
        $i(s, d, a);
      });
      function gl(s, a) {
        var d = at(s) ? Xt : g1;
        return d(s, ze(a, 3));
      }
      function h4(s, a, d, _) {
        return s == null ? [] : (at(a) || (a = a == null ? [] : [a]), d = _ ? r : d, at(d) || (d = d == null ? [] : [d]), _1(s, a, d));
      }
      var f4 = ol(function(s, a, d) {
        s[d ? 0 : 1].push(a);
      }, function() {
        return [[], []];
      });
      function d4(s, a, d) {
        var _ = at(s) ? Mf : qg, O = arguments.length < 3;
        return _(s, ze(a, 4), d, O, ds);
      }
      function p4(s, a, d) {
        var _ = at(s) ? x3 : qg, O = arguments.length < 3;
        return _(s, ze(a, 4), d, O, c1);
      }
      function g4(s, a) {
        var d = at(s) ? us : u1;
        return d(s, yl(ze(a, 3)));
      }
      function m4(s) {
        var a = at(s) ? i1 : c5;
        return a(s);
      }
      function v4(s, a, d) {
        (d ? zr(s, a, d) : a === r) ? a = 1 : a = lt(a);
        var _ = at(s) ? B6 : u5;
        return _(s, a);
      }
      function y4(s) {
        var a = at(s) ? U6 : h5;
        return a(s);
      }
      function _4(s) {
        if (s == null)
          return 0;
        if (sn(s))
          return wl(s) ? Lo(s) : s.length;
        var a = Fr(s);
        return a == fe || a == ue ? s.size : Gf(s).length;
      }
      function w4(s, a, d) {
        var _ = at(s) ? Df : f5;
        return d && zr(s, a, d) && (a = r), _(s, ze(a, 3));
      }
      var b4 = gt(function(s, a) {
        if (s == null)
          return [];
        var d = a.length;
        return d > 1 && zr(s, a[0], a[1]) ? a = [] : d > 2 && zr(a[0], a[1], a[2]) && (a = [a[0]]), _1(s, Mr(a, 1), []);
      }), ml = t6 || function() {
        return Et.Date.now();
      };
      function E4(s, a) {
        if (typeof a != "function")
          throw new On(c);
        return s = lt(s), function() {
          if (--s < 1)
            return a.apply(this, arguments);
        };
      }
      function dm(s, a, d) {
        return a = d ? r : a, a = s && a == null ? s.length : a, Fi(s, v, r, r, r, r, a);
      }
      function pm(s, a) {
        var d;
        if (typeof a != "function")
          throw new On(c);
        return s = lt(s), function() {
          return --s > 0 && (d = a.apply(this, arguments)), s <= 1 && (a = r), d;
        };
      }
      var yd = gt(function(s, a, d) {
        var _ = G;
        if (d.length) {
          var O = hs(d, zo(yd));
          _ |= L;
        }
        return Fi(s, _, a, d, O);
      }), gm = gt(function(s, a, d) {
        var _ = G | H;
        if (d.length) {
          var O = hs(d, zo(gm));
          _ |= L;
        }
        return Fi(a, _, s, d, O);
      });
      function mm(s, a, d) {
        a = d ? r : a;
        var _ = Fi(s, q, r, r, r, r, r, a);
        return _.placeholder = mm.placeholder, _;
      }
      function vm(s, a, d) {
        a = d ? r : a;
        var _ = Fi(s, B, r, r, r, r, r, a);
        return _.placeholder = vm.placeholder, _;
      }
      function ym(s, a, d) {
        var _, O, W, te, ne, ce, _e = 0, we = !1, Ce = !1, De = !0;
        if (typeof s != "function")
          throw new On(c);
        a = Ln(a) || 0, tr(d) && (we = !!d.leading, Ce = "maxWait" in d, W = Ce ? yr(Ln(d.maxWait) || 0, a) : W, De = "trailing" in d ? !!d.trailing : De);
        function Ue(lr) {
          var ni = _, qi = O;
          return _ = O = r, _e = lr, te = s.apply(qi, ni), te;
        }
        function Ve(lr) {
          return _e = lr, ne = sc(yt, a), we ? Ue(lr) : te;
        }
        function dt(lr) {
          var ni = lr - ce, qi = lr - _e, $m = a - ni;
          return Ce ? $r($m, W - qi) : $m;
        }
        function We(lr) {
          var ni = lr - ce, qi = lr - _e;
          return ce === r || ni >= a || ni < 0 || Ce && qi >= W;
        }
        function yt() {
          var lr = ml();
          if (We(lr))
            return St(lr);
          ne = sc(yt, dt(lr));
        }
        function St(lr) {
          return ne = r, De && _ ? Ue(lr) : (_ = O = r, te);
        }
        function wn() {
          ne !== r && A1(ne), _e = 0, _ = ce = O = ne = r;
        }
        function Vr() {
          return ne === r ? te : St(ml());
        }
        function bn() {
          var lr = ml(), ni = We(lr);
          if (_ = arguments, O = this, ce = lr, ni) {
            if (ne === r)
              return Ve(ce);
            if (Ce)
              return A1(ne), ne = sc(yt, a), Ue(ce);
          }
          return ne === r && (ne = sc(yt, a)), te;
        }
        return bn.cancel = wn, bn.flush = Vr, bn;
      }
      var S4 = gt(function(s, a) {
        return a1(s, 1, a);
      }), C4 = gt(function(s, a, d) {
        return a1(s, Ln(a) || 0, d);
      });
      function I4(s) {
        return Fi(s, ie);
      }
      function vl(s, a) {
        if (typeof s != "function" || a != null && typeof a != "function")
          throw new On(c);
        var d = function() {
          var _ = arguments, O = a ? a.apply(this, _) : _[0], W = d.cache;
          if (W.has(O))
            return W.get(O);
          var te = s.apply(this, _);
          return d.cache = W.set(O, te) || W, te;
        };
        return d.cache = new (vl.Cache || Li)(), d;
      }
      vl.Cache = Li;
      function yl(s) {
        if (typeof s != "function")
          throw new On(c);
        return function() {
          var a = arguments;
          switch (a.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, a[0]);
            case 2:
              return !s.call(this, a[0], a[1]);
            case 3:
              return !s.call(this, a[0], a[1], a[2]);
          }
          return !s.apply(this, a);
        };
      }
      function x4(s) {
        return pm(2, s);
      }
      var R4 = d5(function(s, a) {
        a = a.length == 1 && at(a[0]) ? Xt(a[0], vn(ze())) : Xt(Mr(a, 1), vn(ze()));
        var d = a.length;
        return gt(function(_) {
          for (var O = -1, W = $r(_.length, d); ++O < W; )
            _[O] = a[O].call(this, _[O]);
          return br(s, this, _);
        });
      }), _d = gt(function(s, a) {
        var d = hs(a, zo(_d));
        return Fi(s, L, r, a, d);
      }), _m = gt(function(s, a) {
        var d = hs(a, zo(_m));
        return Fi(s, P, r, a, d);
      }), A4 = Bi(function(s, a) {
        return Fi(s, N, r, r, r, a);
      });
      function M4(s, a) {
        if (typeof s != "function")
          throw new On(c);
        return a = a === r ? a : lt(a), gt(s, a);
      }
      function D4(s, a) {
        if (typeof s != "function")
          throw new On(c);
        return a = a == null ? 0 : yr(lt(a), 0), gt(function(d) {
          var _ = d[a], O = ms(d, 0, a);
          return _ && ls(O, _), br(s, this, O);
        });
      }
      function O4(s, a, d) {
        var _ = !0, O = !0;
        if (typeof s != "function")
          throw new On(c);
        return tr(d) && (_ = "leading" in d ? !!d.leading : _, O = "trailing" in d ? !!d.trailing : O), ym(s, a, { leading: _, maxWait: a, trailing: O });
      }
      function P4(s) {
        return dm(s, 1);
      }
      function T4(s, a) {
        return _d(nd(a), s);
      }
      function N4() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return at(s) ? s : [s];
      }
      function k4(s) {
        return Tn(s, C);
      }
      function L4(s, a) {
        return a = typeof a == "function" ? a : r, Tn(s, C, a);
      }
      function $4(s) {
        return Tn(s, g | C);
      }
      function F4(s, a) {
        return a = typeof a == "function" ? a : r, Tn(s, g | C, a);
      }
      function B4(s, a) {
        return a == null || o1(s, a, Er(a));
      }
      function ri(s, a) {
        return s === a || s !== s && a !== a;
      }
      var U4 = ll(Vf), j4 = ll(function(s, a) {
        return s >= a;
      }), Ks = f1(/* @__PURE__ */ function() {
        return arguments;
      }()) ? f1 : function(s) {
        return sr(s) && Lt.call(s, "callee") && !Yg.call(s, "callee");
      }, at = de.isArray, H4 = Hr ? vn(Hr) : Q6;
      function sn(s) {
        return s != null && _l(s.length) && !ji(s);
      }
      function ur(s) {
        return sr(s) && sn(s);
      }
      function q4(s) {
        return s === !0 || s === !1 || sr(s) && qr(s) == Q;
      }
      var vs = n6 || Dd, z4 = Xn ? vn(Xn) : Z6;
      function V4(s) {
        return sr(s) && s.nodeType === 1 && !oc(s);
      }
      function W4(s) {
        if (s == null)
          return !0;
        if (sn(s) && (at(s) || typeof s == "string" || typeof s.splice == "function" || vs(s) || Vo(s) || Ks(s)))
          return !s.length;
        var a = Fr(s);
        if (a == fe || a == ue)
          return !s.size;
        if (ic(s))
          return !Gf(s).length;
        for (var d in s)
          if (Lt.call(s, d))
            return !1;
        return !0;
      }
      function K4(s, a) {
        return tc(s, a);
      }
      function G4(s, a, d) {
        d = typeof d == "function" ? d : r;
        var _ = d ? d(s, a) : r;
        return _ === r ? tc(s, a, r, d) : !!_;
      }
      function wd(s) {
        if (!sr(s))
          return !1;
        var a = qr(s);
        return a == I || a == E || typeof s.message == "string" && typeof s.name == "string" && !oc(s);
      }
      function J4(s) {
        return typeof s == "number" && e1(s);
      }
      function ji(s) {
        if (!tr(s))
          return !1;
        var a = qr(s);
        return a == F || a == se || a == V || a == Z;
      }
      function wm(s) {
        return typeof s == "number" && s == lt(s);
      }
      function _l(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= A;
      }
      function tr(s) {
        var a = typeof s;
        return s != null && (a == "object" || a == "function");
      }
      function sr(s) {
        return s != null && typeof s == "object";
      }
      var bm = Mn ? vn(Mn) : X6;
      function Q4(s, a) {
        return s === a || Kf(s, a, ld(a));
      }
      function Z4(s, a, d) {
        return d = typeof d == "function" ? d : r, Kf(s, a, ld(a), d);
      }
      function Y4(s) {
        return Em(s) && s != +s;
      }
      function X4(s) {
        if (L5(s))
          throw new st(o);
        return d1(s);
      }
      function e8(s) {
        return s === null;
      }
      function t8(s) {
        return s == null;
      }
      function Em(s) {
        return typeof s == "number" || sr(s) && qr(s) == Re;
      }
      function oc(s) {
        if (!sr(s) || qr(s) != b)
          return !1;
        var a = Wu(s);
        if (a === null)
          return !0;
        var d = Lt.call(a, "constructor") && a.constructor;
        return typeof d == "function" && d instanceof d && Hu.call(d) == Z3;
      }
      var bd = mi ? vn(mi) : e5;
      function r8(s) {
        return wm(s) && s >= -A && s <= A;
      }
      var Sm = Va ? vn(Va) : t5;
      function wl(s) {
        return typeof s == "string" || !at(s) && sr(s) && qr(s) == ge;
      }
      function _n(s) {
        return typeof s == "symbol" || sr(s) && qr(s) == Ee;
      }
      var Vo = Bs ? vn(Bs) : r5;
      function n8(s) {
        return s === r;
      }
      function i8(s) {
        return sr(s) && Fr(s) == Ae;
      }
      function s8(s) {
        return sr(s) && qr(s) == xe;
      }
      var o8 = ll(Jf), a8 = ll(function(s, a) {
        return s <= a;
      });
      function Cm(s) {
        if (!s)
          return [];
        if (sn(s))
          return wl(s) ? ei(s) : nn(s);
        if (Ka && s[Ka])
          return B3(s[Ka]());
        var a = Fr(s), d = a == fe ? Lf : a == ue ? Bu : Wo;
        return d(s);
      }
      function Hi(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = Ln(s), s === M || s === -M) {
          var a = s < 0 ? -1 : 1;
          return a * $;
        }
        return s === s ? s : 0;
      }
      function lt(s) {
        var a = Hi(s), d = a % 1;
        return a === a ? d ? a - d : a : 0;
      }
      function Im(s) {
        return s ? qs(lt(s), 0, D) : 0;
      }
      function Ln(s) {
        if (typeof s == "number")
          return s;
        if (_n(s))
          return K;
        if (tr(s)) {
          var a = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = tr(a) ? a + "" : a;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = zg(s);
        var d = Wn.test(s);
        return d || Gn.test(s) ? ot(s.slice(2), d ? 2 : 8) : Bt.test(s) ? K : +s;
      }
      function xm(s) {
        return yi(s, on(s));
      }
      function c8(s) {
        return s ? qs(lt(s), -A, A) : s === 0 ? s : 0;
      }
      function Pt(s) {
        return s == null ? "" : yn(s);
      }
      var u8 = Ho(function(s, a) {
        if (ic(a) || sn(a)) {
          yi(a, Er(a), s);
          return;
        }
        for (var d in a)
          Lt.call(a, d) && Ya(s, d, a[d]);
      }), Rm = Ho(function(s, a) {
        yi(a, on(a), s);
      }), bl = Ho(function(s, a, d, _) {
        yi(a, on(a), s, _);
      }), l8 = Ho(function(s, a, d, _) {
        yi(a, Er(a), s, _);
      }), h8 = Bi(Hf);
      function f8(s, a) {
        var d = jo(s);
        return a == null ? d : s1(d, a);
      }
      var d8 = gt(function(s, a) {
        s = Gt(s);
        var d = -1, _ = a.length, O = _ > 2 ? a[2] : r;
        for (O && zr(a[0], a[1], O) && (_ = 1); ++d < _; )
          for (var W = a[d], te = on(W), ne = -1, ce = te.length; ++ne < ce; ) {
            var _e = te[ne], we = s[_e];
            (we === r || ri(we, Fo[_e]) && !Lt.call(s, _e)) && (s[_e] = W[_e]);
          }
        return s;
      }), p8 = gt(function(s) {
        return s.push(r, z1), br(Am, r, s);
      });
      function g8(s, a) {
        return Ug(s, ze(a, 3), vi);
      }
      function m8(s, a) {
        return Ug(s, ze(a, 3), zf);
      }
      function v8(s, a) {
        return s == null ? s : qf(s, ze(a, 3), on);
      }
      function y8(s, a) {
        return s == null ? s : l1(s, ze(a, 3), on);
      }
      function _8(s, a) {
        return s && vi(s, ze(a, 3));
      }
      function w8(s, a) {
        return s && zf(s, ze(a, 3));
      }
      function b8(s) {
        return s == null ? [] : rl(s, Er(s));
      }
      function E8(s) {
        return s == null ? [] : rl(s, on(s));
      }
      function Ed(s, a, d) {
        var _ = s == null ? r : zs(s, a);
        return _ === r ? d : _;
      }
      function S8(s, a) {
        return s != null && K1(s, a, W6);
      }
      function Sd(s, a) {
        return s != null && K1(s, a, K6);
      }
      var C8 = B1(function(s, a, d) {
        a != null && typeof a.toString != "function" && (a = qu.call(a)), s[a] = d;
      }, Id(an)), I8 = B1(function(s, a, d) {
        a != null && typeof a.toString != "function" && (a = qu.call(a)), Lt.call(s, a) ? s[a].push(d) : s[a] = [d];
      }, ze), x8 = gt(ec);
      function Er(s) {
        return sn(s) ? n1(s) : Gf(s);
      }
      function on(s) {
        return sn(s) ? n1(s, !0) : n5(s);
      }
      function R8(s, a) {
        var d = {};
        return a = ze(a, 3), vi(s, function(_, O, W) {
          $i(d, a(_, O, W), _);
        }), d;
      }
      function A8(s, a) {
        var d = {};
        return a = ze(a, 3), vi(s, function(_, O, W) {
          $i(d, O, a(_, O, W));
        }), d;
      }
      var M8 = Ho(function(s, a, d) {
        nl(s, a, d);
      }), Am = Ho(function(s, a, d, _) {
        nl(s, a, d, _);
      }), D8 = Bi(function(s, a) {
        var d = {};
        if (s == null)
          return d;
        var _ = !1;
        a = Xt(a, function(W) {
          return W = gs(W, s), _ || (_ = W.length > 1), W;
        }), yi(s, cd(s), d), _ && (d = Tn(d, g | y | C, C5));
        for (var O = a.length; O--; )
          ed(d, a[O]);
        return d;
      });
      function O8(s, a) {
        return Mm(s, yl(ze(a)));
      }
      var P8 = Bi(function(s, a) {
        return s == null ? {} : s5(s, a);
      });
      function Mm(s, a) {
        if (s == null)
          return {};
        var d = Xt(cd(s), function(_) {
          return [_];
        });
        return a = ze(a), w1(s, d, function(_, O) {
          return a(_, O[0]);
        });
      }
      function T8(s, a, d) {
        a = gs(a, s);
        var _ = -1, O = a.length;
        for (O || (O = 1, s = r); ++_ < O; ) {
          var W = s == null ? r : s[_i(a[_])];
          W === r && (_ = O, W = d), s = ji(W) ? W.call(s) : W;
        }
        return s;
      }
      function N8(s, a, d) {
        return s == null ? s : rc(s, a, d);
      }
      function k8(s, a, d, _) {
        return _ = typeof _ == "function" ? _ : r, s == null ? s : rc(s, a, d, _);
      }
      var Dm = H1(Er), Om = H1(on);
      function L8(s, a, d) {
        var _ = at(s), O = _ || vs(s) || Vo(s);
        if (a = ze(a, 4), d == null) {
          var W = s && s.constructor;
          O ? d = _ ? new W() : [] : tr(s) ? d = ji(W) ? jo(Wu(s)) : {} : d = {};
        }
        return (O ? Dn : vi)(s, function(te, ne, ce) {
          return a(d, te, ne, ce);
        }), d;
      }
      function $8(s, a) {
        return s == null ? !0 : ed(s, a);
      }
      function F8(s, a, d) {
        return s == null ? s : I1(s, a, nd(d));
      }
      function B8(s, a, d, _) {
        return _ = typeof _ == "function" ? _ : r, s == null ? s : I1(s, a, nd(d), _);
      }
      function Wo(s) {
        return s == null ? [] : kf(s, Er(s));
      }
      function U8(s) {
        return s == null ? [] : kf(s, on(s));
      }
      function j8(s, a, d) {
        return d === r && (d = a, a = r), d !== r && (d = Ln(d), d = d === d ? d : 0), a !== r && (a = Ln(a), a = a === a ? a : 0), qs(Ln(s), a, d);
      }
      function H8(s, a, d) {
        return a = Hi(a), d === r ? (d = a, a = 0) : d = Hi(d), s = Ln(s), G6(s, a, d);
      }
      function q8(s, a, d) {
        if (d && typeof d != "boolean" && zr(s, a, d) && (a = d = r), d === r && (typeof a == "boolean" ? (d = a, a = r) : typeof s == "boolean" && (d = s, s = r)), s === r && a === r ? (s = 0, a = 1) : (s = Hi(s), a === r ? (a = s, s = 0) : a = Hi(a)), s > a) {
          var _ = s;
          s = a, a = _;
        }
        if (d || s % 1 || a % 1) {
          var O = t1();
          return $r(s + O * (a - s + Wt("1e-" + ((O + "").length - 1))), a);
        }
        return Zf(s, a);
      }
      var z8 = qo(function(s, a, d) {
        return a = a.toLowerCase(), s + (d ? Pm(a) : a);
      });
      function Pm(s) {
        return Cd(Pt(s).toLowerCase());
      }
      function Tm(s) {
        return s = Pt(s), s && s.replace(Ar, N3).replace(xf, "");
      }
      function V8(s, a, d) {
        s = Pt(s), a = yn(a);
        var _ = s.length;
        d = d === r ? _ : qs(lt(d), 0, _);
        var O = d;
        return d -= a.length, d >= 0 && s.slice(d, O) == a;
      }
      function W8(s) {
        return s = Pt(s), s && Ke.test(s) ? s.replace(Mt, k3) : s;
      }
      function K8(s) {
        return s = Pt(s), s && qt.test(s) ? s.replace(Ze, "\\$&") : s;
      }
      var G8 = qo(function(s, a, d) {
        return s + (d ? "-" : "") + a.toLowerCase();
      }), J8 = qo(function(s, a, d) {
        return s + (d ? " " : "") + a.toLowerCase();
      }), Q8 = L1("toLowerCase");
      function Z8(s, a, d) {
        s = Pt(s), a = lt(a);
        var _ = a ? Lo(s) : 0;
        if (!a || _ >= a)
          return s;
        var O = (a - _) / 2;
        return ul(Qu(O), d) + s + ul(Ju(O), d);
      }
      function Y8(s, a, d) {
        s = Pt(s), a = lt(a);
        var _ = a ? Lo(s) : 0;
        return a && _ < a ? s + ul(a - _, d) : s;
      }
      function X8(s, a, d) {
        s = Pt(s), a = lt(a);
        var _ = a ? Lo(s) : 0;
        return a && _ < a ? ul(a - _, d) + s : s;
      }
      function eC(s, a, d) {
        return d || a == null ? a = 0 : a && (a = +a), a6(Pt(s).replace(Ye, ""), a || 0);
      }
      function tC(s, a, d) {
        return (d ? zr(s, a, d) : a === r) ? a = 1 : a = lt(a), Yf(Pt(s), a);
      }
      function rC() {
        var s = arguments, a = Pt(s[0]);
        return s.length < 3 ? a : a.replace(s[1], s[2]);
      }
      var nC = qo(function(s, a, d) {
        return s + (d ? "_" : "") + a.toLowerCase();
      });
      function iC(s, a, d) {
        return d && typeof d != "number" && zr(s, a, d) && (a = d = r), d = d === r ? D : d >>> 0, d ? (s = Pt(s), s && (typeof a == "string" || a != null && !bd(a)) && (a = yn(a), !a && ko(s)) ? ms(ei(s), 0, d) : s.split(a, d)) : [];
      }
      var sC = qo(function(s, a, d) {
        return s + (d ? " " : "") + Cd(a);
      });
      function oC(s, a, d) {
        return s = Pt(s), d = d == null ? 0 : qs(lt(d), 0, s.length), a = yn(a), s.slice(d, d + a.length) == a;
      }
      function aC(s, a, d) {
        var _ = z.templateSettings;
        d && zr(s, a, d) && (a = r), s = Pt(s), a = bl({}, a, _, q1);
        var O = bl({}, a.imports, _.imports, q1), W = Er(O), te = kf(O, W), ne, ce, _e = 0, we = a.interpolate || Xr, Ce = "__p += '", De = $f((a.escape || Xr).source + "|" + we.source + "|" + (we === Je ? pi : Xr).source + "|" + (a.evaluate || Xr).source + "|$", "g"), Ue = "//# sourceURL=" + (Lt.call(a, "sourceURL") ? (a.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Rf + "]") + `
`;
        s.replace(De, function(We, yt, St, wn, Vr, bn) {
          return St || (St = wn), Ce += s.slice(_e, bn).replace(Qn, L3), yt && (ne = !0, Ce += `' +
__e(` + yt + `) +
'`), Vr && (ce = !0, Ce += `';
` + Vr + `;
__p += '`), St && (Ce += `' +
((__t = (` + St + `)) == null ? '' : __t) +
'`), _e = bn + We.length, We;
        }), Ce += `';
`;
        var Ve = Lt.call(a, "variable") && a.variable;
        if (!Ve)
          Ce = `with (obj) {
` + Ce + `
}
`;
        else if ($t.test(Ve))
          throw new st(u);
        Ce = (ce ? Ce.replace(bt, "") : Ce).replace(ft, "$1").replace(Lr, "$1;"), Ce = "function(" + (Ve || "obj") + `) {
` + (Ve ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ne ? ", __e = _.escape" : "") + (ce ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ce + `return __p
}`;
        var dt = km(function() {
          return Ot(W, Ue + "return " + Ce).apply(r, te);
        });
        if (dt.source = Ce, wd(dt))
          throw dt;
        return dt;
      }
      function cC(s) {
        return Pt(s).toLowerCase();
      }
      function uC(s) {
        return Pt(s).toUpperCase();
      }
      function lC(s, a, d) {
        if (s = Pt(s), s && (d || a === r))
          return zg(s);
        if (!s || !(a = yn(a)))
          return s;
        var _ = ei(s), O = ei(a), W = Vg(_, O), te = Wg(_, O) + 1;
        return ms(_, W, te).join("");
      }
      function hC(s, a, d) {
        if (s = Pt(s), s && (d || a === r))
          return s.slice(0, Gg(s) + 1);
        if (!s || !(a = yn(a)))
          return s;
        var _ = ei(s), O = Wg(_, ei(a)) + 1;
        return ms(_, 0, O).join("");
      }
      function fC(s, a, d) {
        if (s = Pt(s), s && (d || a === r))
          return s.replace(Ye, "");
        if (!s || !(a = yn(a)))
          return s;
        var _ = ei(s), O = Vg(_, ei(a));
        return ms(_, O).join("");
      }
      function dC(s, a) {
        var d = le, _ = he;
        if (tr(a)) {
          var O = "separator" in a ? a.separator : O;
          d = "length" in a ? lt(a.length) : d, _ = "omission" in a ? yn(a.omission) : _;
        }
        s = Pt(s);
        var W = s.length;
        if (ko(s)) {
          var te = ei(s);
          W = te.length;
        }
        if (d >= W)
          return s;
        var ne = d - Lo(_);
        if (ne < 1)
          return _;
        var ce = te ? ms(te, 0, ne).join("") : s.slice(0, ne);
        if (O === r)
          return ce + _;
        if (te && (ne += ce.length - ne), bd(O)) {
          if (s.slice(ne).search(O)) {
            var _e, we = ce;
            for (O.global || (O = $f(O.source, Pt(vt.exec(O)) + "g")), O.lastIndex = 0; _e = O.exec(we); )
              var Ce = _e.index;
            ce = ce.slice(0, Ce === r ? ne : Ce);
          }
        } else if (s.indexOf(yn(O), ne) != ne) {
          var De = ce.lastIndexOf(O);
          De > -1 && (ce = ce.slice(0, De));
        }
        return ce + _;
      }
      function pC(s) {
        return s = Pt(s), s && Tt.test(s) ? s.replace(It, q3) : s;
      }
      var gC = qo(function(s, a, d) {
        return s + (d ? " " : "") + a.toUpperCase();
      }), Cd = L1("toUpperCase");
      function Nm(s, a, d) {
        return s = Pt(s), a = d ? r : a, a === r ? F3(s) ? W3(s) : M3(s) : s.match(a) || [];
      }
      var km = gt(function(s, a) {
        try {
          return br(s, r, a);
        } catch (d) {
          return wd(d) ? d : new st(d);
        }
      }), mC = Bi(function(s, a) {
        return Dn(a, function(d) {
          d = _i(d), $i(s, d, yd(s[d], s));
        }), s;
      });
      function vC(s) {
        var a = s == null ? 0 : s.length, d = ze();
        return s = a ? Xt(s, function(_) {
          if (typeof _[1] != "function")
            throw new On(c);
          return [d(_[0]), _[1]];
        }) : [], gt(function(_) {
          for (var O = -1; ++O < a; ) {
            var W = s[O];
            if (br(W[0], this, _))
              return br(W[1], this, _);
          }
        });
      }
      function yC(s) {
        return q6(Tn(s, g));
      }
      function Id(s) {
        return function() {
          return s;
        };
      }
      function _C(s, a) {
        return s == null || s !== s ? a : s;
      }
      var wC = F1(), bC = F1(!0);
      function an(s) {
        return s;
      }
      function xd(s) {
        return p1(typeof s == "function" ? s : Tn(s, g));
      }
      function EC(s) {
        return m1(Tn(s, g));
      }
      function SC(s, a) {
        return v1(s, Tn(a, g));
      }
      var CC = gt(function(s, a) {
        return function(d) {
          return ec(d, s, a);
        };
      }), IC = gt(function(s, a) {
        return function(d) {
          return ec(s, d, a);
        };
      });
      function Rd(s, a, d) {
        var _ = Er(a), O = rl(a, _);
        d == null && !(tr(a) && (O.length || !_.length)) && (d = a, a = s, s = this, O = rl(a, Er(a)));
        var W = !(tr(d) && "chain" in d) || !!d.chain, te = ji(s);
        return Dn(O, function(ne) {
          var ce = a[ne];
          s[ne] = ce, te && (s.prototype[ne] = function() {
            var _e = this.__chain__;
            if (W || _e) {
              var we = s(this.__wrapped__), Ce = we.__actions__ = nn(this.__actions__);
              return Ce.push({ func: ce, args: arguments, thisArg: s }), we.__chain__ = _e, we;
            }
            return ce.apply(s, ls([this.value()], arguments));
          });
        }), s;
      }
      function xC() {
        return Et._ === this && (Et._ = Y3), this;
      }
      function Ad() {
      }
      function RC(s) {
        return s = lt(s), gt(function(a) {
          return y1(a, s);
        });
      }
      var AC = sd(Xt), MC = sd(Bg), DC = sd(Df);
      function Lm(s) {
        return fd(s) ? Of(_i(s)) : o5(s);
      }
      function OC(s) {
        return function(a) {
          return s == null ? r : zs(s, a);
        };
      }
      var PC = U1(), TC = U1(!0);
      function Md() {
        return [];
      }
      function Dd() {
        return !1;
      }
      function NC() {
        return {};
      }
      function kC() {
        return "";
      }
      function LC() {
        return !0;
      }
      function $C(s, a) {
        if (s = lt(s), s < 1 || s > A)
          return [];
        var d = D, _ = $r(s, D);
        a = ze(a), s -= D;
        for (var O = Nf(_, a); ++d < s; )
          a(d);
        return O;
      }
      function FC(s) {
        return at(s) ? Xt(s, _i) : _n(s) ? [s] : nn(rm(Pt(s)));
      }
      function BC(s) {
        var a = ++Q3;
        return Pt(s) + a;
      }
      var UC = cl(function(s, a) {
        return s + a;
      }, 0), jC = od("ceil"), HC = cl(function(s, a) {
        return s / a;
      }, 1), qC = od("floor");
      function zC(s) {
        return s && s.length ? tl(s, an, Vf) : r;
      }
      function VC(s, a) {
        return s && s.length ? tl(s, ze(a, 2), Vf) : r;
      }
      function WC(s) {
        return Hg(s, an);
      }
      function KC(s, a) {
        return Hg(s, ze(a, 2));
      }
      function GC(s) {
        return s && s.length ? tl(s, an, Jf) : r;
      }
      function JC(s, a) {
        return s && s.length ? tl(s, ze(a, 2), Jf) : r;
      }
      var QC = cl(function(s, a) {
        return s * a;
      }, 1), ZC = od("round"), YC = cl(function(s, a) {
        return s - a;
      }, 0);
      function XC(s) {
        return s && s.length ? Tf(s, an) : 0;
      }
      function eI(s, a) {
        return s && s.length ? Tf(s, ze(a, 2)) : 0;
      }
      return z.after = E4, z.ary = dm, z.assign = u8, z.assignIn = Rm, z.assignInWith = bl, z.assignWith = l8, z.at = h8, z.before = pm, z.bind = yd, z.bindAll = mC, z.bindKey = gm, z.castArray = N4, z.chain = lm, z.chunk = q5, z.compact = z5, z.concat = V5, z.cond = vC, z.conforms = yC, z.constant = Id, z.countBy = XS, z.create = f8, z.curry = mm, z.curryRight = vm, z.debounce = ym, z.defaults = d8, z.defaultsDeep = p8, z.defer = S4, z.delay = C4, z.difference = W5, z.differenceBy = K5, z.differenceWith = G5, z.drop = J5, z.dropRight = Q5, z.dropRightWhile = Z5, z.dropWhile = Y5, z.fill = X5, z.filter = t4, z.flatMap = i4, z.flatMapDeep = s4, z.flatMapDepth = o4, z.flatten = om, z.flattenDeep = eS, z.flattenDepth = tS, z.flip = I4, z.flow = wC, z.flowRight = bC, z.fromPairs = rS, z.functions = b8, z.functionsIn = E8, z.groupBy = a4, z.initial = iS, z.intersection = sS, z.intersectionBy = oS, z.intersectionWith = aS, z.invert = C8, z.invertBy = I8, z.invokeMap = u4, z.iteratee = xd, z.keyBy = l4, z.keys = Er, z.keysIn = on, z.map = gl, z.mapKeys = R8, z.mapValues = A8, z.matches = EC, z.matchesProperty = SC, z.memoize = vl, z.merge = M8, z.mergeWith = Am, z.method = CC, z.methodOf = IC, z.mixin = Rd, z.negate = yl, z.nthArg = RC, z.omit = D8, z.omitBy = O8, z.once = x4, z.orderBy = h4, z.over = AC, z.overArgs = R4, z.overEvery = MC, z.overSome = DC, z.partial = _d, z.partialRight = _m, z.partition = f4, z.pick = P8, z.pickBy = Mm, z.property = Lm, z.propertyOf = OC, z.pull = hS, z.pullAll = cm, z.pullAllBy = fS, z.pullAllWith = dS, z.pullAt = pS, z.range = PC, z.rangeRight = TC, z.rearg = A4, z.reject = g4, z.remove = gS, z.rest = M4, z.reverse = md, z.sampleSize = v4, z.set = N8, z.setWith = k8, z.shuffle = y4, z.slice = mS, z.sortBy = b4, z.sortedUniq = SS, z.sortedUniqBy = CS, z.split = iC, z.spread = D4, z.tail = IS, z.take = xS, z.takeRight = RS, z.takeRightWhile = AS, z.takeWhile = MS, z.tap = zS, z.throttle = O4, z.thru = pl, z.toArray = Cm, z.toPairs = Dm, z.toPairsIn = Om, z.toPath = FC, z.toPlainObject = xm, z.transform = L8, z.unary = P4, z.union = DS, z.unionBy = OS, z.unionWith = PS, z.uniq = TS, z.uniqBy = NS, z.uniqWith = kS, z.unset = $8, z.unzip = vd, z.unzipWith = um, z.update = F8, z.updateWith = B8, z.values = Wo, z.valuesIn = U8, z.without = LS, z.words = Nm, z.wrap = T4, z.xor = $S, z.xorBy = FS, z.xorWith = BS, z.zip = US, z.zipObject = jS, z.zipObjectDeep = HS, z.zipWith = qS, z.entries = Dm, z.entriesIn = Om, z.extend = Rm, z.extendWith = bl, Rd(z, z), z.add = UC, z.attempt = km, z.camelCase = z8, z.capitalize = Pm, z.ceil = jC, z.clamp = j8, z.clone = k4, z.cloneDeep = $4, z.cloneDeepWith = F4, z.cloneWith = L4, z.conformsTo = B4, z.deburr = Tm, z.defaultTo = _C, z.divide = HC, z.endsWith = V8, z.eq = ri, z.escape = W8, z.escapeRegExp = K8, z.every = e4, z.find = r4, z.findIndex = im, z.findKey = g8, z.findLast = n4, z.findLastIndex = sm, z.findLastKey = m8, z.floor = qC, z.forEach = hm, z.forEachRight = fm, z.forIn = v8, z.forInRight = y8, z.forOwn = _8, z.forOwnRight = w8, z.get = Ed, z.gt = U4, z.gte = j4, z.has = S8, z.hasIn = Sd, z.head = am, z.identity = an, z.includes = c4, z.indexOf = nS, z.inRange = H8, z.invoke = x8, z.isArguments = Ks, z.isArray = at, z.isArrayBuffer = H4, z.isArrayLike = sn, z.isArrayLikeObject = ur, z.isBoolean = q4, z.isBuffer = vs, z.isDate = z4, z.isElement = V4, z.isEmpty = W4, z.isEqual = K4, z.isEqualWith = G4, z.isError = wd, z.isFinite = J4, z.isFunction = ji, z.isInteger = wm, z.isLength = _l, z.isMap = bm, z.isMatch = Q4, z.isMatchWith = Z4, z.isNaN = Y4, z.isNative = X4, z.isNil = t8, z.isNull = e8, z.isNumber = Em, z.isObject = tr, z.isObjectLike = sr, z.isPlainObject = oc, z.isRegExp = bd, z.isSafeInteger = r8, z.isSet = Sm, z.isString = wl, z.isSymbol = _n, z.isTypedArray = Vo, z.isUndefined = n8, z.isWeakMap = i8, z.isWeakSet = s8, z.join = cS, z.kebabCase = G8, z.last = kn, z.lastIndexOf = uS, z.lowerCase = J8, z.lowerFirst = Q8, z.lt = o8, z.lte = a8, z.max = zC, z.maxBy = VC, z.mean = WC, z.meanBy = KC, z.min = GC, z.minBy = JC, z.stubArray = Md, z.stubFalse = Dd, z.stubObject = NC, z.stubString = kC, z.stubTrue = LC, z.multiply = QC, z.nth = lS, z.noConflict = xC, z.noop = Ad, z.now = ml, z.pad = Z8, z.padEnd = Y8, z.padStart = X8, z.parseInt = eC, z.random = q8, z.reduce = d4, z.reduceRight = p4, z.repeat = tC, z.replace = rC, z.result = T8, z.round = ZC, z.runInContext = ae, z.sample = m4, z.size = _4, z.snakeCase = nC, z.some = w4, z.sortedIndex = vS, z.sortedIndexBy = yS, z.sortedIndexOf = _S, z.sortedLastIndex = wS, z.sortedLastIndexBy = bS, z.sortedLastIndexOf = ES, z.startCase = sC, z.startsWith = oC, z.subtract = YC, z.sum = XC, z.sumBy = eI, z.template = aC, z.times = $C, z.toFinite = Hi, z.toInteger = lt, z.toLength = Im, z.toLower = cC, z.toNumber = Ln, z.toSafeInteger = c8, z.toString = Pt, z.toUpper = uC, z.trim = lC, z.trimEnd = hC, z.trimStart = fC, z.truncate = dC, z.unescape = pC, z.uniqueId = BC, z.upperCase = gC, z.upperFirst = Cd, z.each = hm, z.eachRight = fm, z.first = am, Rd(z, function() {
        var s = {};
        return vi(z, function(a, d) {
          Lt.call(z.prototype, d) || (s[d] = a);
        }), s;
      }(), { chain: !1 }), z.VERSION = n, Dn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        z[s].placeholder = z;
      }), Dn(["drop", "take"], function(s, a) {
        _t.prototype[s] = function(d) {
          d = d === r ? 1 : yr(lt(d), 0);
          var _ = this.__filtered__ && !a ? new _t(this) : this.clone();
          return _.__filtered__ ? _.__takeCount__ = $r(d, _.__takeCount__) : _.__views__.push({ size: $r(d, D), type: s + (_.__dir__ < 0 ? "Right" : "") }), _;
        }, _t.prototype[s + "Right"] = function(d) {
          return this.reverse()[s](d).reverse();
        };
      }), Dn(["filter", "map", "takeWhile"], function(s, a) {
        var d = a + 1, _ = d == h || d == x;
        _t.prototype[s] = function(O) {
          var W = this.clone();
          return W.__iteratees__.push({ iteratee: ze(O, 3), type: d }), W.__filtered__ = W.__filtered__ || _, W;
        };
      }), Dn(["head", "last"], function(s, a) {
        var d = "take" + (a ? "Right" : "");
        _t.prototype[s] = function() {
          return this[d](1).value()[0];
        };
      }), Dn(["initial", "tail"], function(s, a) {
        var d = "drop" + (a ? "" : "Right");
        _t.prototype[s] = function() {
          return this.__filtered__ ? new _t(this) : this[d](1);
        };
      }), _t.prototype.compact = function() {
        return this.filter(an);
      }, _t.prototype.find = function(s) {
        return this.filter(s).head();
      }, _t.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, _t.prototype.invokeMap = gt(function(s, a) {
        return typeof s == "function" ? new _t(this) : this.map(function(d) {
          return ec(d, s, a);
        });
      }), _t.prototype.reject = function(s) {
        return this.filter(yl(ze(s)));
      }, _t.prototype.slice = function(s, a) {
        s = lt(s);
        var d = this;
        return d.__filtered__ && (s > 0 || a < 0) ? new _t(d) : (s < 0 ? d = d.takeRight(-s) : s && (d = d.drop(s)), a !== r && (a = lt(a), d = a < 0 ? d.dropRight(-a) : d.take(a - s)), d);
      }, _t.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, _t.prototype.toArray = function() {
        return this.take(D);
      }, vi(_t.prototype, function(s, a) {
        var d = /^(?:filter|find|map|reject)|While$/.test(a), _ = /^(?:head|last)$/.test(a), O = z[_ ? "take" + (a == "last" ? "Right" : "") : a], W = _ || /^find/.test(a);
        O && (z.prototype[a] = function() {
          var te = this.__wrapped__, ne = _ ? [1] : arguments, ce = te instanceof _t, _e = ne[0], we = ce || at(te), Ce = function(yt) {
            var St = O.apply(z, ls([yt], ne));
            return _ && De ? St[0] : St;
          };
          we && d && typeof _e == "function" && _e.length != 1 && (ce = we = !1);
          var De = this.__chain__, Ue = !!this.__actions__.length, Ve = W && !De, dt = ce && !Ue;
          if (!W && we) {
            te = dt ? te : new _t(this);
            var We = s.apply(te, ne);
            return We.__actions__.push({ func: pl, args: [Ce], thisArg: r }), new Pn(We, De);
          }
          return Ve && dt ? s.apply(this, ne) : (We = this.thru(Ce), Ve ? _ ? We.value()[0] : We.value() : We);
        });
      }), Dn(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var a = Uu[s], d = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", _ = /^(?:pop|shift)$/.test(s);
        z.prototype[s] = function() {
          var O = arguments;
          if (_ && !this.__chain__) {
            var W = this.value();
            return a.apply(at(W) ? W : [], O);
          }
          return this[d](function(te) {
            return a.apply(at(te) ? te : [], O);
          });
        };
      }), vi(_t.prototype, function(s, a) {
        var d = z[a];
        if (d) {
          var _ = d.name + "";
          Lt.call(Uo, _) || (Uo[_] = []), Uo[_].push({ name: a, func: d });
        }
      }), Uo[al(r, H).name] = [{ name: "wrapper", func: r }], _t.prototype.clone = p6, _t.prototype.reverse = g6, _t.prototype.value = m6, z.prototype.at = VS, z.prototype.chain = WS, z.prototype.commit = KS, z.prototype.next = GS, z.prototype.plant = QS, z.prototype.reverse = ZS, z.prototype.toJSON = z.prototype.valueOf = z.prototype.value = YS, z.prototype.first = z.prototype.head, Ka && (z.prototype[Ka] = JS), z;
    }, $o = K3();
    cr ? ((cr.exports = $o)._ = $o, Kt._ = $o) : Et._ = $o;
  }).call(wc);
})(wp, wp.exports);
var mz = Object.defineProperty, vz = Object.defineProperties, yz = Object.getOwnPropertyDescriptors, vw = Object.getOwnPropertySymbols, _z = Object.prototype.hasOwnProperty, wz = Object.prototype.propertyIsEnumerable, yw = (t, e, r) => e in t ? mz(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ul = (t, e) => {
  for (var r in e || (e = {}))
    _z.call(e, r) && yw(t, r, e[r]);
  if (vw)
    for (var r of vw(e))
      wz.call(e, r) && yw(t, r, e[r]);
  return t;
}, bz = (t, e) => vz(t, yz(e));
function Rs(t, e, r) {
  var n;
  const i = vF(t);
  return ((n = e.rpcMap) == null ? void 0 : n[i.reference]) || `${gz}?chainId=${i.namespace}:${i.reference}&projectId=${r}`;
}
function Mo(t) {
  return t.includes(":") ? t.split(":")[1] : t;
}
function b3(t) {
  return t.map((e) => `${e.split(":")[0]}:${e.split(":")[1]}`);
}
function Ez(t, e) {
  const r = Object.keys(e.namespaces).filter((i) => i.includes(t));
  if (!r.length)
    return [];
  const n = [];
  return r.forEach((i) => {
    const o = e.namespaces[i].accounts;
    n.push(...o);
  }), n;
}
function Sz(t = {}, e = {}) {
  const r = _w(t), n = _w(e);
  return wp.exports.merge(r, n);
}
function _w(t) {
  var e, r, n, i;
  const o = {};
  if (!pa(t))
    return o;
  for (const [c, u] of Object.entries(t)) {
    const l = Rg(c) ? [c] : u.chains, f = u.methods || [], p = u.events || [], g = u.rpcMap || {}, y = bc(c);
    o[y] = bz(Ul(Ul({}, o[y]), u), { chains: y0(l, (e = o[y]) == null ? void 0 : e.chains), methods: y0(f, (r = o[y]) == null ? void 0 : r.methods), events: y0(p, (n = o[y]) == null ? void 0 : n.events), rpcMap: Ul(Ul({}, g), (i = o[y]) == null ? void 0 : i.rpcMap) });
  }
  return o;
}
function Cz(t) {
  return t.includes(":") ? t.split(":")[2] : t;
}
function Iz(t) {
  const e = {};
  for (const [r, n] of Object.entries(t)) {
    const i = n.methods || [], o = n.events || [], c = n.accounts || [], u = Rg(r) ? [r] : n.chains ? n.chains : b3(n.accounts);
    e[r] = { chains: u, methods: i, events: o, accounts: c };
  }
  return e;
}
function O0(t) {
  return typeof t == "number" ? t : t.includes("0x") ? parseInt(t, 16) : t.includes(":") ? Number(t.split(":")[1]) : Number(t);
}
const E3 = {}, er = (t) => E3[t], P0 = (t, e) => {
  E3[t] = e;
};
class xz {
  constructor(e) {
    this.name = "polkadot", this.namespace = e.namespace, this.events = er("events"), this.client = er("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(os.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]) || [] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var n;
      const i = Mo(r);
      e[i] = this.createHttpProvider(i, (n = this.namespace.rpcMap) == null ? void 0 : n[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const n = this.createHttpProvider(e, r);
    n && (this.httpProviders[e] = n);
  }
  createHttpProvider(e, r) {
    const n = r || Rs(e, this.namespace, this.client.core.projectId);
    if (!n)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new ss(new Ds(n, er("disableProviderPing")));
  }
}
class Rz {
  constructor(e) {
    this.name = "eip155", this.namespace = e.namespace, this.events = er("events"), this.client = er("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
  }
  async request(e) {
    switch (e.request.method) {
      case "eth_requestAccounts":
        return this.getAccounts();
      case "eth_accounts":
        return this.getAccounts();
      case "wallet_switchEthereumChain":
        return await this.handleSwitchChain(e);
      case "eth_chainId":
        return parseInt(this.getDefaultChain());
    }
    return this.namespace.methods.includes(e.request.method) ? await this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(parseInt(e), r), this.chainId = parseInt(e), this.events.emit(os.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId.toString();
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  createHttpProvider(e, r) {
    const n = r || Rs(`${this.name}:${e}`, this.namespace, this.client.core.projectId);
    if (!n)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new ss(new Ds(n, er("disableProviderPing")));
  }
  setHttpProvider(e, r) {
    const n = this.createHttpProvider(e, r);
    n && (this.httpProviders[e] = n);
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var n;
      const i = parseInt(Mo(r));
      e[i] = this.createHttpProvider(i, (n = this.namespace.rpcMap) == null ? void 0 : n[r]);
    }), e;
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  getHttpProvider() {
    const e = this.chainId, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  async handleSwitchChain(e) {
    var r, n;
    let i = e.request.params ? (r = e.request.params[0]) == null ? void 0 : r.chainId : "0x0";
    i = i.startsWith("0x") ? i : `0x${i}`;
    const o = parseInt(i, 16);
    if (this.isChainApproved(o))
      this.setDefaultChain(`${o}`);
    else if (this.namespace.methods.includes("wallet_switchEthereumChain"))
      await this.client.request({ topic: e.topic, request: { method: e.request.method, params: [{ chainId: i }] }, chainId: (n = this.namespace.chains) == null ? void 0 : n[0] }), this.setDefaultChain(`${o}`);
    else
      throw new Error(`Failed to switch to chain 'eip155:${o}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
    return null;
  }
  isChainApproved(e) {
    return this.namespace.chains.includes(`${this.name}:${e}`);
  }
}
class Az {
  constructor(e) {
    this.name = "solana", this.namespace = e.namespace, this.events = er("events"), this.client = er("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(os.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var n;
      const i = Mo(r);
      e[i] = this.createHttpProvider(i, (n = this.namespace.rpcMap) == null ? void 0 : n[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const n = this.createHttpProvider(e, r);
    n && (this.httpProviders[e] = n);
  }
  createHttpProvider(e, r) {
    const n = r || Rs(e, this.namespace, this.client.core.projectId);
    if (!n)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new ss(new Ds(n, er("disableProviderPing")));
  }
}
class Mz {
  constructor(e) {
    this.name = "cosmos", this.namespace = e.namespace, this.events = er("events"), this.client = er("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(os.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var n;
      const i = Mo(r);
      e[i] = this.createHttpProvider(i, (n = this.namespace.rpcMap) == null ? void 0 : n[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const n = this.createHttpProvider(e, r);
    n && (this.httpProviders[e] = n);
  }
  createHttpProvider(e, r) {
    const n = r || Rs(e, this.namespace, this.client.core.projectId);
    if (!n)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new ss(new Ds(n, er("disableProviderPing")));
  }
}
class Dz {
  constructor(e) {
    this.name = "cip34", this.namespace = e.namespace, this.events = er("events"), this.client = er("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(os.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      const n = this.getCardanoRPCUrl(r), i = Mo(r);
      e[i] = this.createHttpProvider(i, n);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  getCardanoRPCUrl(e) {
    const r = this.namespace.rpcMap;
    if (r)
      return r[e];
  }
  setHttpProvider(e, r) {
    const n = this.createHttpProvider(e, r);
    n && (this.httpProviders[e] = n);
  }
  createHttpProvider(e, r) {
    const n = r || this.getCardanoRPCUrl(e);
    if (!n)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new ss(new Ds(n, er("disableProviderPing")));
  }
}
class Oz {
  constructor(e) {
    this.name = "elrond", this.namespace = e.namespace, this.events = er("events"), this.client = er("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(os.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var n;
      const i = Mo(r);
      e[i] = this.createHttpProvider(i, (n = this.namespace.rpcMap) == null ? void 0 : n[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const n = this.createHttpProvider(e, r);
    n && (this.httpProviders[e] = n);
  }
  createHttpProvider(e, r) {
    const n = r || Rs(e, this.namespace, this.client.core.projectId);
    if (!n)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new ss(new Ds(n, er("disableProviderPing")));
  }
}
class Pz {
  constructor(e) {
    this.name = "multiversx", this.namespace = e.namespace, this.events = er("events"), this.client = er("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(os.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var n;
      const i = Mo(r);
      e[i] = this.createHttpProvider(i, (n = this.namespace.rpcMap) == null ? void 0 : n[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const n = this.createHttpProvider(e, r);
    n && (this.httpProviders[e] = n);
  }
  createHttpProvider(e, r) {
    const n = r || Rs(e, this.namespace, this.client.core.projectId);
    if (!n)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new ss(new Ds(n, er("disableProviderPing")));
  }
}
class Tz {
  constructor(e) {
    this.name = "near", this.namespace = e.namespace, this.events = er("events"), this.client = er("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    if (this.chainId = e, !this.httpProviders[e]) {
      const n = r || Rs(`${this.name}:${e}`, this.namespace);
      if (!n)
        throw new Error(`No RPC url provided for chainId: ${e}`);
      this.setHttpProvider(e, n);
    }
    this.events.emit(os.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]) || [] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var n;
      e[r] = this.createHttpProvider(r, (n = this.namespace.rpcMap) == null ? void 0 : n[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const n = this.createHttpProvider(e, r);
    n && (this.httpProviders[e] = n);
  }
  createHttpProvider(e, r) {
    const n = r || Rs(e, this.namespace);
    return typeof n > "u" ? void 0 : new ss(new Ds(n, er("disableProviderPing")));
  }
}
var Nz = Object.defineProperty, kz = Object.defineProperties, Lz = Object.getOwnPropertyDescriptors, ww = Object.getOwnPropertySymbols, $z = Object.prototype.hasOwnProperty, Fz = Object.prototype.propertyIsEnumerable, bw = (t, e, r) => e in t ? Nz(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, jl = (t, e) => {
  for (var r in e || (e = {}))
    $z.call(e, r) && bw(t, r, e[r]);
  if (ww)
    for (var r of ww(e))
      Fz.call(e, r) && bw(t, r, e[r]);
  return t;
}, T0 = (t, e) => kz(t, Lz(e));
class Lg {
  constructor(e) {
    this.events = new Up(), this.rpcProviders = {}, this.shouldAbortPairingAttempt = !1, this.maxPairingAttempts = 10, this.disableProviderPing = !1, this.providerOpts = e, this.logger = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : wt.pino(wt.getDefaultLoggerOptions({ level: e?.logger || gw })), this.disableProviderPing = e?.disableProviderPing || !1;
  }
  static async init(e) {
    const r = new Lg(e);
    return await r.initialize(), r;
  }
  async request(e, r) {
    const [n, i] = this.validateChain(r);
    if (!this.session)
      throw new Error("Please call connect() before request()");
    return await this.getProvider(n).request({ request: jl({}, e), chainId: `${n}:${i}`, topic: this.session.topic });
  }
  sendAsync(e, r, n) {
    const i = (/* @__PURE__ */ new Date()).getTime();
    this.request(e, n).then((o) => r(null, vf(i, o))).catch((o) => r(o, void 0));
  }
  async enable() {
    if (!this.client)
      throw new Error("Sign Client not initialized");
    return this.session || await this.connect({ namespaces: this.namespaces, optionalNamespaces: this.optionalNamespaces, sessionProperties: this.sessionProperties }), await this.requestAccounts();
  }
  async disconnect() {
    var e;
    if (!this.session)
      throw new Error("Please call connect() before enable()");
    await this.client.disconnect({ topic: (e = this.session) == null ? void 0 : e.topic, reason: or("USER_DISCONNECTED") }), await this.cleanup();
  }
  async connect(e) {
    if (!this.client)
      throw new Error("Sign Client not initialized");
    if (this.setNamespaces(e), await this.cleanupPendingPairings(), !e.skipPairing)
      return await this.pair(e.pairingTopic);
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  get isWalletConnect() {
    return !0;
  }
  async pair(e) {
    this.shouldAbortPairingAttempt = !1;
    let r = 0;
    do {
      if (this.shouldAbortPairingAttempt)
        throw new Error("Pairing aborted");
      if (r >= this.maxPairingAttempts)
        throw new Error("Max auto pairing attempts reached");
      const { uri: n, approval: i } = await this.client.connect({ pairingTopic: e, requiredNamespaces: this.namespaces, optionalNamespaces: this.optionalNamespaces, sessionProperties: this.sessionProperties });
      n && (this.uri = n, this.events.emit("display_uri", n)), await i().then((o) => {
        this.session = o, this.namespaces || (this.namespaces = Iz(o.namespaces), this.persist("namespaces", this.namespaces));
      }).catch((o) => {
        if (o.message !== _3)
          throw o;
        r++;
      });
    } while (!this.session);
    return this.onConnect(), this.session;
  }
  setDefaultChain(e, r) {
    try {
      if (!this.session)
        return;
      const [n, i] = this.validateChain(e);
      this.getProvider(n).setDefaultChain(i, r);
    } catch (n) {
      if (!/Please call connect/.test(n.message))
        throw n;
    }
  }
  async cleanupPendingPairings(e = {}) {
    this.logger.info("Cleaning up inactive pairings...");
    const r = this.client.pairing.getAll();
    if (Pi(r)) {
      for (const n of r)
        e.deletePairings ? this.client.core.expirer.set(n.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(n.topic);
      this.logger.info(`Inactive pairings cleared: ${r.length}`);
    }
  }
  abortPairingAttempt() {
    this.shouldAbortPairingAttempt = !0;
  }
  async checkStorage() {
    if (this.namespaces = await this.getFromStore("namespaces"), this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.client.session.length) {
      const e = this.client.session.keys.length - 1;
      this.session = this.client.session.get(this.client.session.keys[e]), this.createProviders();
    }
  }
  async initialize() {
    this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
  }
  async createClient() {
    this.client = this.providerOpts.client || await cz.init({ logger: this.providerOpts.logger || gw, relayUrl: this.providerOpts.relayUrl || fz, projectId: this.providerOpts.projectId, metadata: this.providerOpts.metadata, storageOptions: this.providerOpts.storageOptions, storage: this.providerOpts.storage, name: this.providerOpts.name }), this.logger.trace("SignClient Initialized");
  }
  createProviders() {
    if (!this.client)
      throw new Error("Sign Client not initialized");
    if (!this.session)
      throw new Error("Session not initialized. Please call connect() before enable()");
    const e = [...new Set(Object.keys(this.session.namespaces).map((r) => bc(r)))];
    P0("client", this.client), P0("events", this.events), P0("disableProviderPing", this.disableProviderPing), e.forEach((r) => {
      if (!this.session)
        return;
      const n = Ez(r, this.session), i = b3(n), o = Sz(this.namespaces, this.optionalNamespaces), c = T0(jl({}, o[r]), { accounts: n, chains: i });
      switch (r) {
        case "eip155":
          this.rpcProviders[r] = new Rz({ namespace: c });
          break;
        case "solana":
          this.rpcProviders[r] = new Az({ namespace: c });
          break;
        case "cosmos":
          this.rpcProviders[r] = new Mz({ namespace: c });
          break;
        case "polkadot":
          this.rpcProviders[r] = new xz({ namespace: c });
          break;
        case "cip34":
          this.rpcProviders[r] = new Dz({ namespace: c });
          break;
        case "elrond":
          this.rpcProviders[r] = new Oz({ namespace: c });
          break;
        case "multiversx":
          this.rpcProviders[r] = new Pz({ namespace: c });
          break;
        case "near":
          this.rpcProviders[r] = new Tz({ namespace: c });
          break;
      }
    });
  }
  registerEventListeners() {
    if (typeof this.client > "u")
      throw new Error("Sign Client is not initialized");
    this.client.on("session_ping", (e) => {
      this.events.emit("session_ping", e);
    }), this.client.on("session_event", (e) => {
      const { params: r } = e, { event: n } = r;
      if (n.name === "accountsChanged") {
        const i = n.data;
        i && Pi(i) && this.events.emit("accountsChanged", i.map(Cz));
      } else if (n.name === "chainChanged") {
        const i = r.chainId, o = r.event.data, c = bc(i), u = O0(i) !== O0(o) ? `${c}:${O0(o)}` : i;
        this.onChainChanged(u);
      } else
        this.events.emit(n.name, n.data);
      this.events.emit("session_event", e);
    }), this.client.on("session_update", ({ topic: e, params: r }) => {
      var n;
      const { namespaces: i } = r, o = (n = this.client) == null ? void 0 : n.session.get(e);
      this.session = T0(jl({}, o), { namespaces: i }), this.onSessionUpdate(), this.events.emit("session_update", { topic: e, params: r });
    }), this.client.on("session_delete", async (e) => {
      await this.cleanup(), this.events.emit("session_delete", e), this.events.emit("disconnect", T0(jl({}, or("USER_DISCONNECTED")), { data: e.topic }));
    }), this.on(os.DEFAULT_CHAIN_CHANGED, (e) => {
      this.onChainChanged(e, !0);
    });
  }
  getProvider(e) {
    if (!this.rpcProviders[e])
      throw new Error(`Provider not found: ${e}`);
    return this.rpcProviders[e];
  }
  onSessionUpdate() {
    Object.keys(this.rpcProviders).forEach((e) => {
      var r;
      this.getProvider(e).updateNamespace((r = this.session) == null ? void 0 : r.namespaces[e]);
    });
  }
  setNamespaces(e) {
    const { namespaces: r, optionalNamespaces: n, sessionProperties: i } = e;
    r && Object.keys(r).length && (this.namespaces = r), n && Object.keys(n).length && (this.optionalNamespaces = n), this.sessionProperties = i, this.persist("namespaces", r), this.persist("optionalNamespaces", n);
  }
  validateChain(e) {
    const [r, n] = e?.split(":") || ["", ""];
    if (!this.namespaces || !Object.keys(this.namespaces).length)
      return [r, n];
    if (r && !Object.keys(this.namespaces || {}).map((c) => bc(c)).includes(r))
      throw new Error(`Namespace '${r}' is not configured. Please call connect() first with namespace config.`);
    if (r && n)
      return [r, n];
    const i = bc(Object.keys(this.namespaces)[0]), o = this.rpcProviders[i].getDefaultChain();
    return [i, o];
  }
  async requestAccounts() {
    const [e] = this.validateChain();
    return await this.getProvider(e).requestAccounts();
  }
  onChainChanged(e, r = !1) {
    var n;
    if (!this.namespaces)
      return;
    const [i, o] = this.validateChain(e);
    r || this.getProvider(i).setDefaultChain(o), ((n = this.namespaces[i]) != null ? n : this.namespaces[`${i}:${o}`]).defaultChain = o, this.persist("namespaces", this.namespaces), this.events.emit("chainChanged", o);
  }
  onConnect() {
    this.createProviders(), this.events.emit("connect", { session: this.session });
  }
  async cleanup() {
    this.session = void 0, this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, this.persist("namespaces", void 0), this.persist("optionalNamespaces", void 0), this.persist("sessionProperties", void 0), await this.cleanupPendingPairings({ deletePairings: !0 });
  }
  persist(e, r) {
    this.client.core.storage.setItem(`${mw}/${e}`, r);
  }
  async getFromStore(e) {
    return await this.client.core.storage.getItem(`${mw}/${e}`);
  }
}
const Bz = Lg, Uz = "wc", jz = "ethereum_provider", Hz = `${Uz}@2:${jz}:`, qz = "https://rpc.walletconnect.com/v1/", bp = ["eth_sendTransaction", "personal_sign"], zz = ["eth_accounts", "eth_requestAccounts", "eth_sendRawTransaction", "eth_sign", "eth_signTransaction", "eth_signTypedData", "eth_signTypedData_v3", "eth_signTypedData_v4", "eth_sendTransaction", "personal_sign", "wallet_switchEthereumChain", "wallet_addEthereumChain", "wallet_getPermissions", "wallet_requestPermissions", "wallet_registerOnboarding", "wallet_watchAsset", "wallet_scanQRCode"], Ep = ["chainChanged", "accountsChanged"], Vz = ["chainChanged", "accountsChanged", "message", "disconnect", "connect"];
var Wz = Object.defineProperty, Kz = Object.defineProperties, Gz = Object.getOwnPropertyDescriptors, Ew = Object.getOwnPropertySymbols, Jz = Object.prototype.hasOwnProperty, Qz = Object.prototype.propertyIsEnumerable, Sw = (t, e, r) => e in t ? Wz(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Sc = (t, e) => {
  for (var r in e || (e = {}))
    Jz.call(e, r) && Sw(t, r, e[r]);
  if (Ew)
    for (var r of Ew(e))
      Qz.call(e, r) && Sw(t, r, e[r]);
  return t;
}, Cw = (t, e) => Kz(t, Gz(e));
function lh(t) {
  return Number(t[0].split(":")[1]);
}
function N0(t) {
  return `0x${t.toString(16)}`;
}
function Zz(t) {
  const { chains: e, optionalChains: r, methods: n, optionalMethods: i, events: o, optionalEvents: c, rpcMap: u } = t;
  if (!Pi(e))
    throw new Error("Invalid chains");
  const l = { chains: e, methods: n || bp, events: o || Ep, rpcMap: Sc({}, e.length ? { [lh(e)]: u[lh(e)] } : {}) }, f = o?.filter((C) => !Ep.includes(C)), p = n?.filter((C) => !bp.includes(C));
  if (!r && !c && !i && !(f != null && f.length) && !(p != null && p.length))
    return { required: e.length ? l : void 0 };
  const g = f?.length && p?.length || !r, y = { chains: [...new Set(g ? l.chains.concat(r || []) : r)], methods: [...new Set(l.methods.concat(i != null && i.length ? i : zz))], events: [...new Set(l.events.concat(c != null && c.length ? c : Vz))], rpcMap: u };
  return { required: e.length ? l : void 0, optional: r.length ? y : void 0 };
}
class $g {
  constructor() {
    this.events = new Tr.EventEmitter(), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = Hz, this.on = (e, r) => (this.events.on(e, r), this), this.once = (e, r) => (this.events.once(e, r), this), this.removeListener = (e, r) => (this.events.removeListener(e, r), this), this.off = (e, r) => (this.events.off(e, r), this), this.parseAccount = (e) => this.isCompatibleChainId(e) ? this.parseAccountId(e).address : e, this.signer = {}, this.rpc = {};
  }
  static async init(e) {
    const r = new $g();
    return await r.initialize(e), r;
  }
  async request(e) {
    return await this.signer.request(e, this.formatChainId(this.chainId));
  }
  sendAsync(e, r) {
    this.signer.sendAsync(e, r, this.formatChainId(this.chainId));
  }
  get connected() {
    return this.signer.client ? this.signer.client.core.relayer.connected : !1;
  }
  get connecting() {
    return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
  }
  async enable() {
    return this.session || await this.connect(), await this.request({ method: "eth_requestAccounts" });
  }
  async connect(e) {
    if (!this.signer.client)
      throw new Error("Provider not initialized. Call init() first");
    this.loadConnectOpts(e);
    const { required: r, optional: n } = Zz(this.rpc);
    try {
      const i = await new Promise(async (c, u) => {
        var l;
        this.rpc.showQrModal && ((l = this.modal) == null || l.subscribeModal((f) => {
          !f.open && !this.signer.session && (this.signer.abortPairingAttempt(), u(new Error("Connection request reset. Please try again.")));
        })), await this.signer.connect(Cw(Sc({ namespaces: Sc({}, r && { [this.namespace]: r }) }, n && { optionalNamespaces: { [this.namespace]: n } }), { pairingTopic: e?.pairingTopic })).then((f) => {
          c(f);
        }).catch((f) => {
          u(new Error(f.message));
        });
      });
      if (!i)
        return;
      const o = yF(i.namespaces, [this.namespace]);
      this.setChainIds(this.rpc.chains.length ? this.rpc.chains : o), this.setAccounts(o), this.events.emit("connect", { chainId: N0(this.chainId) });
    } catch (i) {
      throw this.signer.logger.error(i), i;
    } finally {
      this.modal && this.modal.closeModal();
    }
  }
  async disconnect() {
    this.session && await this.signer.disconnect(), this.reset();
  }
  get isWalletConnect() {
    return !0;
  }
  get session() {
    return this.signer.session;
  }
  registerEventListeners() {
    this.signer.on("session_event", (e) => {
      const { params: r } = e, { event: n } = r;
      n.name === "accountsChanged" ? (this.accounts = this.parseAccounts(n.data), this.events.emit("accountsChanged", this.accounts)) : n.name === "chainChanged" ? this.setChainId(this.formatChainId(n.data)) : this.events.emit(n.name, n.data), this.events.emit("session_event", e);
    }), this.signer.on("chainChanged", (e) => {
      const r = parseInt(e);
      this.chainId = r, this.events.emit("chainChanged", N0(this.chainId)), this.persist();
    }), this.signer.on("session_update", (e) => {
      this.events.emit("session_update", e);
    }), this.signer.on("session_delete", (e) => {
      this.reset(), this.events.emit("session_delete", e), this.events.emit("disconnect", Cw(Sc({}, or("USER_DISCONNECTED")), { data: e.topic, name: "USER_DISCONNECTED" }));
    }), this.signer.on("display_uri", (e) => {
      var r, n;
      this.rpc.showQrModal && ((r = this.modal) == null || r.closeModal(), (n = this.modal) == null || n.openModal({ uri: e })), this.events.emit("display_uri", e);
    });
  }
  switchEthereumChain(e) {
    this.request({ method: "wallet_switchEthereumChain", params: [{ chainId: e.toString(16) }] });
  }
  isCompatibleChainId(e) {
    return typeof e == "string" ? e.startsWith(`${this.namespace}:`) : !1;
  }
  formatChainId(e) {
    return `${this.namespace}:${e}`;
  }
  parseChainId(e) {
    return Number(e.split(":")[1]);
  }
  setChainIds(e) {
    const r = e.filter((n) => this.isCompatibleChainId(n)).map((n) => this.parseChainId(n));
    r.length && (this.chainId = r[0], this.events.emit("chainChanged", N0(this.chainId)), this.persist());
  }
  setChainId(e) {
    if (this.isCompatibleChainId(e)) {
      const r = this.parseChainId(e);
      this.chainId = r, this.switchEthereumChain(r);
    }
  }
  parseAccountId(e) {
    const [r, n, i] = e.split(":");
    return { chainId: `${r}:${n}`, address: i };
  }
  setAccounts(e) {
    this.accounts = e.filter((r) => this.parseChainId(this.parseAccountId(r).chainId) === this.chainId).map((r) => this.parseAccountId(r).address), this.events.emit("accountsChanged", this.accounts);
  }
  getRpcConfig(e) {
    var r, n;
    const i = (r = e?.chains) != null ? r : [], o = (n = e?.optionalChains) != null ? n : [], c = i.concat(o);
    if (!c.length)
      throw new Error("No chains specified in either `chains` or `optionalChains`");
    const u = i.length ? e?.methods || bp : [], l = i.length ? e?.events || Ep : [], f = e?.optionalMethods || [], p = e?.optionalEvents || [], g = e?.rpcMap || this.buildRpcMap(c, e.projectId), y = e?.qrModalOptions || void 0;
    return { chains: i?.map((C) => this.formatChainId(C)), optionalChains: o.map((C) => this.formatChainId(C)), methods: u, events: l, optionalMethods: f, optionalEvents: p, rpcMap: g, showQrModal: !!(e != null && e.showQrModal), qrModalOptions: y, projectId: e.projectId, metadata: e.metadata };
  }
  buildRpcMap(e, r) {
    const n = {};
    return e.forEach((i) => {
      n[i] = this.getRpcUrl(i, r);
    }), n;
  }
  async initialize(e) {
    if (this.rpc = this.getRpcConfig(e), this.chainId = this.rpc.chains.length ? lh(this.rpc.chains) : lh(this.rpc.optionalChains), this.signer = await Bz.init({ projectId: this.rpc.projectId, metadata: this.rpc.metadata, disableProviderPing: e.disableProviderPing, relayUrl: e.relayUrl, storageOptions: e.storageOptions }), this.registerEventListeners(), await this.loadPersistedSession(), this.rpc.showQrModal) {
      let r;
      try {
        const { WalletConnectModal: n } = await import("./index-pdFIxOs4.js").then((i) => i.i);
        r = n;
      } catch {
        throw new Error("To use QR modal, please install @walletconnect/modal package");
      }
      if (r)
        try {
          this.modal = new r(Sc({ projectId: this.rpc.projectId }, this.rpc.qrModalOptions));
        } catch (n) {
          throw this.signer.logger.error(n), new Error("Could not generate WalletConnectModal Instance");
        }
    }
  }
  loadConnectOpts(e) {
    if (!e)
      return;
    const { chains: r, optionalChains: n, rpcMap: i } = e;
    r && Pi(r) && (this.rpc.chains = r.map((o) => this.formatChainId(o)), r.forEach((o) => {
      this.rpc.rpcMap[o] = i?.[o] || this.getRpcUrl(o);
    })), n && Pi(n) && (this.rpc.optionalChains = [], this.rpc.optionalChains = n?.map((o) => this.formatChainId(o)), n.forEach((o) => {
      this.rpc.rpcMap[o] = i?.[o] || this.getRpcUrl(o);
    }));
  }
  getRpcUrl(e, r) {
    var n;
    return ((n = this.rpc.rpcMap) == null ? void 0 : n[e]) || `${qz}?chainId=eip155:${e}&projectId=${r || this.rpc.projectId}`;
  }
  async loadPersistedSession() {
    if (!this.session)
      return;
    const e = await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`), r = this.session.namespaces[`${this.namespace}:${e}`] ? this.session.namespaces[`${this.namespace}:${e}`] : this.session.namespaces[this.namespace];
    this.setChainIds(e ? [this.formatChainId(e)] : r?.accounts), this.setAccounts(r?.accounts);
  }
  reset() {
    this.chainId = 1, this.accounts = [];
  }
  persist() {
    this.session && this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`, this.chainId);
  }
  parseAccounts(e) {
    return typeof e == "string" || e instanceof String ? [this.parseAccount(e)] : e.map((r) => this.parseAccount(r));
  }
}
const Yz = $g;
Fg.type = "walletConnect";
function Fg(t) {
  const e = t.isNewChainsStale ?? !0;
  let r, n;
  const i = "eip155";
  return yo((o) => ({
    id: "walletConnect",
    name: "WalletConnect",
    type: Fg.type,
    async setup() {
      const c = await this.getProvider().catch(() => null);
      c && (c.on("connect", this.onConnect.bind(this)), c.on("session_delete", this.onSessionDelete.bind(this)));
    },
    async connect({ chainId: c, ...u } = {}) {
      try {
        const l = await this.getProvider();
        if (!l)
          throw new hI();
        l.on("display_uri", this.onDisplayUri);
        let f = c;
        if (!f) {
          const C = await o.storage?.getItem("state") ?? {};
          o.chains.some((J) => J.id === C.chainId) ? f = C.chainId : f = o.chains[0]?.id;
        }
        if (!f)
          throw new Error("No chains found on connector.");
        const p = await this.isChainsStale();
        if (l.session && p && await l.disconnect(), !l.session || p) {
          const C = o.chains.filter((R) => R.id !== f).map((R) => R.id);
          await l.connect({
            optionalChains: [f, ...C],
            ..."pairingTopic" in u ? { pairingTopic: u.pairingTopic } : {}
          }), this.setRequestedChainsIds(o.chains.map((R) => R.id));
        }
        const g = (await l.enable()).map((C) => es(C)), y = await this.getChainId();
        return l.removeListener("display_uri", this.onDisplayUri), l.removeListener("connect", this.onConnect.bind(this)), l.on("accountsChanged", this.onAccountsChanged.bind(this)), l.on("chainChanged", this.onChainChanged), l.on("disconnect", this.onDisconnect.bind(this)), l.on("session_delete", this.onSessionDelete.bind(this)), { accounts: g, chainId: y };
      } catch (l) {
        throw /(user rejected|connection request reset)/i.test(l?.message) ? new ho(l) : l;
      }
    },
    async disconnect() {
      const c = await this.getProvider();
      try {
        await c?.disconnect();
      } catch (u) {
        if (!/No matching key/i.test(u.message))
          throw u;
      } finally {
        c?.removeListener("accountsChanged", this.onAccountsChanged.bind(this)), c?.removeListener("chainChanged", this.onChainChanged), c?.removeListener("disconnect", this.onDisconnect.bind(this)), c?.removeListener("session_delete", this.onSessionDelete.bind(this)), c?.on("connect", this.onConnect.bind(this)), this.setRequestedChainsIds([]);
      }
    },
    async getAccounts() {
      return (await this.getProvider()).accounts.map((u) => es(u));
    },
    async getProvider({ chainId: c } = {}) {
      async function u() {
        const l = o.chains.map((f) => f.id);
        if (l.length)
          return await Yz.init({
            ...t,
            disableProviderPing: !0,
            optionalChains: l,
            projectId: t.projectId,
            rpcMap: Object.fromEntries(o.chains.map((f) => [
              f.id,
              f.rpcUrls.default.http[0]
            ])),
            showQrModal: t.showQrModal ?? !0
          });
      }
      return r || (n || (n = u()), r = await n, r?.events.setMaxListeners(1 / 0)), c && await this.switchChain?.({ chainId: c }), r;
    },
    async getChainId() {
      return (await this.getProvider()).chainId;
    },
    async isAuthorized() {
      try {
        const [c, u] = await Promise.all([
          this.getAccounts(),
          this.getProvider()
        ]);
        return c.length ? await this.isChainsStale() && u.session ? (await u.disconnect().catch(() => {
        }), !1) : !0 : !1;
      } catch {
        return !1;
      }
    },
    async switchChain({ chainId: c }) {
      const u = o.chains.find((l) => l.id === c);
      if (!u)
        throw new Mc(new Rw());
      try {
        const l = await this.getProvider(), f = this.getNamespaceChainsIds(), p = this.getNamespaceMethods();
        if (!f.includes(c) && p.includes("wallet_addEthereumChain")) {
          await l.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: Yl(u.id),
                blockExplorerUrls: [u.blockExplorers?.default.url],
                chainName: u.name,
                nativeCurrency: u.nativeCurrency,
                rpcUrls: [...u.rpcUrls.default.http]
              }
            ]
          });
          const y = await this.getRequestedChainsIds();
          this.setRequestedChainsIds([...y, c]);
        }
        return await l.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: Yl(c) }]
        }), u;
      } catch (l) {
        const f = typeof l == "string" ? l : l?.message;
        throw /user rejected request/i.test(f) ? new ho(l) : new Mc(l);
      }
    },
    onAccountsChanged(c) {
      c.length === 0 ? this.onDisconnect() : o.emitter.emit("change", {
        accounts: c.map((u) => es(u))
      });
    },
    onChainChanged(c) {
      const u = ma(c);
      o.emitter.emit("change", { chainId: u });
    },
    async onConnect(c) {
      const u = ma(c.chainId), l = await this.getAccounts();
      o.emitter.emit("connect", { accounts: l, chainId: u });
    },
    async onDisconnect(c) {
      this.setRequestedChainsIds([]), o.emitter.emit("disconnect");
      const u = await this.getProvider();
      u.removeListener("accountsChanged", this.onAccountsChanged.bind(this)), u.removeListener("chainChanged", this.onChainChanged), u.removeListener("disconnect", this.onDisconnect.bind(this)), u.removeListener("session_delete", this.onSessionDelete.bind(this)), u.on("connect", this.onConnect.bind(this));
    },
    onDisplayUri(c) {
      o.emitter.emit("message", { type: "display_uri", data: c });
    },
    onSessionDelete() {
      this.onDisconnect();
    },
    getNamespaceChainsIds() {
      return r ? r.session?.namespaces[i]?.chains?.map((u) => parseInt(u.split(":")[1] || "")) ?? [] : [];
    },
    getNamespaceMethods() {
      return r ? r.session?.namespaces[i]?.methods ?? [] : [];
    },
    async getRequestedChainsIds() {
      return await o.storage?.getItem(this.requestedChainsStorageKey) ?? [];
    },
    /**
     * Checks if the target chains match the chains that were
     * initially requested by the connector for the WalletConnect session.
     * If there is a mismatch, this means that the chains on the connector
     * are considered stale, and need to be revalidated at a later point (via
     * connection).
     *
     * There may be a scenario where a dapp adds a chain to the
     * connector later on, however, this chain will not have been approved or rejected
     * by the wallet. In this case, the chain is considered stale.
     *
     * There are exceptions however:
     * -  If the wallet supports dynamic chain addition via `eth_addEthereumChain`,
     *    then the chain is not considered stale.
     * -  If the `isNewChainsStale` flag is falsy on the connector, then the chain is
     *    not considered stale.
     *
     * For the above cases, chain validation occurs dynamically when the user
     * attempts to switch chain.
     *
     * Also check that dapp supports at least 1 chain from previously approved session.
     */
    async isChainsStale() {
      if (this.getNamespaceMethods().includes("wallet_addEthereumChain") || !e)
        return !1;
      const u = o.chains.map((p) => p.id), l = this.getNamespaceChainsIds();
      if (l.length && !l.some((p) => u.includes(p)))
        return !1;
      const f = await this.getRequestedChainsIds();
      return !u.every((p) => f.includes(p));
    },
    async setRequestedChainsIds(c) {
      await o.storage?.setItem(this.requestedChainsStorageKey, c);
    },
    get requestedChainsStorageKey() {
      return `${this.id}.requestedChains`;
    }
  }));
}
const Xz = "data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2040%2040'%3e%3cpath%20d='m37.296%202.348-14.99%2011.134%202.771-6.569%2012.219-4.565Z'%20fill='%23E2761B'%20stroke='%23E2761B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m2.69%202.348%2014.87%2011.24-2.637-6.675L2.689%202.348Zm29.212%2025.808-3.992%206.117%208.542%202.35%202.456-8.331-7.006-.136Zm-30.795.136%202.441%208.331%208.542-2.35-3.992-6.117-6.99.136Z'%20fill='%23E4761B'%20stroke='%23E4761B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m11.608%2017.821-2.38%203.6%208.482.378-.301-9.115-5.8%205.137Zm16.769%200L22.5%2012.578l-.196%209.22%208.467-.376-2.395-3.6ZM12.09%2034.273l5.093-2.486-4.4-3.435-.693%205.921Zm10.712-2.486%205.108%202.486-.709-5.92-4.399%203.434Z'%20fill='%23E4761B'%20stroke='%23E4761B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m27.91%2034.273-5.108-2.486.407%203.33-.045%201.4%204.746-2.244Zm-15.82%200%204.746%202.245-.03-1.401.377-3.33-5.092%202.486Z'%20fill='%23D7C1B3'%20stroke='%23D7C1B3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m16.911%2026.152-4.248-1.25%202.998-1.37%201.25%202.62Zm6.162%200%201.25-2.62%203.014%201.37-4.264%201.25Z'%20fill='%23233447'%20stroke='%23233447'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m12.09%2034.273.723-6.117-4.715.136%203.992%205.981Zm15.096-6.117.724%206.117%203.992-5.981-4.716-.136Zm3.586-6.734-8.467.377.784%204.354%201.25-2.622%203.013%201.371%203.42-3.48Zm-18.11%203.48%203.014-1.37%201.236%202.62.798-4.354-8.482-.376%203.435%203.48Z'%20fill='%23CD6116'%20stroke='%23CD6116'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m9.228%2021.422%203.556%206.93-.121-3.45-3.435-3.48Zm18.124%203.48-.15%203.45%203.57-6.93-3.42%203.48Zm-9.642-3.104-.799%204.355.995%205.137.226-6.764-.422-2.727Zm4.595%200-.407%202.712.181%206.78%201.01-5.137-.784-4.354Z'%20fill='%23E4751F'%20stroke='%23E4751F'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M23.088%2026.153%2022.08%2031.29l.723.497%204.4-3.435.15-3.45-4.264%201.25Zm-10.425-1.25.12%203.45%204.4%203.434.723-.497-.995-5.137-4.248-1.25Z'%20fill='%23F6851B'%20stroke='%23F6851B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m23.164%2036.518.045-1.401-.377-.332h-5.68l-.346.332.03%201.4-4.745-2.244%201.657%201.356%203.36%202.335h5.77l3.374-2.335%201.658-1.356-4.746%202.245Z'%20fill='%23C0AD9E'%20stroke='%23C0AD9E'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m22.802%2031.787-.723-.497h-4.173l-.723.497-.377%203.33.346-.332h5.68l.377.332-.407-3.33Z'%20fill='%23161616'%20stroke='%23161616'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m37.928%2014.205%201.281-6.147-1.913-5.71-14.494%2010.758%205.575%204.715%207.88%202.305%201.747-2.034-.753-.542%201.205-1.1-.934-.723%201.205-.92-.798-.602ZM.791%208.058l1.28%206.147-.813.603%201.205.919-.919.723%201.206%201.1-.754.542%201.733%202.034%207.88-2.305%205.574-4.716L2.689%202.348.791%208.058Z'%20fill='%23763D16'%20stroke='%23763D16'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='m36.256%2020.126-7.88-2.305%202.396%203.6-3.57%206.931%204.7-.06h7.006l-2.652-8.166Zm-24.648-2.305-7.88%202.305-2.62%208.166h6.99l4.685.06-3.555-6.93%202.38-3.6Zm10.697%203.977.497-8.692%202.29-6.193h-10.17l2.26%206.192.528%208.694.18%202.742.016%206.749h4.173l.03-6.75.196-2.741Z'%20fill='%23F6851B'%20stroke='%23F6851B'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", eV = (t) => yo((e) => ({
  ...Aw({ ...t, target: "metaMask" })(e),
  imageSrc: Xz
})), tV = "data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2036%2040'%3e%3cg%20clip-path='url(%23a)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M16.672.477a2.053%202.053%200%200%201%202.632%200c5.171%204.319%2011.067%204.286%2013.363%204.273l.316-.001a2.053%202.053%200%200%201%202.052%202.083c-.109%207.213-.398%2012.367-.966%2016.149-.569%203.779-1.442%206.387-2.861%208.36-1.43%201.986-3.266%203.111-5.198%204.18-.336.185-.678.37-1.028.56-1.694.919-3.57%201.936-5.797%203.534a2.052%202.052%200%200%201-2.393%200c-2.226-1.596-4.099-2.613-5.79-3.532-.352-.19-.695-.377-1.032-.563-1.932-1.069-3.766-2.194-5.192-4.182-1.416-1.972-2.287-4.58-2.853-8.358-.566-3.781-.854-8.935-.963-16.148A2.053%202.053%200%200%201%203.015%204.75l.312.001c2.277.013%208.174.046%2013.345-4.273ZM5.105%208.837c.13%206.074.409%2010.385.88%2013.535.525%203.498%201.26%205.364%202.128%206.572.856%201.193%201.98%201.952%203.844%202.983.303.168.622.341.958.523%201.417.768%203.124%201.694%205.073%203%201.952-1.308%203.662-2.234%205.081-3.003.335-.181.653-.354.955-.52%201.865-1.031%202.993-1.791%203.851-2.985.87-1.207%201.608-3.073%202.134-6.572.473-3.149.753-7.459.884-13.532-2.968-.11-8.074-.75-12.905-4.193-4.824%203.44-9.923%204.082-12.883%204.193Z'%20fill='%233375BB'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='a'%3e%3cpath%20fill='%23fff'%20transform='translate(.962)'%20d='M0%200h34.076v40H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", rV = (t) => yo((e) => ({
  ...Aw({ ...t, target: "trustWallet" })(e),
  imageSrc: tV
})), nV = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201024%201024'%3e%3ccircle%20cx='512'%20cy='512'%20r='512'%20style='fill:%230052ff'/%3e%3cpath%20d='M516.3%20361.83c60.28%200%20108.1%2037.18%20126.26%2092.47H764C742%20336.09%20644.47%20256%20517.27%20256%20372.82%20256%20260%20365.65%20260%20512.49S370%20768%20517.27%20768c124.35%200%20223.82-80.09%20245.84-199.28H642.55c-17.22%2055.3-65%2093.45-125.32%2093.45-83.23%200-141.56-63.89-141.56-149.68.04-86.77%2057.43-150.66%20140.63-150.66z'%20style='fill:%23fff'/%3e%3c/svg%3e", iV = (t) => yo((e) => ({
  ...mg(t)(e),
  imageSrc: nV
})), sV = "data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2040%2040'%3e%3cpath%20d='M8.189%2012.535c6.523-6.384%2017.099-6.384%2023.622%200l.785.768a.805.805%200%200%201%200%201.156l-2.685%202.629a.424.424%200%200%201-.59%200L28.24%2016.03c-4.55-4.453-11.93-4.453-16.48%200l-1.157%201.133a.424.424%200%200%201-.59%200l-2.686-2.629a.805.805%200%200%201%200-1.155l.862-.844Zm29.176%205.436%202.39%202.339a.805.805%200%200%201%200%201.156L28.978%2032.013a.848.848%200%200%201-1.181%200l-7.65-7.485a.212.212%200%200%200-.294%200l-7.65%207.485a.848.848%200%200%201-1.18%200L.244%2021.466a.805.805%200%200%201%200-1.156l2.39-2.34a.848.848%200%200%201%201.18%200l7.65%207.486c.082.08.214.08.295%200l7.65-7.485a.848.848%200%200%201%201.18%200l7.65%207.485c.081.08.213.08.295%200l7.65-7.485a.848.848%200%200%201%201.18%200Z'%20fill='%233396FF'/%3e%3c/svg%3e", oV = (t) => yo((e) => ({
  ...Fg(t)(e),
  imageSrc: sV,
  chainSwitchOnlyFromWallet: !0
})), aV = "data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cg%20clip-path='url(%23a)'%20fill='%23F3BA2F'%3e%3cpath%20d='m7.107%209.775%204.52-4.52%204.52%204.52%202.628-2.628L11.627%200%204.48%207.147l2.627%202.628ZM2.624%209.007%200%2011.63l2.624%202.625L5.25%2011.63%202.624%209.007ZM7.107%2013.486l4.52%204.52%204.52-4.52%202.628%202.628-7.148%207.147-7.147-7.147%202.627-2.628ZM20.63%209.007l-2.625%202.625%202.625%202.624%202.624-2.624-2.624-2.625Z'/%3e%3cpath%20d='m14.292%2011.63-2.664-2.663-1.966%201.966-.239.22-.46.478%202.665%202.664%202.664-2.664Z'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='a'%3e%3cpath%20fill='%23fff'%20d='M0%200h24v24H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", cV = 56, uV = () => {
  let t;
  return yo((e) => ({
    id: "BinanceW3W",
    name: "Binance Web3 Wallet",
    type: "BinanceW3W",
    imageSrc: aV,
    isChainSupported(r) {
      return e.chains.some((n) => n.id === r);
    },
    async connect() {
      try {
        const r = await this.getProvider({
          chainId: cV,
          create: !0
        });
        r.on("accountsChanged", this.onAccountsChanged), r.on("chainChanged", this.onChainChanged), r.on("disconnect", this.onDisconnect), setTimeout(() => e.emitter.emit("message", { type: "connecting" }), 0);
        const i = (await r.enable()).map((c) => es(c)), o = await this.getChainId();
        return { accounts: i, chainId: o };
      } catch (r) {
        throw r.code === 100001 ? new ho(r) : r;
      }
    },
    async disconnect() {
      const r = await this.getProvider();
      r.disconnect(), r.removeListener("accountsChanged", this.onAccountsChanged), r.removeListener("chainChanged", this.onChainChanged), r.removeListener("disconnect", this.onDisconnect), await e.storage?.removeItem("walletconnect");
    },
    async getAccounts() {
      return (await (await this.getProvider()).request({
        method: "eth_accounts"
      })).map((i) => es(i));
    },
    async getProvider({ chainId: r, create: n } = {}) {
      if (!t || r || n) {
        const i = (await import("./index-lFuj8wu9.js")).default;
        t = new i({
          chainId: r,
          rpc: Object.fromEntries(
            e.chains.map((o) => [
              o.id,
              o.rpcUrls.default.http[0]
            ])
          )
        });
      }
      return t;
    },
    async getChainId() {
      const r = await this.getProvider();
      return ma(r.chainId);
    },
    async isAuthorized() {
      try {
        return (await this.getAccounts()).length > 0;
      } catch {
        return !1;
      }
    },
    async switchChain({ chainId: r }) {
      const n = await this.getProvider(), i = e.chains.find((o) => o.id === r);
      try {
        return await Promise.race([
          n.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: Yl(r) }]
          }),
          new Promise((o) => {
            e.emitter.once("change", ({ chainId: c }) => {
              c === r && o(c);
            });
          })
        ]), i;
      } catch (o) {
        const c = typeof o == "string" ? o : o?.message;
        throw /user rejected request/i.test(c) ? new ho(o) : new Mc(o);
      }
    },
    onAccountsChanged(r) {
      r.length === 0 ? this.onDisconnect() : e.emitter.emit("change", {
        accounts: r.map((n) => es(n))
      });
    },
    onChainChanged(r) {
      const n = ma(r);
      e.emitter.emit("change", { chainId: n });
    },
    onDisconnect() {
      e.emitter.emit("disconnect");
    }
  }));
};
var lV = { VITE_WALLETCONNECT_PROJECT_ID: "7a4f8ad947d7cd10dfafdc64c69a267d", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const hV = vI(), S3 = [
  kw,
  Nw,
  ...lV.VITE_ENV_DEV ? [
    GI,
    JI
  ] : []
], fV = Object.fromEntries(S3.map((t) => [t.id, gI()])), dV = mI({
  chains: S3,
  transports: fV,
  multiInjectedProviderDiscovery: !1,
  connectors: [
    ...hV ? [] : [
      eV(),
      rV()
    ],
    uV(),
    iV({ appName: "Swapin" }),
    oV({
      projectId: "7a4f8ad947d7cd10dfafdc64c69a267d",
      qrModalOptions: {
        explorerExcludedWalletIds: "ALL",
        explorerRecommendedWalletIds: [
          "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
          // MetaMask
          "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
          // Trust Wallet
          "8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4",
          // Binance Web3 Wallet
          "bc949c5d968ae81310268bf9193f9c9fb7bb4e1283e1284af8f2bd4992535fd6",
          // Argent
          "1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369",
          // Rainbow
          "e9ff15be73584489ca4a66f64d32c4537711797e30b6660dbcb71ea72a42b1f4",
          // Exodus
          "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927",
          // Ledger Live
          "2a3c89040ac3b723a1972a33a125b1db11e258a6975d3a61252cd64e6ea5ea01",
          // Coin98 Super App
          "1f69170bf7a9bdcf89403ec012659b7124e158f925cdd4a2be49274c24cf5e5d",
          // CoolWallet
          "f2436c67184f158d1beda5df53298ee84abfc367581e4505134b5bcf5f46697d"
          // Crypto.com | DeFi Wallet
        ],
        themeVariables: {
          "--wcm-z-index": "1100"
        }
      }
    })
  ]
}), KV = {
  install: (t) => {
    t.use(fI, { config: dV }), t.use(WI);
  }
};
export {
  KV as W,
  bV as _,
  hi as i,
  fw as m
};
